import React, { Component } from 'react';
import '../css/dataTables.css';
import moment from 'moment';
import $ from 'jquery';
import PersonContactModal from './PersonContactModal';
import PartnerCreateModal from './PartnerCreateModal';
import AlmacenModal from './AlmacenModal';
import MonedaModal from './MonedaModal';
import CentroCosteModal from './CentroCosteModal';
import InvoicesPaymentModal from './InvoicesPaymentModal';
import CheckListModal from './CheckListModal';
import AddressesModal from './AddressesModal';
import SeriesCreateModal from './SeriesCreateModal';
import SeriesCreateModale from './SeriesCreateModale';
import EmployeeSalesModal from './EmployeeSalesModal';
import PropietarioCreateModal from './PropietarioCreateModal';
import PriceListModal from './PriceListModal';
import CfdiCreateModal from './CfdiCreateModal';
import ImpuestoCreateModal from './ImpuestoCreateModal';
import AccountListModal from './AccountListModal';
import { ApiClient } from '../libs/apiClient';
import UserFieldsModal from './UserFieldsModal';
import SelectOfModal from './SelectOfModal';
import UsersModal from './UsersModal';
import BranchesModal from './BranchesModal';
import DepartmentsModal from './DepartmentsModal';
import ConfirmModal from './confirmModal';
import ConfirmCurrencyModal from './confirmCurrencyModal';
import CreditLimitModal from './CreditLimitModal';
import SeriesPagoModal from './SeriesPagoModal';
import AsientoContableModal from './AsientoContableModal';
import AccountBalance from './AccountBalance';
import ProjectsModal from './ProjectsModal'
import TransactionsModal from './TransactionsModal'
import PaymentListModaL from './PaymentListModaL'
import ItemsCreateModal from './ItemsCreateModal';
import GrossProfitModal from './GrossProfitModal';
import AddressModal from './AddressModal'
import SendMailModal from './SendMailModal'
import ValidationBatchsModal from './ValidationBatchsModal';
import BatchReportModal from './BatchReportModal';
import CancelDocuments from './CancelDocuments';
import CancelCFDI from './CancelCFDI';
import AreYouAgreeModal from './AreYouAgreeModal';
import StandardSelectModal from './StandardSelectModal'
import { NewItem, NewItemPayment, NewItemCheck, UserFields, UserFieldsItem, Permissions, NewService, CreditCards } from './NewOrder';
import { json, CURRENCY, cascoItem, FORMAT_NUMBER, Modules, priceDecimalPrecision, development, BASE_URL, SERVICE_API, invFields, OPRQFields, Granel, Envasados, isEntregaCilindro, isTipoConvenio, isCilindrosVaciosDevueltos, isTipodeGasto, isTipodeOperacion, transferFields, SERVICE_RESPONSE, Sections, needTransferReference, billingFields } from '../libs/utils/Const';
import config from "../config";
import download from 'js-file-download';
import CardsListModal from './CardsListModal';
import { ListPartnerModal, ToolTip, DownPayments, ComercioExterior, OxxoReferenceInfo, LocationAssignment, ListLocationsModal, DocumentStockModal, LocationModal, CancelPaymentModal } from '../components';
import DataXML from './DataXML';
import '../css/responsive.css';
import OrderRecommendation from './OrderRecommendation';
import ConfirmCancelModal from './confirmCancelModal';
import { ContentLandedCosts } from '../components';
import { GROSSPROFIT } from "../libs/utils/Const";
import Tooltip from './ToolTip';
import Select from 'react-select';
import { calcultateOperation, disableDocDueDate, getClientCodeText, isMarketingDocumentSAP, setCascosOrder, setDueDateFromPaymentConds, validateCascoG, calcultateOperationHeader, isMarketingDoc, roundToDecimals, isAnticipo } from '../libs/utils/GlobalFunc';
import FactoryTable from './FactoryTables/FactoryTable';
import UomCodeModal from './UomCodeModal';
import FactoryHeader from './FactoryHeader/FactoryHeader';
import FormattedQueriesModal from './FormattedQueriesModal';
import CalculatorModal from './CalculatorModal';
import ORDRTransportsModal from './ORDRTransportsModal';
let apiClient = ApiClient.getInstance();

const selectStyles = {
    container: (base) => ({
        ...base,
        flex: 1,
        width: '100%'
    }),
    control: (base) => ({
        ...base,
        height: 40,
        minHeight: 40,
        width: '100%',
        borderRadius: 4,
        backgroundColor: 'transparent',
        borderColor: '#ced4da'
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999
    }),
    singleValue: (base) => ({
        ...base,
        color: '#000'
    }),
    input: (base) => ({
        ...base,
        color: '#000'
    })
};

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol, decimals = 2) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(decimals));
    },
};

const round = (num) => {
    let m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
}

class DocumentCreateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partners: [],
            userFields: [],
            series: [],
            series2: [],
            series3: [],
            contacts: [],
            warehouses: [],
            defaultwarehouse: [],
            items: [],
            employees: [],
            owners: [],
            taxes: [],
            prices: [],
            centroCostes: [],
            accounts: [],
            transactions: [],
            paymentList: [],
            branches: [],
            departments: [],
            currencies: [],
            checkItemCreateInfo: {
                banks: [],
                contries: [],
            },
            invoicesPayments: [],
            users: [],
            openPersonRequest: false,
            centroCosteId: 0,
            accountMayorId: 0,
            itemOrderModelUpdate: null,
            warehouseUpdate: '',
            editMode: false,
            JsonFields: null,
            indexItem: null,
            service: 'I',
            partnerType: null,
            pageTotal: 0,
            Codigo: '',
            CardName: '',
            Balance: '',
            size: false,
            Asiento: [],
            AsientoContable: [],
            AccountBalan: [],
            CardCodeBalance: [],
            AccountBalanceData: {},
            itemProjectIndex: '',
            projects: [],
            car100: false,
            uuids: [],
            editAddress: null,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),

            ShowGrossProfitModal: false,
            LinesGrossProfit: [],
            PricesList: [],
            ChoosePriceList: props?.newOrderModel?.U_FMB_DEF_PLBasePrice || '-2',
            TotalGrossProfit: 0,
            TotPrctGrossProfit: 0,
            cardList: [],
            cardLine: 0,
            U_FMB_DEF_PLInventoryGenExitService: null,
            U_FMB_DEF_PLInventoryGenEntryService: null,
            U_FMB_DEF_PLStockTransfer: null,
            U_FMB_DEF_PLReqStockTransfer: null,
            itemSelected: '',
            sendMailModel: {
                to: '',
                cc: '',
                subject: '',
                message: '',
                docEntry: null,
                sendFile: false,
                sendXML: false
            },
            SearchWhs: {},
            BatchReports: [],
            cardId: 0,
            isCancelCFDI: false,
            wareHousesList: [],
            checkboxArray: (new Map()),
            transfersListCEDIS: [],
            enableTransfersList: false,
            //MRP
            showOrderRecommendation: false,
            listOrderRecommendation: [],
            recommendationOrderType: '',
            recommendationOrderWhs: '',
            recommendationOrderItem: '',
            indexSelected: null,
            valueSelected: '',
            //END MRP
            flagAgentCode: false,
            handedCasco: 1,

            showDownPayments: false,
            DownPayments: [],
            enableOxxoInfo: false,
            infoOxxo: {
                DocEntry: null,
                ObjType: null,
                SubType: null,
                Param: null,
                IdOxxoRef: null,
            },

            operationList: [],
            igvOperationList: [],
            showLocationAssignment: false,
            optionLocation: 1,
            lineNumLocation: [],
            locations: [],
            showListLocationsModal: false,
            positionLine: 0,
            showDocumentStock: false,
            documentStock: [],
            locationModel: {},
            showLocationModal: false,
            uomCodes: [],

            //#region ATTACHMENT
            hasUploadedAttachment: false,
            flagUploadAttachments: false,
            showAreUAgree: false,
            AcceptAction: () => { },
            CancelAction: () => { },
            //#endregion ATTACHMENT,
            docCurrencies: [],
            formattedInfo: {},
            showFormattedQueriesModal: false,
            cancelCurrentDate: false, // Cancelar con fecha actual
            showAreYouAgreeModal: false,
            listBinLocations: [],
            showBinLocationsModal: false,
            showPropietarioCreateModal: false,
            reasonsListCreditDebit: [],
            showPriceModal: false,
            itemIndex: null,
            totalPriceInput: null,
            ORDRTransports: [],
            showORDRTransportsModal: false,
            taxChangeBy: null,
        };

        this.newModelCopy = '';
        this.selectOfReference = null;
        //MRP
        this.tableOrderRecommendation = null;
        //END MRP
        this.landedCostsRef = null;
    }

    componentDidMount = async () => {
        this._handelBack();
        await this.SetBranchOfficeInfo();
        await this.SetBillingCatalogs();
        await this.SetCurrencies();
        const wareHouseData = {
            ItemCode: null,
            TransferType: null,
            whsCode: '',
        }
        const getAlmacenResponse = await apiClient.getWarehouseList(wareHouseData);
        this.setState({ wareHousesList: getAlmacenResponse?.data ?? [] });
        this.setUserInfo()
    }
    setUserInfo = () => {
        const { view, action, newOrderModel } = this.props;
        const { _user } = this.state;
        if (view === 'PurchaseRequest') {
            if (Number(action) === 1) {
                this.openPersonRequest(_user.USERID);
                this.autoSelectPropietario(_user);
            } else if (Number(action) === 2) {
                this.autoSelectPropietario(newOrderModel);
            }
        }

        if (action === 1 && (view === 'transfersRequest' || view === 'transfers')) {
            this.autoSelectEmployee(_user);
        }
    }

    SetBranchOfficeInfo = () => {
        const { _user } = this.state
        this.setState({
            U_FMB_DEF_PLInventoryGenExitService: _user?.Branch?.U_FMB_DEF_PLInventoryGenExitService || null,
            U_FMB_DEF_PLInventoryGenEntryService: _user?.Branch?.U_FMB_DEF_PLInventoryGenEntryService || null,
            U_FMB_DEF_PLStockTransfer: _user?.Branch?.U_FMB_DEF_PLStockTransfer || null,
            U_FMB_DEF_PLReqStockTransfer: _user?.Branch?.U_FMB_DEF_PLReqStockTransfer || null,
        })
    }

    SetBillingCatalogs = async () => {
        const { enableSpinner } = this.props;
        const { operationList, igvOperationList, reasonsListCreditDebit } = this.state;
        let _OperationList = [];
        let _igvOperationList = [];
        let _reasonsListCreditDebit = [];

        if (!operationList?.length || !Array.isArray(operationList) || !igvOperationList?.length || !Array.isArray(igvOperationList)) {
            enableSpinner(true);
            const apiResponse = await apiClient.getBillingCatalogs();
            enableSpinner(false);

            if (apiResponse?.status === 1) {
                _OperationList = Array.isArray(apiResponse?.data?.operationList) ? apiResponse.data.operationList : [];
                _igvOperationList = Array.isArray(apiResponse?.data?.igvOperationList) ? apiResponse.data.igvOperationList : [];
                _reasonsListCreditDebit = Array.isArray(apiResponse?.data?.reasonsListCreditDebit) ? apiResponse.data.reasonsListCreditDebit : []; // ← agregar
            }
        } else {
            _OperationList = operationList; _igvOperationList = igvOperationList;
            _reasonsListCreditDebit = reasonsListCreditDebit;
        }

        // await this.setState({ operationList: _OperationList, igvOperationList: _igvOperationList })
        await new Promise(resolve => {
            this.setState(
                {
                    operationList: _OperationList,
                    igvOperationList: _igvOperationList,
                    reasonsListCreditDebit: _reasonsListCreditDebit, // ← agregar
                },
                resolve
            );
        });
    }

    SetCurrencies = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        let apiResponse = await apiClient.getCurrencies();
        enableSpinner(false);

        let docCurrencies = Array.isArray(apiResponse?.data) ? apiResponse.data : [];
        this.setState({ docCurrencies });
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () {
            window.location.hash = "no-back-button";
        }
    }

    openUserFields = () => {
        const { parseSeries, view, newOrderModel, isDraftOWTQ = false } = this.props;
        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser"));
        const isInvoice = (view === 'invoice' && !newOrderModel?.newView) || newOrderModel?.newView === 'invoice';
        const isCreditNote = (view === 'creditNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'creditNote';
        const isDebitNote = (view === 'debitNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'debitNote';
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || newOrderModel?.newView === 'transfers' || newOrderModel?.newView === 'transfersRequest' || isDraftOWTQ;

        if (isOWTRoOWTQ || isInvoice || isCreditNote || isDebitNote) {
            json.allUserFields.forEach((field) => {
                if (field.fieldType !== 3) return;

                if (field.fieldId === 1) {
                    let validOptions = [];
                    if (isInvoice) {
                        validOptions = [
                            { value: '01', label: 'Factura' },
                            { value: '03', label: 'Boleta' },
                        ];
                    } else if (isCreditNote) {
                        validOptions = [{ value: '07', label: 'Nota de crédito' }];
                    } else if (isDebitNote) {
                        validOptions = [{ value: '08', label: 'Nota de débito' }];
                    } else {
                        validOptions = [
                            { value: '09', label: 'Guia' },
                            { value: 'DI', label: 'Documento Interno' },
                        ];
                    }
                    field.options = validOptions;
                }

                if (field.fieldId === 36 && !field.options?.length) {
                    let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                    let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                    let seriesPuerta = {};
                    let seriesPlanta = {};
                    try {
                        seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                    } catch (e) { seriesPuerta = {}; }
                    try {
                        seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                    } catch (e) { seriesPlanta = {}; }
                    const noNeedDefault = isInvoice || isCreditNote || isDebitNote;
                    const seriesPuertaParsed = parseSeries(seriesPuerta, noNeedDefault);
                    const seriesPlantaParsed = parseSeries(seriesPlanta, noNeedDefault);
                    const isZonal = Number(user?.Branch?.Type) === 1;
                    field.options = (isZonal
                        ? (Array.isArray(seriesPuertaParsed) ? seriesPuertaParsed : [])
                        : (Array.isArray(seriesPlantaParsed) ? seriesPlantaParsed : [])
                    )?.filter((option, index, self) =>
                        index === self?.findIndex(x => x.value === option.value)
                    );
                }
            });

            this.refreshModel(this.props.newOrderModel);
        }

        this.forceUpdate(() => {
            $("#userFieldsModal").modal("show");
        });
    }

    transactions = async () => {
        const { newOrderModel, enableSpinner, showAlert } = this.props;
        let transactionId = newOrderModel.transactionId;
        enableSpinner(true);
        let getTransactions = await apiClient.getTransactions(transactionId);
        enableSpinner(false);

        if (!Array.isArray(getTransactions.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }
        if (getTransactions.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        this.setState({
            transactions: getTransactions.data,
        });
        $('#transactionsModal').modal('show');
    };

    paymnetList = async () => {
        const { newOrderModel, enableSpinner, showAlert } = this.props;
        enableSpinner(true);

        let getPaymentLists = await apiClient.getPaymnetList(newOrderModel.DocEntry, newOrderModel.ObjType);
        enableSpinner(false);

        if (!Array.isArray(getPaymentLists.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }
        if (getPaymentLists.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        this.setState({
            paymentList: getPaymentLists.data,
        });
        $('#paymentListModaL').modal('show');
    };

    openAction = () => {

        $('#DocumentCreateModal').on('hide.bs.modal', function () {
        });
    };

    validatePartner = () => {
        const { newOrderModel, view, isDraftOWTQ = false } = this.props;

        if ((newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft' || newOrderModel?.newView === 'PurchaseOrder') && !newOrderModel.CardCode) {
            return false;
        }

        if (view === 'transfers' || view === 'transfersRequest' || isDraftOWTQ) {
            return true;
        }

        if (newOrderModel.CardCode !== '' && newOrderModel.CardName !== '') {
            return true;
        }
        return false;
    };

    validatePersonRequest = () => {
        const { newOrderModel, view } = this.props;

        if (view === 'transfers') {
            return true;
        }

        if (newOrderModel.Requester !== '') {
            return true;
        }
        return false;
    }

    validateWharehose = () => {
        const { newOrderModel } = this.props;

        if (newOrderModel.WhsCode !== '') {
            return true;
        }
        return false;
    };

    closeModalCreate = async () => {

        const { action, CloseDocumentModal, setFiles } = this.props
        if (action === 1) {
            $('#confirmModal').modal('show');
        } else {

            $('#DocumentCreateModal').modal('hide');
            await CloseDocumentModal();
        }
        //#region ATTACHMENT
        var fileInput = document.getElementById("fileImput2");
        if (fileInput) {
            fileInput.value = null;
        }
        setFiles([]);
        //#endregion ATTACHMENT
        this.setState({
            service: 'I',
            isCancelCFDI: false,
            hasUploadedAttachment: false,
            flagUploadAttachments: false,
        });

    };

    OpenModalCloseDocuments = async () => {
        $('#cancelDocuments').modal('show');
    }

    CancelDocuments = async () => {
        const { newOrderModel, selectTable, enableSpinner, showAlert } = this.props;
        let table = selectTable(newOrderModel.OriginDocumentCreate);
        $('#cancelDocuments').modal('hide');
        let data = {
            DocEntry: newOrderModel.DocEntry,
            table
        }

        enableSpinner(true);
        let response = await apiClient.cancelDocuments(data);
        enableSpinner(false);

        if (response.status === 0) {
            showAlert({ type: "error", message: `${response.message ?? ''}`, timeOut: 8000 });
            return;
        } else {
            showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
            $('#DocumentCreateModal').modal('hide');
            return;
        }
    };

    OpenModalCancelCFDI = () => {
        $('#cancelCFDI').modal('show');
    }

    CancelCFDI = async () => {
        const { newOrderModel, selectTable, enableSpinner, showAlert } = this.props;
        let table = selectTable(newOrderModel.OriginDocumentCreate);
        $('#cancelDocuments').modal('hide');

        let motivo = document.getElementById("selectCancelCFDI").value;
        const U_FMB_UUID_RELACIONADO = document.getElementById("U_FMB_UUID_RELACIONADO") !== null && document.getElementById("U_FMB_UUID_RELACIONADO") !== undefined ? document.getElementById("U_FMB_UUID_RELACIONADO").value : '';


        if (motivo === '00') {
            return showAlert({ type: "warning", message: `Parámetro inválido. El motivo de cancelacion no es un valor válido`, timeOut: 8000 });
        } else if (motivo === '01' && U_FMB_UUID_RELACIONADO === '') {
            return showAlert({ type: "warning", message: `Parámetro inválido. Debes de colocar un UUID`, timeOut: 8000 });
        }

        const data = {
            DocEntry: newOrderModel.DocEntry,
            Table: table,
            Motivo: motivo || '02',
            U_FMB_UUID_RELACIONADO: U_FMB_UUID_RELACIONADO || '',
        }

        enableSpinner(true);
        let response = await apiClient.CancelCFDI(data);
        enableSpinner(false);

        $('#cancelCFDI').modal('hide');
        if (response.status === 0) {
            return showAlert({ type: "error", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) {
            return showAlert({ type: "info", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else {
            $('#DocumentCreateModal').modal('hide');
            this.setState({
                isCancelCFDI: false,
            });
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    };

    ConsultarEstatusCFDI = async () => {
        const { newOrderModel, selectTable, enableSpinner, showAlert } = this.props;
        let table = selectTable(newOrderModel.OriginDocumentCreate);
        let data = {
            DocEntry: newOrderModel.DocEntry,
            Table: table,
        }

        enableSpinner(true);
        let response = await apiClient.ConsultarEstatusCFDI(data);
        enableSpinner(false);

        if (response.status === 0) {
            return showAlert({ type: "error", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) {
            this.setState(
                {
                    isCancelCFDI: true,
                }
            )
            return showAlert({ type: "info", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else {
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    };

    openAccountBalance = async (info = null) => {
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;

        var date = new Date();
        let cardCode = newOrderModel.CardCode || '';
        var firstDay = moment(new Date(date.getFullYear(), 0, 1)).format('YYYY-MM-DD');
        var lastDay = moment(new Date(date.getFullYear(), 11, 31)).format('YYYY-MM-DD');
        let data;

        if (info) {
            data = {
                CardCode: info.CardCode,
                FirstDay: info.FirstDay,
                LastDay: info.LastDay,
                DocDate: info.DocDate,
                Visualize: info.Visualize,
                VisualizeNum: info.VisualizeNum,
                OnlyUnreconciled: info.OnlyUnreconciled
            }

        } else {
            data = {
                CardCode: cardCode,
                FirstDay: firstDay,
                LastDay: lastDay,
                DocDate: true,
                Visualize: true,
                VisualizeNum: 50,
                OnlyUnreconciled: true
            }
        }


        let getAccountResponse;
        enableSpinner(true);
        getAccountResponse = await apiClient.getAccountBalance(data);
        enableSpinner(false);
        if (!Array.isArray(getAccountResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }
        if (getAccountResponse.data === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        this.setState({
            CardCodeBalance: getAccountResponse.data[0],
            AccountBalan: getAccountResponse.data[1],
            AccountBalanceData: data
        });
        if (!info) {
            $('#accoutBalanceModal').modal('show');
        }



    }

    openPartner = async (index = null, agentCode = false) => {
        const { newOrderModel, view, enableSpinner, showAlert, isDraftOWTQ = false } = this.props;

        let CardCode = null;
        if (agentCode) {
            this.validateEnter(3);
            this.setState({ flagAgentCode: true });
            CardCode = newOrderModel.AgentCode || CardCode;
        } else {
            this.validateEnter(1);
            CardCode = newOrderModel.CardCode || CardCode;
        }

        let type = 'C';
        if (view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'outgoingPayment' || view === 'landedCosts' || view === 'purchaseDownPayments' || view === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft' || view === 'draft' || newOrderModel.OriginDocumentCreate === "PurchaseOrder") {
            type = 'S';
        } else if (view === 'quotations') {
            type = 'SC';
        }

        if (view === 'PurchaseRequest' && ((newOrderModel?.newView !== 'PurchaseQuotation' && newOrderModel?.newView !== 'PurchaseQuotationDraft' && newOrderModel.OriginDocumentCreate !== "PurchaseOrder") || !newOrderModel?.newView)) {
            newOrderModel.CardCode = newOrderModel.Items[index].LineVendor;
        }
        if (view === 'transfersRequest' || isDraftOWTQ) {
            type = newOrderModel?.CardType || 'C';
        }

        enableSpinner(true);
        let getPartnerResponse = await apiClient.getPartner(type, CardCode, newOrderModel?.newView || view);
        enableSpinner(false);

        if (getPartnerResponse.status === 0) {
            if (!Array.isArray(getPartnerResponse.data.results)) {
                showAlert({ type: 'info', message: getPartnerResponse.message });
                return;
            }
            if (getPartnerResponse.data.results.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getPartnerResponse.data.length === 1) {

            if (getPartnerResponse.data[0].validFor === 'N') {
                showAlert({ type: 'error', message: 'El socio de negocio se encuentra inactivo' });
                this.clearSocio();
                return;
            }

            let Balance = getPartnerResponse.data[0].Balance;
            let credit = getPartnerResponse.data[0].CreditLine;
            let limit = Balance - credit;

            if (view === 'orderSales' || view === "deliveries" || view === 'invoice' || view === 'return' || view === 'creditNote' || view === 'debitNote' || view === "invoiceReserve" || view === "quotations") {
                const isContado = getPartnerResponse.data[0].PymntGroup === 'Contado';
                if (limit > 0 && !isContado) {
                    $('#creditLimitModal').modal('show');
                    this.setState({
                        Codigo: getPartnerResponse.data[0].CardCode,
                        CardName: getPartnerResponse.data[0].CardName,
                        Balance: parseFloat(limit).toFixed(2)
                    });
                }
            }

            this.setState({
                partners: getPartnerResponse.data,
                partnerType: type
            });


            this.selectSocio(getPartnerResponse.data[0]);
        } else {
            this.setState({
                partners: getPartnerResponse.data.results,
                partnerType: type,
                pageTotal: getPartnerResponse.data.totalPage,
                indexPurchaseRequest: index,
            });
            $('#partnerCreate').modal('show');
        }
        setTimeout(() => {
            if ($('.modal-backdrop').length && !$('.modal.show').length) {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
            }
        }, 500);
    };
    clearBP = () => {
        const { newOrderModel } = this.props;
        newOrderModel.CardCode = null
        newOrderModel.CardName = null
        newOrderModel.DocCur = null
        newOrderModel.ChangeRate = null
        newOrderModel.CntctCode = null
        newOrderModel.CntctName = null
        if (!newOrderModel.isPurchaseDocument) {
            newOrderModel.OwnerCode = null
            newOrderModel.SlpCode = null
            newOrderModel.SlpName = null
        }
        newOrderModel.GroupNum = null;
        newOrderModel.GroupName = null;
        newOrderModel.GroupCode = null;
        newOrderModel.GroupCodeName = null;
        newOrderModel.ExtraDays = null;
        newOrderModel.PymCode = null;
        newOrderModel.PymName = null;
        newOrderModel.Address = null;
        newOrderModel.deliveriesAddress = [];
        newOrderModel.invoicesAddress = [];
        newOrderModel.ShipToCode = null;
        newOrderModel.Address2 = null;
        newOrderModel.UBIGEO = null;
        newOrderModel.U_RMO_ID_DIRE = null;
        newOrderModel.Balance = null;
        newOrderModel.CreditLine = null;
        newOrderModel.PriceListNum = null;
        newOrderModel.E_Mail = null;
        newOrderModel.ItemsPayments = [];
        newOrderModel.OcrCode2 = null;
        newOrderModel.LicTradNum = null;
        newOrderModel.U_FMB_DescPP = null;
        newOrderModel.GroupNum = null;
        newOrderModel.TaxeDefaultPartner = null;
        newOrderModel.TaxeRateDefaultPartner = null;
        newOrderModel.TaxNameDefaultPartner = null;
        newOrderModel.OcrCode2DefaultPartner = null;
        newOrderModel.AcctCodeDefaultPartner = null;
        newOrderModel.CogsAcctDefaultPartner = null;
        newOrderModel.AcctCodeNameDefaultPartner = null;
        newOrderModel.CogsAcctNameDefaultPartner = null;
        newOrderModel.BpAct = null;
        newOrderModel.BpActName = null;
        newOrderModel.BpActFormatCode = null;
        newOrderModel.BpActCopy = null;
        newOrderModel.BpActNameCopy = null;
        newOrderModel.BpActFormatCodeCopy = null;
        newOrderModel.Project = null;
        newOrderModel.UBIGEO = null;
        newOrderModel.U_RMO_ID_DIRE = null;
        newOrderModel.NeedScopCode = false;
        //#region ################## PERCEPCION ################ ✔
        newOrderModel.U_BPP_BPTD = null;
        newOrderModel.U_STR_AR = null;
        newOrderModel.U_STR_AP = null;
        newOrderModel.U_LLG_EXCEPTUADO_PERCEPCION = null;
        //#endregion ################## PERCEPCION ################ ✔


        //#region DIMENSIONS
        if (newOrderModel.isSalesDocument && newOrderModel.DocType === 'I') {
            newOrderModel.Dimension1 = null;
            for (const item of newOrderModel?.Items) {
                item.OcrCode = null;
            }
        }
        //#endregion DIMENSIONS
        newOrderModel.WTCodes = [];

        //#region DETRACCIONES
        newOrderModel.WTCodesD = [];
        newOrderModel.U_FMB_BP_Detra = 'N';
        //#endregion DETRACCIONES

        //#region RETENCIONES
        newOrderModel.U_FMB_BP_Reten = 'N';
        newOrderModel.U_STR_BC = 'N';
        newOrderModel.WTCodesR = [];
        // newOrderModel = await this.checkWithHolding(newOrderModel);//VALIDATE IF NECESSARY
        //#endregion RETENCIONES

        newOrderModel.Addresses = [];
        newOrderModel.U_FMB_END_DATE = null;
        newOrderModel.DocDueDate = null;

        this.refreshModel(newOrderModel)

    };

    selectSocio = async partner => {
        //GroupNum
        const { U_FMB_DEF_PLReqStockTransfer, U_FMB_DEF_PLStockTransfer, flagAgentCode } = this.state;
        let { newOrderModel, view, enableSpinner, showAlert, getDimension1, isDraftOWTQ = false } = this.props;
        try {
            let newView = newOrderModel.newView || view;
            if (view === 'landedCosts' && flagAgentCode) {
                this.saveAgentCode(partner);
                return;
            }
            let getCurrencies = await apiClient.getCurrencies();
            partner.Currency = partner.Currency === '##' ? CURRENCY : partner.Currency;
            let selectDocCur = getCurrencies.data.filter((currency) => currency.CurrCode === partner.Currency) || 1;
            newOrderModel.CardCode = partner.CardCode;
            newOrderModel.CardName = partner.CardName;
            newOrderModel.DocCur = partner.Currency || '';
            newOrderModel.ChangeRate = selectDocCur[0].Rate || 1;
            const inheritedSlpCode = newOrderModel.SlpCode || '';
            const inheritedSlpName = newOrderModel.SlpName || '';
            const keepInheritedEmployee =
                newView === 'PurchaseQuotationDraft' &&
                !!inheritedSlpCode &&
                !!inheritedSlpName;

            if (newOrderModel.isPurchaseDocument) {
                const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
                if (keepInheritedEmployee) {
                    newOrderModel.SlpCode = inheritedSlpCode;
                    newOrderModel.SlpName = inheritedSlpName;
                } else {
                    newOrderModel.SlpCode = user?.U_SlpCode || partner.SlpCode || '';
                    newOrderModel.SlpName = user?.U_NAME || partner.SlpName || '';
                }
            } else {
                newOrderModel.SlpCode = partner.SlpCode || '';
                newOrderModel.SlpName = partner.SlpName || '';
            }

            newOrderModel.CntctCode = partner.CodigoContacto || '';
            newOrderModel.CntctName = partner.Contacto || '';
            if (!newOrderModel.isPurchaseDocument) {
                newOrderModel.OwnerCode = partner.OwnerCode || '';
            }
            newOrderModel.GroupNum = partner.GroupNum || ''; // first Branch office Price List 
            newOrderModel.GroupName = partner.PymntGroup || '';
            newOrderModel.GroupCode = partner.GroupCode || '';
            newOrderModel.GroupCodeName = partner.GroupCodeName || '';
            newOrderModel.ExtraDays = partner.ExtraDays || 0;
            newOrderModel.PymCode = partner.PymCode || '';
            newOrderModel.PymName = partner.Descript || '';
            newOrderModel.Address = partner.Address || '';
            newOrderModel.deliveriesAddress = [];
            newOrderModel.invoicesAddress = [];
            newOrderModel.ShipToCode = '';
            newOrderModel.Address2 = '';
            newOrderModel.UBIGEO = '';
            newOrderModel.U_RMO_ID_DIRE = '';
            newOrderModel.Balance = partner.Balance || '';
            newOrderModel.CreditLine = partner.CreditLine || 0;
            newOrderModel.PriceListNum = partner.ListNum || '';
            newOrderModel.E_Mail = partner.E_Mail;
            newOrderModel.ItemsPayments = [];
            newOrderModel.OcrCode2 = partner.OcrCode2;
            newOrderModel.LicTradNum = partner.LicTradNum || '';

            newOrderModel.U_FMB_DescPP = Number(partner.U_FMB_DescPP || 0);
            //BRANCH OFFICE CONFIG PRICE LIST
            if (view === 'transfersRequest' || isDraftOWTQ) {
                newOrderModel.GroupNum = U_FMB_DEF_PLReqStockTransfer !== null ? Number(U_FMB_DEF_PLReqStockTransfer) : partner.GroupNum || ''; // first Branch office Price List (REQUEST TRANSFER)
            }
            if (view === 'transfers') {
                newOrderModel.GroupNum = U_FMB_DEF_PLStockTransfer !== null ? Number(U_FMB_DEF_PLStockTransfer) : partner.GroupNum || ''; // first Branch office Price List (stockTransfer)
            }


            //impuesto definido desde el usuario

            if (partner.CardType === 'C') {
                newOrderModel.TaxeDefaultPartner = partner.TaxCode || '';
                newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 16;
                newOrderModel.TaxNameDefaultPartner = partner.TaxCodeName || '';

            } else {
                newOrderModel.TaxeDefaultPartner = partner.VatGroup || '';
                newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 16;
                newOrderModel.TaxNameDefaultPartner = partner.TaxCodeName || '';
            }

            if ((!newOrderModel.TaxeDefaultPartner || newOrderModel.TaxeDefaultPartner === '') && this.isMarketingDocument(view)) {
                showAlert({ type: 'warning', message: 'Información de socio incompleta, no cuenta con indicador de impuestos en su dirección de entrega' }, 5000);
            }

            newOrderModel.OcrCode2DefaultPartner = partner.OcrCode2 || '';
            newOrderModel.AcctCodeDefaultPartner = partner.AcctCodeItem || '';
            newOrderModel.CogsAcctDefaultPartner = partner.CogsAcctItem || '';
            newOrderModel.AcctCodeNameDefaultPartner = partner.AcctCodeItemName || '';
            newOrderModel.CogsAcctNameDefaultPartner = partner.CogsAcctItemName || '';

            //pagos
            newOrderModel.BpAct = partner.AcctCode || '';
            newOrderModel.BpActName = partner.AcctName || '';
            newOrderModel.BpActFormatCode = partner.FormatCode || partner.BpActFormatCode;
            newOrderModel.BpActCopy = partner.AcctCode || '';
            newOrderModel.BpActNameCopy = partner.AcctName || '';
            newOrderModel.BpActFormatCodeCopy = partner.FormatCode || '';



            newOrderModel = await this.updateItemsWhenPartnerChange(newOrderModel);
            //Agregar Direccion Por Defecto

            let getAddressResponse = await apiClient.getAddressParter(newOrderModel.CardCode);
            newOrderModel.deliveriesAddress = getAddressResponse.data.deliveriesAddress || [];
            newOrderModel.invoicesAddress = getAddressResponse.data.invoicesAddress || [];
            let address = [];
            const isPurchaseQuotation = newView === 'PurchaseQuotation' || newView === 'PurchaseQuotationDraft';
            const isPurchaseOrder = newView === 'PurchaseOrder';
            if (newView !== 'PurchaseRequest') {
                if (partner.CardType === 'C' || ((isPurchaseQuotation || isPurchaseOrder || newOrderModel.isTransferDocument) && partner.CardType === 'S')) {
                    let searchDefault = getAddressResponse.data.deliveriesAddress.find(address => address.Address === partner.ShipToDef);
                    address = searchDefault ? searchDefault : getAddressResponse.data.deliveriesAddress[0] || [];
                } else {
                    address = getAddressResponse.data.invoicesAddress[0] || [];
                }

                newOrderModel.ShipToCode = address ? address.Address : '';
                newOrderModel.Address2 = (address.Street ? address.Street : '') + ' ' + (address.Block ? address.Block : '') + '  ' + (address.City ? address.City : '') + ' ' + (address.ZipCode ? address.ZipCode : '') + ' ' + (address.State ? address.State : '') + ' ' + (address.Country ? address.Country : '') || "";
                if (newOrderModel?.isSalesDocument && newOrderModel?.ShipToCode && address?.AdresType === 'S') { // NEW PROJECT LOGIC
                    newOrderModel.Project = address?.U_FMB_Project || '';
                    newOrderModel.UBIGEO = address?.ZipCode || '';
                    newOrderModel.U_RMO_ID_DIRE = address?.U_RMO_ID_DIRE || '';
                }
            }
            // SCOP validation 
            newOrderModel.NeedScopCode = address?.U_FMB_FICHA_OSIN ? true : false;
            //#region ################## PERCEPCION ################ ✔
            newOrderModel.U_BPP_BPTD = partner.U_BPP_BPTD;
            newOrderModel.U_STR_AR = partner.U_STR_AR;
            newOrderModel.U_STR_AP = partner.U_STR_AP;
            newOrderModel.U_LLG_EXCEPTUADO_PERCEPCION = partner.U_LLG_EXCEPTUADO_PERCEPCION;
            //#endregion ################## PERCEPCION ################ ✔

            //#region CENTROS DE COSTOS
            // for (let index = 0; index < newOrderModel.Items.length; index++) {
            //     const item = newOrderModel.Items[index];
            //CENTROS DE COSTOS 
            //CENTRO DE COSTO 1
            //item.OcrCode = '';
            //CENTRO DE COSTO 2
            // item.OcrCode2 = partner.OcrCode2;
            //CENTRO DE COSTO 3
            //item.OcrCode3 = '';
            //CENTRO DE COSTO 4
            // item.OcrCode4 = '';
            //CENTROS DE COSTOS 

            // }
            //#endregion

            //#region DIMENSIONS
            if (newOrderModel.isSalesDocument && newOrderModel.DocType === 'I') {
                newOrderModel.Dimension1 = await getDimension1(newOrderModel);
                if (newOrderModel.Dimension1) {
                    for (const item of newOrderModel?.Items) {
                        item.OcrCode = newOrderModel.Dimension1;
                    }
                    if (newOrderModel?.Items?.length) {
                        showAlert({ type: 'info', message: `La dimensión 1 llamada "CANAL" de los artículos ha cambiado conforme al socio`, timeOut: 8000 });
                    }
                }
            }
            //#endregion DIMENSIONS

            if (newOrderModel.isPurchaseDocument) {
                newOrderModel.WTCodes = partner.WTCodes || [];
                //#region DETRACCIONES
                if (newOrderModel.DetraccionVista || newView === 'PurchaseOrder') {
                    newOrderModel.WTCodesD = partner.WTCodesD || [];
                    newOrderModel.U_FMB_BP_Detra = newOrderModel?.WTCodesD?.length ? 'Y' : 'N';
                }
                //#endregion DETRACCIONES
            }

            //#region RETENCIONES
            if (newOrderModel.RetencionVista || newView === 'PurchaseOrder') {
                newOrderModel.WTCodesR = partner?.WTCodesR || [];
                newOrderModel.WTCodesR = newOrderModel.WTCodesR?.filter(wtcode => (wtcode.WTCode || wtcode.WTName || '')?.includes('3%')) ?? [];
                newOrderModel.U_FMB_BP_Reten = newOrderModel?.WTCodesR?.length ? 'Y' : 'N';
                newOrderModel.U_STR_BC = partner.U_STR_BC || 'N';

                newOrderModel = await this.checkWithHolding(newOrderModel);
            }
            //#endregion RETENCIONES

            //#region PRECIOS ESPECIALES
            if (newOrderModel.Items.length > 0 && (view === 'orderSales')) {
                let CardCode = newOrderModel.CardCode;
                let DocDate = newOrderModel.DocDate;
                enableSpinner(true);
                let getItemResponse = await apiClient.getItemsPrice(CardCode, newOrderModel.Items, DocDate);
                enableSpinner(false);
                if (getItemResponse.status === 1) {
                    newOrderModel.Items = getItemResponse.data;
                }
            }
            //#endregion

            newOrderModel.Addresses = []; // Mandar a consultar direcciones

            //Calculo fecha de entrega 
            let today = moment(new Date()).format('YYYY-MM-DD');
            if (view === 'invoice' || view === 'orderSales' || view === 'debitNote' || view === 'invoiceReserve') {


                let grouNum = newOrderModel.GroupNum;
                let groupName = newOrderModel.GroupName;
                let extraDays = newOrderModel.ExtraDays;
                let typeInvoice = 0;

                // let userFieldTypeInvoice = newOrderModel.userFields.userFields3;
                // if(userFieldTypeInvoice === 'Contado' || (groupName === 'Pago Inmediato' && grouNum === 9)){
                //     typeInvoice = 3;
                // }else if(userFieldTypeInvoice === 'Credito'){
                //     typeInvoice = 14
                // }else if(userFieldTypeInvoice === 'Credito2'){
                //     if(extraDays > 28){
                //         typeInvoice = extraDays;
                //     }else{
                //         typeInvoice = 28;
                //     }
                // }else if (groupName != '' && extraDays != 0){
                //     typeInvoice = extraDays;
                // }

                if (typeInvoice == 0) {
                    typeInvoice = extraDays ? extraDays : Number(newOrderModel?.GroupNum) === -1 ? 0 : 3;
                }
                let docDueDate = new Date(today);
                docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
                let weekDays = 0;
                while (weekDays < typeInvoice) {
                    docDueDate.setDate(docDueDate.getDate() + 1);
                    // if(docDueDate.getDay() != 0){
                    weekDays++;
                    // }
                }
                newOrderModel.DocDueDate = moment(docDueDate).format('YYYY-MM-DD');
            }
            newOrderModel.U_FMB_END_DATE = newOrderModel.DocDueDate;

            const data = {
                GroupNum: newOrderModel.GroupNum,
                view,
                showAlert,
                model: newOrderModel,
                enableSpinner
            }
            await setDueDateFromPaymentConds(data)

            await this.refreshTotal(newOrderModel);
            await this.validateEnter(2);
            await this.restartTabs();
            setTimeout(() => {
                this.setState({ partners: [] });
                if ($('.modal-backdrop').length && !$('.modal.show').length) {
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                }
            }, 100);
            //#region Precio Llamagas
            // if (newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) { // Al cambiar de socio consultar precios
            if (newOrderModel?.isSalesDocument) { // Al cambiar de socio consultar precios
                setTimeout(() => {
                    this.checkItemPrices(false, true);
                }, 500);
            }
            //#endregion Precio Llamagas
        } catch {
            showAlert({ type: 'warning', message: 'Información de socio incompleta, no tiene direcciónes' });
            this.restartTabs();
            setTimeout(() => {
                this.setState({ partners: [] });
                if ($('.modal-backdrop').length && !$('.modal.show').length) {
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                }
            }, 100);
        }
    };

    selectPartner = async (action, newIndex = null) => {
        const { partners, U_FMB_DEF_PLReqStockTransfer, U_FMB_DEF_PLStockTransfer, flagAgentCode } = this.state;
        let { newOrderModel, view, enableSpinner, showAlert, getDimension1, isDraftOWTQ = false } = this.props;
        let partner = partners[action.index];
        let Balance = partner.Balance;
        let credit = partner.CreditLine;
        let limit = Balance - credit;
        let newView = newOrderModel.newView || view;

        if (partner.validFor === 'N') {
            showAlert({ type: 'error', message: 'El socio de negocio se encuentra inactivo' });
            let field = flagAgentCode ? 'AgetCode' : '';
            this.clearSocio(field);
            return;
        }

        if (view === 'landedCosts' && flagAgentCode) {
            this.saveAgentCode(partner);
            $('#partnerCreate').modal('hide');
            return;
        }

        if (view === 'quotations' || view === 'orderSales' || view === "deliveries" || view === 'invoice' || view === 'return' || view === 'creditNote' || view === 'debitNote' || view === "invoiceReserve") {
            const isContado = partner.PymntGroup === 'Contado';
            if (limit > 0 && !isContado) {
                $('#creditLimitModal').modal('show');
                this.setState({
                    Codigo: partner.CardCode,
                    CardName: partner.CardName,
                    Balance: parseFloat(limit).toFixed(2)
                });
            }
        }
        $('#partnerCreate').modal('hide');
        try {
            let getCurrencies = await apiClient.getCurrencies();
            partner.Currency = partner.Currency === '##' ? CURRENCY : partner.Currency;
            let selectDocCur = getCurrencies.data.filter((currency) => currency.CurrCode === partner.Currency) || 1;
            newOrderModel.CardCode = partner.CardCode;
            newOrderModel.CardName = partner.CardName;
            newOrderModel.Email = partner.E_mail || '';
            newOrderModel.DocCur = partner.Currency || '';
            newOrderModel.ChangeRate = selectDocCur[0].Rate || 1;
            const inheritedSlpCode = newOrderModel.SlpCode || '';
            const inheritedSlpName = newOrderModel.SlpName || '';
            const keepInheritedEmployee =
                newView === 'PurchaseQuotationDraft' &&
                !!inheritedSlpCode &&
                !!inheritedSlpName;

            if (newOrderModel.isPurchaseDocument) {
                const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
                if (keepInheritedEmployee) {
                    newOrderModel.SlpCode = inheritedSlpCode;
                    newOrderModel.SlpName = inheritedSlpName;
                } else {
                    newOrderModel.SlpCode = user?.U_SlpCode || partner.SlpCode || '';
                    newOrderModel.SlpName = user?.U_NAME || partner.SlpName || '';
                }
            } else {
                newOrderModel.SlpCode = partner.SlpCode || '';
                newOrderModel.SlpName = partner.SlpName || '';
            }

            newOrderModel.CntctCode = partner.CodigoContacto || '';
            newOrderModel.CntctName = partner.Contacto || '';
            if (!newOrderModel.isPurchaseDocument) {
                newOrderModel.OwnerCode = partner.OwnerCode || '';
            }
            newOrderModel.GroupNum = partner.GroupNum || ''; // first Branch office Price List 
            newOrderModel.GroupName = partner.PymntGroup || '';
            newOrderModel.GroupCode = partner.GroupCode || '';
            newOrderModel.GroupCodeName = partner.GroupCodeName || '';
            newOrderModel.PymCode = partner.PymCode || '';
            newOrderModel.ExtraDays = partner.ExtraDays || 0;
            newOrderModel.PymName = partner.Descript || '';
            newOrderModel.Address = partner.Address || '';
            newOrderModel.deliveriesAddress = [];
            newOrderModel.invoicesAddress = [];
            newOrderModel.ShipToCode = '';
            newOrderModel.Address2 = '';
            newOrderModel.UBIGEO = '';
            newOrderModel.U_RMO_ID_DIRE = '';
            newOrderModel.PriceListNum = partner.ListNum || '';
            newOrderModel.Balance = partner.Balance || '';
            newOrderModel.CreditLine = partner.CreditLine || 0;
            newOrderModel.E_Mail = partner.E_Mail;
            newOrderModel.ItemsPayments = [];
            newOrderModel.OcrCode2 = partner.OcrCode2;
            newOrderModel.LicTradNum = partner.LicTradNum || '';
            //BRANCH OFFICE CONFIG PRICE LIST
            if (view === 'transfersRequest' || isDraftOWTQ) {
                newOrderModel.GroupNum = U_FMB_DEF_PLReqStockTransfer !== null ? Number(U_FMB_DEF_PLReqStockTransfer) : partner.GroupNum || ''; // first Branch office Price List (REQUEST TRANSFER)
            }
            if (view === 'transfers') {
                newOrderModel.GroupNum = U_FMB_DEF_PLStockTransfer !== null ? Number(U_FMB_DEF_PLStockTransfer) : partner.GroupNum || ''; // first Branch office Price List (stockTransfer)
            }

            //impuesto definido desde el usuario

            if (partner.CardType === 'C') {
                newOrderModel.TaxeDefaultPartner = partner.TaxCode || '';
                newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 16;
                newOrderModel.TaxNameDefaultPartner = partner.TaxCodeName || '';
            } else {
                newOrderModel.TaxeDefaultPartner = partner.VatGroup || '';
                newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 16;
                newOrderModel.TaxNameDefaultPartner = partner.TaxCodeName || '';
            }
            //newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 0;
            newOrderModel.OcrCode2DefaultPartner = partner.OcrCode2 || '';
            newOrderModel.AcctCodeDefaultPartner = partner.AcctCodeItem || '';
            newOrderModel.CogsAcctDefaultPartner = partner.CogsAcctItem || '';
            newOrderModel.AcctCodeNameDefaultPartner = partner.AcctCodeItemName || '';
            newOrderModel.CogsAcctNameDefaultPartner = partner.CogsAcctItemName || '';

            //pagos
            newOrderModel.BpAct = partner.AcctCode || '';
            newOrderModel.BpActName = partner.AcctName || '';
            newOrderModel.BpActFormatCode = partner.FormatCode || partner.BpActFormatCode;
            newOrderModel.BpActCopy = partner.AcctCode || '';
            newOrderModel.BpActNameCopy = partner.AcctName || '';
            newOrderModel.BpActFormatCodeCopy = partner.FormatCode || '';

            newOrderModel.U_FMB_DescPP = Number(partner.U_FMB_DescPP || 0);

            // newOrderModel = await this.updateItemsWhenPartnerChange(newOrderModel);

            let getAddressResponse = await apiClient.getAddressParter(newOrderModel.CardCode);
            newOrderModel.deliveriesAddress = getAddressResponse.data.deliveriesAddress || [];
            newOrderModel.invoicesAddress = getAddressResponse.data.invoicesAddress || [];

            let address = [];
            const isPurchaseQuotation = newView === 'PurchaseQuotation' || newView === 'PurchaseQuotationDraft';
            const isPurchaseOrder = newView === 'PurchaseOrder';
            if (newView !== 'PurchaseRequest') {
                if (partner.CardType === 'C' || ((isPurchaseQuotation || isPurchaseOrder || newOrderModel.isTransferDocument) && partner.CardType === 'S')) {
                    let searchDefault = getAddressResponse.data.deliveriesAddress.find(address => address.Address === partner.ShipToDef);
                    address = searchDefault ? searchDefault : getAddressResponse.data.deliveriesAddress[0] || [];
                } else {
                    address = getAddressResponse.data.invoicesAddress[0] || [];
                }

                newOrderModel.ShipToCode = address ? address.Address : '';
                newOrderModel.Address2 = (address.Street ? address.Street : '') + ' ' + (address.Block ? address.Block : '') + '  ' + (address.City ? address.City : '') + ' ' + (address.ZipCode ? address.ZipCode : '') + ' ' + (address.State ? address.State : '') + ' ' + (address.Country ? address.Country : '') || "";
                if (newOrderModel?.isSalesDocument && newOrderModel?.ShipToCode && address?.AdresType === 'S') { // NEW PROJECT LOGIC
                    newOrderModel.Project = address?.U_FMB_Project || '';
                    newOrderModel.UBIGEO = address?.ZipCode || '';
                    newOrderModel.U_RMO_ID_DIRE = address?.U_RMO_ID_DIRE || '';
                }
            }
            // SCOP validation 
            newOrderModel.NeedScopCode = address?.U_FMB_FICHA_OSIN ? true : false;
            //#region ################## PERCEPCION ################ ✔
            newOrderModel.U_BPP_BPTD = partner.U_BPP_BPTD;
            newOrderModel.U_STR_AR = partner.U_STR_AR;
            newOrderModel.U_STR_AP = partner.U_STR_AP;
            newOrderModel.U_LLG_EXCEPTUADO_PERCEPCION = partner.U_LLG_EXCEPTUADO_PERCEPCION;
            //#endregion ################## PERCEPCION ################ ✔

            //#region CENTROS DE COSTOS
            // for (let index = 0; index < newOrderModel.Items.length; index++) {
            // const item = newOrderModel.Items[index];
            //CENTROS DE COSTOS 
            //CENTRO DE COSTO 1
            //item.OcrCode = '';
            //CENTRO DE COSTO 2
            // item.OcrCode2 = partner.OcrCode2;
            //CENTRO DE COSTO 3
            //item.OcrCode3 = '';
            //CENTRO DE COSTO 4
            // item.OcrCode4 = '';
            //CENTROS DE COSTOS 

            // }
            //#endregion

            //#region DIMENSIONS
            if (newOrderModel.isSalesDocument && newOrderModel.DocType === 'I') {
                newOrderModel.Dimension1 = await getDimension1(newOrderModel);
                if (newOrderModel.Dimension1) {
                    for (const item of newOrderModel?.Items) {
                        item.OcrCode = newOrderModel.Dimension1;
                    }
                    if (newOrderModel?.Items?.length) {
                        showAlert({ type: 'info', message: `La dimensión 1 llamada "CANAL" de los artículos ha cambiado conforme al socio`, timeOut: 8000 });
                    }
                }
            }
            //#endregion DIMENSIONS

            if (newOrderModel.isPurchaseDocument) {
                newOrderModel.WTCodes = partner.WTCodes || [];
                //#region DETRACCIONES
                if (newOrderModel.DetraccionVista || newView === 'PurchaseOrder') {
                    newOrderModel.WTCodesD = partner.WTCodesD || [];
                    newOrderModel.U_FMB_BP_Detra = newOrderModel?.WTCodesD?.length ? 'Y' : 'N';
                }
                //#endregion DETRACCIONES
            }

            //#region RETENCIONES
            if (newOrderModel.RetencionVista || newView === 'PurchaseOrder') {
                newOrderModel.WTCodesR = partner?.WTCodesR || [];
                newOrderModel.WTCodesR = newOrderModel.WTCodesR?.filter(wtcode => (wtcode.WTCode || wtcode.WTName || '')?.includes('3%')) ?? [];
                newOrderModel.U_FMB_BP_Reten = newOrderModel?.WTCodesR?.length ? 'Y' : 'N';
                newOrderModel.U_STR_BC = partner.U_STR_BC || 'N';

                newOrderModel = await this.checkWithHolding(newOrderModel);
            }
            //#endregion RETENCIONES

            //#region PRECIOS ESPECIALES
            if (newOrderModel.Items.length > 0 && (view === 'orderSales')) {
                let CardCode = newOrderModel.CardCode;
                let DocDate = newOrderModel.DocDate;
                enableSpinner(true);
                let getItemResponse = await apiClient.getItemsPrice(CardCode, newOrderModel.Items, DocDate);
                enableSpinner(false);
                if (getItemResponse.status === 1) {
                    newOrderModel.Items = getItemResponse.data;
                }
            }
            //#endregion

            newOrderModel.Addresses = []; // Mandar a consultar direcciones

            //Calculo fecha de entrega 
            let today = moment(new Date()).format('YYYY-MM-DD');
            if (view === 'invoice' || view === 'orderSales' || view === 'debitNote' || view === 'invoiceReserve') {


                let grouNum = newOrderModel.GroupNum;
                let groupName = newOrderModel.GroupName;
                let extraDays = newOrderModel.ExtraDays;
                let typeInvoice = 0;
                // let userFieldTypeInvoice = newOrderModel.userFields.userFields3;
                // if(userFieldTypeInvoice === 'Contado' || (groupName === 'Pago Inmediato' && grouNum === 9)){
                //     typeInvoice = 3;
                // }else if(userFieldTypeInvoice === 'Credito'){
                //     typeInvoice = 14
                // }else if(userFieldTypeInvoice === 'Credito2'){
                //     if(extraDays > 28){
                //         typeInvoice = extraDays;
                //     }else{
                //         typeInvoice = 28;
                //     }
                // }else if (groupName != '' && extraDays != 0){
                //     typeInvoice = extraDays;
                // }
                if (typeInvoice == 0) {
                    typeInvoice = extraDays ? extraDays : Number(newOrderModel?.GroupNum) === -1 ? 0 : 3;
                }
                let docDueDate = new Date(today);
                docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
                let weekDays = 0;
                while (weekDays < typeInvoice) {
                    docDueDate.setDate(docDueDate.getDate() + 1);
                    // if(docDueDate.getDay() != 0){
                    weekDays++;
                    // }
                }
                newOrderModel.DocDueDate = moment(docDueDate).format('YYYY-MM-DD');
            }
            newOrderModel.U_FMB_END_DATE = newOrderModel.DocDueDate;

            const data = {
                GroupNum: newOrderModel.GroupNum,
                view,
                showAlert,
                model: newOrderModel,
                enableSpinner
            }
            await setDueDateFromPaymentConds(data)

            await this.refreshTotal(newOrderModel);
            await this.validateEnter(2);
            //#region SOLICITUD DE COMPRA
            if (view === 'PurchaseRequest') {
                newOrderModel.Items[newIndex.indexPurchaseRequest].LineVendor = partner.CardCode;
                newOrderModel.CardCode = '';
                await this.validateEnter(1);
                await this.refreshTotal(newOrderModel);
            }
            //#endregion
            //modal ya cerrado arriba, limpiar backdrop huérfano
            await this.restartTabs();
            setTimeout(() => {
                this.setState({ partners: [] });
                if ($('.modal-backdrop').length && !$('.modal.show').length) {
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                }
            }, 100);

            //#region Precio Llamagas
            // if (newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) { // Al cambiar de socio consultar precios
            if (newOrderModel?.isSalesDocument) { // Al cambiar de socio consultar precios
                setTimeout(() => {
                    this.checkItemPrices(false, true);
                }, 500);
            }
            //#endregion Precio Llamagas
        } catch {
            showAlert({ type: 'warning', message: 'Información de socio incompleta, no tiene direcciónes' });

            // modal ya cerrado arriba, limpiar backdrop huérfano en error
            this.restartTabs();
            setTimeout(() => {
                this.setState({ partners: [] });
                if ($('.modal-backdrop').length && !$('.modal.show').length) {
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                }
            }, 100);
        }
    };

    refreshPartner = async (partner, totalPage) => {
        this.setState({
            partners: partner,
            pageTotal: totalPage
        });
    }

    saveAgentCode = partner => {
        const { newOrderModel } = this.props;
        newOrderModel.AgentCode = partner.CardCode;
        newOrderModel.AgentName = partner.CardName;
        this.refreshTotal(newOrderModel);
        this.validateEnter(4);
        this.restartTabs();
        setTimeout(() => {
            this.setState({
                partners: [],
                flagAgentCode: false
            });
        }, 100);
    }

    validateEnter = (option) => {
        const { newOrderModel } = this.props;

        switch (option) {
            case 1:
                newOrderModel.partnerSelected = false;
                break;
            case 2:
                newOrderModel.partnerSelected = true;
                break;
            case 3:
                newOrderModel.AgentSelected = false;
                break;
            case 4:
                newOrderModel.AgentSelected = true;
                break;
            default:
                break;
        }
        this.refreshModel(newOrderModel);
    }

    validateWhsEnter = (option, index) => {
        let { newOrderModel } = this.props;


        if (option === 1) {
            newOrderModel.Items[index].whsSelected = false;

        }
        if (option === 2) {
            newOrderModel.Items[index].whsSelected = true;
        }
        this.refreshModel(newOrderModel);
    }

    clearSocio = (field = '') => {

        let { newOrderModel, view, enableSpinner, showAlert, isDraftOWTQ = false } = this.props;
        if (field !== 'AgentCode') {
            let today = moment(new Date()).format('YYYY-MM-DD');
            newOrderModel.CardCode = '';
            newOrderModel.CardName = '';
            //newOrderModel.DocCur =  '';
            newOrderModel.CntctCode = '';
            newOrderModel.CntctName = '';
            newOrderModel.GroupNum = '';
            newOrderModel.GroupName = '';
            newOrderModel.GroupCodeName = '';
            newOrderModel.PymCode = '';
            newOrderModel.PymName = '';
            newOrderModel.ExtraDays = 0;
            newOrderModel.Address = '';
            newOrderModel.deliveriesAddress = [];
            newOrderModel.invoicesAddress = [];
            newOrderModel.ShipToCode = '';
            newOrderModel.Address2 = '';
            if (!newOrderModel?.isPurchaseDocument) {
                newOrderModel.Project = '';
                newOrderModel.OwnerCode = '';
                newOrderModel.SlpCode = '';
                newOrderModel.SlpName = '';
            }
            newOrderModel.UBIGEO = '';
            newOrderModel.U_RMO_ID_DIRE = '';
            newOrderModel.CreditLine = '';
            newOrderModel.PriceListNum = '';
            newOrderModel.LicTradNum = '';
            //impuesto definido desde el usuario
            newOrderModel.TaxeDefaultPartner = '';
            newOrderModel.TaxeRateDefaultPartner = 0;
            newOrderModel.TaxNameDefaultPartner = '';
            newOrderModel.OcrCode2DefaultPartner = '';
            newOrderModel.AcctCodeDefaultPartner = '';
            newOrderModel.CogsAcctDefaultPartner = '';
            newOrderModel.AcctCodeNameDefaultPartner = '';
            newOrderModel.CogsAcctNameDefaultPartner = '';
            //PAGOS RECIBIDOS Y PAGOS EFECTUADOS
            //newOrderModel.ItemsPayments
            newOrderModel.TrsfrAcctFormatCode = '';
            newOrderModel.TrsfrRef = '';
            //#region Flujo de caja
            newOrderModel.transferCFWId = null;
            newOrderModel.needTransferCFW = false;
            newOrderModel.transferCFWOptions = [];
            newOrderModel.cashCFWId = null;
            newOrderModel.needCashCFW = false;
            newOrderModel.cashCFWOptions = [];
            newOrderModel.checkCFWId = null;
            newOrderModel.needCheckCFW = false;
            newOrderModel.checkCFWOptions = [];
            //#endregion Flujo de caja
            newOrderModel.TrsfrSum = '';
            newOrderModel.CheckAcctFormatCode = '';
            newOrderModel.CashAcctFormatCode = '';
            newOrderModel.CashSum = 0;
            newOrderModel.CounterRef = '';
            if (!newOrderModel?.isPurchaseDocument && !isDraftOWTQ) {
                newOrderModel.Comments = '';
                newOrderModel.JrnlMemo = '';
            }
            newOrderModel.ItemsPayments = [];
            newOrderModel.DocDueDate = today;
            newOrderModel.U_FMB_END_DATE = today;
            //#region Transportes de ORDR
            newOrderModel.CodigoAutotransporte = '';
            newOrderModel.CodigoUnidad = '';
            newOrderModel.PlacaVM = '';
            newOrderModel.TransportWhs = {};
            //#endregion Transportes de ORDR
            this.validateEnter(1);
        } else {
            newOrderModel.AgentCode = '';
            newOrderModel.AgentName = '';
            this.validateEnter(3);
        }

        this.refreshTotal(newOrderModel);
        this.restartTabs();
        setTimeout(() => {
            this.setState({
                partners: [],
            });
        }, 100);
    };

    openPersonRequest = async (search) => {
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;

        let serviceResponse = null;

        enableSpinner(true);
        if (newOrderModel.ReqType === '12') {
            serviceResponse = await apiClient.getUsersList(typeof search === 'number' ? search : null);
        } else {
            serviceResponse = await apiClient.getOwnersList();
        }
        enableSpinner(false);


        if (!Array.isArray(serviceResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (serviceResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        if (newOrderModel.ReqType === '12') {
            this.setState({
                users: serviceResponse.data,
                openPersonRequest: true
            })
            if (typeof search === 'number') {
                if (this.state.users.length > 0) {
                    this.selectUser({ index: 0 })
                }
            } else {
                $('#usersModal').modal('show');
            }
        } else {
            this.setState({
                owners: serviceResponse?.data ?? [],
                openPersonRequest: true,
                showPropietarioCreateModal: true,
            }, () => {
                $('#propietarioDocumentsModal').modal('show');
            });
        }
    };

    selectUser = async action => {
        const { users } = this.state;
        let { newOrderModel } = this.props;
        let user = users[action.index];

        newOrderModel.Requester = user.USER_CODE || '';
        newOrderModel.ReqName = user.U_NAME || '';
        newOrderModel.Email = user.E_Mail || '';
        newOrderModel.Branch = user.Branch || '';
        newOrderModel.BranchName = user.BranchName || '';
        newOrderModel.Department = user.Department || '';
        newOrderModel.DepartmentName = user.DepartmentName || '';
        newOrderModel.CostCenter = '';

        /*

         newOrderModel.CardCode = partner.CardCode;
         newOrderModel.CardName = partner.CardName;
         //newOrderModel.DocCur = partner.Currency || '';
         newOrderModel.SlpCode = partner.SlpCode || '';
         newOrderModel.SlpName = partner.SlpName || '';
         newOrderModel.CntctCode = partner.CodigoContacto || '';
         newOrderModel.CntctName = partner.Contacto || '';
         newOrderModel.OwnerCode = partner.OwnerCode || '';
         newOrderModel.GroupNum = partner.GroupNum || '';
         newOrderModel.GroupName = partner.PymntGroup || '';
         newOrderModel.PymCode = partner.PymCode || '';
         newOrderModel.PymName = partner.Descript || '';
         newOrderModel.Address = partner.Address || '';
         newOrderModel.deliveriesAddress = [];
         newOrderModel.invoicesAddress = [];
         newOrderModel.ShipToCode = '';
         newOrderModel.Address2 = '';
         //impuesto definido desde el usuario
         newOrderModel.TaxeDefaultPartner = partner.TaxCode || '';
         newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 0;
         newOrderModel.OcrCode2DefaultPartner = partner.OcrCode2 || '';
         newOrderModel.AcctCodeDefaultPartner = partner.AcctCodeItem || '';
         newOrderModel.CogsAcctDefaultPartner = partner.CogsAcctItem || '';
         newOrderModel.AcctCodeNameDefaultPartner = partner.AcctCodeItemName || '';
         newOrderModel.CogsAcctNameDefaultPartner = partner.CogsAcctItemName || '';

         //pagos
         newOrderModel.BpAct = partner.AcctCode || '';
         newOrderModel.BpActName = partner.AcctName || '';
         newOrderModel.BpActFormatCode = partner.FormatCode || '';
         newOrderModel.BpActCopy = partner.AcctCode || '';
         newOrderModel.BpActNameCopy = partner.AcctName || '';
         newOrderModel.BpActFormatCodeCopy = partner.FormatCode || '';

        

         newOrderModel = await this.updateItemsWhenPartnerChange(newOrderModel);

        */
        this.refreshTotal(newOrderModel);
        $('#usersModal').modal('hide');

        setTimeout(() => {
            this.setState({ users: [], openPersonRequest: false });
        }, 100);
    };

    openSeries = async () => {
        const { newOrderModel, showAlert } = this.props;
        if (newOrderModel.SerieArray.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        setTimeout(() => {
            this.setState({
                series: newOrderModel.SerieArray,
            });
            $('#seriesDocumentsModal').modal('show');
        }, 100);
    };

    selectSeries = action => {
        const { partners } = this.state;
        const { newOrderModel, view } = this.props;
        let serie = newOrderModel.SerieArray[action.index];
        newOrderModel.SerieName = serie.SeriesName || '';
        newOrderModel.SerieCode = serie.Series || '';
        newOrderModel.NextFolio = serie.NextNumber || '';


        this.refreshModel(newOrderModel);
        $('#seriesDocumentsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                series: [],
            });
        }, 100);
    };

    openSeries2 = async () => {
        const { newOrderModel, showAlert } = this.props;
        if (newOrderModel.SerieArray2.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        setTimeout(() => {
            this.setState({
                series2: newOrderModel.SerieArray2,
            });
            $('#seriesDocumentsModale').modal('show');
        }, 100);
    };

    selectSeries2 = action => {
        const { newOrderModel } = this.props;
        let serie = newOrderModel.SerieArray2[action.index];
        newOrderModel.SerieName2 = serie.SeriesName;
        newOrderModel.SerieCode2 = serie.Series;
        newOrderModel.NextFolio2 = serie.NextNumber;

        this.refreshModel(newOrderModel);
        $('#seriesDocumentsModale').modal('hide');
        setTimeout(() => {
            this.setState({
                series2: [],
            });
        }, 100);
    };

    openSeriesPago = async () => {
        const { newOrderModel, showAlert } = this.props;
        if (newOrderModel.SerieArray3.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        setTimeout(() => {
            this.setState({
                series3: newOrderModel.SerieArray3,
            });
            $('#seriesPayment').modal('show');
        }, 100);
    };

    selectSeries3 = action => {
        const { newOrderModel } = this.props;
        let series = newOrderModel.SerieArray3[action.index];
        newOrderModel.SerieName3 = series.SeriesName;
        newOrderModel.SerieCode3 = series.Series;
        newOrderModel.NextFolio3 = series.NextNumber;

        this.refreshModel(newOrderModel);
        $('#seriesPayment').modal('hide');
        setTimeout(() => {
            this.setState({
                series3: [],
            });
        }, 100);
    };

    selectDocDate = async (event) => {
        const { newOrderModel, showAlert, view, enableSpinner } = this.props;
        let today = moment(new Date()).format('YYYY-MM-DD');
        if (event.nativeEvent.target.value > today) {
            showAlert({
                type: 'error',
                message: 'La fecha de contabilización tiene que ser igual o menor al día actual',
            });
            return;
        }
        newOrderModel.DocDate = event.nativeEvent.target.value;
        newOrderModel.TaxDate = event.nativeEvent.target.value;

        // if (newOrderModel.Items.length > 0 && (view === 'invoice' || view === 'orderSales' || view === 'debitNote' || view === "invoiceReserve")) {
        //     let CardCode = newOrderModel.CardCode;
        //     let DocDate = newOrderModel.DocDate;
        //     enableSpinner(true);
        //     let getItemResponse = await apiClient.getItemsPrice(CardCode, newOrderModel.Items, DocDate);
        //     enableSpinner(false);
        //     if (getItemResponse.status === 1) {
        //         newOrderModel.Items = getItemResponse.data;
        //     }
        //     this.refreshTotal(newOrderModel);
        // } else {
        //     this.refreshModel(newOrderModel);
        // }
        this.refreshModel(newOrderModel);
    };

    onBlurDate = async (event) => {
        const { newOrderModel, view, enableSpinner } = this.props;
        let isSucccessSpecialPrice = false;
        if (newOrderModel.Items?.length > 0 && (view === 'invoice' || view === 'orderSales' || view === 'debitNote' || view === "invoiceReserve")) {
            let CardCode = newOrderModel.CardCode;
            let DocDate = newOrderModel.DocDate;
            enableSpinner(true);
            let getItemResponse = await apiClient.getItemsPrice(CardCode, newOrderModel.Items, DocDate);
            enableSpinner(false);
            if (getItemResponse.status === 1) {
                isSucccessSpecialPrice = true;
                newOrderModel.Items = getItemResponse.data;
            }
        }
        if (newOrderModel?.isSalesDocument) { // Al cambiar la fecha de contabilización o la fecha de entrega consultar precios
            //#region Precio Llamagas
            setTimeout(() => {
                let auxNewOrderModel = isSucccessSpecialPrice ? newOrderModel : {};
                this.checkItemPrices(false, false, false, false, '', false, '', true, newOrderModel.DocDueDate, newOrderModel.TaxDate, auxNewOrderModel);
            }, 500);
            //#endregion Precio Llamagas
        }
    }

    selectTaxDate = event => {
        const { newOrderModel } = this.props;
        newOrderModel.TaxDate = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    selectTrsfrDate = event => {
        const { newOrderModel } = this.props;
        newOrderModel.TrsfrDate = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    selectDocDueDate = event => {
        const { newOrderModel, view } = this.props;
        if (disableDocDueDate(view)) return
        newOrderModel.DocDueDate = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    selectDueDate = (event) => {
        const { newOrderModel } = this.props;
        newOrderModel.U_FMB_END_DATE = event.target.value;
        this.refreshModel(newOrderModel);
    };

    selectReqDate = event => {
        const { newOrderModel } = this.props;
        newOrderModel.ReqDate = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    validateReqDate = () => {
        const { newOrderModel, showAlert } = this.props;

        if (!newOrderModel?.ReqDate) return;

        const today = new Date().toISOString().split('T')[0];

        if (newOrderModel.ReqDate < today) {
            newOrderModel.ReqDate = today;
            this.refreshModel(newOrderModel);
            showAlert({ type: 'warning', message: 'La F. Necesaria no puede ser menor al día actual' });
        }
    };

    changeScopCode = async (event) => {
        const { newOrderModel } = this.props;
        const copyNewModel = { ...newOrderModel, U_FMB_SCOP_CODE: event.nativeEvent.target.value }
        await this.refreshModel(copyNewModel);
        this.props.scoopTools.cleanScoopFields()
    };

    openPersonContact = async () => {
        const { showAlert, newOrderModel, enableSpinner } = this.props;
        if (!this.validatePartner()) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        enableSpinner(true);
        let getContactsResponse = await apiClient.getContactsList(newOrderModel.CardCode);
        enableSpinner(false);

        if (!Array.isArray(getContactsResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getContactsResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            contacts: getContactsResponse.data,
        });
        $('#personContactModal').modal('show');
    };

    selectContact = action => {
        const { contacts } = this.state;
        const { newOrderModel } = this.props;
        let contact = contacts[action.index];

        newOrderModel.CntctCode = contact.CntctCode || '';
        newOrderModel.CntctName = contact.CntctName || '';

        this.refreshModel(newOrderModel);
        $('#personContactModal').modal('hide');
        setTimeout(() => {
            this.setState({
                contacts: [],
            });
        }, 100);
    };

    openMonedaLocal = async () => {
        $('#monedaDocumentsModal').modal('show');
    };

    openAlmacen = async (index, warehouse, itemCode = null) => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;
        //#region ########## BATCH ####################################

        if (newOrderModel.DocType === "I") {
            if (view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (itemsBatch.length > 0) {
                    let isConfigured = false;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        if (item.BatchNumbers && item.BatchNumbers.length > 0) {
                            isConfigured = true;
                        }
                    }
                    if (isConfigured) {
                        $('#validationBatchsModal').modal('show');
                    } else {
                        await this.SearchAlmacen(index, warehouse, itemCode);
                    }
                } else {
                    await this.SearchAlmacen(index, warehouse, itemCode);
                }
            } else if (view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote') {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (itemsBatch.length > 0) {
                    let isConfigured = false;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        if (item.BatchNumbers && item.BatchNumbers.length > 0) {
                            isConfigured = true;
                        }
                    }
                    if (isConfigured) {
                        let searchWhs = {
                            index,
                            warehouse,
                            itemCode
                        }

                        await this.setState({
                            SearchWhs: searchWhs,
                        });
                        $('#validationBatchsModal').modal('show');
                    } else {
                        await this.SearchAlmacen(index, warehouse, itemCode);
                    }
                } else {
                    await this.SearchAlmacen(index, warehouse, itemCode);
                }
            } else {
                await this.SearchAlmacen(index, warehouse, itemCode);
            }
        } else {
            await this.SearchAlmacen(index, warehouse, itemCode);
        }

        //#emdRegion
    };

    ChangeEnableTransfersList = async () => {
        await this.setState({
            enableTransfersList: !this.state.enableTransfersList
        })
    }

    OpenTransfers = async () => {
        const { showAlert, enableSpinner } = this.props
        const { _user } = this.state

        if (!this.state.enableTransfersList) {
            await this.ChangeEnableTransfersList();
        }

        const data = {
            DocEntry: _user?.Branch?.CodeBranchOffice ?? '',
            action: 'getTransfersByCardCode'
        }

        enableSpinner(true);
        const transfersList = await apiClient.getInvoicesPorte(data);
        enableSpinner(false);

        if (!Array.isArray(transfersList.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (transfersList.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            transfersListCEDIS: transfersList.data,
        });

        $('#partnerList').modal('show');

    }

    selectItemsToArray = async () => {
        const { newOrderModel, enableSpinner, showAlert } = this.props
        const { checkboxArray, transfersListCEDIS } = this.state;

        for (let [id, value] of checkboxArray.entries()) {
            if (value) {
                newOrderModel.DocNumCEDIS = transfersListCEDIS[id].DocNum;
                newOrderModel.DocEntryCEDIS = transfersListCEDIS[id].DocEntry;
                newOrderModel.CEDIS_Reception = true;
                newOrderModel.Items = [];
                this.refreshModel(newOrderModel);

                const data = {
                    DocEntry: transfersListCEDIS[id].DocEntry ?? '',
                    action: 'getLinesRecoverStockTransfer'
                }

                enableSpinner(true);
                const transfersList = await apiClient.getInvoicesPorte(data);
                enableSpinner(false);

                if (!Array.isArray(transfersList.data)) {
                    showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                    return;
                }

                if (transfersList.data.length === 0) {
                    showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                    return;
                }

                $('#partnerList').modal('hide');
                await this.setState({
                    enableTransfersList: false
                })

                showAlert({ type: 'info', message: 'Espera un momento, estamos cargando tu informacion, te notificare cuando puedas continuar', timeOut: 5000 });
                for (const element of transfersList.data) {
                    enableSpinner(true);
                    await this.openItems(element.ItemCode);
                    enableSpinner(false);
                }
                enableSpinner(true);
                setTimeout(async () => {
                    // enableSpinner(true);
                    let cont = 0;
                    for (const element of transfersList.data) {
                        await this.changeQuantityItem(null, cont, element.Quantity)
                        cont++;
                    }
                    enableSpinner(false);
                    showAlert({ type: 'success', message: 'Listo, gracias por la espera, continua el proceso por favor', timeOut: 3000 });
                }, 2000);
            }
        }
    };

    SearchAlmacen = async (index, warehouse, itemCode = null, isORDRTransport = false) => {
        const { showAlert, enableSpinner, view, newOrderModel, isDraftOWTQ = false } = this.props;

        if (view !== 'transfersRequest' && view !== 'transfers' && view !== 'reportSelectionCriteria' && !isDraftOWTQ) {
            this.validateWhsEnter(1, index);
        }

        if (!this.validatePartner() && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'PurchaseRequest' && view !== 'reportSelectionCriteria') {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        let data = null;

        if (view === 'transfersOutput' || view === 'ExitHelmets') {
            data = {
                TransferType: 'O',
                ItemCode: itemCode,
            }
        } else if ((view === 'transfersRequest' || view === 'transfers' || view === 'reportSelectionCriteria' || isDraftOWTQ) && !itemCode) {
            data = {
                TransferType: null,
                ItemCode: null
            }
        } else {
            data = {
                TransferType: 'I',
                ItemCode: itemCode
            }
        }

        let almacen = {};

        let whCode = newOrderModel.Items[index] ? newOrderModel.Items[index].WhsCode !== "" ? newOrderModel.Items[index].WhsCode : '' : '';

        if (warehouse === 2) {
            almacen = {
                item: itemCode,
                whsCode: newOrderModel.Filler || '',
            }
            data.whsCode = newOrderModel.Filler || '';
        } else if (warehouse === 3) {
            almacen = {
                item: itemCode,
                whsCode: newOrderModel.ToWhsCode || '',
            }
            data.whsCode = newOrderModel.ToWhsCode || '';
        } else if (warehouse === 3) {
            almacen = {
                item: itemCode,
                whsCode: newOrderModel.ToWhsCode || '',
            }
            data.whsCode = newOrderModel.ToWhsCode || '';
        } else {
            almacen = {
                item: itemCode,
                whsCode: whCode || '',
                U_FMB_AttentionType: '',
            }
            data.whsCode = whCode || '';
            data.U_FMB_AttentionType = '';
            if (newOrderModel?.isSalesDocument && newOrderModel?.DocType === 'I' && !isORDRTransport) {
                let U_FMB_AttentionType = newOrderModel?.userFields?.userFields28 || '';
                if (U_FMB_AttentionType === 'RUT' || U_FMB_AttentionType === 'RCF' || U_FMB_AttentionType === 'ABS' || U_FMB_AttentionType === 'DST') {
                    // Listado de almacenes basado en:
                    // TIPO DE ATENCION     PLANTA          ZONAL          MAESTRA
                    // Autoabastecimiento   008 || 001     001            008 || 001
                    // Distribuidor         008             001            008 || 001
                    // Ruta CF              009             009            009
                    // RUTA                 009 || 099      NO APLICA      009 || 099

                    let user = await JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
                    let U_FMB_WHS_TYPE = user?.Branch?.Type || ''; // Saber si es planta o zonal
                    if (!U_FMB_WHS_TYPE) {
                        showAlert({ type: 'error', message: 'No se ha identificado el tipo de sede', timeOut: 5000 });
                        return;
                    }
                    const noAplica = U_FMB_AttentionType === 'RUT' && Number(U_FMB_WHS_TYPE) === 1; // RUT - Zonal
                    let whsType = [];

                    if (U_FMB_AttentionType === 'ABS' || U_FMB_AttentionType === 'DST') { // Autoabastecimiento / Distribuidor
                        whsType = Number(U_FMB_WHS_TYPE) === 2 ? ['008', '001'] : // Planta
                            Number(U_FMB_WHS_TYPE) === 1 ? ['001'] : // Zonal
                                Number(U_FMB_WHS_TYPE) === 3 ? ['008', '001'] : // Maestra
                                    [];
                    } else if (U_FMB_AttentionType === 'RUT') { // Ruta
                        whsType = Number(U_FMB_WHS_TYPE) === 2 || Number(U_FMB_WHS_TYPE) === 3 ? ['009', '099'] : // Planta
                            [];
                    } else { // Ruta CF
                        whsType = ['009'];
                    }
                    data.U_FMB_AttentionType = noAplica ? [] : whsType;
                    almacen.U_FMB_AttentionType = noAplica ? [] : whsType;
                }
            }
        }

        let isTransfer = (view === "transfers" && !newOrderModel?.newView) || (newOrderModel?.newView === "transfers");
        if (isTransfer) {
            data = {
                TransferType: null,
                ItemCode: null,
                whsCode: "",
                view: 'transfers',
                TransitType: newOrderModel?.TransitType,
                warehouse,
                Transit: newOrderModel?.Transit,
            }
        }

        let getAlmacenResponse = null;
        enableSpinner(true);
        getAlmacenResponse = await apiClient.getWarehouse(almacen);

        if (getAlmacenResponse.data.length === 0 || (getAlmacenResponse.data.length && whCode)) {
            if (getAlmacenResponse.data.length && whCode) {
                data.whsCode = '';
            }
            // SOLO CUANDO SEA TRASPASO DIRECTO LIMPIAMOS whsCode PARA QUE TRAIGA TODOS LOS ALMACENES DE RelatedWhs
            if (!newOrderModel.Transit || newOrderModel.Transit === "") {
                data.whsCode = '';
            }
            getAlmacenResponse = await apiClient.getWarehouseList(data);
            enableSpinner(false);

            if (!Array.isArray(getAlmacenResponse.data)) {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                return;
            }

            if (getAlmacenResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'El Artículo no existe en los almacenes configurados para la sucursal actual' });
                //#region Transportes de ORDR
                if (isORDRTransport) {
                    this.selectAlmacenEnter(newOrderModel?.TransportWhs ?? {}, index);
                }
                //#endregion Transportes de ORDR
                return;
            }

            //#region Transportes de ORDR
            if (getAlmacenResponse?.data?.length && isORDRTransport) {
                getAlmacenResponse.data = getAlmacenResponse.data?.filter(whs => whs.WhsCode === newOrderModel?.TransportWhs?.WhsCode);
            }
            //#endregion Transportes de ORDR
            if (getAlmacenResponse.data.length === 1 || isORDRTransport) {
                this.setState({
                    warehouses: getAlmacenResponse.data,
                    itemOrderModelUpdate: index,
                    warehouseUpdate: warehouse,
                });


                this.selectAlmacenEnter(getAlmacenResponse.data[0], isORDRTransport ? index : null);
            } else {
                this.setState({
                    warehouses: getAlmacenResponse.data,
                    itemOrderModelUpdate: index,
                    warehouseUpdate: warehouse,
                    itemSelected: itemCode
                });
                $('#almacenDocumentsModal').modal('show');
            }


        } else {
            this.setState({
                warehouses: getAlmacenResponse.data,
                itemOrderModelUpdate: index,
                warehouseUpdate: warehouse,
                itemSelected: itemCode
            });
            enableSpinner(false);
            this.selectAlmacenEnter(getAlmacenResponse.data[0]);
        }
    }

    selectAlmacen = async action => {
        const { warehouses, itemOrderModelUpdate, warehouseUpdate, _user } = this.state;
        const { newOrderModel, showAlert, view, enableSpinner, selectTable, isDraftOWTQ = false } = this.props;
        let warehouse = warehouses[action.index];
        const locationView = ['GoodsReceipt', 'deliveries', 'transfersEntry', 'transfersOutput'];
        const isLocationView = locationView?.includes(view ?? '');
        let checkPrice = false;
        const isTransfer = (view === "transfers" && !newOrderModel?.newView) || (newOrderModel?.newView === "transfers");
        let isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;

        if (warehouseUpdate === 1) {
            if (_user?.FMB_Role === 'counter1') {
                showAlert({ type: 'warning', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
                return;
            }
            newOrderModel.Items[itemOrderModelUpdate].WhsCode = warehouse.WhsCode || '';
            newOrderModel.Items[itemOrderModelUpdate].WhsName = warehouse.WhsName || '';
            newOrderModel.Items[itemOrderModelUpdate].OnHand = warehouse.OnHand || 0;
            newOrderModel.Items[itemOrderModelUpdate].AvgPrice = warehouse.AvgPrice || 0;
            newOrderModel.Items[itemOrderModelUpdate].AcctCode = warehouse.AcctCode || '';
            newOrderModel.Items[itemOrderModelUpdate].AcctCode2 = warehouse.AcctCode2 || '';
            newOrderModel.Items[itemOrderModelUpdate].AcctCodeName = warehouse.AcctName || '';
            newOrderModel.Items[itemOrderModelUpdate].FormatCode = warehouse.FormatCode || '';
            newOrderModel.Items[itemOrderModelUpdate].FormatCode2 = warehouse.FormatCode2 || '';
            if (newOrderModel.U_TipoSalida !== '' && !newOrderModel?.InventoryAccount?.AcctCode) {
                let data = {
                    Type: newOrderModel.U_TipoSalida,
                    WhsCode: newOrderModel.Items[itemOrderModelUpdate].WhsCode,
                }

                let responseGetAcctCode = await apiClient.getAcctCodeType_I_O(data);
                if (responseGetAcctCode.status === 1) {
                    if (responseGetAcctCode.data[0].AcctCode !== '') {
                        const cuentaOriginal = responseGetAcctCode.data[0].AcctCode;
                        const expresionRegular = /^(\d{7})(\d{2})(\d{2})$/;
                        const resultado = cuentaOriginal.replace(expresionRegular, "$1-$2-$3");
                        newOrderModel.Items[itemOrderModelUpdate].FormatCode = resultado;
                        newOrderModel.Items[itemOrderModelUpdate].AcctCode = cuentaOriginal;
                    }
                }
            }

            //#region Cuenta de mayor para OIGN y OIGE
            if (newOrderModel?.InventoryAccount?.AcctCode) {
                newOrderModel.Items[itemOrderModelUpdate].AcctCode = newOrderModel?.InventoryAccount?.AcctCode || '';
                newOrderModel.Items[itemOrderModelUpdate].AcctCodeName = newOrderModel?.InventoryAccount?.AcctName || '';
                newOrderModel.Items[itemOrderModelUpdate].CurrTotal = newOrderModel?.InventoryAccount?.CurrTotal || 0;
                newOrderModel.Items[itemOrderModelUpdate].FormatCode = newOrderModel?.InventoryAccount?.FormatCode || '';
                newOrderModel.Items[itemOrderModelUpdate].AcctCode2 = '';
                newOrderModel.Items[itemOrderModelUpdate].FormatCode2 = '';
            }
            //#endregion Cuenta de mayor para OIGN y OIGE

            if (view === 'inventoryPosting') {
                newOrderModel.Items[itemOrderModelUpdate].OnHandBef = warehouse.BinActivat === 'Y' ? '' : parseFloat(warehouse.OnHand || 0).toFixed(2);
                newOrderModel.Items[itemOrderModelUpdate].BinActivat = warehouse.BinActivat || 'N';
                newOrderModel.Items[itemOrderModelUpdate].AbsEntry = '';
                newOrderModel.Items[itemOrderModelUpdate].BinCode = '';
            }
            if (isLocationView) {
                newOrderModel.Items[itemOrderModelUpdate].BinActivat = warehouse.BinActivat || 'N';
                newOrderModel.Items[itemOrderModelUpdate].DocumentLinesBinAllocations = [];
            }
            newOrderModel.CashAcct = warehouse.CashAccount || '';
            newOrderModel.BpAct = warehouse.ControlAccount || '';
            // Precio x Kilo - ESTO SOLO ERA PARA SERDI
            // let PriceKilo = await apiClient.getPriceKilo(newOrderModel.Items[itemOrderModelUpdate].ItemCode, warehouse.WhsCode);
            // newOrderModel.Items[itemOrderModelUpdate].PrecioKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            // newOrderModel.Items[itemOrderModelUpdate].UserFieldsItem.userFields8 = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
            // Precio x Kilo
            newOrderModel.Items[itemOrderModelUpdate].wareHouseStock.map(async (warehouseStock) => {

                if (newOrderModel.Items[itemOrderModelUpdate].InvntItem === 'N') {
                    return;
                }

                if (warehouseStock.WhsCode === warehouse.WhsCode) {
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? newOrderModel.Items[itemOrderModelUpdate].SalPackUn : newOrderModel.Items[itemOrderModelUpdate].PurPackUn;
                    if (warehouseStock.OnHand <= 0
                        && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'creditNote' && view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'return' && view !== 'PurchaseRequest') {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + newOrderModel.Items[itemOrderModelUpdate].ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                            timeOut: 5000
                        });
                        newOrderModel.Items[itemOrderModelUpdate].stock = false;

                    } else if ((newOrderModel.Items[itemOrderModelUpdate].UserBaseUn == 'Y' && newOrderModel.Items[itemOrderModelUpdate].Quantity > warehouseStock.OnHand) ||
                        (newOrderModel.Items[itemOrderModelUpdate].UserBaseUn == 'N' && (newOrderModel.Items[itemOrderModelUpdate].Quantity * measureUnit) > warehouseStock.OnHand)
                        && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'creditNote' && view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'return' && view !== 'PurchaseRequest') {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + newOrderModel.Items[itemOrderModelUpdate].ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                            timeOut: 5000
                        });
                        newOrderModel.Items[itemOrderModelUpdate].stock = false;
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].stock = true;
                    }
                    if ((view === 'deliveries' || newOrderModel?.newView === 'deliveries' || view === 'transfersOutput' || newOrderModel?.newView === 'transfersOutput') && warehouse.BinActivat === 'Y') {
                        newOrderModel.Items[itemOrderModelUpdate].DocumentLinesBinAllocations = warehouseStock?.Location ?? [];
                    }
                }
                if (newOrderModel.OriginDocumentCreate === "returnRequest" || newOrderModel.OriginDocumentCreate === "return" || newOrderModel.OriginDocumentCreate === "creditNote") {
                    if (warehouse.BinActivat === 'Y') {
                        const binsResult = await apiClient.getPriceKilo(newOrderModel.Items[itemOrderModelUpdate].WhsCode, newOrderModel.ToWhsCode);
                        newOrderModel.Items[itemOrderModelUpdate].ToLocationAssignment = binsResult.data.results ? binsResult.data.results : [];
                    } else { newOrderModel.Items[itemOrderModelUpdate].ToLocationAssignment = []; }
                }
            })

            //#region Precio Llamagas
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
            if ((newOrderModel?.isSalesDocument)) {
                const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = newOrderModel?.Items?.[itemOrderModelUpdate] ?? {}
                const envasado = Envasados?.includes(Number(ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                let searchItem = ItemCode;

                if (!isTemporary && searchItem && (envasado || glpGranel)) {
                    let getItemResponse = null;
                    const newView = newOrderModel?.newView || view;
                    let table = selectTable(newView);
                    let data = {
                        CardCode: newOrderModel?.CardCode || "",
                        ItemCode: searchItem || "",
                        WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : WhsCode,
                        ShipToCode: newOrderModel?.ShipToCode || "",
                        userFields: newOrderModel?.userFields || {},
                        Quantity,
                        U_RS_CANTG,
                        U_RS_UMED,
                        U_RS_PRECIOGL,
                        gallonsPrice: true,
                        DocDueDate: newOrderModel?.DocDueDate,
                        TaxDate: newOrderModel?.TaxDate,
                        ObjType: table?.docType,
                    };

                    //#region GALLON PRICE
                    enableSpinner(true);
                    let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);
                    const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                    data.U_RS_PRECIOGL = U_RS_PRECIO;
                    data.gallonsPrice = false;
                    //#endregion GALLON PRICE

                    enableSpinner(true);
                    getItemResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);

                    const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                    const item = newOrderModel?.Items?.[itemOrderModelUpdate] || {};
                    item.Price = U_RS_CALCULADO;
                    checkPrice = true;

                    if (glpGranel) {
                        newOrderModel.Items[itemOrderModelUpdate].U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                        newOrderModel.Items[itemOrderModelUpdate].U_RS_TOTALGL = Number((Number(newOrderModel.Items[itemOrderModelUpdate]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[itemOrderModelUpdate]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                    }

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newOrderModel.Items[itemOrderModelUpdate].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newOrderModel.Items[itemOrderModelUpdate].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newOrderModel.Items[itemOrderModelUpdate].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newOrderModel.Items[itemOrderModelUpdate].newHomePrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].newPrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].cHomePrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].cPrice = item.Price || 0;
                    if (getItemResponse?.status === 1) {
                        showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar de almacén.', timeOut: 5000 });
                    } else {
                        showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar de almacén.', timeOut: 5000 });
                    }
                }
            }
            //#endregion Precio Llamagas

            //#region Precio Historico Llamagas
            if (Sections['HistoricalPrices'] && isOPRQ) { // Solo aplica para solicitud de compra
                if (!newOrderModel.Items[itemOrderModelUpdate]?.isTemporary) {
                    let getItemResponse = null;
                    let ItemCode = newOrderModel.Items[itemOrderModelUpdate]?.ItemCode;
                    const localCurrency = CURRENCY;
                    const Currency = newOrderModel.Items[itemOrderModelUpdate]?.Currency || localCurrency;
                    const WhsCode = newOrderModel.Items[itemOrderModelUpdate]?.WhsCode || '';
                    let data = {
                        ItemCode,
                        WhsCode,
                        Currency
                    };

                    enableSpinner(true);
                    if (ItemCode) {
                        getItemResponse = await apiClient.getHistoricalPriceListLlama(data);
                    }
                    enableSpinner(false);

                    const historicalPrice = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.historicalPrice || 0) : 0;
                    const item = newOrderModel.Items[itemOrderModelUpdate] || {};
                    item.Price = historicalPrice;
                    item.hasHistoricalPrice = Number(historicalPrice) > 0;
                    checkPrice = true;

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newOrderModel.Items[itemOrderModelUpdate].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newOrderModel.Items[itemOrderModelUpdate].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newOrderModel.Items[itemOrderModelUpdate].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newOrderModel.Items[itemOrderModelUpdate].newHomePrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].newPrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].cHomePrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].cPrice = item.Price || 0;
                }
            }
            //#endregion Precio Historico Llamagas

            //#region GALLONS CONVERSION
            if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && Granel?.includes(Number(newOrderModel?.Items?.[itemOrderModelUpdate]?.ItmsGrpCod))) {
                newOrderModel.Items[itemOrderModelUpdate].U_RS_DENS = Number(warehouse?.U_FMB_Factor_Conversion || 0);
            }
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && newOrderModel?.Items?.[itemOrderModelUpdate]?.Gallons &&
            if ((newOrderModel?.isSalesDocument) && newOrderModel?.Items?.[itemOrderModelUpdate]?.Gallons &&
                Number(newOrderModel?.Items?.[itemOrderModelUpdate]?.U_RS_CANTG) > 0 &&
                newOrderModel?.Items?.[itemOrderModelUpdate]?.U_RS_UMED === 'GLN' &&
                // (view === 'quotations' || view === 'orderSales' || view === 'draft' || newOrderModel?.isTransferDocument)
                (view === 'quotations' || view === 'orderSales' || view === 'draft')
            ) {
                // Al cambiar de almacén volver a consultar la conversion a galones
                newOrderModel.Items[itemOrderModelUpdate] = await this.checkGallons(newOrderModel.Items[itemOrderModelUpdate], itemOrderModelUpdate, newOrderModel);
                checkPrice = true;
            }
            //#endregion GALLONS CONVERSION

            //#region DIMENSIONS
            // Al cambiar de almacén ajustar los códigos OcrCode2 y OcrCode3
            const isTransfersEntry = view === "transfersEntry" || newOrderModel?.newView === "transfersEntry";
            const isTransfersOutput = view === "transfersOutput" || newOrderModel?.newView === "transfersOutput";
            if (newOrderModel.DocType === 'I' && (newOrderModel.isSalesDocument || newOrderModel.isPurchaseDocument || isTransfersEntry || isTransfersOutput)) {
                newOrderModel.Items[itemOrderModelUpdate].OcrCode2 = warehouse?.U_LLG_DIME2 || '';
                newOrderModel.Items[itemOrderModelUpdate].OcrCode3 = warehouse?.U_LLG_DIME3 || '';

                newOrderModel.Items[itemOrderModelUpdate].Dimension2 = newOrderModel.Items[itemOrderModelUpdate].OcrCode2 ? true : false;
                newOrderModel.Items[itemOrderModelUpdate].Dimension3 = newOrderModel.Items[itemOrderModelUpdate].OcrCode3 ? true : false;
                showAlert({ type: 'warning', message: `El valor de "SEDES" y el valor de "SUCURSAL" del artículo ${newOrderModel.Items[itemOrderModelUpdate].ItemCode || newOrderModel.Items[itemOrderModelUpdate].ItemName} ha sido ajustado al cambiar de almacén`, timeOut: 5000 });
            }
            //#endregion DIMENSIONS
        }
        //ALMACEN ORIGEN
        if (warehouseUpdate === 2) {
            const U_FMB_Factor_Conversion = Number(warehouse?.U_FMB_Factor_Conversion || 0);
            if (itemOrderModelUpdate === null) {
                newOrderModel.Filler = warehouse.WhsCode || '';
                newOrderModel.FillerName = warehouse.WhsName || '';
            } else {
                newOrderModel.Items[itemOrderModelUpdate].Filler = warehouse.WhsCode || '';
                newOrderModel.Items[itemOrderModelUpdate].FillerName = warehouse.WhsName || '';
            }

            //#region DIMENSIONS
            if (newOrderModel?.isTransferDocument && newOrderModel.DocType === 'I' && newOrderModel?.Items?.length) { // Al cambiar de almacén ajustar los códigos OcrCode2 y OcrCode3
                const isTransfersRequest = view === "transfersRequest" || newOrderModel?.newView === "transfersRequest";
                enableSpinner(true);
                const data = {
                    Type: 2,
                    filter1: warehouse?.WhsCode || '',
                };
                const apiResponse = await apiClient.getDimensions(data);
                enableSpinner(false);

                for (let item of newOrderModel?.Items) {
                    item.OcrCode2 = apiResponse?.data?.Dimension2 || ''; // Determinado desde el almacén
                    item.OcrName2 = isTransfersRequest ? (apiResponse?.data?.Dimension2Name || '') : '';
                    item.OcrCode3 = apiResponse?.data?.Dimension3 || ''; // Determinado desde el almacén
                    item.OcrName3 = isTransfersRequest ? (apiResponse?.data?.Dimension3Name || '') : '';

                    item.Dimension2 = item.OcrCode2 ? true : false;
                    item.Dimension3 = item.OcrCode3 ? true : false;
                }
                showAlert({ type: 'warning', message: `El valor de "SEDES" y el valor de "SUCURSAL" de los artículo ha sido ajustado al cambiar de almacén`, timeOut: 8000 });
            }
            //#endregion DIMENSIONS

            newOrderModel.Items.map(item => {
                item.wareHouseStock.map(warehouse => {
                    if (warehouse.WhsCode === newOrderModel.Filler && !isTransfer) {
                        item.FromLocationAssignment = warehouse.Location || [];
                        if (warehouse.OnHand <= 0 && !this.docsWithoutStock(newOrderModel.OriginDocumentCreate)) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                timeOut: 5000
                            });
                            item.stock = false;
                        } else {
                            item.stock = true;
                        }
                    }
                });
            });

            for (let item of newOrderModel?.Items) {
                //#region Precio Llamagas
                // if (newOrderModel?.isTransferDocument) {
                if (false) {
                    const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = item ?? {}
                    const envasado = Envasados?.includes(Number(ItmsGrpCod));
                    const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                    let searchItem = ItemCode;

                    if (!isTemporary && searchItem && (envasado || glpGranel)) {
                        let getItemResponse = null;
                        const newView = newOrderModel?.newView || view;
                        let table = selectTable(newView);
                        let data = {
                            CardCode: newOrderModel?.CardCode || "",
                            ItemCode: searchItem || "",
                            WhsCode: newOrderModel?.Filler || '',
                            ShipToCode: newOrderModel?.ShipToCode || "",
                            userFields: newOrderModel?.userFields || {},
                            Quantity,
                            U_RS_CANTG,
                            U_RS_UMED,
                            U_RS_PRECIOGL,
                            gallonsPrice: true,
                            DocDueDate: newOrderModel?.DocDueDate,
                            TaxDate: newOrderModel?.TaxDate,
                            ObjType: table?.docType,
                        };

                        //#region GALLON PRICE
                        enableSpinner(true);
                        let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);
                        const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                        data.U_RS_PRECIOGL = U_RS_PRECIO;
                        data.gallonsPrice = false;
                        //#endregion GALLON PRICE

                        enableSpinner(true);
                        getItemResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);

                        const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                        item.Price = U_RS_CALCULADO;
                        checkPrice = true;

                        if (glpGranel) {
                            item.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                            item.U_RS_TOTALGL = Number((Number(item?.U_RS_PRECIOGL || 0) * Number(item?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                        }

                        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                        if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                            item.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                            item.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                        } else {
                            item.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                            item.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        }

                        item.newHomePrice = item.Price || 0;
                        item.newPrice = item.Price || 0;
                        item.cHomePrice = item.Price || 0;
                        item.cPrice = item.Price || 0;
                        if (getItemResponse?.status === 1) {
                            showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar de almacén.', timeOut: 5000 });
                        } else {
                            showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar de almacén.', timeOut: 5000 });
                        }
                    }
                }
                //#endregion Precio Llamagas

                //#region GALLONS CONVERSION
                if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && Granel?.includes(Number(item?.ItmsGrpCod))) {
                    item.U_RS_DENS = U_FMB_Factor_Conversion;
                }
                if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && item?.Gallons &&
                    // if ((newOrderModel?.isSalesDocument) && item?.Gallons &&
                    Number(item?.U_RS_CANTG) > 0 &&
                    item?.U_RS_UMED === 'GLN' &&
                    (view === 'quotations' || view === 'orderSales' || view === 'draft' || newOrderModel?.isTransferDocument)
                    // (view === 'quotations' || view === 'orderSales' || view === 'draft')
                ) {
                    // Al cambiar de almacén volver a consultar la conversion a galones
                    item = await this.checkGallons(item, null, newOrderModel);
                    checkPrice = true;
                }
                //#endregion GALLONS CONVERSION

                if (isTransfer) {
                    item.stock = true;
                    item.TotalAsigned = 0;
                    item.Filler = newOrderModel.Filler;
                    item.FillerWhs = Array.isArray(item?.wareHouseStock) ? item.wareHouseStock.find(({ WhsCode }) => WhsCode === newOrderModel?.Filler) : {};
                    item.FromLocationAssignment = Array.isArray(item.FillerWhs?.Location) ? item.FillerWhs.Location : [];
                    const onHand = Number(item?.FillerWhs?.OnHand || 0);

                    if (!onHand) {
                        showAlert({ type: "warning", message: `El artículo ${item.ItemCode} ya no tiene existencia en el almacén de Origen` });
                        item.stock = false;
                    }

                    //#region ########## BINS ##########
                    if (item.FromLocationAssignment.length === 1) {
                        let location = item.FromLocationAssignment[0];
                        if (Number(item.Quantity) <= (Number(location.OnHandQty) || 0)) {
                            item.TotalAsigned = Number(item.Quantity).toFixed(3);
                            location.Quantity = Number(item.Quantity).toFixed(3);
                            location.remainingQty = (Number(location.OnHandQty) - Number(item.Quantity)).toFixed(3);
                        } else {
                            item.TotalAsigned = (Number(location.OnHandQty) || 0).toFixed(3);
                            location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                            location.remainingQty = "0.000";
                        }
                    } else if (item.FromLocationAssignment.length && Number(item.Quantity) === Number(item.FillerWhs?.OnHand || 0)) {
                        item.TotalAsigned = Number(item.FillerWhs?.OnHand || 0).toFixed(3);

                        for (let location of item.FromLocationAssignment) {
                            location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                            location.remainingQty = "0.000";
                        }
                    }
                    //#endregion
                }
            }

        }
        //ALMACEN DESTINO
        if (warehouseUpdate === 3) {
            if (itemOrderModelUpdate === null) {
                newOrderModel.ToWhsCode = warehouse.WhsCode || '';
                newOrderModel.ToWhsCodeName = warehouse.WhsName || '';
            } else {
                newOrderModel.Items[itemOrderModelUpdate].ToWhsCode = warehouse.WhsCode || '';
                newOrderModel.Items[itemOrderModelUpdate].ToWhsCodeName = warehouse.WhsName || '';
            }

            if (!isTransfer) {
                for (let index = 0; index < newOrderModel.Items.length; index++) {
                    const item = newOrderModel.Items[index];
                    const warehouse = item.wareHouseStock.find(w => w.WhsCode === newOrderModel.ToWhsCode);
                    if (warehouse) {
                        item.ToWhsCode = warehouse.WhsCode || '';

                        if (warehouse.BinActivat === 'Y') {
                            const ubication = await apiClient.getPriceKilo(item.ItemCode, newOrderModel.ToWhsCode);
                            item.ToLocationAssignment = ubication?.data?.results || [];
                        }
                    }
                }
            } else {
                for (let item of newOrderModel.Items) {
                    item.ToWhsCode = newOrderModel.ToWhsCode;
                    item.ToWhs = Array.isArray(item?.wareHouseStock) ? item.wareHouseStock.find(({ WhsCode }) => WhsCode === newOrderModel?.ToWhsCode) : {};
                    item.ToLocationAssignment = [];
                    item.ToTotalAsigned = 0;

                    if (item.ToWhs?.BinActivat === "Y") {
                        enableSpinner(true);
                        const ubication = await apiClient.getPriceKilo(item.ItemCode, newOrderModel.ToWhsCode);
                        enableSpinner(false);

                        item.ToLocationAssignment = Array.isArray(ubication?.data?.results) ? ubication.data.results : [];
                        if (item.ToLocationAssignment.length) {
                            item.ToTotalAsigned = Number(item.Quantity).toFixed(3);
                            item.ToLocationAssignment[0].Quantity = Number(item.Quantity).toFixed(3);
                        }
                    }
                }
            }
        }
        //ALMACEN TRANSITO
        if (warehouseUpdate === 4) {
            newOrderModel.wareHouseFinalOptional = true;
            newOrderModel.wareHouseFinalOptionalValue = warehouse.WhsCode || '';
        }
        if (warehouseUpdate === 5) {
            newOrderModel.Items[itemOrderModelUpdate].AvgPrice = warehouse.AvgPrice || 0;
        }
        if (warehouseUpdate === 117) {
            newOrderModel.WarehouseCEDIS = warehouse.WhsCode
        }

        this.refreshModel(newOrderModel);
        if (view !== 'transfersRequest' && view !== 'transfers' && !isDraftOWTQ) {
            this.validateWhsEnter(2, itemOrderModelUpdate);
        }
        setTimeout(() => {
            this.setState({
                warehouses: [],
                itemOrderModelUpdate: null,
                itemSelected: '',
            });
        }, 100);
        $('#almacenDocumentsModal').modal('hide');
        if (checkPrice) {
            await this.refreshTotal(newOrderModel);
        }
    };

    selectAlmacenEnter = async (warehouses, auxIndex = null) => {
        let { itemOrderModelUpdate, warehouseUpdate } = this.state;
        //#region Transportes de ORDR
        if (auxIndex !== null && Number(auxIndex) >= 0) {
            itemOrderModelUpdate = auxIndex;
            warehouseUpdate = 1;
        }
        //#endregion Transportes de ORDR
        const { newOrderModel, showAlert, view, enableSpinner, selectTable, isDraftOWTQ = false } = this.props;
        let warehouse = warehouses;
        const locationView = ['GoodsReceipt', 'deliveries', 'transfersEntry', 'transfersOutput'];
        const isLocationView = locationView?.includes(view ?? '');
        let checkPrice = false;
        let isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;
        if (warehouseUpdate === 1) {
            newOrderModel.Items[itemOrderModelUpdate].WhsCode = warehouse.WhsCode || '';
            newOrderModel.Items[itemOrderModelUpdate].WhsName = warehouse.WhsName || '';
            newOrderModel.Items[itemOrderModelUpdate].OnHand = warehouse.OnHand || 0;
            newOrderModel.Items[itemOrderModelUpdate].AvgPrice = warehouse.AvgPrice || 0;
            newOrderModel.Items[itemOrderModelUpdate].AcctCode = warehouse.AcctCode || '';
            newOrderModel.Items[itemOrderModelUpdate].AcctCode2 = warehouse.AcctCode2 || '';
            newOrderModel.Items[itemOrderModelUpdate].AcctCodeName = warehouse.AcctName || '';
            newOrderModel.Items[itemOrderModelUpdate].FormatCode = warehouse.FormatCode || '';
            newOrderModel.Items[itemOrderModelUpdate].FormatCode2 = warehouse.FormatCode2 || '';
            // if(view === 'PurchaseOrder'){
            //     newOrderModel.Items[itemOrderModelUpdate].Quantity = warehouse.sugerencia > 0 ? warehouse.sugerencia : warehouse.sugerencia *-1 || newOrderModel.Items[itemOrderModelUpdate].Quantity ;
            // }
            if (isLocationView) {
                newOrderModel.Items[itemOrderModelUpdate].BinActivat = warehouse.BinActivat || 'N';
                newOrderModel.Items[itemOrderModelUpdate].DocumentLinesBinAllocations = [];
            }
            newOrderModel.CashAcct = warehouse.CashAccount || '';
            newOrderModel.BpAct = warehouse.ControlAccount || '';
            newOrderModel.Items[itemOrderModelUpdate].wareHouseStock.map(async (warehouseStock) => {

                if (newOrderModel.Items[itemOrderModelUpdate].InvntItem === 'N') {
                    return;
                }

                if (warehouseStock.WhsCode === warehouse.WhsCode) {
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? newOrderModel.Items[itemOrderModelUpdate].SalPackUn : newOrderModel.Items[itemOrderModelUpdate].PurPackUn;
                    if (warehouseStock.OnHand <= 0
                        && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'creditNote' && view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'return' && view !== 'PurchaseRequest') {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + newOrderModel.Items[itemOrderModelUpdate].ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                            timeOut: 5000
                        });
                        newOrderModel.Items[itemOrderModelUpdate].stock = false;

                    } else if ((newOrderModel.Items[itemOrderModelUpdate].UserBaseUn == 'Y' && newOrderModel.Items[itemOrderModelUpdate].Quantity > warehouseStock.OnHand) ||
                        (newOrderModel.Items[itemOrderModelUpdate].UserBaseUn == 'N' && (newOrderModel.Items[itemOrderModelUpdate].Quantity * measureUnit) > warehouseStock.OnHand)
                        && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'creditNote' && view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'return' && view !== 'PurchaseRequest') {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + newOrderModel.Items[itemOrderModelUpdate].ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                            timeOut: 5000
                        });
                        newOrderModel.Items[itemOrderModelUpdate].stock = false;
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].stock = true;
                    }
                    if ((view === 'deliveries' || newOrderModel?.newView === 'deliveries' || view === 'transfersOutput' || newOrderModel?.newView === 'transfersOutput') && warehouse.BinActivat === 'Y') {
                        newOrderModel.Items[itemOrderModelUpdate].DocumentLinesBinAllocations = warehouseStock?.Location ?? [];
                    }
                }
                if (view === "returnRequest" || view === "return" || view === "creditNote") {
                    if (warehouse.BinActivat === 'Y') {
                        const binsResult = await apiClient.getPriceKilo(newOrderModel.Items[itemOrderModelUpdate].WhsCode, newOrderModel.ToWhsCode);
                        newOrderModel.Items[itemOrderModelUpdate].ToLocationAssignment = binsResult.data.results ? binsResult.data.results : [];
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].ToLocationAssignment = [];
                    }
                }
            })

            //#region Cuenta de mayor para OIGN y OIGE
            if (newOrderModel?.InventoryAccount?.AcctCode) {
                newOrderModel.Items[itemOrderModelUpdate].AcctCode = newOrderModel?.InventoryAccount?.AcctCode || '';
                newOrderModel.Items[itemOrderModelUpdate].AcctCodeName = newOrderModel?.InventoryAccount?.AcctName || '';
                newOrderModel.Items[itemOrderModelUpdate].CurrTotal = newOrderModel?.InventoryAccount?.CurrTotal || 0;
                newOrderModel.Items[itemOrderModelUpdate].FormatCode = newOrderModel?.InventoryAccount?.FormatCode || '';
                newOrderModel.Items[itemOrderModelUpdate].AcctCode2 = '';
                newOrderModel.Items[itemOrderModelUpdate].FormatCode2 = '';
            }
            //#endregion Cuenta de mayor para OIGN y OIGE

            //#region Precio Llamagas
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
            if ((newOrderModel?.isSalesDocument)) {
                const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = newOrderModel?.Items?.[itemOrderModelUpdate] ?? {}
                const envasado = Envasados?.includes(Number(ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                let searchItem = ItemCode;

                if (!isTemporary && searchItem && (envasado || glpGranel)) {
                    let getItemResponse = null;
                    const newView = newOrderModel?.newView || view;
                    let table = selectTable(newView);
                    let data = {
                        CardCode: newOrderModel?.CardCode || "",
                        ItemCode: searchItem || "",
                        WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : WhsCode,
                        ShipToCode: newOrderModel?.ShipToCode || "",
                        userFields: newOrderModel?.userFields || {},
                        Quantity,
                        U_RS_CANTG,
                        U_RS_UMED,
                        U_RS_PRECIOGL,
                        gallonsPrice: true,
                        DocDueDate: newOrderModel?.DocDueDate,
                        TaxDate: newOrderModel?.TaxDate,
                        ObjType: table?.docType,
                    };

                    //#region GALLON PRICE
                    enableSpinner(true);
                    let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);
                    const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                    data.U_RS_PRECIOGL = U_RS_PRECIO;
                    data.gallonsPrice = false;
                    //#endregion GALLON PRICE

                    enableSpinner(true);
                    getItemResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);

                    const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                    const item = newOrderModel?.Items?.[itemOrderModelUpdate] || {};
                    item.Price = U_RS_CALCULADO;
                    checkPrice = true;

                    if (glpGranel) {
                        newOrderModel.Items[itemOrderModelUpdate].U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                        newOrderModel.Items[itemOrderModelUpdate].U_RS_TOTALGL = Number((Number(newOrderModel.Items[itemOrderModelUpdate]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[itemOrderModelUpdate]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                    }

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newOrderModel.Items[itemOrderModelUpdate].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newOrderModel.Items[itemOrderModelUpdate].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newOrderModel.Items[itemOrderModelUpdate].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newOrderModel.Items[itemOrderModelUpdate].newHomePrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].newPrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].cHomePrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].cPrice = item.Price || 0;
                    if (getItemResponse?.status === 1) {
                        showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar de almacén.', timeOut: 5000 });
                    } else {
                        showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar de almacén.', timeOut: 5000 });
                    }
                }
            }
            //#endregion Precio Llamagas

            //#region Precio Historico Llamagas
            if (Sections['HistoricalPrices'] && isOPRQ) { // Solo aplica para solicitud de compra
                if (!newOrderModel.Items[itemOrderModelUpdate]?.isTemporary) {
                    let getItemResponse = null;
                    let ItemCode = newOrderModel.Items[itemOrderModelUpdate]?.ItemCode;
                    const localCurrency = CURRENCY;
                    const Currency = newOrderModel.Items[itemOrderModelUpdate]?.Currency || localCurrency;
                    const WhsCode = newOrderModel.Items[itemOrderModelUpdate]?.WhsCode || '';
                    let data = {
                        ItemCode,
                        WhsCode,
                        Currency
                    };

                    enableSpinner(true);
                    if (ItemCode) {
                        getItemResponse = await apiClient.getHistoricalPriceListLlama(data);
                    }
                    enableSpinner(false);

                    const historicalPrice = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.historicalPrice || 0) : 0;
                    const item = newOrderModel.Items[itemOrderModelUpdate] || {};
                    item.Price = historicalPrice;
                    item.hasHistoricalPrice = Number(historicalPrice) > 0;
                    checkPrice = true;

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newOrderModel.Items[itemOrderModelUpdate].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newOrderModel.Items[itemOrderModelUpdate].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newOrderModel.Items[itemOrderModelUpdate].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newOrderModel.Items[itemOrderModelUpdate].newHomePrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].newPrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].cHomePrice = item.Price || 0;
                    newOrderModel.Items[itemOrderModelUpdate].cPrice = item.Price || 0;
                }
            }
            //#endregion Precio Historico Llamagas

            //#region GALLONS CONVERSION
            if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && Granel?.includes(Number(newOrderModel?.Items?.[itemOrderModelUpdate]?.ItmsGrpCod))) {
                newOrderModel.Items[itemOrderModelUpdate].U_RS_DENSIDAD = Number(warehouse?.U_FMB_Factor_Conversion || 0);
            }
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && newOrderModel?.Items?.[itemOrderModelUpdate]?.Gallons &&
            if ((newOrderModel?.isSalesDocument) && newOrderModel?.Items?.[itemOrderModelUpdate]?.Gallons &&
                Number(newOrderModel?.Items?.[itemOrderModelUpdate]?.U_RS_CANTG) > 0 &&
                newOrderModel?.Items?.[itemOrderModelUpdate]?.U_RS_UMED === 'GLN' &&
                // (view === 'quotations' || view === 'orderSales' || view === 'draft' || newOrderModel?.isTransferDocument)
                (view === 'quotations' || view === 'orderSales' || view === 'draft')
            ) {
                // Al cambiar de almacén volver a consultar la conversion a galones
                newOrderModel.Items[itemOrderModelUpdate] = await this.checkGallons(newOrderModel.Items[itemOrderModelUpdate], itemOrderModelUpdate, newOrderModel);
                checkPrice = true;
            }
            //#endregion GALLONS CONVERSION

            //#region DIMENSIONS
            // Al cambiar de almacén ajustar los códigos OcrCode2 y OcrCode3
            const isTransfersEntry = view === "transfersEntry" || newOrderModel?.newView === "transfersEntry";
            const isTransfersOutput = view === "transfersOutput" || newOrderModel?.newView === "transfersOutput";
            if (newOrderModel.DocType === 'I' && (newOrderModel.isSalesDocument || newOrderModel.isPurchaseDocument || isTransfersEntry || isTransfersOutput)) {
                newOrderModel.Items[itemOrderModelUpdate].OcrCode2 = warehouse?.U_LLG_DIME2 || '';
                newOrderModel.Items[itemOrderModelUpdate].OcrCode3 = warehouse?.U_LLG_DIME3 || '';

                newOrderModel.Items[itemOrderModelUpdate].Dimension2 = newOrderModel.Items[itemOrderModelUpdate].OcrCode2 ? true : false;
                newOrderModel.Items[itemOrderModelUpdate].Dimension3 = newOrderModel.Items[itemOrderModelUpdate].OcrCode3 ? true : false;
                showAlert({ type: 'warning', message: `El valor de "SEDES" y el valor de "SUCURSAL" del artículo ${newOrderModel.Items[itemOrderModelUpdate].ItemCode || newOrderModel.Items[itemOrderModelUpdate].ItemName} ha sido ajustado al cambiar de almacén`, timeOut: 5000 });
            }
            //#endregion DIMENSIONS
        }
        //ALMACEN ORIGEN
        if (warehouseUpdate === 2) {
            const U_FMB_Factor_Conversion = Number(warehouse?.U_FMB_Factor_Conversion || 0);
            if (itemOrderModelUpdate === null) {
                newOrderModel.Filler = warehouse.WhsCode || '';
                newOrderModel.FillerName = warehouse.WhsName || '';
            } else {
                newOrderModel.Items[itemOrderModelUpdate].Filler = warehouse.WhsCode || '';
                newOrderModel.Items[itemOrderModelUpdate].FillerName = warehouse.WhsName || '';
            }

            //#region DIMENSIONS
            if (newOrderModel?.isTransferDocument && newOrderModel.DocType === 'I' && newOrderModel?.Items?.length) { // Al cambiar de almacén ajustar los códigos OcrCode2 y OcrCode3
                const isTransfersRequest = view === "transfersRequest" || newOrderModel?.newView === "transfersRequest";
                enableSpinner(true);
                const data = {
                    Type: 2,
                    filter1: warehouse?.WhsCode || '',
                };
                const apiResponse = await apiClient.getDimensions(data);
                enableSpinner(false);

                for (let item of newOrderModel?.Items) {
                    item.OcrCode2 = apiResponse?.data?.Dimension2 || ''; // Determinado desde el almacén
                    item.OcrName2 = isTransfersRequest ? (apiResponse?.data?.Dimension2Name || '') : '';
                    item.OcrCode3 = apiResponse?.data?.Dimension3 || ''; // Determinado desde el almacén
                    item.OcrName3 = isTransfersRequest ? (apiResponse?.data?.Dimension3Name || '') : '';

                    item.Dimension2 = item.OcrCode2 ? true : false;
                    item.Dimension3 = item.OcrCode3 ? true : false;
                }
                showAlert({ type: 'warning', message: `El valor de "SEDES" y el valor de "SUCURSAL" de los artículo ha sido ajustado al cambiar de almacén`, timeOut: 8000 });
            }
            //#endregion DIMENSIONS

            newOrderModel.Items.map(item => {
                item.wareHouseStock.map(warehouse => {
                    if (warehouse.WhsCode === newOrderModel.Filler) {
                        item.Filler = newOrderModel.Filler || '';
                        item.FromLocationAssignment = warehouse.Location || [];
                        if (warehouse.OnHand <= 0 && !this.docsWithoutStock(newOrderModel.OriginDocumentCreate)) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                timeOut: 5000
                            });
                            item.stock = false;
                        } else {
                            item.stock = true;
                        }
                    }
                });
            });

            for (let item of newOrderModel?.Items) {
                //#region Precio Llamagas
                // if (newOrderModel?.isTransferDocument) {
                if (false) {
                    const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = item ?? {}
                    const envasado = Envasados?.includes(Number(ItmsGrpCod));
                    const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                    let searchItem = ItemCode;

                    if (!isTemporary && searchItem && (envasado || glpGranel)) {
                        let getItemResponse = null;
                        const newView = newOrderModel?.newView || view;
                        let table = selectTable(newView);
                        let data = {
                            CardCode: newOrderModel?.CardCode || "",
                            ItemCode: searchItem || "",
                            WhsCode: newOrderModel?.Filler || '',
                            ShipToCode: newOrderModel?.ShipToCode || "",
                            userFields: newOrderModel?.userFields || {},
                            Quantity,
                            U_RS_CANTG,
                            U_RS_UMED,
                            U_RS_PRECIOGL,
                            gallonsPrice: true,
                            DocDueDate: newOrderModel?.DocDueDate,
                            TaxDate: newOrderModel?.TaxDate,
                            ObjType: table?.docType,
                        };

                        //#region GALLON PRICE
                        enableSpinner(true);
                        let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);
                        const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                        data.U_RS_PRECIOGL = U_RS_PRECIO;
                        data.gallonsPrice = false;
                        //#endregion GALLON PRICE

                        enableSpinner(true);
                        getItemResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);

                        const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                        item.Price = U_RS_CALCULADO;
                        checkPrice = true;

                        if (glpGranel) {
                            item.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                            item.U_RS_TOTALGL = Number((Number(item?.U_RS_PRECIOGL || 0) * Number(item?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                        }

                        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                        if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                            item.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                            item.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                        } else {
                            item.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                            item.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        }

                        item.newHomePrice = item.Price || 0;
                        item.newPrice = item.Price || 0;
                        item.cHomePrice = item.Price || 0;
                        item.cPrice = item.Price || 0;
                        if (getItemResponse?.status === 1) {
                            showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar de almacén.', timeOut: 5000 });
                        } else {
                            showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar de almacén.', timeOut: 5000 });
                        }
                    }
                }
                //#endregion Precio Llamagas

                //#region GALLONS CONVERSION
                if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && Granel?.includes(Number(item?.ItmsGrpCod))) {
                    item.U_RS_DENS = U_FMB_Factor_Conversion;
                }
                if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && item?.Gallons &&
                    // if ((newOrderModel?.isSalesDocument) && item?.Gallons &&
                    Number(item?.U_RS_CANTG) > 0 &&
                    item?.U_RS_UMED === 'GLN' &&
                    (view === 'quotations' || view === 'orderSales' || view === 'draft' || newOrderModel?.isTransferDocument)
                    // (view === 'quotations' || view === 'orderSales' || view === 'draft')
                ) {
                    // Al cambiar de almacén volver a consultar la conversion a galones
                    item = await this.checkGallons(item, null, newOrderModel);
                    checkPrice = true;
                }
                //#endregion GALLONS CONVERSION
            }

        }
        //ALMACEN DESTINO
        if (warehouseUpdate === 3) {
            if (itemOrderModelUpdate === null) {
                newOrderModel.ToWhsCode = warehouse.WhsCode || '';
                newOrderModel.ToWhsCodeName = warehouse.WhsName || '';
            } else {
                newOrderModel.Items[itemOrderModelUpdate].ToWhsCode = warehouse.WhsCode || '';
                newOrderModel.Items[itemOrderModelUpdate].ToWhsCodeName = warehouse.WhsName || '';
            }

            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const item = newOrderModel.Items[index];
                const warehouse = item.wareHouseStock.find(w => w.WhsCode === newOrderModel.ToWhsCode);
                if (warehouse) {
                    item.ToWhsCode = warehouse.WhsCode || '';

                    if (warehouse.BinActivat === 'Y') {
                        const ubication = await apiClient.getPriceKilo(item.ItemCode, newOrderModel.ToWhsCode);
                        item.ToLocationAssignment = ubication?.data?.results || [];
                    }
                }
            }
        }
        //ALMACEN TRANSITO
        if (warehouseUpdate === 4) {
            newOrderModel.wareHouseFinalOptional = true;
            newOrderModel.wareHouseFinalOptionalValue = warehouse.WhsCode || '';
        }
        // Precio x Kilo - ESTO SOLO ERA PARA SERDI
        // let PriceKilo = await apiClient.getPriceKilo(newOrderModel.Items[itemOrderModelUpdate].ItemCode, warehouse.WhsCode);
        // newOrderModel.Items[itemOrderModelUpdate].PrecioKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
        // newOrderModel.Items[itemOrderModelUpdate].UserFieldsItem.userFields8 = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(2) : 0;
        // Precio x Kilo
        this.refreshModel(newOrderModel);
        if (view !== 'transfersRequest' && view !== 'transfers' && !isDraftOWTQ) {
            this.validateWhsEnter(2, itemOrderModelUpdate);
        }
        setTimeout(() => {
            this.setState({
                warehouses: [],
                itemOrderModelUpdate: null,
            });
        }, 100);
        if (checkPrice) {
            await this.refreshTotal(newOrderModel);
        }
    };

    GetPriceListRequest = async () => {
        const { enableSpinner } = this.props;
        let responseApi = null;

        enableSpinner(true);
        responseApi = await apiClient.getPriceList();
        enableSpinner(false);

        return responseApi;
    }

    openListPrice = async (index, warehouse) => {
        const { showAlert, enableSpinner } = this.props;


        let getPriceListResponse = await this.GetPriceListRequest();


        if (!Array.isArray(getPriceListResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getPriceListResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            prices: getPriceListResponse.data,
        });

        $('#priceListModal').modal('show');
    };

    openAccountListBpAct = async index => {
        const { showAlert, enableSpinner } = this.props;

        if (!this.validatePartner()) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        enableSpinner(true);
        let response = await apiClient.openAccountListBpAct();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            accounts: response.data,
            accountMayorId: index
        });

        $('#AccountListModal').modal('show');
    };

    openAccountListPaymentAct = async index => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;

        enableSpinner(true);
        let data = {
            Currency: newOrderModel?.DocCur || '',
        }
        if (!data?.Currency) {
            showAlert({ type: 'error', message: 'Por favor seleccione una moneda' });
            return;
        }

        let response = await apiClient.openAccountListPaymentAct(data);
        enableSpinner(false);

        if (!Array.isArray(response?.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response?.data?.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            accounts: response?.data || [],
            accountMayorId: 9,
            indexItem: index
        });

        $('#AccountListModal').modal('show');
    };

    addAccountPaymentLine = async () => {
        const { showAlert, newOrderModel } = this.props;

        if (!newOrderModel?.DocCur) {
            showAlert({ type: 'error', message: 'Por favor seleccione una moneda' });
            return;
        }

        if (newOrderModel.ItemsPayments?.some(item => !item.AcctCode)) {
            showAlert({ type: 'error', message: 'Por favor completa la cuenta de mayor de las líneas antes de agregar otra' });
            return;
        }

        const newItemModel = new NewItemPayment();
        newItemModel.DocCur = newOrderModel.DocCur;
        newOrderModel.ItemsPayments.push(newItemModel);
        this.refreshModel(newOrderModel);
    };

    changeAccountPaymentComment = async (event, indexItem) => {
        const { newOrderModel } = this.props;
        const value = event?.target?.value || '';
        newOrderModel.ItemsPayments[indexItem].Descrip = value?.slice(0, 250);
        this.refreshModel(newOrderModel);
    }

    openBranches = async () => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let response = await apiClient.getBranches();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            branches: response.data,
        });

        $('#branchesModal').modal('show');
    };

    selectBranches = action => {
        const { branches } = this.state;
        const { newOrderModel } = this.props;
        let branch = branches[action.index];

        newOrderModel.Branch = branch.Code || '';
        newOrderModel.BranchName = branch.Name || '';

        this.refreshModel(newOrderModel);
        $('#branchesModal').modal('hide');
    };

    openDepartment = async () => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let response = await apiClient.getDepartment();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            departments: response.data,
        });

        $('#departmentsModal').modal('show');
    };

    selectDepartments = action => {
        const { departments } = this.state;
        const { newOrderModel } = this.props;
        let department = departments[action.index];

        newOrderModel.Department = department.Code || '';
        newOrderModel.DepartmentName = department.Name || '';

        this.refreshModel(newOrderModel);
        $('#departmentsModal').modal('hide');
    };

    openCuentaMayor = async (index = null, cuenta) => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;
        const isAccountPayment = newOrderModel?.isAccountPayment;

        if (!this.validatePartner() && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && !isAccountPayment) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        let data = {
            Currency: isAccountPayment ? newOrderModel?.DocCur || '' : '',
            Type: isAccountPayment ? 'Marketing' : '',
        }
        enableSpinner(true);
        let response = await apiClient.getCuentaMayor(data);
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            accounts: response.data,
            accountMayorId: cuenta,
            indexItem: index
        });

        $('#AccountListModal').modal('show');
    };

    openAsientoContable = async (index = null, item) => {
        const { newOrderModel, enableSpinner, showAlert } = this.props;
        const { DocEntry } = newOrderModel;
        let getAsientoCont = null;
        let AsientosContables = null;
        enableSpinner(true);
        getAsientoCont = await apiClient.getAsiento(DocEntry);
        AsientosContables = await apiClient.getAsientoContable(DocEntry);
        enableSpinner(false);

        if (!Array.isArray(getAsientoCont.data) || !Array.isArray(AsientosContables.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getAsientoCont.data.length === 0 || AsientosContables.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        if (getAsientoCont.status === 1 && AsientosContables.status === 1) {
            this.setState({
                Asiento: getAsientoCont.data[0],
                AsientoContable: AsientosContables.data
            });
            setTimeout(() => {
                $('#AsientoContableModal').modal('show');
            }, 300);
        }


    };

    selectAccountList = action => {
        const { accounts, accountMayorId, indexItem, cardId } = this.state;
        const { newOrderModel, showAlert, view } = this.props;
        let account = accounts[action.index];

        if (accountMayorId === 1) {
            newOrderModel.BpAct = account.AcctCode || '';
            newOrderModel.BpActName = account.AcctName || '';
            newOrderModel.BpActFormatCode = account.FormatCode || '';
        }

        if (accountMayorId === 2) {
            newOrderModel.TrsfrAcct = account.AcctCode || '';
            newOrderModel.TrsfrAcctName = account.AcctName || '';
            newOrderModel.TrsfrAcctFormatCode = account.FormatCode || '';
            //#region Flujo de caja
            if (Sections['FlujoCaja'] && (view === 'payment' || view === 'outgoingPayment')) {
                newOrderModel.needTransferCFW = account?.CfwRlvnt === 'Y' && account?.Finanse === 'Y'; // Criterios para indicar que se necesita flujo de caja
                if (!newOrderModel.needTransferCFW) {
                    newOrderModel.transferCFWId = null;
                } else if (!newOrderModel.transferCFWId) {
                    showAlert({ type: 'info', message: 'Por favor especifique el "Flujo de caja" para transferencia', timeOut: 8000 });
                }
            }
            //#endregion Flujo de caja
        }

        if (accountMayorId === 3) {
            newOrderModel.CheckAcct = account.AcctCode || '';
            newOrderModel.CheckAcctName = account.AcctName || '';
            newOrderModel.CheckAcctFormatCode = account.FormatCode || '';
            //#region Flujo de caja
            if (Sections['FlujoCaja'] && (view === 'payment' || view === 'outgoingPayment') && false) { // Este se queda comentado por que en sap no se muestra visualmente
                newOrderModel.needCheckCFW = account?.CfwRlvnt === 'Y' && account?.Finanse === 'Y'; // Criterios para indicar que se necesita flujo de caja
                if (!newOrderModel.needCheckCFW) {
                    newOrderModel.checkCFWId = null;
                } else if (!newOrderModel.checkCFWId) {
                    showAlert({ type: 'info', message: 'Por favor especifique el "Flujo de caja" para cheques', timeOut: 8000 });
                }
            }
            //#endregion Flujo de caja
        }

        if (accountMayorId === 4) {
            newOrderModel.CashAcct = account.AcctCode || '';
            newOrderModel.CashAcctName = account.AcctName || '';
            newOrderModel.CashAcctFormatCode = account.FormatCode || '';
            //#region Flujo de caja
            if (Sections['FlujoCaja'] && (view === 'payment' || view === 'outgoingPayment')) {
                newOrderModel.needCashCFW = account?.CfwRlvnt === 'Y' && account?.Finanse === 'Y'; // Criterios para indicar que se necesita flujo de caja
                if (!newOrderModel.needCashCFW) {
                    newOrderModel.cashCFWId = null;
                } else if (!newOrderModel.cashCFWId) {
                    showAlert({ type: 'info', message: 'Por favor especifique el "Flujo de caja" para efectivo', timeOut: 8000 });
                }
            }
            //#endregion Flujo de caja
        }
        if (accountMayorId === 5) {
            newOrderModel.Items[indexItem].AcctCode = account.AcctCode || '';//AcctCode || '';
            newOrderModel.Items[indexItem].AcctCodeName = account.AcctName || '';
            newOrderModel.Items[indexItem].CurrTotal = account.FormatCode || 0;
            newOrderModel.Items[indexItem].FormatCode = account.FormatCode || '';

        }
        if (accountMayorId === 6) {
            newOrderModel.Items[indexItem].AcctCode2 = account.AcctCode || '';
            newOrderModel.Items[indexItem].FormatCode2 = account.FormatCode || '';
            // newOrderModel.Items[indexItem].AcctCodeName = account.AcctName || '';
            // newOrderModel.Items[indexItem].CurrTotal = account.FormatCode || 0;
        }
        if (accountMayorId === 7) {
            newOrderModel.service[indexItem].AcctCode = account.AcctCode || '';
            newOrderModel.service[indexItem].AcctCodeName = account.AcctName || '';
            // newOrderModel.Items[indexItem].CurrTotal = account.FormatCode || 0;
        }
        if (accountMayorId === 8) {
            newOrderModel.PaymentsCreditCards[cardId].CreditAcct = account.AcctCode || '';
        }
        if (accountMayorId === 9) {
            newOrderModel.ItemsPayments[indexItem].AcctCode = account.AcctCode || '';
            newOrderModel.ItemsPayments[indexItem].AcctName = account.AcctName || '';
        }

        this.refreshModel(newOrderModel);
        $('#AccountListModal').modal('hide');
        setTimeout(() => {
            this.setState({
                account: [],
            });
        }, 100);
    };

    openTaxes = async (index, execBy) => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;

        const isPurchaseQuotation = newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft';

        if (!this.validatePartner() && (view !== 'PurchaseRequest' || (view === 'PurchaseRequest' && isPurchaseQuotation))) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        let validFor = null;
        if (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote') {
            validFor = 'AR'
        } else if (view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || isPurchaseQuotation) {
            validFor = 'AP'
        }

        enableSpinner(true);
        let getTaxesResponse = await apiClient.getTaxesList(validFor);
        enableSpinner(false);

        if (!Array.isArray(getTaxesResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getTaxesResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            taxes: getTaxesResponse.data,
            itemOrderModelUpdate: index,
            taxChangeBy: execBy ?? null
        });

        $('#impuestoDocumentsModal').modal('show');
    };

    openProjects = async index => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;

        const isAccountPayment = newOrderModel?.isAccountPayment;
        const isPurchaseDocument = newOrderModel?.isPurchaseDocument;
        const isTransferEO = view === 'transfersEntry' || view === 'transfersOutput';

        if ((!this.validatePartner() && view !== 'PurchaseRequest') && !isAccountPayment && !isTransferEO) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }


        enableSpinner(true);
        let data = {
            isAccountPayment,
            isPurchaseDocument,
            isTransferEO,
            isLine: Number(index) >= 0 ? true : false,
        }
        let getProjectsResponse = await apiClient.getProjectsList(data);
        enableSpinner(false);

        if (!Array.isArray(getProjectsResponse?.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getProjectsResponse?.data?.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            projects: getProjectsResponse?.data || [],
            itemProjectIndex: index,
        });

        $('#codeProjectsModal').modal('show');
    };

    selectProjects = action => {
        const { projects, itemProjectIndex } = this.state;
        const { newOrderModel, view } = this.props;
        let project = projects[action.index];
        const isAccountPayment = newOrderModel.isAccountPayment;
        const isTransferEO = view === 'transfersEntry' || view === 'transfersOutput';

        if (isAccountPayment) {
            newOrderModel.PrjCode = project.PrjCode || '';
        } else {
            if ((newOrderModel?.isPurchaseDocument || isTransferEO) && itemProjectIndex === null) { // Proyecto nivel cabecera
                newOrderModel.Project = project.PrjCode || '';
            } else if (newOrderModel.DocType === 'I') {
                newOrderModel.Items[itemProjectIndex].Project = project.PrjCode || '';
            } else {
                newOrderModel.service[itemProjectIndex].Project = project.PrjCode || '';
            }
        }

        $('#codeProjectsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                projects: [],
            });
        }, 100);
    };

    openCheckList = async () => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;
        const isAccountPayment = newOrderModel.isAccountPayment;
        if (!this.validatePartner() && !isAccountPayment) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        let getCuentaBancosResponse;
        let getCodigoEstadosResponse;
        if (!isAccountPayment) {
            enableSpinner(true);
            getCuentaBancosResponse = await apiClient.getCuentaBancosList();
            enableSpinner(false);


            enableSpinner(true);
            getCodigoEstadosResponse = await apiClient.getCodigoEstadosList();
            enableSpinner(false);
        } else {
            enableSpinner(true);
            let results = await apiClient.getBanksAndStates();
            enableSpinner(false);
            getCodigoEstadosResponse = {
                data: results?.data?.States || []
            }
            getCuentaBancosResponse = {
                data: results?.data?.Banks || []
            }
        }

        this.setState({
            checkItemCreateInfo: {
                banks: getCuentaBancosResponse.data,
                contries: getCodigoEstadosResponse.data,
            },
        });

        $('#checkListModal').modal('show');
    };

    selectTaxes = async (action) => {
        const { taxes, itemOrderModelUpdate } = this.state;
        const { newOrderModel } = this.props;
        const { operationList = [] } = this.state;
        let taxe = taxes[action.index];
        if (newOrderModel.DocType === 'I') {
            newOrderModel.Items[itemOrderModelUpdate].TaxCode = taxe.Code || '';
            newOrderModel.Items[itemOrderModelUpdate].TaxeRate = Number(taxe.Rate || 0);
            newOrderModel.Items[itemOrderModelUpdate].TaxName = taxe.Name || '';
            // newOrderModel.Items[itemOrderModelUpdate] = this.setItemIgvOptions(newOrderModel.Items[itemOrderModelUpdate]);

            //#region Codigos de afectación
            let isIGV = !newOrderModel.Items[itemOrderModelUpdate]?.TaxCode?.includes("EXO") && (newOrderModel.Items[itemOrderModelUpdate]?.TaxCode?.includes("IGV") || newOrderModel.Items[itemOrderModelUpdate]?.TaxName?.toUpperCase()?.includes("IGV"));
            let isEXO = newOrderModel.Items[itemOrderModelUpdate]?.TaxCode?.includes("EXO") || newOrderModel.Items[itemOrderModelUpdate]?.TaxName?.toUpperCase()?.includes("EXO") || newOrderModel.Items[itemOrderModelUpdate]?.TaxName?.toUpperCase()?.includes("EXENTO");
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument) && (isIGV || isEXO)) {
            if (newOrderModel?.isPurchaseDocument && (isIGV || isEXO)) {
                newOrderModel.Items[itemOrderModelUpdate].U_BPP_OPER = operationList?.find(oper => isIGV ? oper?.Name?.toUpperCase() === 'AFECTA' : oper?.Name?.toUpperCase() === 'GRATUITA')?.Code || '-'; // Tipo de Operación
                let auxCode = null;
                if (isEXO && newOrderModel.Items[itemOrderModelUpdate]?.U_BPP_OPER === 'G') { // Al ser exento el Código de Afectación debe de ser 15
                    auxCode = 15;
                }
                const newOperation = await this.setItemIgvOptions(newOrderModel.Items[itemOrderModelUpdate], auxCode);
                newOrderModel.Items[itemOrderModelUpdate].U_STR_FECodAfect = newOperation?.U_STR_FECodAfect || ''; // Código de Afectación IGV
                newOrderModel.Items[itemOrderModelUpdate].TaxStatus = isIGV ? 'Y' : 'N'; // Sólo Impuesto

                //#region Tipo de operacion
                const aliasToFind = "U_tipoOpT12";
                const headers = newOrderModel?.userFieldsBody || [];
                const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                if (bodyMatch) {
                    const fieldId = bodyMatch?.header?.FieldID;
                    const options = bodyMatch?.options || [];
                    const allFields = json?.allItemsUserFields || [];
                    const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                    if (foundIndex !== -1) {
                        const fieldNumber = foundIndex + 1;
                        const U_tipoOpT12 = options?.find(option => newOrderModel?.isSalesDocument ? option?.Descr?.toUpperCase() === 'VENTA NACIONAL' : option?.Descr?.toUpperCase() === 'COMPRA NACIONAL')?.FldValue || '';

                        if (U_tipoOpT12) {
                            newOrderModel.Items[itemOrderModelUpdate].UserFieldsItem[`userFields${fieldNumber}`] = U_tipoOpT12; // Asignar por defecto
                        }
                    }
                }
                //#endregion Tipo de operacion
            } else {
                newOrderModel.Items[itemOrderModelUpdate] = await this.setItemIgvOptions(newOrderModel.Items[itemOrderModelUpdate]);
            }
            //#endregion Codigos de afectación
            this.refreshTotal(newOrderModel, itemOrderModelUpdate);
        } else {
            newOrderModel.service[itemOrderModelUpdate].TaxCode = taxe.Code || '';
            newOrderModel.service[itemOrderModelUpdate].TaxeRate = Number(taxe.Rate || 0);
            newOrderModel.service[itemOrderModelUpdate].TaxName = taxe.Name || '';
            this.refreshTotalService(newOrderModel, itemOrderModelUpdate);
        }

        $('#impuestoDocumentsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                taxes: [],
            });
        }, 100);
    };

    openCurrency = async () => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;
        let message = 'Selecciona un socio de negocios';
        const isAccountPayment = newOrderModel?.isAccountPayment;

        if (view === 'landedCosts') {
            message = 'Selecciona un proveedor';
        }

        if (!this.validatePartner() && !isAccountPayment) {
            showAlert({ type: 'info', message });
            return;
        }

        enableSpinner(true);
        let getCuentaBancosResponse = await apiClient.getCurrencies();
        enableSpinner(false);

        if (!Array.isArray(getCuentaBancosResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getCuentaBancosResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }


        this.setState({
            currencies: getCuentaBancosResponse.data,
        });
        $('#currenciesModal').modal('show');
    };

    selectCurrency = action => {
        const { currencies, docCurrencies = [] } = this.state;
        const { newOrderModel, view = '' } = this.props;
        let currency = currencies[action.index];
        let docType = newOrderModel.DocType;
        const isAccountPayment = newOrderModel?.isAccountPayment;
        const oldDocCur = newOrderModel?.DocCur || CURRENCY;

        newOrderModel.Currencies = currencies;
        newOrderModel.DocCur = currency.CurrCode || CURRENCY;
        newOrderModel.ChangeRate = currency.Rate || 1;

        // for (let index = 0; index < newOrderModel.Items.length; index++) {
        //     const item = newOrderModel.Items[index];
        //     item.Currency = currency.CurrCode || CURRENCY;
        //     item.ChangeRate = currency.Rate || 1;
        // }

        // for (let index = 0; index < newOrderModel.service.length; index++) {
        //     const service = newOrderModel.service[index];
        //     service.Currency = currency.CurrCode || CURRENCY;
        //     service.ChangeRate = currency.Rate || 1;
        // }
        if (isAccountPayment && newOrderModel?.ItemsPayments?.length) {
            newOrderModel.ItemsPayments = []; // Al cambiar de moneda se limpian todas las lineas actuales
        }

        //#region Al modificar moneda del documento modificar a la misma moneda las linenas
        const isOPOR = (view === 'PurchaseOrder' && !newOrderModel?.newView) || newOrderModel?.newView === 'PurchaseOrder';
        if (isOPOR && newOrderModel?.Items?.length) {
            const value = newOrderModel.DocCur;
            const newCurrency = docCurrencies?.find(({ CurrCode }) => CurrCode === value);
            const newDocRate = Number(newCurrency?.Rate || 1);

            for (const item of newOrderModel.Items) {
                const oldPrice = Number(item?.Price) || 0;
                const baseQty = Number(item?.BaseQty) || 1;
                const itemCurrency = item?.Currency || oldDocCur;
                const itemRate = Number(item?.ChangeRate || item?.ChangeRateCurrency || 1);

                let newPrice = oldPrice;

                if (itemCurrency !== value) {
                    // Moneda de la línea anterior -> moneda local
                    let priceLocal = oldPrice;
                    if (itemCurrency !== CURRENCY) {
                        priceLocal = oldPrice * itemRate;
                    }

                    // Moneda local -> nueva moneda del documento
                    newPrice = priceLocal;
                    if (value !== CURRENCY) {
                        newPrice = priceLocal / newDocRate;
                    }
                }

                item.HomePrice = newPrice / baseQty; // No debe de llevar redondeo ya que lo hara getTotals
                item.Price = newPrice; // No debe de llevar redondeo ya que lo hara getTotals
                item.Currency = value;
                item.ChangeRate = newDocRate;
                item.ChangeRateCurrency = newDocRate;
            }
        }
        //#endregion Al modificar moneda del documento modificar a la misma moneda las lineas

        if (docType === 'S') {
            this.refreshTotalService(newOrderModel);
        } else {
            this.refreshTotal(newOrderModel);
        }
        $('#currenciesModal').modal('hide');
        setTimeout(() => {
            this.setState({
                currencies: [],
            });
        }, 100);
    };

    openConfirmCurrency = () => {
        const { newOrderModel } = this.props;
        if (newOrderModel?.isAccountPayment && newOrderModel?.ItemsPayments?.length) {
            $('#confirmCurrencyModal').modal('show');
        } else {
            setTimeout(() => {
                this.openCurrency();
            }, 500);
        }
    }

    confirmCurrency = () => {
        setTimeout(() => {
            this.openCurrency();
        }, 500);
    }

    openCentroCoste = async (index, centro) => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;
        const isAccountPayment = newOrderModel.isAccountPayment;

        if (isAccountPayment) {
            if (!newOrderModel.ItemsPayments?.[index]?.AcctCode) {
                showAlert({ type: 'info', message: 'Por favor primero selecciona una cuenta de mayor' });
                return;
            }
        } else if (!this.validatePartner() && view !== 'PurchaseRequest' && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets') {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        enableSpinner(true);
        let getCentroCosteResponse = await apiClient.getCentroCosteList(centro);
        enableSpinner(false);






        if (!Array.isArray(getCentroCosteResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getCentroCosteResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({

            centroCostes: getCentroCosteResponse.data,
            itemOrderModelUpdate: index,
            centroCosteId: centro,
        });

        $('#CentroCoste').modal('show');
    };

    selectCentroCoste = action => {
        const { centroCostes, itemOrderModelUpdate, centroCosteId } = this.state;
        const { newOrderModel, view } = this.props;
        let centroCoste = centroCostes[action.index];

        let docType = newOrderModel.DocType;
        switch (centroCosteId) {
            case 1:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                }

                break;
            case 2:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                }

                break;
            case 3:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                }

                break;
            case 4:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                }

                break;
            case 5:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                }

                break;
            default:
        }

        // this.refreshTotal(newOrderModel, itemOrderModelUpdate);
        this.refreshModel(newOrderModel);
        $('#CentroCoste').modal('hide');
        setTimeout(() => {
            this.setState({
                centroCostes: [],
            });
        }, 100);
    };

    autoSelectEmployee = async (user) => {
        const { action, newOrderModel, enableSpinner } = this.props;

        if (action !== 1) {
            return;
        }

        try {
            enableSpinner(true);
            const getEmployeeResponse = await apiClient.getEmployeeList();
            enableSpinner(false);

            if (!Array.isArray(getEmployeeResponse?.data) || getEmployeeResponse.data.length === 0) {
                return;
            }

            const employees = getEmployeeResponse.data;
            const userSlpCode = user?.U_SlpCode;

            const matchedEmployee = employees.find(emp => emp.SlpCode === userSlpCode);

            if (matchedEmployee) {
                newOrderModel.SlpCode = matchedEmployee.SlpCode || '';
                newOrderModel.SlpName = matchedEmployee.SlpName || '';
                this.refreshModel(newOrderModel);
            } else {
                this.setState({
                    showEmployeeSelector: true,
                    availableEmployees: employees
                });
            }
        } catch (error) {
            // Error silenciado
        }
    };

    openEmployee = async () => {
        const { showAlert, enableSpinner } = this.props;
        if (!this.validatePartner()) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        enableSpinner(true);
        let getEmployeeResponse = await apiClient.getEmployeeList();
        enableSpinner(false);

        if (!Array.isArray(getEmployeeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getEmployeeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            employees: getEmployeeResponse.data,
        });
        $('#employeeDocumentsModal').modal('show');
    };

    selectEmployee = action => {
        const { employees } = this.state;
        const { newOrderModel } = this.props;
        let employee = employees[action.index];

        newOrderModel.SlpCode = employee.SlpCode || '';
        newOrderModel.SlpName = employee.SlpName || '';

        newOrderModel.Items.map(item => {
            if (employee.OcrCode4) {
                item.OcrCode4 = employee.OcrCode4 || item.OcrCode4;
            }
        });

        this.refreshModel(newOrderModel);
        $('#employeeDocumentsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                employees: [],
            });
        }, 100);
    };

    openPropietario = async () => {
        const { showAlert, enableSpinner, view } = this.props;
        if (!this.validatePartner() && view != 'PurchaseRequest') {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        enableSpinner(true);
        let getOwnersResponse = await apiClient.getOwnersList();
        enableSpinner(false);

        if (!Array.isArray(getOwnersResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getOwnersResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            owners: getOwnersResponse?.data ?? [],
            showPropietarioCreateModal: true,
            openPersonRequest: false,
        }, () => {
            $('#propietarioDocumentsModal').modal('show');
        });
    };

    selectPropietario = action => {
        const { owners, openPersonRequest } = this.state;
        const { newOrderModel, showAlert } = this.props;
        let owner = owners[action.index];


        if (openPersonRequest) {
            newOrderModel.Requester = owner.empID || '';
            newOrderModel.ReqName = owner.NameTitular || '';
            newOrderModel.Email = owner.email || '';
            newOrderModel.Branch = owner.Branch || '';
            newOrderModel.BranchName = owner.BranchName || '';
            newOrderModel.Department = owner.dept || '';
            newOrderModel.DepartmentName = owner.DepartmentName || '';
            newOrderModel.CostCenter = owner.CostCenter || '';
            // if (owner?.CostCenter) {
            //     for (const item of newOrderModel?.Items) {
            //         item.OcrCode5 = owner.CostCenter;
            //     }
            //     if (newOrderModel?.Items?.length) {
            //         showAlert({ type: 'info', message: 'El CECO de los artículos ha sido ajustado, favor de revisarlo', timeOut: 5000 });
            //     }
            // }
        } else {
            newOrderModel.OwnerName = owner.NameTitular || '';
            newOrderModel.OwnerCode = owner.empID || '';
        }

        this.refreshModel(newOrderModel);
        $('#propietarioDocumentsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                owners: [],
                showPropietarioCreateModal: false,
            });
        }, 100);
    };

    openFormattedQueries = async field => {
        const { enableSpinner } = this.props;
        if (field?.needFormattedQuery) { // Es un campo que requiere busqueda formateada pero no forma parte de una pestaña
            const formatted = [field];
            enableSpinner(true);
            let getFormattedQueriesRes = await apiClient.getFormattedQueries({ formatted });
            enableSpinner(false);

            let formattedMap = {};
            if (getFormattedQueriesRes?.status) {
                const data = getFormattedQueriesRes?.data ?? [];
                for (const element of data) {
                    const { Field = '', Formatted = [] } = element ?? {};
                    formattedMap[Field] = Formatted;
                }
            }
            field.formattedMap = formattedMap;
        }

        this.setState({
            formattedInfo: field ?? {},
            showFormattedQueriesModal: true,
        }, () => {
            $('#formattedQueriesModal').modal('show');
        }
        );
    };

    selectFormattedQueries = async (action) => {
        const { formattedInfo } = this.state;
        const { newOrderModel, enableSpinner, showAlert, view, isDraftOWTQ = false } = this.props;
        let Field = formattedInfo?.Field ?? '';
        if (!Field) {
            return;
        }
        let currentData = formattedInfo?.needFormattedQuery ? formattedInfo?.formattedMap?.[Field] ?? [] : newOrderModel?.formattedMap?.[Field] ?? [];
        let value = Object.values(currentData?.[action?.index] ?? {})[0] ?? '';
        newOrderModel[Field] = value;
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || Number(newOrderModel?.ObjType) === 67 || Number(newOrderModel?.ObjType) === 1250000001 || isDraftOWTQ;
        const isCreditDebitNote = ((view === 'creditNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'creditNote' || Number(newOrderModel?.ObjType) === 14) || ((view === 'debitNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'debitNote');

        let linkedFields = invFields?.filter(field => field?.active && field?.linkedValue === Field) ?? [];  // Campos dependientes
        if (isCreditDebitNote && Field === 'U_RML_DOCORG') {
            linkedFields = linkedFields.concat(billingFields.filter(field => field?.active && field?.linkedValue === Field));
        }

        if (linkedFields?.length) {
            if (value) {
                enableSpinner(true);
                let data = {
                    Field,
                    param1: value
                };
                if (isCreditDebitNote && Field === 'U_RML_DOCORG') {
                    data.param2 = newOrderModel?.U_RML_TDOCORG || ''
                }
                let res = await apiClient.getFormattedQueriesByCUFD(data);
                enableSpinner(false);

                if (res?.status) {
                    const row = res?.data ?? {};

                    for (const lf of linkedFields) { // Asignar valores a campos dependientes
                        const targetField = lf.Field;

                        if (row.hasOwnProperty(targetField)) {
                            newOrderModel[targetField] = row[targetField];
                        } else {
                            newOrderModel[targetField] = '';
                        }
                    }

                } else { // Limpiar dependientes
                    showAlert({ type: 'error', message: `Ocurrió un error al consultar los valores dependientes del campo "${formattedInfo?.Name}"` });
                    for (const lf of linkedFields) {
                        newOrderModel[lf.Field] = '';
                    }
                }

            } else { // Limpiar dependientes
                for (const lf of linkedFields) {
                    newOrderModel[lf.Field] = '';
                }
            }
        }

        if (isOWTRoOWTQ) {
            if (Field === 'U_RML_TIPOS13') {
                const CodigoMotivoTraslado = newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado;
                if (CodigoMotivoTraslado === '13') {
                    const tipos13Field = newOrderModel?.formattedMap?.[Field] ?? [];
                    const tipos13FieldCode = Object.keys(tipos13Field?.[0] || {})[0];
                    const tipos13FieldDesc = Object.keys(tipos13Field?.[0] || {})[1];
                    let tipos13Desc = tipos13Field.find(option => option[tipos13FieldCode] === value)?.[tipos13FieldDesc] || '';

                    enableSpinner(true);
                    let data = {
                        Field: 'U_STR_FE_GRE_CodigoMotivoTraslado',
                        param1: CodigoMotivoTraslado
                    };
                    let res = await apiClient.getFormattedQueriesByCUFD(data);
                    enableSpinner(false);
                    const row = res?.data ?? {};
                    newOrderModel.U_STR_FE_GRE_DescriMotivoTraslado = tipos13Desc ? `${row?.U_STR_FE_GRE_DescriMotivoTraslado || ''}: ${tipos13Desc}` : row?.U_STR_FE_GRE_DescriMotivoTraslado || '';
                    await this.refreshModel(newOrderModel);
                }
            }
        }

        $('#formattedQueriesModal').modal('hide');
        setTimeout(() => {
            this.setState({
                formattedInfo: {},
                showFormattedQueriesModal: false
            });
        }, 100);

        await this.refreshModel(newOrderModel);
    };

    selectPriceList = action => {
        const { prices } = this.state;
        const { newOrderModel } = this.props;
        let price = prices[action.index];

        newOrderModel.GroupNumTraslado = price.ListNum || '';
        newOrderModel.GroupNumTrasladoName = price.ListName || '';

        this.refreshModel(newOrderModel);
        $('#priceListModal').modal('hide');
        setTimeout(() => {
            this.setState({
                prices: [],
            });
        }, 100);
    };

    openInvoicePaymentList = async () => {
        const { newOrderModel, showAlert, enableSpinner, view } = this.props;

        if (!this.validatePartner()) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        let type = 'C';
        if (view === 'outgoingPayment') {
            type = 'S';
        }

        let data = {
            CardCode: newOrderModel.CardCode,
            Currency: newOrderModel.DocCur,
            type: type
        }

        enableSpinner(true);
        let invoicePaymentResponse = await apiClient.getInvoicePaymentList(data);
        enableSpinner(false);



        if (!Array.isArray(invoicePaymentResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (invoicePaymentResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        if (newOrderModel.ItemsPayments.length != 0) {
            invoicePaymentResponse.data.map((item, index) => {
                newOrderModel.ItemsPayments.map(itemModel => {
                    if (itemModel.ItemCode == item.ItemCode) {
                        item.selected = true;
                    }
                })
            });
        }

        this.setState({
            invoicesPayments: invoicePaymentResponse.data,
        });


        $('#invoicesPaymentModal').modal('show');

    };

    selectInvoicePayment = async itemsSelected => {
        const { newOrderModel, showAlert, enableSpinner, getUserFieldHeaderValue, view = '' } = this.props;

        let currency = '';
        let errorCurrency = false;
        itemsSelected.map((item, index) => {
            const newItemModel = new NewItemPayment();

            if (!index) {
                currency = item.DocCur;
            } else if (currency !== item.DocCur) {
                errorCurrency = true;
            }

            let fecha = new Date(item.TaxDate);
            fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());


            //#region RETENCIONES
            if (newOrderModel?.RetencionVista) {
                newItemModel.U_LLG_RETENCI = item.U_LLG_RETENCI || 'N';
                if (newItemModel.U_LLG_RETENCI === 'Y') { // Tuvo retencion de 3 % - Afecta el total
                    newItemModel.WitholdingTaxApplied = item.DocCur === 'SOL' ? Number(item.WTSum || 0) : Number(item.WTSumFC || 0);
                    item.DocTotalO = Number(item.DocTotal || 0);
                    item.DocTotalOFC = Number(item.DocTotalFC || 0);
                    newItemModel.totalO = item.DocCur === 'SOL' ? item.DocTotalO : item.DocTotalOFC;

                    item.DocTotal = Number(item.DocTotal || 0) - Number(item.WTSum || 0);
                    item.DocTotalFC = Number(item.DocTotalFC || 0) - Number(item.WTSumFC || 0);

                    item.totalPago = Number(item.DocTotal || 0) - Number(item.PaidToDate || 0);
                    item.totalPagoFC = Number(item.DocTotalFC || 0) - Number(item.PaidFC || 0);
                }
            }
            //#endregion RETENCIONES

            //#region CREDIT PERCEPTIONS
            newItemModel.U_PRC_IMP = Number(item.U_BPP_TtPc ?? 0);
            //#endregion CREDIT PERCEPTIONS

            newItemModel.DocEntry = item.DocEntry;
            newItemModel.DocNum = item.DocNum;
            newItemModel.docType = item.ObjType;
            newItemModel.ObjType = item.ObjType;
            newItemModel.DocSubType = item.DocSubType
            newItemModel.RefDate = fecha;
            newItemModel.DocCur = item.DocCur;
            newItemModel.daysLast = item.daysLast;
            newItemModel.differentCurrency = !(item.DocCur === 'SOL');
            newItemModel.total = item.DocCur === 'SOL' ? item.DocTotal : item.DocTotalFC;
            newItemModel.pastDueBalance = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidToDate) : (item.DocTotalFC - item.PaidFC);
            newItemModel.totalPago = item.DocCur === 'SOL' ? parseFloat(item.totalPago).toFixed(4) : item.totalPagoFC;
            newItemModel.U_FMB_RelatedFolio = item.U_FMB_RelatedFolio || '';
            newItemModel.Memo = item.Memo ?? '';
            newItemModel.NumAtCard = item.NumAtCard ?? '';
            //CENTRO DE COSTO SUCURSAL

            // newItemModel.OcrCode3 = ''


            newOrderModel.ItemsPayments.push(newItemModel);
        });

        if (errorCurrency) {
            showAlert({ type: 'error', message: 'Los documentos seleccionados deben de tener la misma moneda' });
            newOrderModel.ItemsPayments = [];
            return;
        }

        newOrderModel.DocCurDocumentsPayment = currency;

        //#region CREDIT PERCEPTIONS
        if (view === 'payment') {
            let perceptionData = newOrderModel.ItemsPayments ?? [];
            enableSpinner(true);
            showAlert({ type: 'info', message: 'Revisando percepciones, por favor espere.' });
            let checkPerceptions = await apiClient.perceptionJournalEntries(perceptionData);
            enableSpinner(false);
            newOrderModel.ItemsPayments = checkPerceptions?.data;
            if (!checkPerceptions?.status) {
                showAlert({ type: 'error', message: 'Ocurrió un error al validar las percepciones' });
                newOrderModel.ItemsPayments = [];
                return;
            } else {
                const validPerceptionJE = [];
                for (const line of newOrderModel?.ItemsPayments) {
                    if (line?.TransIdError || line?.creditPerceptionError) {
                        const { DocNum } = line ?? {};
                        showAlert({ type: 'error', message: `Ocurrió un error al validar las percepciones de la factura ${DocNum ?? ''}`, timeOut: 8000 });
                    } else {
                        validPerceptionJE.push(line);
                    }
                }
                newOrderModel.ItemsPayments = validPerceptionJE;
            }
        }

        if (newOrderModel?.ItemsPayments?.some(line => Number(line?.U_PRC_IMP) > 0)) {
            const U_BPP_MDTD = await getUserFieldHeaderValue('U_BPP_MDTD', newOrderModel, true, view);
            if (Number(U_BPP_MDTD?.foundIndex) >= 0) {
                newOrderModel.userFields[`userFields${U_BPP_MDTD?.fieldNumber}`] = '40'; // Tipo de documento -> 40 para percepciones a crédito
            }

            const U_BPP_PTSC = await getUserFieldHeaderValue('U_BPP_PTSC', newOrderModel, true, view);
            if (Number(U_BPP_PTSC?.foundIndex) >= 0) {
                newOrderModel.userFields[`userFields${U_BPP_PTSC?.fieldNumber}`] = ''; // Serie del certificado
            }
        }
        //#endregion CREDIT PERCEPTIONS

        this.refreshTotal(newOrderModel);
        setTimeout(() => {
            this.setState({
                invoicesPayments: [],
            });
        }, 100);
        $('#invoicesPaymentModal').modal('hide');
    };

    openItems = async (searchingItem = null) => {
        const { showAlert, newOrderModel, enableSpinner, view, isDraftOWTQ = false, DraftObjType = '' } = this.props;
        let searchItem = searchingItem !== null ? searchingItem : newOrderModel.searchItem;

        if ((view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && !newOrderModel.Filler && searchingItem === null) {
            showAlert({ type: 'info', message: 'Selecciona primero un almacén de origen' });
            return;
        }
        if (!this.validatePartner() && view !== 'transfersRequest' && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'PurchaseRequest' && !isDraftOWTQ) {
            showAlert({ type: 'error', message: 'Selecciona un socio de negocios o por favor presiona Enter al seleccionar socio de negocios' });
            return;
        }
        if (!this.validatePersonRequest() && view === 'PurchaseRequest') {
            showAlert({ type: 'info', message: 'Selecciona primero un Solicitante' });
            return;
        }

        let getItemResponse = null;
        enableSpinner(true);
        getItemResponse = await apiClient.getItem(newOrderModel.CardCode, newOrderModel?.searchItem === 'CASCOSEARCH' ? newOrderModel?.searchItem : view, searchItem, newOrderModel, DraftObjType);
        enableSpinner(false);

        if (getItemResponse.data.length === 0) {

            if (!Array.isArray(getItemResponse.data.results)) {
                showAlert({ type: 'info', message: getItemResponse.message });
                return;
            }

            if (getItemResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getItemResponse.data.length === 1) {
            this.setState({
                items: getItemResponse.data
            });
            await this.selectItemsEnter(getItemResponse.data);
        } else {
            this.setState({
                items: getItemResponse?.data?.results || getItemResponse?.data || [],
                pageTotal: getItemResponse?.data?.totalPage || getItemResponse?.data?.length || 0
            });
            $('#itemsCreate').modal('show');
        }
    };

    refreshItems = async (item, totalRows) => {
        this.setState({
            items: item,
            pageTotal: totalRows
        });
    }

    addRow = async () => {
        const { newOrderModel, showAlert, view } = this.props;
        if (!this.validatePartner() && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets') {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }


        let newService = new NewService();

        if (newOrderModel.TaxeDefaultPartner) {
            newService.TaxCode = newOrderModel.TaxeDefaultPartner;
        }
        if (newOrderModel.TaxeRateDefaultPartner) {
            newService.TaxeRate = newOrderModel.TaxeRateDefaultPartner;
        }
        if (newOrderModel.TaxNameDefaultPartner) {
            newService.TaxName = newOrderModel.TaxNameDefaultPartner;
        }
        //CENTROS DE COSTOS 
        //CENTRO DE COSTO SUCURSAL
        //CENTRO DE COSTO 1
        newService.OcrCode = '';
        //CENTRO DE COSTO 2
        newService.OcrCode2 = '';
        //CENTRO DE COSTO 3
        newService.OcrCode3 = '';
        //CENTRO DE COSTO 4
        newService.OcrCode4 = '';
        //CENTROS DE COSTOS 
        newService.UserFieldsItem = JSON.parse(JSON.stringify(newOrderModel.userFieldsItem));
        newOrderModel.service.push(newService);
        this.refreshModel(newOrderModel);
    }

    updateItemsWhenPartnerChange = async newOrderModel => {
        const { enableSpinner, showAlert, view } = this.props;

        enableSpinner(true);
        let getItemsResponse = await apiClient.getItemsList(newOrderModel.CardCode);
        enableSpinner(false);

        if (!Array.isArray(getItemsResponse.data)) {
            return newOrderModel;
        }

        if (getItemsResponse.data.length === 0) {
            return newOrderModel;
        }

        let itemsUpdate = [];
        newOrderModel.Items.map(item => {
            getItemsResponse.data.map(refreshItem => {
                if (item.ItemCode === refreshItem.ItemCode) {
                    item.Price = refreshItem.Price;
                    item.HomePrice = refreshItem.Price;
                    item.wareHouseStock = refreshItem.wareHouses;
                    item.InvntItem = refreshItem.InvntItem;



                    if (newOrderModel.TaxeDefaultPartner) {
                        item.TaxeCode = newOrderModel.TaxeDefaultPartner || item.TaxeCode;
                    }

                    if (newOrderModel.TaxeRateDefaultPartner) {
                        item.TaxeRate = newOrderModel.TaxeRateDefaultPartner || item.TaxeRate;
                    }

                    if (newOrderModel.TaxNameDefaultPartner) {
                        item.TaxName = newOrderModel.TaxNameDefaultPartner || item.TaxName;
                    }

                    if (newOrderModel.OcrCode2DefaultPartner) {
                        item.OcrCode2 = newOrderModel.OcrCode2DefaultPartner || item.OcrCode2;
                    }

                    if (newOrderModel.AcctCodeDefaultPartner) {
                        item.AcctCode = newOrderModel.AcctCodeDefaultPartner || item.AcctCode;
                        item.AcctCodeName = newOrderModel.AcctCodeNameDefaultPartner || item.AcctCodeName;
                    }

                    if (newOrderModel.CogsAcctDefaultPartner) {
                        item.CogsAcct = newOrderModel.CogsAcctDefaultPartner || item.CogsAcct;
                        item.CogsAcctName = newOrderModel.CogsAcctNameDefaultPartner || item.CogsAcctName;
                    }


                    if (view !== 'transfers' && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'creditNote' && view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'return' && view !== 'PurchaseRequest') {
                        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                        refreshItem.wareHouses.map(warehouseStock => {
                            if (item.InvntItem === 'N') {
                                return;
                            }
                            if (warehouseStock.WhsCode == item.WhsCode) {
                                if (warehouseStock.OnHand <= 0) {
                                    showAlert({
                                        type: 'warning',
                                        message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                        timeOut: 5000
                                    });
                                    item.stock = false;

                                } else if ((item.UserBaseUn == 'Y' && item.Quantity > warehouseStock.OnHand) ||
                                    (item.UserBaseUn == 'N' && (item.Quantity * Number(measureUnit)) > warehouseStock.OnHand)) {
                                    showAlert({
                                        type: 'warning',
                                        message: 'El artículo ' + item.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                                        timeOut: 5000
                                    });
                                    item.stock = false;
                                } else {
                                    item.stock = true;
                                }
                            }
                        })
                    }


                    itemsUpdate.push(item);
                }
            });
        });


        newOrderModel.Items = itemsUpdate;

        return newOrderModel;
    };

    selectItems = async itemsSelected => {
        await this.SetBillingCatalogs();
        const { newOrderModel, showAlert, view, selectTable, disWhs, enableSpinner, isDraftOWTQ = false } = this.props;
        const { operationList = [] } = this.state;
        let isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;
        let user = await JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let OcrCode4DefaultItems = '';
        if (newOrderModel.Items.length) {
            OcrCode4DefaultItems = newOrderModel.Items[0] ? newOrderModel.Items[0].OcrCode4 : '';
        }

        // let whCode = user.U_whsCode || null;;
        // let almacen = {
        //     item: itemsSelected[0].ItemCode,
        //     whsCode: whCode || '',
        //     Cascos: true
        // };
        // let AlmacenCascos = [];
        // if (view === 'SalesHelmets' && whCode) {
        //     AlmacenCascos = await apiClient.getWarehouse(almacen);
        //     if (AlmacenCascos.data[0]) {
        //         newOrderModel.CashAcct = AlmacenCascos.data[0].CashAccount || '';
        //         newOrderModel.BpAct = AlmacenCascos.data[0].ControlAccount || '';
        //     }
        // }
        // let whsCascos = AlmacenCascos.data ? AlmacenCascos.data[0] : null;


        for (let index = 0; index < itemsSelected.length; index++) {
            const item = itemsSelected[index];
            let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;

            const newItemModel = new NewItem();
            newItemModel.LineNum = newOrderModel.Items.length;
            newItemModel.ItemCode = item.ItemCode;
            newItemModel.ItemName = item.ItemName;
            newItemModel.Description = item.ItemName;
            // if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
            if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision);
                newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision);
            } else {
                newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
            }

            newItemModel.newHomePrice = item.Price || 0;
            newItemModel.newPrice = item.Price || 0;
            newItemModel.cHomePrice = item.Price || 0;
            newItemModel.cPrice = item.Price || 0;
            newItemModel.wareHouseStock = item.wareHouses;
            newItemModel.InvntItem = item.InvntItem || '';
            newItemModel.SalUnitMsr = item.SalUnitMsr || '';
            newItemModel.BuyUnitMsr = item.BuyUnitMsr || '';
            newItemModel.InvntryUom = item.InvntryUom;
            newItemModel.OnHand = item.OnHand || 0;
            newItemModel.PricesList = item.itemPrice || [];
            newItemModel.NoPriceList = item.PriceList;
            newItemModel.SalPackUn = item.SalPackUn;
            newItemModel.PurPackUn = item.PurPackUn;
            newItemModel.RevenuesAc = item.RevenuesAc;
            newItemModel.AvgPrice = item.AvgPrice;
            newItemModel.ManBtchNum = item.ManBtchNum;
            newItemModel.UserFieldsItem = JSON.parse(JSON.stringify(newOrderModel.userFieldsItem));
            newItemModel.UomCode = item.UomCode || '';
            newItemModel.measureUnit = measureUnit || 1;
            newItemModel.U_RS_NEGNR = item.U_RS_NEGNR || '';

            if (item.EvalSystem === 'A') {
                newItemModel.EvalSystem = "Promedio móvil";
            } else if (item.EvalSystem === 'B') {
                newItemModel.EvalSystem = "Serie / Lote";
            } else if (item.EvalSystem === 'F') {
                newItemModel.EvalSystem = "FIFO";
            } else if (item.EvalSystem === 'S') {
                newItemModel.EvalSystem = "Estándar";
            }
            //#region CENTROS DE COSTOS 

            //CENTRO DE COSTO 1
            if (view !== 'transfers' && view !== 'transfersRequest' && view !== 'transfersEntry' && view !== 'transfersOutput' && !isDraftOWTQ) {
                newItemModel.OcrCode = item.OcrdCode;
            }
            //CENTRO DE COSTO 2
            // newItemModel.OcrCode2 = newOrderModel.OcrCode2;
            //CENTRO DE COSTO 3
            // newItemModel.OcrCode3 = item.OcrCode3;
            //CENTRO DE COSTO 4
            // newItemModel.OcrCode4 = item.OcrCode4;

            // if (newOrderModel?.isPurchaseDocument && newOrderModel?.CostCenter) {
            //     newItemModel.OcrCode5 = newOrderModel?.CostCenter;
            // }

            // CAMPO PARA GASTOS ADMINISTRATIVOS Y GASTOS 
            newItemModel.isTemporary = false;
            newItemModel.ParentLineNum = null;
            newItemModel.Quantity = item.Quantity || 1;

            //#endregion CENTROS DE COSTOS 

            //#region ######################## IVA DEFAULT #####################################
            let taxCode = '';
            let taxRate = '';
            let taxName = '';
            if (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve') {
                taxCode = item.TaxCodeAR;
                taxRate = item.TaxeRate || item.TaxRate;
                taxName = item.TaxName;
            } else {
                taxCode = item.TaxCodeAP;
                taxRate = item.TaxeRateAP || item.TaxRateAP;
                taxName = item.TaxNameAP;
            }

            newItemModel.TaxCode = taxCode || newOrderModel.TaxeDefaultPartner;
            newItemModel.TaxeRate = taxRate || newOrderModel.TaxeRateDefaultPartner;
            newItemModel.TaxeRate = Number(newItemModel?.TaxeRate || 0);
            newItemModel.TaxName = taxName || newOrderModel.TaxNameDefaultPartner;
            //#endregion

            //#region ######################## ALMACEN DEFAULT ############################################
            let userFieldRoute = 27;
            let fieldValue = userFieldRoute != -1 ? newOrderModel.userFields[`userFields${userFieldRoute + 1}`] : null

            // let projectWhs = fieldValue == 'RUT' && disWhs && disWhs.WhsCode ? disWhs?.WhsCode : user.Branch.ProjectCode || null;
            let projectWhs = fieldValue == 'RCF' && disWhs && disWhs.WhsCode ? disWhs?.WhsCode : user.Branch.ProjectCode || null;

            if (newOrderModel?.isSalesDocument && (fieldValue === 'ABS' || fieldValue === 'RUT' || fieldValue === 'RCF' || fieldValue === 'DST')) {
                projectWhs = null;
            }

            if (projectWhs || (!projectWhs && newOrderModel?.CodigoUnidad)) {
                newItemModel.whsSelected = true;
                newItemModel.WhsCode = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.WhsCode || '' : projectWhs;

                newItemModel.WhsName = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.WhsName || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].WhsName : '';
                newItemModel.AcctCode = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.AcctCode || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctCode : '';
                newItemModel.AcctCode2 = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.AcctCode2 || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctCode2 : '';
                newItemModel.AcctCodeName = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.AcctCodeName || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctName : '';
                newItemModel.FormatCode = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.FormatCode || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].FormatCode : '';
                newItemModel.FormatCode2 = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.FormatCode2 || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].FormatCode2 : '';
                if (newOrderModel.U_TipoSalida !== '' && !newOrderModel?.InventoryAccount?.AcctCode) {
                    let data = {
                        Type: newOrderModel.U_TipoSalida,
                        WhsCode: newItemModel.WhsCode,
                    }

                    let responseGetAcctCode = await apiClient.getAcctCodeType_I_O(data);
                    if (responseGetAcctCode.status === 1) {
                        if (responseGetAcctCode.data[0].AcctCode !== '') {
                            const cuentaOriginal = responseGetAcctCode.data[0].AcctCode;
                            const expresionRegular = /^(\d{7})(\d{2})(\d{2})$/;
                            const resultado = cuentaOriginal.replace(expresionRegular, "$1-$2-$3");
                            newItemModel.FormatCode = resultado;
                            newItemModel.AcctCode = cuentaOriginal;
                        }
                    }
                }
                //#region Cuenta de mayor para OIGN y OIGE
                if (newOrderModel?.InventoryAccount?.AcctCode) {
                    newItemModel.AcctCode = newOrderModel?.InventoryAccount?.AcctCode || '';
                    newItemModel.AcctCodeName = newOrderModel?.InventoryAccount?.AcctName || '';
                    newItemModel.CurrTotal = newOrderModel?.InventoryAccount?.CurrTotal || 0;
                    newItemModel.FormatCode = newOrderModel?.InventoryAccount?.FormatCode || '';
                    newItemModel.AcctCode2 = '';
                    newItemModel.FormatCode2 = '';
                }
                //#endregion Cuenta de mayor para OIGN y OIGE
            }
            let Almacen = item?.wareHouses?.find((whs) => whs.WhsCode === newItemModel.WhsCode);
            newItemModel.AvgPrice = Almacen ? Almacen.AvgPrice : item.AvgPrice;

            const locationView = ['GoodsReceipt', 'deliveries', 'transfersEntry', 'transfersOutput'];
            if (locationView?.includes(newOrderModel?.newView || view || '')) {
                newItemModel.BinActivat = Almacen?.BinActivat || 'N';
                if ((view === 'deliveries' || newOrderModel?.newView === 'deliveries' || view === 'transfersOutput' || newOrderModel?.newView === 'transfersOutput') && newItemModel?.BinActivat === 'Y') {  // Es para emisión
                    newItemModel.DocumentLinesBinAllocations = Almacen?.Location ?? [];
                }
            }

            // Precio x Kilo - ESTO SOLO ERA PARA SERDI
            // let PriceKilo = await apiClient.getPriceKilo(newItemModel.ItemCode, newItemModel.WhsCode);
            // newItemModel.PrecioKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(priceDecimalPrecision) : 0;
            // newItemModel.UserFieldsItem.userFields8 = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(priceDecimalPrecision) : 0;
            // Precio x Kilo
            //#endregion
            if (view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) {
                let noList = parseInt(newOrderModel.GroupNum);
                noList = (noList === -1 || noList === -2) ? noList + 1 : noList;
                let price = item.itemPrice.filter((item) => item.PriceList === noList) || 0;

                newItemModel.Price = price?.[0]?.Price || 0;
                newItemModel.HomePrice = price?.[0]?.Price || 0;
            }

            if (newOrderModel.AcctCodeDefaultPartner) {
                newItemModel.AcctCode = newOrderModel.AcctCodeDefaultPartner || newItemModel.AcctCode;
                newItemModel.AcctCodeName = newOrderModel.AcctCodeNameDefaultPartner || newItemModel.AcctCodeName;
            }

            if (newOrderModel.CogsAcctDefaultPartner) {
                newItemModel.CogsAcct = newOrderModel.CogsAcctDefaultPartner || newItemModel.CogsAcct;
                newItemModel.CogsAcctName = newOrderModel.CogsAcctNameDefaultPartner || newItemModel.CogsAcctName;
            }


            // Precios de entrada y salida de mercancia (Ultimo precio de compra y ultimo determinado)
            if ((view === 'transfersEntry' || view === 'transfersOutput') && newOrderModel.GroupNum !== '') {
                let numList = parseInt(newOrderModel.GroupNum);
                numList = (numList === -1 || numList === -2) ? numList + 1 : numList;
                for (let i = 0; i < item.itemPrice.length; i++) {
                    let list = item.itemPrice[i].PriceList;
                    if (list == numList) {
                        newItemModel.HomePrice = item.itemPrice[i].Price;
                        newItemModel.Price = item.itemPrice[i].Price;
                    }
                }
            }

            //validate warehoyse stock
            if (newItemModel.InvntItem === 'Y' && (view === 'transfers' || view === 'transfersRequest' || isDraftOWTQ)) {
                for (let index = 0; index < item.wareHouses.length; index++) {
                    const warehouseStock = item.wareHouses[index];
                    if (warehouseStock.WhsCode === newOrderModel.Filler) {
                        newItemModel.FromLocationAssignment = warehouseStock.Location || [];
                        if (warehouseStock.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;

                        } else {
                            newItemModel.stock = true;
                        }

                    }
                }

            } else if (newItemModel.InvntItem === 'Y' && (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve')) {

                for (let index = 0; index < item.wareHouses.length; index++) {
                    const warehouseStock = item.wareHouses[index];
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? newItemModel.SalPackUn : newItemModel.PurPackUn;
                    if (warehouseStock.WhsCode === newItemModel.WhsCode) {
                        newItemModel.OnHand = warehouseStock.OnHand || 0;
                        newItemModel.FromLocationAssignment = warehouseStock.Location || [];
                        if (warehouseStock.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;

                        } else if ((newItemModel.UserBaseUn === 'Y' && newItemModel.Quantity > warehouseStock.OnHand) ||
                            (newItemModel.UserBaseUn === 'N' && (newItemModel.Quantity * measureUnit) > warehouseStock.OnHand)) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;
                        } else {
                            newItemModel.stock = true;
                        }
                    }
                }

            } else if (newItemModel.InvntItem === 'Y' && (view === 'returnRequest' || view === 'return' || view === 'creditNote')) {
                const warehouse = item?.wareHouses?.find(({ WhsCode }) => WhsCode === newItemModel.WhsCode) || null;
                if (warehouse) {
                    if (warehouse.BinActivat === 'Y') {
                        const binsResult = await apiClient.getPriceKilo(newItemModel.ItemCode, newItemModel.WhsCode);
                        newItemModel.ToLocationAssignment = binsResult.data.results ? binsResult.data.results : [];
                    }
                }
            }

            if (item.ItemCode === "DESCUENTO" && (view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseInvoice')) {
                let price = 0;
                for (const cItem of newOrderModel.Items) {
                    price += Number((Number(cItem.Price || 0) * Number(cItem.Quantity || 0) * Number(newOrderModel.U_FMB_DescPP || 0) / 100).toFixed(priceDecimalPrecision));
                }
                newItemModel.HomePrice = price;
                newItemModel.Price = price;
            }


            if (isMarketingDocumentSAP(view)) {
                if (newOrderModel.searchItem == 'CASCOSEARCH' && item?.U_FMB_IS_CILINDRO === '1') {
                    newItemModel.Quantity = newOrderModel.Items[newOrderModel.indexSearch].Quantity;
                    newOrderModel.searchItem = null
                    delete newOrderModel.indexSearch
                }
                newItemModel.Casco = 1;
                newItemModel.U_FMB_CILINDRO = item?.U_FMB_CILINDRO || newItemModel.U_FMB_CILINDRO;
                newItemModel.U_FMB_IS_CILINDRO = item?.U_FMB_IS_CILINDRO || newItemModel.U_FMB_IS_CILINDRO;

            }

            newItemModel.TaxStatus = newItemModel.TaxCode === 'EXO' ? 'N' : item.VATLiable || 'N'
            //#region ########## DEFAULT TAXCODE ITEM ##########
            newItemModel.ItemTaxCodeName = item.ItemTaxCodeName
            newItemModel.ItemTaxCode = item.ItemTaxCode
            newItemModel.ItemRate = item.ItemRate
            //#endregion ########## DEFAULT TAXCODE ITEM ##########

            //#region Codigos de afectación
            let isIGV = !newItemModel?.TaxCode?.includes("EXO") && (newItemModel?.TaxCode?.includes("IGV") || newItemModel?.TaxName?.toUpperCase()?.includes("IGV"));
            let isEXO = newItemModel?.TaxCode?.includes("EXO") || newItemModel?.TaxName?.toUpperCase()?.includes("EXO") || newItemModel?.TaxName?.toUpperCase()?.includes("EXENTO");
            if ((newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument) && (isIGV || isEXO)) {
                newItemModel.U_BPP_OPER = operationList?.find(oper => isIGV ? oper?.Name?.toUpperCase() === 'AFECTA' : oper?.Name?.toUpperCase() === 'GRATUITA')?.Code || '-'; // Tipo de Operación
                let auxCode = null;
                if (isEXO && newItemModel?.U_BPP_OPER === 'G') { // Al ser exento el Código de Afectación debe de ser 15
                    auxCode = 15;
                }
                const newOperation = await this.setItemIgvOptions(newItemModel, auxCode);
                newItemModel.U_STR_FECodAfect = newOperation?.U_STR_FECodAfect || ''; // Código de Afectación IGV
                newItemModel.TaxStatus = isIGV ? 'Y' : 'N'; // Sólo Impuesto

                //#region Tipo de operacion
                const aliasToFind = "U_tipoOpT12";
                const headers = newOrderModel?.userFieldsBody || [];
                const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                if (bodyMatch) {
                    const fieldId = bodyMatch?.header?.FieldID;
                    const options = bodyMatch?.options || [];
                    const allFields = json?.allItemsUserFields || [];
                    const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                    if (foundIndex !== -1) {
                        const fieldNumber = foundIndex + 1;
                        const U_tipoOpT12 = options?.find(option => newOrderModel?.isSalesDocument ? option?.Descr?.toUpperCase() === 'VENTA NACIONAL' : option?.Descr?.toUpperCase() === 'COMPRA NACIONAL')?.FldValue || '';

                        if (U_tipoOpT12) {
                            newItemModel.UserFieldsItem[`userFields${fieldNumber}`] = U_tipoOpT12; // Asignar por defecto
                        }
                    }
                }
                //#endregion Tipo de operacion
            }
            //#endregion Codigos de afectación

            newItemModel.ItmsGrpCod = item.ItmsGrpCod;

            let checkPrice = false;
            //#region Precio Llamagas
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
            if ((newOrderModel?.isSalesDocument)) {
                let searchItem = newItemModel?.ItemCode;
                const envasado = Envasados?.includes(Number(newItemModel?.ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(newItemModel?.ItmsGrpCod));

                if (!newItemModel?.isTemporary && (envasado || glpGranel)) {
                    if (newOrderModel?.isSalesDocument) {
                        if (!newItemModel?.WhsCode) {
                            showAlert({ type: 'warning', message: `Es necesario seleccionar el almacén del artículo ${newItemModel?.ItemCode || newItemModel.ItemName} para obtener su precio`, timeOut: 5000 });
                            // continue;
                        }
                    } else if (newOrderModel?.isTransferDocument) {
                        if (!newOrderModel?.Filler) {
                            showAlert({ type: 'warning', message: `Es necesario seleccionar el almacén origen para obtener el precio del artículo ${newItemModel?.ItemCode || newItemModel.ItemName}`, timeOut: 5000 });
                            // continue;
                        }
                    }
                    let getItemResponse = null;
                    const newView = newOrderModel?.newView || view;
                    let table = selectTable(newView);
                    let data = {
                        CardCode: newOrderModel?.CardCode || "",
                        ItemCode: searchItem || "",
                        WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : newItemModel?.WhsCode || '',
                        ShipToCode: newOrderModel?.ShipToCode || "",
                        userFields: newOrderModel?.userFields || {},
                        Quantity: newItemModel?.Quantity || 0,
                        U_RS_CANTG: newItemModel?.U_RS_CANTG || 0,
                        U_RS_UMED: newItemModel?.U_RS_UMED || "",
                        U_RS_PRECIOGL: newItemModel?.U_RS_PRECIOGL || 0,
                        gallonsPrice: true,
                        DocDueDate: newOrderModel?.DocDueDate,
                        TaxDate: newOrderModel?.TaxDate,
                        ObjType: table?.docType,
                    };

                    //#region GALLON PRICE
                    enableSpinner(true);
                    let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);
                    const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                    data.U_RS_PRECIOGL = U_RS_PRECIO;
                    data.gallonsPrice = false;
                    //#endregion GALLON PRICE

                    enableSpinner(true);
                    if ((newOrderModel?.isSalesDocument && newItemModel?.WhsCode) || (newOrderModel?.isTransferDocument && newOrderModel?.Filler)) {
                        getItemResponse = await apiClient.getPriceListLlama(data);
                    }
                    enableSpinner(false);

                    const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                    const item = newItemModel || {};
                    item.Price = U_RS_CALCULADO;
                    checkPrice = true;

                    if (glpGranel) {
                        newItemModel.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0).toFixed(priceDecimalPrecision));
                        newItemModel.U_RS_TOTALGL = Number((Number(newItemModel?.U_RS_PRECIOGL || 0) * Number(newItemModel?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                    }

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newItemModel.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newItemModel.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                    } else {
                        newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newItemModel.newHomePrice = item.Price || 0;
                    newItemModel.newPrice = item.Price || 0;
                    newItemModel.cHomePrice = item.Price || 0;
                    newItemModel.cPrice = item.Price || 0;

                    if (getItemResponse?.status === 1) {
                        showAlert({ type: 'info', message: `El precio del artículo ${newItemModel.ItemCode || newItemModel.ItemName} ha sido ajustado por el grupo de artículos al que pertenece`, timeOut: 5000 });
                    } else if (newItemModel?.WhsCode) {
                        showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode, timeOut: 5000 });
                    }
                }
            }
            //#endregion Precio Llamagas

            //#region Precio Historico Llamagas
            if (Sections['HistoricalPrices'] && isOPRQ) { // Solo aplica para solicitud de compra
                if (!newItemModel?.isTemporary) {
                    let getItemResponse = null;
                    let ItemCode = newItemModel?.ItemCode;
                    const localCurrency = CURRENCY;
                    const Currency = newItemModel?.Currency || localCurrency;
                    const WhsCode = newItemModel?.WhsCode || '';
                    let data = {
                        ItemCode,
                        WhsCode,
                        Currency
                    };

                    enableSpinner(true);
                    if (ItemCode) {
                        getItemResponse = await apiClient.getHistoricalPriceListLlama(data);
                    }
                    enableSpinner(false);

                    const historicalPrice = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.historicalPrice || 0) : 0;
                    const item = newItemModel || {};
                    item.Price = historicalPrice;
                    item.hasHistoricalPrice = Number(historicalPrice) > 0;
                    checkPrice = true;

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newItemModel.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newItemModel.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    } else {
                        newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newItemModel.newHomePrice = item.Price || 0;
                    newItemModel.newPrice = item.Price || 0;
                    newItemModel.cHomePrice = item.Price || 0;
                    newItemModel.cPrice = item.Price || 0;
                }
            }
            //#endregion Precio Historico Llamagas

            //#region GALLONS CONVERSION
            newItemModel.U_RS_UMED = item.U_RS_UMED || '';
            newItemModel.U_RS_CANTG = Number(item.U_RS_CANTG || 0);
            newItemModel.U_RS_PRECIOGL = checkPrice ? Number(newItemModel.U_RS_PRECIOGL || 0) : Number(item.U_RS_PRECIOGL || 0);
            if (development && !newItemModel?.U_RS_PRECIOGL) { // Temporal en lo que dicen como determinar el Precio Galones
                newItemModel.U_RS_PRECIOGL = 100;
            }
            newItemModel.U_RS_TOTALGL = Number(item.U_RS_TOTALGL || 0);
            newItemModel.U_RS_DENS = Number(item.U_RS_DENS || 0);
            try {
                if (((!newOrderModel?.isTransferDocument && newItemModel?.WhsCode) || (newOrderModel?.isTransferDocument && newOrderModel?.Filler)) && Granel?.includes(Number(newItemModel?.ItmsGrpCod))) {
                    enableSpinner(true);
                    const data = {
                        WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler : newItemModel?.WhsCode,
                    };
                    const apiResponse = await apiClient.getFactorConversion(data);
                    enableSpinner(false);

                    if (apiResponse?.status === 1) {
                        newItemModel.U_RS_DENS = Number(apiResponse?.data?.U_FMB_Factor_Conversion || 0);
                    }
                }
            } catch (err) { }
            newItemModel.Gallons = item.Gallons || 0;
            //#endregion GALLONS CONVERSION

            //#region DIMENSIONS
            const isTransfersEntry = view === "transfersEntry" || newOrderModel?.newView === "transfersEntry";
            const isTransfersOutput = view === "transfersOutput" || newOrderModel?.newView === "transfersOutput";
            const isTransfersRequest = view === "transfersRequest" || newOrderModel?.newView === "transfersRequest";
            if (newOrderModel.DocType === 'I' && (newOrderModel.isSalesDocument)) {
                newItemModel.OcrCode = newOrderModel.Dimension1 || ''; // Determinado por el newOrderModel.GroupCode
                newItemModel.Dimension1 = newItemModel.OcrCode ? true : false;

                try {
                    enableSpinner(true);
                    const data = {
                        Type: 6,
                        filter1: newItemModel.WhsCode || '',
                        filter2: newItemModel.ItemCode || '',
                    };
                    const apiResponse = await apiClient.getDimensions(data);
                    enableSpinner(false);

                    if (apiResponse?.status === 1) {
                        newItemModel.OcrCode2 = apiResponse?.data?.Dimension2 || ''; // Determinado desde el almacén
                        newItemModel.OcrName2 = isTransfersRequest ? (apiResponse?.data?.Dimension2Name || '') : '';
                        newItemModel.OcrCode3 = apiResponse?.data?.Dimension3 || ''; // Determinado desde el almacén
                        newItemModel.OcrName3 = isTransfersRequest ? (apiResponse?.data?.Dimension3Name || '') : '';
                        newItemModel.OcrCode4 = apiResponse?.data?.Dimension4 || ''; // Determinado desde el artículo
                        newItemModel.OcrName4 = isTransfersRequest ? (apiResponse?.data?.Dimension4Name || '') : '';
                        newItemModel.OcrCode5 = apiResponse?.data?.Dimension5 || ''; // Determinado desde el artículo
                        newItemModel.OcrName5 = isTransfersRequest ? (apiResponse?.data?.Dimension5Name || '') : '';

                        newItemModel.Dimension2 = newItemModel.OcrCode2 ? true : false;
                        newItemModel.Dimension3 = newItemModel.OcrCode3 ? true : false;

                        newItemModel.Dimension4 = newItemModel.OcrCode4 ? true : false;
                        newItemModel.Dimension5 = newItemModel.OcrCode5 ? true : false;
                    }
                } catch (err) { }
            } else if (newOrderModel.DocType === 'I' && (newOrderModel.isPurchaseDocument || isTransfersEntry || isTransfersOutput || newOrderModel?.isTransferDocument)) {
                enableSpinner(true);
                const data = {
                    Type: 6,
                    filter1: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : newItemModel.WhsCode || '',
                    filter2: newItemModel.ItemCode || '',
                };
                const apiResponse = await apiClient.getDimensions(data);
                enableSpinner(false);

                if (apiResponse?.status === 1) {
                    newItemModel.OcrCode2 = apiResponse?.data?.Dimension2 || ''; // Determinado desde el almacén
                    newItemModel.OcrName2 = isTransfersRequest ? (apiResponse?.data?.Dimension2Name || '') : '';
                    newItemModel.OcrCode3 = apiResponse?.data?.Dimension3 || ''; // Determinado desde el almacén
                    newItemModel.OcrName3 = isTransfersRequest ? (apiResponse?.data?.Dimension3Name || '') : '';
                    newItemModel.OcrCode4 = apiResponse?.data?.Dimension4 || ''; // Determinado desde el artículo
                    newItemModel.OcrName4 = isTransfersRequest ? (apiResponse?.data?.Dimension4Name || '') : '';
                    newItemModel.OcrCode5 = apiResponse?.data?.Dimension5 || ''; // Determinado desde el artículo
                    newItemModel.OcrName5 = isTransfersRequest ? (apiResponse?.data?.Dimension5Name || '') : '';

                    newItemModel.Dimension2 = newItemModel.OcrCode2 ? true : false;
                    newItemModel.Dimension3 = newItemModel.OcrCode3 ? true : false;

                    newItemModel.Dimension4 = newItemModel.OcrCode4 ? true : false;
                    newItemModel.Dimension5 = newItemModel.OcrCode5 ? true : false;
                }
            }
            //#endregion DIMENSIONS

            //#region DETRACCIONES
            if (newOrderModel.isPurchaseDocument && (newOrderModel.DetraccionVista || newOrderModel?.newView === 'PurchaseOrder')) {
                newItemModel.U_RML_AFEDET = item.U_RML_AFEDET || 'N';   // Afecto a Detraccion
                newItemModel.U_RML_CODRET = item.U_RML_CODRET || '';    // Codigo Detraccion / Retención
                newItemModel.U_RML_CODSERV = item.U_RML_CODSERV || '';  // Codigo de Servicio
                newItemModel.U_RML_PORCE = item.U_RML_PORCE || 0;       // Porcentaje Servicio
            }
            //#endregion DETRACCIONES

            // if (newOrderModel?.isPurchaseDocument || (view === 'transfersEntry' || view === 'transfersOutput')) {
            newItemModel.U_RS_GRUPO = item.U_RS_GRUPO || '';
            // }

            if ((view === 'transfersEntry' || view === 'transfersOutput') && newOrderModel?.DocType === 'I' && newOrderModel?.U_RS_TIPOOPER) {
                const U_RS_TIPOOPER = newOrderModel?.U_RS_TIPOOPER;
                const aliasToFind = "U_tipoOpT12";
                const headers = newOrderModel?.userFieldsBody || [];
                const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                if (bodyMatch) {
                    const fieldId = bodyMatch?.header?.FieldID;
                    const options = bodyMatch?.options || [];
                    const allFields = json?.allItemsUserFields || [];
                    const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                    if (foundIndex !== -1) {
                        const fieldNumber = foundIndex + 1;
                        const U_tipoOpT12 = options?.find(option => U_RS_TIPOOPER ? option?.FldValue?.toUpperCase() === U_RS_TIPOOPER : option?.FldValue?.toUpperCase() === U_RS_TIPOOPER || option?.FldValue?.toUpperCase() === null)?.FldValue || '';
                        newItemModel.UserFieldsItem[`userFields${fieldNumber}`] = U_tipoOpT12; // Asignar mismo que el de cabecera
                    }
                }
            }

            newOrderModel.Items.push(newItemModel);
        }

        newOrderModel.searchItem = '';
        this.refreshTotal(newOrderModel);

        setTimeout(() => {
            this.setState({
                items: [],
            });
        }, 100);

        $('#itemsCreate').modal('hide');
    };

    selectItemsEnter = async itemsSelected => {
        await this.SetBillingCatalogs();
        const { newOrderModel, showAlert, view, tools, enableSpinner, selectTable, isDraftOWTQ = false } = this.props;
        const { operationList = [] } = this.state;
        let user = await JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        newOrderModel.UserID = user.USERID;
        let isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;

        if ((!newOrderModel.TaxeDefaultPartner || newOrderModel.TaxeDefaultPartner === '') && this.isMarketingDocument(view)) {
            showAlert({ type: 'error', message: 'El socio no cuenta con indicador de impuestos en su dirección de entrega' }, 5000);
            return;
        }

        let OcrCode4DefaultItems = '';
        if (newOrderModel.Items.length) {
            OcrCode4DefaultItems = newOrderModel.Items[0] ? newOrderModel.Items[0].OcrCode4 : '';
        }

        // let almacen = {
        //     item: itemsSelected[0].ItemCode,
        //     whsCode: whCode || '',
        //     Cascos: true
        // }

        // let AlmacenCascos = [];
        // if (view === 'SalesHelmets' && whCode) {
        //     AlmacenCascos = await apiClient.getWarehouse(almacen);
        //     newOrderModel.CashAcct = AlmacenCascos.data[0].CashAccount || '';
        //     newOrderModel.BpAct = AlmacenCascos.data[0].ControlAccount || '';
        // }
        // let whsCascos = AlmacenCascos.data ? AlmacenCascos.data[0] : null;




        for (let index = 0; index < itemsSelected.length; index++) {
            const item = itemsSelected[index];
            const newItemModel = new NewItem();
            newItemModel.LineNum = newOrderModel.Items.length;
            newItemModel.ItemCode = item.ItemCode;
            newItemModel.ItemName = item.ItemName;
            newItemModel.Description = item.ItemName;
            let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
            // if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
            if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                newItemModel.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                newItemModel.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

            } else {
                newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
            }

            if ((view === "PurchaseOrder" || view === 'PurchaseQuotation' || (view === "PurchaseRequest" && !Sections['HistoricalPrices'])) && Number(item?.Price ?? '0') === 0) {
                showAlert({ type: 'warning', message: 'El artículo ' + item.ItemCode + ' no tiene un precio valido asignado.', timeOut: 5000 });
            }

            // if (view === 'SalesHelmets' && whsCascos) {
            //     newItemModel.AcctCode = whsCascos.AcctCode || '';
            //     newItemModel.AcctCodeName = whsCascos.AcctName || '';
            //     newItemModel.WhsCode = whsCascos.WhsCode;
            //     newItemModel.WhsName = whsCascos.WhsName;
            // }

            newItemModel.newHomePrice = item.Price || 0;
            newItemModel.newPrice = item.Price || 0;
            newItemModel.cHomePrice = item.Price || 0;
            newItemModel.cPrice = item.Price || 0;
            newItemModel.wareHouseStock = item.wareHouses;
            newItemModel.InvntItem = item.InvntItem || '';
            newItemModel.SalUnitMsr = item.SalUnitMsr || '';
            newItemModel.BuyUnitMsr = item.BuyUnitMsr || '';
            newItemModel.InvntryUom = item.InvntryUom;
            newItemModel.OnHand = item.OnHand || 0;
            newItemModel.PricesList = item.itemPrice || [];
            newItemModel.NoPriceList = item.PriceList;
            newItemModel.SalPackUn = item.SalPackUn;
            newItemModel.PurPackUn = item.PurPackUn;
            newItemModel.RevenuesAc = item.RevenuesAc;
            newItemModel.AvgPrice = item.AvgPrice;
            newItemModel.ManBtchNum = item.ManBtchNum;
            newItemModel.UserFieldsItem = JSON.parse(JSON.stringify(newOrderModel.userFieldsItem));
            newItemModel.Weight = item.Weight;
            newItemModel.UomCode = item.UomCode || '';
            newItemModel.measureUnit = measureUnit || 1;
            newItemModel.U_RS_NEGNR = item.U_RS_NEGNR || '';

            if (item.EvalSystem === 'A') {
                newItemModel.EvalSystem = "Promedio móvil";
            } else if (item.EvalSystem === 'B') {
                newItemModel.EvalSystem = "Serie / Lote";
            } else if (item.EvalSystem === 'F') {
                newItemModel.EvalSystem = "FIFO";
            } else if (item.EvalSystem === 'S') {
                newItemModel.EvalSystem = "Estándar";
            }

            //#region CENTROS DE COSTOS 
            //CENTRO DE COSTO 1
            // newItemModel.OcrCode = item.OcrdCode;
            //CENTRO DE COSTO 2
            // newItemModel.OcrCode2 = newOrderModel.OcrCode2;
            //CENTRO DE COSTO 3
            // newItemModel.OcrCode3 = item.OcrCode3;
            //CENTRO DE COSTO 4
            // newItemModel.OcrCode4 = item.OcrCode4;

            // if (newOrderModel?.isPurchaseDocument && newOrderModel?.CostCenter) {
            //     newItemModel.OcrCode5 = newOrderModel?.CostCenter;
            // }

            // CAMPO PARA GASTOS ADMINISTRATIVOS Y GASTOS 
            newItemModel.isTemporary = item.isTemporary || false;
            newItemModel.ParentLineNum = item.ParentLineNum === 0 ? 0 : item.ParentLineNum || null;
            newItemModel.Quantity = item.Quantity || 1;

            //#endregion

            //#region ######################## IVA DEFAULT ################################################
            let taxCode = '';
            let taxRate = '';
            let taxName = '';
            if (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve') {
                taxCode = item.TaxCodeAR;
                taxRate = item.TaxeRate || item.TaxRate;
                taxName = item.TaxName;
            } else {
                taxCode = item.TaxCodeAP;
                taxRate = item.TaxeRateAP || item.TaxRateAP;
                taxName = item.TaxNameAP;
            }

            newItemModel.TaxCode = taxCode || newOrderModel.TaxeDefaultPartner;
            newItemModel.TaxeRate = taxRate || newOrderModel.TaxeRateDefaultPartner;
            newItemModel.TaxeRate = Number(newItemModel?.TaxeRate || 0);
            newItemModel.TaxName = taxName || newOrderModel.TaxNameDefaultPartner;
            //#endregion

            //#region ######################## ALMACEN DEFAULT ############################################


            let projectWhs = user.Branch.ProjectCode || null;

            let userFieldRoute = 27;
            let fieldValue = userFieldRoute !== -1 ? newOrderModel.userFields[`userFields${userFieldRoute + 1}`] : null
            if (newOrderModel?.isSalesDocument && (fieldValue === 'ABS' || fieldValue === 'RUT' || fieldValue === 'RCF' || fieldValue === 'DST')) {
                projectWhs = null;
            }

            if (projectWhs || (!projectWhs && newOrderModel?.CodigoUnidad)) {
                newItemModel.whsSelected = true;
                newItemModel.WhsCode = projectWhs;
                newItemModel.WhsCode = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.WhsCode || '' : projectWhs;

                newItemModel.WhsName = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.WhsName || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].WhsName : '';
                newItemModel.AcctCode = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.AcctCode || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctCode : '';
                newItemModel.AcctCode2 = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.AcctCode2 || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctCode2 : '';
                newItemModel.AcctCodeName = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.AcctCodeName || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctName : '';
                newItemModel.FormatCode = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.FormatCode || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].FormatCode : '';
                newItemModel.FormatCode2 = newOrderModel?.CodigoUnidad ? newOrderModel?.TransportWhs?.FormatCode2 || '' : user.Branch.AccountDefault ? user.Branch.AccountDefault[0].FormatCode2 : '';
                if (newOrderModel.U_TipoSalida !== '' && !newOrderModel?.InventoryAccount?.AcctCode) {
                    let data = {
                        Type: newOrderModel.U_TipoSalida,
                        WhsCode: newItemModel.WhsCode,
                    }

                    let responseGetAcctCode = await apiClient.getAcctCodeType_I_O(data);
                    if (responseGetAcctCode.status === 1) {
                        if (responseGetAcctCode.data[0].AcctCode !== '') {
                            const cuentaOriginal = responseGetAcctCode.data[0].AcctCode;
                            const expresionRegular = /^(\d{7})(\d{2})(\d{2})$/;
                            const resultado = cuentaOriginal.replace(expresionRegular, "$1-$2-$3");
                            newItemModel.FormatCode = resultado;
                            newItemModel.AcctCode = cuentaOriginal;
                        }
                    }
                }

                //#region Cuenta de mayor para OIGN y OIGE
                if (newOrderModel?.InventoryAccount?.AcctCode) {
                    newItemModel.AcctCode = newOrderModel?.InventoryAccount?.AcctCode || '';
                    newItemModel.AcctCodeName = newOrderModel?.InventoryAccount?.AcctName || '';
                    newItemModel.CurrTotal = newOrderModel?.InventoryAccount?.CurrTotal || 0;
                    newItemModel.FormatCode = newOrderModel?.InventoryAccount?.FormatCode || '';
                    newItemModel.AcctCode2 = '';
                    newItemModel.FormatCode2 = '';
                }
                //#endregion Cuenta de mayor para OIGN y OIGE
            }
            let Almacen = item.wareHouses ? item.wareHouses.find((whs) => whs.WhsCode === newItemModel.WhsCode) : '';
            newItemModel.AvgPrice = Almacen ? Almacen.AvgPrice : item.AvgPrice;

            const locationView = ['GoodsReceipt', 'deliveries', 'transfersEntry', 'transfersOutput'];
            if (locationView?.includes(newOrderModel?.newView || view || '')) {
                newItemModel.BinActivat = Almacen?.BinActivat || 'N';
                if ((view === 'deliveries' || newOrderModel?.newView === 'deliveries' || view === 'transfersOutput' || newOrderModel?.newView === 'transfersOutput') && newItemModel?.BinActivat === 'Y') {  // Es para emisión
                    newItemModel.DocumentLinesBinAllocations = Almacen?.Location ?? [];
                }
            }

            // Precio x Kilo - ESTO SOLO ERA PARA SERDI
            // let PriceKilo = await apiClient.getPriceKilo(newItemModel.ItemCode, newItemModel.WhsCode);
            // newItemModel.PrecioXKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(priceDecimalPrecision) : 0;
            // newItemModel.PrecioKilo = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(priceDecimalPrecision) : 0;
            // newItemModel.UserFieldsItem.userFields8 = PriceKilo.data.results ? parseFloat(PriceKilo.data.results[0].Price).toFixed(priceDecimalPrecision) : 0;
            // Precio x Kilo

            //#endregion
            if (view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) {
                let noList = parseInt(newOrderModel.GroupNum);
                noList = (noList === -1 || noList === -2) ? noList + 1 : noList;
                let price = item.itemPrice.filter((item) => item.PriceList === noList) || 0;

                newItemModel.Price = price?.[0]?.Price || 0;
                newItemModel.HomePrice = price?.[0]?.Price || 0;
            }

            if (newOrderModel.AcctCodeDefaultPartner) {
                newItemModel.AcctCode = newOrderModel.AcctCodeDefaultPartner || newItemModel.AcctCode;
                newItemModel.AcctCodeName = newOrderModel.AcctCodeNameDefaultPartner || newItemModel.AcctCodeName;
            }

            if (newOrderModel.CogsAcctDefaultPartner) {
                newItemModel.CogsAcct = newOrderModel.CogsAcctDefaultPartner || newItemModel.CogsAcct;
                newItemModel.CogsAcctName = newOrderModel.CogsAcctNameDefaultPartner || newItemModel.CogsAcctName;
            }


            // Precios de entrada y salida de mercancia (Ultimo precio de compra y ultimo determinado)
            if ((view === 'transfersEntry' || view === 'transfersOutput') && newOrderModel.GroupNum !== '') {
                let numList = parseInt(newOrderModel.GroupNum);
                numList = (numList === -1 || numList === -2) ? numList + 1 : numList;
                for (let i = 0; i < item.itemPrice.length; i++) {
                    let list = item.itemPrice[i].PriceList;
                    if (list == numList) {
                        newItemModel.HomePrice = item.itemPrice[i].Price;
                        newItemModel.Price = item.itemPrice[i].Price;
                    }
                }
            }
            //validate warehoyse stock
            if (newItemModel.InvntItem === 'Y' && (view === 'transfers' || view === 'transfersRequest' || isDraftOWTQ)) {
                for (let index = 0; index < item.wareHouses.length; index++) {
                    const warehouseStock = item.wareHouses[index];
                    if (warehouseStock.WhsCode === newOrderModel.Filler) {
                        newItemModel.FromLocationAssignment = warehouseStock.Location || [];
                        if (warehouseStock.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;

                        } else {
                            newItemModel.stock = true;
                        }
                    }
                    if (newOrderModel.ToWhsCode !== '' && warehouseStock.WhsCode === newOrderModel.ToWhsCode && warehouseStock.BinActivat === 'Y') {
                        let ubication = await apiClient.getPriceKilo(newItemModel.ItemCode, newOrderModel.ToWhsCode);
                        newItemModel.ToLocationAssignment = ubication.data.results ? ubication.data.results : [];
                    }
                }
            } else if (newItemModel.InvntItem === 'Y' && (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve')) {

                for (let index = 0; index < item.wareHouses.length; index++) {
                    const warehouseStock = item.wareHouses[index];
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? newItemModel.SalPackUn : newItemModel.PurPackUn;
                    if (warehouseStock.WhsCode === newItemModel.WhsCode) {
                        newItemModel.OnHand = warehouseStock.OnHand || 0;
                        newItemModel.FromLocationAssignment = warehouseStock.Location || [];
                        if (warehouseStock.OnHand <= 0) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;

                        } else if ((newItemModel.UserBaseUn === 'Y' && newItemModel.Quantity > warehouseStock.OnHand) ||
                            (newItemModel.UserBaseUn === 'N' && (newItemModel.Quantity * measureUnit) > warehouseStock.OnHand)) {
                            showAlert({
                                type: 'warning',
                                message: 'El artículo ' + newItemModel.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                                timeOut: 5000
                            });
                            newItemModel.stock = false;
                        } else {
                            newItemModel.stock = true;
                        }
                    }

                }

            } else if (newItemModel.InvntItem === 'Y' && (newOrderModel.OriginDocumentCreate === "returnRequest" || newOrderModel.OriginDocumentCreate === "return" || newOrderModel.OriginDocumentCreate === "creditNote")) {
                const warehouse = item?.wareHouses?.find(({ WhsCode }) => WhsCode === newItemModel.WhsCode) || null;
                if (warehouse) {
                    if (warehouse.BinActivat === 'Y') {
                        const binsResult = await apiClient.getPriceKilo(newItemModel.ItemCode, newItemModel.WhsCode);
                        newItemModel.ToLocationAssignment = binsResult.data.results ? binsResult.data.results : [];
                    }
                }
            }

            if (item.ItemCode === "DESCUENTO" && (view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseInvoice')) {
                let price = 0;
                for (const cItem of newOrderModel.Items) {
                    price += Number((Number(cItem.Price || 0) * Number(cItem.Quantity || 0) * Number(newOrderModel.U_FMB_DescPP || 0) / 100).toFixed(priceDecimalPrecision));
                }
                newItemModel.HomePrice = price;
                newItemModel.Price = price;
            }

            if (isMarketingDocumentSAP(view)) {
                if (newOrderModel.searchItem == 'CASCOSEARCH' && item?.U_FMB_IS_CILINDRO === '1') {
                    newItemModel.Quantity = newOrderModel.Items[newOrderModel.indexSearch].Quantity;
                    newOrderModel.searchItem = null
                    delete newOrderModel.indexSearch
                }
                newItemModel.Casco = 1;
                newItemModel.U_FMB_CILINDRO = item?.U_FMB_CILINDRO || newItemModel.U_FMB_CILINDRO;
                newItemModel.U_FMB_IS_CILINDRO = item?.U_FMB_IS_CILINDRO || newItemModel.U_FMB_IS_CILINDRO;

            }
            newItemModel.TaxStatus = newItemModel.TaxCode === 'EXO' ? 'N' : item.VATLiable || 'N'

            //#region ########## DEFAULT TAXCODE ITEM ##########
            newItemModel.ItemTaxCodeName = item.ItemTaxCodeName
            newItemModel.ItemTaxCode = item.ItemTaxCode
            newItemModel.ItemRate = item.ItemRate
            //#endregion ########## DEFAULT TAXCODE ITEM ##########

            //#region Codigos de afectación
            let isIGV = !newItemModel?.TaxCode?.includes("EXO") && (newItemModel?.TaxCode?.includes("IGV") || newItemModel?.TaxName?.toUpperCase()?.includes("IGV"));
            let isEXO = newItemModel?.TaxCode?.includes("EXO") || newItemModel?.TaxName?.toUpperCase()?.includes("EXO") || newItemModel?.TaxName?.toUpperCase()?.includes("EXENTO");
            if ((newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument) && (isIGV || isEXO)) {
                newItemModel.U_BPP_OPER = operationList?.find(oper => isIGV ? oper?.Name?.toUpperCase() === 'AFECTA' : oper?.Name?.toUpperCase() === 'GRATUITA')?.Code || '-'; // Tipo de Operación
                let auxCode = null;
                if (isEXO && newItemModel?.U_BPP_OPER === 'G') { // Al ser exento el Código de Afectación debe de ser 15
                    auxCode = 15;
                }
                const newOperation = await this.setItemIgvOptions(newItemModel, auxCode);
                newItemModel.U_STR_FECodAfect = newOperation?.U_STR_FECodAfect || ''; // Código de Afectación IGV
                newItemModel.TaxStatus = isIGV ? 'Y' : 'N'; // Sólo Impuesto

                //#region Tipo de operacion
                const aliasToFind = "U_tipoOpT12";
                const headers = newOrderModel?.userFieldsBody || [];
                const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                if (bodyMatch) {
                    const fieldId = bodyMatch?.header?.FieldID;
                    const options = bodyMatch?.options || [];
                    const allFields = json?.allItemsUserFields || [];
                    const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                    if (foundIndex !== -1) {
                        const fieldNumber = foundIndex + 1;
                        const U_tipoOpT12 = options?.find(option => newOrderModel?.isSalesDocument ? option?.Descr?.toUpperCase() === 'VENTA NACIONAL' : option?.Descr?.toUpperCase() === 'COMPRA NACIONAL')?.FldValue || '';

                        if (U_tipoOpT12) {
                            newItemModel.UserFieldsItem[`userFields${fieldNumber}`] = U_tipoOpT12; // Asignar por defecto
                        }
                    }
                }
                //#endregion Tipo de operacion
            }
            //#endregion Codigos de afectación

            newItemModel.ItmsGrpCod = item.ItmsGrpCod;

            let checkPrice = false;
            //#region Precio Llamagas
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
            if ((newOrderModel?.isSalesDocument)) {
                let searchItem = newItemModel?.ItemCode;
                const envasado = Envasados?.includes(Number(newItemModel?.ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(newItemModel?.ItmsGrpCod));

                if (!newItemModel?.isTemporary && (envasado || glpGranel)) {
                    if (newOrderModel?.isSalesDocument) {
                        if (!newItemModel?.WhsCode) {
                            showAlert({ type: 'warning', message: `Es necesario seleccionar el almacén del artículo ${newItemModel?.ItemCode || newItemModel.ItemName} para obtener su precio`, timeOut: 5000 });
                            // continue;
                        }
                    } else if (newOrderModel?.isTransferDocument) {
                        if (!newOrderModel?.Filler) {
                            showAlert({ type: 'warning', message: `Es necesario seleccionar el almacén origen para obtener el precio del artículo ${newItemModel?.ItemCode || newItemModel.ItemName}`, timeOut: 5000 });
                            // continue;
                        }
                    }
                    let getItemResponse = null;
                    const newView = newOrderModel?.newView || view;
                    let table = selectTable(newView);
                    let data = {
                        CardCode: newOrderModel?.CardCode || "",
                        ItemCode: searchItem || "",
                        WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : newItemModel?.WhsCode || '',
                        ShipToCode: newOrderModel?.ShipToCode || "",
                        userFields: newOrderModel?.userFields || {},
                        Quantity: newItemModel?.Quantity || 0,
                        U_RS_CANTG: newItemModel?.U_RS_CANTG || 0,
                        U_RS_UMED: newItemModel?.U_RS_UMED || "",
                        U_RS_PRECIOGL: newItemModel?.U_RS_PRECIOGL || 0,
                        gallonsPrice: true,
                        DocDueDate: newOrderModel?.DocDueDate,
                        TaxDate: newOrderModel?.TaxDate,
                        ObjType: table?.docType,
                    };

                    //#region GALLON PRICE
                    enableSpinner(true);
                    let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);
                    const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                    data.U_RS_PRECIOGL = U_RS_PRECIO;
                    data.gallonsPrice = false;
                    //#endregion GALLON PRICE

                    enableSpinner(true);
                    if ((newOrderModel?.isSalesDocument && newItemModel?.WhsCode) || (newOrderModel?.isTransferDocument && newOrderModel?.Filler)) {
                        getItemResponse = await apiClient.getPriceListLlama(data);
                    }
                    enableSpinner(false);

                    const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                    const item = newItemModel || {};
                    item.Price = U_RS_CALCULADO;
                    checkPrice = true;

                    if (glpGranel) {
                        newItemModel.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0).toFixed(priceDecimalPrecision));
                        newItemModel.U_RS_TOTALGL = Number((Number(newItemModel?.U_RS_PRECIOGL || 0) * Number(newItemModel?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                    }

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newItemModel.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newItemModel.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                    } else {
                        newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newItemModel.newHomePrice = item.Price || 0;
                    newItemModel.newPrice = item.Price || 0;
                    newItemModel.cHomePrice = item.Price || 0;
                    newItemModel.cPrice = item.Price || 0;

                    if (getItemResponse?.status === 1) {
                        showAlert({ type: 'info', message: `El precio del artículo ${newItemModel.ItemCode || newItemModel.ItemName} ha sido ajustado por el grupo de artículos al que pertenece`, timeOut: 5000 });
                    } else if (newItemModel?.WhsCode) {
                        showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode, timeOut: 5000 });
                    }
                }
            }
            //#endregion Precio Llamagas

            //#region Precio Historico Llamagas
            if (Sections['HistoricalPrices'] && isOPRQ) { // Solo aplica para solicitud de compra
                if (!newItemModel?.isTemporary) {
                    let getItemResponse = null;
                    let ItemCode = newItemModel?.ItemCode;
                    const localCurrency = CURRENCY;
                    const Currency = newItemModel?.Currency || localCurrency;
                    const WhsCode = newItemModel?.WhsCode || '';
                    let data = {
                        ItemCode,
                        WhsCode,
                        Currency
                    };

                    enableSpinner(true);
                    if (ItemCode) {
                        getItemResponse = await apiClient.getHistoricalPriceListLlama(data);
                    }
                    enableSpinner(false);

                    const historicalPrice = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.historicalPrice || 0) : 0;
                    const item = newItemModel || {};
                    item.Price = historicalPrice;
                    item.hasHistoricalPrice = Number(historicalPrice) > 0;
                    checkPrice = true;

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newItemModel.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newItemModel.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    } else {
                        newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newItemModel.newHomePrice = item.Price || 0;
                    newItemModel.newPrice = item.Price || 0;
                    newItemModel.cHomePrice = item.Price || 0;
                    newItemModel.cPrice = item.Price || 0;
                }
            }
            //#endregion Precio Historico Llamagas

            //#region GALLONS CONVERSION
            newItemModel.U_RS_UMED = item.U_RS_UMED || '';
            newItemModel.U_RS_CANTG = Number(item.U_RS_CANTG || 0);
            newItemModel.U_RS_PRECIOGL = checkPrice ? Number(newItemModel.U_RS_PRECIOGL || 0) : Number(item.U_RS_PRECIOGL || 0);
            if (development && !newItemModel?.U_RS_PRECIOGL) { // Temporal en lo que dicen como determinar el Precio Galones
                newItemModel.U_RS_PRECIOGL = 100;
            }
            newItemModel.U_RS_TOTALGL = Number(item.U_RS_TOTALGL || 0);
            newItemModel.U_RS_DENS = Number(item.U_RS_DENS || 0);
            try {
                if (((!newOrderModel?.isTransferDocument && newItemModel?.WhsCode) || (newOrderModel?.isTransferDocument && newOrderModel?.Filler)) && Granel?.includes(Number(newItemModel?.ItmsGrpCod))) {
                    enableSpinner(true);
                    const data = {
                        WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler : newItemModel?.WhsCode,
                    };
                    const apiResponse = await apiClient.getFactorConversion(data);
                    enableSpinner(false);

                    if (apiResponse?.status === 1) {
                        newItemModel.U_RS_DENS = Number(apiResponse?.data?.U_FMB_Factor_Conversion || 0);
                    }
                }
            } catch (err) { }
            newItemModel.Gallons = item.Gallons || 0;
            //#endregion GALLONS CONVERSION

            //#region DIMENSIONS
            const isTransfersEntry = view === "transfersEntry" || newOrderModel?.newView === "transfersEntry";
            const isTransfersOutput = view === "transfersOutput" || newOrderModel?.newView === "transfersOutput";
            const isTransfersRequest = view === "transfersRequest" || newOrderModel?.newView === "transfersRequest";
            if (newOrderModel.DocType === 'I' && newOrderModel.isSalesDocument) {
                newItemModel.OcrCode = newOrderModel.Dimension1 || ''; // Determinado por el newOrderModel.GroupCode
                newItemModel.Dimension1 = newItemModel.OcrCode ? true : false;

                try {
                    enableSpinner(true);
                    const data = {
                        Type: 6,
                        filter1: newItemModel.WhsCode || '',
                        filter2: newItemModel.ItemCode || '',
                    };
                    const apiResponse = await apiClient.getDimensions(data);
                    enableSpinner(false);

                    if (apiResponse?.status === 1) {
                        newItemModel.OcrCode2 = apiResponse?.data?.Dimension2 || ''; // Determinado desde el almacén
                        newItemModel.OcrName2 = isTransfersRequest ? (apiResponse?.data?.Dimension2Name || '') : '';
                        newItemModel.OcrCode3 = apiResponse?.data?.Dimension3 || ''; // Determinado desde el almacén
                        newItemModel.OcrName3 = isTransfersRequest ? (apiResponse?.data?.Dimension3Name || '') : '';
                        newItemModel.OcrCode4 = apiResponse?.data?.Dimension4 || ''; // Determinado desde el artículo
                        newItemModel.OcrName4 = isTransfersRequest ? (apiResponse?.data?.Dimension4Name || '') : '';
                        newItemModel.OcrCode5 = apiResponse?.data?.Dimension5 || ''; // Determinado desde el artículo
                        newItemModel.OcrName5 = isTransfersRequest ? (apiResponse?.data?.Dimension5Name || '') : '';

                        newItemModel.Dimension2 = newItemModel.OcrCode2 ? true : false;
                        newItemModel.Dimension3 = newItemModel.OcrCode3 ? true : false;
                        newItemModel.Dimension4 = newItemModel.OcrCode4 ? true : false;
                        newItemModel.Dimension5 = newItemModel.OcrCode5 ? true : false;
                    }
                } catch (err) { }
            } else if (newOrderModel.DocType === 'I' && (newOrderModel.isPurchaseDocument || isTransfersEntry || isTransfersOutput || newOrderModel?.isTransferDocument)) {
                enableSpinner(true);
                const data = {
                    Type: 6,
                    filter1: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : newItemModel.WhsCode || '',
                    filter2: newItemModel.ItemCode || '',
                };
                const apiResponse = await apiClient.getDimensions(data);
                enableSpinner(false);

                if (apiResponse?.status === 1) {
                    newItemModel.OcrCode2 = apiResponse?.data?.Dimension2 || ''; // Determinado desde el almacén
                    newItemModel.OcrName2 = isTransfersRequest ? (apiResponse?.data?.Dimension2Name || '') : '';
                    newItemModel.OcrCode3 = apiResponse?.data?.Dimension3 || ''; // Determinado desde el almacén
                    newItemModel.OcrName3 = isTransfersRequest ? (apiResponse?.data?.Dimension3Name || '') : '';
                    newItemModel.OcrCode4 = apiResponse?.data?.Dimension4 || ''; // Determinado desde el artículo
                    newItemModel.OcrName4 = isTransfersRequest ? (apiResponse?.data?.Dimension4Name || '') : '';
                    newItemModel.OcrCode5 = apiResponse?.data?.Dimension5 || ''; // Determinado desde el artículo
                    newItemModel.OcrName5 = isTransfersRequest ? (apiResponse?.data?.Dimension5Name || '') : '';

                    newItemModel.Dimension2 = newItemModel.OcrCode2 ? true : false;
                    newItemModel.Dimension3 = newItemModel.OcrCode3 ? true : false;

                    newItemModel.Dimension4 = newItemModel.OcrCode4 ? true : false;
                    newItemModel.Dimension5 = newItemModel.OcrCode5 ? true : false;
                }
            }
            //#endregion DIMENSIONS

            //#region DETRACCIONES
            if (newOrderModel.isPurchaseDocument && (newOrderModel.DetraccionVista || newOrderModel?.newView === 'PurchaseOrder')) {
                newItemModel.U_RML_AFEDET = item.U_RML_AFEDET || 'N';   // Afecto a Detraccion
                newItemModel.U_RML_CODRET = item.U_RML_CODRET || '';    // Codigo Detraccion / Retención
                newItemModel.U_RML_CODSERV = item.U_RML_CODSERV || '';  // Codigo de Servicio
                newItemModel.U_RML_PORCE = item.U_RML_PORCE || 0;       // Porcentaje Servicio
            }
            //#endregion DETRACCIONES

            // if (newOrderModel?.isPurchaseDocument || (view === 'transfersEntry' || view === 'transfersOutput')) {
            newItemModel.U_RS_GRUPO = item.U_RS_GRUPO || '';
            // }

            if ((view === 'transfersEntry' || view === 'transfersOutput') && newOrderModel?.DocType === 'I' && newOrderModel?.U_RS_TIPOOPER) {
                const U_RS_TIPOOPER = newOrderModel?.U_RS_TIPOOPER;
                const aliasToFind = "U_tipoOpT12";
                const headers = newOrderModel?.userFieldsBody || [];
                const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                if (bodyMatch) {
                    const fieldId = bodyMatch?.header?.FieldID;
                    const options = bodyMatch?.options || [];
                    const allFields = json?.allItemsUserFields || [];
                    const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                    if (foundIndex !== -1) {
                        const fieldNumber = foundIndex + 1;
                        const U_tipoOpT12 = options?.find(option => U_RS_TIPOOPER ? option?.FldValue?.toUpperCase() === U_RS_TIPOOPER : option?.FldValue?.toUpperCase() === U_RS_TIPOOPER || option?.FldValue?.toUpperCase() === null)?.FldValue || '';
                        newItemModel.UserFieldsItem[`userFields${fieldNumber}`] = U_tipoOpT12; // Asignar mismo que el de cabecera
                    }
                }
            }

            newOrderModel.Items.push(newItemModel);
        }

        newOrderModel.searchItem = '';

        setCascosOrder({ newOrderModel })

        await this.refreshTotal(newOrderModel);
        setTimeout(() => {
            this.setState({
                items: [],
            });
        }, 100);

    };

    checkItemPrices = async (changeDireciton = false, changePartner = false, changeTypeofSell = false, flagU_FMB_AttentionType = false, U_FMB_AttentionType = '', flagU_RS_TIPOV = false, U_RS_TIPOV = '', changeDate = false, DocDueDate = '', TaxDate = '', auxNewOrderModel = {}) => {
        const { showAlert, view, enableSpinner, getUserFieldHeaderValue, selectTable } = this.props;
        let { newOrderModel } = this.props;
        let specialPrice = false;

        if (auxNewOrderModel && Object.keys(auxNewOrderModel)?.length > 0) { // Si tiene alguna propiedad entonces es por que aplico a a consultar precios especiales
            newOrderModel = auxNewOrderModel;
            specialPrice = true;
        }
        let checkPrice = false;
        if (!newOrderModel?.CardCode) {
            return;
        }
        U_FMB_AttentionType = flagU_FMB_AttentionType ? U_FMB_AttentionType : getUserFieldHeaderValue('U_FMB_AttentionType', newOrderModel);
        U_RS_TIPOV = flagU_RS_TIPOV ? U_RS_TIPOV : getUserFieldHeaderValue('U_RS_TIPOV', newOrderModel);
        for (let index = 0; index < newOrderModel?.Items?.length; index++) {
            let newItemModel = newOrderModel?.Items[index];
            let searchItem = newItemModel?.ItemCode;
            const envasado = Envasados?.includes(Number(newItemModel?.ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(newItemModel?.ItmsGrpCod));

            if (newItemModel?.isTemporary || !searchItem || (!envasado && !glpGranel)) {
                continue;
            }

            if (newOrderModel?.isSalesDocument) {
                if (!newItemModel?.WhsCode) {
                    showAlert({ type: 'warning', message: `Es necesario seleccionar el almacén del artículo ${newItemModel?.ItemCode || newItemModel.ItemName} para obtener su precio`, timeOut: 5000 });
                    continue;
                }
            } else if (newOrderModel?.isTransferDocument) {
                if (true) { // Se coloco esto por reversa de listas de precios llamagas en transferencias 
                    continue;
                }
                if (!newOrderModel?.Filler) {
                    showAlert({ type: 'warning', message: `Es necesario seleccionar el almacén origen para obtener el precio del artículo ${newItemModel?.ItemCode || newItemModel.ItemName}`, timeOut: 5000 });
                    continue;
                }
            }

            DocDueDate = changeDate ? DocDueDate : newOrderModel?.DocDueDate;
            TaxDate = changeDate ? TaxDate : newOrderModel?.TaxDate;
            const newView = newOrderModel?.newView || view;
            let table = selectTable(newView);

            let getItemResponse = null;
            let data = {
                CardCode: newOrderModel?.CardCode || "",
                ItemCode: searchItem || "",
                // WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || "" : newItemModel?.WhsCode || "",
                WhsCode: newItemModel?.WhsCode || "",
                ShipToCode: newOrderModel?.ShipToCode || "",
                userFields: newOrderModel?.userFields || {},
                Quantity: newItemModel?.Quantity || 0,
                U_RS_CANTG: newItemModel?.U_RS_CANTG || 0,
                U_RS_UMED: newItemModel?.U_RS_UMED || "",
                U_RS_PRECIOGL: newItemModel?.U_RS_PRECIOGL || 0,
                gallonsPrice: true,
                DocDueDate,
                TaxDate,
                ObjType: table?.docType,
            };

            //#region GALLON PRICE
            enableSpinner(true);
            let getItemGallonResponse = await apiClient.getPriceListLlama(data);
            enableSpinner(false);
            const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
            data.U_RS_PRECIOGL = U_RS_PRECIO;
            data.gallonsPrice = false;
            //#endregion GALLON PRICE

            enableSpinner(true);
            getItemResponse = await apiClient.getPriceListLlama(data);
            enableSpinner(false);

            const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
            const item = newItemModel || {};
            item.Price = U_RS_CALCULADO;
            checkPrice = true;

            if (glpGranel) {
                newItemModel.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0).toFixed(priceDecimalPrecision));
                newItemModel.U_RS_TOTALGL = Number((Number(newItemModel?.U_RS_PRECIOGL || 0) * Number(newItemModel?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
            }

            let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
            // if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
            if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                newItemModel.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                newItemModel.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

            } else {
                newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
            }

            newItemModel.newHomePrice = item.Price || 0;
            newItemModel.newPrice = item.Price || 0;
            newItemModel.cHomePrice = item.Price || 0;
            newItemModel.cPrice = item.Price || 0;
            if (glpGranel && newItemModel?.U_RS_UMED === 'GLN' && Number(newItemModel?.U_RS_CANTG) > 0) {
                newItemModel = await this.checkGallons(newItemModel, index, newOrderModel)
            } else {
                if (getItemResponse?.status === 1) {
                    showAlert({ type: 'info', message: `El precio del artículo ${searchItem || newItemModel?.ItemName || ''} ha sido ajustado al cambiar ${changeDireciton ? 'la dirección' : changePartner ? 'de socio' : changeTypeofSell ? 'el Tipo de Venta' : changeDate ? 'la fecha' : 'el Tipo de Atención'}.`, timeOut: 5000 });
                } else {
                    showAlert({ type: 'error', message: `No se pudo determinar el precio del artículo ${searchItem || newItemModel?.ItemName || ''} al cambiar ${changeDireciton ? 'la dirección' : changePartner ? 'de socio' : changeTypeofSell ? 'el Tipo de Venta' : changeDate ? 'la fecha' : 'el Tipo de Atención'}.`, timeOut: 5000 });
                }
            }
        }
        if (checkPrice || specialPrice) {
            await this.refreshTotal(newOrderModel);
        }
    }

    selectBinLocation = (value) => {
        const { newOrderModel } = this.props
        $("#sucursalLocationsModal").modal("hide");
        this.setState({
            listBinLocations: [],
            showBinLocationsModal: false,
        })
        newOrderModel.U_FMB_ID_RUTA = value?.CodigoAutotransporte ?? null;
        newOrderModel.U_AbsEntry = value?.AbsEntry ?? null;
        newOrderModel.U_FMB_BinLocationTr = value?.BinCode ?? null;

        this.refreshModel(newOrderModel);
        this.fillTransportData();
    }

    calculatePerceptionV1 = (newOrderModel) => {
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            let item = newOrderModel.Items[index];
            if (newOrderModel.U_BPP_BPTD == '6') {
                switch (newOrderModel?.U_STR_AR ?? 'N') {//AGENTE DE RETENCION
                    case 'Y':
                        if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') == 'Y') {//NO SE COBRA PERCEPCION
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate);
                        } else {
                            if ((newOrderModel?.U_STR_AP ?? 'N') == 'Y') {//PERCECION + 5%
                                item.TaxCode = 'IGVPER05'
                                item.TaxName = 'IGV + 0.5%'
                                item.TaxeRate = 18.59
                            } else {//PERCECPION +2%
                                item.TaxCode = 'IGVPER'
                                item.TaxName = 'IGV + 2%'
                                item.TaxeRate = 20.36
                            }
                        }
                        break;
                    case 'N':
                        if ((newOrderModel?.U_STR_AP ?? 'N') == 'Y') {//PERCECION + 5%
                            item.TaxCode = 'IGVPER05'
                            item.TaxName = 'IGV + 0.5%'
                            item.TaxeRate = 18.59
                        } else {//PERCECPION +2%
                            item.TaxCode = 'IGVPER'
                            item.TaxName = 'IGV + 2%'
                            item.TaxeRate = 20.36
                        }
                        break;

                    default:
                        item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode);
                        item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName);
                        item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate);
                        break;
                }
            } else {
                let tempItem = { ...item };
                tempItem.Price = Number(Number(tempItem.HomePrice)).toFixed(priceDecimalPrecision) * (tempItem.BaseQty || 1);
                if (tempItem.Gallons) {
                    tempItem.Price = Number(tempItem.Quantity) > 0 ? Number(Number(tempItem.U_RS_TOTALGL || 0) / Number(tempItem.Quantity)).toFixed(priceDecimalPrecision) : 0;
                }
                let discount = tempItem.Price * tempItem.Quantity * (tempItem.DiscountPercent / 100);
                tempItem.Discount = discount || 0;

                let impuesto = tempItem.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(tempItem.ImpuestoRow / newOrderModel.ChangeRate) : round(parseFloat(((tempItem.Price * tempItem.Quantity - tempItem.Discount)).toFixed(2)) * (tempItem.TaxeRate / 100));
                tempItem.TaxeResult = impuesto.toFixed(2);
                let total = 0;
                total = (tempItem.Price / newOrderModel.ChangeRate) * tempItem.Quantity - (tempItem.Discount / newOrderModel.ChangeRate);
                tempItem.Total = tempItem.ifChangeUomCode ? round(total) : tempItem.LineTotal && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(tempItem.LineTotal / newOrderModel.ChangeRate) : round(total);
                if (this.props.newOrderModel.OriginDocumentCreate && this.props.newOrderModel.OriginDocumentCreate === 'deliveries' && this.props.view === 'invoiceReserve') {
                    tempItem.Total = round(tempItem.LineTotal / newOrderModel.ChangeRate);
                }
                const priceWithTax = (tempItem?.Price || 0) * (1 + ((tempItem?.TaxeRate || 0) / 100))
                tempItem.DiscountedPrice = priceWithTax - ((tempItem?.DiscountPercent || 0) * priceWithTax / 100)
                if (tempItem.Total > 1500) {//PERCECPION +2%
                    item.TaxCode = 'IGVPER'
                    item.TaxName = 'IGV + 2%'
                    item.TaxeRate = 20.36

                } else if (tempItem.Quantity > 2) {//PERCECPION +2%
                    item.TaxCode = 'IGVPER'
                    item.TaxName = 'IGV + 2%'
                    item.TaxeRate = 20.36

                } else {//NO SE COBRA PERCEPCION
                    item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode);
                    item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName);
                    item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate);
                }
            }
        }
        return newOrderModel
    }

    calculatePerceptionV2 = (newOrderModel) => { // VERSION 2
        const { view, action } = this.props
        const { editMode } = this.state
        if (action == 2 && !editMode) {//PERCEPCION SOLO APLICA AL MOMENTO DE CREAR O EDITAR EL DOC
            return newOrderModel
        }
        const isCredit = Number(newOrderModel.GroupNum) != -1

        if (view != 'quotations' && view != 'orderSales' && view != 'deliveries' && view != 'invoice') {//SOLO APLICA PARA VENTAS
            return newOrderModel
        }
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            let item = newOrderModel.Items[index];
            if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) {//PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                if (newOrderModel.U_BPP_BPTD == '6') {
                    switch (newOrderModel?.U_STR_AR ?? 'N') { //AGENTE DE RETENCION
                        case 'Y': //NO SE COBRA PERCEPCION
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                            break;

                        case 'N':
                            if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') == 'Y') { //NO SE COBRA PERCEPCION
                                item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                                item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                                item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);

                            } else {
                                if ((newOrderModel?.U_STR_AP ?? 'N') == 'Y') { //PERCECION + 5%
                                    item.TaxCode = 'IGVPER05';
                                    item.TaxName = 'IGV + 0.5%';
                                    item.TaxeRate = 18.59;

                                } else { //PERCECPION +2%
                                    item.TaxCode = 'IGVPER';
                                    item.TaxName = 'IGV + 2%';
                                    item.TaxeRate = 20.36;
                                }
                            }
                            break;

                        default:
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                            break;
                    }
                } else {
                    let tempItem = { ...item };
                    tempItem.Price = Number(Number(tempItem.HomePrice)).toFixed(priceDecimalPrecision) * (tempItem.BaseQty || 1);
                    if (tempItem.Gallons) {
                        tempItem.Price = Number(tempItem.Quantity) > 0 ? Number(Number(tempItem.U_RS_TOTALGL || 0) / Number(tempItem.Quantity)).toFixed(priceDecimalPrecision) : 0;
                    }
                    let discount = tempItem.Price * tempItem.Quantity * (tempItem.DiscountPercent / 100);
                    tempItem.Discount = discount || 0;

                    let impuesto = tempItem.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(tempItem.ImpuestoRow / newOrderModel.ChangeRate) : round(parseFloat(((tempItem.Price * tempItem.Quantity - tempItem.Discount)).toFixed(2)) * (tempItem.TaxeRate / 100));
                    tempItem.TaxeResult = impuesto.toFixed(2);
                    let total = 0;
                    total = (tempItem.Price / newOrderModel.ChangeRate) * tempItem.Quantity - (tempItem.Discount / newOrderModel.ChangeRate);
                    tempItem.Total = tempItem.ifChangeUomCode ? round(total) : tempItem.LineTotal && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(tempItem.LineTotal / newOrderModel.ChangeRate) : round(total);
                    if (this.props.newOrderModel.OriginDocumentCreate && this.props.newOrderModel.OriginDocumentCreate === 'deliveries' && this.props.view === 'invoiceReserve') {
                        tempItem.Total = round(tempItem.LineTotal / newOrderModel.ChangeRate);
                    }
                    const priceWithTax = (tempItem?.Price || 0) * (1 + ((tempItem?.TaxeRate || 0) / 100))
                    tempItem.DiscountedPrice = priceWithTax - ((tempItem?.DiscountPercent || 0) * priceWithTax / 100)

                    if (Granel?.includes(Number(tempItem?.ItmsGrpCod))) { //GLP GRANEL
                        if (Number(tempItem?.Total) > 1500) { //PERCECPION +2%
                            item.TaxCode = 'IGVPER';
                            item.TaxName = 'IGV + 2%';
                            item.TaxeRate = 20.36;

                        } else { //NO SE COBRA PERCEPCION
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                        }

                    } else if (Number(tempItem?.Quantity) > 2) { //PERCECPION +2%
                        item.TaxCode = 'IGVPER';
                        item.TaxName = 'IGV + 2%';
                        item.TaxeRate = 20.36;

                    } else { //NO SE COBRA PERCEPCION
                        item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                        item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                        item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                    }
                }
                if (isCredit) {
                    //GUARDAMOS EL CALCULO DE PERCEPCION PARA SER COBRADO POSTERIORMENTE
                    item.TaxCodeCredit = item.TaxCode
                    item.TaxNameCredit = item.TaxName
                    item.TaxeRateCredit = item.TaxeRate
                    //COLOCAR EL CODIGO DE IMPUESTO POR DEFECTO
                    item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                    item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                    item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                }
            }
        }
        return newOrderModel
    }

    calculatePerceptionV3 = (newOrderModel) => { // VERSION 3
        const { view, action } = this.props;
        const { editMode } = this.state;
        if (Number(action) === 2 && !editMode) {// PERCEPCION SOLO APLICA AL MOMENTO DE CREAR O EDITAR EL DOC
            return newOrderModel;
        }
        const isCredit = Number(newOrderModel.GroupNum) !== -1;

        if (view !== 'quotations' && view !== 'orderSales' && view !== 'deliveries' && view !== 'invoice') {// SOLO APLICA PARA VENTAS
            return newOrderModel;
        }

        if (isCredit) {
            for (const item of newOrderModel?.Items) {
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                    //GUARDAMOS EL CALCULO DE PERCEPCION PARA SER COBRADO POSTERIORMENTE
                    item.TaxCodeCredit = item.TaxCode;
                    item.TaxNameCredit = item.TaxName;
                    item.TaxeRateCredit = item.TaxeRate;
                    //COLOCAR EL CODIGO DE IMPUESTO POR DEFECTO
                    item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                    item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                    item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                }
            }
        } else if (String(newOrderModel?.U_BPP_BPTD) === '6') { // LADO IZQUIERDO
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                let item = newOrderModel.Items[index];
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                    switch (newOrderModel?.U_STR_AR ?? 'N') { // AGENTE DE RETENCION
                        case 'Y': // NO SE COBRA PERCEPCION
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                            break;

                        case 'N':
                            if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') === 'Y') { // NO SE COBRA PERCEPCION
                                item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                                item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                                item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);

                            } else {
                                if ((newOrderModel?.U_STR_AP ?? 'N') === 'Y') { // PERCEPCION + 0.5%
                                    item.TaxCode = 'IGVPER05';
                                    item.TaxName = 'IGV + 0.5%';
                                    item.TaxeRate = 18.59;

                                } else { // PERCEPCION + 2%
                                    item.TaxCode = 'IGVPER';
                                    item.TaxName = 'IGV + 2%';
                                    item.TaxeRate = 20.36;
                                }
                            }
                            break;

                        default:
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                            break;
                    }
                }
            }
        } else { // LADO DERECHO - Revisar en General
            // VERSION 3.1 - Se comentan estos calculos ya que se utiliza getTotals previo a percepciones, ahi se consulta SumTotalPL y SumQuantitiesP
            /*
            let SumTotal = 0; // Sumatoria de todos los totales de las lineas de GLP
            let SumQuantity = 0; // Sumatoria de todas las cantidades de las lineas que no son GLP

            for (const item of newOrderModel?.Items) {
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                    let tempItem = { ...item };
                    tempItem.Price = Number(Number(tempItem.HomePrice)).toFixed(priceDecimalPrecision) * (tempItem.BaseQty || 1);
                    if (tempItem.Gallons) {
                        tempItem.Price = Number(tempItem.Quantity) > 0 ? Number(Number(tempItem.U_RS_TOTALGL || 0) / Number(tempItem.Quantity)).toFixed(priceDecimalPrecision) : 0;
                    }
                    let discount = tempItem.Price * tempItem.Quantity * (tempItem.DiscountPercent / 100);
                    tempItem.Discount = discount || 0;

                    let impuesto = tempItem.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(tempItem.ImpuestoRow / newOrderModel.ChangeRate) : round(parseFloat(((tempItem.Price * tempItem.Quantity - tempItem.Discount)).toFixed(2)) * (tempItem.TaxeRate / 100));
                    tempItem.TaxeResult = impuesto.toFixed(2);
                    let total = 0;
                    total = (tempItem.Price / newOrderModel.ChangeRate) * tempItem.Quantity - (tempItem.Discount / newOrderModel.ChangeRate);
                    tempItem.Total = tempItem.ifChangeUomCode ? round(total) : tempItem.LineTotal && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(tempItem.LineTotal / newOrderModel.ChangeRate) : round(total);
                    if (this.props.newOrderModel.OriginDocumentCreate && this.props.newOrderModel.OriginDocumentCreate === 'deliveries' && this.props.view === 'invoiceReserve') {
                        tempItem.Total = round(tempItem.LineTotal / newOrderModel.ChangeRate);
                    }
                    const priceWithTax = (tempItem?.Price || 0) * (1 + ((tempItem?.TaxeRate || 0) / 100));
                    tempItem.DiscountedPrice = priceWithTax - ((tempItem?.DiscountPercent || 0) * priceWithTax / 100);

                    if (Granel?.includes(Number(tempItem?.ItmsGrpCod))) { // GLP GRANEL - SUMAR TOTALES
                        SumTotal += Number(tempItem?.Total ?? 0);
                    } else { // NO ES GLP GRANEL - SUMAR CANTIDADES
                        SumQuantity += Number(tempItem?.Quantity ?? 0);
                    }
                }
            }
            */

            for (const item of newOrderModel?.Items) {
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS

                    if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') === 'Y') { // VERSION 3.1 - NO SE COBRA PERCEPCION
                        item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                        item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                        item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);

                    } else if (Granel?.includes(Number(item?.ItmsGrpCod))) { // GLP GRANEL
                        if (Number(newOrderModel?.SumTotalPL) > 1500) { // VERSION 3.1 - PERCEPCION + 2%
                            item.TaxCode = 'IGVPER';
                            item.TaxName = 'IGV + 2%';
                            item.TaxeRate = 20.36;

                        } else { // NO SE COBRA PERCEPCION
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                        }

                    } else if (Number(newOrderModel?.SumQuantitiesP) > 2) { // VERSION 3.1 - PERCEPCION + 2%
                        item.TaxCode = 'IGVPER';
                        item.TaxName = 'IGV + 2%';
                        item.TaxeRate = 20.36;

                    } else { // NO SE COBRA PERCEPCION
                        item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                        item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                        item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                    }
                }
            }
        }
        return newOrderModel;
    }

    calculatePerception = (newOrderModel) => { // VERSION 4 - Si se modifica modificar igual en back
        const { view, action } = this.props;
        const { editMode } = this.state;
        if (Number(action) === 2 && !editMode) {// PERCEPCION SOLO APLICA AL MOMENTO DE CREAR O EDITAR EL DOC
            return newOrderModel;
        }
        const isCredit = Number(newOrderModel?.GroupNum ?? -1) !== -1;

        if (view !== 'quotations' && view !== 'orderSales' && view !== 'deliveries' && view !== 'invoice' && view !== 'invoiceAdvance') {// SOLO APLICA PARA VENTAS
            return newOrderModel;
        }

        if (String(newOrderModel?.U_BPP_BPTD) === '6') { // LADO IZQUIERDO
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                let item = newOrderModel.Items[index];
                const anticipo = isAnticipo(item.ItemCode)//NO HAY FACTURAS DE ANTICIPO A CREDITO
                if (item.isTemporary) continue;
                if (item.TaxCode == 'EXO') continue//EXONERADOS NO APLICAN
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                    switch (newOrderModel?.U_STR_AR ?? 'N') { // AGENTE DE RETENCION
                        case 'Y': // NO SE COBRA PERCEPCION
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                            break;

                        case 'N':
                            if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') === 'Y') { // NO SE COBRA PERCEPCION
                                item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                                item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                                item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);

                            } else {
                                if ((newOrderModel?.U_STR_AP ?? 'N') === 'Y') { // PERCEPCION + 0.5%
                                    item.TaxCode = 'IGVPER05';
                                    item.TaxName = 'IGV + 0.5%';
                                    item.TaxeRate = 18.59;
                                    if (isCredit && !anticipo) {
                                        item.TaxCodeCredit = item.TaxCode;
                                        item.TaxNameCredit = item.TaxName;
                                        item.TaxeRateCredit = item.TaxeRate;
                                        item.TaxCode = 'IGV';
                                        item.TaxName = 'IGV (18%)';
                                        item.TaxeRate = 18;
                                        item.isCreditPerception = true;
                                        item.PerceptionRate = 0.5;
                                    } else {
                                        item.TaxCodeCredit = '';
                                        item.TaxNameCredit = '';
                                        item.TaxeRateCredit = 0;
                                        item.isCreditPerception = false;
                                        item.PerceptionRate = 0;
                                    }

                                } else { // PERCEPCION + 2%
                                    item.TaxCode = 'IGVPER';
                                    item.TaxName = 'IGV + 2%';
                                    item.TaxeRate = 20.36;
                                    if (isCredit && !anticipo) {
                                        item.TaxCodeCredit = item.TaxCode;
                                        item.TaxNameCredit = item.TaxName;
                                        item.TaxeRateCredit = item.TaxeRate;
                                        item.TaxCode = 'IGV';
                                        item.TaxName = 'IGV (18%)';
                                        item.TaxeRate = 18;
                                        item.isCreditPerception = true;
                                        item.PerceptionRate = 2;
                                    } else {
                                        item.TaxCodeCredit = '';
                                        item.TaxNameCredit = '';
                                        item.TaxeRateCredit = 0;
                                        item.isCreditPerception = false;
                                        item.PerceptionRate = 0;
                                    }
                                }
                            }
                            break;

                        default:
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                            break;
                    }
                }
            }
        } else { // LADO DERECHO - Revisar en General
            for (const item of newOrderModel?.Items) {
                const anticipo = isAnticipo(item.ItemCode)//NO HAY FACTURAS DE ANTICIPO A CREDITO
                if (item.isTemporary) continue;
                if (item.TaxCode == 'EXO') continue//EXONERADOS NO APLICAN
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS

                    if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') === 'Y') { // NO SE COBRA PERCEPCION
                        item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                        item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                        item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);

                    } else if (Granel?.includes(Number(item?.ItmsGrpCod))) { // GLP GRANEL
                        if (Number(newOrderModel?.SumTotalPL) > 1500 || Number(newOrderModel?.SumTotalPLCredit) > 1500) { // PERCEPCION + 2%
                            item.TaxCode = 'IGVPER';
                            item.TaxName = 'IGV + 2%';
                            item.TaxeRate = 20.36;
                            if (isCredit && !anticipo) {
                                item.TaxCodeCredit = item.TaxCode;
                                item.TaxNameCredit = item.TaxName;
                                item.TaxeRateCredit = item.TaxeRate;
                                item.TaxCode = 'IGV';
                                item.TaxName = 'IGV (18%)';
                                item.TaxeRate = 18;
                                item.isCreditPerception = true;
                                item.PerceptionRate = 2;
                            } else {
                                item.TaxCodeCredit = '';
                                item.TaxNameCredit = '';
                                item.TaxeRateCredit = 0;
                                item.isCreditPerception = false;
                                item.PerceptionRate = 0;
                            }

                        } else { // NO SE COBRA PERCEPCION
                            item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                            item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                            item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                        }

                    } else if (Number(newOrderModel?.SumQuantitiesP) > 2) { // PERCEPCION + 2%
                        item.TaxCode = 'IGVPER';
                        item.TaxName = 'IGV + 2%';
                        item.TaxeRate = 20.36;
                        if (isCredit && !anticipo) {
                            item.TaxCodeCredit = item.TaxCode;
                            item.TaxNameCredit = item.TaxName;
                            item.TaxeRateCredit = item.TaxeRate;
                            item.TaxCode = 'IGV';
                            item.TaxName = 'IGV (18%)';
                            item.TaxeRate = 18;
                            item.isCreditPerception = true;
                            item.PerceptionRate = 2;
                        } else {
                            item.TaxCodeCredit = '';
                            item.TaxNameCredit = '';
                            item.TaxeRateCredit = 0;
                            item.isCreditPerception = false;
                            item.PerceptionRate = 0;
                        }

                    } else { // NO SE COBRA PERCEPCION
                        item.TaxCode = (item.ItemTaxCode || newOrderModel.TaxCode || item.TaxCode);
                        item.TaxName = (item.ItemTaxCodeName || newOrderModel.TaxName || item.TaxName);
                        item.TaxeRate = (item.ItemRate || newOrderModel.TaxRate || item.TaxeRate);
                    }
                }
            }
        }

        return newOrderModel;
    }

    getTotals = (newOrderModel = {}) => { // Obtener totales por linea y documento con multimonedas
        const { view, action } = this.props;
        const { editMode } = this.state;
        // Si se modifica, modificar igual en back
        const localCurrency = CURRENCY;

        if (!Array.isArray(newOrderModel?.Items) || newOrderModel?.Items?.length === 0) {
            //#region Moneda del documento
            newOrderModel.SubtotalWithoutDiscount = 0;
            newOrderModel.Subtotal = 0;
            newOrderModel.Discount = 0;
            newOrderModel.Taxes = 0;
            newOrderModel.Total = 0;
            newOrderModel.VatSum = 0;
            newOrderModel.DocTotal = 0;
            //#endregion Moneda del documento

            //#region Moneda local
            newOrderModel.SubtotalWithoutDiscountLocal = 0;
            newOrderModel.SubtotalLocal = 0;
            newOrderModel.DiscountLocal = 0;
            newOrderModel.TaxesLocal = 0;
            newOrderModel.TotalLocal = 0;
            newOrderModel.VatSumLocal = 0;
            newOrderModel.DocTotalLocal = 0;
            //#endregion Moneda local

            //#region Perceptions
            newOrderModel.SumTotalPL = 0;
            newOrderModel.SumQuantitiesP = 0;
            //#region CREDIT PERCEPTIONS
            newOrderModel.SumTotalPLCredit = 0;
            newOrderModel.U_STR_FE_Tasa_Percepcion = 0; // Tasa
            newOrderModel.U_BPP_TtPc = 0;  // Total
            //#endregion CREDIT PERCEPTIONS
            //#endregion Perceptions

            newOrderModel.DownPaymentAmount = 0;
            newOrderModel.DpmAmnt = 0;
        } else {
            // ========================
            // CABECERA
            // ========================

            let DocCur = newOrderModel?.DocCur || localCurrency;
            let DocRate = Number(newOrderModel?.ChangeRate) || 1;
            let DocDiscPrcnt = Number(newOrderModel?.DiscountPercent) || 0;

            let Subtotal = 0;
            let SubtotalLocal = 0;
            let Discount = 0;
            let DiscountLocal = 0;
            let Taxes = 0;
            let TaxesLocal = 0;
            let Total = 0;
            let TotalLocal = 0;

            let VatSum = 0;
            let VatSumLocal = 0;
            let DocTotal = 0;
            let DocTotalLocal = 0;
            let WeightTotal = 0;

            let TotalAntesDescuento = 0; // NUEVO control bruto (moneda documento)
            let TotalAntesDescuentoLocal = 0; // NUEVO control bruto (moneda local)

            //#region Perceptions
            let SumTotalPL = 0; // Total de lineas que son GLP (SIEMPRE EN LOCAL)
            let SumQuantitiesP = 0; // Total de en cantidades de envasado
            //#region CREDIT PERCEPTIONS
            let TaxesCredit = 0;
            let TaxesLocalCredit = 0;
            let TotalCredit = 0;
            let TotalLocalCredit = 0;
            let VatSumCredit = 0;
            let VatSumLocalCredit = 0;

            let DocTotalCredit = 0;
            let DocTotalLocalCredit = 0;

            let SumTotalPLCredit = 0; // Total de lineas que son GLP (SIEMPRE EN LOCAL)
            let PerceptionLocalCredit = 0;
            //#endregion CREDIT PERCEPTIONS
            //#endregion Perceptions

            //#region PROCESAR LINEAS
            newOrderModel.Items.forEach(line => {
                const {
                    Currency = DocCur,
                    Quantity = 0,
                    DiscountPercent = 0,
                    TaxOnly = 'N',
                    TaxStatus = 'Y',
                    Gallons = false,
                    ChangeRateCurrency = 1,
                    isTemporary = false,
                } = line || {};

                let {
                    TaxeRate = 0,
                    Weight = 0,
                    ItmsGrpCod = 100,
                    HomePrice = 0,
                    BaseQty = 1,
                    U_RS_TOTALGL = 0,
                    Price = 0,
                    //#region CREDIT PERCEPTIONS
                    TaxeRateCredit = 0,
                    isCreditPerception = false,
                    //#endregion CREDIT PERCEPTIONS
                } = line || {};

                const qty = Number(Quantity) || 0;
                let originalPrice = Number(Price) || 0;
                const lineDiscPrcnt = Number(DiscountPercent) || 0;
                TaxeRate = Number(TaxeRate) || 0;
                Weight = Number(Weight) || 0;
                U_RS_TOTALGL = Number(U_RS_TOTALGL) || 0;
                ItmsGrpCod = Number(ItmsGrpCod) || 100;
                HomePrice = Number(HomePrice) || 0;
                BaseQty = Number(BaseQty) || 1;

                //#region Precio por galones
                // if (Gallons) {
                //     originalPrice = qty > 0 ? roundToDecimals((U_RS_TOTALGL / qty), 6) : 0;
                //     originalPrice = Number(originalPrice) || 0;
                // } else {
                //     originalPrice = roundToDecimals((HomePrice * BaseQty), 6);
                // }
                originalPrice = roundToDecimals((HomePrice * BaseQty), 6);
                line.Price = Number(originalPrice) || 0;
                //#endregion

                const lineCurrency = Currency || localCurrency;

                //#region Convertir SOLO para cálculo
                let priceForCalc = originalPrice;

                const docCurrency = DocCur || localCurrency;
                const lineRate = Number(ChangeRateCurrency) || 1;
                const docRate = Number(DocRate) || 1;
                //#endregion Convertir SOLO para cálculo

                //#region Si moneda de línea es distinta al documento
                if (lineCurrency !== docCurrency) {
                    if (docCurrency === localCurrency) { // Documento en moneda local
                        priceForCalc = originalPrice * lineRate; // Línea extranjera → convertir a local
                    } else { // Documento en moneda extranjera
                        // Convertimos línea a local primero
                        const priceInLocal =
                            lineCurrency === localCurrency ? originalPrice
                                : originalPrice * lineRate;

                        // Luego local → documento
                        priceForCalc = priceInLocal / docRate;
                    }
                }
                // priceForCalc = roundToDecimals(priceForCalc, 6);
                //#endregion Si moneda de línea es distinta al documento

                //#region Descuento línea
                const priceAfterDiscount = priceForCalc * (1 - (lineDiscPrcnt / 100));
                line.Discount = round(originalPrice * (lineDiscPrcnt / 100) * qty); // moneda línea
                line.DiscountDoc = round(priceForCalc * (lineDiscPrcnt / 100) * qty); // moneda documento
                //#endregion Descuento línea

                //#region Precio bruto despues de descuento
                line.DiscountedPrice = round(originalPrice * (1 - (lineDiscPrcnt / 100)) * (1 + (TaxeRate / 100))); // moneda línea
                line.DiscountedPriceDoc = round(priceAfterDiscount * (1 + (TaxeRate / 100))); // moneda documento
                //#region CREDIT PERCEPTIONS
                line.DiscountedPriceCredit = !isCreditPerception ? 0 : round(originalPrice * (1 - (lineDiscPrcnt / 100)) * (1 + (TaxeRateCredit / 100))); // moneda línea
                line.DiscountedPriceDocCredit = !isCreditPerception ? 0 : round(priceAfterDiscount * (1 + (TaxeRateCredit / 100))); // moneda documento
                //#endregion CREDIT PERCEPTIONS
                //#endregion Precio bruto despues de descuento

                //#region Totales línea
                const rawLineTotal = qty * priceAfterDiscount; // Subtotal sin redondear

                // Impuesto calculado sobre valor real
                let rawVat = 0;
                let rawVatCredit = 0;
                let rawPerception = 0; // CREDIT PERCEPTIONS: Only Perception
                if (TaxStatus === 'Y') {
                    rawVat = rawLineTotal * (TaxeRate / 100);
                    //#region PERCEPCION CREDIT
                    if (isCreditPerception) {
                        rawVatCredit = rawLineTotal * (TaxeRateCredit / 100); // CREDIT PERCEPTIONS
                        const perceptionRate = TaxeRateCredit - 18;
                        rawPerception = rawLineTotal * (perceptionRate / 100);
                    }
                    //#endregion PERCEPCION CREDIT
                }

                // Redondeos
                const LineTotal = round(rawLineTotal);
                const lineVatSum = round(rawVat);
                const effectiveLineTotal = TaxOnly === 'Y' ? 0 : LineTotal;
                const GTotal = round(rawLineTotal + rawVat);
                //#region CREDIT PERCEPTIONS
                const lineVatSumCredit = round(rawVatCredit);
                const GTotalCredit = !isCreditPerception ? 0 : round(rawLineTotal + rawVatCredit);
                const perception = round(rawPerception);
                //#endregion CREDIT PERCEPTIONS
                //#endregion Totales línea

                //#region Convertir a moneda local
                let lineVatSumLocal = lineVatSum;
                let GTotalLocal = GTotal;
                //#region CREDIT PERCEPTIONS
                let lineVatSumLocalCredit = lineVatSumCredit;
                let GTotalLocalCredit = GTotalCredit;
                let perceptionLocal = perception;
                //#endregion CREDIT PERCEPTIONS

                if (DocCur !== localCurrency) {
                    lineVatSumLocal = round(lineVatSum * DocRate);
                    GTotalLocal = round(GTotal * DocRate);
                    //#region CREDIT PERCEPTIONS
                    lineVatSumLocalCredit = round(lineVatSumCredit * DocRate);
                    GTotalLocalCredit = round(GTotalCredit * DocRate);
                    perceptionLocal = round(perception * DocRate);
                    //#endregion CREDIT PERCEPTIONS
                }
                //#endregion Convertir a moneda local

                //#region Totales locales adicionales
                let effectiveLineTotalLocal = effectiveLineTotal;

                if (DocCur !== localCurrency) {
                    effectiveLineTotalLocal = round(effectiveLineTotal * DocRate);
                }
                //#endregion Totales locales adicionales

                //#region Acumular Documento
                TotalAntesDescuento += effectiveLineTotal;
                TotalAntesDescuentoLocal += effectiveLineTotalLocal;

                Subtotal += effectiveLineTotal;

                Taxes += lineVatSum;
                TaxesLocal += lineVatSumLocal;
                //#region CREDIT PERCEPTIONS
                TaxesCredit += lineVatSumCredit;
                TaxesLocalCredit += lineVatSumLocalCredit;
                //#endregion CREDIT PERCEPTIONS

                Total += GTotal;
                TotalLocal += GTotalLocal;
                //#region CREDIT PERCEPTIONS
                TotalCredit += GTotalCredit;
                TotalLocalCredit += GTotalLocalCredit;
                //#endregion CREDIT PERCEPTIONS

                VatSum += lineVatSum;
                VatSumLocal += lineVatSumLocal;
                //#region CREDIT PERCEPTIONS
                VatSumCredit += lineVatSumCredit;
                VatSumLocalCredit += lineVatSumLocalCredit;
                //#endregion CREDIT PERCEPTIONS

                DocTotalLocal += GTotalLocal;
                WeightTotal += (Weight * qty);
                //#region CREDIT PERCEPTIONS
                PerceptionLocalCredit += perceptionLocal;
                //#endregion CREDIT PERCEPTIONS
                //#endregion Acumular Documento

                //#region Asignar valores linea
                line.Currency = lineCurrency;

                line.LineTotal = effectiveLineTotal;
                line.Total = effectiveLineTotal;

                line.VatSum = lineVatSum;
                line.TaxeResult = lineVatSum;
                line.VatSumLocal = lineVatSumLocal;

                line.GTotal = GTotal;
                line.GTotalLocal = GTotalLocal;

                //#region CREDIT PERCEPTIONS
                line.VatSumCredit = lineVatSumCredit;
                line.TaxeResultCredit = lineVatSumCredit;
                line.VatSumLocalCredit = lineVatSumLocalCredit;
                line.GTotalCredit = GTotalCredit;
                line.GTotalLocalCredit = GTotalLocalCredit;
                //#endregion CREDIT PERCEPTIONS
                //#endregion Asignar valores linea

                //#region Perceptions
                if (!isTemporary && (Granel?.includes(Number(ItmsGrpCod)) || Envasados?.includes(Number(ItmsGrpCod)))) {
                    if (Granel?.includes(ItmsGrpCod)) { // GLP GRANEL - SUMAR TOTALES DE LA LINEA CON IMPUESTO
                        SumTotalPL += GTotalLocal;
                        SumTotalPLCredit += GTotalLocalCredit;
                    } else { // NO ES GLP GRANEL - SUMAR CANTIDADES
                        SumQuantitiesP += qty;
                    }
                }
                //#endregion Perceptions
            });
            //#endregion PROCESAR LINEAS

            //#region Totales del documento

            //#region Moneda del documento
            let totalAntesDcto = round(TotalAntesDescuento); // Total antes descuento real
            Discount = round(totalAntesDcto * (DocDiscPrcnt / 100));// Descuento cabecera
            Subtotal = round(totalAntesDcto - Discount);

            // Recalcular impuesto después del descuento
            let factorDescuento = totalAntesDcto !== 0 ? (Subtotal / totalAntesDcto) : 1;

            let impuestos = round(VatSum * factorDescuento);
            let total = round(Subtotal + impuestos);

            impuestos = Math.round(impuestos * 100) / 100;
            total = Math.round(total * 100) / 100;
            //#region CREDIT PERCEPTIONS
            let impuestosCredit = round(VatSumCredit * factorDescuento);
            let totalCredit = round(Subtotal + impuestosCredit);

            impuestosCredit = Math.round(impuestosCredit * 100) / 100;
            totalCredit = Math.round(totalCredit * 100) / 100;
            //#endregion CREDIT PERCEPTIONS
            //#endregion Moneda del documento

            //#region Moneda local
            let totalAntesDctoLocal = round(TotalAntesDescuentoLocal);
            DiscountLocal = round(totalAntesDctoLocal * (DocDiscPrcnt / 100));
            SubtotalLocal = round(totalAntesDctoLocal - DiscountLocal);

            let impuestosLocal = round(VatSumLocal * factorDescuento);
            let totalLocal = round(SubtotalLocal + impuestosLocal);

            impuestosLocal = Math.round(impuestosLocal * 100) / 100;
            totalLocal = Math.round(totalLocal * 100) / 100;
            //#region CREDIT PERCEPTIONS
            let impuestosLocalCredit = round(VatSumLocalCredit * factorDescuento);
            let totalLocalCredit = round(SubtotalLocal + impuestosLocalCredit);

            impuestosLocalCredit = Math.round(impuestosLocalCredit * 100) / 100;
            totalLocalCredit = Math.round(totalLocalCredit * 100) / 100;
            //#endregion CREDIT PERCEPTIONS
            //#endregion Moneda local

            //#region Set Model
            //#region Moneda del documento
            newOrderModel.SubtotalWithoutDiscount = Number(totalAntesDcto.toFixed(2));
            newOrderModel.Subtotal = Number(Subtotal.toFixed(2));
            newOrderModel.Discount = Number(Discount.toFixed(2));
            newOrderModel.Taxes = Number(impuestos.toFixed(2));
            newOrderModel.Total = Number(total.toFixed(2));
            newOrderModel.VatSum = newOrderModel.Taxes;
            newOrderModel.DocTotal = newOrderModel.Total;
            //#region CREDIT PERCEPTIONS
            newOrderModel.TaxesCredit = Number(impuestosCredit.toFixed(2));
            newOrderModel.TotalCredit = Number(totalCredit.toFixed(2));
            newOrderModel.VatSumCredit = newOrderModel.TaxesCredit;
            newOrderModel.DocTotalCredit = newOrderModel.TotalCredit;
            //#endregion CREDIT PERCEPTIONS
            //#endregion Moneda del documento

            //#region Moneda local
            newOrderModel.SubtotalWithoutDiscountLocal = Number(totalAntesDctoLocal.toFixed(2));
            newOrderModel.SubtotalLocal = Number(SubtotalLocal.toFixed(2));
            newOrderModel.DiscountLocal = Number(DiscountLocal.toFixed(2));
            newOrderModel.TaxesLocal = Number(impuestosLocal.toFixed(2));
            newOrderModel.TotalLocal = Number(totalLocal.toFixed(2));
            newOrderModel.VatSumLocal = newOrderModel.TaxesLocal;
            newOrderModel.DocTotalLocal = newOrderModel.TotalLocal;
            //#region CREDIT PERCEPTIONS
            newOrderModel.TaxesLocalCredit = Number(impuestosLocalCredit.toFixed(2));
            newOrderModel.TotalLocalCredit = Number(totalLocalCredit.toFixed(2));
            newOrderModel.VatSumLocalCredit = newOrderModel.TaxesLocalCredit;
            newOrderModel.DocTotalLocalCredit = newOrderModel.TotalLocalCredit;
            //#endregion CREDIT PERCEPTIONS
            //#region Moneda local
            //#endregion Set Model

            //#region Otros acumulados
            //#region Perceptions
            newOrderModel.SumTotalPL = SumTotalPL;
            newOrderModel.SumQuantitiesP = SumQuantitiesP;
            //#region CREDIT PERCEPTIONS
            newOrderModel.SumTotalPLCredit = Number(SumTotalPLCredit);

            const PerceptionRate = Number(newOrderModel?.Items?.find(line => line.isCreditPerception)?.PerceptionRate ?? 0);
            newOrderModel.U_STR_FE_Tasa_Percepcion = Number(PerceptionRate) || 0; // VERSION 4: De acuerdo al diagrama solo entra a 1 valor (lado izquierdo o lado derecho)
            newOrderModel.U_BPP_TtPc = Number(action) === 2 && !editMode ? roundToDecimals(newOrderModel.PerceptionValue, 2) : roundToDecimals(PerceptionLocalCredit, 2); // Total de la percepción
            //#endregion CREDIT PERCEPTIONS
            //#endregion Perceptions

            newOrderModel.WeightTotal = round(WeightTotal);
            //#region Otros acumulados

            //#endregion Totales
        }

        return newOrderModel;
    }

    deleteItem = async (indexToDelete) => {
        const { newOrderModel } = this.props;
        let newItems = [];
        let hasBaseEntry = false;
        let flagProm = false;
        if (newOrderModel?.Items?.[indexToDelete]?.U_FMB_IS_CILINDRO === '1') {
            return
        }

        const itemToDelete = newOrderModel.Items[indexToDelete];
        const itemLineNum = Number(itemToDelete.LineNum);
        const isChild = itemToDelete.ParentLineNum !== undefined && itemToDelete.ParentLineNum !== null && itemToDelete.ParentLineNum !== '';

        newOrderModel.Items.map((item, index) => {
            if (indexToDelete !== index) {
                if (item.BaseEntry) {
                    hasBaseEntry = true;
                }

                const isLinkedCil = (item?.U_FMB_IS_CILINDRO ?? '') === '1' && (item?.U_FMB_CILINDRO ?? '') === itemToDelete.ItemCode && itemToDelete.WhsCode === item.WhsCode && itemToDelete.Quantity === item.Quantity;

                if (isLinkedCil) {
                    return null;
                }

                const ln = Number(item.LineNum);
                const parentLn = item.ParentLineNum ?? null;

                if (isChild) {
                    if (ln !== itemLineNum) {
                        newItems.push(item);
                    }
                } else {
                    if (ln === itemLineNum || parentLn === itemLineNum) {
                        return null;
                    }
                    newItems.push(item);
                }
            }
            return null;
        });

        newOrderModel.isSelectTo = hasBaseEntry;
        newOrderModel.Items = newItems;

        if (newOrderModel.Items.length === 0) { this.props.scoopTools.cleanScoopFields() }

        this.refreshModel(newOrderModel);
        setTimeout(() => {
            this.refreshTotal(newOrderModel);
        }, 500);
    };

    deleteService = indexToDelete => {
        const { newOrderModel } = this.props;

        let newItems = [];
        let hasBaseEntry = false;
        newOrderModel.service.map((item, index) => {
            if (indexToDelete != index) {
                if (item.BaseEntry) {
                    hasBaseEntry = true;
                }
                newItems.push(item);
            }
        });

        newOrderModel.isSelectTo = hasBaseEntry;
        newOrderModel.service = newItems;
        this.refreshTotalService(newOrderModel);
    };

    deleteInvoicePayment = indexToDelete => {
        const { newOrderModel } = this.props;

        let newItems = [];

        newOrderModel.ItemsPayments.map((item, index) => {
            if (indexToDelete != index) {
                newItems.push(item);
            }
        });

        newOrderModel.ItemsPayments = newItems;
        this.refreshTotal(newOrderModel);
    };

    changeReqType = async event => {
        const { view } = this.props;
        const { _user } = this.state
        const { newOrderModel } = this.props;
        newOrderModel.ReqType = event.nativeEvent.target.value;
        newOrderModel.Requester = '';
        newOrderModel.ReqName = '';
        newOrderModel.Branch = '';
        newOrderModel.BranchName = '';
        newOrderModel.Department = '';
        newOrderModel.DepartmentName = '';
        newOrderModel.Email = '';
        newOrderModel.CostCenter = '';

        // if (view !== 'PurchaseRequest') {
        if (!newOrderModel.isPurchaseDocument) {
            newOrderModel.OwnerName = '';
            newOrderModel.OwnerCode = '';
        }

        setTimeout(() => {
            this.setState({
                users: [],
            });
        }, 100);
        await this.refreshModel(newOrderModel);

        if (view === 'PurchaseRequest') {
            this.autoSelectPropietario(_user);
        }

        if (Number(newOrderModel?.ReqType) === 12) { // Si se cambia a usuario, conservar los valores default
            setTimeout(() => {
                this.openPersonRequest(_user?.USERID)
            }, 100);
        }

    };

    autoSelectPropietario = async (userOrModel) => {
        const { view } = this.props;
        const { newOrderModel } = this.props;

        if (view !== 'PurchaseRequest') {
            return;
        }

        try {
            const getOwnersResponse = await apiClient.getOwnersList();

            if (!Array.isArray(getOwnersResponse?.data) || getOwnersResponse.data.length === 0) {
                return;
            }

            const owners = getOwnersResponse.data;
            const requesterCode = String(
                // newOrderModel?.Requester || ''
                newOrderModel?.OwnerCode || ''
            ).trim();

            const userEmail = String(userOrModel?.E_Mail || newOrderModel?.Email || '').trim().toLowerCase();
            let matchedOwner = owners.find(
                owner => String(owner?.empID || '').trim() === requesterCode
            );

            if (!matchedOwner && userEmail) {
                matchedOwner = owners.find(
                    owner => String(owner?.email || '').trim().toLowerCase() === userEmail
                );
            }

            if (matchedOwner) {
                newOrderModel.OwnerName = matchedOwner.NameTitular || '';
                newOrderModel.OwnerCode = matchedOwner.empID || '';
            } else {
                newOrderModel.OwnerName = '';
                newOrderModel.OwnerCode = '';
            }
            this.refreshModel(newOrderModel);
        } catch (error) {
            console.error('[autoSelectPropietario] ERROR al auto-asignar propietario:', error);
        }
    };

    changeNoReferencia = event => {


        const { newOrderModel } = this.props;
        newOrderModel.NumAtCard = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    getPartner = async (value) => {
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;


        let type = 'C'
        if (view == 'PurchaseOrder' || view === 'PurchaseQuotation' || view == 'purchaseReturn' || view === 'GoodsReceipt') {
            type.type = 'S';
        }

        enableSpinner(true);
        let getPartnerResponse = await apiClient.getPartnerListCreateLike(type, value);
        enableSpinner(false);

        if (!Array.isArray(getPartnerResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getPartnerResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        return getPartnerResponse;

    };

    changeCardCode = async (event) => {
        const { newOrderModel } = this.props;
        this.clearSocio(event.nativeEvent.target.name);
        if (event.nativeEvent.data !== '') {
            if (event.nativeEvent.target.name !== 'AgentCode') {
                newOrderModel.CardCode = event.nativeEvent.target.value;
            } else {
                newOrderModel.AgentCode = event.nativeEvent.target.value;
            }
        }
        // this.refreshModel(newOrderModel);
    };

    changeComments = event => {
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;
        let value = event.nativeEvent.target.value
        if (value.length > 250) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida' });
        }
        newOrderModel.Comments = value;
        this.refreshModel(newOrderModel);
    };

    changeCommentsAccount = event => {
        const { newOrderModel } = this.props;
        newOrderModel.CommentsAccount = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeReference = event => {
        const { newOrderModel } = this.props;
        newOrderModel.Ref2 = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changePickMmrk = event => {
        const { newOrderModel } = this.props;
        newOrderModel.PickRmrk = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeCommentsMemo = event => {
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;

        let value = event.nativeEvent.target.value;
        if (value.length > 50) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida' });

        }
        newOrderModel.JrnlMemo = value;
        this.refreshModel(newOrderModel);
    };

    changePagoACuenta = event => {
        const { newOrderModel } = this.props;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                newOrderModel.NoDocSum = event.nativeEvent.target.value;
                // newOrderModel.totalDocumento = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(newOrderModel);
    };

    changeAddress = event => {
        const { newOrderModel } = this.props;
        newOrderModel.Address = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeActiveSendEmail = event => {
        const { newOrderModel } = this.props;
        newOrderModel.Notify = event.target.checked ? 'Y' : 'N';
        this.refreshModel(newOrderModel);
    };

    changeEmail = event => {
        const { newOrderModel } = this.props;
        newOrderModel.Email = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeTransfersRef = event => {
        const { newOrderModel } = this.props;
        newOrderModel.TrsfrRef = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeCashSum = event => {
        const { newOrderModel } = this.props;
        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                newOrderModel.CashSum = event.nativeEvent.target.value;
            }
        }
        this.refreshTotal(newOrderModel);
    };

    changeCashSumEnter = event => {
        const { newOrderModel } = this.props;
        if (!isNaN(newOrderModel.totalPago)) {
            if (newOrderModel.totalPago != ' ') {
                newOrderModel.CashSum = newOrderModel.totalPago;
            }
        }
        this.refreshTotal(newOrderModel);
    };

    validateCashSumNull = index => {
        const { newOrderModel } = this.props;
        let value = newOrderModel.CashSum;

        if (value.length == 0) {
            newOrderModel.CashSum = 0;
        }
        this.refreshTotal(newOrderModel);
    };

    changeTrsfrSum = event => {
        const { newOrderModel } = this.props;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                newOrderModel.TrsfrSum = event.nativeEvent.target.value;
            }
        }
        this.refreshTotal(newOrderModel);
    };

    validateTrsfrSumNull = index => {
        const { newOrderModel } = this.props;
        let value = newOrderModel.TrsfrSum;

        if (value.length == 0) {
            newOrderModel.TrsfrSum = 0;
        }
        this.refreshTotal(newOrderModel);
    };

    changeCounterRef = event => {
        const { newOrderModel } = this.props;
        newOrderModel.CounterRef = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    validateNull = value => {
        if (value === 0) {
            return value;
        }
        if (!value) {
            return "";
        }
        return value;
    };

    setUserFieldValueDefault = (userFields, index, field) => {

        switch (index) {
            case 0:
                userFields.userFields1 = this.validateNull(field.Dflt);
                break;
            case 1:
                userFields.userFields2 = this.validateNull(field.Dflt);
                break;
            case 2:
                userFields.userFields3 = this.validateNull(field.Dflt);
                break;
            case 3:
                userFields.userFields4 = this.validateNull(field.Dflt);
                break;
            case 4:
                userFields.userFields5 = this.validateNull(field.Dflt);
                break;
            case 5:
                userFields.userFields6 = this.validateNull(field.Dflt);
                break;
            case 6:
                userFields.userFields7 = this.validateNull(field.Dflt);
                break;
            case 7:
                userFields.userFields8 = this.validateNull(field.Dflt);
                break;
            case 8:
                userFields.userFields9 = this.validateNull(field.Dflt);
                break;
            case 9:
                userFields.userFields10 = this.validateNull(field.Dflt);
                break;
            case 10:
                userFields.userFields11 = this.validateNull(field.Dflt);
                break;
            case 11:
                userFields.userFields12 = this.validateNull(field.Dflt);
                break;
            case 12:
                userFields.userFields13 = this.validateNull(field.Dflt);
                break;
            case 13:
                userFields.userFields14 = this.validateNull(field.Dflt);
                break;
            case 14:
                userFields.userFields15 = this.validateNull(field.Dflt);
                break;
            case 15:
                userFields.userFields16 = this.validateNull(field.Dflt);
                break;
            case 16:
                userFields.userFields17 = this.validateNull(field.Dflt);
                break;
            case 17:
                userFields.userFields18 = this.validateNull(field.Dflt);
                break;
            case 18:
                userFields.userFields19 = this.validateNull(field.Dflt);
                break;
            case 19:
                userFields.userFields20 = this.validateNull(field.Dflt);
                break;
            case 20:
                userFields.userFields21 = this.validateNull(field.Dflt);
                break;
            case 21:
                userFields.userFields22 = this.validateNull(field.Dflt);
                break;
            case 22:
                userFields.userFields23 = this.validateNull(field.Dflt);
                break;
            case 23:
                userFields.userFields24 = this.validateNull(field.Dflt);
                break;
            case 24:
                userFields.userFields25 = this.validateNull(field.Dflt);
                break;
            case 25:
                userFields.userFields26 = this.validateNull(field.Dflt);
                break;
            case 26:
                userFields.userFields27 = this.validateNull(field.Dflt);
                break;
            case 27:
                userFields.userFields28 = this.validateNull(field.Dflt);
                break;
            case 28:
                userFields.userFields29 = this.validateNull(field.Dflt);
                break;
            case 29:
                userFields.userFields30 = this.validateNull(field.Dflt);
                break;
            case 30:
                userFields.userFields31 = this.validateNull(field.Dflt);
                break;
            case 31:
                userFields.userFields32 = this.validateNull(field.Dflt);
                break;
            case 32:
                userFields.userFields33 = this.validateNull(field.Dflt);
                break;
            case 33:
                userFields.userFields34 = this.validateNull(field.Dflt);
                break;
            case 34:
                userFields.userFields35 = this.validateNull(field.Dflt);
                break;
            case 35:
                userFields.userFields36 = this.validateNull(field.Dflt);
                break;
            case 36:
                userFields.userFields37 = this.validateNull(field.Dflt);
                break;
            case 37:
                userFields.userFields38 = this.validateNull(field.Dflt);
                break;
            case 38:
                userFields.userFields39 = this.validateNull(field.Dflt);
                break;
            case 39:
                userFields.userFields40 = this.validateNull(field.Dflt);
                break;
            case 40:
                userFields.userFields41 = this.validateNull(field.Dflt);
                break;
            case 41:
                userFields.userFields42 = this.validateNull(field.Dflt);
                break;
            case 42:
                userFields.userFields43 = this.validateNull(field.Dflt);
                break;
            case 43:
                userFields.userFields44 = this.validateNull(field.Dflt);
                break;
            case 44:
                userFields.userFields45 = this.validateNull(field.Dflt);
                break;
            case 45:
                userFields.userFields46 = this.validateNull(field.Dflt);
                break;
            case 46:
                userFields.userFields47 = this.validateNull(field.Dflt);
                break;
            case 47:
                userFields.userFields48 = this.validateNull(field.Dflt);
                break;
            case 48:
                userFields.userFields49 = this.validateNull(field.Dflt);
                break;
            case 49:
                userFields.userFields50 = this.validateNull(field.Dflt);
                break;
            case 50:
                userFields.userFields51 = this.validateNull(field.Dflt);
                break;
            case 51:
                userFields.userFields52 = this.validateNull(field.Dflt);
                break;
            case 52:
                userFields.userFields53 = this.validateNull(field.Dflt);
                break;
            case 53:
                userFields.userFields54 = this.validateNull(field.Dflt);
                break;
            case 54:
                userFields.userFields55 = this.validateNull(field.Dflt);
                break;
            case 55:
                userFields.userFields56 = this.validateNull(field.Dflt);
                break;
            case 56:
                userFields.userFields57 = this.validateNull(field.Dflt);
                break;
            case 57:
                userFields.userFields58 = this.validateNull(field.Dflt);
                break;
            case 58:
                userFields.userFields59 = this.validateNull(field.Dflt);
                break;
            case 59:
                userFields.userFields60 = this.validateNull(field.Dflt);
                break;
            case 60:
                userFields.userFields61 = this.validateNull(field.Dflt);
                break;
            case 61:
                userFields.userFields62 = this.validateNull(field.Dflt);
                break;
            case 62:
                userFields.userFields63 = this.validateNull(field.Dflt);
                break;
            case 63:
                userFields.userFields64 = this.validateNull(field.Dflt);
                break;
            case 64:
                userFields.userFields65 = this.validateNull(field.Dflt);
                break;
            case 65:
                userFields.userFields66 = this.validateNull(field.Dflt);
                break;
            case 66:
                userFields.userFields67 = this.validateNull(field.Dflt);
                break;
            case 67:
                userFields.userFields68 = this.validateNull(field.Dflt);
                break;
            case 68:
                userFields.userFields69 = this.validateNull(field.Dflt);
                break;
            case 69:
                userFields.userFields70 = this.validateNull(field.Dflt);
                break;
            case 70:
                userFields.userFields71 = this.validateNull(field.Dflt);
                break;
            case 71:
                userFields.userFields72 = this.validateNull(field.Dflt);
                break;
            case 72:
                userFields.userFields73 = this.validateNull(field.Dflt);
                break;
            case 73:
                userFields.userFields74 = this.validateNull(field.Dflt);
                break;
            case 74:
                userFields.userFields75 = this.validateNull(field.Dflt);
                break;
            case 75:
                userFields.userFields76 = this.validateNull(field.Dflt);
                break;
            case 76:
                userFields.userFields77 = this.validateNull(field.Dflt);
                break;
            case 77:
                userFields.userFields78 = this.validateNull(field.Dflt);
                break;
            case 78:
                userFields.userFields79 = this.validateNull(field.Dflt);
                break;
            case 79:
                userFields.userFields80 = this.validateNull(field.Dflt);
                break;
            case 80:
                userFields.userFields81 = this.validateNull(field.Dflt);
                break;
            case 81:
                userFields.userFields82 = this.validateNull(field.Dflt);
                break;
            case 82:
                userFields.userFields83 = this.validateNull(field.Dflt);
                break;
            case 83:
                userFields.userFields84 = this.validateNull(field.Dflt);
                break;
            case 84:
                userFields.userFields85 = this.validateNull(field.Dflt);
                break;
            case 85:
                userFields.userFields86 = this.validateNull(field.Dflt);
                break;
            case 86:
                userFields.userFields87 = this.validateNull(field.Dflt);
                break;
            case 87:
                userFields.userFields88 = this.validateNull(field.Dflt);
                break;
            case 88:
                userFields.userFields89 = this.validateNull(field.Dflt);
                break;
            case 89:
                userFields.userFields90 = this.validateNull(field.Dflt);
                break;
            case 90:
                userFields.userFields91 = this.validateNull(field.Dflt);
                break;
            case 91:
                userFields.userFields92 = this.validateNull(field.Dflt);
                break;
            case 92:
                userFields.userFields93 = this.validateNull(field.Dflt);
                break;
            case 93:
                userFields.userFields94 = this.validateNull(field.Dflt);
                break;
            case 94:
                userFields.userFields95 = this.validateNull(field.Dflt);
                break;
            case 95:
                userFields.userFields96 = this.validateNull(field.Dflt);
                break;
            case 96:
                userFields.userFields97 = this.validateNull(field.Dflt);
                break;
            case 97:
                userFields.userFields98 = this.validateNull(field.Dflt);
                break;
            case 98:
                userFields.userFields99 = this.validateNull(field.Dflt);
                break;
            case 99:
                userFields.userFields100 = this.validateNull(field.Dflt);
                break;
            case 100:
                userFields.userFields101 = this.validateNull(field.Dflt);
                break;
            case 101:
                userFields.userFields102 = this.validateNull(field.Dflt);
                break;
            case 102:
                userFields.userFields103 = this.validateNull(field.Dflt);
                break;
            case 103:
                userFields.userFields104 = this.validateNull(field.Dflt);
                break;
            case 104:
                userFields.userFields105 = this.validateNull(field.Dflt);
                break;
            case 105:
                userFields.userFields106 = this.validateNull(field.Dflt);
                break;
            case 106:
                userFields.userFields107 = this.validateNull(field.Dflt);
                break;
            case 107:
                userFields.userFields108 = this.validateNull(field.Dflt);
                break;
            case 108:
                userFields.userFields109 = this.validateNull(field.Dflt);
                break;
            case 109:
                userFields.userFields110 = this.validateNull(field.Dflt);
                break;
            case 110:
                userFields.userFields111 = this.validateNull(field.Dflt);
                break;
            case 111:
                userFields.userFields112 = this.validateNull(field.Dflt);
                break;
            case 112:
                userFields.userFields113 = this.validateNull(field.Dflt);
                break;
            case 113:
                userFields.userFields114 = this.validateNull(field.Dflt);
                break;
            case 114:
                userFields.userFields115 = this.validateNull(field.Dflt);
                break;
            case 115:
                userFields.userFields116 = this.validateNull(field.Dflt);
                break;
            case 116:
                userFields.userFields117 = this.validateNull(field.Dflt);
                break;
            case 117:
                userFields.userFields118 = this.validateNull(field.Dflt);
                break;
            case 118:
                userFields.userFields119 = this.validateNull(field.Dflt);
                break;
            case 119:
                userFields.userFields120 = this.validateNull(field.Dflt);
                break;
            case 120:
                userFields.userFields121 = this.validateNull(field.Dflt);
                break;
            case 121:
                userFields.userFields122 = this.validateNull(field.Dflt);
                break;
            case 122:
                userFields.userFields123 = this.validateNull(field.Dflt);
                break;
            case 123:
                userFields.userFields124 = this.validateNull(field.Dflt);
                break;
            case 124:
                userFields.userFields125 = this.validateNull(field.Dflt);
                break;
            case 125:
                userFields.userFields126 = this.validateNull(field.Dflt);
                break;
            case 126:
                userFields.userFields127 = this.validateNull(field.Dflt);
                break;
            case 127:
                userFields.userFields128 = this.validateNull(field.Dflt);
                break;
            case 128:
                userFields.userFields129 = this.validateNull(field.Dflt);
                break;
            case 129:
                userFields.userFields130 = this.validateNull(field.Dflt);
                break;
            case 130:
                userFields.userFields131 = this.validateNull(field.Dflt);
                break;
            default:
                break
        }

        return userFields;
    };
    returnValue = index => {
        const { newOrderModel } = this.props;

        let value = "";
        switch (index) {
            case 0:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields1 : "";
                break;
            case 1:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields2 : "";
                break;
            case 2:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields3 : "";
                break;
            case 3:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields4 : "";
                break;
            case 4:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields5 : "";
                break;
            case 5:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields6 : "";
                break;
            case 6:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields7 : "";
                break;
            case 7:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields8 : "";
                break;
            case 8:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields9 : "";
                break;
            case 9:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields10 : "";
                break;
            case 10:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields11 : "";
                break;
            case 11:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields12 : "";
                break;
            case 12:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields13 : "";
                break;
            case 13:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields14 : "";
                break;
            case 14:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields15 : "";
                break;
            case 15:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields16 : "";
                break;
            case 16:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields17 : "";
                break;
            case 17:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields18 : "";
                break;
            case 18:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields19 : "";
                break;
            case 19:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields20 : "";
                break;
            case 20:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields21 : "";
                break;
            case 21:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields22 : "";
                break;
            case 22:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields23 : "";
                break;
            case 23:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields24 : "";
                break;
            case 24:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields25 : "";
                break;
            case 25:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields26 : "";
                break;
            case 26:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields27 : "";
                break;
            case 27:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields28 : "";
                break;
            case 28:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields29 : "";
                break;
            case 29:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields30 : "";
                break;
            case 30:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields31 : "";
                break;
            case 31:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields32 : "";
                break;
            case 32:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields33 : "";
                break;
            case 33:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields34 : "";
                break;
            case 34:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields35 : "";
                break;
            case 35:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields36 : "";
                break;
            case 36:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields37 : "";
                break;
            case 37:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields38 : "";
                break;
            case 38:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields39 : "";
                break;
            case 39:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields40 : "";
                break;
            case 40:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields41 : "";
                break;
            case 41:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields42 : "";
                break;
            case 42:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields43 : "";
                break;
            case 43:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields44 : "";
                break;
            case 44:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields45 : "";
                break;
            case 45:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields46 : "";
                break;
            case 46:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields47 : "";
                break;
            case 47:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields48 : "";
                break;
            case 48:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields49 : "";
                break;
            case 49:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields50 : "";
                break;
            case 50:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields51 : "";
                break;
            case 51:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields52 : "";
                break;
            case 52:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields53 : "";
                break;
            case 53:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields54 : "";
                break;
            case 54:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields55 : "";
                break;
            case 55:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields56 : "";
                break;
            case 56:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields57 : "";
                break;
            case 57:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields58 : "";
                break;
            case 58:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields59 : "";
                break;
            case 59:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields60 : "";
                break;
            case 60:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields61 : "";
                break;
            case 61:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields62 : "";
                break;
            case 62:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields63 : "";
                break;
            case 63:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields64 : "";
                break;
            case 64:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields65 : "";
                break;
            case 65:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields66 : "";
                break;
            case 66:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields67 : "";
                break;
            case 67:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields68 : "";
                break;
            case 68:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields69 : "";
                break;
            case 69:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields70 : "";
                break;
            case 70:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields71 : "";
                break;
            case 71:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields72 : "";
                break;
            case 72:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields73 : "";
                break;
            case 73:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields74 : "";
                break;
            case 74:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields75 : "";
                break;
            case 75:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields76 : "";
                break;
            case 76:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields77 : "";
                break;
            case 77:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields78 : "";
                break;
            case 78:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields79 : "";
                break;
            case 79:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields80 : "";
                break;
            case 80:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields81 : "";
                break;
            case 81:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields82 : "";
                break;
            case 82:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields83 : "";
                break;
            case 83:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields84 : "";
                break;
            case 84:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields85 : "";
                break;
            case 85:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields86 : "";
                break;
            case 86:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields87 : "";
                break;
            case 87:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields88 : "";
                break;
            case 88:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields89 : "";
                break;
            case 89:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields90 : "";
                break;
            case 90:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields91 : "";
                break;
            case 91:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields92 : "";
                break;
            case 92:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields93 : "";
                break;
            case 93:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields94 : "";
                break;
            case 94:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields95 : "";
                break;
            case 95:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields96 : "";
                break;
            case 96:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields97 : "";
                break;
            case 97:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields98 : "";
                break;
            case 98:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields99 : "";
                break;
            case 99:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields100 : "";
                break;
            case 100:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields101 : "";
                break;
            case 101:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields102 : "";
                break;
            case 102:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields103 : "";
                break;
            case 103:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields104 : "";
                break;
            case 104:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields105 : "";
                break;
            case 105:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields106 : "";
                break;
            case 106:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields107 : "";
                break;
            case 107:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields108 : "";
                break;
            case 108:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields109 : "";
                break;
            case 109:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields110 : "";
                break;
            case 110:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields111 : "";
                break;
            case 111:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields112 : "";
                break;
            case 112:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields113 : "";
                break;
            case 113:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields114 : "";
                break;
            case 114:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields115 : "";
                break;
            case 115:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields116 : "";
                break;
            case 116:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields117 : "";
                break;
            case 117:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields118 : "";
                break;
            case 118:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields119 : "";
                break;
            case 119:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields120 : "";
                break;
            case 120:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields121 : "";
                break;
            case 121:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields122 : "";
                break;
            case 122:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields123 : "";
                break;
            case 123:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields124 : "";
                break;
            case 124:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields125 : "";
                break;
            case 125:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields126 : "";
                break;
            case 126:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields127 : "";
                break;
            case 127:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields128 : "";
                break;
            case 128:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields129 : "";
                break;
            case 129:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields130 : "";
                break;
            case 130:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields131 : "";
                break;
            default:
                break
        }

        return value;
    }
    isValidPaymentFormField = (field) => {
        switch (field) {
            case 'SO1_02FORMAPAGO':
                return true
            case 'SO1_02METODOPAGO':
                return true
            default:
                return false
        }
    }

    isValidDataCFDIField = (field) => {
        switch (field) {
            case 'SO1_02USOCFDI':
                return true
            case 'SO1_02RECREGFISCAL':
                return true
            default:
                return false
        }
    }
    originDocuments = (currentView) => {
        let copyFields = false;
        switch (currentView) {
            case 'orderSales':
            case 'invoice':
            case 'transfersRequest':
                copyFields = true
                break;

            default:
                break;
        }
        return copyFields;
    }
    selectionDocument = (select) => {
        let copyFields = false;
        switch (select) {
            case 'invoice':
            case 'orderSales':
            case 'transfers':
                copyFields = true
                break;

            default:
                break;
        }
        return copyFields;
    }

    selectTo = async event => {
        const { showAlert, newOrderModel, changeDocumentActionModal, view, enableSpinner, selectTable, selectValidateSeries, processUserFields, parseSeries } = this.props;
        let select = event.nativeEvent.target.value;

        let today = moment(new Date()).format('YYYY-MM-DD');
        const fullYear = new Date();
        let month = fullYear.getMonth() < 10 ? `0${fullYear.getMonth() + 1}` : fullYear.getMonth();
        newOrderModel.isSelectToActive = true;

        if (!this.validatePartner() && (select !== 'PurchaseQuotation' && select !== 'PurchaseQuotationDraft' && (view === 'PurchaseRequest' && select !== 'PurchaseOrder'))) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        if (select === 'PurchaseQuotationDraft' && newOrderModel?.OPQTDraft >= 3) {
            showAlert({ type: 'warning', message: "No se pueden crear más de 3 borradores de ofertas de compra para distintos proveedores.", timeOut: 5000 });
            return;
        }
        //#region copy userfields
        let copyUserFields = false
        if (this.selectionDocument(select) && this.originDocuments(view)) {
            copyUserFields = true
        }
        //#region copy userfields


        const commentDocumentorigin = table => {
            let name = '';

            switch (table) {
                case 'orderSales':
                    name = 'orden de venta';
                    break;
                case 'invoice':
                    name = 'factura';
                    break;
                case 'deliveries':
                    name = 'entrega';
                    break;
                case 'return':
                    name = 'devolución';
                    break;
                case 'creditNote':
                    name = 'nota de crédito';
                    break;
                case 'debitNote':
                    name = 'nota de debito';
                    break;
                case 'PurchaseOrder':
                    name = 'orden de compra';
                    break;
                case 'GoodsReceipt':
                    name = 'entrada de mercancía';
                    break;
                case 'SalesHelmets':
                    name = 'entrada de mercancía cascos';
                    break;
                case 'invoiceReserve':
                    name = 'factura de reserva de clientes';
                    break;
                case 'purchaseInvoice':
                    name = 'factura de proveedores';
                    break;
                case 'purchaseCreditNotes':
                    name = 'factura de proveedores';
                    break;
                case 'transfersRequest':
                    name = 'Solicitud de Traslado';
                    break;
                case 'PurchaseRequest':
                    name = 'solicitud de compra';
                    break;
                case 'PurchaseQuotation':
                    name = 'oferta de compra';
                    break;
                case 'PurchaseQuotationDraft':
                    name = 'oferta de compra (borrador)';
                    break;

                default:
                    break;
            }
            return name;
        };

        let newItems = [];
        let newService = [];
        // Limpiar para no llevar el folio de Counter
        newOrderModel.NumAtCard = '';
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            let serviceModel = new NewService();
            if (!item.LineStatus) {
                item.BaseEntry = newOrderModel.DocEntry;
                item.BaseType = newOrderModel.ObjType;
                item.BaseLine = item.LineNum;
                item.LineStatus = false;
                item.RevenuesAc = item.AcctCode || item?.RevenuesAc; // No diga GL Account is missing

                let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;

                if (view === 'transfersRequest') {
                    for (let index = 0; index < newOrderModel.Items.length; index++) {
                        const item = newOrderModel.Items[index];
                        for (let index = 0; index < item.wareHouseStock.length; index++) {
                            const warehouse = item.wareHouseStock[index];
                            if (warehouse.WhsCode === newOrderModel.Filler) {
                                item.FromLocationAssignment = warehouse.Location || [];
                                if (warehouse.OnHand <= 0) {
                                    showAlert({
                                        type: 'warning',
                                        message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado de Origen',
                                        timeOut: 5000
                                    });
                                    item.stock = false;
                                } else {
                                    item.stock = true;
                                }
                            }
                        }
                        const warehouses = item?.wareHouseStock?.find(({ WhsCode }) => WhsCode === item.ToWhsCode) || null;
                        if (warehouses) {
                            if (warehouses.BinActivat === 'Y') {
                                const binsResult = await apiClient.getPriceKilo(item.ItemCode, item.ToWhsCode);

                                const results = binsResult?.data?.results || [];

                                item.FirstBin = results.length === 1 ? results[0].BinCode : '';
                                item.ToLocationAssignment = results;
                            }
                        }
                    }
                } else {
                    for (let index = 0; index < item.wareHouseStock.length; index++) {
                        const warehouseStock = item.wareHouseStock[index];

                        if (warehouseStock.WhsCode.toString() === item.WhsCode.toString()) {
                            item.OnHand = warehouseStock.OnHand || 0;
                            if (warehouseStock.OnHand <= 0 && item.BaseType !== '15') {
                                showAlert({
                                    type: 'warning',
                                    message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                    timeOut: 5000
                                });
                                item.stock = false;

                            } else if (((item.UserBaseUn === 'Y' && item.Quantity > warehouseStock.OnHand) || (item.UserBaseUn === 'N' && (item.Quantity * measureUnit) > warehouseStock.OnHand)) && item.BaseType !== '15') {
                                showAlert({
                                    type: 'warning',
                                    message: 'El artículo ' + item.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                                    timeOut: 5000
                                });
                                item.stock = false;
                            } else {
                                item.stock = true;
                            }
                        }
                    }
                }

                if ((view === 'invoice' && select === 'creditNote') || (view === 'invoiceReserve' && select === 'creditNote')) {
                    item.HomePrice = item.PriceBefDi;
                }

                if (select === 'PurchaseQuotationDraft') { // Al copiar a preliminar de oferta de compra debe nacer con precio en 0
                    item.Price = 0;
                    item.HomePrice = 0;
                    if (item.Currency !== CURRENCY) {
                        item.Price = 0.01;
                        item.HomePrice = 0.01;
                    }
                }

                if (item.UserBaseUn === 'Y') {
                    item.newHomePrice = parseFloat(item.Price).toFixed(2);
                    item.newPrice = parseFloat(item.Price).toFixed(2);
                    item.cHomePrice = parseFloat(item.Price).toFixed(2);
                    item.cPrice = parseFloat(item.Price).toFixed(2);
                } else {
                    item.newHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                    item.newPrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                    item.cHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                    item.cPrice = parseFloat(item.Price).toFixed(2) / measureUnit;

                    if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn') {
                        item.newHomePrice = parseFloat(item.Price).toFixed(2);
                        item.newPrice = parseFloat(item.Price).toFixed(2);
                        item.cHomePrice = parseFloat(item.Price).toFixed(2);
                        item.cPrice = parseFloat(item.Price).toFixed(2);
                    }
                }

                if (select === 'PurchaseQuotationDraft' || select === 'PurchaseOrder') {
                    item.PQTReqQty = Number(item.Quantity || 1);
                }

                item.U_RS_DENS = Number(item.U_RS_DENS || 0);
                try {
                    if ((select === 'transfers') && Granel?.includes(Number(item?.ItmsGrpCod))) { // Se queda solo para traslados: OWTQ a OWTR
                        enableSpinner(true);
                        const data = {
                            WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler : item?.WhsCode,
                        };
                        const apiResponse = await apiClient.getFactorConversion(data);
                        enableSpinner(false);

                        if (apiResponse?.status === 1) {
                            item.U_RS_DENS = Number(apiResponse?.data?.U_FMB_Factor_Conversion || 0);
                        }
                    }
                } catch (err) { }

                newItems.push(item);
                serviceModel.BaseEntry = newOrderModel.DocEntry;
                serviceModel.BaseType = newOrderModel.ObjType;
                serviceModel.BaseLine = item.LineNum;
                serviceModel.LineStatus = false;
                serviceModel.Description = item.Description || '';
                serviceModel.AcctCode = item.AcctCode || '';
                serviceModel.AcctCodeName = item.AcctName || '';
                serviceModel.TaxCode = item.TaxCode || "";
                serviceModel.Price = item.Price || 0;
                serviceModel.HomePrice = item.Price || 0;
                serviceModel.TaxeRate = item.Impuesto || select === 'PurchaseQuotationDraft' ? item.TaxeRate || 0 : 0;
                serviceModel.TaxeResult = item.ImpuestoRow || select === 'PurchaseQuotationDraft' ? item.TaxeResult || 0 : 0;
                serviceModel.NoGlobal = '';
                serviceModel.BaseEntry = item.BaseEntry || '';
                serviceModel.ServiceNew = false;
                serviceModel.Project = item.Project || '';
                serviceModel.OcrCode = item.OcrCode;
                serviceModel.OcrName = "";
                serviceModel.OcrCode2 = item.OcrCode2;
                serviceModel.OcrName2 = "";
                serviceModel.OcrCode3 = item.OcrCode3;
                serviceModel.OcrName3 = "";
                serviceModel.OcrCode4 = item.OcrCode4;
                serviceModel.OcrName4 = "";
                serviceModel.OcrCode5 = item.OcrCode5;
                serviceModel.OcrName5 = "";
                newService.push(serviceModel);
            }
        }
        newOrderModel.Items = newItems;
        newOrderModel.service = newService;

        let comment = ' Basado en ' + commentDocumentorigin(newOrderModel.OriginDocumentCreate) + ' ' + newOrderModel.NextFolio;
        newOrderModel.OriginDocumentCreate = select || '';
        newOrderModel.newView = newOrderModel.OriginDocumentCreate;
        if (view !== 'invoiceReserve' && select === 'deliveries') {//SET VALUE FOR AUTHORIZATION BY LEVEL 1214,1215,1216
            newOrderModel.DeliveryAuthorization = 'I'
        }
        await this.refreshModel(newOrderModel);
        this.refreshTotal(newOrderModel);
        newOrderModel.Comments += comment;
        newOrderModel.isDocumentWithAuthorization = false;
        let table = selectTable(newOrderModel.OriginDocumentCreate);
        let getCuentaBancosResponse = await apiClient.getCurrencies();
        newOrderModel.Currencies = getCuentaBancosResponse.data;

        //cambio de moneda de dolares y detener so el documento no tiene el tipo de cambio

        let currency = newOrderModel.Currencies.filter((currency) => currency.CurrCode === newOrderModel.DocCur);

        if (!currency.length) {
            showAlert({
                type: 'error',
                timeOut: 5000,
                message: "No se a definido el tipo de cambio de la moneda del documento. Para continuar ingrese en SAP el tipo de cambio: " + newOrderModel.DocCur
            })
            return;
        }

        newOrderModel.ChangeRate = currency[0].Rate || 1;


        let dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };

        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let ValidateSeries = selectValidateSeries(table.name, user);

        if (!user || ValidateSeries.series === "") {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "Ocurrió un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            });
            return;
        }

        let seriesUsers = ValidateSeries.series.split("|");


        let newArraySeries = [];

        for (let index = 0; index < seriesUsers.length; index++) {
            const serieUser = seriesUsers[index];
            for (let index = 0; index < seriesResponse.data.length; index++) {
                const serieResponse = seriesResponse.data[index];
                if (String(serieResponse.Series) === String(serieUser) && !newArraySeries.some(item => String(item.Series) === String(serieResponse.Series))) {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }

        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";

        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (newArraySeries.length === 1) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }

        // Código sugerido para serie default
        // if (newArraySeries.length > 0) {
        //     const serie = newArraySeries[0];
        //     defaultName = serie.SeriesName;
        //     defaultcode = serie.Series;
        //     nextNumber = serie.NextNumber
        // }

        newOrderModel.SerieArray = newArraySeries;
        newOrderModel.SerieName = defaultName;
        newOrderModel.SerieCode = defaultcode;
        newOrderModel.NextFolio = nextNumber;
        newOrderModel.StatusDocument = "Abierto";

        //#region ######### USERFIELDS ####################################################

        // let userFieldsService = await apiClient.getUserFields(table);
        // userFieldsService = userFieldsService.data.header || [];
        // let userFields = new UserFields();


        // for (let index = 0; index < json.allUserFields.length; index++) {
        //     const item = json.allUserFields[index];
        //     for (let indexz = 0; indexz < userFieldsService.length; indexz++) {
        //         const userfieldItem = userFieldsService[indexz];
        //         if (Number(item.fieldId) === Number(userfieldItem.header.FieldID)) {
        //             item.name = userfieldItem.header.Descr;
        //             item.fieldType = userfieldItem.options.length !== 0 ? 2 : 1;
        //             item.options = userfieldItem.options;
        //             item.IdValue = index;
        //             let newUserFields = this.setUserFieldValueDefault(userFields, index, newOrderModel.userFields);
        //             if (item.fieldType === 2) {
        //                 item.options.push({ FldValue: "", Descr: "" });
        //             }
        //             userFields = newUserFields;
        //         }
        //     }
        // }
        let userFieldsResponse = await apiClient.getUserFields(table);
        let userFieldsHeader = [];
        let userFieldsBody = [];
        if (userFieldsResponse.status) {
            userFieldsHeader = userFieldsResponse.data.header || [];
            userFieldsBody = userFieldsResponse.data.body || [];
        }
        let userFields = new UserFields();
        // let userFieldsItems = new UserFieldsItem();
        if (view !== 'payment') {
            for (let index = 0; index < json.allUserFields.length; index++) {
                const item = json.allUserFields[index];
                for (let indez = 0; indez < userFieldsHeader.length; indez++) {
                    const userfield = userFieldsHeader[indez];
                    if (item.fieldId === userfield.header.FieldID) {
                        json.allEnableUserFields[index].name = userfield.header.Descr;
                        item.name = userfield.header.Descr;
                        const isInvoice = select === 'invoice';
                        const isCreditNote = select === 'creditNote';
                        const isDebitNote = select === 'debitNote';
                        const isTransfer = select === 'transfers';
                        if (isInvoice || isCreditNote || isDebitNote || isTransfer) {
                            const fieldsSelectList = ["U_BPP_MDTD", "U_BPP_MDSD"];
                            const aliasId = userfield?.header?.AliasID || '';
                            item.fieldType = item.fieldType === 3 || fieldsSelectList.includes(aliasId) || fieldsSelectList.includes(`U_${aliasId}`) ? 3 : userfield.options.length !== 0 ? 2 : 1;
                        } else {
                            item.fieldType = item.fieldType === 3 ? 3 : userfield.options?.length !== 0 ? 2 : 1;
                        }
                        item.options = userfield.options;
                        item.IdValue = index;
                        let newUserFields = this.setUserFieldValueDefault(userFields, index, { ...userfield.header, Dflt: copyUserFields ? this.returnValue(index) : userfield.header.Dflt });
                        if (item.fieldType === 2) {
                            item.options.push({ FldValue: "", Descr: "" });
                        }

                        //#region SERIES Y CORRELATIVOS
                        if (isInvoice || isCreditNote || isDebitNote || isTransfer) { // Validación temporal
                            if (item.fieldId === 1) {//TIPO DE DOCUMENTO
                                let validOptions = [];
                                if (isInvoice) {
                                    validOptions = [
                                        { value: '01', label: 'Factura' },
                                        { value: '03', label: 'Boleta' },
                                    ]
                                } else if (isCreditNote) {
                                    validOptions = [
                                        { value: '07', label: 'Nota de crédito' },
                                    ]
                                } else if (isDebitNote) {
                                    validOptions = [
                                        { value: '08', label: 'Nota de débito' }
                                    ]
                                } else { // Guía
                                    validOptions = [
                                        { value: '09', label: 'Guia' },
                                        { value: 'DI', label: 'Documento Interno' },//AUN NO EXISTE REGISTRO EN DB
                                    ]
                                }
                                item.options = validOptions
                            }
                            if (item.fieldId === 22) {//CORRELATIVO DOCUMENTO
                                //A FUTURO MOSTRAR POSIBLE CORRELATIVO, DE MOMENTO NO ESTAN INDISPENSABLE AL CREAR

                            }
                            if (item.fieldId === 36) {//SERIE DOCUMENTO
                                let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                                let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                                let seriesPuerta = {}
                                let seriesPlanta = {}
                                try {
                                    seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                                } catch (e) {
                                    seriesPuerta = {};
                                }
                                try {
                                    seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                                } catch (e) {
                                    seriesPlanta = {};
                                }
                                const noNeedDefault = isInvoice || isCreditNote || isDebitNote;
                                seriesPuerta = parseSeries(seriesPuerta, noNeedDefault)
                                seriesPlanta = parseSeries(seriesPlanta, noNeedDefault)
                                const isZonal = Number(user?.Branch?.Type) === 1;
                                item.options = (isZonal
                                    ? (Array.isArray(seriesPuerta) ? seriesPuerta : [])
                                    : (Array.isArray(seriesPlanta) ? seriesPlanta : [])
                                )?.filter((option, index, self) =>
                                    index === self?.findIndex(x => x.value === option.value)
                                );
                            }
                        }
                        //#endregion SERIES Y CORRELATIVOS
                        if (view === 'deliveries' && select === 'invoice') {//LLEVAR CAMPOS DE USUARIO PARA FACTURAR AL COPIAR ENTREGA A FACTURA
                            if (this.isValidPaymentFormField(userfield.header.AliasID) || this.isValidDataCFDIField(userfield.header.AliasID)) {
                                newUserFields = this.setUserFieldValueDefault(userFields, index, { Dflt: this.returnValue(index) });
                            }
                        }
                        userFields = newUserFields;
                    }
                }
            }
        } else {
            for (let index = 0; index < json.userFieldsPayment.length; index++) {
                const item = json.userFieldsPayment[index];
                for (let indez = 0; indez < userFieldsHeader.length; indez++) {
                    const userfield = userFieldsHeader[indez];
                    if (item.fieldId === userfield.header.FieldID) {
                        json.allEnableUserFields[index].name = userfield.header.Descr;
                        item.name = userfield.header.Descr;
                        item.fieldType = userfield.options.length != 0 ? 2 : 1;
                        item.options = userfield.options;
                        item.IdValue = index;
                        let newUserFields = this.setUserFieldValueDefault(userFields, index, userfield.header);
                        if (item.fieldType === 2) {
                            item.options.push({ FldValue: "", Descr: "" });
                        }
                        userFields = newUserFields;
                    }
                }
            }
        }
        if (newOrderModel.OriginDocumentCreate !== "PurchaseOrder" && !copyUserFields) { // don't clear user fields when copied to Purchase Order
            newOrderModel.userFields = userFields;
        } else if (copyUserFields && select === 'transfers') {
            const field36 = json.allUserFields.find(f => f.fieldId === 36);
            const key36 = field36 ? `userFields${field36.IdValue + 1}` : 'userFields8';

            const currentVal36 = newOrderModel.userFields?.[key36];
            const tipoDoc = newOrderModel.userFields?.userFields1 || '';

            const isValid36 = field36?.options?.some(opt =>
                opt.value === `${tipoDoc}-${currentVal36}` || opt.value === currentVal36
            );

            newOrderModel.userFields = {
                ...newOrderModel.userFields,
                [key36]: isValid36 ? currentVal36 : '',
            };
        }

        //#region DETRACCIONES
        newOrderModel.U_FMB_BP_Detra = newOrderModel?.WTCodesD?.length || newOrderModel.OU_STR_AfctoDtr === 'Y' ? 'Y' : 'N'; // Al copiar a conservar si tiene detracciones o si el docummento a copiar aplicó a detracción
        newOrderModel.existsDetraccion = ((view === 'PurchaseOrder' && select === 'purchaseInvoice')
            || (view === 'PurchaseOrder' && select === 'GoodsReceipt')
            || (view === 'GoodsReceipt' && select === 'purchaseInvoice')
        ) ? newOrderModel.OU_STR_AfctoDtr === 'Y' : 'N'; // Si se copia de alguna vista valida se conserva el valor, si no no aplica
        //#endregion DETRACCIONES

        // newOrderModel.U_FMB_UUID_RELACIONADO = [newOrderModel.U_UDF_UUID];
        newOrderModel.U_FMB_UUID_RELACIONADO = [newOrderModel.U_UDF_UUID];
        newOrderModel.U_FMB_TIPO_REL = '01';
        newOrderModel.U_UDF_UUID = '';
        newOrderModel.U_FMB_SELLO = '';
        newOrderModel.U_FMB_SERIE = '';
        newOrderModel.U_FMB_FOLIO = '';

        //#endregion

        // CAMPOS FACTURACIÓN
        if (select === 'creditNote' || select === 'debitNote') {
            newOrderModel.U_RML_TDOCORG = newOrderModel.U_RML_TDOCORG || '';
            newOrderModel.U_RML_DOCORG = newOrderModel.U_RML_DOCORG || '';
            newOrderModel.U_BPP_MDTO = newOrderModel.U_BPP_MDTO || '';
            newOrderModel.U_BPP_MDSO = newOrderModel.U_BPP_MDSO || '';
            newOrderModel.U_BPP_MDCO = newOrderModel.U_BPP_MDCO || '';
            newOrderModel.U_BPP_SDocDate = newOrderModel.U_BPP_SDocDate || '';
            newOrderModel.U_RS_SOLAPR = newOrderModel.U_RS_SOLAPR || '';
            newOrderModel.U_STR_MtvoCD = newOrderModel.U_STR_MtvoCD || '';
        } else {
            newOrderModel.U_RML_TDOCORG = '';
            newOrderModel.U_RML_DOCORG = '';
            newOrderModel.U_BPP_MDTO = '';
            newOrderModel.U_BPP_MDSO = '';
            newOrderModel.U_BPP_MDCO = '';
            newOrderModel.U_BPP_SDocDate = '';
            newOrderModel.U_RS_SOLAPR = '';
            newOrderModel.U_STR_MtvoCD = '';
        }

        let permissions = new Permissions();

        permissions.editItems = true;
        permissions.editDiscountDocument = true;
        permissions.editDiscountLine = true;
        permissions.editEmployee = true;
        permissions.editOwner = true;

        newOrderModel.permissions = permissions;

        //guardar orign de documento para ccines de copiar a:

        //ACCIONES UE CAMBIAN EL MODELO EN EL PASO DE DOCUEMMNTOS A:

        //dE ORDEN DE VENTA A FACTURA
        newOrderModel.DocDate = today;
        newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
        //Calculo fecha de entrega 
        if (newOrderModel.OriginDocumentCreate === 'invoice' || newOrderModel.OriginDocumentCreate === 'invoiceReserve') {

            newOrderModel.DocDate = today;
            newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
            // let grouNum = newOrderModel.GroupNum;
            // let groupName = newOrderModel.GroupName;
            let extraDays = newOrderModel.ExtraDays;
            let typeInvoice = 0;

            // let userFieldTypeInvoice = newOrderModel.userFields.userFields3;

            // if(userFieldTypeInvoice === 'Contado' || (groupName === 'Pago Inmediato' && grouNum === 9)){
            //     typeInvoice = 3;
            // }else if(userFieldTypeInvoice === 'Credito'){
            //     typeInvoice = 14
            // }else if(userFieldTypeInvoice === 'Credito2'){
            //     if(extraDays > 28){
            //         typeInvoice = extraDays;
            //     }else{
            //         typeInvoice = 28;
            //     }
            // }
            if (typeInvoice === 0) {
                typeInvoice = extraDays ? extraDays : Number(newOrderModel?.GroupNum) === -1 ? 0 : 3;
            }
            let docDueDate = new Date(today);/*new Date(newOrderModel.DocDueDate)*/
            docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
            let weekDays = 0;
            while (weekDays < typeInvoice) {
                docDueDate.setDate(docDueDate.getDate() + 1);
                // if(docDueDate.getDay() != 0){
                weekDays++;
                // }
            }
            newOrderModel.DocDueDate = moment(docDueDate).format('YYYY-MM-DD');
        } else {
            newOrderModel.DocDueDate = today;
        }
        newOrderModel.CardType = newOrderModel.CardType || '';
        newOrderModel.U_FMB_END_DATE = newOrderModel.DocDueDate;

        newOrderModel.Items.map(item => {
            item.Quantity = item.OpenQty;
            return item;
        });
        if (view === 'invoiceReserve') {
            let newArreglo = [];
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const element = newOrderModel.Items[index];
                if (element.TargetType !== 14 && select === 'creditNote') {
                    element.Quantity = element.ActualOpenQty ? element.ActualOpenQty : element.Quantity;
                    newArreglo.push(newOrderModel.Items[index])
                } else if ((element.TargetType !== 15 && select === 'deliveries' && element.Quantity !== 0) || element.ActualOpenQty !== 0) {
                    newArreglo.push(newOrderModel.Items[index])
                }
            }
            newOrderModel.Items = newArreglo;
        }

        //validacion para evitar que salga la pestaña de coppiar de cuando pasas a copiar a
        newOrderModel.isSelectTo = true;
        newOrderModel.isSelectOf = true;

        //Asignar Series de usuario
        //CENTROS DE COSTOS 
        // for (let index = 0; index < newOrderModel.Items.length; index++) {
        //     const element = newOrderModel.Items[index];
        //CENTRO DE COSTO 1
        // element.OcrCode = element.OcrdCode;
        //CENTRO DE COSTO 2
        // element.OcrCode2 = newOrderModel.OcrCode2;
        //CENTRO DE COSTO 3
        // element.OcrCode3 = element.OcrCode3;
        //CENTRO DE COSTO 4
        // element.OcrCode4 = '';
        // }
        //CENTROS DE COSTOS 

        if (select === 'PurchaseQuotationDraft') { // Al copiar de solicitud de compra un servicio, visualizar los mismos cálculos
            if (newOrderModel?.DocType === 'S') {
                this.refreshTotalService(newOrderModel)
            }
            showAlert({ type: 'info', timeOut: 5000, message: "Por favor seleccione un Proveedor" });
        }

        //#region Ramo
        if (select === 'transfers') {
            const isOWTRoOWTQ = select === 'transfers' || select === 'transfersRequest' || Number(newOrderModel?.ObjType) === 67 || Number(newOrderModel?.ObjType) === 1250000001;
            await processUserFields({
                fields: invFields,
                model: newOrderModel,
                targetProperty: "invFields",
                headerFields: isOWTRoOWTQ ? [] : [
                    'U_BPP_MDTS',
                    'U_RS_MOTIVOIS',
                    'U_RS_TIPOOPER',
                    'U_BPP_MDTD',
                    'U_BPP_MDSD',
                    'U_BPP_MDCD'
                ],
                dateFields: ["U_STR_FE_GRE_FechaTransporte"],
                isOWTRoOWTQ,
                isCopy: true,
                header: newOrderModel
            });
            await processUserFields({
                fields: transferFields,
                model: newOrderModel,
                targetProperty: "transferFields",
                headerFields: [],
                dateFields: [],
                isOWTRoOWTQ,
                isCopy: true,
                header: newOrderModel
            });

            //#region U_RML_TIPOS13
            const isType13 = Number(newOrderModel?.U_STR_FE_GRE_CodigoMotivoTraslado) === 13;

            const tipos13Field = newOrderModel?.invFields?.find(field => field?.Field === 'U_RML_TIPOS13');
            if (tipos13Field && Object.prototype.hasOwnProperty.call(tipos13Field, 'Static')) {
                tipos13Field.Static = !isType13;
            }
            if (!isType13) {
                newOrderModel.U_RML_TIPOS13 = '';
            }
            //#endregion U_RML_TIPOS13
        }
        //#endregion Ramo

        await this.refreshModel(newOrderModel);


        changeDocumentActionModal();

        // Cargar gasto administrativo y cesion en uso
        if ((view === 'orderSales' || view === 'deliveries') && (select === 'invoice' || select === 'deliveries')) {
            if (newOrderModel?.Items?.length) {
                for (let index = 0; index < newOrderModel?.Items?.length; index++) {
                    const item = newOrderModel?.Items[index];
                    if (Number(item.UserFieldsItem?.userFields2) === 1) { // Es CESION DE USO
                        await this.changeUserFieldsItemsDocument({ nativeEvent: { target: { value: '1' } } }, 1, index)
                    }
                }
            }
        }

        //#region DETRACCIONES
        if (newOrderModel.existsDetraccion && select === 'purchaseInvoice') {  // Si existe detraccion ajustar el total
            this.refreshTotal(newOrderModel);
        }
        //#endregion DETRACCIONES

    };

    SearchAdministrativeExpenses = async (item) => {
        const { enableSpinner, showAlert } = this.props;
        let { newOrderModel } = this.props;

        const data = {
            CardCode: newOrderModel.CardCode || "",
            ItemCode: item.ItemCode || "",
        };

        enableSpinner(true);
        const response = await apiClient.getAdministrativeExpenses(data);
        enableSpinner(false);

        if (!response.data || typeof response.data !== 'object') {
            showAlert({ type: "error", message: "No hay Información por mostrar" });
            return;
        }

        const { itemAdminExpen, itemcertCUItm } = response.data;

        if ((!Array.isArray(itemAdminExpen) || itemAdminExpen.length === 0) && (!Array.isArray(itemcertCUItm) || itemcertCUItm.length === 0)) {
            showAlert({ type: "error", message: response.message || "No hay hijos" });
            return;
        }

        if (itemAdminExpen.length === 1 && itemcertCUItm.length === 1) {
            newOrderModel = { ...this.props.newOrderModel };

            const parent = newOrderModel.Items.find(i => i.LineNum === item.LineNum) || newOrderModel.Items[item.LineNum];

            if (!parent) {
                showAlert({ type: "error", message: "No se encontró el artículo padre." });
                return;
            }

            const maxLineNum = newOrderModel.Items.length
                ? Math.max(...newOrderModel.Items.map(i => Number(i.LineNum || 0)))
                : -1;
            const child1LineNum = maxLineNum + 1;
            const child2LineNum = maxLineNum + 2;

            const child1 = { ...itemAdminExpen[0], Quantity: ((parent.Quantity || 1) - (Number(parent.UserFieldsItem.userFields3 || 0))), LineNum: child1LineNum, ParentLineNum: parent.LineNum };
            const child2 = { ...itemcertCUItm[0], Quantity: ((parent.Quantity || 1) - (Number(parent.UserFieldsItem.userFields3 || 0))), LineNum: child2LineNum, ParentLineNum: parent.LineNum };

            parent.isAdministrativeExpenseParent = `${parent.LineNum}_${child1LineNum}_${child2LineNum}_${itemAdminExpen[0].ItemCode}`;
            await this.selectItemsEnter([child1]);
            await this.selectItemsEnter([child2]);

            await this.refreshTotal(newOrderModel);
        } else {
            showAlert({ type: "error", message: itemAdminExpen.message || "Error al obtener hijos" });
            return;
        }
    };

    duplicate = async () => {
        const { showAlert, newOrderModel, changeDocumentActionModal, view, enableSpinner, selectTable, selectValidateSeries, parseSeries } = this.props;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        if (!this.validatePartner()) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        //cambio de moneda de dolares y detener so el documento no tiene el tipo de cambio
        let getCuentaBancosResponse = await apiClient.getCurrencies();
        newOrderModel.Currencies = getCuentaBancosResponse.data;

        let currency = newOrderModel.Currencies.filter(currency => {
            return currency.CurrCode.toString() === newOrderModel.DocCur.toString();
        });

        if (!currency.length) {
            showAlert({
                type: 'error',
                timeOut: 5000,
                message: "No se a definido el tipo de cambio de la moneda del documento. Para continuar ingrese en SAP el tipo de cambio: " + newOrderModel.DocCur
            })
            return;
        }

        newOrderModel.ChangeRate = currency[0].Rate || 1;

        let newItems = [];

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            item.BaseEntry = null;
            item.BaseType = -1;
            item.BaseLine = null;
            item.LineStatus = false;
            let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
            for (let index = 0; index < item.wareHouseStock.length; index++) {
                const warehouseStock = item.wareHouseStock[index];
                if (warehouseStock.WhsCode.toString() === item.WhsCode.toString()) {
                    item.OnHand = warehouseStock.OnHand || 0;
                    if (warehouseStock.OnHand <= 0) {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                            timeOut: 5000
                        });
                        item.stock = false;
                    } else if ((item.UserBaseUn === 'Y' && item.Quantity > warehouseStock.OnHand) ||
                        (item.UserBaseUn === 'N' && (item.Quantity * measureUnit) > warehouseStock.OnHand)) {
                        showAlert({
                            type: 'warning',
                            message: 'El artículo ' + item.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                            timeOut: 5000
                        });
                        item.stock = false;
                    } else {
                        item.stock = true;
                    }
                }
            }
            if (item.UserBaseUn === 'Y') {
                item.newHomePrice = parseFloat(item.Price).toFixed(2);
                item.newPrice = parseFloat(item.Price).toFixed(2);
                item.cHomePrice = parseFloat(item.Price).toFixed(2);
                item.cPrice = parseFloat(item.Price).toFixed(2);
            } else {
                item.newHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                item.newPrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                item.cHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                item.cPrice = parseFloat(item.Price).toFixed(2) / measureUnit;

                if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn') {
                    item.newHomePrice = parseFloat(item.Price).toFixed(2);
                    item.newPrice = parseFloat(item.Price).toFixed(2);
                    item.cHomePrice = parseFloat(item.Price).toFixed(2);
                    item.cPrice = parseFloat(item.Price).toFixed(2);
                }
            }
            if (newOrderModel.DocStatus === 'C') { item.OpenQty = parseFloat(item.Quantity).toFixed(6); }
            item.Quantity = item.OpenQty;
            newItems.push(item);
        }

        this.refreshTotal(newOrderModel);

        newOrderModel.Items = newItems;

        newOrderModel.OriginDocumentCreate = view;
        newOrderModel.newView = newOrderModel.OriginDocumentCreate;
        newOrderModel.isDocumentWithAuthorization = false;
        let table = selectTable(newOrderModel.OriginDocumentCreate);





        let dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };

        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);



        let ValidateSeries = selectValidateSeries(table.name, user);

        if (!user || ValidateSeries.series === "") {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            });
            return;
        }

        let seriesUsers = ValidateSeries.series.split("|");


        let newArraySeries = [];

        for (let index = 0; index < seriesUsers.length; index++) {
            const serieUser = seriesUsers[index];
            for (let index = 0; index < seriesResponse.data.length; index++) {
                const serieResponse = seriesResponse.data[index];
                if (serieResponse.Series.toString() === serieUser.toString() && !newArraySeries.some(item => item.Series.toString() === serieResponse.Series.toString())) {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }

        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";

        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (serie.Series.toString() === newArraySeries[0].DfltSeries.toString()) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }


        let today = moment(new Date()).format('YYYY-MM-DD');
        newOrderModel.SerieArray = newArraySeries;
        newOrderModel.SerieName = defaultName;
        newOrderModel.SerieCode = defaultcode;
        newOrderModel.NextFolio = nextNumber;
        newOrderModel.StatusDocument = "Abierto";


        // let userFieldsService = await apiClient.getUserFields(table);
        // userFieldsService = userFieldsService.data || [];

        // let userFields = new UserFields();

        // json.allUserFields.map((item, index) => {
        //     userFieldsService.map(userfieldItem => {
        //         if (item.fieldId === userfieldItem.header.FieldID) {
        //             item.name = userfieldItem.header.Descr;
        //             item.fieldType = userfieldItem.options.length != 0 ? 2 : 1;
        //             item.options = userfieldItem.options;
        //             item.IdValue = index;
        //             let newUserFields = this.setUserFieldValueDefault(userFields, index, newOrderModel.userFields);
        //             if (item.fieldType === 2) {
        //                 item.options.push({ FldValue: "", Descr: "" });
        //             }
        //             userFields = newUserFields;
        //         }
        //     });
        // });


        let permissions = new Permissions();
        permissions.editItems = true;
        permissions.editDiscountDocument = true;
        permissions.editEmployee = true;
        permissions.editOwner = true;

        newOrderModel.permissions = permissions;

        //guardar orign de documento para ccines de copiar a:

        //ACCIONES UE CAMBIAN EL MODELO EN EL PASO DE DOCUEMMNTOS A:

        //dE ORDEN DE VENTA A FACTURA
        newOrderModel.DocDate = today;
        newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
        //Calculo fecha de entrega 
        if (newOrderModel.OriginDocumentCreate === 'invoice' || newOrderModel.OriginDocumentCreate === 'invoiceReserve') {

            newOrderModel.DocDate = today;
            newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
            // let grouNum = newOrderModel.GroupNum;
            // let groupName = newOrderModel.GroupName;
            let extraDays = newOrderModel.ExtraDays;
            let typeInvoice = 0;

            // let userFieldTypeInvoice = newOrderModel.userFields.userFields3;

            // if(userFieldTypeInvoice === 'Contado' || (groupName === 'Pago Inmediato' && grouNum === 9)){
            //     typeInvoice = 3;
            // }else if(userFieldTypeInvoice === 'Credito'){
            //     typeInvoice = 14
            // }else if(userFieldTypeInvoice === 'Credito2'){
            //     if(extraDays > 28){
            //         typeInvoice = extraDays;
            //     }else{
            //         typeInvoice = 28;
            //     }
            // }
            if (Number(typeInvoice) === 0) {
                typeInvoice = extraDays ? extraDays : Number(newOrderModel?.GroupNum) === -1 ? 0 : 3;
            }
            let docDueDate = new Date(today);
            docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
            let weekDays = 0;
            while (weekDays < typeInvoice) {
                docDueDate.setDate(docDueDate.getDate() + 1);
                // if(docDueDate.getDay() != 0){
                weekDays++;
                // }
            }
            newOrderModel.DocDueDate = moment(docDueDate).format('YYYY-MM-DD');
        } else {
            newOrderModel.DocDueDate = today;
        }
        newOrderModel.U_FMB_END_DATE = newOrderModel.DocDueDate;

        //#region ########## USER FIELDS #########################################
        let userFieldsResponse = await apiClient.getUserFields(table);
        let userFieldsHeader = [];
        let userFieldsBody = [];
        if (userFieldsResponse.status) {
            userFieldsHeader = userFieldsResponse.data.header || [];
            userFieldsBody = userFieldsResponse.data.body || [];
        }


        let userFields = new UserFields();
        let userFieldsItems = new UserFieldsItem();

        for (let index = 0; index < json.allUserFields.length; index++) {
            const item = json.allUserFields[index];
            for (let indez = 0; indez < userFieldsHeader.length; indez++) {
                const userfield = userFieldsHeader[indez];
                if (item.fieldId === userfield.header.FieldID) {
                    json.allEnableUserFields[index].name = userfield.header.Descr;
                    item.name = userfield.header.Descr;
                    const isInvoice = view === 'invoice';
                    const isCreditNote = view === 'creditNote';
                    const isDebitNote = view === 'debitNote';
                    if (isInvoice || isCreditNote || isDebitNote) {
                        const fieldsSelectList = ["U_BPP_MDTD", "U_BPP_MDSD"];
                        const aliasId = userfield?.header?.AliasID || '';
                        item.fieldType = item.fieldType === 3 || fieldsSelectList.includes(aliasId) || fieldsSelectList.includes(`U_${aliasId}`) ? 3 : userfield.options.length !== 0 ? 2 : 1;
                    } else {
                        item.fieldType = item.fieldType === 3 ? 3 : userfield.options?.length !== 0 ? 2 : 1;
                    }
                    item.options = userfield.options;
                    item.IdValue = index;
                    let newUserFields = this.setUserFieldValueDefault(userFields, index, userfield.header);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }

                    //#region SERIES Y CORRELATIVOS
                    if (isInvoice || isCreditNote || isDebitNote) { // Validación temporal
                        if (item.fieldId === 1) {//TIPO DE DOCUMENTO
                            let validOptions = [];
                            if (isInvoice) {
                                validOptions = [
                                    { value: '01', label: 'Factura' },
                                    { value: '03', label: 'Boleta' },
                                ]
                            } else if (isCreditNote) {
                                validOptions = [
                                    { value: '07', label: 'Nota de crédito' },
                                ]
                            } else if (isDebitNote) {
                                validOptions = [
                                    { value: '08', label: 'Nota de débito' }
                                ]
                            } else { // Guía
                                validOptions = [
                                    { value: '09', label: 'Guia' },
                                    { value: 'DI', label: 'Documento Interno' },//AUN NO EXISTE REGISTRO EN DB
                                ]
                            }
                            item.options = validOptions
                        }
                        if (item.fieldId === 22) {//CORRELATIVO DOCUMENTO
                            //A FUTURO MOSTRAR POSIBLE CORRELATIVO, DE MOMENTO NO ESTAN INDISPENSABLE AL CREAR

                        }
                        if (item.fieldId === 36) {//SERIE DOCUMENTO
                            let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                            let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                            let seriesPuerta = {}
                            let seriesPlanta = {}
                            try {
                                seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                            } catch (e) {
                                seriesPuerta = {};
                            }
                            try {
                                seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                            } catch (e) {
                                seriesPlanta = {};
                            }
                            const noNeedDefault = isInvoice || isCreditNote || isDebitNote;
                            seriesPuerta = parseSeries(seriesPuerta, noNeedDefault)
                            seriesPlanta = parseSeries(seriesPlanta, noNeedDefault)
                            const isZonal = Number(user?.Branch?.Type) === 1;
                            item.options = (isZonal
                                ? (Array.isArray(seriesPuerta) ? seriesPuerta : [])
                                : (Array.isArray(seriesPlanta) ? seriesPlanta : [])
                            )?.filter((option, index, self) =>
                                index === self?.findIndex(x => x.value === option.value)
                            );
                        }
                    }
                    //#endregion SERIES Y CORRELATIVOS
                    userFields = newUserFields;
                }
            }
        }
        newOrderModel.userFields = userFields;

        // Limpiar para no llevar el folio de Counter
        newOrderModel.NumAtCard = '';

        // CAMPOS FACTURACIÓN
        newOrderModel.U_RML_TDOCORG = newOrderModel.U_RML_TDOCORG || '';
        newOrderModel.U_RML_DOCORG = newOrderModel.U_RML_DOCORG || '';
        newOrderModel.U_BPP_MDTO = newOrderModel.U_BPP_MDTO || '';
        newOrderModel.U_BPP_MDSO = newOrderModel.U_BPP_MDSO || '';
        newOrderModel.U_BPP_MDCO = newOrderModel.U_BPP_MDCO || '';
        newOrderModel.U_BPP_SDocDate = newOrderModel.U_BPP_SDocDate || '';
        newOrderModel.U_RS_SOLAPR = newOrderModel.U_RS_SOLAPR || '';
        newOrderModel.U_STR_MtvoCD = newOrderModel.U_STR_MtvoCD || '';

        for (let index = 0; index < json.allItemsUserFields.length; index++) {
            const item = json.allItemsUserFields[index];
            for (let indexz = 0; indexz < userFieldsBody.length; indexz++) {
                const userfieldItem = userFieldsBody[indexz];
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = userfieldItem.options.length !== 0 ? 2 : 1;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFieldsItems = this.setUserFieldValueDefault(userFieldsItems, index, userfieldItem.header);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFieldsItems = newUserFieldsItems;
                }

            }
        }
        newOrderModel.userFieldsItem = userFieldsItems;
        //#endregion

        //#region
        newOrderModel.AtcEntry = null;
        for (const attachment of newOrderModel.Attachment) {
            newOrderModel.UploadAttachments.push({
                SourcePath: attachment.srcPath,
                FileName: attachment.FileName,
                TargetPath: attachment.trgtPath,
                FileExtension: attachment.FileExt,
                FreeText: attachment.FreeText,
            });
        }
        //#endregion

        this.refreshModel(newOrderModel);


        changeDocumentActionModal();
    };

    selectOf = async event => {
        const { showAlert, newOrderModel, view } = this.props;
        let message = 'Selecciona un socio de negocios';

        if (view === 'landedCosts') {
            message = 'Selecciona un proveedor'
        }

        if (!this.validatePartner()) {
            showAlert({ type: 'info', message });
            return;
        }
        newOrderModel.SelectOf = event.nativeEvent.target.value || '';

        this.refreshModel(newOrderModel);
        this.selectOfReference.enableDataTable();
        $('#selectOfModal').modal('show');
    };

    getUserFieldKey = (fieldId) => {
        const field = json.allItemsUserFields.find(f => Number(f.fieldId) === Number(fieldId));
        const key = (field && field.IdValue !== null) ? 'userFields' + (Number(field.IdValue) + 1) : null;
        return key;
    };

    changeQuantityItem = async (event, index, specifQty = null, Gallons = false) => {
        const { showAlert, newOrderModel, view, enableSpinner, selectTable } = this.props;

        // let docDate = newOrderModel.DocDate;
        // let cardCode = newOrderModel.CardCode;
        // let itemCode = newOrderModel.Items[index].ItemCode;
        let quantity = specifQty !== null ? specifQty : event.nativeEvent.target.value;


        // if( quantity.indexOf(".") !== -1 ){
        //    showAlert({type: 'warning', message: "Solo se permiten cantidades enteras"});
        //    return;
        // }      
        if (quantity.indexOf(" ") !== -1 || quantity.indexOf("-") !== -1) {
            showAlert({ type: 'warning', message: "Carácter no permitido" });
            return;
        }
        // Validación para que al copiar a factura no respete cantidad de documento origen
        // if(quantity > newOrderModel.Items[index].OriginalQuantity && (newOrderModel.isSelectTo || newOrderModel.isSelectOf ) && !newOrderModel.Items[index].ItemNew)
        // {
        //     showAlert({type: 'warning', message: "La cantidad excede a la cantidad original"});
        //     quantity=newOrderModel.Items[index].quantity;
        // }
        if (view === 'invoiceBorrador' && newOrderModel.ObjType === "67" && newOrderModel.U_FMB_EditTraslado === 'Y') {
            if ((!isNaN(quantity) && quantity !== '') && Number(quantity) > Number(newOrderModel.Items[index].OriginalQuantity)) {
                showAlert({ type: 'warning', message: "La cantidad ingresada no puede ser mayor a la cantidad original del traslado." });
                return;
            }
        }


        if (!isNaN(quantity) && quantity !== '') {
            newOrderModel.Items[index].Quantity = quantity;
            //#region ########## BATCH #######################
            if (newOrderModel.Items[index].ManBtchNum === 'Y') {
                newOrderModel.Items[index].DocUoMQty = Number(quantity);
                newOrderModel.Items[index].OpenLneQty = Number(quantity) - Number(newOrderModel.Items[index].SnBUoMQty);
            }
            //#endregion

            const entregaKeyQty = this.getUserFieldKey(isEntregaCilindro);
            const cilindrosKeyQty = this.getUserFieldKey(isCilindrosVaciosDevueltos);

            if (entregaKeyQty && cilindrosKeyQty && newOrderModel.Items[index].UserFieldsItem?.[entregaKeyQty] === "1") {
                newOrderModel.Items[index].UserFieldsItem[cilindrosKeyQty] = Number(quantity || 0).toString();
                showAlert({ type: 'info', message: 'Al cambiar la cantidad se ha ajustado la cantidad de cilindros vacíos devueltos.', timeOut: 6000 });
            }

        } else if (quantity === '') {
            newOrderModel.Items[index].Quantity = '';
        }
        if (view === 'invoice') {
            const parentLineNum = newOrderModel.Items[index].LineNum;
            const CU = newOrderModel.Items[index].UserFieldsItem.userFields3 || 0;

            const childItems = newOrderModel.Items.filter(i => i.ParentLineNum === parentLineNum);
            childItems.forEach(child => {
                child.Quantity = Number(quantity) - Number(CU);
            });
            if (newOrderModel.Items[index].ParentLineNum !== null && newOrderModel.Items[index].ParentLineNum !== undefined) {
                const parentItem = newOrderModel.Items.find(i => i.LineNum === Number(newOrderModel.Items[index].ParentLineNum));
                if (parentItem) parentItem.Quantity = quantity;
            }
        }

        if (Gallons) {
            //#region Precio Llamagas
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
            if ((newOrderModel?.isSalesDocument)) {
                const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = newOrderModel.Items[index] ?? {}
                const envasado = Envasados?.includes(Number(ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                let searchItem = ItemCode;

                if (!isTemporary && searchItem && (envasado || glpGranel)) {
                    let getItemResponse = null;
                    const newView = newOrderModel?.newView || view;
                    let table = selectTable(newView);
                    let data = {
                        CardCode: newOrderModel?.CardCode || "",
                        ItemCode: searchItem || "",
                        WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : WhsCode,
                        ShipToCode: newOrderModel?.ShipToCode || "",
                        userFields: newOrderModel?.userFields || {},
                        Quantity,
                        U_RS_CANTG,
                        U_RS_UMED,
                        U_RS_PRECIOGL,
                        gallonsPrice: true,
                        DocDueDate: newOrderModel?.DocDueDate,
                        TaxDate: newOrderModel?.TaxDate,
                        ObjType: table?.docType,
                    };

                    //#region GALLON PRICE
                    enableSpinner(true);
                    let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);
                    const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                    data.U_RS_PRECIOGL = U_RS_PRECIO;
                    data.gallonsPrice = false;
                    //#endregion GALLON PRICE

                    enableSpinner(true);
                    getItemResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);

                    const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                    const item = newOrderModel.Items[index] || {};
                    item.Price = U_RS_CALCULADO;

                    if (glpGranel) {
                        newOrderModel.Items[index].U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                        newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                    }

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newOrderModel.Items[index].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newOrderModel.Items[index].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                    } else {
                        newOrderModel.Items[index].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newOrderModel.Items[index].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newOrderModel.Items[index].newHomePrice = item.Price || 0;
                    newOrderModel.Items[index].newPrice = item.Price || 0;
                    newOrderModel.Items[index].cHomePrice = item.Price || 0;
                    newOrderModel.Items[index].cPrice = item.Price || 0;
                    if (getItemResponse?.status === 1) {
                        showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar la cantidad de galones.', timeOut: 5000 });
                    } else {
                        showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar la cantidad de galones.', timeOut: 5000 });
                    }
                }
            }
            //#endregion Precio Llamagas
        }

        setTimeout(async () => {
            await this.refreshTotal(newOrderModel, index);
        }, 100);

    };

    //#region GALLONS CONVERSION
    changeUserUM = async (index, event) => {
        const { newOrderModel, showAlert, view, enableSpinner, selectTable } = this.props;
        let newView = newOrderModel?.newView || view;

        newOrderModel.Items[index].U_RS_UMED = event?.target?.value || '';
        let checkPrice = false;
        //#region Precio Llamagas
        // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
        if ((newOrderModel?.isSalesDocument)) {
            const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = newOrderModel.Items[index] ?? {}
            const envasado = Envasados?.includes(Number(ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(ItmsGrpCod));
            let searchItem = ItemCode;

            if (!isTemporary && searchItem && (envasado || glpGranel)) {
                let getItemResponse = null;
                const newView = newOrderModel?.newView || view;
                let table = selectTable(newView);
                const data = {
                    CardCode: newOrderModel?.CardCode || "",
                    ItemCode: searchItem || "",
                    WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : WhsCode,
                    ShipToCode: newOrderModel?.ShipToCode || "",
                    userFields: newOrderModel?.userFields || {},
                    Quantity,
                    U_RS_CANTG,
                    U_RS_UMED,
                    U_RS_PRECIOGL,
                    gallonsPrice: true,
                    DocDueDate: newOrderModel?.DocDueDate,
                    TaxDate: newOrderModel?.TaxDate,
                    ObjType: table?.docType,
                };

                //#region GALLON PRICE
                enableSpinner(true);
                let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);
                const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                data.U_RS_PRECIOGL = U_RS_PRECIO;
                data.gallonsPrice = false;
                //#endregion GALLON PRICE

                enableSpinner(true);
                getItemResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);

                const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                const item = newOrderModel.Items[index] || {};
                item.Price = U_RS_CALCULADO;
                checkPrice = true;

                if (glpGranel) {
                    newOrderModel.Items[index].U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                    newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                }

                let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                    newOrderModel.Items[index].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    newOrderModel.Items[index].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                } else {
                    newOrderModel.Items[index].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    newOrderModel.Items[index].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                }

                newOrderModel.Items[index].newHomePrice = item.Price || 0;
                newOrderModel.Items[index].newPrice = item.Price || 0;
                newOrderModel.Items[index].cHomePrice = item.Price || 0;
                newOrderModel.Items[index].cPrice = item.Price || 0;
                if (getItemResponse?.status === 1) {
                    showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar la unidad de medida.', timeOut: 5000 });
                } else {
                    showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar la unidad de medida.', timeOut: 5000 });
                }
            }
        }
        //#endregion Precio Llamagas
        if (checkPrice) {
            await this.refreshTotal(newOrderModel);
        } else {
            await this.refreshModel(newOrderModel);
        }
        if (newView !== 'transfersEntry') {
            if (!newOrderModel.Items[index].U_RS_UMED || newOrderModel.Items[index].U_RS_UMED === 'KGM') {
                let cantG = false
                if (Number(newOrderModel.Items[index].U_RS_CANTG) > 0 && newOrderModel.Items[index]?.Gallons) {
                    cantG = true;
                }
                // newOrderModel.Items[index].U_RS_DENS = 0;
                newOrderModel.Items[index].U_RS_CANTG = 0;
                newOrderModel.Items[index].U_RS_TOTALGL = 0;
                newOrderModel.Items[index].Gallons = false;
                await this.refreshModel(newOrderModel);
                setTimeout(async () => {
                    if (cantG) {
                        await this.changeQuantityItem({ nativeEvent: { target: { value: String(1) } } }, index);
                        showAlert({ type: 'info', message: `La cantidad y precio del artículo ${newOrderModel.Items[index]?.ItemCode} ha sido ajustada al quitar la conversión de galones.` });
                    }
                }, 100);
            } else if (newOrderModel.Items[index].U_RS_UMED === 'GLN' && Number(newOrderModel.Items[index].U_RS_CANTG) > 0) {
                newOrderModel.Items[index] = await this.checkGallons(newOrderModel.Items[index], index, newOrderModel)
                await this.refreshModel(newOrderModel);
                if (newOrderModel.Items[index]?.Gallons) {
                    setTimeout(async () => {
                        await this.changeQuantityItem({ nativeEvent: { target: { value: String(newOrderModel.Items[index]?.Quantity || 0) } } }, index, null, newOrderModel.Items[index]?.Gallons);
                    }, 100);
                }
            }
        }
    };

    normalizeNumber = (value) => {
        value = String(value ?? "").replace(/[^0-9.]/g, "");

        if (value.includes(".")) {
            const [i, d] = value.split(".");
            return `${i}.${d}`;
        }
        if (value.startsWith(".")) {
            return `0${value}`;
        }
        return value;
    };

    changeGalonesCant = async (index, event) => {
        const { newOrderModel } = this.props;
        const value = this.normalizeNumber(event.target.value);

        newOrderModel.Items[index].U_RS_CANTG = value;
        await this.refreshModel(newOrderModel);
    };

    changeDensidad = async (index, event) => {
        const { newOrderModel } = this.props;
        const value = this.normalizeNumber(event.target.value);

        newOrderModel.Items[index].U_RS_DENS = value;
        await this.refreshModel(newOrderModel);
    };

    changeHDensidad = async (event) => {
        const { newOrderModel } = this.props;
        const value = this.normalizeNumber(event.target.value);

        newOrderModel.U_RS_DENSIDAD = value;
        await this.refreshModel(newOrderModel);
    };

    changeQuantityBlur = async (index, event, field = '') => {
        if (!field) {
            return;
        };
        const { newOrderModel, view, enableSpinner, showAlert, selectTable } = this.props;
        let newView = newOrderModel?.newView || view;
        if (newView !== 'transfersEntry') {
            newOrderModel.Items[index][field] = Number(Number(event?.nativeEvent?.target?.value || 0)?.toFixed(3));

            let U_RS_CANTG = field === 'U_RS_CANTG' ? Number(newOrderModel.Items[index][field]) : Number(newOrderModel.Items[index].U_RS_CANTG);
            newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
            let checkPrice = false;
            if (field === 'U_RS_CANTG') {
                //#region Precio Llamagas
                // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
                if ((newOrderModel?.isSalesDocument)) {
                    const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = newOrderModel.Items[index] ?? {}
                    const envasado = Envasados?.includes(Number(ItmsGrpCod));
                    const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                    let searchItem = ItemCode;

                    if (!isTemporary && searchItem && (envasado || glpGranel)) {
                        let getItemResponse = null;
                        const newView = newOrderModel?.newView || view;
                        let table = selectTable(newView);
                        let data = {
                            CardCode: newOrderModel?.CardCode || "",
                            ItemCode: searchItem || "",
                            WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : WhsCode,
                            ShipToCode: newOrderModel?.ShipToCode || "",
                            userFields: newOrderModel?.userFields || {},
                            Quantity,
                            U_RS_CANTG,
                            U_RS_UMED,
                            U_RS_PRECIOGL,
                            gallonsPrice: true,
                            DocDueDate: newOrderModel?.DocDueDate,
                            TaxDate: newOrderModel?.TaxDate,
                            ObjType: table?.docType,
                        };

                        //#region GALLON PRICE
                        enableSpinner(true);
                        let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);
                        const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                        data.U_RS_PRECIOGL = U_RS_PRECIO;
                        data.gallonsPrice = false;
                        //#endregion GALLON PRICE

                        enableSpinner(true);
                        getItemResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);

                        const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                        const item = newOrderModel.Items[index] || {};
                        item.Price = U_RS_CALCULADO;
                        checkPrice = true;

                        if (glpGranel) {
                            newOrderModel.Items[index].U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                            newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                        }

                        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                        if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                            newOrderModel.Items[index].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                            newOrderModel.Items[index].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                        } else {
                            newOrderModel.Items[index].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                            newOrderModel.Items[index].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        }

                        newOrderModel.Items[index].newHomePrice = item.Price || 0;
                        newOrderModel.Items[index].newPrice = item.Price || 0;
                        newOrderModel.Items[index].cHomePrice = item.Price || 0;
                        newOrderModel.Items[index].cPrice = item.Price || 0;
                        if (getItemResponse?.status === 1) {
                            showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar la cantidad de galones.', timeOut: 5000 });
                        } else {
                            showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar la cantidad de galones.', timeOut: 5000 });
                        }
                    }
                }
                if (checkPrice) {
                    await this.refreshTotal(newOrderModel);
                }
                //#endregion Precio Llamagas
            }

            await this.refreshModel(newOrderModel);
            if (field === 'U_RS_CANTG') {
                newOrderModel.Items[index] = await this.checkGallons(newOrderModel.Items[index], index, newOrderModel)
                await this.refreshModel(newOrderModel);
                if (newOrderModel.Items[index]?.Gallons) {
                    setTimeout(async () => {
                        await this.changeQuantityItem({ nativeEvent: { target: { value: String(newOrderModel.Items[index]?.Quantity || 0) } } }, index, null, newOrderModel.Items[index]?.Gallons);
                    }, 100);
                }
            }
        } else {
            newOrderModel[field] = Number(Number(event?.nativeEvent?.target?.value || 0)?.toFixed(3));
            await this.refreshModel(newOrderModel);
        }
    };

    checkGallons = async (item, index, newOrderModel = {}) => {
        const { enableSpinner, showAlert } = this.props;
        const { Filler = '' } = newOrderModel;

        if (!item?.U_RS_UMED ||
            (
                (!newOrderModel?.isTransferDocument && !item?.WhsCode) // Ventas evalua WhsCode
                || (newOrderModel?.isTransferDocument && !Filler) // Traslados evalua Filler
            ) ||
            !item?.ItemCode ||
            item?.U_RS_UMED !== 'GLN' ||
            (Number(item?.U_RS_CANTG || 0) === 0) ||
            (!Granel?.includes(Number(item?.ItmsGrpCod)))) {
            return item;
        };

        let checkItem = {
            ItemCode: item.ItemCode,
            U_RS_UMED: item.U_RS_UMED,
            // U_RS_DENS: item.U_RS_DENS,
            U_RS_CANTG: item.U_RS_CANTG,
            WhsCode: newOrderModel?.isTransferDocument ? Filler : item.WhsCode,
            // WhsCode: item.WhsCode,
        }
        enableSpinner(true);
        let gallons = await apiClient.getGallonsConversion(checkItem);
        enableSpinner(false);
        item.Gallons = true;
        if (gallons?.status && gallons?.data) {
            item.Quantity = Number(gallons.data?.Quantity || 0);
            showAlert({ type: 'info', message: `La cantidad y precio del artículo ${item?.ItemCode} ha sido ajustada por la conversión a galones.`, timeOut: 10000 });
        } else {
            item.Quantity = 0;
            showAlert({ type: 'warning', message: gallons?.message || `La cantidad y precio del artículo ${item?.ItemCode} ha sido ajustada por la conversión a galones.`, timeOut: 10000 });
        }
        return item;
    }
    //#endregion GALLONS CONVERSION

    changeSearchItem = async (event) => {
        const { newOrderModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.searchItem = event.nativeEvent.target.value.trim();
        }
        // this.refreshTotal(newOrderModel);
        this.refreshModel(newOrderModel)
    };

    changeAlmacen = async (index, event) => {
        const { newOrderModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.Items[index].WhsCode = event.nativeEvent.target.value;
            newOrderModel.Items[index].whsSelected = false;
            if (!newOrderModel?.InventoryAccount?.AcctCode) {
                newOrderModel.Items[index].AcctCode = '';
                newOrderModel.Items[index].AcctCode2 = '';
            }
            newOrderModel.Items[index].AvgPrice = 0;
        }
        this.refreshModel(newOrderModel);
    };

    onBlurWhs = async (index, event) => {
        const { newOrderModel, view, enableSpinner } = this.props;
        let checkPrice = false;
        let isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;

        //#region Precio Historico Llamagas
        if (Sections['HistoricalPrices'] && isOPRQ) { // Solo aplica para solicitud de compra
            if (!newOrderModel.Items[index]?.isTemporary) {
                let getItemResponse = null;
                let ItemCode = newOrderModel.Items[index]?.ItemCode;
                const localCurrency = CURRENCY;
                const Currency = newOrderModel.Items[index]?.Currency || localCurrency;
                const WhsCode = newOrderModel.Items[index]?.WhsCode || '';
                let data = {
                    ItemCode,
                    WhsCode,
                    Currency
                };

                enableSpinner(true);
                if (ItemCode) {
                    getItemResponse = await apiClient.getHistoricalPriceListLlama(data);
                }
                enableSpinner(false);

                const historicalPrice = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.historicalPrice || 0) : 0;
                const item = newOrderModel.Items[index] || {};
                item.Price = historicalPrice;
                item.hasHistoricalPrice = Number(historicalPrice) > 0;
                checkPrice = true;

                let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                    newOrderModel.Items[index].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    newOrderModel.Items[index].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                } else {
                    newOrderModel.Items[index].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    newOrderModel.Items[index].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                }

                newOrderModel.Items[index].newHomePrice = item.Price || 0;
                newOrderModel.Items[index].newPrice = item.Price || 0;
                newOrderModel.Items[index].cHomePrice = item.Price || 0;
                newOrderModel.Items[index].cPrice = item.Price || 0;
            }
        }
        //#endregion Precio Historico Llamagas
        if (checkPrice) {
            await this.refreshTotal(newOrderModel);
        }
    }

    ChangeLineVendor = async (index, event) => {
        const { newOrderModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.Items[index].LineVendor = event.nativeEvent.target.value;
        }
        this.refreshModel(newOrderModel);
    };

    OpenUomCode = async (index, itemCode) => {
        const { showAlert, enableSpinner, view } = this.props;
        if (!this.validatePartner() && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets') {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        enableSpinner(true);
        let getUomCodes = await apiClient.getUomCodeList(itemCode);
        enableSpinner(false);

        if (!Array.isArray(getUomCodes.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getUomCodes.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            uomCodes: getUomCodes.data,
            itemOrderModelUpdate: index,
        });

        $('#UomCode').modal('show');
    };

    selectUomCode = action => {
        const { uomCodes, itemOrderModelUpdate } = this.state;
        const { newOrderModel } = this.props;
        let uomcode = uomCodes[action.index];

        newOrderModel.Items[itemOrderModelUpdate].UomEntry = uomcode.UomEntry || '-1';
        newOrderModel.Items[itemOrderModelUpdate].UomCode = uomcode.UomCode || '';
        newOrderModel.Items[itemOrderModelUpdate].SalUnitMsr = uomcode.UomName || '';
        newOrderModel.Items[itemOrderModelUpdate].BaseQty = uomcode.BaseQty || 1;
        newOrderModel.Items[itemOrderModelUpdate].ifChangeUomCode = true;

        this.refreshTotal(newOrderModel);
        $('#UomCode').modal('hide');
        setTimeout(() => {
            this.setState({
                uomCodes: [],
            });
        }, 100);
    };

    ChangeSalUnitMsr = async (index, event) => {
        const { newOrderModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.Items[index].SalUnitMsr = event.nativeEvent.target.value;
        }
        this.refreshModel(newOrderModel);
    };

    changeAlmacenDestino = async (event) => {
        const { newOrderModel } = this.props;
        const { wareHousesList } = this.state;
        if (event.nativeEvent.data !== '') {
            newOrderModel.ToWhsCode = event.nativeEvent.target.value;
            newOrderModel.ToWhsCodeName = wareHousesList?.find(whs => whs.WhsCode === event.nativeEvent.target.value)?.WhsName ?? '';
        }
        this.refreshModel(newOrderModel);
    };

    ChangeAlmacenRecepCEDIS = async (event) => {
        const { newOrderModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.WarehouseCEDIS = event.nativeEvent.target.value;
        }
        this.refreshModel(newOrderModel);
    }

    changeAlmacenOrigen = async (event) => {

        const { newOrderModel } = this.props;
        const { wareHousesList } = this.state;
        if (event.nativeEvent.data !== '') {
            newOrderModel.Filler = event.nativeEvent.target.value;
            newOrderModel.FillerName = wareHousesList?.find(whs => whs.WhsCode === event.nativeEvent.target.value)?.WhsName ?? '';
        }
        this.refreshModel(newOrderModel);
    };

    changeAlmacenTransito = async (selectedOption, value = null) => {
        const { _user } = this.state;
        const { newOrderModel } = this.props;

        newOrderModel.U_FMB_BinLocationTr = null//RESET BINLOCATION
        if (Number(newOrderModel.Transit) === 2) { newOrderModel.CEDIS_Reception = false; }
        newOrderModel.Transit = value !== null ? value : (selectedOption?.value ?? '');
        newOrderModel.DocNumCEDIS = '';
        if (Number(newOrderModel.Transit) === 2) {
            newOrderModel.WarehouseCEDIS = _user?.Branch?.ProjectCode ?? '';
            newOrderModel.Filler = "";
            newOrderModel.ToWhsCode = "";
        } else {
            newOrderModel.WarehouseCEDIS = '';
            newOrderModel.Filler = _user?.Branch?.ProjectCode || "";
        }

        if (Number(newOrderModel.Transit) === 1) {
            newOrderModel.Filler = null
            newOrderModel.TransitType = 'PZ'
        }
        this.refreshModel(newOrderModel);
    }

    changeTransitType = async (selectedOption) => {
        const { newOrderModel } = this.props;
        if (Number(newOrderModel.Transit) !== 1) { newOrderModel.TransitType = null }
        newOrderModel.TransitType = selectedOption?.value ?? null;
        this.refreshModel(newOrderModel);
    }

    change_U_BPP_MDTS = async (selectedOption) => {
        const { newOrderModel } = this.props;
        newOrderModel.U_BPP_MDTS = selectedOption?.value ?? '';

        this.refreshModel(newOrderModel);
    };

    change_U_STR_FE_GRE_CodigoMotivoTraslado = async (selectedOption) => {
        const { newOrderModel, enableSpinner, showAlert } = this.props;
        const value = selectedOption?.value ?? '';
        newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado = value;
        const Field = 'U_STR_FE_GRE_CodigoMotivoTraslado';
        const linkedFields = invFields?.filter(field => field?.active && field?.linkedValue === Field) ?? [];  // Campos dependientes
        if (linkedFields?.length) {
            if (value) {
                enableSpinner(true);
                let data = {
                    Field,
                    param1: value
                };
                let res = await apiClient.getFormattedQueriesByCUFD(data);
                enableSpinner(false);

                if (res?.status) {
                    const row = res?.data ?? {};

                    for (const lf of linkedFields) { // Asignar valores a campos dependientes
                        const targetField = lf.Field;

                        if (row.hasOwnProperty(targetField)) {
                            newOrderModel[targetField] = row[targetField];
                        } else {
                            newOrderModel[targetField] = '';
                        }
                    }

                } else { // Limpiar dependientes
                    showAlert({ type: 'error', message: `Ocurrió un error al consultar los valores dependientes del campo` });
                    for (const lf of linkedFields) {
                        newOrderModel[lf.Field] = '';
                    }
                }

            } else { // Limpiar dependientes
                for (const lf of linkedFields) {
                    newOrderModel[lf.Field] = '';
                }
            }
        }

        //#region U_RML_TIPOS13
        const isType13 = Number(value) === 13;

        const tipos13Field = newOrderModel?.invFields?.find(field => field?.Field === 'U_RML_TIPOS13');
        if (tipos13Field && Object.prototype.hasOwnProperty.call(tipos13Field, 'Static')) {
            tipos13Field.Static = !isType13;
        }
        if (!isType13) {
            newOrderModel.U_RML_TIPOS13 = '';
        }
        //#endregion U_RML_TIPOS13

        this.refreshModel(newOrderModel);
    };

    ChangeDocNumCEDIS = async (value) => {
        const { newOrderModel } = this.props
        newOrderModel.DocNumCEDIS = value
        this.refreshModel(newOrderModel);
    }

    SaveCheckBoxTransfers = async (check) => {
        await this.setState({
            checkboxArray: check
        })
    }

    changeCurrItem = async (value, index) => {
        const { newOrderModel, view, enableSpinner } = this.props;
        const { docCurrencies = [] } = this.state;
        const currency = docCurrencies?.find(({ CurrCode }) => CurrCode === value);
        let item = newOrderModel.Items[index];
        let isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;

        item.Currency = value;
        item.ChangeRate = Number(currency?.Rate || 1);
        item.ChangeRateCurrency = Number(currency?.Rate || 1);

        //#region Precio Historico Llamagas
        if (Sections['HistoricalPrices'] && isOPRQ && false) { // Solo aplica para solicitud de compra
            if (!item?.isTemporary) {
                let getItemResponse = null;
                let ItemCode = item?.ItemCode;
                const localCurrency = CURRENCY;
                const Currency = item?.Currency || localCurrency;
                const WhsCode = item?.WhsCode || '';
                let data = {
                    ItemCode,
                    WhsCode,
                    Currency
                };

                enableSpinner(true);
                if (ItemCode) {
                    getItemResponse = await apiClient.getHistoricalPriceListLlama(data);
                }
                enableSpinner(false);

                const historicalPrice = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.historicalPrice || 0) : 0;
                item.Price = historicalPrice;
                item.hasHistoricalPrice = Number(historicalPrice) > 0;

                let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                    item.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    item.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                } else {
                    item.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    item.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                }

                item.newHomePrice = item.Price || 0;
                item.newPrice = item.Price || 0;
                item.cHomePrice = item.Price || 0;
                item.cPrice = item.Price || 0;
            }
        }
        //#endregion Precio Historico Llamagas

        await this.refreshTotal(newOrderModel);
    };

    changePriceItem = async (event, index) => {
        const { newOrderModel, action, view } = this.props;
        const { editMode } = this.state;
        const isAccountPayment = newOrderModel.isAccountPayment;
        let price = event.nativeEvent.target.value;
        let isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;
        if (Sections['HistoricalPrices'] && isOPRQ && newOrderModel?.Items?.[index]?.hasHistoricalPrice) {
            return;
        }
        if (isAccountPayment) {
            let value = event.nativeEvent.target.value;
            let price = (event.nativeEvent.target.value)?.replace(/[,-]/g, '');
            if (!isNaN(price)) {
                if (!price) {
                    price = 0;
                }
                newOrderModel.ItemsPayments[index].Price = price;
                newOrderModel.ItemsPayments[index].HomePrice = price;
                newOrderModel.ItemsPayments[index].PriceFormat = value;
            }
        } else if (!isNaN(price)) {
            // if (event.nativeEvent.data != ' ') {
            newOrderModel.Items[index].Price = price;
            newOrderModel.Items[index].HomePrice = price;

            if ((newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument)
                && (Number(action) === 1 || (Number(action) === 2 && editMode && newOrderModel?.permissions?.editItems))
            ) {
                if (view === 'PurchaseRequest' && !newOrderModel?.newView) {
                    newOrderModel.Items[index].Currency = !newOrderModel.Items[index].Currency ? newOrderModel.DocCur || CURRENCY : newOrderModel.Items[index].Currency;
                    newOrderModel.Items[index].ChangeRateCurrency = Number(newOrderModel.Items[index].ChangeRate || 1);
                    newOrderModel.Items[index].LocalCurrency = CURRENCY;
                    newOrderModel.Items[index].ChangeRate = newOrderModel.Items[index].Currency === CURRENCY ? 1 : Number(newOrderModel.Items[index].ChangeRate || 1);
                } else {
                    newOrderModel.Items[index].Currency = newOrderModel.DocCur || CURRENCY;
                    newOrderModel.Items[index].ChangeRateCurrency = newOrderModel.ChangeRate;
                    newOrderModel.Items[index].LocalCurrency = CURRENCY;
                    newOrderModel.Items[index].ChangeRate = 1;
                }
            }
            // }
        }

        await this.refreshModel(newOrderModel);
    };

    changeKilosXComprar = (event, index) => {
        const { newOrderModel } = this.props;
        let KilosXComprar = event.nativeEvent.target.value;
        if (!isNaN(KilosXComprar)) { newOrderModel.Items[index].KilosXComprar = KilosXComprar; }
        this.refreshModel(newOrderModel);
    };

    changePesosXPieza = (event, index) => {
        const { newOrderModel } = this.props;
        let PesosXPieza = event.nativeEvent.target.value;
        if (!isNaN(PesosXPieza)) { newOrderModel.Items[index].PesosXPieza = PesosXPieza; }
        this.refreshModel(newOrderModel);
    };

    changePrecioXKilo = (event, index) => {
        const { newOrderModel } = this.props;
        let PrecioXKilo = event.nativeEvent.target.value;
        if (!isNaN(PrecioXKilo)) { newOrderModel.Items[index].PrecioXKilo = PrecioXKilo; }
        this.refreshModel(newOrderModel);
    };

    changePriceInvntItem = (price, index, onblurPrice) => {
        const { newOrderModel, showAlert } = this.props;

        if (isNaN(price) || Number(price) < 0) {
            showAlert({ type: "error", message: 'Ingresa un valor valido.', timeOut: 5000 });
            return;
        } else if (onblurPrice) { price = Number(price).toFixed(2); }

        newOrderModel.Items[index].Price = price;
        newOrderModel.Items[index].HomePrice = price;

        this.refreshTotal(newOrderModel, index);
    };

    changePriceService = (event, index) => {
        const { newOrderModel } = this.props;
        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                newOrderModel.service[index].HomePrice = event.nativeEvent.target.value;
            }
        }

        this.refreshTotalService(newOrderModel, index);
    };

    returnValueItem = (FieldID, index) => {
        const { newOrderModel } = this.props;
        let value = "";
        switch (FieldID) {
            case 0:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields1 : "";
                break;
            case 1:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields2 : "";
                break;
            case 2:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields3 : "";
                break;
            case 3:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields4 : "";
                break;
            case 4:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields5 : "";
                break;
            case 5:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields6 : "";
                break;
            case 6:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields7 : "";
                break;
            case 7:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields8 : "";
                break;
            case 8:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields9 : "";
                break;
            case 9:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields10 : "";
                break;
            case 10:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields11 : "";
                break;
            case 11:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields12 : "";
                break;
            case 12:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields13 : "";
                break;
            case 13:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields14 : "";
                break;
            case 14:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields15 : "";
                break;
            case 15:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields16 : "";
                break;
            case 16:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields17 : "";
                break;
            case 17:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields18 : "";
                break;
            case 18:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields19 : "";
                break;
            case 19:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields20 : "";
                break;
            case 20:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields21 : "";
                break;
            case 21:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields22 : "";
                break;
            case 22:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields23 : "";
                break;
            case 23:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields24 : "";
                break;
            case 24:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields25 : "";
                break;
            case 25:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields26 : "";
                break;
            case 26:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields27 : "";
                break;
            case 27:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields28 : "";
                break;
            case 28:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields29 : "";
                break;
            case 29:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields30 : "";
                break;
            case 30:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields31 : "";
                break;

            default:
                break;

        }

        return value;
    }

    changeUserFieldsItemsDocument = async (event, IdValue, index, fieldId = null) => {
        const { refreshModel, view, showAlert } = this.props;
        let { newOrderModel } = this.props;

        if (fieldId != null && Number(fieldId) === isCilindrosVaciosDevueltos) {
            const rawValue = event.nativeEvent.target.value;
            if (rawValue !== '' && !/^\d+$/.test(rawValue)) {
                showAlert({ type: 'warning', message: 'Solo se permiten números en la cantidad de cilindros vacíos devueltos.' });
                return;
            }
        }

        switch (IdValue) {
            case 0:
                newOrderModel.Items[index].UserFieldsItem.userFields1 = event.nativeEvent.target.value;
                if (view === 'invoice' || view === 'deliveries' || (view === 'orderSales' && (newOrderModel?.OriginDocumentCreate === 'invoice' || newOrderModel?.OriginDocumentCreate === 'deliveries'))) {
                    const parentLineNum_3 = newOrderModel.Items[index].LineNum;
                    if (newOrderModel.Items[index].isAdministrativeExpenseParent) {
                        newOrderModel.Items = newOrderModel.Items.filter(
                            item => item.ParentLineNum !== parentLineNum_3
                        );
                    }
                }
                break;
            case 1:
                newOrderModel.Items[index].UserFieldsItem.userFields2 = event.nativeEvent.target.value;

                if (view === 'invoice' || view === 'deliveries' || (view === 'orderSales' && (newOrderModel?.OriginDocumentCreate === 'invoice' || newOrderModel?.OriginDocumentCreate === 'deliveries'))) {
                    const parentLineNum = newOrderModel.Items[index].LineNum;

                    if (newOrderModel.Items[index].isAdministrativeExpenseParent) {
                        newOrderModel.Items = newOrderModel.Items.filter(
                            item => item.ParentLineNum !== parentLineNum
                        );
                    }

                    newOrderModel.Items[index].isAdministrativeExpenseParent = '';

                    if (Number(event.nativeEvent.target.value) === 1) {
                        await this.SearchAdministrativeExpenses(newOrderModel.Items[index]);
                    }
                }
                break;
            case 2:
                newOrderModel.Items[index].UserFieldsItem.userFields3 = event.nativeEvent.target.value;

                if (view === 'invoice' || view === 'deliveries' || (view === 'orderSales' && (newOrderModel?.OriginDocumentCreate === 'invoice' || newOrderModel?.OriginDocumentCreate === 'deliveries'))) {
                    if (newOrderModel.Items[index].UserFieldsItem.userFields3.indexOf(" ") !== -1 || newOrderModel.Items[index].UserFieldsItem.userFields3.indexOf("-") !== -1) {
                        break;
                    }
                    const parentLineNum_1 = newOrderModel.Items[index].LineNum;
                    const childItems = newOrderModel.Items.filter(i => i.ParentLineNum === parentLineNum_1);

                    childItems.forEach(child => {
                        child.Quantity = Number(newOrderModel.Items[index].Quantity) - Number(event.nativeEvent.target.value);
                    });
                }
                break;
            case 3:
                newOrderModel.Items[index].UserFieldsItem.userFields4 = event.nativeEvent.target.value;
                if (newOrderModel.isPurchaseDocument && (newOrderModel.RetencionVista || newOrderModel?.newView === 'PurchaseOrder')) {
                    newOrderModel = await this.checkWithHolding(newOrderModel);
                }
                break;
            case 4:
                newOrderModel.Items[index].UserFieldsItem.userFields5 = event.nativeEvent.target.value;
                break;
            case 5:
                newOrderModel.Items[index].UserFieldsItem.userFields6 = event.nativeEvent.target.value;
                break;
            case 6:
                newOrderModel.Items[index].UserFieldsItem.userFields7 = event.nativeEvent.target.value;
                break;
            case 7:
                newOrderModel.Items[index].UserFieldsItem.userFields8 = event.nativeEvent.target.value;
                break;
            case 8:
                newOrderModel.Items[index].UserFieldsItem.userFields9 = event.nativeEvent.target.value;
                break;
            case 9:
                newOrderModel.Items[index].UserFieldsItem.userFields10 = event.nativeEvent.target.value;
                break;
            case 10:
                newOrderModel.Items[index].UserFieldsItem.userFields11 = event.nativeEvent.target.value;
                break;
            case 11:
                newOrderModel.Items[index].UserFieldsItem.userFields12 = event.nativeEvent.target.value;
                break;
            case 12:
                newOrderModel.Items[index].UserFieldsItem.userFields13 = event.nativeEvent.target.value;
                break;
            case 13:
                newOrderModel.Items[index].UserFieldsItem.userFields14 = event.nativeEvent.target.value;
                break;
            case 14:
                newOrderModel.Items[index].UserFieldsItem.userFields15 = event.nativeEvent.target.value;
                break;
            case 15:
                newOrderModel.Items[index].UserFieldsItem.userFields16 = event.nativeEvent.target.value;
                break;
            case 16:
                newOrderModel.Items[index].UserFieldsItem.userFields17 = event.nativeEvent.target.value;
                break;
            case 17:
                newOrderModel.Items[index].UserFieldsItem.userFields18 = event.nativeEvent.target.value;
                break;
            case 18:
                newOrderModel.Items[index].UserFieldsItem.userFields19 = event.nativeEvent.target.value;
                break;
            case 19:
                newOrderModel.Items[index].UserFieldsItem.userFields20 = event.nativeEvent.target.value;
                break;
            case 20:
                newOrderModel.Items[index].UserFieldsItem.userFields21 = event.nativeEvent.target.value;
                break;
            case 21:
                newOrderModel.Items[index].UserFieldsItem.userFields22 = event.nativeEvent.target.value;
                break;
            case 22:
                newOrderModel.Items[index].UserFieldsItem.userFields23 = event.nativeEvent.target.value;
                break;
            case 23:
                newOrderModel.Items[index].UserFieldsItem.userFields24 = event.nativeEvent.target.value;
                break;
            case 24:
                newOrderModel.Items[index].UserFieldsItem.userFields25 = event.nativeEvent.target.value;
                break;
            case 25:
                newOrderModel.Items[index].UserFieldsItem.userFields26 = event.nativeEvent.target.value;
                break;
            case 26:
                newOrderModel.Items[index].UserFieldsItem.userFields27 = event.nativeEvent.target.value;
                break;
            case 27:
                newOrderModel.Items[index].UserFieldsItem.userFields28 = event.nativeEvent.target.value;
                break;
            case 28:
                newOrderModel.Items[index].UserFieldsItem.userFields29 = event.nativeEvent.target.value;
                break;
            case 29:
                newOrderModel.Items[index].UserFieldsItem.userFields30 = event.nativeEvent.target.value;
                break;
            case 30:
                newOrderModel.Items[index].UserFieldsItem.userFields31 = event.nativeEvent.target.value;
                break;

            default:
                break
        }

        if (fieldId != null) {
            const entregaKey = this.getUserFieldKey(isEntregaCilindro);
            const cilindrosKey = this.getUserFieldKey(isCilindrosVaciosDevueltos);
            const tipoConvenioKey = this.getUserFieldKey(isTipoConvenio);
            const item = newOrderModel.Items[index];
            const uf = item?.UserFieldsItem;
            const quantity = Number(item.Quantity || 0);

            const cleanUpTipoConvenio = () => {
                if (tipoConvenioKey && uf) {
                    uf[tipoConvenioKey] = '-';
                }
                if (item.isAdministrativeExpenseParent) {
                    const parentLineNum = item.LineNum;
                    newOrderModel.Items = newOrderModel.Items.filter(
                        i => i.ParentLineNum !== parentLineNum
                    );
                    item.isAdministrativeExpenseParent = '';
                }
            };

            if (uf && entregaKey && cilindrosKey) {

                if (Number(fieldId) === isEntregaCilindro) {
                    if (uf[entregaKey] === "1") {
                        uf[cilindrosKey] = quantity.toString();
                        cleanUpTipoConvenio();
                    } else if (uf[entregaKey] === "2") {
                        uf[cilindrosKey] = '0';
                    } else {
                        uf[cilindrosKey] = '0';
                    }
                }

                else if (Number(fieldId) === isCilindrosVaciosDevueltos && uf[entregaKey] === "2") {
                    const cilindrosValue = Number(uf[cilindrosKey] || 0);

                    if (uf[cilindrosKey] !== '' && cilindrosValue >= quantity) {
                        uf[entregaKey] = "1";
                        uf[cilindrosKey] = quantity.toString();
                        cleanUpTipoConvenio();
                        showAlert({ type: 'info', message: 'Como la cantidad de cilindros vacíos devueltos coincide o supera la cantidad del artículo, se cambió "¿Entrega Cilindro?" a SI.', timeOut: 6000 });
                    }
                }
            }
        }

        refreshModel(newOrderModel);
    };

    changeUserFieldsDocumentItemUnitMed = (event, index) => {
        const { newOrderModel, view } = this.props;
        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? newOrderModel.Items[index].SalPackUn : newOrderModel.Items[index].PurPackUn;
        newOrderModel.Items[index].UserBaseUn = event.nativeEvent.target.value;
        if (newOrderModel.Items[index].UserBaseUn === 'N') {
            if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'purchaseReturn') {
                newOrderModel.Items[index].HomePrice = newOrderModel.Items[index].newHomePrice;
                newOrderModel.Items[index].Price = newOrderModel.Items[index].newPrice;
            } else {
                newOrderModel.Items[index].HomePrice = parseFloat(newOrderModel.Items[index].newHomePrice).toFixed(2) * measureUnit;
                newOrderModel.Items[index].Price = parseFloat(newOrderModel.Items[index].newPrice).toFixed(2) * measureUnit;
                newOrderModel.Items[index].NumPerMsr = measureUnit;
            }
        } else if (newOrderModel.Items[index].UserBaseUn === 'Y') {
            newOrderModel.Items[index].HomePrice = newOrderModel.Items[index].newHomePrice;
            newOrderModel.Items[index].Price = newOrderModel.Items[index].newPrice;
            newOrderModel.Items[index].NumPerMsr = 1;
        }
        this.refreshTotal(newOrderModel, index);
    };

    validatePriceNull = (index, newValue = 0) => {
        const { newOrderModel, view } = this.props;
        let isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;
        if (Sections['HistoricalPrices'] && isOPRQ && newOrderModel?.Items?.[index]?.hasHistoricalPrice) {
            return;
        }
        let value = newOrderModel.Items[index].Quantity;

        if (value.length == 0) {
            newOrderModel.Items[index].Price = 0;
        }
        if (isAnticipo(newOrderModel.Items[index].ItemCode) && !isNaN(newValue)) {
            newOrderModel.Items[index].Price = newValue;
            newOrderModel.Items[index].HomePrice = newValue;
            newOrderModel.Items[index].PriceAfterVAT = null;
        }
        this.refreshTotal(newOrderModel, index);
    };

    validatePaymentPriceNull = async (index) => {
        const { newOrderModel } = this.props;

        let value = newOrderModel?.ItemsPayments[index]?.Price || '';

        if (value?.length === 0 || value === 'NaN' || !value) {
            newOrderModel.ItemsPayments[index].Price = 0;
        }

        newOrderModel.ItemsPayments[index].PriceFormat = FORMAT_NUMBER.new(newOrderModel.ItemsPayments[index].Price);
        await this.refreshTotal(newOrderModel);
    };

    validateKilosXComprar = index => {
        const { newOrderModel } = this.props;
        let value = newOrderModel.Items[index].KilosXComprar;
        if (!value) { newOrderModel.Items[index].KilosXComprar = 0; }
        this.refreshTotal(newOrderModel, index);
    };

    validatePesosXPieza = index => {
        const { newOrderModel } = this.props;
        let value = newOrderModel.Items[index].PesosXPieza;
        if (!value) { newOrderModel.Items[index].PesosXPieza = 0; }
        this.refreshTotal(newOrderModel, index);
    };

    validatePrecioXKilo = index => {
        const { newOrderModel } = this.props;
        let value = newOrderModel.Items[index].PrecioXKilo;
        if (!value) { newOrderModel.Items[index].PrecioXKilo = 0; }
        this.refreshTotal(newOrderModel, index);
    };

    changeNewAvgPrice = (event, index) => {
        const { newOrderModel } = this.props;
        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ' && event.nativeEvent.data != '-') {
                newOrderModel.Items[index].NewAvgPrice = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(newOrderModel);
    }

    specialPrice = async (index) => {
        const { newOrderModel, view, enableSpinner, showAlert, selectTable } = this.props;
        let quantity = newOrderModel.Items[index].Quantity;
        const isPurchaseQuotationDraft = newOrderModel?.newView === 'PurchaseQuotationDraft' || view === 'PurchaseQuotationDraft';
        const isCopy = newOrderModel.isSelectToActive || newOrderModel.isSelectOfActive; // Se copia el documento
        const isCopyToOPOR = isCopy && newOrderModel?.newView === 'PurchaseOrder';
        if ((isPurchaseQuotationDraft || isCopyToOPOR) && newOrderModel.Items[index].PQTReqQty) {
            const reqQty = Number(newOrderModel.Items[index].PQTReqQty);
            if (!isNaN(quantity) && quantity !== '' && Number(quantity) > reqQty) {
                showAlert({
                    type: 'warning',
                    message: `La cantidad de la línea ${newOrderModel.Items[index].ItemCode || newOrderModel.Items[index].ItemName || ''} no puede ser mayor a la cantidad requerida. Se ha ajustado la cantidad`,
                    timeOut: 8000
                });
                newOrderModel.Items[index].Quantity = reqQty;
                quantity = reqQty;
            }
        }

        const entregaKeyBlur = this.getUserFieldKey(isEntregaCilindro);
        const cilindrosKeyBlur = this.getUserFieldKey(isCilindrosVaciosDevueltos);
        const tipoConvenioKeyBlur = this.getUserFieldKey(isTipoConvenio);
        const itemBlur = newOrderModel.Items[index];
        const ufBlur = itemBlur?.UserFieldsItem;
        const finalQuantityBlur = Number(quantity || 0);

        if (ufBlur && entregaKeyBlur && cilindrosKeyBlur) {
            if (ufBlur[entregaKeyBlur] === "2") {
                const currentCUBlur = Number(ufBlur[cilindrosKeyBlur] || 0);
                if (currentCUBlur >= finalQuantityBlur) {
                    ufBlur[entregaKeyBlur] = "1";
                    ufBlur[cilindrosKeyBlur] = finalQuantityBlur.toString();

                    if (tipoConvenioKeyBlur) {
                        ufBlur[tipoConvenioKeyBlur] = '-';
                    }
                    if (itemBlur.isAdministrativeExpenseParent) {
                        const parentLineNumBlur = itemBlur.LineNum;
                        newOrderModel.Items = newOrderModel.Items.filter(
                            i => i.ParentLineNum !== parentLineNumBlur
                        );
                        itemBlur.isAdministrativeExpenseParent = '';
                    }

                    showAlert({ type: 'info', message: 'Al cambiar la cantidad se ha ajustado la cantidad de cilindros vacíos devueltos, "¿Entrega Cilindro?" se cambió a SI.', timeOut: 6000 });
                }
            } else if (ufBlur[entregaKeyBlur] === "1") {
                ufBlur[cilindrosKeyBlur] = finalQuantityBlur.toString();
            }
        }


        const envasado = Envasados?.includes(Number(newOrderModel.Items[index].ItmsGrpCod));
        const glpGranel = Granel?.includes(Number(newOrderModel.Items[index].ItmsGrpCod));

        if ((view === 'invoice' || view === 'orderSales' || view === 'debitNote' || view === "invoiceReserve") && newOrderModel.OriginDocumentCreate !== "creditNote" && (!envasado && !glpGranel)) {
            let cardCode = newOrderModel.CardCode;
            let itemCode = newOrderModel.Items[index].ItemCode;
            let docDate = newOrderModel.DocDate;
            let data = {
                CardCode: cardCode,
                ItemCode: itemCode,
                Quantity: quantity,
                DocDate: docDate,
            }
            let getItemResponse = await apiClient.getItemPrice(data);
            if (getItemResponse.status === 1) {
                newOrderModel.Items[index].HomePrice = getItemResponse.data.Price;
                newOrderModel.Items[index].DiscountPercent = getItemResponse.data.DiscountPercent;
            }
        }

        if (view === 'invoice') {
            const parentLineNum = newOrderModel.Items[index].LineNum;
            const CU = newOrderModel.Items[index].UserFieldsItem.userFields3 || 0;

            const childItems = newOrderModel.Items.filter(i => i.ParentLineNum === parentLineNum);

            childItems.forEach(child => {
                child.Quantity = Number(quantity) - Number(CU);
            });
            if (newOrderModel.Items[index].ParentLineNum !== null && newOrderModel.Items[index].ParentLineNum !== undefined) {
                const parentItem = newOrderModel.Items.find(i => i.LineNum === Number(newOrderModel.Items[index].ParentLineNum));
                if (parentItem) parentItem.Quantity = quantity;
            }
        }
        await this.refreshTotal(newOrderModel, index);
        // await this.ValidateTaxCodePerceptions(index); // Se comenta por que el calculo se realiza desde la función calculatePerception, NO desde consulta
        let checkPrice = false;
        //#region Precio Llamagas
        // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
        if ((newOrderModel?.isSalesDocument)) {
            const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = newOrderModel.Items[index] ?? {}
            const envasado = Envasados?.includes(Number(ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(ItmsGrpCod));
            let searchItem = ItemCode;

            if (!isTemporary && searchItem && (envasado || glpGranel)) {
                let getItemResponse = null;
                const newView = newOrderModel?.newView || view;
                let table = selectTable(newView);
                const data = {
                    CardCode: newOrderModel?.CardCode || "",
                    ItemCode: searchItem || "",
                    WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : WhsCode,
                    ShipToCode: newOrderModel?.ShipToCode || "",
                    userFields: newOrderModel?.userFields || {},
                    Quantity,
                    U_RS_CANTG,
                    U_RS_UMED,
                    U_RS_PRECIOGL,
                    gallonsPrice: true,
                    DocDueDate: newOrderModel?.DocDueDate,
                    TaxDate: newOrderModel?.TaxDate,
                    ObjType: table?.docType,
                };

                //#region GALLON PRICE
                enableSpinner(true);
                let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);
                const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                data.U_RS_PRECIOGL = U_RS_PRECIO;
                data.gallonsPrice = false;
                //#endregion GALLON PRICE

                enableSpinner(true);
                getItemResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);

                const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                const item = newOrderModel.Items[index] || {};
                item.Price = U_RS_CALCULADO;
                checkPrice = true;

                if (glpGranel) {
                    newOrderModel.Items[index].U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIOGL || 0)?.toFixed(priceDecimalPrecision));
                    newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                }

                let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                    newOrderModel.Items[index].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    newOrderModel.Items[index].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                } else {
                    newOrderModel.Items[index].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    newOrderModel.Items[index].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                }

                newOrderModel.Items[index].newHomePrice = item.Price || 0;
                newOrderModel.Items[index].newPrice = item.Price || 0;
                newOrderModel.Items[index].cHomePrice = item.Price || 0;
                newOrderModel.Items[index].cPrice = item.Price || 0;
                if (getItemResponse?.status === 1) {
                    showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar la cantidad.', timeOut: 5000 });
                } else {
                    showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar la cantidad.', timeOut: 5000 });
                }
            }
        }
        //#endregion Precio Llamagas
        if (checkPrice) {
            await this.refreshTotal(newOrderModel);
        }
    };


    ValidateTaxCodePerceptions = async (index) => {
        const { view, newOrderModel } = this.props;
        if (view === 'invoice') {

            const data = {
                CardCode: newOrderModel.CardCode,
                Quantity: newOrderModel.Items[index].Quantity,
                LineTotal: newOrderModel.Items[index].Total,
                ItemCode: newOrderModel.Items[index].ItemCode,
            }
            const percepResponse = await apiClient.getItemTaxCodePerceptions(data);
            if (percepResponse.status === 1) {
                newOrderModel.Items[index].TaxCode = percepResponse.data.Code || '';
                newOrderModel.Items[index].TaxeRate = percepResponse.data.Rate || 0;
                this.refreshTotal(newOrderModel);
            }
        }
    }



    //#region ########## Billing Fields ##########
    changeOperation = (index, value) => {
        let { newOrderModel } = this.props;
        let item = newOrderModel.Items[index];
        item.U_BPP_OPER = value;
        item = this.setItemIgvOptions(item);
        this.refreshTotal(newOrderModel);
    }

    setItemIgvOptions = (item, auxCode = null) => {
        /**
         * TIPO VENTA *************** INDICADOR DE IMPUESTO  **** TIPO DE OPERACION **** CODIGO DE AFECTACION   **** ESTATUS
         * GRAVADA                      IGV                             AFECTA                  10                      OK
         * GRATUITA GRAVADA             IGV                             GRATUITA                11-17                   OK
         * 
         * GRATUITA                     EXO                             GRATUITA                11-16                   OK
         * EXONERADA                    EXO                             EXONERADA               20                      OK
         * EXONERADA GRATUITA           EXO                             GRATUITA                21                      OK
         * INAFECTA                     EXO                             INAFECTA                30                      OK
         * INAFECTA RETIROS             EXO                             INAFECTA                31-36                   OK
         * INAFECTA GRATUITA            EXO                             INAFECTA GRATUITO       37                      OK
         * EXPORTACION                  EXO                             EXPORTACION             40                      OK
         */
        let { igvOperationList = [] } = this.state;
        let availableIgvOperationList = [];
        let isIGV = !item?.TaxCode?.includes("EXO") && (item.TaxCode?.includes("IGV") || item.TaxName?.toUpperCase()?.includes("IGV"));
        let isEXO = item.TaxCode?.includes("EXO") || item.TaxName?.toUpperCase()?.includes("EXO") || item.TaxName?.toUpperCase()?.includes("EXENTO");

        // if (item.TaxCode?.includes("IGV")) {
        if (isIGV) {
            switch (item.U_BPP_OPER) {
                case "A":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === 10);
                    break;
                case "G":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) > 10 && Number(Code) < 18);
                    break;
                default:
                    break;
            }
            // } else if (item.TaxCode?.includes("EXO")) {
        } else if (isEXO) {
            switch (item.U_BPP_OPER) {
                case "E":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === 20);
                    break;
                case "I":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) > 29 && Number(Code) < 37);
                    break;
                case "G":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => (Number(Code) > 10 && Number(Code) < 17) || Number(Code) === 21);
                    break;
                case "EX":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === 40);
                    break;
                case "IG":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === 37);
                    break;
                default:
                    break;
            }
        }

        item.availableIgvOperationList = availableIgvOperationList;
        if (availableIgvOperationList.length === 1) {
            item.U_STR_FECodAfect = availableIgvOperationList[0].Code;
        } else if (isEXO && item.U_BPP_OPER === 'G' && auxCode) {
            availableIgvOperationList = igvOperationList?.filter(({ Code }) => Number(Code) === auxCode);
            item.U_STR_FECodAfect = availableIgvOperationList?.[0]?.Code || '';
        } else {
            item.U_STR_FECodAfect = "";
        }

        return item;
    }

    changeIgvOperation = (index, value) => {
        let { newOrderModel } = this.props;
        let item = newOrderModel.Items[index];
        item.U_STR_FECodAfect = value;
        this.refreshTotal(newOrderModel);
    }
    //#endregion

    changeDiscountItem = (event, index) => {
        const { newOrderModel } = this.props;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                newOrderModel.Items[index].DiscountPercent = event.nativeEvent.target.value;
            }
        }

        this.refreshTotal(newOrderModel, index);
    };

    validateDiscountNull = index => {
        const { newOrderModel } = this.props;
        let value = newOrderModel.Items[index].DiscountPercent;

        if (value.length == 0) {
            newOrderModel.Items[index].DiscountPercent = 0;
        }
        this.refreshTotal(newOrderModel, index);
    };

    changeTotalInvoicePaynent = (event, index) => {
        const { newOrderModel } = this.props;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                newOrderModel.ItemsPayments[index].totalPago = event.nativeEvent.target.value;
            }
        }

        this.refreshTotal(newOrderModel);
    };

    validateTotalInvoicePaymentNullORIGINAL = index => {
        const { newOrderModel, showAlert } = this.props;
        let value = newOrderModel.ItemsPayments[index].totalPago;

        if (value.length == 0) {
            newOrderModel.ItemsPayments[index].totalPago = newOrderModel.ItemsPayments[index].pastDueBalance;
        }

        if (value > newOrderModel.ItemsPayments[index].pastDueBalance) {
            showAlert({ type: 'info', message: 'El valor ingresado es mayor que el saldo vencido' });
            newOrderModel.ItemsPayments[index].totalPago = newOrderModel.ItemsPayments[index].pastDueBalance;
        }
        this.refreshTotal(newOrderModel);
    };

    validateTotalInvoicePaymentNull = index => {
        const { newOrderModel, showAlert } = this.props;

        let item = newOrderModel.ItemsPayments[index];
        let value = Number(item.totalPago ?? 0);
        let flagPerception = false;

        if (!value || value?.length === 0) {
            item.totalPago = item.pastDueBalance;
            item.U_PRC_IMP = item.auxU_PRC_IMP;
            flagPerception = true;
            value = Number(item.totalPago);
        }

        if (value > Number(item.pastDueBalance)) {
            showAlert({ type: 'info', message: 'El valor ingresado es mayor que el saldo vencido' });
            item.totalPago = item.pastDueBalance;
            item.U_PRC_IMP = item.auxU_PRC_IMP;
            flagPerception = true;
            value = Number(item.totalPago);
        }

        if (value < 0) {
            showAlert({ type: 'info', message: 'El valor ingresado no puede ser negativo' });
            item.totalPago = item.pastDueBalance;
            item.U_PRC_IMP = item.auxU_PRC_IMP;
            flagPerception = true;
            value = Number(item.totalPago);
        }

        //#region CREDIT PERCEPTIONS
        if (!flagPerception && Number(item.originalU_PRC_IMP) > 0) {
            if (value === Number(item.pastDueBalance)) {
                item.U_PRC_IMP = item.auxU_PRC_IMP;
            } else {
                const porcentaje = value === 0 ? 0 : value / Number(item.pastDueBalance);
                // item.U_PRC_IMP = roundToDecimals(Number(item.auxU_PRC_IMP || 0) * porcentaje,6);
                item.U_PRC_IMP = roundToDecimals(Number(item.auxU_PRC_IMP || 0) * porcentaje, 2);
            }
        }
        //#endregion CREDIT PERCEPTIONS

        this.refreshTotal(newOrderModel);
    };

    changeParcialidadPayment = (event, index) => {
        const { newOrderModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newOrderModel.ItemsPayments[index].U_Parcialidad = event.nativeEvent.target.value;
        }

        this.refreshTotal(newOrderModel);
    };

    changeDiscountDocument = event => {
        const { newOrderModel } = this.props;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                let discount = newOrderModel.Subtotal * (event.nativeEvent.target.value / 100);
                newOrderModel.DiscountPercent = event.nativeEvent.target.value;
                newOrderModel.Discount = discount;
            }
        }
        this.refreshTotal(newOrderModel);
    };

    ChangeField = async (field, value) => {
        const { newOrderModel } = this.state;
        if (field === 'U_RS_SOLAPR') {
            let U_RS_SOLAPR = newOrderModel[field];
            if (!U_RS_SOLAPR) {
                value = 'Y'
            } else {
                value = U_RS_SOLAPR === 'Y' ? 'N' : 'Y';
            }
        }
        newOrderModel[field] = value;
        await this.setState({ newOrderModel });
    }

    validateDiscountDocumentNull = () => {
        const { newOrderModel } = this.props;
        let value = newOrderModel.DiscountPercent;

        if (value.length == 0) {
            newOrderModel.DiscountPercent = 0;
        }
        this.refreshTotal(newOrderModel);
    };

    validatePagoACuentaNull = () => {
        const { newOrderModel } = this.props;
        let value = newOrderModel.NoDocSum;
        if (value.length == 0) {
            newOrderModel.NoDocSum = 0;
        }
        this.refreshTotal(newOrderModel);
    };

    refreshModel = newOrderModel => {
        const { refreshModel } = this.props;
        refreshModel(newOrderModel);
    };

    checkWithHolding = async (newOrderModel = {}) => {
        const { view, action, getUserFieldHeaderValue } = this.props;
        const { editMode } = this.state;
        try {
            if ((newOrderModel.RetencionVista || newOrderModel?.newView === 'PurchaseOrder') && (Number(action) === 1 || (Number(action) === 2 && editMode))) {
                const { U_FMB_BP_Reten = 'N', U_STR_BC = 'N', U_STR_AR = 'N', U_STR_AP = 'N', Total = 0, totalPago = 0, newView = '', Items = [], LicTradNum = '', U_BPP_BPTD = -1, ItemsPayments = [], DocCur = 'SOL' } = newOrderModel || {};
                const docView = newView || view;
                const isOutgoingPayment = docView === 'outgoingPayment';
                const isU_FMB_BP_Reten = U_FMB_BP_Reten === 'Y';    // El socio tiene retención
                const isU_STR_BC = U_STR_BC === 'Y';                // El socio es buen contribuyente
                const isU_STR_AR = U_STR_AR === 'Y';                // El socio es agente de retención
                const isU_STR_AP = U_STR_AP === 'Y';                // El socio es agente de percepción
                const isIGV = Items?.some((item) => !item?.TaxCode?.includes("EXO") && (item.TaxCode?.includes("IGV") || item.TaxName?.toUpperCase()?.includes("IGV")));
                const isDetraccion = newOrderModel?.U_STR_AfctoDtr === 'Y' || Items?.some((item) => item?.U_RML_AFEDET === 'Y');

                let totalConvert = !isOutgoingPayment ? calcultateOperationHeader(newOrderModel) : { totalLocal: 0 };
                totalConvert = Number(totalConvert?.totalLocal || 0) || 0;

                let totalPagoConvert = isOutgoingPayment ? calcultateOperationHeader(newOrderModel, true) : { totalLocal: 0 };
                totalPagoConvert = Number(totalPagoConvert?.totalLocal || 0) || 0;

                const documentTotal = !isOutgoingPayment && Number(totalConvert || 0) > 700;
                const documentPaymentTotal = isOutgoingPayment && Number(totalPagoConvert || 0) > 700;
                const RUC = LicTradNum && Number(U_BPP_BPTD || -1) === 6; // El socio tenga RUC y el tipo de documento sea RUC -> Contribuyente nacional

                //#region Importación
                let importacion = false;
                const aliasToFind = "U_tipoOpT12";
                const headers = newOrderModel?.userFieldsBody || [];
                const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                if (bodyMatch) {
                    const fieldId = bodyMatch?.header?.FieldID;
                    const options = bodyMatch?.options || [];
                    const allFields = json?.allItemsUserFields || [];
                    const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                    if (foundIndex !== -1) {
                        const fieldNumber = foundIndex + 1;
                        const importacionValue = options?.find(option => option?.Descr?.toUpperCase() === 'IMPORTACIÓN' || option?.Descr?.toUpperCase() === 'IMPORTACION')?.FldValue || '';
                        importacion = Items?.some((item) => item?.UserFieldsItem[`userFields${fieldNumber}`] === importacionValue);
                    }
                }
                importacion = !importacion ? newOrderModel?.U_RS_IMP === 'Y' || newOrderModel?.U_RS_IMP === true : importacion;
                //#endregion Tipo de operacion

                const U_BPP_MDTD = docView === 'purchaseInvoice' ? getUserFieldHeaderValue('U_BPP_MDTD', newOrderModel) : -1;
                const is01 = docView === 'purchaseInvoice' ? Number(U_BPP_MDTD || -1) === 1 : false;
                const existWithHolding = isOutgoingPayment && ItemsPayments?.some((item) => item?.U_LLG_RETENCI === 'Y');

                if (isU_FMB_BP_Reten && // El socio tiene retención
                    !isU_STR_BC &&      // El socio no debe de ser buen contribuyente
                    !isU_STR_AR &&      // El socio no debe de ser agente de retención
                    !isU_STR_AP &&      // El socio no debe de ser agente de percepción
                    (
                        ( // Aqui es para compras
                            !isOutgoingPayment &&   // No es pago efectuado
                            isIGV &&                // Alguna linea tiene IGV
                            documentTotal &&        // Total mayor a 700
                            !isDetraccion &&        // Ninguna linea del documento es detraccion
                            RUC &&                  // El socio tiene un RUC
                            !importacion &&         // No corresponde a una importacion
                            (
                                (docView === 'purchaseInvoice' && is01) // En caso de ser factura debe de ser de tipo 01
                                || !docView !== 'purchaseInvoice'
                            )
                        )
                        ||
                        ( // Aqui es para pago efectuado
                            isOutgoingPayment &&            // Es pago efectuado
                            (
                                documentPaymentTotal        // Total mayor a 700
                                ||
                                (!documentPaymentTotal &&   // El monto es menor o igual a 700
                                    existWithHolding        // La factura aplico a retención
                                )
                            )
                        )
                    )
                ) { // Aplica a retención
                    newOrderModel.U_LLG_RETENCI = 'Y';
                    if (isOutgoingPayment && documentPaymentTotal && !existWithHolding) {
                        newOrderModel.WithHoldingPrev = true; // Cuando es pago efectuado con total mayor a 700 pero ninguna factura tuvo retención, no permitir crear el pago (No es posible crear retenciones)
                    } else {
                        newOrderModel.WithHoldingPrev = false;
                    }
                    if (!isOutgoingPayment) {
                        newOrderModel.MONRET = Number((Number(Total || 0) * (0.03))?.toFixed(2));
                    } else {
                        newOrderModel.MONRET = 0;
                    }
                } else { // No aplica a retención
                    newOrderModel.U_LLG_RETENCI = 'N';
                    newOrderModel.MONRET = 0;
                }
            }
        } catch (error) {
            // console.log('checkWithHolding -> Error:', error);
        }
        return newOrderModel;
    }

    changeDocumentType = value => {
        const { newOrderModel } = this.props;
        newOrderModel.DocumentType = value;

        this.refreshModel(newOrderModel);
    };

    toggleCheckBoxPagoACuenta = (event) => {
        const { newOrderModel } = this.props;
        newOrderModel.PayNoDoc = event.nativeEvent.target.checked;

        if (!event.nativeEvent.target.checked) {
            newOrderModel.BpAct = newOrderModel.BpActCopy;
            newOrderModel.BpActName = newOrderModel.BpActNameCopy;
            newOrderModel.NoDocSum = 0;
        }

        this.refreshTotal(newOrderModel);
    };

    openAddresses = async type => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        if ((!newOrderModel?.isTransferDocument && !this.validatePartner()) || (newOrderModel?.isTransferDocument && (!newOrderModel?.CardCode && !newOrderModel?.CardName))) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        if (newOrderModel.Addresses.length > 0) {
            $('#addressesModal').modal('show');
            return;
        }
        enableSpinner(true);
        let getAddressResponse = await apiClient.getAddressParter(newOrderModel.CardCode);
        enableSpinner(false);

        let data = [];
        if (type === 1) {
            if (getAddressResponse.data.deliveriesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }

            data = getAddressResponse.data.deliveriesAddress;
        } else {
            if (getAddressResponse.data.invoicesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
            data = getAddressResponse.data.invoicesAddress;
        }

        newOrderModel.Addresses = data;
        this.setState({
            newOrderModel,
        });

        $('#addressesModal').modal('show');

    };

    selectAddresses = async (action) => {
        const { newOrderModel } = this.props;
        const address = newOrderModel.Addresses[action.index];

        newOrderModel.TaxeDefaultPartner = address.TaxCode;
        newOrderModel.TaxeRateDefaultPartner = !!address.TaxCodeRate && address.TaxCodeRate !== null ? address.TaxCodeRate : 16;
        newOrderModel.TaxNameDefaultPartner = address.TaxCodeName || '';
        newOrderModel.ShipToCode = address.Address;
        newOrderModel.Address2 = (address.Street ? address.Street : '') + ' ' + (address.Block ? address.Block : '') + '  ' + (address.City ? address.City : '') + ' ' + (address.ZipCode ? address.ZipCode : '') + ' ' + (address.State ? address.State : '') + ' ' + (address.Country ? address.Country : '') || "";
        if (newOrderModel?.isTransferDocument) {
            newOrderModel.Address = newOrderModel.Address2;
        }
        if (newOrderModel?.isSalesDocument && address?.AdresType === 'S') { // NEW PROJECT LOGIC
            newOrderModel.Project = address?.U_FMB_Project || '';
            newOrderModel.UBIGEO = address?.ZipCode || '';
            newOrderModel.U_RMO_ID_DIRE = address?.U_RMO_ID_DIRE || '';
        }
        // SCOP keyCode
        newOrderModel.NeedScopCode = address?.U_FMB_FICHA_OSIN ? true : false;

        //#region Transportes de ORDR
        newOrderModel.CodigoAutotransporte = '';
        newOrderModel.CodigoUnidad = '';
        newOrderModel.PlacaVM = '';
        newOrderModel.TransportWhs = {};
        //#endregion Transportes de ORDR

        await this.refreshModel(newOrderModel);
        $('#addressesModal').modal('hide');

        //#region Precio Llamagas
        // if (newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) { // Al cambiar dirección consultar precios
        if (newOrderModel?.isSalesDocument) { // Al cambiar dirección consultar precios
            setTimeout(() => {
                this.checkItemPrices(true);
            }, 500);
        }
        //#endregion Precio Llamagas

    };

    edditAddres = async (index) => {
        const { newOrderModel } = this.props;
        await this.setState({
            editAddress: Object.assign({}, newOrderModel.Addresses[index]),
        });
        $('#addressModal').modal('show');
    };

    refreshAddress = async (editAddress) => {
        await this.setState({
            editAddress,
        });
    }

    aceptEditAddress = async (editAddress) => {
        const { newOrderModel } = this.props;
        newOrderModel.Addresses.map((address) => {
            if (address.Address === editAddress.Address) {
                address.Street = editAddress.Street;
                address.Block = editAddress.Block;
                address.City = editAddress.City;
                address.ZipCode = editAddress.ZipCode;
                address.County = editAddress.County;
                address.Country = editAddress.Country;
                address.State = editAddress.State;
            }
            return address
        });

        newOrderModel.ShipToCode = editAddress.Address;
        newOrderModel.Address2 = (editAddress.Street ? editAddress.Street : '') + ' ' + (editAddress.Block ? editAddress.Block : '') + '  ' + (editAddress.City ? editAddress.City : '') + ' ' + (editAddress.ZipCode ? editAddress.ZipCode : '') + ' ' + (editAddress.State ? editAddress.State : '') + ' ' + (editAddress.Country ? editAddress.Country : '') || "";

        await this.setState({
            newOrderModel,
            editAddress: null
        });

        $('#addressModal').modal('hide');
    }

    refreshTotal = async (newOrderModel, index = null) => {
        const { action, view } = this.props;
        const { editMode } = this.state
        let newView = newOrderModel.newView || '';

        if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || isMarketingDoc(newOrderModel?.ObjType)) {
            // Se requiere el siguiente orden para calcular percepciones
            newOrderModel = this.getTotals(newOrderModel);
            newOrderModel = this.calculatePerception(newOrderModel);
            newOrderModel = this.getTotals(newOrderModel, true);
        } else {
            // newOrderModel = this.calculatePerception(newOrderModel);
            if (index || index === 0) {


                newOrderModel.Items[index].Price = parseFloat(newOrderModel.Items[index].HomePrice).toFixed(priceDecimalPrecision) * (newOrderModel.Items[index].BaseQty || 1);
                // if (newOrderModel.Items[index]?.Gallons) { // Precio determinado por conversion a galones
                //     newOrderModel.Items[index].Price = Number(newOrderModel.Items[index].Quantity) > 0 ? parseFloat(Number(newOrderModel.Items[index].U_RS_TOTALGL || 0) / Number(newOrderModel.Items[index].Quantity))?.toFixed(priceDecimalPrecision) : 0
                // }
                let discount = newOrderModel.Items[index].Price * newOrderModel.Items[index].Quantity * (newOrderModel.Items[index].DiscountPercent / 100);
                newOrderModel.Items[index].Discount = discount || 0;

                let impuesto = parseFloat(((newOrderModel.Items[index].Price * newOrderModel.Items[index].Quantity - newOrderModel.Items[index].Discount)).toFixed(2)) * (newOrderModel.Items[index].TaxeRate / 100);
                newOrderModel.Items[index].TaxeResult = impuesto.toFixed(2);
                let total = 0;
                total = (newOrderModel.Items[index].Price / newOrderModel.ChangeRate) * newOrderModel.Items[index].Quantity - (newOrderModel.Items[index].Discount / newOrderModel.ChangeRate);
                total = calcultateOperation(newOrderModel.Items[index], newOrderModel)?.totalHeader ?? total

                newOrderModel.Items[index].Total = total;
                const priceWithTax = (newOrderModel?.Items?.[index]?.Price || 0) * (1 + ((newOrderModel?.Items?.[index]?.TaxeRate || 0) / 100))
                newOrderModel.Items[index].DiscountedPrice = priceWithTax - ((newOrderModel?.Items?.[index]?.DiscountPercent || 0) * priceWithTax / 100)


            } else {

                newOrderModel.Items.map(item => {
                    item.Price = Number(Number(item.HomePrice)).toFixed(priceDecimalPrecision) * (item.BaseQty || 1);
                    // if (item.Gallons) { // Precio determinado por conversion a galones
                    //     item.Price = Number(item.Quantity) > 0 ? parseFloat(Number(item.U_RS_TOTALGL || 0) / Number(item.Quantity))?.toFixed(priceDecimalPrecision) : 0
                    // }
                    let discount = item.Price * item.Quantity * (item.DiscountPercent / 100);
                    item.Discount = discount || 0;

                    let impuesto = item.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(item.ImpuestoRow / newOrderModel.ChangeRate) : round(parseFloat(((item.Price * item.Quantity - item.Discount)).toFixed(2)) * (item.TaxeRate / 100));
                    item.TaxeResult = impuesto.toFixed(2);
                    let total = 0;
                    total = (item.Price / newOrderModel.ChangeRate) * item.Quantity - (item.Discount / newOrderModel.ChangeRate);
                    total = calcultateOperation(item, newOrderModel)?.totalHeader ?? total
                    item.Total = item.ifChangeUomCode ? round(total) : item.LineTotal && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true ? round(item.LineTotal / newOrderModel.ChangeRate) : round(total);
                    if (this.props.newOrderModel.OriginDocumentCreate && this.props.newOrderModel.OriginDocumentCreate === 'deliveries' && this.props.view === 'invoiceReserve') {
                        item.Total = round(item.LineTotal / newOrderModel.ChangeRate);
                    }
                    const priceWithTax = (item?.Price || 0) * (1 + ((item?.TaxeRate || 0) / 100))
                    item.DiscountedPrice = priceWithTax - ((item?.DiscountPercent || 0) * priceWithTax / 100)
                });

            }



            let subTotal = 0;
            let impuestos = 0;
            let discount = 0;
            let total = 0;
            let weightTotal = 0;
            let taxesRate = 0;
            let subTotalTaxOnly = 0;
            let subTotalTaxStatus = 0;


            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const item = newOrderModel.Items[index];
                let discount = parseFloat(item.Total * ((newOrderModel.DiscountPercent || 0) / 100)).toFixed(2);

                let impuesto = item.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true && action === 1 ? round(item.ImpuestoRow / newOrderModel.ChangeRate) : round(parseFloat(((item.Total - discount)).toFixed(2)) * (item.TaxeRate / 100));
                item.TaxeResult = Number(Number(impuesto)).toFixed(2);
                const taxNotRounded = item.ImpuestoRow && newOrderModel.isSelectToActive !== true && newOrderModel.isSelectOfActive !== true && action === 1 ? (item.ImpuestoRow / newOrderModel.ChangeRate) : parseFloat(((item.Total - discount)) * (item.TaxeRate / 100));

                subTotalTaxStatus += item.TaxStatus == 'N' ? Number(taxNotRounded) : 0
                subTotalTaxOnly += item.TaxOnly == 'Y' ? Number(item.Total) : 0
                subTotal += parseFloat(Number(item.Total).toFixed(2));
                impuestos += parseFloat(Number(item.TaxeResult).toFixed(2));
                weightTotal += Number(item.Weight) * Number(item.Quantity);
                taxesRate += (item.TaxeRate / 100); // part of new code DpmAddition
            }
            taxesRate = taxesRate / newOrderModel.Items.length ?? 1;
            // last code before DpmAdding in BRANCH
            // let iva = (impuestos * 100) / subTotal;
            // let subtotalDpm = subTotal - newOrderModel.DpmAmnt;
            // discount = subtotalDpm * (newOrderModel.DiscountPercent / 100);
            // impuestos = subtotalDpm * (iva / 100);
            // total = parseFloat(parseFloat(subtotalDpm).toFixed(2) - parseFloat(discount).toFixed(2)) + parseFloat(parseFloat(impuestos).toFixed(2));

            newOrderModel.DpmAmnt = Number(newOrderModel.DownPaymentAmount) ?? 0.0;
            subTotal = subTotal - newOrderModel.DpmAmnt;
            discount = subTotal * (newOrderModel.DiscountPercent / 100);
            impuestos = subTotal * taxesRate;
            impuestos = Math.round(impuestos * 100) / 100
            total = parseFloat(parseFloat(subTotal).toFixed(2) - parseFloat(discount).toFixed(2)) + parseFloat(parseFloat(impuestos).toFixed(2));
            subTotal = subTotal - subTotalTaxOnly
            total -= subTotalTaxOnly + subTotalTaxStatus
            total = Math.round(total * 100) / 100
            const restaPrecision = (Math.round(impuestos * 1000) - Math.round(subTotalTaxStatus * 1000)) / 1000;
            impuestos = Math.round(restaPrecision * 100) / 100;

            newOrderModel.Subtotal = Number(subTotal.toFixed(2));
            newOrderModel.Discount = Number(discount.toFixed(2));
            newOrderModel.Taxes = Number(impuestos.toFixed(2));
            newOrderModel.Total = Number(total.toFixed(2));
            newOrderModel.WeightTotal = weightTotal;
        }

        if (newOrderModel.RateAmnt) {
            newOrderModel.TotalRetenido = Number((newOrderModel.Subtotal * newOrderModel.RateAmnt).toFixed(2));
            newOrderModel.Total = newOrderModel.Total - newOrderModel.TotalRetenido;
        }

        //#region DETRACCIONES
        if (newOrderModel.isPurchaseDocument && (newOrderModel.DetraccionVista || newView === 'PurchaseOrder')) {
            let isBPDetraccion = newOrderModel.U_FMB_BP_Detra === 'Y';
            let isDetraccion = false;

            const isPurchaseInvoice = newView === 'purchaseInvoice' || view === 'purchaseInvoice';
            const isPurchaseOrder = newView === 'PurchaseOrder';
            const isCopy = newOrderModel.isSelectToActive || newOrderModel.isSelectOfActive; // Se copia el documento
            const noCopy = !newOrderModel.isSelectToActive && !newOrderModel.isSelectOfActive; // No se esta copiando el documento
            const isPurchaseInvoiceOnlyOpen = isPurchaseInvoice && action === 2 && !editMode;
            const isEdit = Number(action) === 2 && editMode;
            const isCreate = Number(action) === 1;

            if (isPurchaseInvoiceOnlyOpen && newOrderModel.U_STR_AfctoDtr === 'Y') { // Mostrar la información con la que ya se creo la factura de proveedor
                newOrderModel.Total = Number((Number(newOrderModel.Total) - Number(newOrderModel.U_RS_MONDET || 0)).toFixed(2));
            } else if ((isCreate || isEdit) &&
                isBPDetraccion &&
                (
                    (noCopy) ||
                    (isCopy && (newOrderModel.existsDetraccion || isPurchaseOrder))
                )
            ) {
                if (noCopy || (isCopy && isPurchaseOrder)) { // Mientras sea un docuento sin copiar se evaluan detracciones
                    const totalConvert = calcultateOperationHeader(newOrderModel);
                    // const detraccion = this.checkDetraccion(newOrderModel.Items, Number(totalConvert?.totalLocal ?? newOrderModel?.Total ?? 0) || 0);
                    const detraccion = this.checkDetraccion(newOrderModel.Items, Number(newOrderModel?.DocTotalLocal ?? totalConvert?.totalLocal ?? newOrderModel?.Total ?? 0) || 0);
                    isDetraccion = detraccion?.isDetraccion || 'N';

                    newOrderModel.U_STR_AfctoDtr = isDetraccion;
                    newOrderModel.U_STR_TasaDTR = Number(detraccion?.Rate || 0);
                    newOrderModel.U_STR_CodBnSs = detraccion?.tasa || '';
                }

                const U_RS_MONDET = Number(newOrderModel.Total || 0) * (newOrderModel.U_STR_TasaDTR / 100);
                newOrderModel.U_RS_MONDET = Number(U_RS_MONDET || 0).toFixed(2);
                if (newView === 'purchaseInvoice') { // Solo en factura de proveedor se muestra el monto total menos el monto de la detracción
                    newOrderModel.Total = Number((Number(newOrderModel.Total) - Number(newOrderModel.U_RS_MONDET)).toFixed(2));
                }
            } else if ((isCreate || isEdit) && noCopy) { // No aplica detracciones
                newOrderModel.U_FMB_BP_Detra = 'N';
                newOrderModel.U_STR_AfctoDtr = 'N';
                newOrderModel.U_STR_TasaDTR = 0;
                newOrderModel.U_STR_CodBnSs = '';
                newOrderModel.U_RS_MONDET = 0;
            }
        }
        //#endregion DETRACCIONES

        //PAGOS
        newOrderModel.totalDocumento = 0;
        newOrderModel.totalPago = 0;
        newOrderModel.totalCreditPerception = 0;
        newOrderModel.CheckSum = 0;

        const isAccountPayment = newOrderModel.isAccountPayment;

        newOrderModel.ItemsPayments.map(item => {
            newOrderModel.totalDocumento += Number(item.pastDueBalance); //item.total
            newOrderModel.totalPago += isAccountPayment ? Number(item.PriceFormat || 0) : Number(item.totalPago);
            if (item.TransId) { // Este no debe de venir en detalle para que no se sume (Por eso vienen registros extras con el valor)
                newOrderModel.totalCreditPerception += Number(item.U_PRC_IMP) || 0;
            }
        });

        newOrderModel.CheckList.map(item => {
            newOrderModel.CheckSum += Number(item.CheckSum);
        });

        if (newOrderModel.PayNoDoc) {
            newOrderModel.totalDocumento = newOrderModel.NoDocSum;
        }


        newOrderModel.totalRecibido = Number(newOrderModel.CashSum) + Number(newOrderModel.CreditSum) + Number(newOrderModel.CheckSum) + Number(newOrderModel.TrsfrSum);

        if (newOrderModel.DocCur != newOrderModel.DocCurDocumentsPayment && !isAccountPayment) {
            let localCurrency = CURRENCY;
            let rate = 1;
            if (localCurrency == newOrderModel.DocCur) {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCurDocumentsPayment == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });

                newOrderModel.totalPago = Number((newOrderModel.totalPago * rate).toFixed(2));
            } else {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCur == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });
                newOrderModel.totalPago = Number((newOrderModel.totalPago / rate).toFixed(2));
            }
        }

        newOrderModel.totalPago = Number((newOrderModel.totalPago).toFixed(2));
        //#region CREDIT PERCEPTIONS
        newOrderModel.totalPago = Number((Number(newOrderModel.totalPago) + Number(newOrderModel.totalCreditPerception))?.toFixed(2));
        //#endregion CREDIT PERCEPTIONS
        newOrderModel.totalRestante = newOrderModel.totalPago - newOrderModel.totalRecibido;
        // newOrderModel.WeightTotal = weightTotal;

        //#region RETENCIONES
        newOrderModel = await this.checkWithHolding(newOrderModel); // Se coloca hasta aqui por que ocupa totalPago
        //#region RETENCIONES
        this.refreshModel(newOrderModel);

    };

    refreshTotalService = (newOrderModel, index = null) => {
        if (index || index === 0) {

            let total = 0;
            newOrderModel.service[index].Price = parseFloat(newOrderModel.service[index].HomePrice / newOrderModel.ChangeRate) || '';
            let impuesto = (newOrderModel.service[index].Price) * (newOrderModel.service[index].TaxeRate / 100);
            newOrderModel.service[index].TaxeResult = parseFloat(impuesto).toFixed(2);

            total = newOrderModel.service[index].Price;
            newOrderModel.service[index].Total = total;

        } else {
            newOrderModel.service.map(item => {
                let total = 0;
                item.Price = (item.HomePrice / newOrderModel.ChangeRate).toFixed(2);
                let impuesto = item.Price * (item.TaxeRate / 100);
                item.TaxeResult = parseFloat(impuesto).toFixed(2);

                total = item.Price;
                item.Total = total;
            });

        }


        let subTotal = 0;
        let impuestos = 0;
        let discount = 0;
        let total = 0;

        newOrderModel.service.map(item => {
            subTotal += Number(item.Total);
            impuestos += parseFloat(item.TaxeResult);
        });

        newOrderModel.Subtotal = subTotal;
        newOrderModel.Taxes = impuestos;
        newOrderModel.Discount = discount;

        total = newOrderModel.Subtotal + impuestos;

        newOrderModel.Total = total;
        this.refreshModel(newOrderModel);
    };

    sendModel = async (draft) => {
        const { newOrderModel, createDocument, view, showAlert, setWhsByRouteDocs, getUserFieldHeaderValue, getItemUserFieldValue, isDraftOWTQ = false } = this.props;
        const { flagUploadAttachments, hasUploadedAttachment } = this.state;
        let newView = newOrderModel.newView || view;

        if (newOrderModel.OriginDocumentCreate === "PurchaseOrder") {
            if (!newOrderModel.CardName) {
                return showAlert({ type: "warning", message: "Selecciona un proveedor" });
            }
        }

        //Factura de reserva de clientes
        if (newView === 'invoiceReserve') {
            newOrderModel.ReserveInvoice = 'tYES';
        }

        if (view === 'payment') {
            const isAccountPayment = newOrderModel?.isAccountPayment;

            if (isAccountPayment) {
                if (!newOrderModel?.ItemsPayments?.length) {
                    showAlert({ type: 'error', message: 'El pago no puede ser creado sin ninguna línea' });
                    return;
                }
                if (newOrderModel?.ItemsPayments?.some(item => !item.AcctCode)) {
                    showAlert({ type: 'error', message: 'Por favor completa la cuenta de mayor de las líneas' });
                    return;
                }
                if (newOrderModel?.ItemsPayments?.some(item => !item.PriceFormat || Number(item.PriceFormat) <= 0)) {
                    showAlert({ type: 'error', message: 'El importe de las líneas debe de ser mayor a 0' });
                    return;
                }
                if (Number(newOrderModel?.totalRecibido || 0) <= 0) {
                    showAlert({ type: 'error', message: 'El total recibido debe de ser mayor a 0' });
                    return;
                }
            }

            let reconciliacion = false;
            newOrderModel.ItemsPayments.map(Item => {
                if (Item.docType === '14') {
                    reconciliacion = true;
                }
            });
            if (!reconciliacion) {
                if (newOrderModel.totalRecibido != newOrderModel.totalPago) {
                    showAlert({
                        type: 'error',
                        message: 'El total del documento no corresponde al total de dinero recibido'
                    });
                    return;
                }
            } else if ((newOrderModel.totalRecibido <= 0 || newOrderModel.totalRestante < -0.01) && reconciliacion) {
                showAlert({
                    type: 'error',
                    message: 'El total del documento no corresponde al total de dinero recibido'
                });
                return;
            }

            //#region CREDIT PERCEPTIONS
            if (newOrderModel.ItemsPayments?.some(line => Number(line?.U_PRC_IMP) > 0)) {
                const U_BPP_MDTD = await getUserFieldHeaderValue('U_BPP_MDTD', newOrderModel, true, view);
                if (Number(U_BPP_MDTD?.foundIndex) >= 0) {
                    newOrderModel.userFields[`userFields${U_BPP_MDTD?.fieldNumber}`] = '40'; // Tipo de documento -> 40 para percepciones a crédito
                }

                const U_BPP_PTSC = await getUserFieldHeaderValue('U_BPP_PTSC', newOrderModel, true, view);
                if (Number(U_BPP_PTSC?.foundIndex) >= 0 && !newOrderModel.userFields?.[`userFields${U_BPP_PTSC?.fieldNumber}`]) {
                    showAlert({ type: 'warning', message: `Es necesario un valor para el campo "${U_BPP_PTSC?.headerMatch?.header?.Descr || 'Serie del certificado'}"`, timeOut: 8000 });
                    return;
                }
            }
            //#endregion CREDIT PERCEPTIONS

            if (Number(newOrderModel?.TrsfrSum ?? 0) > 0) { // Transferencia
                if (!moment(newOrderModel?.TrsfrDate || "").isValid()) {
                    showAlert({ type: "warning", message: "Ingrese una fecha valida para la transferencia.", timeOut: 8000 });
                    return;
                }
                const U_RS_CODAPR = await getUserFieldHeaderValue('U_RS_CODAPR', newOrderModel, true, view);
                let days = newOrderModel?.TrsfrDate && moment().diff(moment(newOrderModel?.TrsfrDate), 'days') > 3;
                if (days && Number(U_RS_CODAPR?.foundIndex) >= 0 && !newOrderModel.userFields?.[`userFields${U_RS_CODAPR?.fieldNumber}`]) {
                    showAlert({ type: "warning", message: `No puede registrar cobros de documentos con mas de 3 dias de antigüedad. Es necesario un valor para el campo "${U_RS_CODAPR?.headerMatch?.header?.Descr || 'Código de aprobación'}"`, timeOut: 8000 });
                    return;
                }
            }
            if (needTransferReference(newOrderModel)) {
                showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar una referencia.`, timeOut: 8000 });
                return;
            }
        }

        //#region Flujo de caja
        if (Sections['FlujoCaja'] && (view === 'payment' || view === 'outgoingPayment')) {
            if (newOrderModel?.TrsfrAcct) {
                if (newOrderModel?.needTransferCFW && !newOrderModel?.transferCFWId) {
                    showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar el "Flujo de caja" de para transferencia`, timeOut: 8000 });
                    return;
                }
            }
            if (newOrderModel?.CashAcct) {
                if (newOrderModel?.needCashCFW && !newOrderModel?.cashCFWId) {
                    showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar el "Flujo de caja" para efectivo`, timeOut: 8000 });
                    return;
                }
            }
            if (newOrderModel?.CheckAcct && false) { // Este se queda comentado por que en sap no se muestra visualmente
                if (newOrderModel?.needCheckCFW && !newOrderModel?.checkCFWId) {
                    showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar el "Flujo de caja" para cheques`, timeOut: 8000 });
                    return;
                }
            }
        }
        //#endregion Flujo de caja

        if (view === 'orderSales' || view === "deliveries" || view === 'invoice' || view === 'return' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve' || view === "quotations") {
            let limit = newOrderModel.Balance + newOrderModel.Total - newOrderModel.CreditLine;
            if (limit >= 1) {
                showAlert({ type: 'info', message: newOrderModel.CardCode + ' - ' + newOrderModel.CardName + ' Límite de crédito excedido en ' + parseFloat(limit).toFixed(2) + ' ' + newOrderModel.DocCur });
            }
        }

        // Validación de lista de precios para documentos de inventario//SOLICTAN ELIMINAR VALIDACION DE PRECIO EN INVENTARIO LLG 30-03-2026
        // if (view === 'transfersRequest' || view === "transfers" || view === 'transfersEntry' || view === 'transfersOutput' || isDraftOWTQ) {
        //     let error = false;
        //     const priceListNum = (newOrderModel.GroupNum === -2 || newOrderModel.GroupNum === -1) ? newOrderModel.GroupNum + 1 : newOrderModel.GroupNum;
        //     for (let i = 0; i < newOrderModel.Items.length; i++) {
        //         const item = newOrderModel.Items[i];
        //         if ((view === 'transfers' || newOrderModel.OriginDocumentCreate === 'transfers') && item.FromLocationAssignment.length > 0 && Number(item.TotalAsigned || 0) !== Number(item.Quantity)) { return showAlert({ type: "warning", message: `${item.ItemCode}: Asigne la cantidad total para las ubicaciones de origen` }); }
        //         if ((view === 'transfers' || newOrderModel.OriginDocumentCreate === 'transfers') && item.ToLocationAssignment.length > 0 && Number(item.ToTotalAsigned || 0) !== Number(item.Quantity)) { return showAlert({ type: "warning", message: `${item.ItemCode}: Asigne la cantidad total para las ubicaciones de destino` }); }
        //         if (!item.PricesList || item.PricesList.length === 0) continue;

        //         const Price = item?.PricesList?.find(({ PriceList }) => PriceList === Number(priceListNum))?.Price ?? 0;
        //         if (!Price || Number(Price) === 0) {
        //             showAlert({ type: 'warning', message: item.ItemCode + ` no cuenta con un precio valido` });
        //             error = true;
        //             break;
        //         }
        //     }
        //     if (error) return;
        // }

        if ((view === "transfers" && !newOrderModel?.newView) || (newOrderModel?.newView === "transfers")) {
            for (const item of newOrderModel.Items) {
                if (!Number(item.Quantity || 0)) { return showAlert({ type: "warning", message: `${item.ItemCode}: La cantidad no puede esta vacia` }); }
                else if (Number(item.Quantity || 0) < 0) { return showAlert({ type: "warning", message: `${item.ItemCode}: La cantidad no puede ser negativa` }); }

                if ((newOrderModel.TransitType != 'PZ' && newOrderModel.TransitType != 'DZ' && newOrderModel.TransitType != 'DC') && item.FillerWhs?.BinActivat === "Y" && Number(item.TotalAsigned || 0) !== Number(item.Quantity)) { return showAlert({ type: "warning", message: `${item.ItemCode}: Asigne la cantidad total para las ubicaciones de origen` }); }
                if ((newOrderModel.TransitType != 'PZ' && newOrderModel.TransitType != 'DZ' && newOrderModel.TransitType != 'DC') && item.ToWhs?.BinActivat === "Y" && Number(item.ToTotalAsigned || 0) !== Number(item.Quantity)) { return showAlert({ type: "warning", message: `${item.ItemCode}: Asigne la cantidad total para las ubicaciones de destino` }); }
            }
        }

        if (newOrderModel.DocType === 'S' && (view === 'orderSales' || view === "deliveries" || view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve' || view === "quotations")) {
            let error = false;
            newOrderModel.service.map(service => {
                if (service.AcctCode === '') {
                    showAlert({ type: 'warning', message: 'Seleccione una cuenta de mayor para la descripción ' + service.Description });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (newOrderModel.DocType === 'I' && view !== 'inventoryData' && view !== 'bussinesPartner' && view !== 'transfersRequest' && view !== 'transfers' && !isDraftOWTQ) {
            let error = false;
            newOrderModel.Items.map(Item => {
                if (Item.WhsCode === '' && Item.InvntItem === 'Y') {
                    showAlert({
                        type: 'warning',
                        message: 'Seleccione un almacén para el artículo ' + Item.ItemCode
                    });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (view !== 'inventoryData' && view !== 'bussinesPartner' && view !== 'transfersRequest' && view !== 'transfers' && view !== 'inventoryRevaluation' && view !== 'PurchaseRequest' && !isDraftOWTQ) {
            let error = false;
            newOrderModel.Items.map(Item => {
                if (Item.Price === '0.00' && Item.ItemCode !== 'DESCUENTO') {
                    showAlert({
                        type: 'error',
                        message: Item.ItemCode + ` Su precio es de ${CURRENCY} 0.00`
                    });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (view === 'inventoryRevaluation') {
            let error = false;
            newOrderModel.Items.map(Item => {
                if (Item.NewAvgPrice === 0) {
                    showAlert({
                        type: 'error',
                        message: Item.ItemCode + ' Su costo nuevo no puede ser 0'
                    });
                    error = true;
                }
            });

            if (error) {
                return;
            }

            newOrderModel.Items.map(Item => {
                if (Item.NewAvgPrice <= 0) {
                    showAlert({
                        type: 'error',
                        message: Item.ItemCode + ' Su costo nuevo no puede ser negativo'
                    });
                    error = true;
                }
            });

            if (error) {
                return;
            }
        }

        if (view === 'transfersEntry' || view === 'transfersOutput') {
            // if (!newOrderModel.U_TipoSalida || newOrderModel.U_TipoSalida === '') {
            //     showAlert({ type: 'error', message: 'Selecciona un tipo de Salida/Entrada valido' });
            //     return;
            // }
            if (!newOrderModel?.U_RS_TIPOOPER || newOrderModel?.U_RS_TIPOOPER === '-' || !Number(newOrderModel?.U_RS_TIPOOPER ?? 0) || Number(newOrderModel?.U_RS_TIPOOPER ?? 0) <= 0) {
                showAlert({ type: 'error', message: 'Por favor seleccione el "Tipo de Operación" del documento' });
                return;
            }
            const requiredFields = [
                'U_BPP_MDTD',
                'U_BPP_MDSD',
                // 'U_BPP_MDCD',
                'U_BPP_MDTS'
            ];

            const areRequiredFieldsActive = requiredFields?.every(field =>
                invFields?.some(f => f.Field === field && f.active === true)
            );
            if (areRequiredFieldsActive && ((newOrderModel?.U_BPP_MDTS !== 'TSI' && view === 'transfersEntry') || view === 'transfersOutput')) { // Para documentos que no sean internos solicitar valores de series y correlativos
                const U_BPP_MDTD = await getUserFieldHeaderValue('U_BPP_MDTD', newOrderModel, true); // Tipo de documento
                const U_BPP_MDSD = await getUserFieldHeaderValue('U_BPP_MDSD', newOrderModel, true); // Serie del documento
                if (!newOrderModel?.U_BPP_MDTD || newOrderModel?.U_BPP_MDTD === '-') {
                    showAlert({ type: 'warning', message: `Es necesario un valor para el campo "${U_BPP_MDTD?.headerMatch?.header?.Descr || 'Tipo de documento'}"`, timeOut: 8000 });
                    return;
                }
                if (view === 'transfersOutput' && newOrderModel?.U_BPP_MDTD !== 'DI' && newOrderModel?.U_BPP_MDTS !== 'TSE') {
                    showAlert({ type: 'warning', message: `El valor para el campo "${U_BPP_MDTD?.headerMatch?.header?.Descr || 'Tipo de documento'}" solo puede ser DI - Documento Interno`, timeOut: 8000 });
                    return;
                }
                if (!newOrderModel?.U_BPP_MDSD || newOrderModel?.U_BPP_MDSD === '-') {
                    showAlert({ type: 'warning', message: `Es necesario un valor para el campo "${U_BPP_MDSD?.headerMatch?.header?.Descr || 'Serie del documento'}"`, timeOut: 8000 });
                    return;
                }
            }
            let error = 0;
            let message = '';
            for (let index in newOrderModel.Items) {
                const Item = newOrderModel.Items[index];

                if (Item.Price === '0.00' || Number(Item.Price || '0') === 0 && !(view === 'transfersRequest' || view === "transfers" || view === 'transfersEntry' || view === 'transfersOutput' || isDraftOWTQ)) {
                    error = 1;
                    message = `El artículo ${Item.ItemCode} no cuenta con un precio valido`;
                }
                if (Item.WhsCode.toUpperCase() === 'SAP-R1' || Item.WhsCode.toUpperCase() === 'R1-R1') {
                    error = 2;
                    message = 'No esta permitido usar el almacén seleccionado para esta operación';
                }
                if (view === 'transfersOutput') {
                    let whsStock = Item.wareHouseStock?.find(({ WhsCode }) => WhsCode === Item?.WhsCode) || { OnHand: 0 };
                    if (Number(whsStock.OnHand) === 0) {
                        error = 3;
                        message = `El artículo ${Item.ItemCode} no cuenta con stock en el almacén seleccionado`;
                    } else if (Number(whsStock.OnHand) < Number(Item.Quantity)) {
                        error = 3;
                        message = `El artículo ${Item.ItemCode} no cuenta con stock suficiente en el almacén seleccionado`;
                    }
                }
                if (error !== 0) break;
            }

            if (error !== 0) {
                showAlert({ type: 'warning', message });
                return;
            }
        }

        if (view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) {
            if (newOrderModel.Transit.toString() !== '2') {
                if (newOrderModel.Filler === "" || newOrderModel.ToWhsCode === "") {
                    showAlert({ type: "warning", message: "Asegúrese de llenar de forma correcta los almacenes" });
                    return;
                }
                if (newOrderModel.ToWhsCode === newOrderModel.Filler && newOrderModel.Transit) {
                    showAlert({ type: 'warning', message: 'El almacén destino no puede ser el mismo que el almacén de origen' });
                    return;
                }
            }
            if (newOrderModel.Filler.toUpperCase() === "SAP-R1" || newOrderModel.Filler.toUpperCase() === "R1-R1") {
                showAlert({ type: 'warning', message: 'No esta permitido usar el almacén de origen seleccionado para esta operación' });
                return;
            }
        }

        if (view === 'PurchaseRequest') {
            const requiredFields = [
                'U_RS_PERIODO',
                'U_RS_MESES',
            ];

            const areRequiredFieldsActive = requiredFields?.every(field =>
                OPRQFields?.some(f => f.Field === field && f.active === true)
            );
            if (areRequiredFieldsActive) { // Para documentos que no sean internos solicitar valores de series y correlativos
                const U_RS_PERIODO = await getUserFieldHeaderValue('U_RS_PERIODO', newOrderModel, true); // Periodicidad
                const U_RS_MESES = await getUserFieldHeaderValue('U_RS_MESES', newOrderModel, true); // Mes afecto
                if (!newOrderModel?.U_RS_PERIODO || newOrderModel?.U_RS_PERIODO === '-' || newOrderModel?.U_RS_PERIODO === '- --') {
                    showAlert({ type: 'warning', message: `Es necesario un valor para el campo "${U_RS_PERIODO?.headerMatch?.header?.Descr || 'Periodicidad'}"`, timeOut: 8000 });
                    return;
                }
                if (!newOrderModel?.U_RS_MESES || newOrderModel?.U_RS_MESES === '-' || newOrderModel?.U_RS_MESES === '- --') {
                    showAlert({ type: 'warning', message: `Es necesario un valor para el campo "${U_RS_MESES?.headerMatch?.header?.Descr || 'Mes afecto'}"`, timeOut: 8000 });
                    return;
                }
            }
        }

        //ORDEN DE COMPRA SIN RELACIÓN
        if (newView === 'PurchaseOrder') {
            const lineasSinRelacion = newOrderModel.Items.filter(
                item => !item.BaseEntry || item.BaseType === -1
            );

            if (lineasSinRelacion.length > 0) {
                const itemsSinRelacion = lineasSinRelacion.map(i => i.ItemCode).join(', ');
                showAlert({ type: 'warning', message: `Los siguientes artículos no tienen relación con un documento anterior: ${itemsSinRelacion}. Todas las líneas deben provenir de una solicitud de compra o de una oferta de compra.`, timeOut: 8000 });
                return;
            }
        }

        if (newOrderModel.OriginDocumentCreate === 'transfers' && newOrderModel.Transit.toString() === '2') {
            if (newOrderModel.DocNumCEDIS === '') {
                showAlert({ type: "warning", message: "Si seleccionas el tipo de traslado 'Recuperar de CEDIS' debes de agregar un numero de documento ", timeOut: 5000 });
                return;
            }
            if (newOrderModel.WarehouseCEDIS === '') {
                showAlert({ type: "warning", message: "Si seleccionas el tipo de traslado 'Recuperar de CEDIS' debes de agregar el almacen a donde se realizara la entrada de mercancia ", timeOut: 5000 });
                return;
            }

        }

        // CODIGO SCOP
        const validSCOP = ['PR01', 'PR02'];
        const scopCodeIn = ['01', '02', '04', '18', '27'];
        const transferScop = ['01', '02', '03', '04', '05', '08', '14', '18'];
        const mustValidateSCOP =
            newOrderModel.Items.length > 0 &&
            newOrderModel.Items.some(
                line => validSCOP.includes((line.U_RS_NEGNR || '').trim())
            );

        let validMotivos = scopCodeIn.includes(newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado);
        const hasGranel =
            newOrderModel.Items.length > 0 &&
            newOrderModel.Items.some(
                line => Granel.includes(line.ItmsGrpCod)
            );
        const requireScop = transferScop.includes(newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado)
        if (
            ((newOrderModel.newView === 'orderSales' || view === 'orderSales' || newOrderModel.newView === 'deliveries' || view === 'deliveries' || newOrderModel.newView === 'invoice' || view === 'invoice') && newOrderModel.NeedScopCode && mustValidateSCOP) ||
            ((newOrderModel.newView === 'GoodsReceipt' || view === 'GoodsReceipt') && mustValidateSCOP) ||
            ((newOrderModel.newView === 'transfersRequest' || view === 'transfersRequest') && mustValidateSCOP && newOrderModel.U_BPP_MDTS === 'TSE' && validMotivos && newOrderModel.userFields.userFields1 === '09') ||
            ((isDraftOWTQ) && mustValidateSCOP && newOrderModel.U_BPP_MDTS === 'TSE' && validMotivos && newOrderModel.userFields.userFields1 === '09' && hasGranel) ||
            ((newOrderModel.newView === 'transfers' || view === 'transfers') && requireScop)
        ) {
            if (newOrderModel.U_FMB_SCOP_CODE === '') {
                showAlert({ type: "warning", message: "Debe de tener un codigo SCOP para crear el documento", timeOut: 5000 });
                return;
            }
            const scopCode = String(newOrderModel.U_FMB_SCOP_CODE || '').trim();
            if (!/^\d{11}$/.test(scopCode)) {
                showAlert({
                    type: "warning",
                    message: "El código SCOP debe contener exactamente 11 dígitos.",
                    timeOut: 5000
                });
                return;
            }

            if (!newOrderModel.ValidSCOP) {
                showAlert({ type: "warning", message: "Debe de validar que el codigo SCOP es valido. (Enter en el campo o con el boton de lado derecho)", timeOut: 5000 });
                return;
            }
        }

        //#region GALLONS CONVERSION
        // if (newOrderModel?.DocType === 'I' && (newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument || isDraftOWTQ)) {
        if (newOrderModel?.DocType === 'I' && (newOrderModel?.isSalesDocument)) {
            let isGallonValid = true;
            let itemMessage = '';
            for (const item of newOrderModel.Items) {
                if (Granel?.includes(Number(item?.ItmsGrpCod)) && item?.U_RS_UMED === 'GLN' && (!item?.U_RS_CANTG || Number(item?.U_RS_CANTG) <= 0)) {
                    itemMessage = `La cantidad de galones del artículo ${item?.ItemCode || item?.ItemName} debe de ser mayor a 0`;
                    isGallonValid = false;
                    break;
                }
                if (Granel?.includes(Number(item?.ItmsGrpCod)) && item?.U_RS_UMED === 'GLN' && (!item?.U_RS_PRECIOGL || Number(item?.U_RS_PRECIOGL) <= 0)) {
                    itemMessage = `El artículo ${item?.ItemCode || item?.ItemName} no cuenta con un precio valido para la conversión a galones`;
                    isGallonValid = false;
                    break;
                }
            }
            if (!isGallonValid) {
                showAlert({ type: "warning", message: itemMessage, timeOut: 5000 });
                return
            };
        }
        if (newView === 'transfersEntry') {
            if ((!newOrderModel?.U_RS_DENSIDAD || (Number(newOrderModel?.U_RS_DENSIDAD || 0) <= 0)) &&
                newOrderModel?.Items?.some((item => Granel?.includes(Number(item?.ItmsGrpCod))))
            ) {
                showAlert({ type: 'warning', message: `Es necesario agregar un valor mayor a 0 para el campo de Densidad`, timeOut: 5000 });
                return;
            }
        }
        if (newOrderModel?.DocType === 'I' &&
            (newView === 'PurchaseQuotation' || newView === 'PurchaseOrder' || newView === 'GoodsReceipt' ||
                newView === 'purchaseReturn' || newView === 'purchaseInvoice' || newView === 'purchaseCreditNotes')
        ) {
            const aliasToFind = "U_RS_DENSIDAD";
            const headers = newOrderModel?.userFieldsHeader || [];
            const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
            const headerMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

            if (headerMatch) {
                const fieldId = headerMatch.header.FieldID;
                const Descr = headerMatch.header.Descr;
                const allFields = json?.allUserFields || [];
                const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                if (foundIndex !== -1) {
                    const fieldNumber = foundIndex + 1;
                    const U_RS_DENSIDAD = newOrderModel?.userFields?.[`userFields${fieldNumber}`] || '';

                    if (U_RS_DENSIDAD && isNaN(Number(U_RS_DENSIDAD))) {
                        showAlert({ type: 'warning', message: `El campo de usuario "${Descr}" debe contener un número válido.`, timeOut: 5000 });
                        return;
                    }
                    if (
                        (!U_RS_DENSIDAD || Number(U_RS_DENSIDAD) <= 0) &&
                        newOrderModel?.Items?.some(item => Granel?.includes(Number(item?.ItmsGrpCod)))
                    ) {
                        showAlert({ type: 'warning', message: `Es necesario agregar un valor mayor a 0 para el campo de usuario "${Descr}"`, timeOut: 5000 });
                        return;
                    }
                }
            }
        }
        //#endregion GALLONS CONVERSION

        // Si es Tipo de Atencion RUT - ABS - RCF entonces se revisan los almacenes validos para planta o zonal
        if (newOrderModel?.DocType === 'I'
            && newOrderModel.isSalesDocument
            && !(await setWhsByRouteDocs(newOrderModel?.userFields?.userFields28, true))
        ) {
            return;
        }

        //#region DIMENSIONS
        // const isTransfersEntry = view === "transfersEntry" || newOrderModel?.newView === "transfersEntry";
        const isTransfersOutput = view === "transfersOutput" || newOrderModel?.newView === "transfersOutput";
        if (newOrderModel?.DocType === 'I' && (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || isTransfersOutput || newOrderModel?.isTransferDocument || isDraftOWTQ)) {
            let flagD = false;

            const validations = [
                { field: 'OcrCode', label: 'CANAL' },
                { field: 'OcrCode2', label: 'SEDES' },
                { field: 'OcrCode3', label: 'SUCURSAL' },
                { field: 'OcrCode4', label: 'NEGOCIO' },
                { field: 'OcrCode5', label: 'CECO' },
            ];

            for (const item of newOrderModel?.Items) {
                if (!item.isTemporary) {
                    const invalid = validations?.find(v => !item[v.field]);
                    if (invalid) {
                        flagD = true;
                        showAlert({ type: "warning", message: `Es necesario un valor para el campo "${invalid.label}" para el artículo ${item.ItemCode || item.ItemName}`, timeOut: 5000 });
                        return;
                    }
                }
            }

            if (flagD) {
                return;
            }
        }
        //#endregion DIMENSIONS

        //#region RETENCIONES
        if (newView === 'outgoingPayment' && newOrderModel?.RetencionVista && newOrderModel?.U_LLG_RETENCI === 'Y' && newOrderModel?.WithHoldingPrev) {
            showAlert({ type: 'error', message: `El pago no puede ser creado porque las facturas seleccionadas no tienen retenciones aplicadas.`, timeOut: 10000 });
            return;
        }
        //#endregion RETENCIONES

        if (newOrderModel?.isPurchaseDocument) {
            if (!newOrderModel?.Project) {
                showAlert({ type: 'warning', message: `Es necesario un valor para el campo de Proyecto`, timeOut: 5000 });
                return;
            }
            if (
                (
                    newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft' ||
                    view === 'PurchaseQuotation' || view === 'PurchaseQuotationDraft' || Number(newOrderModel?.ObjType) === 540000006
                    || view === 'PurchaseRequest' || Number(newOrderModel?.ObjType) === 1470000113
                ) &&
                (
                    !newOrderModel?.ReqDate ||
                    isNaN(new Date(newOrderModel.ReqDate)?.getTime())
                )
            ) {
                showAlert({ type: 'warning', message: 'Es necesario especificar la Fecha Necesaria', timeOut: 5000 });
                return;
            }

            if ((newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft' ||
                view === 'PurchaseQuotation' || view === 'PurchaseQuotationDraft' || Number(newOrderModel?.ObjType) === 540000006)
                && !newOrderModel.ShipToCode
            ) {
                showAlert({ type: 'warning', message: 'Es necesario especificar la dirección de "Destino"', timeOut: 5000 });
                return;
            }

            const isCopy = newOrderModel.isSelectToActive || newOrderModel.isSelectOfActive; // Se copia el documento
            const isCopyToOPOR = isCopy && newOrderModel?.newView === 'PurchaseOrder';
            if (newOrderModel?.newView === 'PurchaseQuotationDraft' || view === 'PurchaseQuotationDraft' || isCopyToOPOR) {
                const lineaExcedida = newOrderModel.Items.find(
                    item => item.PQTReqQty && Number(item.Quantity || 0) > Number(item.PQTReqQty)
                );
                if (lineaExcedida) {
                    showAlert({
                        type: 'warning',
                        message: `La cantidad de la línea ${lineaExcedida.ItemCode || lineaExcedida.ItemName || ''} no puede ser mayor a la cantidad requerida.`,
                        timeOut: 8000
                    });
                    return;
                }
            }
        }

        if ((newOrderModel?.isPurchaseDocument || (view === 'transfersEntry' || view === 'transfersOutput')) && newOrderModel?.DocType === 'I') {
            let flagD = false;
            for (const item of newOrderModel?.Items) {
                if ((newOrderModel?.isPurchaseDocument && item?.U_RS_GRUPO === 'SRV') || ((view === 'transfersEntry' || view === 'transfersOutput') && item?.U_RS_GRUPO === 'SU')) {// Campo de usuario Grupo - 1.- En compras para aquellos en valor servicios es necesario el Tipo de Gasto 2.- En Entradas y salidas para aquellos en valor suministros es necesario el Tipo de Gasto
                    let U_RS_TIPGA = null;
                    const aliasToFind = "U_RS_TIPGA";
                    const headers = newOrderModel?.userFieldsBody || [];
                    const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                    const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                    if (bodyMatch) {
                        const fieldId = bodyMatch?.header?.FieldID;
                        const Descr = bodyMatch?.header?.Descr;
                        const allFields = json?.allItemsUserFields || [];
                        const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);
                        if (foundIndex !== -1) {
                            const fieldNumber = foundIndex + 1;
                            U_RS_TIPGA = item?.UserFieldsItem[`userFields${fieldNumber}`] || '';

                            if (!U_RS_TIPGA || U_RS_TIPGA === '-') {
                                flagD = true;
                                showAlert({ type: "warning", message: `Es necesario un valor para el campo "${Descr}" para el artículo ${item.ItemCode || item.ItemName}`, timeOut: 5000 });
                                return;
                            }
                        }
                    }
                }
            }

            if (flagD) {
                return;
            }
        }

        if ((newView === 'PurchaseOrder' || newView === 'GoodsReceipt' || newView === 'purchaseInvoice' || (view === 'PurchaseRequest' && !newOrderModel?.newView)) && newOrderModel.UploadAttachments.length === 0) {
            showAlert({ type: 'info', message: `Para crear este tipo de documento es necesario adjuntar al menos un archivo.`, timeOut: 8000 });
            return;
        }

        if (hasUploadedAttachment && !flagUploadAttachments) {
            showAlert({ type: 'info', message: `Por favor, haz clic en 'Subir archivo' para adjuntar los anexos correctamente.`, timeOut: 8000 });
            return;
        }

        //#region Campos RAMO
        const isOWTRoOWTQ =
            view === 'transfers' ||
            view === 'transfersRequest' ||
            Number(newOrderModel?.ObjType) === 67 ||
            Number(newOrderModel?.ObjType) === 1250000001 ||
            isDraftOWTQ;

        const isOIGNoOIGE =
            view === 'transfersEntry' ||
            view === 'transfersOutput' ||
            Number(newOrderModel?.ObjType) === 59 ||
            Number(newOrderModel?.ObjType) === 60;

        if ((isOWTRoOWTQ || isOIGNoOIGE) && !(await this.validateRAMOFields(newOrderModel, invFields, getUserFieldHeaderValue, isOWTRoOWTQ, isOIGNoOIGE))) {
            return; // No continuar si fallaron las validaciones de RAMO
        }
        //#endregion Campos RAMO

        //#region Campos Facturación
        const isCreditDebitNote = ((view === 'creditNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'creditNote' || Number(newOrderModel?.ObjType) === 14) || ((view === 'debitNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'debitNote');
        if ((isCreditDebitNote)) {
            if (!(await this.validateBillingields(newOrderModel, billingFields, getUserFieldHeaderValue))) {
                return; // No continuar si fallaron las validaciones
            }
        }
        //#endregion Campos Facturación

        //#region Validar artículo como anticipo
        if (newOrderModel?.DocType === 'I'
            && (
                ['deliveries', 'invoice', 'creditNote', 'debitNote']?.includes(newView)
            )
        ) {
            let isAnticipo = false;
            for (const item of newOrderModel?.Items) {
                if (item?.U_RS_GRUPO === 'ANT') {
                    isAnticipo = true;
                    showAlert({ type: "warning", message: `El artículo ${item.ItemCode || item.ItemName} está configurado como Anticipo y debe ser removido para poder crear el documento.`, timeOut: 5000 });
                }
            }
            if (isAnticipo) {
                return;
            }
        }
        if (newOrderModel?.DocType === 'I'
            && (
                ['invoiceAdvance']?.includes(newView)
            )
        ) {
            let isntAnticipo = false;
            for (const item of newOrderModel?.Items) {
                if (item?.U_RS_GRUPO !== 'ANT') {
                    isntAnticipo = true;
                    showAlert({ type: "warning", message: `El artículo ${item.ItemCode || item.ItemName} NO está configurado como Anticipo y debe ser removido para poder crear el documento.`, timeOut: 5000 });
                }
            }
            if (isntAnticipo) {
                return;
            }
        }
        //#endregion Validar artículo como anticipo

        //#region Precio Llamagas
        if (newOrderModel?.DocType === 'I' && newOrderModel?.isSalesDocument) {
            for (const element of newOrderModel?.Items) {
                const envasado = Envasados?.includes(Number(element?.ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(element?.ItmsGrpCod));
                if (!element?.isTemporary && (envasado || glpGranel)) {
                    if (Number(element?.Price || 0) <= 0) {
                        showAlert({ type: "warning", message: `El precio debe de ser mayor a 0 para el artículo ${element.ItemCode || element.ItemName}`, timeOut: 50000 });
                        return;
                    }
                }
            }
        }
        //#endregion Precio Llamagas

        if (newOrderModel?.isSalesDocument && newOrderModel?.Items?.length) {
            for (const item of newOrderModel.Items) {
                const entregaValue = getItemUserFieldValue('U_RML_ENTCLNDRO', item, newOrderModel);
                if (!entregaValue) continue;

                const cilindrosValue = Number(getItemUserFieldValue('U_RML_CU', item, newOrderModel) || 0);
                const quantityValue = Number(item.Quantity || 0);

                if (entregaValue === '1') {
                    if (cilindrosValue !== quantityValue) {
                        showAlert({ type: 'warning', message: `El artículo ${item.ItemCode || item.ItemName || ''} tiene "Entrega Cilindro" en SI, la cantidad de cilindros vacíos devueltos debe coincidir con la cantidad del artículo.`, timeOut: 6000 });
                        return;
                    }
                } else if (entregaValue === '2') {
                    if (cilindrosValue >= quantityValue) {
                        showAlert({ type: 'warning', message: `El artículo ${item.ItemCode || item.ItemName || ''} tiene "Entrega Cilindro" en NO, la cantidad de cilindros vacíos devueltos debe ser menor a la cantidad del artículo.`, timeOut: 6000 });
                        return;
                    }
                }
            }
        }

        if (newOrderModel?.DocType === 'I' && newOrderModel?.isPurchaseDocument && !newOrderModel?.newView && (view === 'PurchaseRequest' || Number(newOrderModel?.ObjType) === 1470000113)) {
            let flagD = false;
            const validations = [
                { field: 'TaxCode', label: 'Indicador I.', preffix: 'el' },
            ];

            for (const item of newOrderModel?.Items) {
                if (!item.isTemporary) {
                    const invalid = validations?.find(v => !item[v.field]);
                    if (invalid) {
                        flagD = true;
                        showAlert({ type: "warning", message: `Es necesario un valor para ${invalid.preffix ? `${invalid.preffix} ` : ''}"${invalid.label}" para el artículo ${item.ItemCode || item.ItemName}`, timeOut: 5000 });
                        return;
                    }
                }
            }

            if (flagD) {
                return;
            }
        }

        if (view === 'SalesHelmets') {
            // newOrderModel.NumAtCard = '';
            // newOrderModel.NumAtCard += ' Entrada Cascos: ' + newOrderModel.NextFolio;
            //newOrderModel.ref2 += newOrderModel.NextFolio2;
            // if(newOrderModel.isSelectTo)
            // {
            //     newOrderModel.NumAtCard = '';
            //     newOrderModel.NumAtCard += ' Salida Cascos: ' + newOrderModel.NextFolio;
            // }

            let error = false;
            newOrderModel.Items.map(item => {
                if (item.AcctCode === '') {
                    showAlert({
                        type: 'warning',
                        message: 'Asegurese de presionar la tecla ENTER al almacén de ' + item.ItemCode
                    });
                    error = true;
                }
            });
            if (error) {
                return;
            }

        }

        if (view === 'ExitHelmets') {
            // newOrderModel.NumAtCard = '';
            // newOrderModel.NumAtCard += ' Salida Cascos: ' + newOrderModel.NextFolio;
            //newOrderModel.ref2 += newOrderModel.NextFolio2;

            let error = false;
            newOrderModel.Items.map(item => {
                if (item.AcctCode === '') {
                    showAlert({
                        type: 'warning',
                        message: 'Asegurese de presionar la tecla ENTER al almacén de ' + item.ItemCode
                    });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (view !== 'inventoryData' && view !== 'bussinesPartner') {
            let error = false;
            newOrderModel.Items.map(Item => {
                if (Item.Quantity === '0') {
                    error = true;
                }
            });

            if (error) {
                showAlert({
                    type: 'error',
                    message: 'La cantidad no puede ser 0'
                });
                return;
            }
            newOrderModel.Items.map(Item => {
                if (Item.Quantity < 0) {
                    error = true;
                }
            });

            if (error) {
                showAlert({
                    type: 'error',
                    message: 'La cantidad no puede ser negativa'
                });
                return;
            }
            newOrderModel.Items.map(Item => {
                if (Item.Quantity === '') {
                    error = true;
                }
            });

            if (error) {
                showAlert({
                    type: 'error',
                    message: 'La cantidad no puede esta vacia'
                });
                return;
            }

        }

        if (view === 'ExitHelmets' && !newOrderModel.SerieCode2) {
            showAlert({ type: 'warning', message: "Selecciona una serie de Nota de Débito" });
            return;
        }

        if (view === 'SalesHelmets' && !newOrderModel.SerieCode2) {
            if (newOrderModel.isSelectTo) {
                showAlert({ type: 'warning', message: "Selecciona una serie de Nota de Débito" });
                return;
            }
            showAlert({ type: 'warning', message: "Selecciona una serie de Nota de Crédito" });

            return;
        }

        if (!newOrderModel.SerieCode && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'bussinesPartner' && view !== 'inventoryRevaluation' && view !== 'reportSelectionCriteria') {
            showAlert({ type: 'warning', message: "Selecciona una serie valida" });
            return;
        }
        if ((!newOrderModel.TaxeDefaultPartner || newOrderModel.TaxeDefaultPartner === '') && this.isMarketingDocument(view)) {
            showAlert({ type: 'error', message: 'El socio no cuenta con indicador de impuestos en su dirección de entrega' }, 5000);
            return;
        }

        if (draft === true || draft === 'draft') {
            newOrderModel.createDraft = draft
        }

        // COMERCIO EXTERIOR
        if (newOrderModel.isComercioExterior === "Y") {
            if (!newOrderModel.ComercioExterior.CertificadoOrigen) {
                showAlert({ type: "warning", message: `El campo Certificado Origen no puede ir vacío.` });
                return;
            }

            if (newOrderModel.ComercioExterior.CertificadoOrigen === '1') {
                if (!newOrderModel.ComercioExterior.NumCertificadoOrigen) {
                    showAlert({ type: "warning", message: `El campo N° de Certificado Origen no puede ir vacío.` });
                    return;
                }
            }
            // EMISOR
            if (!newOrderModel.ComercioExterior.Emisor_Pais) {
                showAlert({ type: "warning", message: `El campo País del Emisor no puede ir vacío.` });
                return;
            }

            if (!newOrderModel.ComercioExterior.Emisor_Estado) {
                showAlert({ type: "warning", message: `El campo Estado del Emisor no puede ir vacío.` });
                return;
            }

            if (!newOrderModel.ComercioExterior.Emisor_CodigoPostal) {
                showAlert({ type: "warning", message: `El campo Código Postal del Emisor no puede ir vacío.` });
                return;
            }

            if (!newOrderModel.ComercioExterior.Emisor_Calle) {
                showAlert({ type: "warning", message: `El campo Calle del Emisor no puede ir vacío.` });
                return;
            }

            // RECEPTOR
            if (!newOrderModel.ComercioExterior.Receptor_Pais) {
                showAlert({ type: "warning", message: `El campo País del Receptor no puede ir vacío.` });
                return;
            }

            if (!newOrderModel.ComercioExterior.Receptor_Estado) {
                showAlert({ type: "warning", message: `El campo Estado del Receptor no puede ir vacío.` });
                return;
            }

            if (!newOrderModel.ComercioExterior.Receptor_CodigoPostal) {
                showAlert({ type: "warning", message: `El campo Código Postal del Receptor no puede ir vacío.` });
                return;
            }

            if (!newOrderModel.ComercioExterior.Receptor_Calle) {
                showAlert({ type: "warning", message: `El campo Calle del Receptor no puede ir vacío.` });
                return;
            }

            let sendContinue = false;

            if (!newOrderModel.ComercioExterior.Mercancias) {
                showAlert({ type: "warning", message: `No se agregaron mercancias.` });
                return;
            }
            for (let index = 0; index < newOrderModel.ComercioExterior.Mercancias.length; index++) {
                const mercancia = newOrderModel.ComercioExterior.Mercancias[index];
                if (!mercancia.UnidadAduana) {
                    sendContinue = true;
                }
            }

            if (sendContinue) {
                showAlert({ type: "warning", message: `Es necesario llenar la unidad de aduana en las mercancias.` });
                return;
            }
        }
        // LEYENDAS FISCALES
        if (newOrderModel.isLeyendaFiscal === "Y") {
            let sendContinue = false;

            for (let index = 0; index < newOrderModel.LeyendasFiscales.length; index++) {
                const element = newOrderModel.LeyendasFiscales[index];

                if (!element.textoLeyenda) {
                    sendContinue = true;
                }
            }

            if (sendContinue) {
                showAlert({ type: "warning", message: `Es necesario llenar el texto de la leyenda para poder agregar una nueva Leyenda Fiscal.` });
                return;
            }
        }

        createDocument(newOrderModel);
    };

    searchLocations = async () => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        if ((newOrderModel?.Filler ?? '') == '') {
            showAlert({ type: 'warning', message: 'Selecciona almacén origen' });
            return;
        }
        $("#sucursalLocationsModal").modal("hide");
        this.setState({
            listBinLocations: [],
            showBinLocationsModal: false,
        })
        const search = {
            Sucursal: newOrderModel?.Filler ?? null,
            ToWhsCode: newOrderModel?.ToWhsCode ?? null,
            view
        }
        enableSpinner(true);
        let responseApi = await apiClient.getBinLocationBySucursal(search);
        enableSpinner(false);
        if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                listBinLocations: responseApi?.data ?? [],
                showBinLocationsModal: true,
            }, () => {
                $("#sucursalLocationsModal").modal("show");
            })
        } else {
            showAlert({ type: 'warning', message: responseApi?.message ?? 'No se encontraron resultados' });
        }
    }

    //#region DETRACCIONES
    checkDetraccion = (Items = [], Total = 0) => {
        if (!Items.length) return { Rate: 0, isDetraccion: 'N' };

        const sunatDetractionTable = [
            { codigoSunat: "001", descripcion: "Azúcar", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "003", descripcion: "Alcohol etílico", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "004", descripcion: "Recursos hidrobiológicos", montoMinimo: 700, tasa: "D004" }
            , { codigoSunat: "005", descripcion: "Maíz amarillo duro", montoMinimo: 700, tasa: "D004" }
            , { codigoSunat: "007", descripcion: "Caña de azúcar", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "008", descripcion: "Madera", montoMinimo: 700, tasa: "D004" }
            , { codigoSunat: "009", descripcion: "Arena y piedra", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "010", descripcion: "Residuos, subproductos, desechos, recortes y desperdicios", montoMinimo: 700, tasa: "D015" }
            , { codigoSunat: "012", descripcion: "Intermediación laboral y tercerización", montoMinimo: 700, tasa: "D012" }
            , { codigoSunat: "019", descripcion: "Arrendamiento de bienes", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "020", descripcion: "Mantenimiento y reparación de bienes muebles", montoMinimo: 700, tasa: "D012" }
            , { codigoSunat: "021", descripcion: "Movimiento de carga", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "022", descripcion: "Otros Servicios Empresariales", montoMinimo: 700, tasa: "D012" }
            , { codigoSunat: "024", descripcion: "Comisión mercantil", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "025", descripcion: "Fabricación de bienes por encargo", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "026", descripcion: "Servicio de transporte de personas", montoMinimo: 700, tasa: "D010" }
            , { codigoSunat: "027", descripcion: "Servicio de transporte de bienes realizado por vía terrestre", montoMinimo: 400, tasa: "D004" }
            , { codigoSunat: "030", descripcion: "Contratos de Construcción", montoMinimo: 700, tasa: "D004" }
            , { codigoSunat: "037", descripcion: "Demás servicios gravados con el IGV", montoMinimo: 700, tasa: "D012" }
            , { codigoSunat: "040", descripcion: "Primera venta de inmuebles gravados con el IGV", montoMinimo: 1, tasa: "D004" }
            , { codigoSunat: "099", descripcion: "Ley N° 30737", montoMinimo: 1, tasa: "D008" }
        ];

        const detractionMap = new Map();

        for (const item of Items) {
            const isIGV = !item?.TaxCode?.includes("EXO") && (item.TaxCode?.includes("IGV") || item.TaxName?.toUpperCase()?.includes("IGV"));
            if (isIGV && item.InvntItem === 'N' && item.U_RML_AFEDET === 'Y' && item.U_RML_CODRET && item.U_RML_CODSERV && item.U_RML_PORCE) {
                // Entra aqui si es IGV. el articulo es servicio (No inventariable), es afecto a detracción, tiene un codigo y % de detraccion
                const codigoSunat = item.U_RML_CODSERV;
                const tasa = item.U_RML_CODRET;
                const Rate = Number(item.U_RML_PORCE);

                const sunatConfig = sunatDetractionTable.find(
                    s => Number(s.codigoSunat) === Number(codigoSunat) // Se convierten a Number para comparar correctamente, ya que los valores pueden venir como STRING o NUMBER, aunque originalmente debia de ser STRING.
                );

                // Valida monto mínimo según SUNAT
                if (sunatConfig && Total >= sunatConfig.montoMinimo) {
                    const key = `${codigoSunat}-${tasa}`;

                    // Guardar solo el Rate más alto por combinación
                    if (!detractionMap.has(key) || detractionMap.get(key).Rate < Rate) {
                        detractionMap.set(key, { codigoSunat, tasa, Rate });
                    }
                }
            }
        }

        if (!detractionMap.size) {
            return { Rate: 0, isDetraccion: 'N' };
        }

        // Obtener el registro con el Rate máximo
        const maxDetraction = Array
            .from(detractionMap.values())
            .reduce((max, current) =>
                current.Rate > max.Rate ? current : max
            );

        return {
            Rate: maxDetraction.Rate,
            isDetraccion: 'Y',
            codigoSunat: maxDetraction.codigoSunat,
            tasa: maxDetraction.tasa
        };
    };
    //#endregion DETRACCIONES

    //#region Campos RAMO
    getFieldDataRAMO = async (field, newOrderModel, invFields) => {
        const { getUserFieldHeaderValue } = this.props;
        const isActive = invFields?.some(f => f.Field === field && f.active === true);

        const headerData = await getUserFieldHeaderValue(field, newOrderModel, true);

        return {
            field,
            active: isActive,
            value: newOrderModel?.[field] ?? '',
            Descr: headerData?.headerMatch?.header?.Descr || field
        };
    };

    isEmptyValueRAMO = (val) => {
        return !val || val === '' || val === '-' || val === '- --' || val == null;
    };

    validateRAMOFields = async (newOrderModel, invFields, getUserFieldHeaderValue, isOWTRoOWTQ = true, isOIGNoOIGE = false) => {
        //#region Revisar Serie de documento
        if (isOWTRoOWTQ) { // En Solicitud de traslado y en traslados de momento vienen de campos del json
            const U_BPP_MDSD = await getUserFieldHeaderValue('U_BPP_MDSD', newOrderModel, false);

            const serie = (U_BPP_MDSD ?? '')?.toString()?.toUpperCase();

            if (!serie?.startsWith('T')) {
                return true; // No hubo error
            }
        }
        //#region Revisar Serie de documento

        const { showAlert } = this.props;
        const fieldsToEvaluate = [
            'U_STR_FE_GRE_ModalidadTransporte',
            'U_STR_FE_GRE_CodigoMotivoTraslado',
            'U_STR_FE_GRE_DescriMotivoTraslado',
            'U_STR_FE_GRE_FechaTransporte',
            'U_STR_FE_GRE_TipoDocTransporte',
            'U_STR_FE_GRE_NumDocTransporte',
            'U_STR_FE_GRE_RazonSocialTransporte',
            'U_STR_FE_GRE_NumeroMTC',
            'U_STR_FE_GRE_UnidadMedida',
            'U_STR_FE_GRE_TipoDocConductor',
            'U_STR_FE_GRE_NumeroDocConductor',
            'U_STR_FE_GRE_NombreConductor',
            'U_STR_FE_GRE_ApellidoConductor',
            'U_STR_FE_GRE_LicenciaConductor',
            'U_STR_FE_GRE_PlacaVehiculo',
            'U_RML_GRE_UBILLE',
            'U_RML_GRE_UBIPAR',
            'U_RML_GRE_DNI',
            'U_RML_GRE_NOM',
            'U_RML_GRE_LICENCIA',
            'U_RML_GRE_VEHICULO',
            'U_RML_GRE_CODSUCURSAL',
            'U_RML_GRE_DIRLLE',
            'U_RML_GRE_DIRPAR',
            'U_RS_MOTIVOIS'
        ];

        const fieldMap = {};

        for (const field of fieldsToEvaluate) {
            fieldMap[field] = await this.getFieldDataRAMO(field, newOrderModel, invFields); // Obtener descripción y valor
        }

        const CODIGO = fieldMap['U_STR_FE_GRE_CodigoMotivoTraslado'];
        const DESCRIPCION = fieldMap['U_STR_FE_GRE_DescriMotivoTraslado'];
        const UBILLE = fieldMap['U_RML_GRE_UBILLE'];
        const UBIPAR = fieldMap['U_RML_GRE_UBIPAR'];
        const SUCURSAL = fieldMap['U_RML_GRE_CODSUCURSAL'];
        const FECHA = fieldMap['U_STR_FE_GRE_FechaTransporte'];
        const UNIDAD = fieldMap['U_STR_FE_GRE_UnidadMedida'];
        const MODALIDAD = fieldMap['U_STR_FE_GRE_ModalidadTransporte'];

        const TIPO_DOC_TRANSP = fieldMap['U_STR_FE_GRE_TipoDocTransporte'];
        const NUM_DOC_TRANSP = fieldMap['U_STR_FE_GRE_NumDocTransporte'];
        const RAZON_SOCIAL = fieldMap['U_STR_FE_GRE_RazonSocialTransporte'];
        const MTC = fieldMap['U_STR_FE_GRE_NumeroMTC'];

        const DNI = fieldMap['U_RML_GRE_DNI'];
        const NOM = fieldMap['U_RML_GRE_NOM'];
        const LIC = fieldMap['U_RML_GRE_LICENCIA'];
        const VEH = fieldMap['U_RML_GRE_VEHICULO'];

        const TIPO_DOC_COND = fieldMap['U_STR_FE_GRE_TipoDocConductor'];
        const NUM_DOC_COND = fieldMap['U_STR_FE_GRE_NumeroDocConductor'];
        const NOM_COND = fieldMap['U_STR_FE_GRE_NombreConductor'];
        const APE_COND = fieldMap['U_STR_FE_GRE_ApellidoConductor'];
        const LIC_COND = fieldMap['U_STR_FE_GRE_LicenciaConductor'];
        const PLACA = fieldMap['U_STR_FE_GRE_PlacaVehiculo'];

        const DIRLLE = fieldMap['U_RML_GRE_DIRLLE'];
        const DIRPAR = fieldMap['U_RML_GRE_DIRPAR'];

        const MOTIVOIS = fieldMap['U_RS_MOTIVOIS'];

        const err = (field, labelFallback) => {
            showAlert({
                type: 'warning',
                message: `Es necesario un valor para el campo "${field?.header || labelFallback}"`,
                timeOut: 8000
            });
            return false; // Hubo error
        };

        if (isOIGNoOIGE) {
            //#region Cuenta de mayor para OIGN y OIGE
            if (MOTIVOIS?.active && this.isEmptyValueRAMO(MOTIVOIS?.value)) return err(MOTIVOIS, 'Motivo Ingreso/Salida');
            //#endregion Cuenta de mayor para OIGN y OIGE

            return true; // No hubo error -> En isOIGNoOIGE solo se debe de evaluar lo que este dentro de este if
        }

        if (
            CODIGO?.active && CODIGO?.value === '02' &&
            UBILLE?.active && !this.isEmptyValueRAMO(UBILLE?.value) &&
            SUCURSAL?.active && this.isEmptyValueRAMO(SUCURSAL?.value)
        ) return err(SUCURSAL, 'Código Sucursal');

        if (
            CODIGO?.active && CODIGO?.value !== '02' &&
            UBIPAR?.active && !this.isEmptyValueRAMO(UBIPAR?.value) &&
            SUCURSAL?.active && this.isEmptyValueRAMO(SUCURSAL?.value)
        ) return err(SUCURSAL, 'Código Sucursal');

        if (CODIGO?.active && this.isEmptyValueRAMO(CODIGO?.value))
            return err(CODIGO, 'Código Motivo Traslado');

        if (DESCRIPCION?.active && this.isEmptyValueRAMO(DESCRIPCION?.value))
            return err(DESCRIPCION, 'Descripción Motivo Traslado');

        if (FECHA?.active) {
            if (this.isEmptyValueRAMO(FECHA?.value))
                return err(FECHA, 'Fecha entrega Transportista');

            if (!moment(FECHA?.value, moment.ISO_8601, true).isValid()) {
                showAlert({
                    type: 'warning',
                    message: `La fecha ingresada en "${FECHA?.header}" no es válida`,
                    timeOut: 8000
                });
                return false;
            }
        }

        if (UNIDAD?.active && this.isEmptyValueRAMO(UNIDAD?.value))
            return err(UNIDAD, 'Unidad Medida');

        //#region Modalidades
        if (MODALIDAD?.active && this.isEmptyValueRAMO(MODALIDAD?.value))
            return err(MODALIDAD, 'Modalidad Transporte');

        if (MODALIDAD?.active && MODALIDAD?.value === '01') {
            if (TIPO_DOC_TRANSP?.active && this.isEmptyValueRAMO(TIPO_DOC_TRANSP?.value)) return err(TIPO_DOC_TRANSP, 'Tipo Doc Transportista');
            if (NUM_DOC_TRANSP?.active && this.isEmptyValueRAMO(NUM_DOC_TRANSP?.value)) return err(NUM_DOC_TRANSP, 'Num Doc Transportista');
            if (RAZON_SOCIAL?.active && this.isEmptyValueRAMO(RAZON_SOCIAL?.value)) return err(RAZON_SOCIAL, 'Razón Social');
            if (MTC?.active && this.isEmptyValueRAMO(MTC?.value)) return err(MTC, 'Número MTC');
            if (DNI?.active && this.isEmptyValueRAMO(DNI?.value)) return err(DNI, 'DNI transportista');
            if (NOM?.active && this.isEmptyValueRAMO(NOM?.value)) return err(NOM, 'Nombres transportista');
            if (LIC?.active && this.isEmptyValueRAMO(LIC?.value)) return err(LIC, 'Licencia transportista');
            if (VEH?.active && this.isEmptyValueRAMO(VEH?.value)) return err(VEH, 'Vehículo transportista');
        }

        if (MODALIDAD?.active && MODALIDAD?.value === '02') {
            if (TIPO_DOC_COND?.active && this.isEmptyValueRAMO(TIPO_DOC_COND?.value)) return err(TIPO_DOC_COND, 'Tipo Doc Conductor');
            if (NUM_DOC_COND?.active && this.isEmptyValueRAMO(NUM_DOC_COND?.value)) return err(NUM_DOC_COND, 'Número Doc Conductor');
            if (NOM_COND?.active && this.isEmptyValueRAMO(NOM_COND?.value)) return err(NOM_COND, 'Nombre Conductor');
            if (APE_COND?.active && this.isEmptyValueRAMO(APE_COND?.value)) return err(APE_COND, 'Apellido Conductor');
            if (LIC_COND?.active && this.isEmptyValueRAMO(LIC_COND?.value)) return err(LIC_COND, 'Licencia Conductor');
            if (PLACA?.active && this.isEmptyValueRAMO(PLACA?.value)) return err(PLACA, 'Placa Vehículo');
        }
        //#endregion Modalidades

        //#region Código Motivo Traslado
        if (CODIGO?.active && ['01', '13', '14', '18']?.includes(CODIGO?.value)) {
            if ((UBILLE?.active && !this.isEmptyValueRAMO(UBILLE?.value)) && (DIRLLE?.active && this.isEmptyValueRAMO(DIRLLE?.value)))
                return err(DIRLLE, 'Dirección Llegada');

            if ((DIRLLE?.active && !this.isEmptyValueRAMO(DIRLLE?.value)) && (UBILLE?.active && this.isEmptyValueRAMO(UBILLE?.value)))
                return err(UBILLE, 'Ubigeo Llegada');
        }

        if (CODIGO?.active && ['02']?.includes(CODIGO?.value)) {
            if ((UBIPAR?.active && !this.isEmptyValueRAMO(UBIPAR?.value)) && (DIRPAR?.active && this.isEmptyValueRAMO(DIRPAR?.value)))
                return err(DIRPAR, 'Dirección Partida');

            if ((DIRPAR?.active && !this.isEmptyValueRAMO(DIRPAR?.value)) && (UBIPAR?.active && this.isEmptyValueRAMO(UBIPAR?.value)))
                return err(UBIPAR, 'Ubigeo Partida');
        }
        //#endregion Código Motivo Traslado 

        return true; // No hubo error
    };
    //#region Campos RAMO

    validateBillingields = async (newOrderModel, billingFields, getUserFieldHeaderValue) => {
        const { showAlert } = this.props;
        const fieldsToEvaluate = [
            'U_RML_TDOCORG',
            'U_RML_DOCORG',
            'U_BPP_MDTO',
            'U_BPP_MDSO',
            'U_BPP_MDCO',
            'U_BPP_SDocDate',
        ];

        const fieldMap = {};

        for (const field of fieldsToEvaluate) {
            fieldMap[field] = await this.getFieldDataRAMO(field, newOrderModel, billingFields); // Obtener descripción y valor
        }

        const TDOCORG = fieldMap['U_RML_TDOCORG'];
        const DOCORG = fieldMap['U_RML_DOCORG'];
        const MDTO = fieldMap['U_BPP_MDTO'];
        const MDSO = fieldMap['U_BPP_MDSO'];
        const MDCO = fieldMap['U_BPP_MDCO'];
        const SDocDate = fieldMap['U_BPP_SDocDate'];

        const err = (field, labelFallback) => {
            showAlert({
                type: 'warning',
                message: `Es necesario un valor para el campo "${field?.header || labelFallback}"`,
                timeOut: 8000
            });
            return false; // Hubo error
        };

        if (TDOCORG?.active && this.isEmptyValueRAMO(TDOCORG?.value)) return err(TDOCORG, 'SUNAT: Tipo SAP de Documento Origen');
        if (DOCORG?.active && this.isEmptyValueRAMO(DOCORG?.value)) return err(DOCORG, 'SUNAT: Id. Documento Origen');
        if (MDTO?.active && this.isEmptyValueRAMO(MDTO?.value)) return err(MDTO, 'Tipo de documento de origen');
        if (MDSO?.active && this.isEmptyValueRAMO(MDSO?.value)) return err(MDSO, 'Serie del documento origen');
        if (MDCO?.active && this.isEmptyValueRAMO(MDCO?.value)) return err(MDCO, 'Correlativo doc.origen');
        if (SDocDate?.active) {
            if (this.isEmptyValueRAMO(SDocDate?.value))
                return err(SDocDate, 'FechaCreacion Documento Origen');

            if (!moment(SDocDate?.value, moment.ISO_8601, true).isValid()) {
                showAlert({
                    type: 'warning',
                    message: `La fecha ingresada en "${SDocDate?.header}" no es válida`,
                    timeOut: 8000
                });
                return false;
            }
        }
        return true; // No hubo error
    }

    isMarketingDocument = (view) => {
        return (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'billing' || view === 'invoiceAdvance' || view === 'invoiceReserve' || view === 'return' || view === 'creditNote' || view === 'pendingTimbraDocs')
    }
    showDocs = async (arrDocs) => {
        const { showDocs } = this.props
        $('#DocumentCreateModal').modal('hide');
        await showDocs(arrDocs, this.state.listOrderRecommendation)
    }
    selectOfDocuments = async documentsSelected => {
        const { newOrderModel, showAlert, view, setUserFieldValue, enableSpinner, parseSeries, processUserFields } = this.props;

        if (view === 'landedCosts') {
            if (this.landedCostsRef) {
                this.landedCostsRef.selectOfDocuments(documentsSelected);
            }
            return;
        }

        let user = await JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let origin = documentsSelected[0] ? documentsSelected[0].table ? documentsSelected[0].table.table : '' : '';
        let BaseType;
        let DocEntry;
        let newItems = [];
        let newService = [];
        let header = documentsSelected[0] ? documentsSelected[0].header : [];
        let userFieldsService = documentsSelected[0] ? documentsSelected[0].userFields : [];

        newOrderModel.isSelectOfActive = true;

        if (view === 'ExitHelmets') {
            let comment = ' Basado en entrada de mercancia cascos ' + documentsSelected[0].header.DocNum;
            newOrderModel.Comments += comment;
        }

        const CodigoPromo = Code => {
            let promo = '';

            switch (Code.toUpperCase()) {
                case 'TR':
                    promo = 'YTR';
                    break;
                case 'DG':
                    promo = 'YDG';
                    break;
                case 'ZC':
                    promo = 'YZC';
                    break;
                case 'EN':
                    promo = 'YEN';
                    break;
                case 'ME':
                    promo = 'YME';
                    break;
                case 'PN':
                    promo = 'YPN';
                    break;
                case 'ST':
                    promo = 'YST';
                    break;
                case 'TJ':
                    promo = 'YTJ';
                    break;
                case 'TL':
                    promo = 'YTL';
                    break;

                default:
                    break;
            }
            return promo;
        };
        //#region copy userfields
        let copyUserFields = false
        if (this.selectionDocument(newOrderModel.SelectOf) && this.originDocuments(view)) {
            copyUserFields = true
        }
        //#region copy userfields

        documentsSelected.map(document => {

            if (origin === 'OIGNN') {
                DocEntry = null;
                newOrderModel.DocEntry = null;
                newOrderModel.DocEntryRel = document.header.DocEntryRel;
            } else {
                BaseType = document.header.ObjType;
                DocEntry = document.header.DocEntry;
                newOrderModel.DocEntry = document.header.DocEntry;
            }

            document.items.map(async (item, index) => {
                if (item.LineStatus == 'O') {
                    let itemModel = new NewItem();
                    let serviceModel = new NewService();

                    //hace falta colocar el ultimo nuero de items para que al modificar sepa donde se queod


                    itemModel.LineStatus = false;
                    itemModel.BaseEntry = DocEntry;
                    itemModel.BaseType = BaseType;
                    itemModel.BaseLine = item.LineNum;
                    itemModel.LineNum = item.LineNum;
                    itemModel.ItemCode = item.ItemCode;
                    itemModel.ItemName = item.Dscription;
                    itemModel.Quantity = item.OpenQty || 1; // poner la cantiad que hace falta por facturar antes de cerrar linea
                    itemModel.PQTReqQty = Number(item.PQTReqQty || 0);
                    itemModel.OriginalQuantity = item.Quantity || 1;
                    itemModel.OpenQty = item.OpenQty || 1;
                    itemModel.OriginalQuantityClose = item.Quantity - item.OpenQty;
                    itemModel.WhsCode = item.WhsCode;
                    itemModel.WhsName = item.Almacen;
                    itemModel.OcrCode = item.OcrCode;
                    itemModel.OcrName = "";
                    itemModel.OcrCode2 = item.OcrCode2;
                    itemModel.OcrName2 = "";
                    itemModel.OcrCode3 = item.OcrCode3;
                    itemModel.OcrName3 = "";
                    itemModel.OcrCode4 = item.OcrCode4;
                    itemModel.OcrName4 = "";
                    itemModel.OcrCode5 = item.OcrCode5;
                    itemModel.OcrName5 = "";
                    itemModel.TaxCode = item.TaxCode;
                    itemModel.TaxeRate = item.Impuesto;
                    itemModel.TaxeResult = 0;
                    itemModel.DiscountPercent = item.Descuento;
                    itemModel.Discount = 0;
                    itemModel.Total = 0;
                    itemModel.Filler = item.FromWhsCod;
                    itemModel.FillerName = "";
                    itemModel.ToWhsCode = item.WhsCode;
                    itemModel.ToWhsCodeName = "";
                    itemModel.wareHouseStock = item.wareHouses;
                    itemModel.AcctCode = item.AcctCode || "";
                    itemModel.CogsAcct = item.CogsAcct || "";
                    itemModel.AcctCodeName = item.AcctCodeName || "";
                    itemModel.CogsAcctName = item.CogsAcctName || "";
                    itemModel.ItemNew = false;
                    itemModel.RevenuesAc = item.AcctCode || item.RevenuesAc || "";
                    itemModel.SalPackUn = item.SalPackUn || 1;
                    itemModel.PurPackUn = item.PurPackUn || 1;
                    itemModel.UserBaseUn = item.UserBaseUn || 'N';
                    itemModel.Text = item.Text || '';
                    itemModel.UoMCode = item.UoMCode || '';
                    itemModel.BinActivat = item.BinActivat || 'N';
                    itemModel.Project = item.Project || '';

                    // orden de compra                    
                    itemModel.KilosXComprar = item.U_kilosxcomprar ?? 0;
                    itemModel.PesosXPieza = item.U_pesosxpieza ?? 0;
                    itemModel.PrecioXKilo = item.U_precioxkilo ?? 0;

                    // Información de lotes
                    itemModel.ManBtchNum = item.ManBtchNum;
                    if (itemModel.ManBtchNum === 'Y') {
                        itemModel.OpenLneQty = item.OpenQty;
                        if (!newOrderModel.ShowBatchInfo) { newOrderModel.ShowBatchInfo = true; }
                    }

                    itemModel.TaxStatus = item?.TaxStatus || (itemModel.TaxCode === 'EXO' ? 'N' : item.VATLiable || 'N');
                    itemModel.TaxOnly = item?.TaxOnly || "N";
                    //#region ########## DEFAULT TAXCODE ITEM ##########
                    itemModel.ItemTaxCodeName = item.ItemTaxCodeName
                    itemModel.ItemTaxCode = item.ItemTaxCode
                    itemModel.ItemRate = item.ItemRate
                    //#endregion ########## DEFAULT TAXCODE ITEM ##########

                    //#region Codigos de afectación
                    let isIGV = !itemModel?.TaxCode?.includes("EXO") && (itemModel?.TaxCode?.includes("IGV") || itemModel?.TaxName?.toUpperCase()?.includes("IGV"));
                    let isEXO = itemModel?.TaxCode?.includes("EXO") || itemModel?.TaxName?.toUpperCase()?.includes("EXO") || itemModel?.TaxName?.toUpperCase()?.includes("EXENTO");
                    if ((newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument) && (isIGV || isEXO)) {
                        itemModel.U_BPP_OPER = item?.U_BPP_OPER || '-' // Tipo de Operación
                        itemModel.U_STR_FECodAfect = item?.U_STR_FECodAfect || ''; // Código de Afectación IGV
                        itemModel.TaxStatus = !item?.TaxStatus ? isIGV ? 'Y' : 'N' : itemModel.TaxStatus; // Sólo Impuesto
                    }
                    //#endregion Codigos de afectación

                    itemModel.ItmsGrpCod = item.ItmsGrpCod;

                    //#region GALLONS CONVERSION
                    itemModel.U_RS_UMED = item.U_RS_UMED || '';
                    itemModel.U_RS_CANTG = Number(item.U_RS_CANTG || 0);
                    itemModel.U_RS_PRECIOGL = Number(item.U_RS_PRECIOGL || 0);
                    if (development && !itemModel?.U_RS_PRECIOGL) { // Temporal en lo que dicen como determinar el Precio Galones
                        itemModel.U_RS_PRECIOGL = 100;
                    }
                    itemModel.U_RS_TOTALGL = Number(item.U_RS_TOTALGL || 0);
                    itemModel.U_RS_DENS = Number(item.U_RS_DENS || 0);
                    try {
                        if (((!newOrderModel?.isTransferDocument && itemModel?.WhsCode) || (newOrderModel?.isTransferDocument && newOrderModel?.Filler)) && Granel?.includes(Number(itemModel?.ItmsGrpCod))) {
                            enableSpinner(true);
                            const data = {
                                WhsCode: newOrderModel?.isTransferDocument ? newOrderModel?.Filler : itemModel?.WhsCode,
                            };
                            const apiResponse = await apiClient.getFactorConversion(data);
                            enableSpinner(false);

                            if (apiResponse?.status === 1) {
                                itemModel.U_RS_DENS = Number(apiResponse?.data?.U_FMB_Factor_Conversion || 0);
                            }
                        }
                    } catch (err) { }
                    itemModel.Gallons = item.U_RS_UMED === 'GLN';
                    //#endregion GALLONS CONVERSION

                    //#region DETRACCIONES
                    itemModel.U_RML_AFEDET = item.U_RML_AFEDET || 'N';
                    itemModel.U_RML_CODRET = item.U_RML_CODRET || '';
                    itemModel.U_RML_CODSERV = item.U_RML_CODSERV || '';
                    itemModel.U_RML_PORCE = Number(item.U_RML_PORCE || 0);
                    //#endregion DETRACCIONES

                    itemModel.U_RS_GRUPO = item.U_RS_GRUPO || '';

                    itemModel.UserFieldsItem.userFields1 = item.userFields1;
                    itemModel.UserFieldsItem.userFields2 = item.userFields2 ? item.userFields2.toString().trim() : '';
                    itemModel.UserFieldsItem.userFields3 = item.userFields3;
                    itemModel.UserFieldsItem.userFields4 = item.userFields4;
                    itemModel.UserFieldsItem.userFields5 = item.userFields5;
                    itemModel.UserFieldsItem.userFields6 = item.userFields6;
                    itemModel.UserFieldsItem.userFields7 = item.userFields7;
                    itemModel.UserFieldsItem.userFields8 = item.userFields8;
                    itemModel.UserFieldsItem.userFields9 = item.userFields9;
                    itemModel.UserFieldsItem.userFields10 = item.userFields10;
                    itemModel.UserFieldsItem.userFields11 = item.userFields11;
                    itemModel.UserFieldsItem.userFields12 = item.userFields12;
                    itemModel.UserFieldsItem.userFields13 = item.userFields13;
                    itemModel.UserFieldsItem.userFields14 = item.userFields14;
                    itemModel.UserFieldsItem.userFields15 = item.userFields15;
                    itemModel.UserFieldsItem.userFields16 = item.userFields16;
                    itemModel.UserFieldsItem.userFields17 = item.userFields17;
                    itemModel.UserFieldsItem.userFields18 = item.userFields18;
                    itemModel.UserFieldsItem.userFields19 = item.userFields19;
                    itemModel.UserFieldsItem.userFields20 = item.userFields20;
                    itemModel.UserFieldsItem.userFields21 = item.userFields21;
                    itemModel.UserFieldsItem.userFields22 = item.userFields22;
                    itemModel.UserFieldsItem.userFields23 = item.userFields23;
                    itemModel.UserFieldsItem.userFields24 = item.userFields24;
                    itemModel.UserFieldsItem.userFields25 = item.userFields25;
                    itemModel.UserFieldsItem.userFields26 = item.userFields26;
                    itemModel.UserFieldsItem.userFields27 = item.userFields27;
                    itemModel.UserFieldsItem.userFields28 = item.userFields28;
                    itemModel.UserFieldsItem.userFields29 = item.userFields29;
                    itemModel.UserFieldsItem.userFields30 = item.userFields30;
                    //Campos nivel partida
                    if (view === "invoice" || view === "debitNote" || view === "orderSales" || view === "deliveries" || view === "creditNote") {
                        let data2 = {
                            CardCode: newOrderModel.CardCode,
                            ItemCode: itemModel.ItemCode,
                            Quantity: itemModel.Quantity
                        };
                    }

                    item.wareHouses.map(warehouseStock => {
                        if (warehouseStock.WhsCode == item.WhsCode) {
                            itemModel.OnHand = warehouseStock.OnHand || 0;
                        }
                    });

                    // //Campo para determinar unidad de medida
                    itemModel.NumPerMsr = item.NumPerMsr || 0;
                    //
                    itemModel.InvntItem = item.InvntItem || '';

                    if (itemModel.UserBaseUn === 'Y') {
                        itemModel.newHomePrice = parseFloat(item.Price).toFixed(2);
                        itemModel.newPrice = parseFloat(item.Price).toFixed(2);
                        itemModel.cHomePrice = parseFloat(item.Price).toFixed(2);
                        itemModel.cPrice = parseFloat(item.Price).toFixed(2);
                    } else {
                        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? itemModel.SalPackUn : itemModel.PurPackUn;
                        itemModel.newHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                        itemModel.newPrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                        itemModel.cHomePrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                        itemModel.cPrice = parseFloat(item.Price).toFixed(2) / measureUnit;
                        if (view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn') {
                            itemModel.newHomePrice = parseFloat(item.Price).toFixed(2);
                            itemModel.newPrice = parseFloat(item.Price).toFixed(2);
                            itemModel.cHomePrice = parseFloat(item.Price).toFixed(2);
                            itemModel.cPrice = parseFloat(item.Price).toFixed(2);
                        }

                    }

                    if (view === 'transfers') {
                        itemModel.PricesList = item.itemPrice;
                    }

                    //itemModel.ChangeRate = item.Rate || 1;
                    itemModel.Currency = item.Currency || itemModel.Currency;
                    newOrderModel.DocCur = item.Currency;
                    // newOrderModel.ChangeRate = Number(item.Rate) !== 0 ? item.Rate : 1;
                    newOrderModel.ChangeRate = Number(item.LineRate) !== 0 ? item.LineRate : 1;

                    itemModel.Price = (Number(item.Price) * Number(newOrderModel.ChangeRate));
                    itemModel.HomePrice = (Number(item.Price) * Number(newOrderModel.ChangeRate));

                    if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || isMarketingDoc(newOrderModel?.ObjType)) {
                        itemModel.Price = Number(item.Price) || 0;
                        itemModel.HomePrice = Number(item.Price) || 0;
                    }

                    if (view === 'creditNote' && newOrderModel.SelectOf === 'invoice') {
                        itemModel.HomePrice = item.PriceBefDi;
                    }

                    if (view !== 'payment' && view !== 'transfers' && view !== 'transfersRequest') {
                        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? itemModel.SalPackUn : itemModel.PurPackUn;
                        itemModel.wareHouseStock.map(warehouseStock => {
                            if (warehouseStock.WhsCode == item.WhsCode) {
                                if (warehouseStock.OnHand <= 0) {
                                    showAlert({
                                        type: 'warning',
                                        message: 'El artículo ' + itemModel.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                        timeOut: 5000
                                    });
                                    itemModel.stock = false;

                                } else if ((itemModel.UserBaseUn == 'Y' && itemModel.Quantity > warehouseStock.OnHand) ||
                                    (itemModel.UserBaseUn == 'N' && (itemModel.Quantity * measureUnit) > warehouseStock.OnHand)) {
                                    showAlert({
                                        type: 'warning',
                                        message: 'El artículo ' + itemModel.ItemCode + ' ya no suficiente stock en el almacén seleccionado',
                                        timeOut: 5000
                                    });
                                    itemModel.stock = false;
                                } else {
                                    itemModel.stock = true;
                                }
                            }
                        });
                    }

                    if (view === 'payment') {
                        newOrderModel.DocCur = document.DocCurr;
                    }
                    //Items  para Servicio
                    serviceModel.Description = item.Dscription || '';
                    serviceModel.AcctCode = item.AcctCode || '';
                    serviceModel.AcctCodeName = item.AcctName || '';
                    serviceModel.TaxCode = item.TaxCode || '';
                    serviceModel.Price = item.Price || 0;
                    serviceModel.HomePrice = item.Price || 0;
                    serviceModel.TaxeRate = item.Impuesto || 0;
                    serviceModel.TaxeResult = item.ImpuestoRow || 0;
                    serviceModel.NoGlobal = '';
                    serviceModel.BaseEntry = DocEntry;
                    serviceModel.BaseType = BaseType;
                    serviceModel.BaseLine = item.LineNum;
                    serviceModel.ServiceNew = false;
                    newService.push(serviceModel);

                    newItems.push(itemModel);
                }
            });

        });

        if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || isMarketingDoc(newOrderModel?.ObjType)) {
            newOrderModel.DocCur = header?.DocCur ?? CURRENCY;
        }

        if (view === 'transfers') {
            //Trasnfers
            newOrderModel.Address = header.Address;
            newOrderModel.Filler = header.Filler;
            newOrderModel.FillerName = header.FromWhsName || "";
            newOrderModel.PickRmrk = header.PickRmrk || '';
            newOrderModel.ToWhsCode = header.ToWhsCode || '';
            newOrderModel.ToWhsCodeName = header.ToWhsName || "";
            newOrderModel.JrnlMemo = header.JrnlMemo;
            newOrderModel.Comments += 'Basado en Solicitud de traslado ' + header.DocNum;
            newOrderModel.GroupNumTraslado = header.GroupNum;
            newOrderModel.GroupNumTrasladoName = header.ListName;

            newOrderModel.CardCode = header.CardCode || '';
            newOrderModel.CardName = header.CardName || '';
            newOrderModel.SlpCode = header.SlpCode;
            newOrderModel.SlpName = header.SlpName;
            newOrderModel.CntctCode = header.CntctCode;
            newOrderModel.CntctName = header.CntntName;
            newOrderModel.GroupNum = header.GroupNum;
            newOrderModel.ShipToCode = header.ShipToCode;
            newOrderModel.Address2 = header.Address2;

        }
        let getCuentaBancosResponse = await apiClient.getCurrencies();
        newOrderModel.Currencies = getCuentaBancosResponse?.data;

        //cambio de moneda de dolares y detener so el documento no tiene el tipo de cambio
        if (!newOrderModel?.isSalesDocument && !newOrderModel?.isPurchaseDocument && !isMarketingDoc(newOrderModel?.ObjType)) {
            let currency = newOrderModel.Currencies.filter(currency => {
                return currency.CurrCode === newOrderModel.DocCur;
            });
            if (!currency.length) {
                showAlert({
                    type: 'error',
                    timeOut: 5000,
                    message: "No se a definido el tipo de cambio de la moneda del documento. Para continuar ingrese en SAP el tipo de cambio: " + newOrderModel.DocCur
                })
                return;
            }

            newOrderModel.ChangeRate = currency[0].Rate || 1;

            newItems.map(item => {
                item.ChangeRate = newOrderModel.ChangeRate;
                newOrderModel.Items.push(item);
                return null
            });
        } else {
            if (newOrderModel.DocCur !== CURRENCY) {
                const currency = newOrderModel.Currencies
                    ?.filter(c => c.CurrCode === newOrderModel.DocCur);

                if (!currency?.length) {
                    showAlert({
                        type: 'error',
                        timeOut: 5000,
                        message: "No se ha definido el tipo de cambio de la moneda del documento. Para continuar ingrese en SAP el tipo de cambio: " + newOrderModel.DocCur
                    });
                    return;
                }

                newOrderModel.ChangeRate = Number(currency?.[0]?.Rate) || 1;
            } else { // Documento en moneda local
                newOrderModel.ChangeRate = 1;
            }

            //#region Validar monedas de líneas
            for (const item of newItems) {
                const itemCurrency = item.Currency || newOrderModel.DocCur;
                let lineRate = 1;

                if (itemCurrency !== CURRENCY) {
                    const currencyLine = newOrderModel.Currencies?.filter(c => c.CurrCode === itemCurrency);

                    if (!currencyLine?.length) {
                        showAlert({
                            type: 'error',
                            timeOut: 5000,
                            message: "No se ha definido el tipo de cambio para la moneda de la línea: " + itemCurrency
                        });
                        return;
                    }

                    lineRate = Number(currencyLine?.[0]?.Rate) || 1;
                }

                item.ChangeRate = newOrderModel.ChangeRate;
                item.ChangeRateCurrency = lineRate;

                newOrderModel.Items.push(item);
            }
            //#endregion Validar monedas de líneas
        }

        newService.map(service => {
            newOrderModel.service.push(service);
            return null
        });
        let lastLineNum = newOrderModel.Items.length;
        newOrderModel.Items.map((item, index) => {
            if ((lastLineNum - 1) === index) {
                newOrderModel.LastLineNumItems = item.LineNum;
            }
            return null
        })

        //validacion para evitar que salga la pestaña de coppiar de cuando pasas a copiar a
        newOrderModel.isSelectTo = true;
        // if (view === 'PurchaseOrder' || view=== 'GoodsReceipt' || view==='purchaseReturn') {


        let userFields = new UserFields();
        json.allUserFields.map((item, index) => {
            userFieldsService.map(userfieldItem => {
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    const isInvoice = view === 'invoice';
                    const isCreditNote = view === 'creditNote';
                    const isDebitNote = view === 'debitNote';
                    if (isInvoice || isCreditNote || isDebitNote) {
                        const fieldsSelectList = ["U_BPP_MDTD", "U_BPP_MDSD"];
                        const aliasId = userfieldItem?.header?.AliasID || '';
                        item.fieldType = item.fieldType === 3 || fieldsSelectList.includes(aliasId) || fieldsSelectList.includes(`U_${aliasId}`) ? 3 : userfieldItem.options.length !== 0 ? 2 : 1;
                    } else {
                        item.fieldType = item.fieldType === 3 ? 3 : userfieldItem.options?.length !== 0 ? 2 : 1;
                    }
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = setUserFieldValue(userFields, index, header);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }

                    //#region SERIES Y CORRELATIVOS
                    if (isInvoice || isCreditNote || isDebitNote) { // Validación temporal
                        if (item.fieldId === 1) {//TIPO DE DOCUMENTO
                            let validOptions = [];
                            if (isInvoice) {
                                validOptions = [
                                    { value: '01', label: 'Factura' },
                                    { value: '03', label: 'Boleta' },
                                ]
                            } else if (isCreditNote) {
                                validOptions = [
                                    { value: '07', label: 'Nota de crédito' },
                                ]
                            } else if (isDebitNote) {
                                validOptions = [
                                    { value: '08', label: 'Nota de débito' }
                                ]
                            } else { // Guía
                                validOptions = [
                                    { value: '09', label: 'Guia' },
                                    { value: 'DI', label: 'Documento Interno' },//AUN NO EXISTE REGISTRO EN DB
                                ]
                            }
                            item.options = validOptions
                        }
                        if (item.fieldId === 22) {//CORRELATIVO DOCUMENTO
                            //A FUTURO MOSTRAR POSIBLE CORRELATIVO, DE MOMENTO NO ESTAN INDISPENSABLE AL CREAR

                        }
                        if (item.fieldId === 36) {//SERIE DOCUMENTO
                            let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                            let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                            let seriesPuerta = {}
                            let seriesPlanta = {}
                            try {
                                seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                            } catch (e) {
                                seriesPuerta = {};
                            }
                            try {
                                seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                            } catch (e) {
                                seriesPlanta = {};
                            }
                            const noNeedDefault = isInvoice || isCreditNote || isDebitNote;
                            seriesPuerta = parseSeries(seriesPuerta, noNeedDefault)
                            seriesPlanta = parseSeries(seriesPlanta, noNeedDefault)
                            const isZonal = Number(user?.Branch?.Type) === 1;
                            item.options = (isZonal
                                ? (Array.isArray(seriesPuerta) ? seriesPuerta : [])
                                : (Array.isArray(seriesPlanta) ? seriesPlanta : [])
                            )?.filter((option, index, self) =>
                                index === self?.findIndex(x => x.value === option.value)
                            );
                        }
                    }
                    //#endregion SERIES Y CORRELATIVOS
                    userFields = newUserFields;
                }
                return null
            });
            return null
        });
        if (copyUserFields) {
            const newObject = Object.keys(header ?? {})
                .filter(key => key.startsWith('userFields'))
                .reduce((acc, key) => {
                    acc[key] = header[key];
                    return acc;
                }, {});

            newOrderModel.userFields =
                newObject &&
                    Object.keys(newObject).length > 0
                    ? newObject
                    : userFields;
        } else {
            newOrderModel.userFields = userFields;
        }
        // }
        // Limpiar para no llevar el folio de Counter
        newOrderModel.NumAtCard = '';

        newOrderModel.ExtraDays = header.metodoPago;
        newOrderModel.U_FMB_SCOP_CODE = header.U_FMB_SCOP_CODE || '';


        //Calculo fecha de entrega 
        let today = moment(new Date()).format('YYYY-MM-DD');
        if (newOrderModel.OriginDocumentCreate === 'invoice' || newOrderModel.OriginDocumentCreate === 'invoiceReserve') {


            newOrderModel.DocDate = today;
            newOrderModel.TaxDate = today;  // cambiar la fecha de facturacion y aemas regresar las fechas al dia de hoy
            let extraDays = newOrderModel.ExtraDays;
            let typeInvoice = 0;

            // let userFieldTypeInvoice = newOrderModel.userFields.userFields3;
            // if(userFieldTypeInvoice === 'Contado' || (groupName === 'Pago Inmediato' && grouNum === 9)){
            //     typeInvoice = 3;
            // }else if(userFieldTypeInvoice === 'Credito'){
            //     typeInvoice = 14
            // }else if(userFieldTypeInvoice === 'Credito2'){
            //     if(extraDays > 28){
            //         typeInvoice = extraDays;
            //     }else{
            //         typeInvoice = 28;
            //     }
            // }
            if (typeInvoice === 0) {
                typeInvoice = extraDays ? extraDays : Number(header?.GroupNum) === -1 ? 0 : 3;
            }
            let docDueDate = new Date(today);
            docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
            let weekDays = 0;
            while (weekDays < typeInvoice) {
                docDueDate.setDate(docDueDate.getDate() + 1);
                // if(docDueDate.getDay() != 0){
                weekDays++;
                // }
            }
            newOrderModel.DocDueDate = moment(docDueDate).format('YYYY-MM-DD');
        } else {
            newOrderModel.DocDueDate = today;
        }
        newOrderModel.U_FMB_END_DATE = newOrderModel.DocDueDate;

        //#region Campos de compras
        newOrderModel.U_RS_IMP = header.U_RS_IMP || false;
        newOrderModel.U_RS_IMP = newOrderModel.U_RS_IMP === 'Y' ? true : false;
        newOrderModel.U_RS_NUMIMP = header.U_RS_NUMIMP || '';
        newOrderModel.U_RS_NivelReq = header.U_RS_NivelReq || '0';
        if (newOrderModel?.isPurchaseDocument) {
            newOrderModel.Project = header.Project || '';
        }
        //#endregion Campos de compras

        // CAMPOS FACTURACIÓN
        if (view === 'creditNote' || view === 'debitNote') {
            newOrderModel.U_RML_TDOCORG = header.U_RML_TDOCORG || '';
            newOrderModel.U_RML_DOCORG = header.U_RML_DOCORG || '';
            newOrderModel.U_BPP_MDTO = header.U_BPP_MDTO || '';
            newOrderModel.U_BPP_MDSO = header.U_BPP_MDSO || '';
            newOrderModel.U_BPP_MDCO = header.U_BPP_MDCO || '';
            newOrderModel.U_BPP_SDocDate = header.U_BPP_SDocDate
                ? moment(header.U_BPP_SDocDate).format('YYYY-MM-DD')
                : '';
            newOrderModel.U_RS_SOLAPR = header.U_RS_SOLAPR || '';
            newOrderModel.U_STR_MtvoCD = header.U_STR_MtvoCD || '';
        } else {
            newOrderModel.U_RML_TDOCORG = '';
            newOrderModel.U_RML_DOCORG = '';
            newOrderModel.U_BPP_MDTO = '';
            newOrderModel.U_BPP_MDSO = '';
            newOrderModel.U_BPP_MDCO = '';
            newOrderModel.U_BPP_SDocDate = '';
            newOrderModel.U_RS_SOLAPR = '';
            newOrderModel.U_STR_MtvoCD = '';
        }
        //#region ATTACHMENT
        if (newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument) {
            if (documentsSelected?.length === 1) {
                newOrderModel.AtcEntry = header?.AtcEntry || null;
                newOrderModel.Attachment = header?.Attachment || [];
            }
        }
        //#endregion ATTACHMENT

        if (newOrderModel?.isPurchaseDocument) {
            //#region DETRACCIONES
            newOrderModel.U_STR_AfctoDtr = documentsSelected?.some(doc => doc?.header?.U_STR_AfctoDtr === 'Y') ? 'Y' : 'N';
            newOrderModel.WTCodes = header?.WTCodes || [];
            newOrderModel.WTCodesD = header?.WTCodesD || [];
            newOrderModel.U_FMB_BP_Detra = newOrderModel?.WTCodesD?.length || newOrderModel.U_STR_AfctoDtr === 'Y' ? 'Y' : 'N';

            if (documentsSelected?.length === 1) {
                newOrderModel.U_STR_TasaDTR = Number(header?.U_STR_TasaDTR || 0);
                newOrderModel.U_STR_CodBnSs = header?.U_STR_CodBnSs || '';
                newOrderModel.U_RS_MONDET = Number(header?.U_RS_MONDET || 0);
            } else {
                // Obtener el documento con la mayor tasa DTR
                const docMaxDTR = documentsSelected?.reduce((maxDoc, currentDoc) => {
                    const currentRate = Number(currentDoc?.header?.U_STR_TasaDTR || 0);
                    const maxRate = Number(maxDoc?.header?.U_STR_TasaDTR || 0);
                    return currentRate > maxRate ? currentDoc : maxDoc;
                }, documentsSelected?.[0]);

                newOrderModel.U_STR_TasaDTR = Number(docMaxDTR?.header?.U_STR_TasaDTR || 0);
                newOrderModel.U_STR_CodBnSs = docMaxDTR?.header?.U_STR_CodBnSs || '';
                newOrderModel.U_RS_MONDET = Number(docMaxDTR?.header?.U_RS_MONDET || 0);
            }
            newOrderModel.existsDetraccion = newOrderModel.U_STR_AfctoDtr || 'N';
            newOrderModel.existsDetraccion = ((newOrderModel?.SelectOf === 'PurchaseOrder' && view === 'purchaseInvoice')
                || (newOrderModel?.SelectOf === 'PurchaseOrder' && view === 'GoodsReceipt')
                || (newOrderModel?.SelectOf === 'GoodsReceipt' && view === 'purchaseInvoice')
            ) ? newOrderModel.existsDetraccion === 'Y' : false; // Si se copia de alguna vista valida se conserva el valor, si no no aplica
            //#endregion DETRACCIONES
        }

        //#region RETENCIONES
        if (newOrderModel?.RetencionVista) {
            newOrderModel.U_LLG_RETENCI = documentsSelected?.some(doc => doc?.header?.U_LLG_RETENCI === 'Y') ? 'Y' : 'N';
            newOrderModel.WTCodesR = header?.WTCodesR || [];
            newOrderModel.WTCodesR = newOrderModel.WTCodesR?.filter(wtcode => (wtcode.WTCode || wtcode.WTName || '')?.includes('3%')) ?? [];
            newOrderModel.U_FMB_BP_Reten = newOrderModel?.WTCodesR?.length ? 'Y' : 'N';
            if (documentsSelected?.length === 1) {
                const { DocTotal = 0, DocTotalFC = 0, DocCur = 'SOL' } = header || {};
                newOrderModel.MONRET = newOrderModel?.U_LLG_RETENCI === 'Y' ?
                    DocCur === 'SOL' ? Number((Number(DocTotal || 0) * 0.03)?.toFixed(2)) : Number((Number(DocTotalFC || 0) * 0.03)?.toFixed(2))
                    : 0;
            }
        }
        //#endregion RETENCIONES

        //#region CAMPOS EMPRESA
        const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput';
        const isOWTR = view === 'transfers';
        const isOWTRoOWTQ = isOWTR || view === 'transfersRequest';

        if (isOIGNoOIGE || isOWTRoOWTQ) {
            newOrderModel.GroupNum = -1;
            newOrderModel.invFields = [];
            await processUserFields({
                fields: invFields,
                model: newOrderModel,
                targetProperty: "invFields",
                headerFields: isOWTRoOWTQ ? [] : [
                    'U_BPP_MDTS',
                    'U_RS_MOTIVOIS',
                    'U_RS_TIPOOPER',
                    'U_BPP_MDTD',
                    'U_BPP_MDSD',
                    'U_BPP_MDCD'
                ],
                dateFields: ["U_STR_FE_GRE_FechaTransporte"],
                isOWTRoOWTQ,
                isCopy: true,
                header
            });
        }

        if (isOWTRoOWTQ) {
            newOrderModel.transferFields = [];
            await processUserFields({
                fields: transferFields,
                model: newOrderModel,
                targetProperty: "transferFields",
                headerFields: [],
                dateFields: [],
                isOWTRoOWTQ,
                isCopy: true,
                header
            });
        }

        //#region U_RML_TIPOS13
        const isType13 = Number(newOrderModel?.U_STR_FE_GRE_CodigoMotivoTraslado) === 13;

        const tipos13Field = newOrderModel?.invFields?.find(field => field?.Field === 'U_RML_TIPOS13');
        if (tipos13Field && Object.prototype.hasOwnProperty.call(tipos13Field, 'Static')) {
            tipos13Field.Static = !isType13;
        }
        if (!isType13) {
            newOrderModel.U_RML_TIPOS13 = '';
        }
        //#endregion U_RML_TIPOS13
        //#endregion

        await this.refreshTotal(newOrderModel);


        // Cargar gasto administrativo y cesion en uso
        if ((newOrderModel?.SelectOf === 'orderSales' && view === 'invoice')
            || (newOrderModel?.SelectOf === 'orderSales' && view === 'deliveries')
            || (newOrderModel?.SelectOf === 'deliveries' && view === 'invoice')
            || (newOrderModel?.SelectOf === 'invoice' && view === 'deliveries')
        ) {
            for (let index = 0; index < newOrderModel?.Items?.length; index++) {
                const item = newOrderModel?.Items[index];
                if (Number(item.UserFieldsItem?.userFields2) === 1) { // Es CESION DE USO
                    await this.changeUserFieldsItemsDocument({ nativeEvent: { target: { value: '1' } } }, 1, index)
                }
            }
        }


        this.selectOfReference.disableDataTable();
        $('#selectOfModal').modal('hide');
    };

    changeSelectedFieldDocument = (event) => {
        const { newOrderModel } = this.props;
        let noList = event.nativeEvent.target.value;

        noList = parseInt(noList);

        newOrderModel.GroupNum = noList;

        // Precios de entrada y salida de mercancia (Ultimo precio de compra y ultimo determinado)
        noList = (noList === -1 || noList === -2) ? noList + 1 : noList;
        newOrderModel.Items.map((item) => {
            for (let i = 0; i < item.PricesList.length; i++) {
                let list = item.PricesList[i].PriceList;
                if (list === noList) {
                    // if (newOrderModel.isTransferDocument && (Envasados?.includes(Number(item?.ItmsGrpCod)) || Granel?.includes(Number(item?.ItmsGrpCod)))) {
                    //     // No se hace nada
                    // } else {
                    item.Price = item.PricesList[i].Price;
                    item.HomePrice = item.PricesList[i].Price;
                    // }
                }
            }
            return null
        });
        this.refreshTotal(newOrderModel);
    };

    changeService = event => {
        const { newOrderModel } = this.props;
        let DocType = event.nativeEvent.target.value;
        let servicio = DocType === 'I' ? false : true;
        newOrderModel.DocType = DocType || 'I'

        if (DocType === 'I') {
            newOrderModel.service = [];
        } else {
            newOrderModel.Items = [];
        }
        newOrderModel.Total = 0;
        newOrderModel.Subtotal = 0;
        newOrderModel.Taxes = 0;
        newOrderModel.Discount = 0;

        this.refreshModel(newOrderModel);
        this.setState({
            service: servicio
        });


    }

    changeDescription = (event, index) => {
        const { newOrderModel, view, showAlert } = this.props;

        if (!this.validatePartner() && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets') {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        newOrderModel.service[index].Description = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    }

    ChangeU_TipoSalida = async (value) => {
        const { newOrderModel, enableSpinner } = this.props;
        newOrderModel.U_TipoSalida = value;

        enableSpinner(true);
        if (newOrderModel.Items.length !== 0 && !newOrderModel?.InventoryAccount?.AcctCode) {
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const item = newOrderModel.Items[index];

                let data = {
                    Type: newOrderModel.U_TipoSalida,
                    WhsCode: item.WhsCode,
                }

                let responseGetAcctCode = await apiClient.getAcctCodeType_I_O(data);
                if (responseGetAcctCode.status === 1) {
                    if (responseGetAcctCode.data[0].AcctCode !== '') {
                        const cuentaOriginal = responseGetAcctCode.data[0].AcctCode;
                        const expresionRegular = /^(\d{7})(\d{2})(\d{2})$/;
                        const resultado = cuentaOriginal.replace(expresionRegular, "$1-$2-$3");
                        item.FormatCode = resultado;
                        item.AcctCode = cuentaOriginal;
                    }
                }
            }
        }
        enableSpinner(false);
        this.refreshModel(newOrderModel);
    }

    DownloadDoc = async (type) => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        let data = {
            docNum: newOrderModel.DocNum,
            serie: newOrderModel.SerieCode,
            serieName: newOrderModel.SerieName,
            type
        }
        enableSpinner(true);
        let responsePdf = await apiClient.DownloadDocuments(data);
        enableSpinner(false);
        let getFieldName = responsePdf.headers.get('content-disposition');
        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: 'Error al traer PDF', timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    }

    DownloadForeignDocs = async (type) => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        let data = {
            docNum: newOrderModel.DocNum,
            serie: newOrderModel.SerieCode,
            serieName: newOrderModel.SerieName,
            table: 'OINV',
            type
        }
        enableSpinner(true);
        let responsePdf = await apiClient.DownloadForeignDocs(data);
        enableSpinner(false);
        let getFieldName = responsePdf.headers.get('content-disposition');
        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: 'Error al traer PDF', timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    }

    DownloadDocCartaPorte = async (type) => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        let data = {
            docNum: '555_' + newOrderModel.DocNum,
            serie: 'CARTA_PORTE_' + newOrderModel.CardCode + '_' + newOrderModel.SerieCode,
            serieName: newOrderModel.SerieName,
            type
        }
        enableSpinner(true);
        let responsePdf = await apiClient.DownloadDocuments(data);
        enableSpinner(false);
        let getFieldName = responsePdf.headers.get('content-disposition');
        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: `Error al traer el ${type} de CARTA PORTE`, timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    }

    DownloadDocCancel = async (type) => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        const data = {
            nameDocument: newOrderModel.LicTradNum + "_" + newOrderModel.U_UDF_UUID,
            type,
        }
        enableSpinner(true);
        let responsePdf = await apiClient.DownloadCancelationDocuments(data);
        enableSpinner(false);
        let getFieldName = responsePdf.headers.get('content-disposition');
        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: 'Error al traer PDF de solicitud de Cancelación', timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    }

    openCard = async (index) => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;
        const isAccountPayment = newOrderModel?.isAccountPayment;
        if (!this.validatePartner() && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && !isAccountPayment) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }
        enableSpinner(true);
        let response = await apiClient.getCards();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            cardList: response.data,
            cardLine: index
        });

        $('#cardsListModal').modal('show');
    };

    selectCardList = async (action) => {
        const { cardList, cardLine } = this.state;
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        let card = cardList[action.index];

        enableSpinner(true);
        let response = await apiClient.getCard(card.CreditCard);
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        newOrderModel.PaymentsCreditCards[cardLine].CreditCard = card.CreditCard || '';
        newOrderModel.PaymentsCreditCards[cardLine].LineNum = cardLine;
        newOrderModel.PaymentsCreditCards[cardLine].CrTypeCode = response.data[0].CrTypeName || '1';
        newOrderModel.PaymentsCreditCards[cardLine].OwnerPhone = card.Phone || '';
        newOrderModel.PaymentsCreditCards[cardLine].MaxValid = response.data[0].MaxValid || 0;
        newOrderModel.PaymentsCreditCards[cardLine].CardName = card.CardName || '';
        newOrderModel.PaymentsCreditCards[cardLine].CreditAcct = card.AcctCode || '';

        this.refreshModel(newOrderModel);

        $('#cardsListModal').modal('hide');
    };

    validateCasco = async (e, index, item) => {
        validateCascoG({ props: this.props, state: this.state, refreshModel: this.refreshModel, e, index, item, openItems: this.openItems, refreshTotal: this.refreshTotal })
    }

    //#region ATTACHMENT
    ChangeStateAreYouAgreeAttachments = async (files) => {
        await this.setState({
            showAreUAgree: !this.state.showAreUAgree
        })
        if (files !== null || files !== undefined) await this.ShowAreUAgreeModalAttachments(files);
    }

    ShowAreUAgreeModalAttachments = async (files) => {
        const { showAreUAgree } = this.state
        if (showAreUAgree) {
            await this.setState({
                CancelAction: async () => {
                    await this.ChangeStateAreYouAgreeAttachments(null);
                    var fileInput = document.getElementById("fileImput2");
                    if (fileInput) {
                        fileInput.value = null;
                    }
                    $('#areYouAgreeModal').modal('hide');
                },
                AcceptAction: async () => {
                    const auxFiles = files;
                    this.Change_Attachment(auxFiles);
                    await this.ChangeStateAreYouAgreeAttachments(null);
                    document.getElementById("fileImput2").value = null;
                }
            })
            $('#areYouAgreeModal').modal('show');
        }
    }

    Change_Attachment = (files) => {
        const { newOrderModel, showAlert, setFiles, file } = this.props;

        Object.getOwnPropertyNames(files).forEach((prop) => {
            const value = files[prop];
            if (value === undefined) {
                showAlert({ type: 'warning', message: 'Por favor seleccione el archivo', timeOut: 8000 });
                document.getElementById("fileImput2").value = null;
                setFiles([])
                return;
            }

            let extension = value.name.lastIndexOf(".");
            let validateExt = value.name.substring(extension, value.name.length);
            let name = value.name.substring(0, extension);

            let exist = file.find(currFile => currFile.name === value.name);
            if (exist) {
                return showAlert({ type: 'warning', message: 'El archivo ' + value.name + ' ya se cargó', timeOut: 8000 });
            }
            exist = newOrderModel.Attachment.find(currFile => currFile.FileName === name && currFile.FileExt === validateExt.substring(1, validateExt.length));
            if (exist) {
                return showAlert({ type: 'warning', message: 'El archivo ' + value.name + ' ya se cargó', timeOut: 8000 });
            }

            let attach = {
                AbsEntry: newOrderModel.AtcEntry || null,
                Line: newOrderModel.Attachment.length + 1,
                srcPath: './Attachments/',
                trgtPath: './Attachments/',
                FileName: name,
                FileExt: extension,
                New: true,
                validateExt,
                Date: moment(new Date()).utc().format('YYYY-MM-DD'),
                UsrID: 1,
                Copied: 'Y',
                Override: 'N',
                subPath: null,
                FreeText: '',
                CopyToTrgt: 'N',
                FileInput: value
            }
            newOrderModel.Attachment.push(attach);

            this.refreshModel(newOrderModel);
            let auxArray = file;
            auxArray.push(value)
            setFiles(auxArray)
            showAlert({ type: 'success', message: `Archivo ${name || ''} listo para subirse`, timeOut: 8000 });
        });
        this.setState({
            auxFilesState: files,
            hasUploadedAttachment: true,
        })
    };

    UploadFile = async () => {
        const { newOrderModel, showAlert, enableSpinner, file } = this.props;

        if (file.length > 0) {
            for (let x = 0; x < file.length; x++) {
                const fileTurn = file[x];
                let formData = new FormData();
                formData.append("id", x);
                formData.append("AtcEntry", newOrderModel.AtcEntry || null);
                formData.append("Attachment", JSON.stringify(newOrderModel.Attachment[[x]]));
                formData.append("FreeText", newOrderModel?.Attachment[x]?.FreeText ? JSON.stringify(newOrderModel.Attachment[x].FreeText) : '');
                formData.append("archivo", fileTurn);
                enableSpinner(true);
                const saveFileResponse = await apiClient.SaveFileOV(formData);
                enableSpinner(false);
                if (saveFileResponse.status === 1) {
                    showAlert({ type: 'success', message: saveFileResponse.message });
                    this.setState({ flagUploadAttachments: true });
                    newOrderModel.UploadAttachments.push(saveFileResponse.data);
                } else if (saveFileResponse.status === 3) {
                    showAlert({ type: 'info', message: saveFileResponse.message });
                } else if (saveFileResponse.status === 0 || saveFileResponse.status === 4 || saveFileResponse.status === 5) {
                    showAlert({ type: 'error', message: saveFileResponse.message });
                }
            }
        } else {
            showAlert({ type: 'warning', message: 'Selecciona un archivo a subir' });
        }
    };

    Change_FreeText = (event, index) => {
        const { newOrderModel } = this.props;
        if (index != null) {
            newOrderModel.Attachment[index].FreeText = event.nativeEvent.target.value;
            this.refreshModel(newOrderModel);
        }
    };

    DeleteAttachment = async (index) => {
        const { newOrderModel, setFiles, file } = this.props
        const atcName = `${newOrderModel.Attachment[index]?.FileName || ""}`;
        const uploadIndex = (Array.isArray(newOrderModel?.UploadAttachments) ? newOrderModel.UploadAttachments : []).
            findIndex((attachment) => attachment.FileName === atcName);

        let auxArrayFiles = file;
        let auxArrayAttachment = newOrderModel.Attachment;
        auxArrayAttachment.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        auxArrayFiles.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        if (uploadIndex !== -1) {
            newOrderModel.UploadAttachments.splice(uploadIndex, 1);
        }

        if (auxArrayAttachment.length === 0) {
            document.getElementById("fileImput2").value = null;
            this.setState({
                hasUploadedAttachment: false,
            });
        }

        this.refreshModel(newOrderModel)
        setFiles(auxArrayFiles)
    }
    //#endregion ATTACHMENT

    //SOCIO DE NEGOCIOS
    //######################################################################### newDoc   ################################
    openDownPayments = async () => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;
        const data = {
            CardCode: newOrderModel.CardCode
        }
        enableSpinner(true);
        const responseApi = await apiClient.getDownPaymentsByPartner(data);
        enableSpinner(false);
        if (responseApi.status === 0) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        const downPayments = await this.MatchDownPaymentsWithData(responseApi?.data?.DownPayments ?? [])
        this.setState({
            DownPayments: downPayments,
            showDownPayments: true
        })
        $('#downPayments').modal('show');
    }

    ChangeDowPaymentData = async (index, value) => {
        const { DownPayments } = this.state
        let auxDP = DownPayments;

        auxDP[index].BaseAmntEdit = Number(value) > Number(auxDP[index].BaseAmnt) ? Number(auxDP[index].BaseAmnt) : value;

        await this.setState({
            DownPayments: auxDP
        })
    }

    MatchDownPaymentsWithData = async (backData) => {
        const { newOrderModel } = this.props
        for (let n = 0; n < backData.length; n++) {
            let backDownPayment = backData[n];
            const findItem = newOrderModel?.DownPaymentsToDraw?.find((dp) => Number(backDownPayment.DocEntry) === Number(dp.DocEntry))
            if (findItem !== undefined) {
                backDownPayment.BaseAmntEdit = findItem.AmountToDraw;
            }
        }
        return backData
    }

    showDocumentStock = async (lineNum) => {
        const { newOrderModel } = this.props;
        const data = newOrderModel.DocumentStock?.filter(({ LineNum }) => LineNum === lineNum);
        await this.setState({ documentStock: data, showDocumentStock: true });
        $("#documentStockModal").modal("show");
    };

    showLocationAssignment = async (lineNum, option) => {
        // const { newOrderModel } = this.props;
        // const data = newOrderModel.Items.filter(({ LineNum }) => LineNum === lineNum);
        await this.setState({ lineNumLocation: lineNum, showLocationAssignment: true, optionLocation: option });
        $("#locationAssignment").modal("show");
    };

    changeBatFromWarehouse = async (event, index, LineNum) => {
        const { showAlert, newOrderModel } = this.props;

        let quantity = event.nativeEvent.target.value;

        if (quantity.indexOf(" ") !== -1 || quantity.indexOf("-") !== -1) {
            showAlert({ type: 'warning', message: "Carácter no permitido" });
            return;
        }

        if (!isNaN(quantity) && quantity !== '') {
            newOrderModel.Items[LineNum].TotalAsigned -= Number(newOrderModel.Items[LineNum].FromLocationAssignment[index].Quantity || 0);
            if (Number(newOrderModel.Items[LineNum].TotalAsigned) <= Number(newOrderModel.Items[LineNum].Quantity)) {
                newOrderModel.Items[LineNum].FromLocationAssignment[index].Quantity = quantity;
                newOrderModel.Items[LineNum].TotalAsigned += Number(quantity);
            } else {
                showAlert({ type: 'warning', message: "La cantidad no puede ser mayor a la asignada." });
            }
        } else if (quantity === '') {
            newOrderModel.Items[LineNum].FromLocationAssignment[index].Quantity = '';
        }
        setTimeout(() => {
            this.refreshModel(newOrderModel);
        }, 100);

    };

    openLocations = async (positionToLocation = null, auxWhsCode = null) => {
        const { showAlert, enableSpinner, newOrderModel, view } = this.props;
        let searchLocation = newOrderModel.searchLocation;
        // let ToWhsCode = newOrderModel.ToWhsCode || ''; // Original

        const newView = newOrderModel.newView || view;
        const DocBinView = newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument || newView === 'transfersEntry' || newView === 'transfersOutput';
        let ToWhsCode = !DocBinView ? newOrderModel.ToWhsCode || '' : auxWhsCode || '';

        this.setState({
            showOptions: false
        })
        let getLocationResponse = null;
        enableSpinner(true);
        getLocationResponse = await apiClient.getLocations(searchLocation, 1, 10, ToWhsCode);
        enableSpinner(false);

        if (getLocationResponse.data.length === 0) {

            if (!Array.isArray(getLocationResponse.data.results)) {
                showAlert({ type: 'info', message: getLocationResponse.message });
                return;
            }

            if (getLocationResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }
        if (view === 'inventoryPosting') {
            this.setState({
                positionLine: positionToLocation,
            });
        }
        if (getLocationResponse.data.results.length === 1) {
            this.setState({
                locations: getLocationResponse.data.results,
            });
            await this.selectLocationsEnter(getLocationResponse.data.results[0], positionToLocation);
        } else {
            this.setState({
                showListLocationsModal: true,
                locations: getLocationResponse.data.results,
                pageTotal: getLocationResponse.data.totalPage
            });
            $('#listLocations').modal('show');
        }
    };

    changeSearchLocations = async (event, position = null) => {
        const { newOrderModel, view } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.searchLocation = event.nativeEvent.target.value;
        }
        if (view === 'inventoryPosting') {
            newOrderModel.Items[position].BinCode = event.nativeEvent.target.value;
        }
        this.refreshModel(newOrderModel);
    };

    openLocationDetails = async (AbsEntry) => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getLocation(AbsEntry);
        enableSpinner(false);
        if (responseApi.status === 0) { return showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' }); }

        await this.setState({ locationModel: responseApi.data[0], showLocationModal: true });
        $("#locationModal").modal("show");
    };

    changeBatToWarehouse = async (event, index, LineNum) => {
        const { showAlert, newOrderModel } = this.props;
        const newValue = event.nativeEvent.target.value;

        let item = newOrderModel.Items[LineNum];
        let location = item.ToLocationAssignment[index];

        if (!isNaN(newValue)) {
            let totalAssigned = Number(item.ToTotalAsigned ?? 0);
            let locationQty = Number((location.Quantity === "." ? 0 : location.Quantity) ?? 0);
            let quantity = Number(newValue ?? 0);

            totalAssigned = totalAssigned - locationQty;
            item.ToTotalAsigned = totalAssigned.toFixed(3);

            totalAssigned = totalAssigned + quantity;
            item.ToTotalAsigned = totalAssigned.toFixed(3);

            location.Quantity = newValue;
            location.remainingQty = (Number(location.OnHandQty) - quantity).toFixed(3);

            if (Number(item.ToTotalAsigned) > Number(item.Quantity)) { return showAlert({ type: 'warning', message: "La cantidad asignada no puede ser mayor a la cantidad requerida." }); }
        }
        else if (newValue === ".") { location.Quantity = newValue; }
        else { return showAlert({ type: 'warning', message: "Ingrese un número valido" }); }
        this.refreshModel(newOrderModel);
    };

    selectLocationsEnter = async (data, positionToLocation) => {
        const { newOrderModel, showAlert, view } = this.props;
        const newView = newOrderModel.newView || view;
        const DocBinView = newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument || newView === 'transfersEntry' || newView === 'transfersOutput';

        if (view === 'inventoryPosting') {
            newOrderModel.Items[positionToLocation].AbsEntry = data.AbsEntry || '';
            newOrderModel.Items[positionToLocation].BinCode = data.BinCode || '';
            let validateOnHand = newOrderModel.Items[positionToLocation].wareHouseStock.find(whs => whs.WhsCode === newOrderModel.Items[positionToLocation].WhsCode);
            if (validateOnHand.Location) {

                let onHand = validateOnHand.Location.find(stock => stock.BinCode === newOrderModel.Items[positionToLocation].BinCode);

                if (onHand) {
                    newOrderModel.Items[positionToLocation].OnHandBef = parseFloat(onHand.OnHandQty || 0).toFixed(2);
                }
            }
        } else {
            const item = newOrderModel.Items.find(i => i.LineNum === positionToLocation);

            if (!item) {
                showAlert({ type: 'error', message: 'No se encontró la línea para asignar la ubicación' });
                return;
            }
            // if (newOrderModel.Items[positionToLocation].ToLocationAssignment.some(toLocation => toLocation.AbsEntry === data.AbsEntry)) {
            //     showAlert({ type: 'warning', message: "No se puede agregar ubicaciones que ya existen" });
            //     return;
            // }
            if (item.ToLocationAssignment.some(toLocation => toLocation.AbsEntry === data.AbsEntry) || (item.DocumentLinesBinAllocations?.some(toLocation => toLocation.AbsEntry === data.AbsEntry) && DocBinView)) {
                showAlert({ type: 'warning', message: "No se puede agregar ubicaciones que ya existen" });
                return;
            }
            // newOrderModel.Items[positionToLocation].ToLocationAssignment.push(data);
            if (!DocBinView) {
                item.ToLocationAssignment.push(data);
            }
            else {
                item.DocumentLinesBinAllocations.push(data);
            }
        }
        newOrderModel.searchLocation = '';
        this.refreshModel(newOrderModel);
        this.setState({
            showListLocationsModal: false,
        });
        $('#listLocations').modal('show');
    };

    refreshLocations = async (item, totalRows, searchLocation) => {
        const { newOrderModel } = this.props;
        newOrderModel.searchLocation = searchLocation;
        this.setState({
            locations: item,
            pageTotal: totalRows
        });
        this.refreshModel(newOrderModel);
    };

    docsWithoutStock = (docType) => {
        if (docType === 'returnRequest') return true;
        return false;
    }

    changePaymentDocumentType = DocType => {
        const { newOrderModel, view } = this.props;
        newOrderModel.PaymentDocType = DocType;
        newOrderModel.isAccountPayment = view === 'payment' && newOrderModel?.PaymentDocType === 'A' ? true : false;
        newOrderModel.ItemsPayments = [];

        newOrderModel.TrsfrAcctFormatCode = '';
        // newOrderModel.TrsfrDate = '';
        newOrderModel.TrsfrRef = '';
        newOrderModel.TrsfrSum = 0;

        newOrderModel.CheckAcctFormatCode = '';
        newOrderModel.CheckList = [];
        newOrderModel.CheckSum = 0;

        newOrderModel.CashAcctFormatCode = '';
        newOrderModel.CashSum = 0;

        newOrderModel.PaymentsCreditCards = [new CreditCards()];

        newOrderModel.totalRecibido = 0;
        newOrderModel.totalDocumento = 0;
        newOrderModel.totalRestante = 0;

        this.refreshModel(newOrderModel);
    };

    changeHeaderField = async (key, value, maxLength = null, isNumber = false) => {
        if (!key) {
            return;
        }
        const { newOrderModel, view, enableSpinner, showAlert, isDraftOWTQ = false, parseSeries } = this.props;
        let newValue = value ?? '';
        const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput' || Number(newOrderModel?.ObjType) === 59 || Number(newOrderModel?.ObjType) === 60;
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || Number(newOrderModel?.ObjType) === 67 || Number(newOrderModel?.ObjType) === 1250000001 || isDraftOWTQ;
        const isCreditDebitNote = ((view === 'creditNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'creditNote' || Number(newOrderModel?.ObjType) === 14) || ((view === 'debitNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'debitNote');

        if (isNumber) {
            newValue = newValue?.replace(/[^0-9.]/g, '');
            const parts = newValue?.split('.');
            if (parts?.length > 2) {
                newValue = parts[0] + '.' + parts?.slice(1)?.join('');
            }
        }

        if (maxLength) {
            newValue = newValue?.slice(0, maxLength);
        }

        newOrderModel[key] = newValue;
        await this.refreshModel(newOrderModel);
        //#region RETENCIONES
        if (key === 'U_RS_IMP' && (newOrderModel.RetencionVista || newOrderModel?.newView === 'PurchaseOrder')) {
            await this.refreshTotal(newOrderModel);
        }
        //#endregion RETENCIONES
        if ((isOIGNoOIGE) && key === 'U_RS_TIPOOPER' && newOrderModel?.DocType === 'I' && newOrderModel?.Items?.length) {
            for (const item of newOrderModel?.Items) {
                const aliasToFind = "U_tipoOpT12";
                const headers = newOrderModel?.userFieldsBody || [];
                const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                if (bodyMatch) {
                    const fieldId = bodyMatch?.header?.FieldID;
                    const options = bodyMatch?.options || [];
                    const allFields = json?.allItemsUserFields || [];
                    const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                    if (foundIndex !== -1) {
                        const fieldNumber = foundIndex + 1;
                        const U_tipoOpT12 = options?.find(option => value ? option?.FldValue?.toUpperCase() === value : option?.FldValue?.toUpperCase() === value || option?.FldValue?.toUpperCase() === null)?.FldValue || '';
                        item.UserFieldsItem[`userFields${fieldNumber}`] = U_tipoOpT12; // Asignar mismo que el de cabecera
                    }
                }
            }
            await this.refreshModel(newOrderModel);
        }

        //#region Valores dependientes
        if ((!isNumber && (isOIGNoOIGE || isOWTRoOWTQ)) || isCreditDebitNote) {
            const Field = key;
            let linkedFields = invFields?.filter(field => field?.active && field?.linkedValue === Field) ?? [];  // Campos dependientes
            if (isCreditDebitNote && Field === 'U_RML_DOCORG' && !newValue) {
                linkedFields = linkedFields = linkedFields.concat(billingFields.filter(field => field?.active && field?.linkedValue === Field));
            }
            if (linkedFields?.length) {
                if (value) {
                    enableSpinner(true);
                    let data = {
                        Field,
                        param1: value
                    };
                    if (isCreditDebitNote && Field === 'U_RML_DOCORG') {
                        data.param2 = newOrderModel?.U_RML_TDOCORG || ''
                    }
                    let res = await apiClient.getFormattedQueriesByCUFD(data);
                    enableSpinner(false);

                    if (res?.status) {
                        const row = res?.data ?? {};

                        for (const lf of linkedFields) { // Asignar valores a campos dependientes
                            const targetField = lf.Field;

                            if (row.hasOwnProperty(targetField)) {
                                newOrderModel[targetField] = row[targetField];
                            } else {
                                newOrderModel[targetField] = '';
                            }
                        }

                    } else { // Limpiar dependientes
                        showAlert({ type: 'error', message: `Ocurrió un error al consultar los valores dependientes del campo` });
                        for (const lf of linkedFields) {
                            newOrderModel[lf.Field] = '';
                        }
                    }

                } else { // Limpiar dependientes
                    for (const lf of linkedFields) {
                        newOrderModel[lf.Field] = '';
                    }
                }
            }
            await this.refreshModel(newOrderModel);
        }
        if (isOWTRoOWTQ) {
            if (key === 'U_RML_TIPOS13') {
                const CodigoMotivoTraslado = newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado;
                if (CodigoMotivoTraslado === '13') {
                    const tipos13Field = newOrderModel?.invFields?.find(field => field?.Field === key);
                    let tipos13Desc = tipos13Field?.options?.find(option => option?.FldValue === value)?.Descr || '';
                    enableSpinner(true);
                    let data = {
                        Field: 'U_STR_FE_GRE_CodigoMotivoTraslado',
                        param1: CodigoMotivoTraslado
                    };
                    let res = await apiClient.getFormattedQueriesByCUFD(data);
                    enableSpinner(false);
                    const row = res?.data ?? {};
                    newOrderModel.U_STR_FE_GRE_DescriMotivoTraslado = tipos13Desc ? `${row?.U_STR_FE_GRE_DescriMotivoTraslado || ''}: ${tipos13Desc}` : row?.U_STR_FE_GRE_DescriMotivoTraslado || '';
                    await this.refreshModel(newOrderModel);
                }
            }
        }
        if (isOIGNoOIGE) {
            if (key === 'U_BPP_MDTD') {
                let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
                let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                let seriesPuerta = {}
                let seriesPlanta = {}
                try {
                    seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                } catch (e) {
                    seriesPuerta = {};
                }
                try {
                    seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                } catch (e) {
                    seriesPlanta = {};
                }
                const noNeedDefault = true;
                seriesPuerta = parseSeries(seriesPuerta, noNeedDefault);
                seriesPlanta = parseSeries(seriesPlanta, noNeedDefault);
                const isZonal = Number(user?.Branch?.Type) === 1;
                let options = (
                    isZonal
                        ? (Array.isArray(seriesPuerta) ? seriesPuerta : [])
                        : (Array.isArray(seriesPlanta) ? seriesPlanta : [])
                )?.filter((option, index, self) =>
                    (option.key === newValue) &&
                    index === self.findIndex(x => x.value === option.value)
                );

                const serieField = newOrderModel?.invFields?.find(field => field?.Field === 'U_BPP_MDSD');
                if (serieField && Object.prototype.hasOwnProperty.call(serieField, 'Static')) {
                    const hasOptions = options?.length;
                    serieField.Static = newValue ? false : true;
                    serieField.options = !newValue ? [] : hasOptions ? options : [];
                    serieField.Type = hasOptions ? "select" : "text";
                }

                newOrderModel.U_BPP_MDSD = '';
                newOrderModel.U_BPP_MDCD = '';
                await this.refreshModel(newOrderModel);
            }
        }
        //#endregion Valores dependientes

        //#region Cuenta de mayor para OIGN y OIGE
        if (isOIGNoOIGE && key === 'U_RS_MOTIVOIS') {
            let InventoryAccount = {}
            if (newValue) {
                let data = {
                    U_RS_MOTIVOIS: newValue
                }
                enableSpinner(true);
                const res = await apiClient.getInventoryAccount(data);
                enableSpinner(false);
                if (res?.status) {
                    InventoryAccount = res?.data ?? {};
                } else {
                    showAlert({ type: 'error', message: `Ocurrió un error al consultar la cuenta de mayor conforme el motivo` });
                }
            }

            newOrderModel.InventoryAccount = InventoryAccount ?? {};
            for (let item of newOrderModel?.Items) {
                item.AcctCode = InventoryAccount?.AcctCode || '';
                item.AcctCodeName = InventoryAccount?.AcctName || '';
                item.CurrTotal = InventoryAccount?.CurrTotal || 0;
                item.FormatCode = InventoryAccount?.FormatCode || '';
                item.AcctCode2 = '';
                item.FormatCode2 = '';
            }
            await this.refreshModel(newOrderModel);
        }
        //#endregion Cuenta de mayor para OIGN y OIGE
    };

    changeBlurHeaderField = async (key, value, toFixedValue = null, isNumber = false) => {
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;
        if (isNumber && (toFixedValue || toFixedValue === 0)) {
            value = !value || value === '.' ? 0 : value;
            newOrderModel[key] = Number(value || 0)?.toFixed(toFixedValue);
            await this.refreshModel(newOrderModel);
        } else {
            const blurFields = [ // Listado de campos que aplican a onBlur
                'U_BPP_MDSD'
            ];
            if (blurFields?.includes(key || '')) {
                const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput' || Number(newOrderModel?.ObjType) === 59 || Number(newOrderModel?.ObjType) === 60;
                if (isOIGNoOIGE && key === 'U_BPP_MDSD') { // Obtener correlativo
                    if (value) {
                        const tipoDocumento = newOrderModel.U_BPP_MDTD;
                        const serieDocumento = value;

                        enableSpinner(true);
                        const response = await apiClient.getCorrelativo({ tipoDocumento, serieDocumento });
                        enableSpinner(false);

                        if (!response?.status) {
                            newOrderModel.U_BPP_MDCD = '';
                            showAlert({ type: 'warning', message: response?.message || 'No se encontró un correlativo para el tipo y la serie seleccionados' });
                        } else {
                            newOrderModel.U_BPP_MDCD = response?.data?.DocNum ?? '';
                        }
                    } else {
                        newOrderModel.U_BPP_MDCD = '';
                    }
                    await this.refreshModel(newOrderModel);
                }
            }
        }
    }

    changeLineField = async (key, index, value, maxLength = null) => {
        const { newOrderModel } = this.props;
        if (newOrderModel?.DocType === 'I') {
            newOrderModel.Items[index][key] = maxLength ? value?.slice(0, maxLength) : value;
        } else {
        }
        await this.refreshModel(newOrderModel);
    };

    changeTaxStatus = async (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.Items[index].TaxStatus = event.nativeEvent.target.value;
        await this.refreshTotal(newOrderModel, index);
    }

    validateInventoryCheck = () => {
        const { newOrderModel } = this.props;
        return (newOrderModel.OriginDocumentCreate === "PurchaseQuotation" || newOrderModel.OriginDocumentCreate === "PurchaseQuotationDraft" || newOrderModel.OriginDocumentCreate === "PurchaseOrder" ||
            newOrderModel.OriginDocumentCreate === "purchaseReturn" || newOrderModel.OriginDocumentCreate === "purchaseInvoice" || newOrderModel.OriginDocumentCreate === "purchaseCreditNotes" ||
            newOrderModel.OriginDocumentCreate === "purchaseDownPayments" || newOrderModel.OriginDocumentCreate === 'GoodsReceipt' || newOrderModel.OriginDocumentCreate === "PurchaseRequest");
    }

    //HEADER DOCUMENTO GENERAL
    renderDocumentHeader = () => {
        const { newOrderModel, view, action } = this.props;
        const { editMode, handedCasco, reasonsListCreditDebit } = this.state;
        const nivelesReq = [
            { value: '0', label: 'Normal' },
            { value: '1', label: 'Urgente' },
            { value: '2', label: 'Muy urgente' }
        ];
        let { permissions } = newOrderModel;

        let clientCardCode = 'Cliente';
        let dateText = ' F. Entrega';

        if (newOrderModel.OriginDocumentCreate === 'invoice' || newOrderModel.OriginDocumentCreate === 'purchaseInvoice' || newOrderModel.OriginDocumentCreate === 'purchaseCreditNotes' || newOrderModel.OriginDocumentCreate === 'invoiceReserve' || newOrderModel.OriginDocumentCreate === 'purchaseDownPayments') {
            dateText = 'F. Vencimiento'
        }

        if (newOrderModel.OriginDocumentCreate === 'PurchaseOrder' || newOrderModel.OriginDocumentCreate === 'purchaseReturn'
            || newOrderModel.OriginDocumentCreate === 'transfersEntry' || newOrderModel.OriginDocumentCreate === 'transfersOutput'
            || newOrderModel.OriginDocumentCreate === 'GoodsReceipt' || newOrderModel.OriginDocumentCreate === 'purchaseInvoice'
            || newOrderModel.OriginDocumentCreate === 'purchaseCreditNotes' || newOrderModel.OriginDocumentCreate === 'purchaseDownPayments' || newOrderModel.OriginDocumentCreate === 'PurchaseQuotation'
            || newOrderModel.OriginDocumentCreate === 'PurchaseQuotationDraft'
        ) {
            clientCardCode = 'Proveedor'
        }
        if (view == 'draft') {
            clientCardCode = getClientCodeText({ newOrderModel })
        }

        const scopCodeIn = ["orderSales", "PurchaseOrder", "deliveries", "invoice", "GoodsReceipt"];

        const isORDR = newOrderModel?.newView === 'orderSales' || (view === 'orderSales' && !newOrderModel?.newView);

        return (
            <div className="row">
                <div className="col-12 col-md-6">

                    {/*No del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">{clientCardCode}</span>
                        </div>
                        <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                            style={{ backgroundColor: newOrderModel.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                            disabled={action === 2 && !editMode ? true : false}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    this.openPartner();
                                }
                            }}
                            onChange={this.changeCardCode}
                            value={newOrderModel.CardCode ? newOrderModel.CardCode : ''} />
                        {action === 1 && (
                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={this.openPartner}>
                                <i className="fas fa-user fa-lg" />
                            </button>
                        )}
                        {((newOrderModel.CardName !== '' && newOrderModel.partnerSelected) || (action === 2)) && (
                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={() => this.openAccountBalance()}>
                                <i className="fas fa-info-circle"></i>
                            </button>)}
                    </div>
                    {/*Nombre del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.CardName ? newOrderModel.CardName : ''}
                        />
                    </div>
                    {/*Persona de Contacto*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Contacto</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.CntctName ? newOrderModel.CntctName : ''}
                        />
                        {(action === 1 || (action === 2 && editMode)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPersonContact}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Número de referencia:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">No. Referencia</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtCustomerRefNo"
                            disabled={action === 2 && !editMode ? true : false}
                            value={newOrderModel.NumAtCard ? newOrderModel.NumAtCard : ''}
                            onChange={this.changeNoReferencia}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                    {/*Moneda */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Moneda</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={newOrderModel.DocCur ? newOrderModel.DocCur : ''}
                        />
                        {(action === 1 || (action === 2 && editMode && permissions.editItems)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openCurrency}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                        {/*<button type="button" style={{backgroundColor: "transparent", color: "#EABF28"}} className="btn"
                                onClick={this.openMonedaLocal}>
                            <i className="fa fa-list" aria-hidden="true"></i>
                        </button>*/}
                    </div>
                    {/*Moneda */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cambio</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={newOrderModel.ChangeRate ? newOrderModel.ChangeRate : 1}
                        />
                    </div>
                    {/* Grupo de cliente */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Grupo SN</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtGroupName"
                            disabled={true}
                            value={newOrderModel.GroupCodeName ? newOrderModel.GroupCodeName : ''}
                        />
                    </div>
                    {isORDR && newOrderModel?.DocType === 'I' && action === 1 &&
                        < div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Transporte</span>
                            </div>
                            <input type=" text" className="form-control"
                                readOnly
                                value={newOrderModel.CodigoUnidad || ""}
                            />
                            {newOrderModel.CodigoUnidad &&
                                <button
                                    disabled={((action === 2 && !editMode) || (action === 1 && (!newOrderModel.CodigoUnidad))) ? true : false}
                                    type="button"
                                    style={{
                                        backgroundColor: 'transparent',
                                        padding: 5,
                                        color: '#c42222',
                                        paddingTop: 2,
                                        paddingBottom: 2,
                                    }}
                                    className="input-group-text"
                                    onClick={() => newOrderModel.CodigoUnidad && this.removeORDRTranport()}>
                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                </button>
                            }
                            <button type="button"
                                disabled={((action === 2 && !editMode) || (action === 1 && (!newOrderModel?.CardCode || !newOrderModel?.CardName || !newOrderModel?.ShipToCode))) ? true : false}
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={() => newOrderModel?.CardCode && newOrderModel?.CardName && newOrderModel?.ShipToCode && this.getORDRTransports()}>
                                <i className="fa fa-search" />
                            </button>
                        </div>
                    }
                    {newOrderModel?.isPurchaseDocument &&
                        <>
                            {/* Nivel de requerimiento */}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold">
                                        <span className="d-none d-xl-inline">Nivel de requerimiento</span>
                                        <span className="d-inline d-xl-none">Niv. req.</span>
                                    </span>
                                </div>
                                <Select
                                    options={nivelesReq}
                                    value={nivelesReq.find(option => String(option.value) === String(newOrderModel?.U_RS_NivelReq ?? '0')) || null}
                                    onChange={(selectedOption) => this.changeHeaderField('U_RS_NivelReq', selectedOption?.value ?? '0')}
                                    isSearchable={true}
                                    isClearable={false}
                                    placeholder="Seleccionar"
                                    isDisabled={Number(action) === 2 && !editMode}
                                    styles={selectStyles}
                                />
                            </div>
                        </>
                    }
                    {/*Almacén
                    <div className="form-group row " id="div1">
                        <label htmlFor="txtAlmacen"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">Almacén:</label>
                        <div className="col-md-6 col-sm-12">
                            <input type="text" className="form-control" id="txtAlmacen" disabled="true" value={newOrderModel.WhsName ? newOrderModel.WhsName : ""}
                                />
                        </div>
                        <button type="button" style={{backgroundColor: "transparent", color: "#EABF28"}} className="btn"
                                onClick={this.openAlmacen}>
                            <i className="fa fa-list" aria-hidden="true"></i>
                        </button>
                    </div>

                    <div className="form-group row " id="div1">
                        <label htmlFor="txtRegion"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">Región:</label>
                        <div className="col-md-6 col-sm-12">
                            <input type="text" className=" form-control" id="txtRegion" disabled="true"/>
                        </div>
                        <button type="button" style={{backgroundColor: "transparent", color: "#EABF28"}} className="btn"
                                onClick={this.openRegion}>
                            <i className="fa fa-list" aria-hidden="true"></i>
                        </button>
                    </div>*/}
                    {(action === 2 && (view === 'deliveries' || view === 'orderSales')) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de Cliente</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtClientType"
                                disabled={true}
                                value={newOrderModel.CardType ? newOrderModel.CardType : ''}
                            />
                        </div>
                    }

                    {(action === 1 || editMode) && (this.validateInventoryCheck()) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <div className="input-group-text font-weight-bold">
                                    <input
                                        type="checkbox"
                                        id="inInvCheck"
                                        checked={newOrderModel.searchInvItems || false}
                                        onChange={() => this.changeHeaderField("searchInvItems", !newOrderModel.searchInvItems)} />
                                </div>
                            </div>
                            <label className="form-control" htmlFor="inInvCheck">
                                <span className="d-none d-xxl-inline"> Buscar artículos inventariables</span>
                                <span className="d-inline d-xxl-none"> Buscar.Art.Inv</span>
                            </label>
                        </div>
                    }
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            {/*No Serie*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                                </div>
                                <input
                                    type=" text"
                                    className=" form-control"
                                    id="txtDocumentDate"
                                    disabled="true"
                                    value={newOrderModel.SerieName ? newOrderModel.SerieName : ''} />
                                {action === 1 && (
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={this.openSeries}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            {/*N°:*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                                </div>
                                <input
                                    type=" text"
                                    className=" form-control"
                                    id="txtNo"
                                    disabled="true"
                                    value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''} />
                            </div>
                        </div>
                    </div>
                    {/*Estado*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtStatus"
                            disabled="true"
                            value={newOrderModel.StatusDocument ? newOrderModel.StatusDocument : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="lblJournalRemark">
                                <span className="d-none d-xl-inline">Fecha de contabilización</span>
                                <span className="d-inline d-xl-none">F. Conta</span>
                            </span>
                        </div>
                        <input
                            id="txtPostingDate"
                            className="form-control"
                            type="date"
                            disabled={action === 2 ? true : false}
                            value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                            onChange={this.selectDocDate}
                            onBlur={this.onBlurDate}
                        />
                    </div>
                    {/*Fecha de entrega:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">{dateText}</span>
                        </div>
                        <input
                            id="txtDeliverDate"
                            className="form-control"
                            type="date"
                            disabled={disableDocDueDate(view) || action === 2 && !editMode ? true : false}
                            value={newOrderModel.DocDueDate ? newOrderModel.DocDueDate : ''}
                            onChange={this.selectDocDueDate}
                            onBlur={this.onBlurDate}
                        />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            className="form-control"
                            id="txtStatus"
                            disabled="true"
                            value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''} />
                    </div>
                    {((view === 'deliveries' || view === 'orderSales') && (!newOrderModel?.OriginDocumentCreate || newOrderModel?.OriginDocumentCreate === 'orderSales' || newOrderModel?.OriginDocumentCreate === 'deliveries')) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">F. Vencimiento</span>
                            </div>
                            <input
                                type="date"
                                className="form-control"
                                id="txtDueDate"
                                disabled={action === 2 && !editMode}
                                value={newOrderModel.U_FMB_END_DATE ? newOrderModel.U_FMB_END_DATE : ''}
                                onChange={this.selectDueDate} />
                        </div>}
                    {/* El PERRO SNOOP SCOP 🐕 */}
                    {scopCodeIn.includes(newOrderModel.newView && newOrderModel.newView !== '' ? newOrderModel.newView : view) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">Código SCOP</span>
                            </div>
                            <input
                                type="text"
                                maxLength="11"
                                className="form-control"
                                id="txtScop"
                                disabled={action === 2 && !editMode}
                                value={newOrderModel?.U_FMB_SCOP_CODE ?? ""}
                                onChange={this.changeScopCode}
                                onKeyPress={(eve) => {
                                    if (eve.key === 'Enter') {
                                        this.props.scoopTools.checkScoop()
                                    }
                                }}
                            />
                            {(action === 1 || (action === 2 && editMode)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.props.scoopTools.checkScoop}>
                                    <i className="fa fa-cloud" aria-hidden="true" />
                                </button>
                            )}
                        </div>
                    )}
                    {/*F. Necesaria*/}
                    {(newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft'
                        || view === 'PurchaseQuotation' || view === 'PurchaseQuotationDraft' || Number(newOrderModel?.ObjType) === 540000006) &&
                        <>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">F. Necesaria</span>
                                </div>
                                <input
                                    id="txtPostingDate"
                                    style={{
                                        width: '100%',
                                        important: true,
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                    }}
                                    className="form-control  btn-outline-secondary"
                                    type={action == 2 ? 'date' : 'date'}
                                    disabled={action == 2 && !editMode ? true : false}
                                    placeholder="Fecha min"
                                    autoComplete="off"
                                    value={newOrderModel.ReqDate ? newOrderModel.ReqDate : ''}
                                    onChange={this.selectReqDate}
                                />
                            </div>
                        </>
                    }
                    {newOrderModel?.isPurchaseDocument &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Proyecto</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtProject"
                                disabled={true}
                                value={newOrderModel?.Project || ''}
                            />
                            {(action === 1 || (action === 2 && editMode)) &&
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={() => this.openProjects(null)}
                                >
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            }
                        </div>
                    }
                    {newOrderModel?.isPurchaseDocument &&
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                {/*Importacion*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Importación</span>
                                    </div>
                                    <input
                                        type="checkbox"
                                        id="txtImportacion"
                                        disabled={Number(action) === 2 && !editMode}
                                        onChange={() => this.changeHeaderField('U_RS_IMP', !newOrderModel?.U_RS_IMP)}
                                        style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                        checked={newOrderModel?.U_RS_IMP}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                {/*N° Carpeta IMP.*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">N° Carpeta IMP.</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="txtNoCarpetaIMP"
                                        disabled={Number(action) === 2 && !editMode}
                                        onChange={(event) => this.changeHeaderField('U_RS_NUMIMP', event.nativeEvent.target.value, 15)}
                                        maxLength={15}
                                        value={newOrderModel?.U_RS_NUMIMP || ''} />
                                </div>
                            </div>
                        </div>
                    }
                    {(action === 2 && view === 'orderSales') && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Creado por</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtCreatedBy"
                                disabled={true}
                                value={newOrderModel.U_NAME || newOrderModel.U_FMB_User || ''}
                            />
                        </div>
                    )}
                    {(view === 'orderSales') && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">H. Creación</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={true}
                                value={newOrderModel.U_FMB_OrderTime ? `${String(newOrderModel.U_FMB_OrderTime).padStart(4, '0').slice(0, 2)}:${String(newOrderModel.U_FMB_OrderTime).padStart(4, '0').slice(2, 4)}` : ''}
                            />
                        </div>
                    )}

                    {(view === 'creditNote' || newOrderModel.OriginDocumentCreate === 'creditNote') && newOrderModel.OriginDocumentCreate !== 'debitNote' && (
                        <>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <div className="input-group-text d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            id="todosCheck"
                                            checked={newOrderModel.U_RS_SOLAPR === 'Y'}
                                            onChange={() => this.changeHeaderField("U_RS_SOLAPR", newOrderModel.U_RS_SOLAPR === 'Y' ? 'N' : 'Y')}
                                            style={{
                                                transform: 'scale(1.4)',
                                                marginRight: '8px',
                                                cursor: 'pointer'
                                            }}
                                        />
                                        <strong>Solicitar aprobación</strong>
                                    </div>
                                </div>
                            </div>

                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold">
                                        <span className="d-none d-lg-inline">Motivo de Nota de Crédito</span>
                                        <span className="d-inline d-lg-none">Motivo N.Crédito</span>
                                    </span>
                                </div>
                                <Select
                                    options={(reasonsListCreditDebit || [])
                                        .filter(option => {
                                            const tipo = option.Tipo ?? option.tipo ?? option.TIPO ?? option.type ?? "";
                                            return String(tipo).trim() === '07';
                                        })
                                        .map(option => ({
                                            value: option.Code,
                                            label: `${option.Code} - ${option.Name}`
                                        }))}
                                    value={(reasonsListCreditDebit || [])
                                        .filter(option => {
                                            const tipo = option.Tipo ?? option.tipo ?? option.TIPO ?? option.type ?? "";
                                            return String(tipo).trim() === '07';
                                        })
                                        .map(option => ({
                                            value: option.Code,
                                            label: `${option.Code} - ${option.Name}`
                                        }))
                                        .find(option => String(option.value) === String(newOrderModel.U_STR_MtvoCD || '')) || null}
                                    onChange={(selectedOption) =>
                                        this.changeHeaderField('U_STR_MtvoCD', selectedOption?.value ?? '')
                                    }
                                    placeholder="Seleccionar"
                                    isSearchable={true}
                                    isClearable={true}
                                    noOptionsMessage={() => "No se encontraron coincidencias"}
                                    isDisabled={action === 2 && !editMode}
                                    styles={selectStyles}
                                />
                            </div>
                        </>
                    )}

                    {(view === 'debitNote' || newOrderModel.OriginDocumentCreate === 'debitNote') && newOrderModel.OriginDocumentCreate !== 'creditNote' && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-lg-inline">Motivo de Nota de Débito</span>
                                    <span className="d-inline d-lg-none">Motivo N.Débito</span>
                                </span>
                            </div>
                            <Select
                                options={(reasonsListCreditDebit || [])
                                    .filter(option => {
                                        const tipo = option.Tipo ?? option.tipo ?? option.TIPO ?? option.type ?? "";
                                        return String(tipo).trim() === '08';
                                    })
                                    .map(option => ({
                                        value: option.Code,
                                        label: `${option.Code} - ${option.Name}`
                                    }))}
                                value={(reasonsListCreditDebit || [])
                                    .filter(option => {
                                        const tipo = option.Tipo ?? option.tipo ?? option.TIPO ?? option.type ?? "";
                                        return String(tipo).trim() === '08';
                                    })
                                    .map(option => ({
                                        value: option.Code,
                                        label: `${option.Code} - ${option.Name}`
                                    }))
                                    .find(option => String(option.value) === String(newOrderModel.U_STR_MtvoCD || '')) || null}
                                onChange={(selectedOption) =>
                                    this.changeHeaderField('U_STR_MtvoCD', selectedOption?.value ?? '')
                                }
                                placeholder="Seleccionar"
                                isSearchable={true}
                                isClearable={true}
                                noOptionsMessage={() => "No se encontraron coincidencias"}
                                isDisabled={action === 2 && !editMode}
                                styles={selectStyles}
                            />
                        </div>
                    )}

                    {newOrderModel?.isPurchaseDocument &&
                        (<div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Solicitar aprobacion</span>
                            </div>
                            <input
                                type="checkbox"
                                id="txtImportacion"
                                disabled={Number(action) === 2 && !editMode}
                                onChange={() => this.changeHeaderField('U_RS_SOLAPR', !newOrderModel?.U_RS_SOLAPR)}
                                style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                checked={newOrderModel?.U_RS_SOLAPR}
                            />
                        </div>)
                    }
                </div>
            </div>
        );
    };

    //BODY DE CREACIÓN GENERAL
    renderDocumentBody = (item) => {
        const { newOrderModel, action, view, ShowBatchDefinitionModal } = this.props;
        const { editMode, _user, operationList, igvOperationList, docCurrencies = [] } = this.state;
        let service = newOrderModel.DocType || 'I';
        let uuids = newOrderModel.U_FMB_UUID_RELACIONADO ? newOrderModel.U_FMB_UUID_RELACIONADO : [];
        let relacionSAT = newOrderModel.U_FMB_TIPO_RELACION ? newOrderModel.U_FMB_TIPO_RELACION : [];
        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];
        let newOrderModelService = newOrderModel.service ? newOrderModel.service : [];
        let newView = newOrderModel.newView || view;
        let { permissions } = newOrderModel;
        const { isSelectTo } = newOrderModel;
        let itemsBatch = newOrderModelItems.filter((item) => item.ManBtchNum === 'Y');
        let isPurchaseQuotation = newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft';
        let isPurchaseOrder = newOrderModel?.newView === 'PurchaseOrder';
        let noPurchaseQuotationExists = !isPurchaseQuotation || !newOrderModel.newView;
        const isCopy = newOrderModel.isSelectToActive || newOrderModel.isSelectOfActive; // Se copia el documento
        const isCopyToOPOR = isCopy && newOrderModel?.newView === 'PurchaseOrder';
        return (
            <div style={{ marginBottom: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + (view !== 'PurchaseRequest' && !this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                        {(view !== 'PurchaseRequest' || (isPurchaseQuotation || isPurchaseOrder)) && <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-Finanzas"
                            data-toggle="tab"
                            href="#dataFinanzas"
                            role="tab"
                            aria-controls="dataFinanzas"
                            aria-selected="false">
                            Finanzas
                        </a>}
                        {(view !== 'PurchaseRequest' || (isPurchaseQuotation || isPurchaseOrder)) && <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-logistica"
                            data-toggle="tab"
                            href="#dataLogistica"
                            role="tab"
                            aria-controls="dataLogistica"
                            aria-selected="false">
                            Logística
                        </a>}
                        {(view === 'invoice' || newOrderModel.OriginDocumentCreate === 'invoice' || (view === 'invoiceAuthorization' && Number(newOrderModel.ObjType) === 13) || (view === 'invoiceBorrador' && Number(newOrderModel.ObjType) === 13)) && Modules.ComercioExterior && <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-Complemento"
                            data-toggle="tab"
                            href="#dataComplemento"
                            role="tab"
                            aria-controls="dataComplemento"
                            aria-selected="false">
                            Complemento
                        </a>}
                        {(view === 'debitNote' || view === 'invoiceReserve' || view === 'invoice' || view === 'invoiceAdvance' || view === 'creditNote' || view === 'payment') && <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-timbra"
                            data-toggle="tab"
                            href="#dataTimbra"
                            role="tab"
                            aria-controls="dataTimbra"
                            aria-selected="false">
                            Timbra-One
                        </a>}
                        {(view === 'citibanamex' && newOrderModel.U_FMB_Bank_Status === 'C') &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                id="nav-profile-tab-concilia"
                                data-toggle="tab"
                                href="#dataConcilia"
                                role="tab"
                                aria-controls="dataConcilia"
                                aria-selected="false">
                                Concilia-One
                            </a>
                        }
                        {(view === 'invoice' || view === 'invoiceReserve' || view === 'invoiceAdvance' || view === 'creditNote') &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                id="nav-profile-tab-XML"
                                data-toggle="tab"
                                href="#dataXML"
                                role="tab"
                                aria-controls="dataXML"
                                aria-selected="false"
                            >
                                Datos XML
                            </a>
                        }
                        {(Modules['oxxoReferences']) && (view === 'invoice' || view === 'invoiceReserve') && (action === 2 && !editMode) &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                onClick={() => this.PrepareOxxoComp()}
                                data-toggle="tab"
                                href="#infoRefOxxo"
                                role="tab"
                                aria-controls="nav-home-tab-infoRefOxxo"
                                aria-selected="false"
                            >
                                Referencia Oxxo
                            </a>
                        }
                        {(view === 'creditNote' || view === 'debitNote' || newOrderModel?.newView === 'creditNote' || newOrderModel?.newView === 'debitNote') &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                id="nav-profile-tab-Facturacion"
                                data-toggle="tab"
                                href="#dataFacturacion"
                                role="tab"
                                aria-controls="dataFacturacion"
                                aria-selected="false"
                            >
                                Facturación
                            </a >
                        }
                        {Modules['attachments'] && (view === 'invoiceAuthorization' || newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument || Number(newOrderModel?.ObjType) === 540000006) &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary " + (view !== 'PurchaseRequest' && view !== 'invoiceAuthorization' && !this.validatePartner() ? 'disabled' : '')}
                                id="nav-profile-tab-Attach"
                                data-toggle="tab"
                                href="#dataAttach"
                                role="tab"
                                aria-controls="dataAttach"
                                aria-selected="false">
                                Anexos
                            </a>
                        }
                    </div>
                </nav>
                <div className="tab-content">
                    {/* CONTENIDO */}
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}>

                        {service === 'I' &&
                            (<table
                                id="dataTableDocuments"
                                className="display"
                                style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                                <thead className="table-header-yellow">
                                    <FactoryTable
                                        view={view}
                                        type='HEAD'
                                        newOrderModel={newOrderModel}
                                        action={action}
                                        ShowBatchDefinitionModal={ShowBatchDefinitionModal}
                                    />
                                </thead>

                                <tbody>
                                    <FactoryTable
                                        view={view}
                                        type='BODY'
                                        newOrderModel={newOrderModel}
                                        action={action}
                                        ShowBatchDefinitionModal={ShowBatchDefinitionModal}
                                        editMode={editMode}
                                        _user={_user}
                                        changeQuantityItem={this.changeQuantityItem}
                                        openAlmacen={this.openAlmacen}
                                        changeAlmacen={this.changeAlmacen}
                                        openPartner={this.openPartner}
                                        ChangeLineVendor={this.ChangeLineVendor}
                                        specialPrice={this.specialPrice}
                                        changePriceInvntItem={this.changePriceInvntItem}
                                        changeSearchItem={this.changeSearchItem}
                                        openItems={this.openItems}
                                        returnValueItem={this.returnValueItem}
                                        changePriceItem={this.changePriceItem}
                                        validatePriceNull={this.validatePriceNull}
                                        validateCasco={this.validateCasco}
                                        changeDiscountItem={this.changeDiscountItem}
                                        validateDiscountNull={this.validateDiscountNull}
                                        openTaxes={this.openTaxes}
                                        openCentroCoste={this.openCentroCoste}
                                        openProjects={this.openProjects}
                                        changeKilosXComprar={this.changeKilosXComprar}
                                        validateKilosXComprar={this.validateKilosXComprar}
                                        changePesosXPieza={this.changePesosXPieza}
                                        validatePesosXPieza={this.validatePesosXPieza}
                                        changePrecioXKilo={this.changePrecioXKilo}
                                        validatePrecioXKilo={this.validatePrecioXKilo}
                                        changeUserFieldsItemsDocument={this.changeUserFieldsItemsDocument}
                                        deleteItem={this.deleteItem}
                                        refreshTotal={this.refreshTotal}
                                        operationList={operationList}
                                        igvOperationList={igvOperationList}
                                        changeOperation={this.changeOperation}
                                        changeIgvOperation={this.changeIgvOperation}
                                        changeUserFieldsDocumentItemUnitMed={this.changeUserFieldsDocumentItemUnitMed}
                                        OpenUomCode={this.OpenUomCode}
                                        ChangeSalUnitMsr={this.ChangeSalUnitMsr}
                                        changeUserUM={this.changeUserUM}
                                        changeGalonesCant={this.changeGalonesCant}
                                        changeDensidad={this.changeDensidad}
                                        changeQuantityBlur={this.changeQuantityBlur}
                                        changeLineField={this.changeLineField}
                                        changeTaxStatus={this.changeTaxStatus}
                                        showLocationAssignment={this.showLocationAssignment}
                                        showDocumentStock={this.showDocumentStock}
                                        docCurrencies={docCurrencies}
                                        changeCurrItem={this.changeCurrItem}
                                        onBlurWhs={this.onBlurWhs}
                                        clickPriceCalculate={this.clickPriceCalculate}
                                        isCopyToOPOR={isCopyToOPOR}
                                    />
                                </tbody>
                            </table>)}
                        {service === 'S' && (<table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td className=" sticky-column sticky-header" style={{ maxWidth: 300, backgroundColor: '#d2ab24' }}>
                                        Descripción
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Cuenta Mayor
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Nombre de la Cuenta Mayor
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Indicador I.
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Total
                                    </td>
                                    {(view === 'purchaseInvoice') && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Proyecto
                                    </td>}
                                    {/* <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 1
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 2
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 3
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 4
                                    </td> */}
                                    <td
                                        className="sticky-header sticky-columns"
                                        style={{ backgroundColor: '#d2ab24' }}
                                    />
                                </tr>
                            </thead>
                            <tbody>
                                {newOrderModelService.map((item, index) => {
                                    return (
                                        <tr style={{
                                            maxHeight: 10,
                                            paddingTop: 8,
                                            paddingBottom: 8
                                        }}>
                                            {/*Descripción de servicio*/}
                                            <td className="sticky-column" style={{ width: 500 }}>
                                                {(action == 1) && (
                                                    <input
                                                        type=" text"
                                                        disabled={item.ServiceNew ? false : true}
                                                        className="form-control btn-outline-secondary"
                                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', height: 'auto' }}
                                                        onChange={event => this.changeDescription(event, index)}
                                                        value={item.Description}
                                                    />
                                                )}
                                                {(action == 2) && (
                                                    <p
                                                        className="descrip"
                                                        style={{ backgroundColor: 'white', borderColor: '#ced4da', color: '#000' }}
                                                    >{item.Description}
                                                    </p>
                                                )}
                                            </td>
                                            {/*Cuenta Mayor*/}
                                            <td style={{ textAlign: 'center' }}>
                                                {item.AcctCode}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems)) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="btn"
                                                        onClick={() => this.openCuentaMayor(index, 7)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            {/*NombreCuenta Mayor*/}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {item.AcctCodeName}
                                            </td>
                                            {/*Impuesto*/}
                                            <td>
                                                {item?.TaxName?.replace('Percepción', '') || item.TaxCode}
                                                {(action === 1 || (action === 2 && editMode && permissions.editItems)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openTaxes(index)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            {/*Total*/}
                                            <td style={{ textAlign: 'right' }}>
                                                <input
                                                    type="number"
                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                    disabled={(action == 2 && !editMode) ? true : !permissions.editItems}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        width: 130,
                                                        textAlign: 'center',
                                                    }}

                                                    value={Number.parseFloat(item.Price).toFixed(2)}
                                                    onChange={event => this.changePriceService(event, index)}

                                                />
                                            </td>
                                            {(view === 'purchaseInvoice') && <td>
                                                {/*No de Proyecto*/}
                                                {item.Project}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openProjects(index)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>}
                                            {/*Centros de costos*/}
                                            {/* <td>
                                                {item.OcrCode}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 1)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode2}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode3}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 3)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode4}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 4)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td> */}




                                            {noPurchaseQuotationExists &&
                                                <td
                                                    className="sticky-columns"
                                                    style={{
                                                        backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF',
                                                        textAlign: 'center'
                                                    }}>
                                                    {/*Eliminar*/}
                                                    {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                padding: 5,
                                                                color: '#c42222',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                            }}
                                                            className="btn"
                                                            onClick={() => this.deleteService(index)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    )}
                                                </td>
                                            }

                                        </tr>
                                    );
                                })}
                                {noPurchaseQuotationExists &&
                                    <tr>
                                        <td className="sticky-column"
                                            style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                            {(action == 1 || (action == 2 && editMode && permissions.editItems)) && (
                                                <div>
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: 'green',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"

                                                        onClick={this.addRow}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>)}
                    </div>
                    {/* FRINANZAS */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade col-12 col-md-6"
                        id="dataFinanzas"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Fianazas">
                        {(view === 'PurchaseOrder' || view === 'purchaseInvoice') && <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Entrada en el diario</span>
                                    <span className="d-inline d-xl-none">Entrada diario</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                disabled={action === 2 && !editMode ? true : false}
                                value={newOrderModel.JrnlMemo ? newOrderModel.JrnlMemo : ''}
                                maxLength={50}
                                onChange={this.changeCommentsMemo}
                            />
                        </div>}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Condición Pago</span>
                            </div>
                            <input
                                type=" text"
                                className="form-control btn-outline-secondary"
                                disabled={true}
                                style={{ widht: '50%', backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                value={newOrderModel.GroupName ? newOrderModel.GroupName : ''}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Forma Pago</span>
                            </div>
                            <input
                                type=" text"
                                className="form-control"
                                disabled={true}
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                value={newOrderModel.PymName ? newOrderModel.PymName : ''}
                            />
                        </div>
                        <div>
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Autorización</span>
                                <input
                                    type="checkbox"
                                    disabled={true}
                                    onChange={() => this.ChangeConfirmed()}
                                    style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                    checked={newOrderModel.Confirmed}
                                />
                            </div>
                        </div>
                        <div>
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Permitir entrega parcial</span>

                                <input
                                    type="checkbox"
                                    disabled={true}
                                    onChange={() => this.ChangePartSupply()}
                                    style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                    checked={newOrderModel.PartSupply}
                                />
                            </div>
                        </div>
                    </div>
                    {/* LOGISTICA */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade col-12"
                        id="dataLogistica"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Logistica">
                        <div className="row" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6 col-lg-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Destino</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="txtCustomer"
                                        disabled="true"
                                        value={newOrderModel.ShipToCode ? newOrderModel.ShipToCode : ''}
                                    />
                                    {(action == 1 || (action == 2 && editMode && permissions.editItems) || (action == 2 && editMode && view == 'draft')) && (
                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="input-group-text"
                                            onClick={() => this.openAddresses(1)}>
                                            <i className="fas fa-list" />
                                        </button>
                                    )}
                                </div>

                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtCustomer"
                                        disabled="true"
                                        value={newOrderModel.Address2 ? newOrderModel.Address2 : ''}
                                    />
                                </div>
                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6 col-lg-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Ubigeo</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtUBIGEO"
                                        disabled="true"
                                        value={newOrderModel?.UBIGEO || ''}
                                    />
                                </div><div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">ID Instalación</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtIDDire"
                                        disabled="true"
                                        value={newOrderModel?.U_RMO_ID_DIRE || ''}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* COMPLEMENTO (COMERCIO EXTERIOR - LEYENDAS FISCALES) */
                        <ComercioExterior {...this.props} editMode={editMode} />
                    }
                    {/* TIMBRA-ONE */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="dataTimbra"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-timbra">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend cfdi-res">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Tipo relación CFDI</span>
                                            <span className="d-inline d-xl-none">Tipo rel CFDI</span>
                                        </span>
                                    </div>
                                    <select
                                        className="form-control input-sm"
                                        id="txtRELACION_SAT"

                                        disabled={action === 2 && !editMode && permissions.editEmployee}
                                        value={newOrderModel.U_FMB_TIPO_REL}
                                        onChange={(event) => { this.ChangeU_FMB_TIPO_REL(event.target.value) }}>
                                        {relacionSAT.map((opcion) => {
                                            return (
                                                <option value={opcion.FldValue}>{opcion.Descr}</option>
                                            )

                                        })}
                                    </select>
                                    <div className="col-md-1" style={{ padding: 0, paddingTop: 2 }}>
                                        {(action === 1 || (action === 2 && !editMode && permissions.editEmployee)) && <button
                                            type="button"
                                            className="btn"
                                            style={{ padding: 4 }}
                                            onClick={() => this.AddUuid()} >
                                            <i className="fa fa-plus-circle" aria-hidden="true" size="10"></i>
                                        </button>}
                                    </div>
                                </div>

                                {!!uuids && uuids.map((uuid, index) => {
                                    return (
                                        <div
                                            id={`uuidRel${index}`}
                                            className="input-group mb-3" >
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold"> UUID Relacionado {index + 1}</span>
                                            </div>
                                            <input
                                                type="text"
                                                maxLength="36"
                                                style={{ textAlign: 'left' }}
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                className="form-control input-sm"
                                                value={uuid}
                                                onChange={(e) => this.HandleChange(e, index)} />
                                            <div className="col-md-1" style={{ padding: 0, paddingTop: 2 }}>
                                                {(action === 1 || (action === 2 && editMode && permissions.editEmployee)) && <button
                                                    type="button"
                                                    className="btn"
                                                    style={{ padding: 4 }}
                                                    onClick={() => this.RemoveUuid(index)} >
                                                    <i className="fa fa-minus-circle" aria-hidden="true" size="10"></i>
                                                </button>}

                                            </div>
                                        </div>
                                    )
                                })
                                }

                                {newOrderModel.U_UDF_UUID && <div >
                                    <div>
                                        <label className="btn float-left" onClick={() => this.DownloadForeignDocs('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF</label>
                                        <label className="btn float-left" onClick={() => this.DownloadForeignDocs('XML')}><i className="fa fa-file-text"></i> Descargar XML</label>
                                    </div>
                                </div>}

                                {newOrderModel.U_FMB_FOLIO_PORTE && <div >
                                    <div>
                                        <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF Carta Porte</label>
                                        <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('XML')}><i className="fa fa-file-text"></i> Descargar XML Carta Porte</label>
                                    </div>
                                </div>}

                                {newOrderModel.IsCancelCFDI === 'Y' && <div >
                                    <div>
                                        <label className="btn float-left" onClick={() => this.DownloadDocCancel('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF de solicitud de Cancelación</label>
                                        <label className="btn float-left" onClick={() => this.DownloadDocCancel('XML')}><i className="fa fa-file-text"></i> Descargar XML de solicitud de Cancelación</label>
                                    </div>
                                </div>}

                            </div>
                            <div className="col-12 col-md-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">UUID</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtUDF_UUID"
                                        disabled="true"
                                        value={newOrderModel.U_UDF_UUID || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Sello digital</span>
                                            <span className="d-inline d-xl-none">Sello dig</span>
                                        </span>
                                    </div>
                                    <textarea
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_SELLO"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_SELLO || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Folio digital</span>
                                            <span className="d-inline d-xl-none">Folio dig</span>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_FOLIO"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_FOLIO || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Serie digital</span>
                                            <span className="d-inline d-xl-none">Serie dig</span>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_SERIE"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_SERIE || ''}
                                    />
                                </div>
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">UUID Relacionado</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_UUID_ASOCIADO"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_UUID_RELACIONADO || ''}
                                    />
                                </div> */}

                            </div>
                        </div>
                    </div>
                    {/* CONCILIA-ONE */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="dataConcilia"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-timbra">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Numero de cuenta</span>
                                            <span className="d-inline d-xl-none">Numero cuenta</span>
                                        </span>
                                    </div>
                                    <label className="form-control">{newOrderModel.TransferAccount || ""}</label>
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Fecha de la transferencia</span>
                                            <span className="d-inline d-xl-none">Fecha transferencia</span>
                                        </span>
                                    </div>
                                    <label className="form-control">{newOrderModel.TransferDate || ""}</label>
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Concepto</span>
                                    </div>
                                    <label className="form-control">{newOrderModel.TransferConcept || ""}</label>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Referencia</span>
                                    </div>
                                    <label className="form-control">{newOrderModel.TransferReference || ""}</label>
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Importe</span>
                                    </div>
                                    <label className="form-control text-right">{newOrderModel.TransferTotal || "0.00"}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* DATOS XML*/}
                    <div style={{ paddingTop: 5 }} className="tab-pane fade" id="dataXML" role="tabpanel" aria-labelledby="nav-home-tab-XML">
                        <DataXML
                            newOrderModel={newOrderModel}
                            enableSpinner={this.props.enableSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </div>

                    {/* REF OXXO*/}
                    <div style={{ paddingTop: 5 }} className="tab-pane fade" id="infoRefOxxo" role="tabpanel" aria-labelledby="nav-home-tab-infoRefOxxo">
                        {this.state.enableOxxoInfo &&
                            <OxxoReferenceInfo
                                DocEntry={this.state.infoOxxo.DocEntry}
                                ObjType={this.state.infoOxxo.ObjType}
                                ObjSubType={this.state.infoOxxo.SubType}
                                Param={this.state.infoOxxo.Param}
                                IdOxxoRef={this.state.infoOxxo.IdOxxoRef}
                            />
                        }

                    </div>
                    {/* ANEXOS */}
                    <div
                        className="tab-pane fade"
                        id="dataAttach"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Attach"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}>

                        <div className='row'>
                            <div className='col-12 col-md-12' style={{ height: 450, maxHeight: 450, overflow: 'auto' }}>
                                <table className="display" style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                    <thead style={{ background: "#d4d4d5", height: "32px" }}>
                                        <tr style={{ color: '#fff' }}>
                                            <th className='sticky-header text-center' style={{ backgroundColor: '#EABF28' }}>#</th>
                                            <th className='sticky-header text-left' style={{ backgroundColor: '#EABF28' }}>Vía de acceso destino</th>
                                            <th className='sticky-header text-left' style={{ backgroundColor: '#EABF28' }}>Nombre de archivo</th>
                                            <th className='sticky-header text-left' style={{ backgroundColor: '#EABF28' }}>Fecha del anexo</th>
                                            <th className='sticky-header text-left' style={{ backgroundColor: '#EABF28' }}>Texto libre</th>
                                            <th className='sticky-header text-left' style={{ backgroundColor: '#EABF28' }}>Visualizar</th>
                                            <th className='sticky-header text-left' style={{ backgroundColor: '#EABF28' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!!newOrderModel.Attachment && newOrderModel.Attachment?.map((attach, originalIndex) => ({ attach, originalIndex }))?.filter(({ attach }) => {
                                            const isPurchaseFile =
                                                attach.FileName?.startsWith("solicitud_compra_") ||  // NOTA: Si se mueve este nombre "solicitud_compra_" moverlo igual en el PORTAL DE PROVEEDORES
                                                attach.FileName?.startsWith("tabla_solicitud_compra_"); // NOTA: Si se mueve este nombre "tabla_solicitud_compra_" moverlo igual en el PORTAL DE PROVEEDORES

                                            // Desde BRANCH no se pueden ver estos documentos solo desde el portal 
                                            if (isPurchaseFile) {
                                                const isOPOR = (view === 'PurchaseOrder' && !newOrderModel?.newView) || newOrderModel?.newView === 'PurchaseOrder';
                                                const isOPDN = (view === 'GoodsReceipt' && !newOrderModel?.newView) || newOrderModel?.newView === 'GoodsReceipt';
                                                const isOPCH = (view === 'PurchaseInvoice' && !newOrderModel?.newView) || newOrderModel?.newView === 'PurchaseInvoice';
                                                if (isOPOR || isOPDN || isOPCH) { // Vistas Branch desde la cual si se pueden ver los documentos de isPurchaseFile
                                                    return true;
                                                } else {
                                                    return false;
                                                }
                                            }

                                            // El resto de archivos los pueden ver todos
                                            return true;
                                        })?.map(({ attach, originalIndex }, index) => {
                                            let FileExt = attach.FileExt ? "." + attach.FileExt : '';
                                            return (<tr key={originalIndex}>
                                                <th scope="col-lg-auto row">{index + 1}</th>
                                                <th scope="col-lg-auto row">{attach.FileName ? attach.FileName : 'Sin nombre'}</th>
                                                <td >{attach.FileName ? attach.FileName : ''}</td>
                                                <td >{moment(attach.Date).utc().format('DD/MM/YYYY')}</td>
                                                <td >
                                                    <input type=" text" className="form-control"
                                                        style={{
                                                            borderColor: '#ced4da',
                                                            color: '#000'
                                                        }}
                                                        value={attach.FreeText ? attach.FreeText : ""}
                                                        disabled={!attach.New ? true : false}
                                                        onChange={(event) => attach.New && this.Change_FreeText(event, originalIndex)}
                                                        id={`free-text-${originalIndex}`}
                                                    />
                                                </td>
                                                <td>
                                                    {attach.AbsEntry && !attach.New && <a href={BASE_URL + SERVICE_API.getAttachment + "/" + encodeURIComponent(attach.FileName + FileExt)} target="_blank" rel="noopener noreferrer">Visualizar</a>}
                                                </td>
                                                <td
                                                    className="sticky-columns"
                                                    style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                    {/*Eliminar*/}
                                                    {(action === 1 || (action === 2 && editMode)) && (
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                padding: 5,
                                                                color: '#c42222',
                                                            }}
                                                            className="btn"
                                                            onClick={() => this.DeleteAttachment(originalIndex)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <div className='col-12 col-md-2'>
                            </div>
                            {(Number(action) === 1 || (Number(action) === 2 && editMode)) &&
                                <div className='col-12 col-md-10'>
                                    <div className="row">
                                        <div className="col-12 col-sm mb-2 mb-sm-0">
                                            <input
                                                type="file"
                                                name="file"
                                                id="fileImput2"
                                                onChange={(event) => this.ChangeStateAreYouAgreeAttachments(event.target.files)}
                                                // accept="application/pdf"
                                                multiple="multiple"
                                                placeholder="Explorar"
                                                disabled={Number(action) === 2 && !editMode ? true : false}
                                                className="form-control-file anexos">
                                            </input>
                                        </div>
                                        <div className="col-12 col-sm">
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                disabled={Number(action) === 2 && !editMode ? true : false}
                                                onClick={() => this.UploadFile()}>
                                                Subir archivo
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {(view === 'creditNote' || view === 'debitNote' || newOrderModel?.newView === 'creditNote' || newOrderModel?.newView === 'debitNote') &&
                        <div
                            className="tab-pane fade mt-3"
                            id="dataFacturacion"
                            role="tabpanel"
                            aria-labelledby="nav-profile-tab-Facturacion">
                            <div className="row" style={{ paddingRight: 0 }}>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">SUNAT: Tipo SAP de Documento Origen</span>
                                        </div>
                                        <select
                                            className="form-control"
                                            disabled={action === 2 && !editMode}
                                            value={newOrderModel.U_RML_TDOCORG || ''}
                                            onChange={(event) => this.changeHeaderField('U_RML_TDOCORG', event.nativeEvent.target.value)}>
                                            <option value=""></option>
                                            <option value="13">13 - Factura de Clientes</option>
                                            <option value="203">203 - Factura de Anticipo de clientes</option>
                                            <option value="18">18 - Factura de Proveedor</option>
                                            <option value="204">204 - Factura de Anticipo de proveedor</option>
                                        </select>
                                    </div>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">SUNAT: Id. Documento Origen</span>
                                        <input
                                            type="text"
                                            disabled={action === 2 && !editMode}
                                            className="form-control btn-outline-secondary"
                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                            value={newOrderModel.U_RML_DOCORG || ''}
                                            onChange={(event) => this.changeHeaderField('U_RML_DOCORG', event.nativeEvent.target.value, null, true)}
                                        />
                                        {(Number(action) === 1 || (Number(action) === 2 && editMode)) && <>
                                            {newOrderModel.U_RML_DOCORG &&
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        padding: 5,
                                                        color: '#c42222',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="input-group-text"
                                                    onClick={(e) => this.changeHeaderField('U_RML_DOCORG', '')} >
                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                </button>
                                            }
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                disabled={(Number(action) === 2 && !editMode) || !newOrderModel?.U_RML_TDOCORG}
                                                onClick={(e) => newOrderModel?.U_RML_TDOCORG &&
                                                    this.openFormattedQueries(
                                                        {
                                                            Field: 'U_RML_DOCORG'
                                                            , Name: 'SUNAT: Id. Documento Origen'
                                                            , Type: 'table'
                                                            , needFormattedQuery: true
                                                            , param1: newOrderModel?.CardCode || ''
                                                            , param2: newOrderModel?.U_RML_TDOCORG || ''
                                                        })}
                                            >
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </>
                                        }
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de documento de origen</span>
                                        </div>
                                        <input
                                            type="text"
                                            disabled={action === 2 && !editMode}
                                            maxLength={2}
                                            className="form-control"
                                            value={newOrderModel.U_BPP_MDTO || ''}
                                            onChange={(event) => this.changeHeaderField('U_BPP_MDTO', event.nativeEvent.target.value, 2, true)}
                                        />
                                    </div>
                                </div>

                                {/*Segunda columna*/}
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie del documento origen</span>
                                        </div>
                                        <input
                                            type="text"
                                            disabled={action === 2 && !editMode}
                                            maxLength={8}
                                            className="form-control"
                                            value={newOrderModel.U_BPP_MDSO || ''}
                                            onChange={(event) => this.changeHeaderField('U_BPP_MDSO', event.nativeEvent.target.value)}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Correlativo doc.origen</span>
                                        </div>
                                        <input
                                            type="text"
                                            disabled={action === 2 && !editMode}
                                            maxLength={15}
                                            className="form-control"
                                            value={newOrderModel.U_BPP_MDCO || ''}
                                            onChange={(event) => this.changeHeaderField('U_BPP_MDCO', event.nativeEvent.target.value, 15, true)}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">FechaCreacion Documento Origen</span>
                                        </div>
                                        <input
                                            type="date"
                                            disabled={action === 2 && !editMode}
                                            className="form-control"
                                            value={newOrderModel.U_BPP_SDocDate || ''}
                                            onChange={(event) => this.changeHeaderField('U_BPP_SDocDate', event.nativeEvent.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    };
    //FOOTER DE CREACIÓN GENERAL
    renderDocumentFooter = () => {
        const { view, newOrderModel, action } = this.props;
        const { editMode } = this.state;
        let { permissions } = newOrderModel;
        let isPurchaseQuotation = newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft';

        return (
            <div className="row">
                <div className="col-12 col-md-6 mb-3">
                    {/*Empleado de ventas:*/}
                    {(view !== 'PurchaseRequest' || isPurchaseQuotation || (view === 'PurchaseRequest' && newOrderModel?.newView)) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">
                                        {newOrderModel?.isPurchaseDocument ? 'Empleado compras' : 'Empleado ventas'}
                                    </span>
                                    <span className="d-inline d-xl-none">
                                        {newOrderModel?.isPurchaseDocument ? 'Empl compras' : 'Empl ventas'}
                                    </span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtSlpName"
                                disabled="true"
                                value={newOrderModel.SlpName ? newOrderModel.SlpName : ''}
                            />
                            {(action === 1 || (action === 2 && editMode && permissions.editEmployee)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openEmployee}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>}
                    {/*Nombre del Propietario*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Propietario</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtDocumentsOwnerName"
                            disabled="true"
                            value={newOrderModel.OwnerName ? newOrderModel.OwnerName : ''}
                        />
                        {/* {false && (action === 1 || (action === 2 && editMode && permissions.editOwner)) && ( */}
                        {(Number(action) === 1 || (Number(action) === 2 && editMode)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPropietario}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={action === 2 && !editMode ? true : false}
                            value={newOrderModel.Comments ? newOrderModel.Comments : ''}
                            onChange={this.changeComments}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                    {/*Nombre del Etapa autorización*/}
                    {((view === 'invoiceAuthorization') && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Modelo de autorización</span>
                                    <span className="d-inline d-xl-none">Mod autorización</span>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtDocumentsOwnerName"
                                disabled="true"
                                value={newOrderModel.WtmName ? newOrderModel.WtmName : ''}
                            />
                            {(action === 1 || (action === 2 && editMode && permissions.editOwner)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openPropietario}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>))}
                </div>
                {/*Segunda columna*/}
                <div className="col-12 col-md-6" style={{ paddingRight: 0 }}>
                    {/*Total antes del Descuento*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Total antes Dcto:</span>
                                <span className="d-inline d-xl-none">Antes Dcto:</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtSubTotalS"
                            disabled="true"
                            value={
                                ((newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || isMarketingDoc(newOrderModel?.ObjType)) ?
                                    (newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' ' + formatNumber.new(newOrderModel.SubtotalWithoutDiscount ?? '')
                                    : (newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' ' + formatNumber.new(newOrderModel.Subtotal ? newOrderModel.Subtotal : '')
                                )
                            }
                        />
                    </div>

                    {/* DOWN PAYMENTS:*/}
                    {view === 'invoice' &&
                        <>
                            {this.state.showDownPayments &&
                                <DownPayments
                                    data={this.state.DownPayments}
                                    checkbox={this.props.checkbox}
                                    newOrderModel={newOrderModel}
                                    ChangeDowPaymentData={this.ChangeDowPaymentData}
                                    refreshModel={this.refreshModel}
                                    refreshTotal={this.refreshTotal}
                                    cleanData={() => { }}
                                />
                            }
                            <div className="input-group mb-3">
                                {Modules['InvoiceAdvance'] && Number(action) === 1 && (
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={this.openDownPayments}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                )}
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                        <span className="d-none d-xl-inline">Anticipo total:</span>
                                        <span className="d-inline d-xl-none">Anticipo:</span>
                                    </span>
                                </div>

                                <input
                                    type="text"
                                    className="form-control input-sm"
                                    id="txtAmountDownPayments"
                                    style={{ textAlign: 'right' }}
                                    disabled="true"
                                    value={newOrderModel.DownPaymentAmount ? `${newOrderModel.DocCur || CURRENCY} ${FORMAT_NUMBER.new(newOrderModel.DownPaymentAmount)}` : ''} />
                            </div>
                        </>

                    }
                    {/*Descuento:*/}
                    {(view !== 'PurchaseRequest' || isPurchaseQuotation) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Descuento</span>
                            </div>
                            <input
                                style={{
                                    width: '20%',
                                    textAlign: 'right',
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                }}
                                type="text"
                                className="form-control"
                                id="txtDiscPrcnt"
                                disabled={true}
                                onChange={event => this.changeDiscountDocument(event)}
                                onBlur={this.validateDiscountDocumentNull}
                                value={newOrderModel.DiscountPercent || ''}
                            />
                            <input
                                style={{ textAlign: 'right' }}
                                type="text"
                                className="form-control"
                                id="txtDiscPrcntt"
                                value={((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                    + formatNumber.new(newOrderModel.Discount ? newOrderModel.Discount : '')
                                )
                                }
                                disabled="true"
                            />
                        </div>}

                    {/*Anticipo*/}
                    {/* {newOrderModel.DpmAmnt > 0 && <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Anticipo total</span>
                        </div>
                        <input
                            type=" text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtDpmAmnts"
                            disabled="true"
                            value={
                                ((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                    + formatNumber.new(newOrderModel.DpmAmnt)
                                )
                            }
                        />
                    </div>} */}
                    {/*Impuesto*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Impuesto</span>
                        </div>
                        <input
                            type=" text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtVatSumS"
                            disabled="true"
                            value={
                                ((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                    + formatNumber.new(newOrderModel.Taxes ? newOrderModel.Taxes : '')
                                )
                            }
                        />
                    </div>

                    {/*Retención de impuestos*/}
                    {view === 'invoice' && newOrderModel.RateAmnt != null && newOrderModel.RateAmnt != undefined && Number(newOrderModel?.TotalRetenido ?? 0) > 0 && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Retención</span>
                            </div>
                            <input
                                type="text"
                                className="form-control text-right"
                                id="txtRateAmnt"
                                readOnly
                                disabled
                                value={`${newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY} ${newOrderModel?.TotalRetenido ? formatNumber.new(newOrderModel?.TotalRetenido ? newOrderModel.TotalRetenido : '') : 0}`}
                            />
                        </div>
                    )}
                    {/* {(newOrderModel.newView === 'purchaseInvoice' || view === 'purchaseInvoice') && newOrderModel?.isPurchaseDocument */}
                    {newOrderModel?.isPurchaseDocument && (newOrderModel.DetraccionVista || newOrderModel?.newView === 'PurchaseOrder') && newOrderModel?.U_STR_AfctoDtr === 'Y' &&
                        <>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Detracción %</span>
                                </div>
                                <input
                                    type=" text"
                                    style={{ textAlign: 'right' }}
                                    className="form-control"
                                    id="txtDetraccionPer"
                                    disabled="true"
                                    value={`${formatNumber.new(newOrderModel?.U_STR_TasaDTR || 0)} %`}
                                />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Detracción</span>
                                </div>
                                <input
                                    type=" text"
                                    style={{ textAlign: 'right' }}
                                    className="form-control"
                                    id="txtDetraccion"
                                    disabled="true"
                                    value={((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                        + formatNumber.new(newOrderModel?.U_RS_MONDET || ''))}
                                />
                            </div>
                        </>
                    }
                    {/* {(newOrderModel.newView === 'purchaseInvoice' || view === 'purchaseInvoice') && newOrderModel?.isPurchaseDocument */}
                    {newOrderModel?.isPurchaseDocument
                        && (newOrderModel.DetraccionVista || newOrderModel?.newView === 'PurchaseOrder') && newOrderModel?.U_LLG_RETENCI === 'Y' &&
                        <>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Retención</span>
                                </div>
                                <input
                                    type=" text"
                                    style={{ textAlign: 'right' }}
                                    className="form-control"
                                    id="txtRetencion"
                                    disabled="true"
                                    value={((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                        + formatNumber.new(newOrderModel?.MONRET || ''))}
                                />
                            </div>
                        </>
                    }

                    {newOrderModel?.isSalesDocument && view === 'invoice' && newOrderModel.U_BPP_TtPc > 0 &&
                        <>
                            {(Number(action) === 1 || (Number(action) === 2 && editMode)) &&
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Percepción %</span>
                                    </div>
                                    <input
                                        type=" text"
                                        style={{ textAlign: 'right' }}
                                        className="form-control"
                                        id="txtRetencion"
                                        disabled="true"
                                        value={`${formatNumber.new(newOrderModel.U_STR_FE_Tasa_Percepcion || 0)} %`}
                                    />
                                </div>
                            }
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Percepción</span>
                                </div>
                                <input
                                    type=" text"
                                    style={{ textAlign: 'right' }}
                                    className="form-control"
                                    id="txtRetencion"
                                    disabled="true"
                                    value={CURRENCY + ' ' + formatNumber.new(newOrderModel.U_BPP_TtPc || '')}
                                />
                            </div>
                        </>
                    }

                    {/*Total del documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Total documento</span>
                                <span className="d-inline d-xl-none">Total doc</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtDocTotalS"
                            disabled="true"
                            value={((newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' '
                                + formatNumber.new(newOrderModel.Total ? newOrderModel.Total : '')
                            )
                            }
                        />
                    </div>
                    {/*Importe aplicado*/}
                    {(view === 'invoice' || view === 'creditNote' || view === 'debitNote') && <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Importe aplicado</span>
                                <span className="d-inline d-xl-none">Imp aplicado</span>
                            </span>
                        </div>
                        <input
                            type=" text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtVatSumS"
                            disabled="true"
                            value={
                                // CURRENCY+
                                (newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' ' +
                                (formatNumber.new(newOrderModel.PaidToDate ? newOrderModel.PaidToDate : 0)
                                    //  +' ' +(newOrderModel.DocCur ? newOrderModel.DocCur : '')
                                )
                            }
                        />
                    </div>}
                    {/*Importe aplicado*/}
                    {(view === 'invoice' || view === 'creditNote' || view === 'debitNote') && (<div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Saldo Pendiente</span>
                                <span className="d-inline d-xl-none">Saldo Pend</span>
                            </span>
                        </div>
                        <input
                            type=" text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            id="txtVatSumS"
                            disabled="true"
                            value={
                                // CURRENCY+
                                (newOrderModel.DocCur ? newOrderModel.DocCur : CURRENCY) + ' ' +
                                (formatNumber.new(newOrderModel.PaidToDate ? newOrderModel.Total - newOrderModel.PaidToDate : newOrderModel.Total ? newOrderModel.Total : 0)
                                    //  +' ' +(newOrderModel.DocCur ? newOrderModel.DocCur : '')
                                )
                            }
                        />
                    </div>)}
                </div>
            </div>
        );
    };

    //HEADER DE ENTRADA,SALIDA DE MERCANCIA Y REVALORIZACION DE INVENTARIOS
    renderDocumentHeaderTransfers = () => {
        const { newOrderModel, action, prices } = this.props;
        let { view } = this.props;
        const auxView = view;
        view = (view === 'invoiceAuthorization' || view === 'invoiceBorrador') && (Number(newOrderModel.ObjType) === 59 || Number(newOrderModel.ObjType) === 60) ?
            Number(newOrderModel.ObjType) === 59 ? 'transfersEntry' : 'transfersOutput'
            : view;
        const { editMode, U_FMB_DEF_PLInventoryGenExitService, U_FMB_DEF_PLInventoryGenEntryService } = this.state;

        // Al crear nuevo documento trae cero y no existe en el mapeo (Default -1 Ult precio de compra en SAP)
        // newOrderModel.GroupNum = newOrderModel.GroupNum === 0 ? -1 : newOrderModel.GroupNum; 


        let { permissions } = newOrderModel;
        let dateText = ' F. Entrega';

        if (newOrderModel.OriginDocumentCreate == 'invoice' || newOrderModel.OriginDocumentCreate == 'invoiceReserve') {
            dateText = 'F. Vencimiento'
        }
        const { invFLeft = [], invFRight = [] } = this.splitInHalf(newOrderModel?.invFields ?? [], true);

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*No del cliente*/}
                    {/*Nombre del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Número</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtName"
                            disabled="true"
                            value={(auxView === 'invoiceBorrador' || auxView === 'invoiceAuthorization') ? `${newOrderModel.DocNum}-${newOrderModel.DocEntry}` : newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                        />
                    </div>
                    {/*No Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtDocumentDate"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/* Lista de Precios:*/}
                    {(view !== 'inventoryRevaluation') && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Lista De Precios</span>
                            </div>
                            <select className="form-control" disabled={(action == 2 && !editMode) ? true : false}
                                onChange={action === 1 ? (event) => this.changeSelectedFieldDocument(event) : ''}
                                value={newOrderModel.GroupNum || -1}>
                                {prices?.map(price => {
                                    return (
                                        <option value={price.ListNum}>{price.ListName}</option>
                                    )
                                })}
                                <option value={-1}>Último precio de compra</option>
                                <option value={-2}>Último precio determinado</option>
                            </select>
                        </div>)}
                    {/* Densidad */}
                    {view === 'transfersEntry' &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">Densidad</span>
                            </div>
                            <input
                                type="text"
                                maxLength="20"
                                className="form-control"
                                id="txtU_RS_DENSIDAD"
                                disabled={Number(action) !== 1}
                                value={newOrderModel?.U_RS_DENSIDAD || ''}
                                onChange={(event) => Number(action) === 1 && this.changeHDensidad(event)}
                                onBlur={(event) => Number(action) === 1 && this.changeQuantityBlur(null, event, 'U_RS_DENSIDAD')}
                            />
                        </div>
                    }
                    {(view === 'transfersEntry' || view === 'transfersOutput') &&
                        this.renderSpecificFields(invFLeft, newOrderModel, action, editMode)
                    }

                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Contabilización</span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={Number(action) === 2 ? 'date' : 'date'}
                            disabled={Number(action) === 2 || (view === 'transfersEntry' || view === 'transfersOutput') ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                            onChange={this.selectDocDate}
                        />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className=" form-control"
                            id="txtStatus"
                            max='9999-12-31'
                            autoComplete="off"
                            disabled="true"
                            value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
                        />
                    </div>
                    {/*Referencia 2:*/}

                    {(view === 'transfersEntry' || view === 'transfersOutput') &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia 2</span>
                            </div>
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtRef2"
                                disabled={action === 2 ? true : false}
                                value={newOrderModel?.Ref2 || ''}
                                maxlength={11}
                                onChange={(event) => action === 1 && this.changeHeaderField('Ref2', event.nativeEvent.target.value, 11)}
                            />
                        </div>
                    }

                    {/*Referencia 2:*/}
                    {/* {(action == 2) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Asiento Contable</span>
                            </div>
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtNo"
                                disabled="true"
                                value={''}
                            />
                            <button
                                type="button"
                                style={{
                                    backgroundColor: 'transparent',
                                    color: '#EABF28',
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                }}
                                className="input-group-text"
                                onClick={() => this.openAsientoContable(1, 'Item')}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        </div>)} */}

                    {(view === 'transfersEntry' || view === 'transfersOutput') &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Proyecto</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="txtProject"
                                disabled={true}
                                value={newOrderModel?.Project || ''}
                            />
                            {(action === 1) &&
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={() => this.openProjects(null)}
                                >
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            }
                        </div>
                    }
                    {(view === 'transfersEntry' || view === 'transfersOutput') &&
                        this.renderSpecificFields(invFRight, newOrderModel, action, editMode)
                    }
                </div>
            </div>
        );
    };
    //BODY DE ENTRADA Y SALIDA DE MERCANCIA
    renderDocumentBodyTranfers = (item) => {
        const { newOrderModel, action } = this.props;
        let { view } = this.props;
        view = (view === 'invoiceAuthorization' || view === 'invoiceBorrador') && (Number(newOrderModel.ObjType) === 59 || Number(newOrderModel.ObjType) === 60) ?
            Number(newOrderModel.ObjType) === 59 ? 'transfersEntry' : 'transfersOutput'
            : view;

        const { editMode } = this.state;

        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];

        const deliveriesAddress = newOrderModel.deliveriesAddress || [];
        let { permissions } = newOrderModel;
        const { isSelectTo } = newOrderModel;
        const isTransfersEntry = view === "transfersEntry" || newOrderModel?.newView === "transfersEntry";
        const isTransfersOutput = view === "transfersOutput" || newOrderModel?.newView === "transfersOutput";

        const { invFLeft = [], invFRight = [] } = this.splitInHalf(newOrderModel?.invFields ?? [], false);
        return (
            <div style={{ marginBottom: 30 }}>
                {/* Pestañas del body */}
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + ((view !== 'transfersEntry' && view !== 'transfersOutput') && !this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                        {Modules['InventoryFields'] && ((view === 'transfersEntry' || view === 'transfersOutput')) &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary"}
                                id="nav-profile-tab-InvFields"
                                data-toggle="tab"
                                href="#invFields"
                                role="tab"
                                aria-controls="invFields"
                                aria-selected="false">
                                Ramo
                            </a>
                        }
                    </div>
                </nav>

                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    <div
                        className="tab-pane fade"
                        id="dataFinanzas"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Fianazas">
                        <div className="form-group row" id="div1">
                            <label
                                htmlFor="txtContactPerson"
                                className="col-md-2 col-sm-12 col-form-label font-weight-bold"
                                style={{ paddingLeft: 30 }}>
                                Condición Pago:
                            </label>
                            <div className="col-md-3 col-sm-12" style={{ paddingLeft: 30 }}>
                                <input
                                    type=" text"
                                    className="form-control btn-outline-secondary"
                                    disabled={action == 2}
                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                    value={newOrderModel.GroupName ? newOrderModel.GroupName : ''}
                                />
                            </div>
                        </div>
                        <div className="form-group row" id="div1">
                            <label
                                htmlFor="txtContactPerson"
                                className="col-md-2 col-sm-12 col-form-label font-weight-bold"
                                style={{ paddingLeft: 30 }}>
                                Forma Pago:
                            </label>
                            <div className="col-md-3 col-sm-12" style={{ paddingLeft: 30 }}>
                                <input
                                    type=" text"
                                    className="form-control btn-outline-secondary"
                                    disabled={action == 2}
                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                    value={newOrderModel.PymName ? newOrderModel.PymName : ''}
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="dataLogistica"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Logistica">
                        <div className="form-group row" id="div1">
                            <label
                                htmlFor="txtContactPerson"
                                className="col-md-2 col-sm-12 col-form-label font-weight-bold"
                                style={{ paddingLeft: 30 }}>
                                Destino:
                            </label>
                            <div className="col-md-3 col-sm-12">
                                <input
                                    type="text"
                                    className="form-control input-sm"
                                    id="txtCustomer"
                                    disabled="true"
                                    value={newOrderModel.ShipToCode ? newOrderModel.ShipToCode : ''}
                                />
                            </div>
                            {(action == 1 || (action == 2 && permissions.editItems)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="btn"
                                    onClick={() => this.openAddresses(1)}>
                                    <i className="fas fa-list" />
                                </button>
                            )}
                        </div>

                        <div className="form-group row" id="div1">
                            <label
                                htmlFor="txtContactPerson"
                                className="col-md-2 col-sm-12 col-form-label font-weight-bold"
                                style={{ paddingLeft: 30 }}>
                            </label>
                            <div className="col-md-3 col-sm-12">
                                <input
                                    type="text"
                                    className="form-control input-sm"
                                    id="txtCustomer"
                                    disabled="true"
                                    value={newOrderModel.Address2 ? newOrderModel.Address2 : ''}
                                />
                            </div>
                        </div>
                    </div>

                    {/* CONTENIDO */}
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, paddingTop: 5 }}>
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Artículo
                                    </td>
                                    <td className="sticky-header" style={{ maxWidth: 800, backgroundColor: '#d2ab24' }}>
                                        Descripción
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 180 }}>
                                        Almacén
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        {isSelectTo ? 'Cantidad Abierta' : 'Cantidad'}
                                    </td>
                                    {isSelectTo && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Cantidad Cerrada
                                    </td>}
                                    {isSelectTo && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Cantidad Original
                                    </td>}
                                    <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                        Precio
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Total
                                    </td>
                                    {(view === 'transfersOutput' || view === 'transfersEntry') ?
                                        <>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}> Stock en general </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}> Stock en almacén </td>
                                        </>
                                        :
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}> En stock </td>
                                    }
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Código de cuenta
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Costo del artículo
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Código UMI
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Unidad de medida Alternativa
                                    </td>
                                    {view === 'transfersEntry' &&
                                        <>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                UND Med.
                                            </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                Densidad
                                            </td>
                                        </>
                                    }
                                    {(isTransfersEntry || isTransfersOutput) && (
                                        <>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                Asignación de ubicación
                                            </td>
                                        </>
                                    )}
                                    {(isTransfersEntry || isTransfersOutput) && Modules.CostCenter && <>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            CANAL
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            SEDES
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            SUCURSAL
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            NEGOCIO
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            CECO
                                        </td>
                                    </>}
                                    {/* 
                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                    Descuento por Pronto Pago
                                </td>                   */}
                                    {/* <td
                                    className="sticky-header sticky-columns"
                                    style={{backgroundColor: '#d2ab24'}}
                                /> */}
                                    {/* Campos de usuario dinamicos */}
                                    {json.allItemsUserFields.map((field, index) => {

                                        if (field.enabled && field.name && (field.fieldId === isTipodeOperacion || field.fieldId === isTipodeGasto)) {
                                            return (
                                                <td className="sticky-header" id={'userFields' + index} style={{ backgroundColor: '#d2ab24' }}>
                                                    {field.name}
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {/* Filas de tabla  */}
                                {newOrderModelItems.map((item, index) => {
                                    const whsStock = item.wareHouseStock.find(({ WhsCode }) => WhsCode === item.WhsCode) || { OnHand: 0 };
                                    return (
                                        <tr style={{
                                            maxHeight: 10,
                                            paddingTop: 8,
                                            paddingBottom: 8,
                                            color: item.stock ? 'black' : 'red',
                                            backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : 'transparent'
                                        }}>
                                            {/*Artículos*/}
                                            <td className="sticky-column"
                                                style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                                                {item.ItemCode}
                                            </td>
                                            {/*Descripción*/}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {item.ItemName}
                                            </td>
                                            {/*Almacen*/}
                                            <td style={{ textAlign: 'center' }}>
                                                <div className='input-group'>
                                                    <input
                                                        type=" text"
                                                        placeholder="Almacén"
                                                        disabled={Number(action) === 2 && !editMode ? true : false}
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        style={{
                                                            backgroundColor: item.whsSelected ? 'rgb(248,242,209)' : 'transparent',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            maxWidth: 800,
                                                            minWidth: 100,
                                                            widht: 150,
                                                        }}
                                                        onKeyPress={(eve) => {
                                                            if (eve.key === 'Enter') {
                                                                this.openAlmacen(index, 1, item.ItemCode);
                                                            }
                                                        }}
                                                        value={item.WhsCode}
                                                        onChange={event => this.changeAlmacen(index, event)}
                                                    />
                                                    {(Number(action) === 1 || (Number(action) === 2 && editMode && !item.LineStatus)) && (
                                                        <div className="input-group-append" >
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    border: "1px solid #ced4da"
                                                                }}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.openAlmacen(index, 1, item.ItemCode)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            {/*Cantidad*/}
                                            <td>
                                                <input
                                                    type=" text"
                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                    disabled={(action == 2) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        maxWidth: 60,
                                                        textAlign: "center",

                                                    }}
                                                    id={'itemCantidad' + index}
                                                    value={item.Quantity}
                                                    onChange={event => this.changeQuantityItem(event, index)}
                                                // onBlur={event => this.specialPrice(index)}
                                                />
                                            </td>

                                            {isSelectTo &&
                                                <td>
                                                    <input
                                                        type=" text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        disabled={true}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            maxWidth: 60,
                                                            textAlign: "center",

                                                        }}
                                                        id={'itemCantidad' + index}
                                                        value={item.BaseEntry ? item.OriginalQuantityClose : ''}
                                                    />
                                                </td>}

                                            {isSelectTo && <td>
                                                <input
                                                    type=" text"
                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                    disabled={true}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        maxWidth: 60,
                                                        textAlign: "center",
                                                    }}
                                                    id={'itemCantidad' + index}
                                                    value={item.BaseEntry ? item.OriginalQuantity : ''}
                                                />
                                            </td>}

                                            {/*Precio*/}
                                            <td style={{ width: 130 }}>
                                                {(action == 1 || (action == 2 && permissions.editItems && !item.LineStatus)) ?
                                                    <input
                                                        type=" text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        // disabled={(action == 2 ) ? true : !permissions.editItems}
                                                        // disabled={action === 1 ? false : true}
                                                        // disabled
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            width: 130,
                                                            textAlign: 'right',
                                                        }}
                                                        id={'itemCantidad' + index}
                                                        value={CURRENCY + formatNumber.new(item.Price)}
                                                        onChange={event => this.changePriceItem(event, index)}
                                                        onBlur={event => this.validatePriceNull(index)}
                                                    />
                                                    :
                                                    <label>{CURRENCY + formatNumber.new(item.Price) + " " + item.Currency} </label>
                                                }
                                            </td>

                                            {/*Total*/}
                                            <td style={{ textAlign: 'right' }}>{CURRENCY + formatNumber.new(item.Total)}</td>
                                            {/*Stock*/}
                                            {(view === 'transfersOutput' || view === 'transfersEntry') ?
                                                <>
                                                    <td style={{ textAlign: 'right' }}>{Number(item.OnHand).toFixed(4) || 0}</td>
                                                    <td style={{ textAlign: 'right' }}>{Number(whsStock.OnHand).toFixed(4) || 0}</td>
                                                </>
                                                :
                                                <td style={{ textAlign: 'right' }}>{Number(item.OnHand).toFixed(4) || 0}</td>
                                            }
                                            {/*Centros de costos*/}
                                            {/* <td>
                                                {item.OcrCode}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 1)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode2}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode3}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 3)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode4}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 4)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td> */}
                                            {/* Código de cuenta */}
                                            <td style={{ textAlign: 'center' }}>
                                                {/* {item.AcctCode}   */}
                                                {newOrderModel?.InventoryAccount?.AcctCode ? item.AcctCode : item.FormatCode}
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#EABF28',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    disabled={action == 2 ? true : false}
                                                    className={`btn ${newOrderModel?.InventoryAccount?.AcctCode ? 'd-none' : ''}`}
                                                    onClick={() => !newOrderModel?.InventoryAccount?.AcctCode && this.openCuentaMayor(index, 5)}>
                                                    <i className="fa fa-list" aria-hidden="true" />
                                                </button>
                                                {/* <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#EABF28',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn "
                                                    onClick={() => this.openAsientoContable(index,item.ItemCode)}>
                                                    <i className="fa fa-list" aria-hidden="true"/>
                                                </button> */}
                                                {/* {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#EABF28',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn "
                                                    onClick={() => this.openCuentaMayor(index,5)}>
                                                    <i className="fa fa-list" aria-hidden="true"/>
                                                </button>
                                            )} */}
                                            </td>
                                            {/*Costo del artículo*/}
                                            <td style={{ textAlign: 'right' }}>{''}</td>
                                            {/*Unidad de Medida*/}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {item.InvntryUom}
                                            </td>

                                            <td style={{ textAlign: 'right' }}>{''}</td>



                                            {/* <td style={{textAlign: 'center'}}>
                                            {item.AcctCodeName}
                                        </td>
                                        <td style={{textAlign: 'center'}}>
                                            {item.CogsAcctName}
                                        </td> */}
                                            {view === 'transfersEntry' &&
                                                <>
                                                    {/* UND Med. */}
                                                    <td style={{ textAlign: 'center' }}>
                                                        <select className="form-control"
                                                            disabled={Number(action) !== 1 || !Granel?.includes(Number(item?.ItmsGrpCod))}
                                                            onChange={event => Number(action) === 1 && Granel?.includes(Number(item?.ItmsGrpCod)) && this.changeUserUM(index, event)}
                                                            value={item.U_RS_UMED || ''}
                                                            style={{ minWidth: '120px' }}
                                                        >
                                                            <option value={''}> {'Seleccionar'}</option>
                                                            <option value={'KGM'}> {'Kilogramos'}</option>
                                                            <option value={'GLN'}> {'Galones'}</option>
                                                        </select>
                                                    </td>
                                                    {/* Densidad */}
                                                    <td style={{ textAlign: 'center' }}>
                                                        <input
                                                            type="text"
                                                            id={`DENS-${index}`}
                                                            className="form-control btn-outline-secondary"
                                                            disabled={Number(action) !== 1 || !Granel?.includes(Number(item?.ItmsGrpCod))}
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                            value={item.U_RS_DENS || ''}
                                                            onChange={event => Number(action) === 1 && Granel?.includes(Number(item?.ItmsGrpCod)) && this.changeDensidad(index, event)}
                                                            onBlur={event => Number(action) === 1 && Granel?.includes(Number(item?.ItmsGrpCod)) && this.changeQuantityBlur(index, event, 'U_RS_DENS')}
                                                        />
                                                    </td>
                                                </>
                                            }
                                            {(isTransfersEntry || isTransfersOutput) && (
                                                <>
                                                    {/* Asignación de ubicación */}
                                                    <td>
                                                        <div className="input-group">
                                                            {item.BinActivat === 'Y' && <>
                                                                <input
                                                                    className={`form-control text-right ${action === 1 && (!isTransfersOutput ? Number(item.Quantity) !== Number(item.ToTotalAsigned) : Number(item.Quantity) !== Number(item.TotalAsigned)) ? "text-danger" : ""}`}
                                                                    disabled
                                                                    readOnly
                                                                    value={item.Quantity || ""}
                                                                />
                                                                {(action === 1 || action === 2) && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => action === 2 ? this.showDocumentStock(item.LineNum) : this.showLocationAssignment(item.LineNum, !isTransfersOutput ? 2 : 1)}
                                                                        >
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </>
                                                            }
                                                        </div>
                                                    </td>
                                                </>
                                            )}
                                            {(isTransfersEntry || isTransfersOutput) && Modules.CostCenter && <>
                                                <td>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={item.OcrCode || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension1) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 1)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={item.OcrCode2 || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension2) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 2)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={item.OcrCode3 || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension3) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 3)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={item.OcrCode4 || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension4) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 4)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={item.OcrCode5 || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension5) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 5)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </>}
                                            {/* Campos de usuario dinamicos */}
                                            {json.allItemsUserFields.map((field, indexField) => {

                                                if (field.enabled && field.name && (field.fieldId === isTipodeOperacion || field.fieldId === isTipodeGasto)) {
                                                    return (
                                                        <td style={{ textAlign: 'right' }}>
                                                            {(
                                                                Number(field.fieldType) === 1 ?
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        id={'inputUserField' + 1}
                                                                        disabled={((Number(action) === 2 && !editMode) || (field.fieldId === isTipodeOperacion && (view === 'transfersEntry' || view === 'transfersOutput'))) ? true : false}
                                                                        value={field.name == 'Precio x kilo' ? (this.returnValueItem(field.IdValue, index) || item.PrecioKilo) : this.returnValueItem(field.IdValue, index)}
                                                                        onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}

                                                                    /> :
                                                                    <select
                                                                        className="form-control"
                                                                        id={'selectUserField' + 1}
                                                                        disabled={((Number(action) === 2 && !editMode) || (field.fieldId === isTipodeOperacion && (view === 'transfersEntry' || view === 'transfersOutput'))) ? true : false}
                                                                        value={this.returnValueItem(field.IdValue, index)}
                                                                        onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}
                                                                    >
                                                                        {field.options.map((option) => {
                                                                            if (option.FldValue != null) {
                                                                                return (
                                                                                    <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }

                                                                        })}
                                                                    </select>
                                                            )}
                                                        </td>
                                                    );
                                                } else {
                                                    return (<></>)
                                                }
                                            })}
                                            {(action === 1) && (
                                                <td
                                                    className="sticky-columns"
                                                    style={{
                                                        backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF',
                                                        textAlign: 'center'
                                                    }}>
                                                    {/*Eliminar*/}

                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: '#c42222',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.deleteItem(index)}>
                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                    </button>

                                                </td>
                                            )}

                                        </tr>
                                    );
                                })}
                                {/*  agregar articulo y busqueda realcionada */}
                                {(action === 1) && (
                                    <tr>
                                        <td className="sticky-column" style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                            <div>
                                                <input
                                                    type=" text"
                                                    placeholder="Artículo"
                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                    // disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                    }}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openItems();

                                                        }
                                                    }}
                                                    value={newOrderModel.searchItem || ''}
                                                    onChange={event => this.changeSearchItem(event)}
                                                // onBlur={event => this.specialPrice(index)}
                                                />
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        padding: 5,
                                                        color: 'green',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.openItems()}>
                                                    <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                </button>
                                            </div>


                                        </td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </div>
                    {/* INVENTORY FIELDS */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="invFields"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-InvFields">
                        <div className="row" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6">{this.renderSpecificFields(invFLeft, newOrderModel, action, editMode)}</div>
                            <div className="col-12 col-md-6">{this.renderSpecificFields(invFRight, newOrderModel, action, editMode)}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    splitInHalf = (fields = [], filter = false, target = '') => {
        const { view } = this.props
        const activeFields = fields?.filter(f => f.isHeader === filter);
        const middle = Math.ceil(activeFields?.length / 2);

        if (view === 'PurchaseRequest') {
            return {
                OPRQFieldsLeft: activeFields?.slice(0, middle),
                OPRQFieldsRight: activeFields?.slice(middle),
            };
        } else if (target === 'transferFields') {
            return {
                OWTRFieldsLeft: activeFields?.slice(0, middle),
                OWTRFieldsRight: activeFields?.slice(middle),
            };
        } else {
            return {
                invFLeft: activeFields?.slice(0, middle),
                invFRight: activeFields?.slice(middle),
            };
        }
    };

    renderSpecificFields = (fields = [], newOrderModel, action, editMode = false) =>
        fields.map(invField => (
            <div className="input-group mb-3" key={invField.Field}>
                <div className="input-group-prepend">
                    <span className="input-group-text font-weight-bold">
                        {invField.Name}
                    </span>
                </div>

                {(invField.Type === 'text' || invField.Type === 'number' || invField.Type === 'date') ? (
                    <input
                        type={invField.Type === 'number' ? 'text' : invField.Type}
                        className="form-control"
                        id={`${invField.Type}${invField.Field}`}
                        disabled={(Number(action) === 2 && !editMode) || invField.Static}
                        value={newOrderModel?.[invField.Field] ?? invField.emptyValue}
                        onChange={(e) => !invField.Static && this.changeHeaderField(invField.Field, e.target.value, invField?.Type === 'date' ? null : invField?.Size || null, invField?.isNumber || false)}
                        onBlur={(e) => { this.changeBlurHeaderField(invField.Field, e.target.value, 2, invField?.isNumber) }}
                    />
                ) :
                    <>
                        {invField.Type === 'select' ?
                            <>
                                <Select
                                    options={(invField?.options || []).map(row => ({ value: row.FldValue, label: `${row.FldValue ?? ''} - ${row.Descr ?? ''}` }))}
                                    value={(invField?.options || []).map(row => ({ value: row.FldValue, label: `${row.FldValue ?? ''} - ${row.Descr ?? ''}` }))
                                        .find(option => String(option.value) === String(newOrderModel?.[invField.Field] ?? invField.emptyValue)) || null}
                                    onChange={(selectedOption) => !invField.Static && this.changeHeaderField(invField.Field, selectedOption?.value ?? invField.emptyValue)}
                                    placeholder="Seleccionar"
                                    isSearchable={true}
                                    isClearable={true}
                                    noOptionsMessage={() => "No se encontraron coincidencias"}
                                    isDisabled={(Number(action) === 2 && !editMode) || invField.Static}
                                    styles={{
                                        container: (base) => ({ ...base, flex: 1, width: '100%' }),
                                        control: (base) => ({
                                            ...base,
                                            height: 40,
                                            minHeight: 40,
                                            width: '100%',
                                            borderRadius: 4,
                                            backgroundColor: "transparent",
                                            borderColor: "#ced4da"
                                        }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        singleValue: (base) => ({ ...base, color: "#000" }),
                                        input: (base) => ({ ...base, color: "#000" })
                                    }}
                                />
                            </>
                            :
                            <>
                                {invField.Type === 'table' ?
                                    <>
                                        <input
                                            type={'text'}
                                            className="form-control"
                                            id={`${invField.Type}${invField.Field}`}
                                            disabled={true}
                                            onlyRead={true}
                                            value={newOrderModel?.[invField.Field] ?? invField.default}
                                        />
                                        {(Number(action) === 1 || (Number(action) === 2 && editMode)) && <>
                                            {(newOrderModel?.[invField.Field] && newOrderModel?.[invField.Field] !== invField.default) &&
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        padding: 5,
                                                        color: '#c42222',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="input-group-text"
                                                    onClick={(e) => !invField.Static && this.changeHeaderField(invField.Field, invField.default)} >
                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                </button>
                                            }
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                disabled={(Number(action) === 2 && !editMode) || invField.Static}
                                                onClick={(e) => !invField.Static && this.openFormattedQueries(invField)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </>
                                        }
                                    </>
                                    :
                                    <>

                                    </>
                                }
                            </>
                        }
                    </>
                }
            </div>
        ));

    //FOOTER DE ENTRADA Y SALIDA DE MERCANCIA
    renderDocumentFooterTransfer = () => {
        const { newOrderModel, action } = this.props;
        const { editMode } = this.state;
        let optionsType = newOrderModel.U_TipoSalidaOptions || [];
        return (
            <div className="row">
                <div className="col-md-6 col-sm-12">

                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className=" form-control btn-outline-secondary styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={action === 2}
                            value={newOrderModel.Comments ? newOrderModel.Comments : ''}
                            onChange={this.changeComments}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                </div>
                <div className="col-md-6 col-sm-12">

                    {/*U_TipoSalida:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Tipo Salida/Entrada</span>
                                <span className="d-inline d-xl-none">Tipo S/E</span>
                            </span>
                        </div>
                        <select className="form-control" disabled={(action === 2 && !editMode) ? true : false}
                            onChange={(event) => this.ChangeU_TipoSalida(event.target.value)}
                            value={newOrderModel.U_TipoSalida || ''} >
                            <option value={''}>Selecciona una opcion</option>
                            {optionsType.map(type => {
                                if (type.FldValue) {
                                    return (
                                        <option value={type.FldValue}>{type.Descr}</option>
                                    )
                                } else {
                                    return <></>;
                                }
                            })}

                        </select>
                    </div>
                </div>

            </div>
        );
    };

    //BODY REVALORIZACION DE INVENTARIOS
    renderDocumentBodyInventory = (item) => {
        const { newOrderModel, action, view } = this.props;
        const { editMode } = this.state;



        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];


        const deliveriesAddress = newOrderModel.deliveriesAddress || [];
        let { permissions } = newOrderModel;
        const { isSelectTo } = newOrderModel;
        return (
            <div style={{ marginBottom: 30 }}>
                {/* Pestañas del body */}
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                    </div>
                </nav>

                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, paddingTop: 5 }}>
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Artículo
                                    </td>
                                    <td className="sticky-header" style={{ maxWidth: 200, textAlign: 'center', backgroundColor: '#d2ab24' }}>
                                        Descripción
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Almacén
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Costos Actuales
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Costos Nuevos
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Unidad de Medida
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        En Stock
                                    </td>
                                    {/* <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 1
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 2
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 3
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 4
                                    </td> */}
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Aumentar cuenta de mayor
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Disminuir cuenta de mayor
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Método de validación
                                    </td>
                                    <td
                                        className="sticky-header sticky-columns"
                                        style={{ backgroundColor: '#d2ab24' }}
                                    />
                                </tr>
                            </thead>
                            <tbody>
                                {/* Filas de tabla  */}
                                {newOrderModelItems.map((item, index) => {
                                    return (
                                        <tr style={{
                                            maxHeight: 10,
                                            paddingTop: 8,
                                            paddingBottom: 8,
                                            color: item.stock ? 'black' : 'red',
                                            backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : 'transparent'
                                        }}>
                                            {/*Artículos*/}
                                            <td className="sticky-column"
                                                style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                                                {item.ItemCode}
                                            </td>
                                            {/*Descripción*/}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {item.ItemName}
                                            </td>
                                            {/*Almacen*/}
                                            <td style={{ textAlign: 'center' }}>
                                                <input
                                                    type=" text"
                                                    placeholder="Almacén"
                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                    disabled={action == 2 && !editMode ? true : false}
                                                    style={{
                                                        backgroundColor: item.whsSelected ? 'rgb(248,242,209)' : 'transparent',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        maxWidth: 800
                                                    }}
                                                    onKeyPress={(eve) => {
                                                        if (eve.key === 'Enter') {
                                                            this.openAlmacen(index, 1, item.ItemCode);
                                                        }
                                                    }}
                                                    value={item.WhsCode}
                                                    onChange={event => this.changeAlmacen(index, event)}
                                                />
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn "
                                                        onClick={() => this.openAlmacen(index, 1, item.ItemCode)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            {/*Costos Actuales*/}
                                            <td style={{ width: 130 }}>
                                                {
                                                    <input
                                                        type=" text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        disabled={true}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            width: 130,
                                                            textAlign: 'right',
                                                        }}
                                                        id={'itemCantidad' + index}
                                                        value={item.AvgPrice}
                                                    />
                                                }
                                            </td>
                                            {/*Costos Nuevos*/}
                                            <td style={{ width: 130 }}>
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                                    <input
                                                        type=" text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        disabled={(action == 2 && !editMode) ? true : !permissions.editItems}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            width: 130,
                                                            textAlign: 'right',
                                                        }}
                                                        id={'itemCantidad' + index}
                                                        value={item.NewAvgPrice}
                                                        onChange={event => this.changeNewAvgPrice(event, index)}
                                                    /> :
                                                    <label>{CURRENCY + formatNumber.new(item.NewAvgPrice) + " " + item.Currency} </label>
                                                }
                                            </td>

                                            {/*Unidad de Medida*/}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {item.InvntryUom}
                                            </td>

                                            {/*Stock*/}
                                            <td style={{ textAlign: 'right' }}>{Number.parseFloat(item.OnHand).toFixed(4)}</td>
                                            {/*Centros de costos*/}
                                            {/* <td>
                                                {item.OcrCode}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 1)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode2}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode3}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 3)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode4}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 4)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td> */}
                                            {/*Aumentar Cuenta Mayor*/}
                                            <td style={{ textAlign: 'center' }}>
                                                {item.FormatCode}
                                                {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn "
                                                        onClick={() => this.openCuentaMayor(index, 5)}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            {/*Disminuir cuenta Mayor*/}
                                            <td style={{ textAlign: 'center' }}>
                                                {item.FormatCode2}
                                                {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn "
                                                        onClick={() => this.openCuentaMayor(index, 6)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            {/*Unidad de Medida*/}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {item.EvalSystem}
                                            </td>



                                            {(action === 1) && (
                                                <td
                                                    className="sticky-columns"
                                                    style={{
                                                        backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF',
                                                        textAlign: 'center'
                                                    }}>
                                                    {/*Eliminar*/}

                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: '#c42222',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.deleteItem(index)}>
                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                    </button>

                                                </td>
                                            )}

                                        </tr>
                                    );
                                })}
                                {/*  agregar articulo y busqueda realcionada */}
                                {(action === 1) && (
                                    <tr>
                                        <td className="sticky-column"
                                            style={{ backgroundColor: '#FFF', textAlign: 'center' }}>



                                            <div>
                                                <input
                                                    type=" text"
                                                    placeholder="Artículo"
                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                    // disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                    }}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openItems();

                                                        }
                                                    }}
                                                    value={newOrderModel.searchItem || ''}
                                                    onChange={event => this.changeSearchItem(event)}
                                                // onBlur={event => this.specialPrice(index)}
                                                />
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        padding: 5,
                                                        color: 'green',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.openItems()}>
                                                    <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                </button>
                                            </div>


                                        </td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };
    //FOOTER REVALORIZACION DE INVENTARIOS
    renderInventoryFooter = () => {
        const { newOrderModel } = this.props
        return (
            <div className="row">

                <div className="col-12 col-md-6">
                    <label htmlFor="txtComments" className="col-md-4 col-sm-12 col-form-label font-weight-bold">
                        Comentarios:
                    </label>
                    <div className="col-12">
                        <textarea
                            type="text"
                            className=" form-control btn-outline-secondary styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            rows="4"
                            value={newOrderModel.Comments}
                            onChange={this.changeComments}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>

                </div>
            </div>
        )

    }
    changeCardType = (e) => {
        const { newOrderModel } = this.props
        this.clearBP()
        newOrderModel.CardType = e?.target?.value ?? null
        this.refreshModel(newOrderModel)
    }
    // HEADER DE CREACION DE TRASLADO
    renderDocumentTransfersHeader = () => {
        const { newOrderModel, action, view, prices, requestPartialEdit, isDraftOWTQ = false } = this.props;
        const { editMode } = this.state;
        // Al crear nuevo documento trae cero y no existe en el mapeo (Default -1 Ult precio de compra en SAP)
        newOrderModel.GroupNum = newOrderModel.GroupNum === 0 ? -1 : newOrderModel.GroupNum;
        const scopCodeIn = ["transfers", "transfersRequest"];
        const type = [{ key: 'C', value: 'Cliente' }, { key: 'S', value: 'Proveedor' }]
        const CardType = type.find(sel => sel.key === (newOrderModel?.CardType || 'C'))
        const opcionesTipoTraslado = [
            { value: '1', label: 'Sucursal a Sucursal' },
            { value: '2', label: 'Recepción de CEDIS' },
            { value: '', label: 'Traspaso directo' }
        ];

        const opcionesTransitType = [
            { value: 'PZ', label: 'Planta-Zonal' },
            { value: 'DZ', label: 'Distribución-Zonal' },
            { value: 'TP', label: 'Transito-Principal' },
            { value: 'DC', label: 'Distribución-Cilindros' }
        ];

        const opcionesTipoSalida = [
            { value: '', label: '-Selecciona-' },
            { value: 'TSE', label: 'Externa' },
            { value: 'TSI', label: 'Interna' }
        ];

        const opcionesMotivoTraslado = [
            { value: '', label: '-Selecciona-' },
            { value: '01', label: 'Venta' },
            { value: '02', label: 'Compra' },
            { value: '03', label: 'Venta con entrega a terceros' },
            { value: '04', label: 'Translado entre establecimientos de la misma empresa' },
            { value: '05', label: 'Consignación' },
            { value: '06', label: 'Devolución' },
            { value: '07', label: 'Recojo de bienes transformados' },
            { value: '08', label: 'Traslado Importacion' },
            { value: '09', label: 'Traslado Exportacion' },
            { value: '13', label: 'Otros' },
            { value: '14', label: 'Venta sujeta a confirmación del comprador' },
            { value: '17', label: 'Traslado de bienes para transformación' },
            { value: '18', label: 'Traslado emisor itenerante CP' },
            { value: '19', label: 'Traslado a zona primaria' }
        ];
        return (
            <div className="row">
                {/*Priemra columna*/}
                <div className="col-12 col-md-6">

                    {/*CARDTYPE SELECTION*/}
                    {(Number(action) === 1 || (Number(action) === 2 && editMode && isDraftOWTQ)) &&
                        < div className="input-group mb-3">
                            < div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo</span>
                            </div>
                            <select className="form-control"
                                onChange={event => this.changeCardType(event)}
                                value={newOrderModel?.CardType ?? ""} >
                                {type?.map(sel => {
                                    return (
                                        <option value={sel?.key ?? null}>{sel?.value ?? ''}</option>
                                    )
                                })}

                            </select>
                        </div>
                    }
                    {/*No del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">{CardType?.value ?? '--'}</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtPartner"
                            style={{ backgroundColor: newOrderModel.partnerSelected ? 'rgb(248,242,209)' : 'transparent' }}
                            disabled={(Number(action) === 2 && !isDraftOWTQ) || (isDraftOWTQ && Number(action) === 2 && !editMode)}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    this.openPartner();
                                }
                            }}
                            onChange={this.changeCardCode}
                            value={newOrderModel.CardCode ? newOrderModel.CardCode : ''}
                        />
                        {(Number(action) === 1 || (Number(action) === 2 && editMode && isDraftOWTQ)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPartner}>
                                <i className="fas fa-user" />
                            </button>
                        )}
                    </div>
                    {/*Nombre del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.CardName ? newOrderModel.CardName : ''}
                        />
                    </div>
                    {/*Persona de Contacto*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Contacto</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.CntctName ? newOrderModel.CntctName : ''}
                        />
                        {(action == 1 || (action == 2 && editMode)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPersonContact}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Address:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control btn-outline-secondary"
                            id="txtCustomerRefNo"
                            disabled="true"
                            value={newOrderModel.Address ? newOrderModel.Address : ''}
                            onChange={this.changeAddress}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>

                    {((newOrderModel.OriginDocumentCreate === 'transfers') && (action === 1)) &&
                        <>
                            {/* Almacén de transito */}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de Traslado</span>
                                </div>
                                <Select
                                    options={opcionesTipoTraslado}
                                    value={
                                        opcionesTipoTraslado.find(
                                            option =>
                                                String(option.value) ===
                                                String(newOrderModel?.Transit ?? '')
                                        ) || null
                                    }
                                    onChange={(selectedOption) =>
                                        this.changeAlmacenTransito(selectedOption)
                                    }
                                    placeholder="Seleccionar"
                                    isSearchable={true}
                                    isClearable={false}
                                    isDisabled={
                                        newOrderModel.OriginDocumentCreate === 'transfersRequest'
                                    }
                                    styles={selectStyles}
                                />
                                {(newOrderModel?.Transit ?? '') === '1' &&
                                    <Select
                                        options={opcionesTransitType}
                                        value={
                                            opcionesTransitType.find(
                                                option =>
                                                    String(option.value) ===
                                                    String(newOrderModel?.TransitType ?? '')
                                            ) || null
                                        }
                                        onChange={(selectedOption) =>
                                            this.changeTransitType(selectedOption)
                                        }
                                        placeholder="Seleccionar"
                                        isSearchable={true}
                                        isClearable={false}
                                        styles={selectStyles}
                                    />
                                }
                            </div>

                            {newOrderModel.OriginDocumentCreate === 'transfers' &&
                                <>
                                    {/*NUMERO DE DOCUMENTO PARA REVERSA:*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">No. Doc Recuperar</span>
                                        </div>
                                        <input type=" text" placeholder="Documentos pendientes CEDIS" className="form-control "
                                            disabled={true}
                                            onKeyDown={(eve) => {
                                                if (eve.key === 'Enter') { this.OpenTransfers() }
                                            }}
                                            value={newOrderModel?.DocNumCEDIS ?? ''}
                                            onChange={event => this.ChangeDocNumCEDIS(event.target.value)}
                                        />

                                        <button type="button"
                                            className="input-group-text"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                                            onClick={() => this.OpenTransfers()}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>

                                    </div>

                                    {/*>almacen de entrada CEDIS*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Almacén de entrada</span>
                                        </div>
                                        <input
                                            type=" text"
                                            placeholder="Almacén Recepcion CEDIS"
                                            className="form-control "
                                            // style={{ backgroundColor: 'transparent', color: '#000', paddingTop: 1, paddingBottom: 2, maxWidth: 800 }}
                                            disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                                            onKeyPress={(eve) => {
                                                if (eve.key === 'Enter') {
                                                    this.openAlmacen(null, 117);
                                                }
                                            }}
                                            value={newOrderModel.WarehouseCEDIS ?? ''}
                                            onChange={event => this.ChangeAlmacenRecepCEDIS(event)}
                                        />

                                        <button type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28', paddingTop: 2, paddingBottom: 2 }}
                                            className="input-group-text"
                                            disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                                            onClick={() => this.openAlmacen(null, 117)}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                </>
                            }
                        </>
                    }
                    {(view === 'invoiceBorrador' && newOrderModel.ObjType === "67" && newOrderModel.U_FMB_EditTraslado === 'N' && newOrderModel.SendRequestEdition !== 'Y') && <div className="input-group mb-3">
                        <div className="input-group-prepend">
                        </div>
                        <button
                            type="button"
                            className="btn botonCorrect text-black input-group-text"
                            style={{ width: '100%' }}
                            onClick={() => requestPartialEdit()}>
                            <i className="fa fa-pen-to-square" aria-hidden="true" />
                            &nbsp;
                            Solicitar edición parcial
                        </button>
                    </div>}
                    {(scopCodeIn.includes(view) || isDraftOWTQ) &&
                        (
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                        <span className="d-none d-xl-inline">Tipo de salida del documento</span>
                                        <span className="d-inline d-xl-none">Tipo salida</span>
                                    </span>
                                </div>
                                <Select
                                    options={opcionesTipoSalida}
                                    value={
                                        opcionesTipoSalida.find(
                                            option =>
                                                String(option.value) ===
                                                String(newOrderModel?.U_BPP_MDTS ?? '')
                                        ) || null
                                    }
                                    onChange={(selectedOption) =>
                                        this.change_U_BPP_MDTS(selectedOption)
                                    }
                                    placeholder="-Selecciona-"
                                    isSearchable={true}
                                    isClearable={false}
                                    isDisabled={action === 2 && !editMode}
                                    styles={selectStyles}
                                />
                            </div>
                        )
                    }
                    {(scopCodeIn.includes(view) || isDraftOWTQ) &&
                        (
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold">
                                        <span className="d-none d-xl-inline">Codigo Motivo Traslado</span>
                                        <span className="d-inline d-xl-none">Motivo</span>
                                    </span>
                                </div>
                                <Select
                                    options={opcionesMotivoTraslado}
                                    value={
                                        opcionesMotivoTraslado.find(
                                            option =>
                                                String(option.value) ===
                                                String(
                                                    newOrderModel?.U_STR_FE_GRE_CodigoMotivoTraslado ?? ''
                                                )
                                        ) || null
                                    }
                                    onChange={(selectedOption) =>
                                        this.change_U_STR_FE_GRE_CodigoMotivoTraslado(selectedOption)
                                    }
                                    placeholder="-Selecciona-"
                                    isSearchable={true}
                                    isClearable={false}
                                    isDisabled={action === 2 && !editMode}
                                    styles={selectStyles}
                                />
                            </div>
                        )
                    }

                    {/* SCOP */}
                    {(scopCodeIn.includes(view) || isDraftOWTQ) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">Código SCOP</span>
                            </div>
                            <input
                                type="text"
                                maxLength="11"
                                className="form-control"
                                id="txtScop"
                                disabled={action === 2 && !editMode}
                                value={newOrderModel?.U_FMB_SCOP_CODE ?? ""}
                                onChange={this.changeScopCode}
                                onKeyPress={(eve) => {
                                    if (eve.key === 'Enter') {
                                        this.props.scoopTools.checkScoop()
                                    }
                                }}
                            />
                            {(action === 1 || (action === 2 && editMode)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.props.scoopTools.checkScoop}>
                                    <i className="fa fa-cloud" aria-hidden="true" />
                                </button>
                            )}
                        </div>
                    )}
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*No Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtDocumentDate"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*N°:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtNo"
                            disabled="true"
                            value={isDraftOWTQ && newOrderModel.DocNum && newOrderModel.DocEntry ? `${newOrderModel.DocNum}-${newOrderModel.DocEntry}` : newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Contabilización</span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={action == 2 ? 'date' : 'date'}
                            // disabled={action == 2 ? true : false}
                            disabled={(Number(action) === 2 && !isDraftOWTQ) || (Number(action) === 2 && !editMode && isDraftOWTQ) ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                            onChange={this.selectDocDate}
                        />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}

                            disabled={action == 2}
                            className=" form-control"
                            id="txtStatus"
                            max='9999-12-31'
                            autoComplete="off"
                            value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
                            onChange={this.selectDocDueDate}
                        />
                    </div>
                    {/*>almacen origen:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">De Almacén</span>
                        </div>
                        <input
                            type="text"
                            placeholder="Almacén origen"
                            className="form-control"
                            disabled
                            onKeyPress={({ key }) => { if (key === 'Enter') { this.openAlmacen(null, 2); } }}
                            value={newOrderModel.Filler ? newOrderModel.Filler : ''}
                        // onChange={event => this.changeAlmacenOrigen(event)} // Isra pidio que el almacen de origen no se pueda cambiar
                        />
                        {(action === 1 /*&& ((!newOrderModel.Filler || newOrderModel.Filler === "") || (!newOrderModel.Transit || newOrderModel.Transit === "")) && (Number(newOrderModel?.Transit || 0) !== 2)*/) && (<button type="button" // Solo mostrar si no se detecto el almacen de origen
                            style={{
                                backgroundColor: 'transparent',
                                color: '#EABF28',
                                paddingTop: 2,
                                paddingBottom: 2,
                            }}
                            className="input-group-text"
                            onClick={() => this.openAlmacen(null, 2)}>
                            <i className="fa fa-list" aria-hidden="true" />
                        </button>
                        )}
                    </div>
                    {/*>almacen Finall opcional:*/}
                    {/* {action == 1 && <div className="form-group row" id="div1">
                        <label htmlFor="txtDocumentDate" className="col-md-4 col-sm-12 col-form-label font-weight-bold">
                            Almacén Tránsito:
                        </label>
                        <div className="col-md-6 col-sm-12">
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtStatus"
                                disabled="true"
                                value={newOrderModel.wareHouseFinalOptionalValue ? newOrderModel.wareHouseFinalOptionalValue : ''}
                            />
                        </div>
                        {action == 1 && (
                            <button
                                type="button"
                                style={{
                                    backgroundColor: 'transparent',
                                    color: '#EABF28',
                                }}
                                className="btn "
                                onClick={() => this.openAlmacen(null, 4)}>
                                <i className="fa fa-list" aria-hidden="true"/>
                            </button>
                        )}
                    </div>} */}
                    {/*>almacen destino:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1"> Almacén Destino <ToolTip tips={[{ message: "Seleccione el almacén con el botón" }]} position="up" width="200" /> </span>
                        </div>
                        <input
                            type="text"
                            placeholder="Almacén destino"
                            className="form-control"
                            disabled
                            readOnly
                            // disabled={(action === 2 && !editMode) || (Number(newOrderModel?.Transit || 0) === 2)}
                            // onKeyPress={(eve) => {
                            //     if (eve.key === 'Enter') {
                            //         this.openAlmacen(null, 3);
                            //     }
                            // }}
                            value={newOrderModel.ToWhsCode ? newOrderModel.ToWhsCode : ''}
                        // onChange={event => this.changeAlmacenDestino(event)}
                        />
                        {(action === 1 && (Number(newOrderModel?.Transit || 0) !== 2)) && (<button type="button"
                            style={{
                                backgroundColor: 'transparent',
                                color: '#EABF28',
                                paddingTop: 2,
                                paddingBottom: 2,
                            }}
                            className="input-group-text"
                            onClick={() => this.openAlmacen(null, 3)}>
                            <i className="fa fa-list" aria-hidden="true" />
                        </button>
                        )}
                    </div>

                    {/* Lista de Precios: */}
                    {((view === 'transfers' || view === 'transfersRequest') || isDraftOWTQ) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Lista De Precios</span>
                            </div>
                            <select className="form-control" disabled={(action === 2 && !editMode) ? true : false}
                                onChange={action === 1 ? (event) => this.changeSelectedFieldDocument(event) : ''}
                                value={newOrderModel.GroupNum || -1} >

                                {prices?.map(price => {
                                    return (
                                        <option value={price.ListNum}>{price.ListName}</option>
                                    )
                                })}
                                <option value={-1}>Último precio de compra</option>
                                <option value={-2}>Último precio determinado</option>
                            </select>
                        </div>)}
                    {/* TRANSPORTE */}
                    {(newOrderModel?.Transit ?? '') === '1' &&
                        < div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Transporte</span>
                            </div>
                            <input type=" text" className="form-control"
                                readOnly
                                value={newOrderModel.U_FMB_BinLocationTr ? newOrderModel.U_FMB_BinLocationTr : ""}
                            />
                            <button type="button"
                                disabled={(action === 2 && !editMode) ? true : false}
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={this.searchLocations}>
                                <i className="fa fa-search" />
                            </button>
                        </div>
                    }
                </div>
            </div >
        );
    };
    //BODY DE CREACION DE TRASLADO
    renderDocumentTransfersBody = () => {
        const { newOrderModel, action, view, isDraftOWTQ = false } = this.props;
        const { editMode } = this.state;
        let { permissions } = newOrderModel;
        let uuids = newOrderModel.U_FMB_UUID_RELACIONADO ? newOrderModel.U_FMB_UUID_RELACIONADO : [];
        let relacionSAT = newOrderModel.U_FMB_TIPO_RELACION ? newOrderModel.U_FMB_TIPO_RELACION : [];
        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];
        const { invFLeft = [], invFRight = [] } = this.splitInHalf(newOrderModel?.invFields ?? [], false);
        const isOWTR = (view === "transfers" && !newOrderModel?.newView) || newOrderModel?.newView === "transfers";
        const { OWTRFieldsLeft = [], OWTRFieldsRight = [] } = this.splitInHalf(newOrderModel?.transferFields ?? [], false, 'transferFields');
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || Number(newOrderModel?.ObjType) === 67 || Number(newOrderModel?.ObjType) === 1250000001 || isDraftOWTQ;
        return (
            <div style={{ marginBottom: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-Contenido-T"
                            data-toggle="tab"
                            href="#dataContenido2"
                            role="tab"
                            aria-controls="dataContenido"
                            aria-selected="true">
                            Contenido
                        </a>
                        {view === 'transfers' &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary"}
                                id="nav-profile-tab-timbra"
                                data-toggle="tab"
                                href="#dataTimbra"
                                role="tab"
                                aria-controls="dataTimbra"
                                aria-selected="false">
                                Timbra-One
                            </a>}
                        {/*<a className="nav-item nav-link font-weight-bold text-secondary "
                           id="nav-profile-tab-Finanzas" data-toggle="tab" href="#dataFinanzas"
                           role="tabFin" aria-controls="dataFinanzas"
                           aria-selected="false">Finanzas</a>*/}
                        {Modules['InventoryFields'] && (newOrderModel.isTransferDocument) &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary"}
                                id="nav-profile-tab-InvFields"
                                data-toggle="tab"
                                href="#invFields"
                                role="tab"
                                aria-controls="invFields"
                                aria-selected="false">
                                Ramo
                            </a>
                        }
                        {newOrderModel?.isTransferDocument && <a
                            className={"nav-item nav-link font-weight-bold text-secondary"}
                            id="nav-profile-tab-logistica"
                            data-toggle="tab"
                            href="#dataLogistica"
                            role="tab"
                            aria-controls="dataLogistica"
                            aria-selected="false">
                            Logística
                        </a>}
                        {Modules['LiquidationFields'] && (isOWTRoOWTQ) &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary"}
                                id="nav-profile-tab-LiquidationFields"
                                data-toggle="tab"
                                href="#liquidationFields"
                                role="tab"
                                aria-controls="liquidationFields"
                                aria-selected="false">
                                Liquidación
                            </a>
                        }
                    </div>
                </nav>

                <div className="tab-content" style={{ textAlign: 'left' }}>
                    {/* Contenido */}
                    <div
                        className="w-100 table-scroll tab-pane fade show active"
                        id="dataContenido2"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 500 }}>
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                            <thead className="table-header-yellow">
                                <tr>
                                    <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Artículo
                                    </td>
                                    <td className="sticky-header" style={{ maxWidth: 200, textAlign: 'center', backgroundColor: '#d2ab24' }}>
                                        Descripción
                                    </td>
                                    {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && (
                                        <td className="sticky-header" style={{ minWidth: 115, backgroundColor: '#d2ab24' }}>
                                            Almacén
                                        </td>)
                                    }
                                    {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) &&
                                        <>
                                            <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}> Cant. Almacén Or </td>
                                            <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}> Cant. Almacén De </td>
                                        </>
                                    }

                                    {isOWTRoOWTQ && Modules.CostCenter && <>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            CANAL
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            SEDES
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            SUCURSAL
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            NEGOCIO
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            CECO
                                        </td>
                                    </>}

                                    {newOrderModel.isTransferDocument &&
                                        <>
                                            <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                                                UND Med.
                                            </td>
                                            <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>
                                                Cant. Galones
                                            </td>
                                            <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                                                Precio Galones
                                            </td>
                                            <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                                                Total Galones
                                            </td>
                                            <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>
                                                Densidad
                                            </td>
                                        </>
                                    }

                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', maxWidth: 80 }}>
                                        Cantidad
                                    </td>

                                    {/* view === 'transfersRequest' ||  */}
                                    {(view === 'transfers' || newOrderModel.OriginDocumentCreate === 'transfers') && (
                                        <>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}> DE ALMACÉN </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}> DE UBICACIONES </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}> ALMACÉN DESTINO </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}> A UBICACIONES </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}> PRIMERA UBICACIÓN DE DESTINO </td>
                                        </>
                                    )}

                                    {(view === 'transfers') &&
                                        <>
                                            <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}> Peso </td>
                                            <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}> Peso Total </td>
                                        </>
                                    }

                                    {(action == 2 || (action == 1 && (view === 'transfersRequest' || isDraftOWTQ)) || (action == 1 && view === 'transfers')) && (<td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Precio
                                    </td>)}
                                    {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && (
                                        <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                            Costo artículo
                                        </td>)
                                    }
                                    {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && (
                                        <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                            Código UMI
                                        </td>)
                                    }
                                    {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && (
                                        <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                            Cesion uso
                                        </td>)
                                    }
                                    {/* <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 1
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 2
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 3
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 4
                                    </td> */}
                                    {/* 
                                <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                    Total
                                </td> */}
                                    {/* CAMPOS DE USUARIO LINE */}
                                    {json.allItemsUserFields.map((field, index) => {
                                        if (field.enabled) {
                                            return (
                                                <td className="sticky-header" id={'userFields' + index} style={{ backgroundColor: '#d2ab24' }}>
                                                    {field.name}
                                                </td>
                                            );
                                        }
                                    })}
                                    <td
                                        className="sticky-header sticky-columns"
                                        style={{ backgroundColor: '#d2ab24' }}
                                    />
                                </tr>
                            </thead>
                            <tbody>
                                {newOrderModelItems.map((item, index) => {
                                    const whsOnHand = Array.isArray(item?.wareHouseStock) ? (item?.wareHouseStock?.find(({ WhsCode }) => WhsCode === newOrderModel?.Filler)?.OnHand || 0) : 0;
                                    const toWhsOnHand = Array.isArray(item?.wareHouseStock) ? (item?.wareHouseStock?.find(({ WhsCode }) => WhsCode === newOrderModel?.ToWhsCode)?.OnHand || 0) : 0;
                                    return (
                                        <tr style={{ color: item.stock ? 'black' : 'red' }}>
                                            <td className="sticky-column" style={{ backgroundColor: '#FFF' }}>
                                                {item.ItemCode}
                                            </td>
                                            {/*Artículos*/}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {item.ItemName}
                                            </td>
                                            {/*Almacen*/}
                                            {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && (
                                                <td style={{ textAlign: 'center' }}>
                                                    <div className='input-group'>
                                                        {/* {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && ( */}
                                                        <div className="input-group-append" >
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    border: "1px solid #ced4da"
                                                                }}
                                                                disabled={(action === 2 && !editMode) ? true : false}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.openAlmacen(index, 5, item.ItemCode)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                        {/* )} */}
                                                    </div>
                                                </td>)
                                            }

                                            {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) &&
                                                <>
                                                    <td>{/*Cantidad en Almacén Origen*/}
                                                        <input
                                                            type="text"
                                                            className="form-control text-center"
                                                            readOnly
                                                            value={formatNumber.new(whsOnHand || 0)} />
                                                    </td>
                                                    <td>{/*Cantidad en Almacén Destino*/}
                                                        <input
                                                            type="text"
                                                            className="form-control text-center"
                                                            readOnly
                                                            value={formatNumber.new(toWhsOnHand || 0)} />
                                                    </td>
                                                </>
                                            }
                                            {/*Descripción*/}
                                            {/*<td style={{textAlign: 'center'}}>
                                            {item.Filler}
                                            {action == 5 && (
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#EABF28',
                                                    }}
                                                    className="btn "
                                                    onClick={() => this.openAlmacen(index, 2)}>
                                                    <i className="fa fa-list" aria-hidden="true"/>
                                                </button>
                                            )}
                                        </td>
                                        <td style={{textAlign: 'center'}}>
                                            {item.ToWhsCode}
                                            {action == 5 && (
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#EABF28',
                                                    }}
                                                    className="btn "
                                                    onClick={() => this.openAlmacen(index, 3)}>
                                                    <i className="fa fa-list" aria-hidden="true"/>
                                                </button>
                                            )}
                                        </td>*/}

                                            {isOWTRoOWTQ && Modules.CostCenter && (<>
                                                {/* CANAL */}
                                                <td>
                                                    <div className="input-group" style={view === 'transfersRequest' ? { width: 270 } : {}}>
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={view === 'transfersRequest' && item.OcrCode && item.OcrName ? `${item.OcrCode} - ${item.OcrName}` : item.OcrCode || ''} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension1) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: '1px solid #ced4da'
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 1)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                {/* SEDES */}
                                                <td>
                                                    <div className="input-group" style={view === 'transfersRequest' ? { width: 270 } : {}}>
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={view === 'transfersRequest' && item.OcrCode2 && item.OcrName2 ? `${item.OcrCode2} - ${item.OcrName2}` : item.OcrCode2 || ''} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension2) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: '1px solid #ced4da'
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 2)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                {/* SUCURSAL */}
                                                <td>
                                                    <div className="input-group" style={view === 'transfersRequest' ? { width: 270 } : {}}>
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={view === 'transfersRequest' && item.OcrCode3 && item.OcrName3 ? `${item.OcrCode3} - ${item.OcrName3}` : item.OcrCode3 || ''} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension3) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: '1px solid #ced4da'
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 3)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                {/* NEGOCIO */}
                                                <td>
                                                    <div className="input-group" style={view === 'transfersRequest' ? { width: 270 } : {}}>
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={view === 'transfersRequest' && item.OcrCode4 && item.OcrName4 ? `${item.OcrCode4} - ${item.OcrName4}` : item.OcrCode4 || ''} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension4) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: '1px solid #ced4da'
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 4)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                {/* CECO */}
                                                <td>
                                                    <div className="input-group" style={view === 'transfersRequest' ? { width: 270 } : {}}>
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={view === 'transfersRequest' && item.OcrCode5 && item.OcrName5 ? `${item.OcrCode5} - ${item.OcrName5}` : item.OcrCode5 || ''} />

                                                        {((action === 1 || (action === 2 && editMode)) && !item.Dimension5) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: '1px solid #ced4da'
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => this.openCentroCoste(index, 5)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </>)}

                                            {newOrderModel.isTransferDocument &&
                                                <>
                                                    {/* UND Med. */}
                                                    {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                        this.emptyField()
                                                        :
                                                        <>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <select className="form-control"
                                                                    disabled={Number(action) !== 1}
                                                                    onChange={event =>
                                                                        (Number(action) === 1) &&
                                                                        this.changeUserUM(index, event)
                                                                    }
                                                                    value={item.U_RS_UMED || ''} >
                                                                    <option value={''}> {'Seleccionar'}</option>
                                                                    <option value={'KGM'}> {'Kilogramos'}</option>
                                                                    <option value={'GLN'}> {'Galones'}</option>
                                                                </select>
                                                            </td>
                                                        </>
                                                    }
                                                    {/* Cant. Galones */}
                                                    {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                        this.emptyField()
                                                        :
                                                        <>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input
                                                                    type="text"
                                                                    id={`CANTG-${index}`}
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={(item.U_RS_UMED !== 'GLN' || (Number(action) !== 1))}
                                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                    value={item.U_RS_CANTG || ''}
                                                                    onChange={event =>
                                                                        item.U_RS_UMED === 'GLN' &&
                                                                        Number(action) === 1 &&
                                                                        this.changeGalonesCant(index, event)
                                                                    }
                                                                    onBlur={event =>
                                                                        item.U_RS_UMED === 'GLN' &&
                                                                        Number(action) === 1 &&
                                                                        this.changeQuantityBlur(index, event, 'U_RS_CANTG')
                                                                    }
                                                                />
                                                            </td>
                                                        </>
                                                    }
                                                    {/* Precio Galones */}
                                                    {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                        this.emptyField()
                                                        :
                                                        <>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input
                                                                    type="text"
                                                                    id={`PRECIOGL-${index}`}
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={true} readOnly={true}
                                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                    value={item.U_RS_PRECIOGL || ''}
                                                                />
                                                            </td>
                                                        </>
                                                    }
                                                    {/* Total Galones */}
                                                    {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                        this.emptyField()
                                                        :
                                                        <>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input
                                                                    type="text"
                                                                    id={`TOTALGL-${index}`}
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={true} readOnly={true}
                                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                    value={item.U_RS_TOTALGL || ''}
                                                                />
                                                            </td>
                                                        </>
                                                    }
                                                    {/* Densidad */}
                                                    {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                        this.emptyField()
                                                        :
                                                        <>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input
                                                                    type="text"
                                                                    id={`DENS-${index}`}
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={true} readOnly={true}
                                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                    value={item.U_RS_DENS || ''}
                                                                />
                                                            </td>
                                                        </>
                                                    }
                                                </>
                                            }
                                            {/* CANTIDAD */}
                                            {!newOrderModel?.CEDIS_Reception ?
                                                <td>
                                                    <input
                                                        type=" text"
                                                        // style={{ maxWidth: 60 }}
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        // Version 1
                                                        // disabled={newOrderModel.U_FMB_EditTraslado === 'Y' ? false : action == 2 ? true : false}
                                                        // Version 2
                                                        disabled={newOrderModel.isTransferDocument && item.Gallons ? true : newOrderModel.U_FMB_EditTraslado === 'Y' ? false : (action === 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : false}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            // maxWidth: 80
                                                            width: 100
                                                        }}
                                                        id={'itemCantidad' + index}
                                                        value={item.Quantity}
                                                        onChange={event => this.changeQuantityItem(event, index)}
                                                    // onBlur={event => this.specialPrice(index)}
                                                    />
                                                </td>
                                                :
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 200 }}>
                                                    {item.Quantity}
                                                </td>
                                            }
                                            {/* view === 'transfersRequest' ||  */}
                                            {(view === 'transfers' || newOrderModel.OriginDocumentCreate === 'transfers') && (
                                                <>
                                                    <td style={{ textAlign: 'center' }}>{item.Filler}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        {item.FromLocationAssignment.length > 0 && <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                                border: "1px solid #ced4da"
                                                            }}
                                                            className="btn btn-outline-secondary mr-3"
                                                            onClick={() => this.showLocationAssignment(item.LineNum, 1)}>
                                                            <i className="fa fa-list" aria-hidden="true" />
                                                        </button>}
                                                        {item.Quantity}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>{item.ToWhsCode}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        {item.ToLocationAssignment.length > 0 && <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                                border: "1px solid #ced4da"
                                                            }}
                                                            className="btn btn-outline-secondary mr-3"
                                                            onClick={() => this.showLocationAssignment(item.LineNum, 2)}>
                                                            <i className="fa fa-list" aria-hidden="true" />
                                                        </button>}
                                                        {item.Quantity}
                                                    </td>
                                                    <td style={{ textAlign: 'left' }}>
                                                        {!!item.FirstBin && item.FirstBin !== '' &&
                                                            <>
                                                                {action === 2 && (<button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary mr-3"
                                                                    onClick={() => this.showDocumentStock(item.LineNum)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>)}
                                                                {item.FirstBin}
                                                            </>
                                                        }
                                                    </td>
                                                </>
                                            )}

                                            {(view === 'transfers') &&
                                                <>
                                                    <td>{/*Peso*/}
                                                        <input
                                                            type="text"
                                                            className="form-control text-center"
                                                            readOnly
                                                            value={formatNumber.new(item.Weight || 0, '', 3)} />
                                                    </td>
                                                    <td>{/*Peso total*/}
                                                        <input
                                                            type="text"
                                                            className="form-control text-center"
                                                            readOnly
                                                            value={formatNumber.new(Number(item.Weight || 0) * Number(item.Quantity || 0), '', 3)} />
                                                    </td>
                                                </>
                                            }
                                            {/*Precio*/}
                                            {!newOrderModel?.CEDIS_Reception ?
                                                (action == 2 || (action == 1 && (view === 'transfersRequest' || isDraftOWTQ)) || (action == 1 && view === 'transfers')) && (<td style={{ width: 130 }}>
                                                    <input
                                                        type=" text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        //disabled={(action == 2 ) ? true : !permissions.editItems}
                                                        disabled={true}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: Number(item.Price) === 0 ? 'red' : '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            width: 130,
                                                            textAlign: 'right',
                                                        }}
                                                        id={'itemCantidad' + index}
                                                        value={CURRENCY + formatNumber.new(item.Price)}
                                                        onChange={event => this.changePriceItem(event, index)}
                                                        onBlur={event => this.validatePriceNull(index)}
                                                    />
                                                </td>)
                                                :
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', width: 130, maxWidth: 200 }}>
                                                    {CURRENCY + formatNumber.new(item.Price)}
                                                </td>
                                            }
                                            {/* Costo del artículo */}
                                            {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && (
                                                <td style={{ textAlign: 'right' }}>
                                                    {CURRENCY + " " + formatNumber.new(item.AvgPrice)}
                                                    {/* {newOrderModel.DocCur + " " + formatNumber.new(item.AvgPrice)} */}
                                                </td>)
                                            }
                                            {/*Código UMI*/}
                                            {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && (
                                                <td style={{ textAlign: 'center' }}>
                                                    {item.InvntryUom || ''}
                                                </td>)
                                            }
                                            {/*CESION USO*/}
                                            {(view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ) && (
                                                <td style={{ textAlign: 'center' }}>
                                                    {item.MovimientoDiario || '0'}
                                                </td>)
                                            }
                                            {/*Centros de costos*/}
                                            {/* <td>
                                                {item.OcrCode}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 1)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode2}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode3}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 3)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode4}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 4)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td> */}
                                            {/* CAMPOS DE USUARIO LINE */}
                                            {json.allItemsUserFields.map((field, indexField) => {

                                                if (field.enabled) {
                                                    return (
                                                        <td style={{ textAlign: 'right' }}>
                                                            {(
                                                                Number(field.fieldType) === 1 ?
                                                                    <input
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            borderColor: '#ced4da',
                                                                            color: '#000',
                                                                            paddingTop: 1,
                                                                            paddingBottom: 2,
                                                                            minWidth: 100,
                                                                            textAlign: "center",
                                                                        }}
                                                                        className="form-control"
                                                                        type="text"
                                                                        id={'inputUserField' + 1}
                                                                        disabled={(Number(action) === 2 && !editMode) || (field.fieldId === isCilindrosVaciosDevueltos && Granel?.includes(Number(newOrderModel.Items[index].ItmsGrpCod))) ? true : false}
                                                                        value={field.name == 'Precio x kilo' ? (this.returnValueItem(field.IdValue, index) || item.PrecioKilo) : this.returnValueItem(field.IdValue, index)}
                                                                        onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}


                                                                    /> :
                                                                    <select
                                                                        className="form-control"
                                                                        id={'selectUserField' + 1}
                                                                        disabled={((Number(action) === 2 && !editMode) || (field.fieldId === isTipoConvenio && Number(newOrderModel.Items[index].UserFieldsItem.userFields1 || 0) !== 2)) || ((field.fieldId === isEntregaCilindro || field.fieldId === isTipoConvenio) && Granel?.includes(Number(newOrderModel.Items[index].ItmsGrpCod))) ? true : false}
                                                                        value={this.returnValueItem(field.IdValue, index)}
                                                                        onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}
                                                                    >
                                                                        {field.options.map((option) => {
                                                                            if (option.FldValue != null) {
                                                                                return (
                                                                                    <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }

                                                                        })}
                                                                    </select>
                                                            )}
                                                        </td>
                                                    );
                                                } else {
                                                    return (<></>)
                                                }
                                            })}

                                            {/*Eliminar*/}

                                            <td
                                                className="sticky-columns"
                                                style={{ backgroundColor: '#FFF', textAlign: 'center' }}>


                                                {action == 1 && !newOrderModel?.CEDIS_Reception && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: '#c42222',
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.deleteItem(index)}>
                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                    </button>
                                                )}
                                            </td>
                                            {' '}

                                        </tr>
                                    );
                                })}
                                {!newOrderModel?.CEDIS_Reception &&
                                    <tr> {/*Eliminar*/}
                                        <td
                                            className="sticky-column"
                                            style={{ backgroundColor: '#FFF', textAlign: 'center' }}>

                                            {action == 1 && (
                                                <div>
                                                    < input
                                                        type=" text"
                                                        placeholder="Artículo"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        // disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                        }}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.openItems();
                                                            }
                                                        }}
                                                        value={newOrderModel.searchItem || ''}
                                                        onChange={event => this.changeSearchItem(event)}
                                                    // onBlur={event => this.specialPrice(index)}
                                                    />
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: 'green',
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openItems()}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>

                                                </div>

                                            )}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* TIMBRA-ONE */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="dataTimbra"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-timbra">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                {newOrderModel.U_UDF_UUID && <div >
                                    <div>
                                        <label className="btn float-left" onClick={() => this.DownloadDoc('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF</label>
                                        <label className="btn float-left" onClick={() => this.DownloadDoc('XML')}><i className="fa fa-file-text"></i> Descargar XML</label>
                                    </div>
                                </div>}

                            </div>
                            <div className="col-12 col-md-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">UUID</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtUDF_UUID"
                                        disabled="true"
                                        value={newOrderModel.U_UDF_UUID || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Sello digital</span>
                                            <span className="d-inline d-xl-none">Sello dig.</span>
                                        </span>
                                    </div>
                                    <textarea
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_SELLO"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_SELLO || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Folio digital</span>
                                            <span className="d-inline d-xl-none">Folio dig.</span>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_FOLIO"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_FOLIO || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Serie digital</span>
                                            <span className="d-inline d-xl-none">Serie dig.</span>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_SERIE"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_SERIE || ''}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* INVENTORY FIELDS */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="invFields"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-InvFields">
                        <div className="row" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6">{this.renderSpecificFields(invFLeft, newOrderModel, action, editMode)}</div>
                            <div className="col-12 col-md-6">{this.renderSpecificFields(invFRight, newOrderModel, action, editMode)}</div>
                        </div>
                    </div>

                    {/* Logística */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="dataLogistica"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Logistica">
                        <div className="row" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6 col-lg-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Destino</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="txtShipToCode"
                                        disabled="true"
                                        value={newOrderModel.ShipToCode ? newOrderModel.ShipToCode : ''}
                                    />
                                    {Number(action) === 1 && (
                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="input-group-text"
                                            onClick={() => this.openAddresses(1)}>
                                            <i className="fas fa-list" />
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/*Segunda columna*/}
                        </div>
                    </div>

                    {/* LIQUIDATION FIELDS */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="liquidationFields"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-LiquidationFields">
                        <div className="row" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6">{this.renderSpecificFields(OWTRFieldsLeft, newOrderModel, action, editMode)}</div>
                            <div className="col-12 col-md-6">{this.renderSpecificFields(OWTRFieldsRight, newOrderModel, action, editMode)}</div>
                        </div>
                    </div>

                </div>
            </div>
        );
    };
    //FOOTER DE CREACION DE TRASLADO
    renderTransfersFooter = () => {
        const { newOrderModel, action, view, isDraftOWTQ = false } = this.props;
        const { editMode } = this.state;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*Empleado de ventas:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Empleado ventas</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtSlpName"
                            disabled="true"
                            value={newOrderModel.SlpName ? newOrderModel.SlpName : ''}
                        />
                        {(Number(action === 1) || (Number(action) === 2 && editMode && isDraftOWTQ)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openEmployee}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control"
                            id="txtComments"
                            placeholder="50 caracteres máximo"
                            maxLength={51}
                            disabled={(action === 2 && !editMode) ? true : false}
                            value={newOrderModel.JrnlMemo ? newOrderModel.JrnlMemo : ''}
                            onChange={this.changeCommentsMemo}
                        // style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                </div>
                {/*Segunda columna*/}
                <div className="col-sm" style={{ paddingRight: 0 }}>
                    {newOrderModel.OriginDocumentCreate === "transfers" &&
                        <div className="input-group mb-3"> {/* Peso Total */}
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Peso Total </span>
                            </div>
                            <input
                                className="form-control text-right"
                                readOnly
                                value={formatNumber.new(newOrderModel.WeightTotal || 0, '', 3)} />
                        </div>
                    }
                    {/*Comentarios:*/}

                    {(view == 'transfersRequest' || newOrderModel.ObjType == '1250000001') && false &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Obs. de Empaque</span>
                            </div>
                            <input
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtComments"
                                //maxLength={10}
                                //----------------
                                disabled={action == 2}
                                value={newOrderModel.PickRmrk ? newOrderModel.PickRmrk : ''}
                                onChange={this.changePickMmrk}
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            />
                        </div>}

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={(action === 2 && !editMode) ? true : false}
                            value={newOrderModel.Comments ? newOrderModel.Comments : ''}
                            onChange={this.changeComments}
                        // style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    //HEADER PAGOS
    renderDocumentsPagosHeader = () => {
        return <FactoryHeader
            type={'HEAD'}
            props={this.props}
            state={this.state}
            openProjects={this.openProjects}
            openPartner={this.openPartner}
            changeCardCode={this.changeCardCode}
            changeAddress={this.changeAddress}
            openPersonContact={this.openPersonContact}
            openConfirmCurrency={this.openConfirmCurrency}
            openCurrency={this.openCurrency}
            openCuentaMayor={this.openCuentaMayor}
            selectTrsfrDate={this.selectTrsfrDate}
            changeTransfersRef={this.changeTransfersRef}
            changeTrsfrSum={this.changeTrsfrSum}
            validateTrsfrSumNull={this.validateTrsfrSumNull}
            openCheckList={this.openCheckList}
            changeCashSumEnter={this.changeCashSumEnter}
            changeCashSum={this.changeCashSum}
            validateCashSumNull={this.validateCashSumNull}
            selectTabCard={this.selectTabCard}
            addCreditCard={this.addCreditCard}
            openCard={this.openCard}
            validateCardNum={this.validateCardNum}
            changeCardNum={this.changeCardNum}
            changeCardValid={this.changeCardValid}
            ChangeValidateValidCard={this.ChangeValidateValidCard}
            changeOwnerIdNum={this.changeOwnerIdNum}
            changeOwnerPhone={this.changeOwnerPhone}
            keydownHandler={this.keydownHandler}
            changeCreditSum={this.changeCreditSum}
            changeVoucherNum={this.changeVoucherNum}
            changeCreditType={this.changeCreditType}
            changeCreditSumOne={this.changeCreditSumOne}
            openSeries={this.openSeries}
            selectDocDate={this.selectDocDate}
            selectDocDueDate={this.selectDocDueDate}
            changeCounterRef={this.changeCounterRef}
            refreshModel={this.refreshModel}
            changeCFW={this.changeCFW}
        />

    };
    //BODY PAGOS
    renderDocumentsPagosItems = checkbox => {
        const { newOrderModel, action, view } = this.props;
        const { editMode } = this.state;
        let uuids = newOrderModel.U_FMB_UUID_RELACIONADO ? newOrderModel.U_FMB_UUID_RELACIONADO : [];
        //item.saldoVencido
        let newOrderModelItems = newOrderModel.ItemsPayments ? newOrderModel.ItemsPayments : [];
        let { permissions } = newOrderModel;
        const isAccountPayment = newOrderModel?.isAccountPayment;
        return (


            <div style={{ marginBottom: 30 }}>
                {/* Pestañas del body */}
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                        {!isAccountPayment &&
                            <>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                    id="nav-profile-tab-timbra"
                                    data-toggle="tab"
                                    href="#dataTimbra"
                                    role="tab"
                                    aria-controls="dataTimbra"
                                    aria-selected="false">
                                    Timbra-One
                                </a>
                                {(view && view === 'payment') &&
                                    <a
                                        className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                                        id="nav-profile-tab-XML"
                                        data-toggle="tab"
                                        href="#dataXML"
                                        role="tab"
                                        aria-controls="dataXML"
                                        aria-selected="false"
                                    >
                                        Datos XML
                                    </a>
                                }
                            </>
                        }
                    </div>
                </nav>

                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, paddingTop: 5 }}>
                        {isAccountPayment ?
                            <>
                                {/* INICIA TABLA DE PAGOS A CUENTA */}
                                <table
                                    id="dataTableDocuments"
                                    className="display"
                                    style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                    <thead className="table-header-yellow">
                                        <tr>
                                            <td style={{ textAlign: 'center' }}>Cuenta de mayor</td>
                                            <td style={{ textAlign: 'center' }}>Nombre de cuenta</td>
                                            <td style={{ textAlign: 'center' }}>Comentarios documento</td>
                                            <td style={{ textAlign: 'center' }}>Importe</td>
                                            {Modules.CostCenter && <>
                                                <td style={{ textAlign: 'center', minWidth: 150, }}>
                                                    CANAL
                                                </td>
                                                <td style={{ textAlign: 'center', minWidth: 150, }}>
                                                    SEDES
                                                </td>
                                                <td style={{ textAlign: 'center', minWidth: 150, }}>
                                                    SUCURSAL
                                                </td>
                                                <td style={{ textAlign: 'center', minWidth: 150, }}>
                                                    NEGOCIO
                                                </td>
                                                {/* <td style={{ textAlign: 'center', minWidth: 150, }}>
                                                    CECO
                                                </td> */}
                                            </>}
                                            <td
                                                className="sticky-header sticky-columns"
                                                style={{ backgroundColor: '#d2ab24' }}
                                            />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {newOrderModelItems.map((item, index) => {
                                            return (
                                                <tr>
                                                    {/* Cuenta de mayor */}
                                                    <td>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item.AcctCode || ""} />

                                                            {/* {(action === 1 || (action === 2 && editMode)) && ( */}
                                                            {action === 1 && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => this.openAccountListPaymentAct(index)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    {/* Nombre de cuenta */}
                                                    <td style={{ textAlign: 'center' }}>{item.AcctName}</td>
                                                    {/* Comentarios documento */}
                                                    <td style={{ textAlign: 'center', minWidth: '120px' }}>
                                                        <input
                                                            className="form-control"
                                                            disabled={action !== 1 || (action === 1 && !item.AcctCode) ? true : false}
                                                            type="text"
                                                            onChange={(event) => action === 1 && item.AcctCode && this.changeAccountPaymentComment(event, index)}
                                                            value={item.Descrip || ''}
                                                            maxlength={250}
                                                        />
                                                    </td>
                                                    {/* Importe */}
                                                    <td style={{ textAlign: 'right' }}>
                                                        {action === 1 ?
                                                            <div className='input-group' style={{ width: 200 }}>
                                                                <span className="input-group-text left font-weight-bold"> {item.DocCur || ''} </span>
                                                                <input
                                                                    className="form-control text-right"
                                                                    id={'itemPrice' + index}
                                                                    disabled={action !== 1 || (action === 1 && !item.AcctCode) ? true : false}
                                                                    value={item.PriceFormat || formatNumber.new(item.Price)}
                                                                    onChange={(event) => action === 1 && item.AcctCode && this.changePriceItem(event, index)}
                                                                    onBlur={() => this.validatePaymentPriceNull(index)}
                                                                />
                                                            </div>
                                                            :
                                                            <label
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    borderColor: '#ced4da',
                                                                    color: '#000',
                                                                    paddingTop: 1,
                                                                    paddingBottom: 2,
                                                                    width: 130,
                                                                    textAlign: 'right',
                                                                }}>
                                                                {(newOrderModel.DocCur || '') + " " + formatNumber.new(item.Price)}
                                                            </label>
                                                        }
                                                    </td>
                                                    {Modules.CostCenter && <>
                                                        <td>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode || ""} />

                                                                {/* {(action === 1 || (action === 2 && editMode)) && ( */}
                                                                {action === 1 && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => this.openCentroCoste(index, 1)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode2 || ""} />

                                                                {/* {(action === 1 || (action === 2 && editMode)) && ( */}
                                                                {action === 1 && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => this.openCentroCoste(index, 2)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode3 || ""} />

                                                                {/* {(action === 1 || (action === 2 && editMode)) && ( */}
                                                                {action === 1 && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => this.openCentroCoste(index, 3)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode4 || ""} />

                                                                {/* {(action === 1 || (action === 2 && editMode)) && ( */}
                                                                {action === 1 && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => this.openCentroCoste(index, 4)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        {/* <td>
                                                            <div className="input-group">
                                                                <input
                                                                    className="form-control"
                                                                    disabled
                                                                    readOnly
                                                                    value={item.OcrCode5 || ""} />

                                                                // {(action === 1 || (action === 2 && editMode)) && (
                                                                {action === 1 && (
                                                                    <div className="input-group-append" >
                                                                        <button
                                                                            type="button"
                                                                            style={{
                                                                                backgroundColor: 'transparent',
                                                                                color: '#EABF28',
                                                                                paddingTop: 2,
                                                                                paddingBottom: 2,
                                                                                border: "1px solid #ced4da"
                                                                            }}
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => this.openCentroCoste(index, 5)}>
                                                                            <i className="fa fa-list" aria-hidden="true" />
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td> */}
                                                    </>}
                                                    <td
                                                        className="sticky-columns"
                                                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                        {/*Eliminar*/}
                                                        {Number(action) === 1 && (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    padding: 5,
                                                                    color: '#c42222',
                                                                }}
                                                                className="btn"
                                                                onClick={() => this.deleteInvoicePayment(index)}>
                                                                <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                            </button>
                                                        )}
                                                    </td>

                                                </tr>
                                            );
                                        })}
                                        <tr>
                                            <td
                                                className="sticky-column"
                                                style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                {Number(action) === 1 && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: 'green',
                                                        }}
                                                        className="btn"
                                                        onClick={this.addAccountPaymentLine}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                {/* TERMINA TABLA DE PAGOS A CUENTA */}
                            </>
                            :
                            <>
                                <table
                                    id="dataTableDocuments"
                                    className="display"
                                    style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                    <thead className="table-header-yellow">
                                        <tr>
                                            <td className="sticky-columns">N° documento</td>
                                            <td style={{ textAlign: 'center' }}>No.Ref.de. cliente</td>
                                            <td style={{ textAlign: 'center' }}>Clase de Documento</td>
                                            <td style={{ textAlign: 'center' }}>Fecha</td>
                                            <td style={{ textAlign: 'center' }}>Días de atraso</td>
                                            <td style={{ textAlign: 'center' }}>Total</td>
                                            {newOrderModel?.RetencionVista && <td style={{ textAlign: 'center' }}>WIpte.retención</td>}
                                            <td style={{ textAlign: 'center' }}><div className="d-flex"> Total Pronto Pago <ToolTip tips={[{ message: `${FORMAT_NUMBER.new(newOrderModel.U_FMB_DescPP || 0)} %` }]} width="200" /> </div></td>
                                            <td style={{ textAlign: 'center' }}>saldo vencido</td>
                                            <td style={{ textAlign: 'center' }}>Pago Total</td>
                                            <td style={{ textAlign: 'center' }}>Importe Percepción</td>
                                            <td style={{ textAlign: 'center' }}>Parcialidad</td>
                                            {/* <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 1
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 2
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 3
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 4
                                    </td> */}
                                            <td
                                                className="sticky-header sticky-columns"
                                                style={{ backgroundColor: '#d2ab24' }}
                                            />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {newOrderModelItems.map((item, index) => {
                                            let fecha = moment(item.RefDate).utc().format('DD-MM-YYYY');
                                            return (
                                                <tr>

                                                    <td className="sticky-columns">{item.DocNum}</td>
                                                    <td style={{ textAlign: 'center' }}>{item.NumAtCard ?? ''}</td>
                                                    {/* <td style={{ textAlign: 'center' }}>{item.docType == '13' ? item.DocSubType == '--' ? 'Factura' : 'Nota de Débito' : item.docType == '14' ? item.DocSubType == '--' ? 'Nota de Crédito' : '' : 'Factura de Proveedores'}</td> */}
                                                    <td style={{ textAlign: 'center' }}>{this.getInvType(item)}</td>
                                                    <td style={{ textAlign: 'center' }}>{fecha}</td>
                                                    <td style={{ textAlign: 'center' }}>{item.daysLast}</td>
                                                    {newOrderModel?.RetencionVista ?
                                                        <>
                                                            {item.U_LLG_RETENCI === 'Y' ?
                                                                <>
                                                                    <td style={{ textAlign: 'right' }}>{CURRENCY + formatNumber.new(item.totalO ? item.totalO : '')}</td>
                                                                    <td style={{ textAlign: 'right' }}>{CURRENCY + formatNumber.new(item.WitholdingTaxApplied ? item.WitholdingTaxApplied : '')}</td>
                                                                </>
                                                                :
                                                                <>
                                                                    <td style={{ textAlign: 'right' }}>{CURRENCY + formatNumber.new(item.total ? item.total : '')}</td>
                                                                    <td style={{ textAlign: 'right' }}>{CURRENCY + formatNumber.new('')}</td>
                                                                </>
                                                            }
                                                        </>
                                                        :
                                                        <td style={{ textAlign: 'right' }}>{CURRENCY + formatNumber.new(item.total ? item.total : '')/* + " " + (item.DocCur ? item.DocCur : '')*/}</td>
                                                    }
                                                    <td style={{ textAlign: 'right', color: Number(item.daysLast) > 0 ? "red" : "balck" }}>{CURRENCY} {formatNumber.new(Number(item.daysLast) > 0 ? (item.total || '') : (Number(item.total) - Number((Number(item.total) * Number(newOrderModel.U_FMB_DescPP) / 100).toFixed(2))))/* Total tras pronto pago */}</td>
                                                    <td style={{ textAlign: 'right' }}>{CURRENCY + formatNumber.new(item.pastDueBalance ? item.pastDueBalance : '')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <input
                                                            style={{
                                                                textAlign: 'right',
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#ced4da',
                                                                color: '#000',
                                                            }}
                                                            type="text"
                                                            className="form-control btn-outline-secondary"
                                                            id="txtDiscPrcnt"
                                                            disabled={(action == 2 && !editMode) ? true : (permissions ? !permissions.editDiscountLine : false)}
                                                            onChange={event => this.changeTotalInvoicePaynent(event, index)}
                                                            onBlur={() => this.validateTotalInvoicePaymentNull(index)}
                                                            value={item.totalPago || item.totalOutgoing}
                                                        />
                                                    </td>
                                                    {/* Importe Percepción */}
                                                    <td style={{ textAlign: 'right' }}>
                                                        <input
                                                            style={{
                                                                textAlign: 'right',
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#ced4da',
                                                                color: '#000',
                                                            }}
                                                            type="text"
                                                            className="form-control btn-outline-secondary"
                                                            id="txtPerception"
                                                            disabled={true}
                                                            readOnly={true}
                                                            value={`${CURRENCY ?? ''} ${formatNumber.new(item.U_PRC_IMP ?? 0)}`}
                                                        />
                                                    </td>
                                                    {/* Parcialidad */}
                                                    <td style={{ textAlign: 'right' }}>
                                                        <input
                                                            style={{
                                                                textAlign: 'right',
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#ced4da',
                                                                color: '#000',
                                                            }}
                                                            type="text"
                                                            className="form-control btn-outline-secondary"
                                                            id="txtParcialidad"
                                                            maxlength="4"
                                                            disabled={(action == 2 && !editMode) ? true : (permissions ? !permissions.editDiscountLine : false)}
                                                            onChange={event => this.changeParcialidadPayment(event, index)}
                                                            // onBlur={() => this.validateTotalInvoicePaymentNull(index)}
                                                            value={item.U_Parcialidad}
                                                        />
                                                    </td>
                                                    {/*Centros de costos*/}
                                                    {/* <td>
                                                {item.OcrCode}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 1)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode2}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode3}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 3)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode4}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 4)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td> */}
                                                    <td
                                                        className="sticky-columns"
                                                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                        {/*Eliminar*/}
                                                        {action == 1 && (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    padding: 5,
                                                                    color: '#c42222',
                                                                }}
                                                                className="btn"
                                                                onClick={() => this.deleteInvoicePayment(index)}>
                                                                <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                            </button>
                                                        )}
                                                    </td>

                                                </tr>
                                            );
                                        })}

                                        <tr>
                                            <td
                                                className="sticky-column"
                                                style={{ backgroundColor: '#FFF', textAlign: 'center' }}>

                                                {action == 1 && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: 'green',
                                                        }}
                                                        className="btn"
                                                        onClick={this.openInvoicePaymentList}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>


                                </table>
                            </>
                        }
                    </div>
                    {/* TIMBRA-ONE */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="dataTimbra"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-timbra">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">UUID Sustitución</span>
                                    </div>
                                    <div className="col-md-1" style={{ padding: 0, paddingTop: 2 }}>
                                        {(action === 1 || (action === 2 && editMode && permissions.editEmployee)) && <button
                                            type="button"
                                            className="btn"
                                            style={{ padding: 4 }}
                                            onClick={() => this.AddUuid()} >
                                            <i className="fa fa-plus-circle" aria-hidden="true" size="10"></i>
                                        </button>}
                                    </div>
                                </div>

                                {!!uuids && uuids.map((uuid, index) => {
                                    return (
                                        <div
                                            id={`uuidRel${index}`}
                                            className="input-group mb-3" >
                                            <div className="input-group-prepend cfdi-res">
                                                <span className="input-group-text font-weight-bold"> UUID {index + 1}</span>
                                            </div>
                                            <input
                                                type="text"
                                                maxLength="36"
                                                style={{ textAlign: 'right' }}
                                                className="form-control input-sm"
                                                value={uuid}
                                                onChange={(e) => this.HandleChange(e, index)} />
                                            <div className="col-md-1" style={{ padding: 0, paddingTop: 2 }}>
                                                {(action === 1 || (action === 2 && editMode && permissions.editEmployee)) && <button
                                                    type="button"
                                                    className="btn"
                                                    style={{ padding: 4 }}
                                                    onClick={() => this.RemoveUuid(index)} >
                                                    <i className="fa fa-minus-circle" aria-hidden="true" size="10"></i>
                                                </button>}
                                            </div>
                                        </div>
                                    )
                                })
                                }

                                {newOrderModel.U_UDF_UUID && <div >
                                    <div>
                                        <label className="btn float-left" onClick={() => this.DownloadDoc('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF</label>
                                        <label className="btn float-left" onClick={() => this.DownloadDoc('XML')}><i className="fa fa-file-text"></i> Descargar XML</label>
                                    </div>
                                </div>}

                                {newOrderModel.IsCancelCFDI === 'Y' && <div >
                                    <div>
                                        <label className="btn float-left" onClick={() => this.DownloadDocCancel('PDF')}><i className="fa fa-file-text-o"></i> Descargar PDF de solicitud de Cancelación</label>
                                        <label className="btn float-left" onClick={() => this.DownloadDocCancel('XML')}><i className="fa fa-file-text"></i> Descargar XML de solicitud de Cancelación</label>
                                    </div>
                                </div>}

                            </div>
                            <div className="col-12 col-md-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">UUID</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtUDF_UUID"
                                        disabled="true"
                                        value={newOrderModel.U_UDF_UUID || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Sello digital</span>
                                    </div>
                                    <textarea
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_SELLO"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_SELLO || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Folio digital</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_FOLIO"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_FOLIO || ''}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Serie digital</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        id="txtFMB_SERIE"
                                        disabled="true"
                                        value={newOrderModel.U_FMB_SERIE || ''}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* DATOS XML*/}
                    {(view && view === 'payment') &&
                        <div style={{ paddingTop: 5 }} className="tab-pane fade" id="dataXML" role="tabpanel" aria-labelledby="nav-home-tab-XML">
                            <DataXML
                                newOrderModel={newOrderModel}
                                enableSpinner={this.props.enableSpinner}
                                showAlert={this.props.showAlert}
                            />
                        </div>
                    }
                </div>
            </div>

            // <table
            //     id="dataTableDocumentsPagos"
            //     className="display"
            //     style={{width: '100%', marginTop: 10, marginBottom: 40}}>
            //     <thead className="table-header-yellow">
            //     <tr>
            //         <td className="sticky-columns">N° documento</td>
            //         <td style={{textAlign: 'center'}}>Clase de Documento</td>
            //         <td style={{textAlign: 'center'}}>Fecha</td>
            //         <td style={{textAlign: 'center'}}>Días de atraso</td>
            //         <td style={{textAlign: 'center'}}>Total</td>
            //         <td style={{textAlign: 'center'}}>saldo vencido</td>
            //         <td style={{textAlign: 'center'}}>Pago Total</td>
            //         <td
            //             className="sticky-header sticky-columns"
            //             style={{backgroundColor: '#d2ab24'}}
            //         />
            //     </tr>
            //     </thead>
            //     <tbody>


            //     {newOrderModelItems.map((item, index) => {
            //         let fecha = moment(item.RefDate).format('DD-MM-YYYY');
            //         return (
            //             <tr>

            //                 <td className="sticky-columns">{item.DocNum}</td>
            //                 <td style={{textAlign: 'center'}}>{item.docType == '13' ?   item.DocSubType == '--' ? 'Factura' : 'Nota de Débito' : item.docType == '14' ? item.DocSubType == '--' ? 'Nota de Crédito' : '' : ''}</td>
            //                 <td style={{textAlign: 'center'}}>{fecha}</td>
            //                 <td style={{textAlign: 'center'}}>{item.daysLast}</td>
            //                 <td style={{textAlign: 'right'}}>{CURRENCY + formatNumber.new(item.total ? item.total : '') + " " + (item.DocCur ? item.DocCur : '')}</td>
            //                 <td style={{textAlign: 'right'}}>{CURRENCY + formatNumber.new(item.pastDueBalance ? item.pastDueBalance : '')}</td>
            //                 <td style={{textAlign: 'right'}}>
            //                     <input
            //                         style={{
            //                             textAlign: 'right',
            //                             backgroundColor: 'transparent',
            //                             borderColor: '#ced4da',
            //                             color: '#000',
            //                         }}
            //                         type="text"
            //                         className="form-control btn-outline-secondary"
            //                         id="txtDiscPrcnt"
            //                         disabled={(action == 2 && !editMode) ? true : (permissions ? !permissions.editDiscountDocument : false)}
            //                         onChange={event => this.changeTotalInvoicePaynent(event, index)}
            //                         onBlur={() => this.validateTotalInvoicePaymentNull(index)}
            //                         value={item.totalPago}
            //                     />
            //                 </td>
            //                 <td
            //                     className="sticky-columns"
            //                     style={{backgroundColor: '#FFF', textAlign: 'center'}}>
            //                     {/*Eliminar*/}
            //                     {action == 1 && (
            //                         <button
            //                             type="button"
            //                             style={{
            //                                 backgroundColor: 'transparent',
            //                                 padding: 5,
            //                                 color: '#c42222',
            //                             }}
            //                             className="btn"
            //                             onClick={() => this.deleteInvoicePayment(index)}>
            //                             <i className="fas fa-trash-alt" aria-hidden="true" size="10"/>
            //                         </button>
            //                     )}
            //                 </td>

            //             </tr>
            //         );
            //     })}

            //     <tr>
            //         <td
            //             className="sticky-column"
            //             style={{backgroundColor: '#FFF', textAlign: 'center'}}>

            //             {action == 1 && (
            //                         <button
            //                             type="button"
            //                             style={{
            //                                 backgroundColor: 'transparent',
            //                                 padding: 5,
            //                                 color: 'green',
            //                             }}
            //                             className="btn"
            //                             onClick={this.openInvoicePaymentList}>
            //                             <i className="fa fa-plus-circle" aria-hidden="true" size="10"/>
            //                         </button>  
            //             )}
            //         </td>
            //     </tr>
            //     </tbody>
            // </table>
        );
    };
    //FOOTER PAGOS
    renderDocumentsPagosFooter = () => {
        const { newOrderModel, action } = this.props;
        const { editMode } = this.state;
        const isAccountPayment = newOrderModel?.isAccountPayment;
        return (
            <div className="row">

                <div className="col-12 col-md-6">
                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className=" form-control btn-outline-secondary styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={action == 2 && !editMode ? true : false}
                            value={newOrderModel.Comments ? newOrderModel.Comments : ''}
                            onChange={this.changeComments}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>

                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className=" form-control btn-outline-secondary styleTextarea"
                            id="txtComments"
                            placeholder="50 caracteres máximo"
                            maxLength={51}
                            disabled={action == 2 && !editMode ? true : false}
                            value={newOrderModel.JrnlMemo ? newOrderModel.JrnlMemo : ''}
                            onChange={this.changeCommentsMemo}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>

                    {/*cuenta asociada*/}
                    {!isAccountPayment &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Cuenta asociada</span>
                            </div>
                            <input
                                type="text"
                                className="form-control input-sm"
                                id="txtDocumentsOwnerName"
                                disabled="true"
                                value={newOrderModel.BpActFormatCode ? newOrderModel.BpActFormatCode + " - " + newOrderModel.BpActName : ''}
                            />
                            {action == 1 && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={() => this.openAccountListBpAct(1)}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>
                    }


                    {/*Total efectivo*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total Efectivo</span>
                        </div>
                        <input type="text" style={{ textAlign: "right" }} className="form-control" disabled="true"
                            value={(!isAccountPayment ? CURRENCY : newOrderModel.DocCur || '') + formatNumber.new(newOrderModel.CashSum ? newOrderModel.CashSum : '')} />

                    </div>
                    {/*Total cheque*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total Cheques</span>
                        </div>
                        <input type="text" style={{ textAlign: "right" }} className="form-control" disabled="true"
                            value={(!isAccountPayment ? CURRENCY : newOrderModel.DocCur || '') + formatNumber.new(newOrderModel.CheckSum ? newOrderModel.CheckSum : '')} />
                    </div>
                    {/*Total transferencia*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total Transferencia</span>
                        </div>
                        <input type="text" style={{ textAlign: "right" }} className="form-control" disabled="true"
                            value={(!isAccountPayment ? CURRENCY : newOrderModel.DocCur || '') + formatNumber.new(newOrderModel.TrsfrSum ? newOrderModel.TrsfrSum : '')} />
                    </div>
                    {/*Total tarjeta*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total Tarjeta</span>
                        </div>
                        <input type="text" style={{ textAlign: "right" }} className="form-control" disabled="true"
                            value={(!isAccountPayment ? CURRENCY : newOrderModel.DocCur || '') + formatNumber.new(newOrderModel.CreditSum ? newOrderModel.CreditSum : '')} />
                    </div>
                    {/*Total Recibido*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total Recibido</span>
                        </div>
                        <input type="text" style={{ textAlign: "right", fontWeight: "bold" }} className="form-control"
                            disabled="true"
                            value={(!isAccountPayment ? CURRENCY : newOrderModel.DocCur || '') + formatNumber.new(newOrderModel.totalRecibido ? newOrderModel.totalRecibido : '')/* + " " + (newOrderModel.DocCur ? newOrderModel.DocCur : '')*/} />
                    </div>

                </div>

                {/*Segunda columna*/}
                <div className="col-sm" style={{ paddingRight: 0 }}>
                    {/*Pago a ceunta*/}
                    {!isAccountPayment &&
                        <div className="input-group mb-3">
                            <input id="txtPagoCuenta" type="checkbox" checked={newOrderModel.PayNoDoc}
                                style={{ marginRight: 2 }}
                                disabled={action == 2 ? true : false} onChange={this.toggleCheckBoxPagoACuenta} />
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Pago a Cuenta</span>
                            </div>
                            <input
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtCustomer"
                                disabled={action == 1 ? !newOrderModel.PayNoDoc : true}
                                value={
                                    newOrderModel.NoDocSum
                                }
                                onChange={this.changePagoACuenta}
                                onBlur={this.validatePagoACuentaNull}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    textAlign: "right"
                                }}
                            />
                        </div>
                    }

                    {/* <div className="form-group row " id="div1">
                        <label
                            htmlFor="txtPagoCuenta"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">
                            <input id="txtPagoCuenta" type="checkbox" checked={newOrderModel.PayNoDoc}
                                   style={{marginRight: 2}}
                                   disabled={action == 2 ? true : false} onChange={this.toggleCheckBoxPagoACuenta}/>
                            Pago a Cuenta:
                        </label>
                        <div className="col-md-6 col-sm-12">
                            <input
                                type="text"
                                className=" form-control btn-outline-secondary"
                                id="txtCustomer"
                                disabled={action == 1 ? !newOrderModel.PayNoDoc : true}
                                value={
                                    newOrderModel.NoDocSum
                                }
                                onChange={this.changePagoACuenta}
                                onBlur={this.validatePagoACuentaNull}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    textAlign: "right"
                                }}
                            />
                        </div>
                    </div> */}

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total Saldo Vencido</span>
                        </div>
                        <input
                            type="text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            disabled="true"
                            value={
                                CURRENCY + formatNumber.new(newOrderModel.totalDocumento ? newOrderModel.totalDocumento : 0) + ' ' + newOrderModel.DocCurDocumentsPayment
                            }
                        />
                    </div>

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Pago Total</span>
                        </div>
                        <input
                            type="text"
                            style={{ textAlign: 'right' }}
                            className="form-control"
                            disabled="true"
                            value={
                                (!isAccountPayment ? CURRENCY : newOrderModel.DocCur || '') + formatNumber.new(newOrderModel.totalPago ? newOrderModel.totalPago : 0) /*+ ' ' + newOrderModel.DocCur*/
                            }
                        />
                    </div>

                    {action == 1 &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Restante</span>
                            </div>
                            <input
                                type="text"
                                style={{ textAlign: 'right' }}
                                className="form-control"
                                disabled="true"
                                value={
                                    (!isAccountPayment ? CURRENCY : newOrderModel.DocCur || '') + formatNumber.new(newOrderModel.totalRestante ? newOrderModel.totalRestante : "") /*+ ' ' + newOrderModel.DocCur*/
                                }
                            />
                        </div>}
                </div>
            </div>
        )

    };
    //HEADER ENTRADA DE MERCANCIA CASCOS
    renderHeaderSalesHelmets = () => {
        const { newOrderModel, action, view } = this.props;

        const { editMode, partners } = this.state;
        let { permissions } = newOrderModel;

        let clientCardCode = 'Cliente';
        let dateText = ' F. Entrega';
        let nota = 'Nota de Crédito';
        let entryExit = 'Entrada de Mercancía'

        if (newOrderModel.OriginDocumentCreate === 'ExitHelmets') {
            nota = 'Nota de Débito';
            entryExit = 'Salida de Mercancía'
        }


        return (
            <div className="row">

                {/*Primer columna*/}
                <div className="col-sm col">
                    {/*No del cliente*/}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Cliente</span>
                            </div>
                            <input type="text" className="form-control"
                                id="txtPartner"
                                style={{
                                    backgroundColor: newOrderModel.partnerSelected ? 'rgb(248,242,209)' : 'transparent',
                                }}
                                disabled={action == 2 && !editMode ? true : false}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.openPartner();
                                    }
                                }}

                                onChange={this.changeCardCode}
                                value={newOrderModel.CardCode ? newOrderModel.CardCode : ''} />
                            {action == 1 && (
                                <button
                                    type="button"
                                    className="input-group-text"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    onClick={this.openPartner}>
                                    <i className="fas fa-user fa-lg" />
                                </button>
                            )}
                        </div>)}

                    {/*Nombre del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input
                            type="text"
                            className="form-control "
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.CardName ? newOrderModel.CardName : ''}
                        />
                    </div>
                    {/*Contacto*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Contacto</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.CntctName ? newOrderModel.CntctName : ''}
                        />

                        {(action == 1 || (action == 2 && editMode)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPersonContact}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Número de referencia:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1"> No. Referencia</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control btn-outline-secondary"
                            id="txtCustomerRefNo"
                            disabled={action == 2 && !editMode ? true : false}
                            value={newOrderModel.NumAtCard ? newOrderModel.NumAtCard : ''}
                            onChange={this.changeNoReferencia}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                    {/*Moneda */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Moneda</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={newOrderModel.DocCur ? newOrderModel.DocCur : ''}
                        />

                        {(action == 1 || (action == 2 && editMode && permissions.editItems)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openCurrency}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Cambio */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cambio</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={newOrderModel.ChangeRate ? Number(newOrderModel.ChangeRate).toFixed(2) : 1}
                        />

                    </div>

                    <div className="tab-content" id="myTabContent" style={{ textAlign: 'left' }}>
                        <div
                            className="tab-pane fade show active "
                            id="transfersControl"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-One"><br />
                            <div className="card col-12 col-md-12" style={{ background: 'transparent' }}>
                                <div className="card-body">
                                    <h5 className="card-title" style={{ color: '#EABF28' }}>{nota}:</h5>
                                    {/*N° */}

                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                                        </div>
                                        <input
                                            type=" text"
                                            className=" form-control"
                                            id="txtNo"
                                            disabled="true"
                                            value={newOrderModel.NextFolio2 ? newOrderModel.NextFolio2 : ''}
                                        />
                                    </div>
                                    {/*No Serie*/}
                                    {((action === 1 || action === 2) && !editMode) && (
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                                            </div>
                                            <input
                                                type=" text"
                                                className=" form-control"
                                                id="txtDocumentDate"
                                                disabled="true"
                                                value={newOrderModel.SerieName2 ? newOrderModel.SerieName2 : ''}
                                            />
                                            {action == 1 && (
                                                <button
                                                    type="button"
                                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                    className="input-group-text"
                                                    onClick={this.openSeries2}>
                                                    <i className="fa fa-list" aria-hidden="true" />
                                                </button>

                                            )}
                                        </div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />

                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">

                    {/*Estado*/}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                            </div>
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtStatus"
                                disabled="true"
                                value={newOrderModel.StatusDocument ? newOrderModel.StatusDocument : ''}
                            />

                        </div>

                    )}
                    {/*Fecha de contabilización:*/}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline"> F. Contabilización</span>
                                    <span className="d-inline d-xl-none">F. Contab.</span>
                                </span>
                            </div>
                            <input
                                id="txtPostingDate"
                                style={{
                                    width: '100%',
                                    important: true,
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                }}
                                className="form-control"
                                type={action == 2 ? 'date' : 'date'}
                                disabled={action == 2 ? true : false}
                                placeholder="Fecha min"
                                autoComplete="off"
                                value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                                onChange={this.selectDocDate}
                            />

                        </div>)}
                    {/*Fecha de entrega:*/}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">{dateText}</span>
                            </div>
                            <input
                                id="txtDeliverDate"
                                style={{
                                    width: '100%',
                                    important: true,
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                }}
                                className="form-control"
                                type={action == 2 && !editMode ? 'date' : 'date'}
                                disabled={action == 2 && !editMode ? true : false}
                                placeholder="Fecha min"
                                autoComplete="off"
                                value={newOrderModel.DocDueDate ? newOrderModel.DocDueDate : ''}
                                onChange={this.selectDocDueDate}
                            />

                        </div>)}
                    {/*>Fecha de documento:*/}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                            </div>
                            <input
                                style={{
                                    width: '100%',
                                    important: true,
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                }}
                                type="date"
                                className="form-control"
                                id="txtStatus"
                                max='9999-12-31'
                                autoComplete="off"
                                disabled="true"
                                value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
                            />
                        </div>
                    )}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="form-group row" id="div1">
                            <div className="col-12" style={{ textAlign: 'center' }}>
                                {/* <label htmlFor="entrada de mercancía" className="col-form-label font-weight-bold" >
                                {entryExit}
                            </label> */}
                                <h5>{entryExit}</h5>
                            </div>
                        </div>)}
                    {/*N°:*/}
                    {((action === 1 || action === 2) && !editMode) && (

                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                            </div>
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtNo"
                                disabled="true"
                                value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                            />
                        </div>)}
                    {/*No Serie*/}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                            </div>
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtDocumentDate"
                                disabled="true"
                                value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                            />
                            {action == 1 && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openSeries}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>)}

                    {((action === 1 || action === 2) && !editMode && view === 'SalesHelmets') && (
                        <div className="form-group row" id="div1">
                            <div className="col-12" style={{ textAlign: 'center' }}>
                                {/* <label htmlFor="entrada de mercancía" className="col-form-label font-weight-bold" >
                                    {entryExit}
                                </label> */}
                                <h5>Serie Pago</h5>
                            </div>
                        </div>)}
                    {/*N°:*/}
                    {((action === 1 || action === 2) && !editMode && view === 'SalesHelmets') && (

                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                            </div>
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtNo"
                                disabled="true"
                                value={newOrderModel.NextFolio3 ? newOrderModel.NextFolio3 : ''}
                            />
                        </div>)}
                    {/*No Serie*/}
                    {((action === 1 || action === 2) && !editMode && view === 'SalesHelmets') && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                            </div>
                            <input
                                type=" text"
                                className=" form-control"
                                id="txtDocumentDate"
                                disabled="true"
                                value={newOrderModel.SerieName3 ? newOrderModel.SerieName3 : ''}
                            />
                            {action == 1 && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openSeriesPago}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>)}
                </div>
            </div>
        );
    };
    //BODY ENTRADA DE MERCANCIA CASCOS
    renderBodySalesHelmets = (item) => {
        const { newOrderModel, action, view } = this.props;
        const { editMode, size } = this.state;
        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];

        const deliveriesAddress = newOrderModel.deliveriesAddress || [];
        let { permissions } = newOrderModel;
        const { isSelectTo } = newOrderModel;
        var x = window.matchMedia("(max-width: 600px)")


        return (
            <div style={{ marginBottom: 30 }}>
                {/* Pestañas del body */}
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={"nav-item nav-link font-weight-bold text-secondary " + (!this.validatePartner() ? 'disabled' : '')}
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                    </div>
                </nav>

                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    <div
                        className="tab-pane fade"
                        id="dataFinanzas"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Fianazas">
                        <div className="form-group row" id="div1">
                            <label
                                htmlFor="txtContactPerson"
                                className="col-md-2 col-sm-12 col-form-label font-weight-bold"
                                style={{ paddingLeft: 30 }}>
                                Condición Pago:
                            </label>
                            <div className="col-md-3 col-sm-12" style={{ paddingLeft: 30 }}>
                                <input
                                    type=" text"
                                    className="form-control btn-outline-secondary"
                                    disabled={action == 2}
                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                    value={newOrderModel.GroupName ? newOrderModel.GroupName : ''}
                                />
                            </div>
                        </div>
                        <div className="form-group row" id="div1">
                            <label
                                htmlFor="txtContactPerson"
                                className="col-md-2 col-sm-12 col-form-label font-weight-bold"
                                style={{ paddingLeft: 30 }}>
                                Forma Pago:
                            </label>
                            <div className="col-md-3 col-sm-12" style={{ paddingLeft: 30 }}>
                                <input
                                    type=" text"
                                    className="form-control btn-outline-secondary"
                                    disabled={action == 2}
                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                    value={newOrderModel.PymName ? newOrderModel.PymName : ''}
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="dataLogistica"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Logistica">


                        <div className="form-group row" id="div1">
                            <label
                                htmlFor="txtContactPerson"
                                className="col-md-2 col-sm-12 col-form-label font-weight-bold"
                                style={{ paddingLeft: 30 }}>
                                Destino:
                            </label>
                            <div className="col-md-3 col-sm-12">
                                <input
                                    type="text"
                                    className="form-control input-sm"
                                    id="txtCustomer"
                                    disabled="true"
                                    value={newOrderModel.ShipToCode ? newOrderModel.ShipToCode : ''}
                                />
                            </div>
                            {(action == 1 || (action == 2 && permissions.editItems)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="btn"
                                    onClick={() => this.openAddresses(1)}>
                                    <i className="fas fa-list" />
                                </button>
                            )}
                        </div>

                        <div className="form-group row" id="div1">
                            <label
                                htmlFor="txtContactPerson"
                                className="col-md-2 col-sm-12 col-form-label font-weight-bold"
                                style={{ paddingLeft: 30 }}>
                            </label>
                            <div className="col-md-3 col-sm-12">
                                <input
                                    type="text"
                                    className="form-control input-sm"
                                    id="txtCustomer"
                                    disabled="true"
                                    value={newOrderModel.Address2 ? newOrderModel.Address2 : ''}
                                />
                            </div>
                        </div>

                    </div>

                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, paddingTop: 5 }}>
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Artículo
                                    </td>
                                    {(!x.matches &&
                                        <td className="sticky-header " style={{ maxWidth: 800, backgroundColor: '#d2ab24' }}>
                                            Descripción
                                        </td>)}
                                    <td className="sticky-header " style={{ backgroundColor: '#d2ab24' }}>
                                        Almacén
                                    </td>
                                    {(!x.matches &&
                                        <td className="sticky-header " style={{ backgroundColor: '#d2ab24' }}>
                                            Cuenta Mayor
                                        </td>)}
                                    {(!x.matches &&
                                        <td className="sticky-header " style={{ backgroundColor: '#d2ab24' }}>
                                            Nombre de la Cuenta Mayor
                                        </td>)}
                                    {(!x.matches &&
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                            Indicador I.
                                        </td>)}
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Cantidad
                                    </td>
                                    <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                                        Precio
                                    </td>
                                    {(!x.matches &&
                                        <td className="sticky-header coltotal" style={{ backgroundColor: '#d2ab24' }}>
                                            Total
                                        </td>)}

                                    {/* {(!x.matches && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 1
                                    </td>)}
                                    {(!x.matches && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 2
                                    </td>)}
                                    {(!x.matches && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 3
                                    </td>)}
                                    {(!x.matches && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 4
                                    </td>)} */}
                                    {(!x.matches &&
                                        <td className="sticky-header colStock" style={{ backgroundColor: '#d2ab24' }}>
                                            En stock
                                        </td>)}
                                </tr>
                            </thead>
                            <tbody>
                                {/* Filas de tabla  */}
                                {newOrderModelItems.map((item, index) => {
                                    return (
                                        <tr style={{
                                            maxHeight: 10,
                                            paddingTop: 8,
                                            paddingBottom: 8,
                                            color: item.stock ? 'black' : 'red',
                                            backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : 'transparent'
                                        }}>
                                            {/*Artículos*/}
                                            <td className="sticky-column"
                                                style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                                                {item.ItemCode}
                                            </td>
                                            {/*Descripción*/}
                                            {(!x.matches &&
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 800 }}>
                                                    {item.Description || item.ItemName}

                                                </td>)}
                                            {/*Almacen*/}
                                            <td style={{ textAlign: 'center' }}>
                                                <input
                                                    type=" text"
                                                    placeholder="Almacén"
                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                    disabled={action == 2 && !editMode ? true : false}
                                                    style={{
                                                        backgroundColor: item.whsSelected ? 'rgb(248,242,209)' : 'transparent',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        width: 100,
                                                        maxWidth: 800
                                                    }}
                                                    onKeyPress={(eve) => {
                                                        if (eve.key === 'Enter') {
                                                            this.openAlmacen(index, 1, item.ItemCode);
                                                        }
                                                    }}
                                                    value={item.WhsCode}
                                                    onChange={event => this.changeAlmacen(index, event)}
                                                />
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn "
                                                        onClick={() => this.openAlmacen(index, 1, item.ItemCode)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            {/*Cuenta Mayor*/}
                                            {(!x.matches &&
                                                <td style={{ textAlign: 'center' }}>
                                                    {item.AcctCode}
                                                    {/* {action == 1 && (
                                                        <button
                                                            type="button"
                                                            style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                                            className="btn"
                                                            onClick={() => this.openCuentaMayor(index,5)}>
                                                            <i className="fa fa-list" aria-hidden="true"/>
                                                        </button>
                                                    )} */}
                                                </td>)}

                                            {(!x.matches &&
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 800 }}>
                                                    {item.AcctCodeName}
                                                </td>)}

                                            {/*Impuesto*/}
                                            {(!x.matches &&
                                                <td>
                                                    {item?.TaxName?.replace('Percepción', '') || item.TaxCode}
                                                    {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (

                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                paddingTop: 1,
                                                                paddingBottom: 2,
                                                            }}
                                                            className="btn"
                                                            onClick={() => this.openTaxes(index)}>
                                                            <i className="fa fa-list" aria-hidden="true" />
                                                        </button>
                                                    )}
                                                </td>)}

                                            {/*Cantidad*/}
                                            <td>
                                                <input
                                                    type="text"
                                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                                    disabled={(action == 2) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        maxWidth: 60,
                                                        textAlign: "center",

                                                    }}
                                                    id={'itemCantidad' + index}

                                                    value={item.Quantity}
                                                    onChange={event => this.changeQuantityItem(event, index)}
                                                //onBlur={() => this.specialPrice(index)}
                                                />
                                            </td>


                                            {/*Precio*/}
                                            <td style={{ width: 130 }}>
                                                {(action == 1 || (action == 2 && permissions.editItems && !item.LineStatus)) ?
                                                    <input
                                                        type=" text"
                                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                                        // disabled={(action == 2) ? true : !permissions.editItems}
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            paddingTop: 1,
                                                            paddingBottom: 2,
                                                            width: 130,
                                                            textAlign: 'right',
                                                        }}
                                                        id={'itemCantidad' + index}
                                                        disabled={true}
                                                        value={CURRENCY + formatNumber.new(item.Price)}
                                                        onChange={event => this.changePriceItem(event, index)}
                                                        onBlur={event => this.validatePriceNull(index)}
                                                    /> :
                                                    <label>{CURRENCY + formatNumber.new(item.Price) + " " + item.Currency} </label>
                                                }
                                            </td>

                                            {/*Total*/}
                                            {(!x.matches &&
                                                <td style={{ textAlign: 'right' }}>{CURRENCY + formatNumber.new(item.Total)}</td>
                                            )}
                                            {/*Centros de costos*/}
                                            {/* <td>
                                                {item.OcrCode}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 1)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode2}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode3}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 3)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                {item.OcrCode4}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.openCentroCoste(index, 4)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td> */}
                                            {/*Stock*/}
                                            {(!x.matches &&
                                                <td style={{ textAlign: 'right' }}>{Number.parseFloat(item.OnHand).toFixed(4)}</td>
                                            )}
                                            {/*Compensación de stocks*/}



                                            {(action === 1) && (
                                                <td
                                                    className="sticky-columns"
                                                    style={{
                                                        backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF',
                                                        textAlign: 'center'
                                                    }}>
                                                    {/*Eliminar*/}

                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            padding: 5,
                                                            color: '#c42222',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => this.deleteItem(index)}>
                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                    </button>

                                                </td>
                                            )}

                                        </tr>
                                    );
                                })}
                                {/*  agregar articulo y busqueda realcionada */}
                                {(action === 1 && view !== 'ExitHelmets') && (
                                    <tr>
                                        <td className="sticky-column"
                                            style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                            <div>
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        padding: 5,
                                                        color: 'green',
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.openItems()}
                                                    value={newOrderModel.searchItem = 'CA00'}>
                                                    <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };
    //FOOTER  ENTRADA DE MERCANCIA CASCOS
    renderSalesHelmetsFooter = () => {
        const { view, newOrderModel, action } = this.props;
        const { editMode } = this.state;
        newOrderModel.Casco = 1;

        let { permissions } = newOrderModel;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*Empleado de ventas:*/}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Empleado ventas</span>
                            </div>
                            <input
                                type="text"
                                className="form-control input-sm"
                                id="txtSlpName"
                                disabled="true"
                                value={newOrderModel.SlpName ? newOrderModel.SlpName : ''}
                            />
                            {(action == 1 || (action == 2 && editMode && permissions.editEmployee)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openEmployee}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>
                            )}
                        </div>
                    )}
                    {/*Nombre del Propietario*/}
                    {((action === 1 || action === 2) && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Propietario</span>
                            </div>
                            <input
                                type="text"
                                className="form-control input-sm"
                                id="txtDocumentsOwnerName"
                                disabled="true"
                                value={newOrderModel.OwnerName ? newOrderModel.OwnerName : ''}
                            />
                            {false && (action == 1 || (action == 2 && editMode && permissions.editEmployee)) && (
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                    className="input-group-text"
                                    onClick={this.openPropietario}>
                                    <i className="fa fa-list" aria-hidden="true" />
                                </button>)}

                        </div>
                    )}
                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control input-sm styleTextarea"
                            id="txtComments"
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            disabled={action == 2 && !editMode ? true : false}
                            value={newOrderModel.Comments ? newOrderModel.Comments : ''}
                            onChange={this.changeComments}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                </div>
                {/*Segunda columna*/}
                {((action === 1 || action === 2) && !editMode) && (
                    <div className="col-sm" style={{ paddingRight: 0 }}>
                        {/*Total antes del Descuento*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Total antes Dcto:</span>
                            </div>
                            <input type="text"
                                style={{ textAlign: 'right' }}
                                className="form-control"
                                id="txtSubTotalS"
                                disabled="true"
                                value={
                                    CURRENCY +
                                    formatNumber.new(newOrderModel.Subtotal ? newOrderModel.Subtotal : '') +
                                    ' ' +
                                    (newOrderModel.DocCur ? newOrderModel.DocCur : '')} />
                        </div>
                        {/*Descuento:*/}
                        {view != 'PurchaseRequest' &&
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Descuento</span>
                                </div>
                                <input
                                    style={{
                                        textAlign: 'right',
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                    }}
                                    type="text"
                                    className="form-control btn-outline-secondary"
                                    id="txtDiscPrcnt"
                                    //disabled={(action == 2 && !editMode) ? true : (permissions ? !permissions.editDiscountDocument : false)}
                                    disabled='true'
                                    onChange={event => this.changeDiscountDocument(event)}
                                    onBlur={this.validateDiscountDocumentNull}
                                    value={newOrderModel.DiscountPercent}
                                />
                                <input
                                    style={{ textAlign: 'right' }}
                                    type="text"
                                    className="form-control"
                                    id="txtDiscPrcntt"
                                    value={
                                        CURRENCY +
                                        (formatNumber.new(newOrderModel.Discount ? newOrderModel.Discount : '') +
                                            ' ' +
                                            (newOrderModel.DocCur ? newOrderModel.DocCur : ''))
                                    }
                                    disabled="true"
                                />
                            </div>}
                        {/*Impuesto*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Impuesto</span>
                            </div>
                            <input
                                type=" text"
                                style={{ textAlign: 'right' }}
                                className=" form-control"
                                id="txtVatSumS"
                                disabled="true"
                                value={
                                    CURRENCY +
                                    (formatNumber.new(newOrderModel.Taxes ? newOrderModel.Taxes : '') +
                                        ' ' +
                                        (newOrderModel.DocCur ? newOrderModel.DocCur : ''))
                                }
                            />
                        </div>
                        {/*Total del documento:*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Total documento</span>
                            </div>
                            <input
                                type="text"
                                style={{ textAlign: 'right' }}
                                className="form-control"
                                id="txtDocTotalS"
                                disabled="true"
                                value={
                                    CURRENCY +
                                    (formatNumber.new(newOrderModel.Total ? newOrderModel.Total : '') +
                                        ' ' +
                                        (newOrderModel.DocCur ? newOrderModel.DocCur : ''))
                                }
                            />
                        </div>
                    </div>)}
            </div>
        );
    };

    //#################################################################################################################################
    //SELECTOR BORRADOR Y FIRME
    renderSelector = () => {
        const { newOrderModel, action, view } = this.props;
        const { service } = this.state;
        let transactionId = newOrderModel.transactionId || null;

        // let itemBaseType = action === 2 ? newOrderModel.Items.filter((item) => item.BaseType == '13') : [];

        return (
            <div className="row g-2 align-items-center flex-wrap">
                {action === 1 && view !== 'inventoryRevaluation' && view !== 'reportSelectionCriteria' && view !== 'landedCosts' && (
                    <div className="form-group row align-items-center px-2 px-md-3 flex-wrap">

                        <div className="col-auto radio font-weight-bold" style={{ fontSize: 18 }}>
                            <label className="d-flex align-items-center gap-1">
                                <input
                                    type="radio"
                                    name="optradio"
                                    checked={newOrderModel.DocumentType === 'F' ? true : false}
                                    id="radioOne"
                                    onChange={() => this.changeDocumentType('F')}
                                />{' '}
                                <span className="Firmes" >Firmes</span>
                            </label>
                        </div>

                        {view === 'payment' &&
                            <div className="col-auto font-weight-bold" style={{ fontSize: 18 }}>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type="checkbox"
                                        name="paymentRadio"
                                        checked={newOrderModel?.PaymentDocType === 'A' ? true : false}
                                        id="radioTwo"
                                        onChange={() => this.changePaymentDocumentType(newOrderModel?.PaymentDocType === 'A' ? 'C' : 'A')}
                                    />{' '}
                                    <span className="Firmes" >Cuenta</span>
                                </label>
                            </div>
                        }

                        {/* <div className="radio font-weight-bold" style={{fontSize: 18, padding: 5}}>
                            <label>
                                <input
                                    type="radio"
                                    name="optradio"
                                    checked={newOrderModel.DocumentType === 'P' ? true : false}
                                    id="radioTwo"
                                    onChange={() => this.changeDocumentType('P')}
                                />{' '}
                                Preliminar
                            </label>
                        </div> */}
                    </div>
                )}

                {(action === 1) && (view === 'quotations' || view === 'orderSales' || view === 'debitNote' || view === 'deliveries' || view === 'invoice' || view === 'creditNote' || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'invoiceReserve' || view === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft') &&
                    (<>
                        <div className="col-5 col-sm-3 col-md-3 ps-2 ps-md-3">
                            <select className="form-control w-100"
                                value={newOrderModel.DocType}
                                onChange={this.changeService}>
                                <option value={'I'}> {'Artículo'}</option>
                                <option value={'S'}> {'Servicio'}</option>
                            </select>
                        </div>


                        <div className="col-auto d-flex align-items-center ms-1">
                            {(newOrderModel.DocType === 'I' ? <label htmlFor="txtCustomer"
                                className="col-form-label col-form-label-md text-left font-weight-bold articulo-responsive mb-0">
                                Artículo
                            </label> : <label htmlFor="txtCustomer"
                                className="col-form-label col-form-label-md text-left font-weight-bold servicio-responsive mb-0">
                                Servicio
                            </label>)}
                        </div>
                    </>)
                }

                {(action === 2 && transactionId) && (view === 'invoice' || view === 'creditNote' || view === 'orderSales' || view === 'debitNote') && <div className="col-auto d-flex align-items-center radio font-weight-bold textleft" style={{ fontSize: 18 }}>
                    <button
                        type="button"
                        style={{
                            backgroundColor: 'transparent',
                            color: '#EABF28',
                        }}
                        title="Transacciones aplicadas"
                        data-toggle="tooltip"
                        className="btn mr-sm-1"
                        onClick={this.transactions}>
                        <img alt='' className="img-fluid iconoTrasacciones" src={require("../images/transacciones.png")} />
                    </button>
                    <button
                        type="button"
                        style={{
                            backgroundColor: 'transparent',
                            color: '#EABF28',
                        }}
                        title="Lista de pagos"
                        data-toggle="tooltip"
                        className="btn"
                        onClick={this.paymnetList}>
                        <img alt='' className="img-fluid iconoTrasacciones" src={require("../images/paymentList.png")} />
                    </button>
                </div>}

                {/* {(action === 2 && view === 'deliveries' && itemBaseType.length > 0) &&
                   (
                        <div className="form-group row" >
                            <button
                                type="button"
                                style={{
                                    backgroundColor: '#ff0000'
                                }}
                                className="btn success text-white"
                                onClick={this.OpenModalCloseDocuments}>
                                CANCELAR
                            </button>
                        </div>
                    )
                } */}

                {/* && view !=='GoodsReceipt' && view !=='PurchaseOrder' && view !=='purchaseReturn'  && view !=='bussinesPartner' */}
                {/* && view !=='transfersRequest' && view !=='transfers'  */}
                {(
                    view !== 'inventoryRevaluation' &&
                    // view !== 'payment' &&
                    view !== 'bussinesPartner' &&
                    view !== 'middleware' &&
                    view !== 'outgoingPayment' &&
                    view !== 'transfersEntry' &&
                    view !== 'transfersOutput' &&
                    view !== 'reportSelectionCriteria' &&
                    view !== 'landedCosts'
                ) && (
                        <div className="col d-flex justify-content-end align-items-center pe-3">
                            <label htmlFor="txtCustomer" className="col-form-label col-form-label-md text-right font-weight-bold mb-0">
                                <span className="d-none d-xl-inline">Campos de Usuario</span>
                                <span className="d-inline d-xl-none">Campos Usuario</span>
                            </label>
                            <button
                                type="button"
                                style={{
                                    backgroundColor: 'transparent',
                                    color: '#EABF28',
                                }}
                                className="btn "
                                onClick={this.openUserFields}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        </div>)}

                {(service === false || service === 'I') &&
                    (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote' || (view === 'invoiceAuthorization' && action === 2)) &&
                    <>
                        <div className="col-auto d-flex justify-content-end align-items-center pe-2">
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="btn "
                                onClick={() => this.ShowGrossProfitModal(action)}
                            >
                                <i className="fa fa-line-chart" aria-hidden="true"></i>
                            </button>
                        </div>
                        <br></br><br></br>

                        {this.renderGrossProfitModal()}

                    </>
                }
                <p style={{ visibility: 'hidden' }}>s</p>
            </div>
        );
    };

    //#region ########## TOOLBAR ###################################################

    RenderToolBar = () => {
        const { newOrderModel, action } = this.props;
        return (
            <div className="row justify-content-around">
                <div className="col-12 text-right" >
                    {newOrderModel.ShowBatchInfo && action === 2 && <button
                        className="btn btn-primary"
                        data-toggle="modal"
                        data-target="#clientsModal"
                        style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}
                        onClick={this.OpenBatchReportModal}
                    >
                        <i className="fa fa-hashtag" aria-hidden="true"></i>
                    </button>}
                </div>
            </div>
        )
    }

    //#endRender

    //HEADER DE CREACIÓN GENERAL
    renderDocumentHeaderPurchaseRequest = () => {
        const { newOrderModel, action } = this.props;
        const { editMode } = this.state;
        const nivelesRequerimiento = [
            { value: '0', label: 'Normal' },
            { value: '1', label: 'Urgente' },
            { value: '2', label: 'Muy urgente' }
        ];
        let { permissions } = newOrderModel;

        let clientCardCode = 'Solicitante';
        const { OPRQFieldsLeft = [], OPRQFieldsRight = [] } = this.splitInHalf(newOrderModel?.OPRQFields ?? [], true);

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*No del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">{clientCardCode}</span>
                        </div>
                        <select
                            className="form-control"
                            id='selectTypePurchaseRequest'
                            onChange={this.changeReqType}
                            disabled={action == 2 && !editMode ? true : (permissions ? !permissions.editItems : false)}
                            value={newOrderModel.ReqType ? newOrderModel.ReqType : ''}>
                            <option value="12">Usuario</option>
                            <option value="171">Empleado</option>
                        </select>
                    </div>
                    {/*CODIGO del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.Requester ? newOrderModel.Requester : ''}
                        />
                        {((Number(action) === 1 || (Number(action) === 2 && editMode && permissions.editItems)) && Number(newOrderModel?.ReqType) !== 12) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openPersonRequest}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Nombre del solicitangte*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Nombre de solicitante</span>
                                <span className="d-inline d-xl-none">Solicitante</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtName"
                            disabled="true"
                            value={newOrderModel.ReqName ? newOrderModel.ReqName : ''}
                        />
                    </div>
                    {/*Sucursal*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Sucursal</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.BranchName ? newOrderModel.BranchName : ''}
                        />
                        {((Number(action) == 1 || (Number(action) == 2 && editMode && permissions.editItems)) && Number(newOrderModel?.ReqType) !== 12) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openBranches}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Departament*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Departamento</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled="true"
                            value={newOrderModel.DepartmentName ? newOrderModel.DepartmentName : ''}
                        />
                        {((Number(action) == 1 || (Number(action) == 2 && editMode && permissions.editItems)) && Number(newOrderModel?.ReqType) !== 12) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openDepartment}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Active*/}
                    <div className="input-group mb-3" style={{ height: 60 }}>
                        <label htmlFor="txtContactPerson"
                            className="col-md-12 col-sm-12 col-form-label font-weight-bold" style={{ marginTop: '-10px' }}> <input
                                type="checkbox"
                                disabled={(action === 2 && !editMode) ? true : (permissions ? !permissions.editItems : false)}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000'
                                }}
                                id="cbox1"
                                checked={newOrderModel.Notify === 'Y' ? true : false}
                                onChange={this.changeActiveSendEmail} /> Enviar correo electrónico si se agrega un pedido, o un pedido de entrada de mercancías:
                        </label>
                    </div>

                    {/*Correo */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Correo</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={(action == 2 && !editMode) ? true : (permissions ? !permissions.editItems : false)}
                            value={newOrderModel.Email ? newOrderModel.Email : ''}
                            onChange={this.changeEmail}
                        />
                    </div>

                    {/* Nivel de requerimiento */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Nivel de requerimiento</span>
                                <span className="d-inline d-xl-none">Niv. req.</span>
                            </span>
                        </div>
                        <Select
                            options={nivelesRequerimiento}
                            value={nivelesRequerimiento.find(option => String(option.value) === String(newOrderModel?.U_RS_NivelReq ?? '0')) || null}
                            onChange={(selectedOption) => this.changeHeaderField('U_RS_NivelReq', selectedOption?.value ?? '0')}
                            isSearchable={true}
                            isClearable={false}
                            placeholder="Seleccionar"
                            isDisabled={Number(action) === 2 && !editMode}
                            styles={selectStyles}
                        />
                    </div>

                    <div className="row">
                        <div className="col-12 col-lg-6">
                            {/*Importacion*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Importación</span>
                                </div>
                                <input
                                    type="checkbox"
                                    id="txtImportacion"
                                    disabled={Number(action) === 2 && !editMode}
                                    onChange={() => this.changeHeaderField('U_RS_IMP', !newOrderModel?.U_RS_IMP)}
                                    style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                                    checked={newOrderModel?.U_RS_IMP}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            {/*N° Carpeta IMP.*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">N° Carpeta IMP.</span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtNoCarpetaIMP"
                                    disabled={Number(action) === 2 && !editMode}
                                    onChange={(event) => this.changeHeaderField('U_RS_NUMIMP', event.nativeEvent.target.value, 15)}
                                    maxLength={15}
                                    value={newOrderModel?.U_RS_NUMIMP || ''} />
                            </div>
                        </div>
                    </div>

                    {(action === 1 || editMode) && (this.validateInventoryCheck()) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <div className="input-group-text font-weight-bold">
                                    <input
                                        type="checkbox"
                                        id="inInvCheck"
                                        checked={newOrderModel.searchInvItems || false}
                                        onChange={() => this.changeHeaderField("searchInvItems", !newOrderModel.searchInvItems)} />
                                </div>
                            </div>
                            <label className="form-control" htmlFor="inInvCheck">
                                <span className="d-none d-xxl-inline"> Buscar artículos inventariables</span>
                                <span className="d-inline d-xxl-none"> Buscar.Art.Inv</span>
                            </label>
                        </div>
                    }
                    {this.renderSpecificFields(OPRQFieldsLeft, newOrderModel, action, editMode)}
                </div>

                {/*Segunda columna*/}
                <div className="col-sm" style={{ paddingRight: 0 }}>
                    {/*No Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtDocumentDate"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*N°:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtNo"
                            disabled="true"
                            value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                        />
                    </div>
                    {/*Estado*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtStatus"
                            disabled="true"
                            value={newOrderModel.StatusDocument ? newOrderModel.StatusDocument : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Contabilización</span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={action == 2 ? 'date' : 'date'}
                            disabled={action == 2 ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                            onChange={this.selectDocDate}
                        />
                    </div>
                    {/*Fecha de entrega:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Válido Hasta</span>
                        </div>
                        <input
                            id="txtDeliverDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={action == 2 && !editMode ? 'date' : 'date'}
                            disabled={action == 2 && !editMode ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDueDate ? newOrderModel.DocDueDate : ''}
                            onChange={this.selectDocDueDate}
                        />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            className=" form-control"
                            id="txtStatus"
                            autoComplete="off"
                            max='9999-12-31'
                            disabled="true"
                            value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Necesaria</span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control  btn-outline-secondary"
                            type={action == 2 ? 'date' : 'date'}
                            disabled={action == 2 && !editMode ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.ReqDate ? newOrderModel.ReqDate : ''}
                            min={new Date().toISOString().split('T')[0]}
                            onChange={this.selectReqDate}
                            onBlur={this.validateReqDate}

                        />
                    </div>

                    {/* Proyecto */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Proyecto</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtProject"
                            disabled={true}
                            value={newOrderModel?.Project || ''}
                        />
                        {(action === 1 || (action === 2 && editMode)) &&
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={() => this.openProjects(null)}
                            >
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        }
                    </div>
                    {this.renderSpecificFields(OPRQFieldsRight, newOrderModel, action, editMode)}

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Solicitar aprobacion</span>
                        </div>
                        <input
                            type="checkbox"
                            id="txtImportacion"
                            disabled={Number(action) === 2 && !editMode}
                            onChange={() => this.changeHeaderField('U_RS_SOLAPR', !newOrderModel?.U_RS_SOLAPR)}
                            style={{ borderStyle: 'solid', marginTop: '10px', marginLeft: '10px', minWidth: '20px', height: '20px' }}
                            checked={newOrderModel?.U_RS_SOLAPR}
                        />
                    </div>
                </div>
            </div>
        );

    };

    restartTabs = () => {
        const { newOrderModel, view, isDraftOWTQ = false } = this.props;
        let newView = newOrderModel?.newView || view;

        $('#nav-profile-tab-Contenido-D').removeClass('active');
        $('#nav-profile-tab-Finanzas').removeClass('active');
        $('#nav-profile-tab-logistica').removeClass('active');
        $('#nav-profile-tab-Costs-D').removeClass('active');
        $('#nav-profile-tab-Complemento').removeClass('active');
        $('#nav-profile-tab-Attach').removeClass('active');
        $('#nav-profile-tab-InvFields').removeClass('active');
        $('#nav-profile-tab-LiquidationFields').removeClass('active');
        $('#nav-profile-tab-Facturacion').removeClass('active');

        $('#dataContenidoDocument').removeClass('active');
        $('#dataFinanzas').removeClass('active');
        $('#dataLogistica').removeClass('active');
        $('#dataCostsDocument').removeClass('active');
        $('#dataComplemento').removeClass('active');
        $('#dataAttach').removeClass('active');
        $('#invFields').removeClass('active');
        $('#liquidationFields').removeClass('active');
        $('#dataFacturacion').removeClass('active');

        $('#dataContenidoDocument').removeClass('show');
        $('#dataFinanzas').removeClass('show');
        $('#dataLogistica').removeClass('show');
        $('#dataCostsDocument').removeClass('show');
        $('#dataComplemento').removeClass('show');
        $('#dataAttach').removeClass('show');
        $('#invFields').removeClass('show');
        $('#liquidationFields').removeClass('show');
        $('#dataFacturacion').removeClass('show');

        if (newView === 'transfersRequest' || newView === 'transfers' || isDraftOWTQ) {
            $('#nav-profile-tab-Contenido-T').addClass('active');
            $('#dataContenido2').addClass('active')
            $('#dataContenido2').addClass('show')
        } else {
            $('#nav-profile-tab-Contenido-D').addClass('active');
            $('#dataContenidoDocument').addClass('active')
            $('#dataContenidoDocument').addClass('show')
        }
    };

    renderTitleModal = () => {
        const { action, newOrderModel, docFilter } = this.props;
        let complemento = "";
        let authorized = newOrderModel.isDocumentWithAuthorization;

        if (authorized) {
            complemento = "[Autorizado]";
        }

        let title = '';

        switch (newOrderModel.OriginDocumentCreate) {
            case 'quotations':
                title = 'Oferta de Venta ' + complemento;
                break;
            case 'orderSales':
                title = 'Orden de Venta ' + complemento;
                break;
            case 'deliveries':
                title = 'Entrega ' + complemento;
                break;
            case 'invoice':
                title = 'Factura ' + complemento;
                break;
            case 'invoiceAdvance':
                title = 'Factura de Anticipo ' + complemento;
                break;
            case 'purchaseDownPayments':
                title = 'Factura de Anticipo de provedores ' + complemento;
                break;
            case 'return':
                title = 'Devolución ' + complemento;
                break;
            case 'purchaseReturn':
                title = 'Devolución de Mercancía ' + complemento;
                break;
            case 'debitNote':
                title = 'Nota de Débito ' + complemento;
                break;
            case 'creditNote':
                title = 'Nota de Crédito ' + complemento;
                break;
            case 'payment':
                title = 'Pagos Recibidos ';
                break;
            case 'transfers':
                title = 'Traslado de Mercancía ' + complemento;
                break;
            case 'transfersRequest':
                title = 'Solicitud de Traslado ' + complemento;
                break;
            case 'transfersEntry':
                title = 'Entrada de Mercancía ' + complemento;
                break;
            case 'transfersOutput':
                title = 'Salida de Mercancía ' + complemento;
                break;
            case 'invoiceAuthorization':
                title = 'Borrador [Pendiente]  ';
                break;
            case 'invoiceBorrador':
                title = 'Borrador [Autorizado]  ';
                break;
            case 'PurchaseOrder':
                title = 'Orden de Compra  ' + complemento;
                break;
            case 'GoodsReceipt':
                title = 'Entrada de Mercancía ' + complemento;
                break;
            case 'SalesHelmets':
                title = 'Entrada de Mercancía Cascos';
                break;
            case 'ExitHelmets':
                title = 'Salida de Mercancía Cascos';
                break;
            case 'PurchaseRequest':
                title = 'Solicitud de Compra  ' + complemento;
                break;
            case 'inventoryRevaluation':
                title = 'Revalorización de Inventario ' + complemento;
                break;
            case 'purchaseInvoice':
                title = 'Factura de Proveedores';
                break;
            case 'purchaseCreditNotes':
                title = 'Nota de crédito Proveedores';
                break;
            case 'outgoingPayment':
                title = 'Pagos Efectuados';
                break;
            case 'invoiceReserve':
                title = 'Factura de reserva de clientes';
                break;
            case 'middleware':
                if (newOrderModel.ObjType === '22') {
                    title = 'Orden de Compra';
                } else if (newOrderModel.ObjType === '18') {
                    title = 'Factura de Proveedores [Preliminar]';
                }
                break;
            case 'citibanamex':
                title = docFilter === 'OPCH' ? 'Factura de proveedor' : 'Orden de Compra';
                break;
            case 'reportSelectionCriteria':
                title = 'Recomendación de Pedido: Criterios de selección ' + complemento;
                break;
            case 'landedCosts':
                title = 'Precio de Entrega';
                break;
            case 'PurchaseQuotation':
                title = 'Oferta de Compra';
                break;
            case 'PurchaseQuotationDraft':
                title = 'Oferta de Compra (Borrador)';
                break;
            case 'draft':
                title = 'Documento Preliminar';
                break;
            default:
        }

        if (action === 1) {
            title = 'Nuevo(a) ' + title;
        }

        if (action === 2) {
            title = 'Detalle de ' + title;
        }

        return title;
    };

    TitleModal = () => {
        const { view, action, newOrderModel } = this.props;

        let complemento = "";

        let authorized = newOrderModel.isDocumentWithAuthorization;

        if (authorized) {
            complemento = "";
        }

        let title = '';

        switch (newOrderModel.OriginDocumentCreate) {
            case 'quotations':
                title = 'Oferta de Venta ' + complemento;
                break;
            case 'orderSales':
                title = 'Orden de Venta ' + complemento;
                break;
            case 'deliveries':
                title = 'Entrega ' + complemento;
                break;
            case 'invoice':
                title = 'Factura ' + complemento;
                break;
            case 'return':
                title = 'Devolución ' + complemento;
                break;
            case 'purchaseReturn':
                title = 'Devolución de Mercancía ' + complemento;
                break;
            case 'debitNote':
                title = 'Nota de Débito ' + complemento;
                break;
            case 'creditNote':
                title = 'Nota de Crédito ' + complemento;
                break;
            case 'payment':
                title = 'Pagos Recibidos ';
                break;
            case 'transfers':
                title = 'Traslado de Mercancía ' + complemento;
                break;
            case 'transfersRequest':
                title = 'Solicitud de Traslado ' + complemento;
                break;
            case 'transfersEntry':
                title = 'Entrada de Mercancía ' + complemento;
                break;
            case 'transfersOutput':
                title = 'Salida de Mercancía ' + complemento;
                break;
            case 'invoiceAuthorization':
                title = 'Borrador [Pendiente]  ';
                break;
            case 'invoiceBorrador':
                title = 'Borrador [Autorizado]  ';
                break;
            case 'PurchaseOrder':
                title = 'Orden de Compra  ' + complemento;
                break;
            case 'GoodsReceipt':
                title = 'Entrada de Mercancía ' + complemento;
                break;
            case 'SalesHelmets':
                title = 'Entrada de Mercancía Cascos';
                break;
            case 'ExitHelmets':
                title = 'Salida de Mercancía Cascos';
                break;
            case 'PurchaseRequest':
                title = 'Solicitud de Compra  ' + complemento;
                break;
            case 'inventoryRevaluation':
                title = 'Revalorización de Inventario ' + complemento;
                break;
            case 'purchaseInvoice':
                title = 'Factura de Proveedores';
                break;
            case 'purchaseCreditNotes':
                title = 'Nota de crédito Proveedores';
                break;

            case 'outgoingPayment':
                title = 'Pagos Efectuados';
                break;
            case 'invoiceReserve':
                title = 'Factura de reserva de clientes';
                break;
            case 'reportSelectionCriteria':
                title = 'Recomendación de Pedido: Criterios de selección ' + complemento;
                break;
            case 'PurchaseQuotation':
                title = 'Oferta de Compra  ' + complemento;
                break;
            default:

        }

        return title;
    };

    renderContentColumnCreate = () => {
        const { view, newOrderModel } = this.props;

        let title = '';
        switch (view) {
            case 'quotations':
                title = this.renderDocumentHeader();
                break;
            case 'orderSales':
                title = this.renderDocumentHeader();
                break;
            case 'deliveries':
                title = this.renderDocumentHeader();
                break;
            case 'invoice':
                title = this.renderDocumentHeader();
                break;
            case 'invoiceAdvance':
                title = this.renderDocumentHeader();
                break;
            case 'purchaseDownPayments':
                title = this.renderDocumentHeader();
                break;
            case 'return':
                title = this.renderDocumentHeader();
                break;
            case 'purchaseReturn':
                title = this.renderDocumentHeader();
                break;
            case 'debitNote':
                title = this.renderDocumentHeader();
                break;
            case 'creditNote':
                title = this.renderDocumentHeader();
                break;
            case 'PurchaseOrder':
                title = this.renderDocumentHeader();
                break;
            case 'GoodsReceipt':
                title = this.renderDocumentHeader();
                break;
            case 'PurchaseRequest':
                if (newOrderModel?.OriginDocumentCreate === 'PurchaseQuotation' || newOrderModel?.OriginDocumentCreate === 'PurchaseQuotationDraft' || newOrderModel?.OriginDocumentCreate === 'PurchaseOrder') {
                    title = this.renderDocumentHeader();
                } else {
                    title = this.renderDocumentHeaderPurchaseRequest();
                }
                break;
            case 'payment':
                title = this.renderDocumentsPagosHeader();
                break;
            case 'transfers':
                title = this.renderDocumentTransfersHeader();
                break;
            case 'transfersRequest':
                title = this.renderDocumentTransfersHeader();
                break;
            case 'invoiceBorrador':
                if (newOrderModel.ObjType == "67" || newOrderModel.ObjType == '1250000001') {
                    title = this.renderDocumentTransfersHeader();
                } else if (newOrderModel.ObjType == "59" || newOrderModel.ObjType == '60') {
                    title = this.renderDocumentHeaderTransfers();
                } else if (newOrderModel.ObjType == "1470000113") {
                    title = this.renderDocumentHeaderPurchaseRequest();
                } else {
                    title = this.renderDocumentHeader();
                }
                break;
            case 'invoiceAuthorization':
                if (newOrderModel.ObjType == "59" || newOrderModel.ObjType == '60') {
                    title = this.renderDocumentHeaderTransfers();
                } else {
                    if (newOrderModel.ObjType == "67" || newOrderModel.ObjType == '1250000001') {
                        title = this.renderDocumentTransfersHeader();
                    } else if (newOrderModel.ObjType == "1470000113") {
                        title = this.renderDocumentHeaderPurchaseRequest();
                    } else {
                        title = this.renderDocumentHeader();
                    }
                }
                break;
            case 'transfersEntry':
                title = this.renderDocumentHeaderTransfers();
                break;
            case 'transfersOutput':
                title = this.renderDocumentHeaderTransfers();
                break;
            case 'inventoryRevaluation':
                title = this.renderDocumentHeaderTransfers();
                break;
            case 'SalesHelmets':
                title = this.renderHeaderSalesHelmets();
                break;
            case 'ExitHelmets':
                title = this.renderHeaderSalesHelmets();
                break;
            case 'purchaseInvoice':
                title = this.renderDocumentHeader();
                break;
            case 'purchaseCreditNotes':
                title = this.renderDocumentHeader();
                break;
            case 'outgoingPayment':
                title = this.renderDocumentsPagosHeader();
                break;
            case 'invoiceReserve':
                title = this.renderDocumentHeader();
                break;
            case 'middleware':
                title = this.renderDocumentHeader();
                break;
            case 'citibanamex':
                title = this.renderDocumentHeader();
                break;
            case 'reportSelectionCriteria':
                title = this.renderReportSelectionCriteria();
                break;
            case 'landedCosts':
                title = this.renderContentLandedCosts('header');
                break;
            case 'PurchaseQuotation':
                title = this.renderDocumentHeader();
                break;
            case 'draft':
                title = this.renderDraftHeader()
                break;
            default:
        }

        return title;
    };
    renderDraftHeader = () => {
        const { newOrderModel, DraftObjType = '' } = this.props;
        const ObjType = newOrderModel.ObjType || DraftObjType;
        switch (String(ObjType)) {
            case "540000006":
            case "22":
                return this.renderDocumentHeader();
            case "1250000001":
                return this.renderDocumentTransfersHeader();

            default:
                break;
        }
    }

    renderPartidasColumnCreate = () => {
        const { view, newOrderModel } = this.props;

        let title = '';
        switch (view) {
            case 'quotations':
                title = this.renderDocumentBody();
                break;
            case 'orderSales':
                title = this.renderDocumentBody();
                break;
            case 'deliveries':
                title = this.renderDocumentBody();
                break;
            case 'invoice':
                title = this.renderDocumentBody();
                break;
            case 'invoiceAdvance':
                title = this.renderDocumentBody();
                break;
            case 'purchaseDownPayments':
                title = this.renderDocumentBody();
                break;
            case 'return':
                title = this.renderDocumentBody();
                break;
            case 'purchaseReturn':
                title = this.renderDocumentBody();
                break;
            case 'debitNote':
                title = this.renderDocumentBody();
                break;
            case 'creditNote':
                title = this.renderDocumentBody();
                break;
            case 'PurchaseOrder':
                title = this.renderDocumentBody();
                break;
            case 'GoodsReceipt':
                title = this.renderDocumentBody();
                break;
            case 'PurchaseRequest':
                title = this.renderDocumentBody();
                break;
            case 'payment':
                title = this.renderDocumentsPagosItems();
                break;
            case 'transfers':
                title = this.renderDocumentTransfersBody();
                break;
            case 'transfersRequest':
                title = this.renderDocumentTransfersBody();
                break;
            case 'invoiceBorrador':

                if (newOrderModel.ObjType == "67" || newOrderModel.ObjType == '1250000001') {
                    title = this.renderDocumentTransfersBody();
                } else if (newOrderModel.ObjType == "59" || newOrderModel.ObjType == '60') {
                    title = this.renderDocumentBodyTranfers();
                } else {
                    title = this.renderDocumentBody();
                }
                break;
            case 'invoiceAuthorization':
                if (newOrderModel.ObjType == "59" || newOrderModel.ObjType == '60') {
                    title = this.renderDocumentBodyTranfers();
                } else {
                    if (newOrderModel.ObjType == "67" || newOrderModel.ObjType == '1250000001') {
                        title = this.renderDocumentTransfersBody();
                    } else {
                        title = this.renderDocumentBody();
                    }
                }
                break;
            case 'transfersEntry':
                title = this.renderDocumentBodyTranfers();
                break;
            case 'transfersOutput':
                title = this.renderDocumentBodyTranfers();
                break;
            case 'inventoryRevaluation':
                title = this.renderDocumentBodyInventory();
                break;
            case 'SalesHelmets':
                title = this.renderBodySalesHelmets();
                break;
            case 'ExitHelmets':
                title = this.renderBodySalesHelmets();
                break;
            case 'purchaseInvoice':
                title = this.renderDocumentBody();
                break;
            case 'purchaseCreditNotes':
                title = this.renderDocumentBody();
                break;
            case 'outgoingPayment':
                title = this.renderDocumentsPagosItems();
                break;
            case 'invoiceReserve':
                title = this.renderDocumentBody();
                break;
            case 'middleware':
                title = this.renderDocumentBody();
                break;
            case 'citibanamex':
                title = this.renderDocumentBody();
                break;
            case 'landedCosts':
                title = this.renderContentLandedCosts('body');
                break;
            case 'PurchaseQuotation':
                title = this.renderDocumentBody();
                break;
            case 'draft':
                title = this.renderDraftBody();
                break;
            default:
        }

        return title;
    };
    renderDraftBody = () => {
        const { newOrderModel, DraftObjType = '' } = this.props;
        const ObjType = newOrderModel.ObjType || DraftObjType;
        switch (String(ObjType)) {
            case "540000006":
            case "22":
                return this.renderDocumentBody();
            case "1250000001":
                return this.renderDocumentTransfersBody();

            default:
                break;
        }
    }

    renderContentColumnTwoCreate = () => {
        const { view, newOrderModel } = this.props;

        let title = '';

        switch (view) {
            case 'quotations':
                title = this.renderDocumentFooter();
                break;
            case 'orderSales':
                title = this.renderDocumentFooter();
                break;
            case 'deliveries':
                title = this.renderDocumentFooter();
                break;
            case 'invoice':
                title = this.renderDocumentFooter();
                break;
            case 'invoiceAdvance':
                title = this.renderDocumentFooter();
                break;
            case 'purchaseDownPayments':
                title = this.renderDocumentFooter();
                break;
            case 'return':
                title = this.renderDocumentFooter();
                break;
            case 'purchaseReturn':
                title = this.renderDocumentFooter();
                break;
            case 'debitNote':
                title = this.renderDocumentFooter();
                break;
            case 'creditNote':
                title = this.renderDocumentFooter();
                break;
            case 'payment':
                title = this.renderDocumentsPagosFooter();
                break;
            case 'transfers':
                title = this.renderTransfersFooter();
                break;
            case 'transfersRequest':
                title = this.renderTransfersFooter();
                break;
            case 'PurchaseOrder':
                title = this.renderDocumentFooter();
                break;
            case 'GoodsReceipt':
                title = this.renderDocumentFooter();
                break;
            case 'PurchaseRequest':
                title = this.renderDocumentFooter();
                break;
            case 'invoiceBorrador':

                if (newOrderModel.ObjType == "67" || newOrderModel.ObjType == '1250000001') {
                    title = this.renderTransfersFooter();
                } else if (newOrderModel.ObjType == "59" || newOrderModel.ObjType == '60') {
                    title = this.renderDocumentFooterTransfer();
                } else {
                    title = this.renderDocumentFooter();
                }
                break;
            case 'invoiceAuthorization':
                if (newOrderModel.ObjType == "59" || newOrderModel.ObjType == '60') {
                    title = this.renderDocumentFooterTransfer();
                } else {
                    if (newOrderModel.ObjType == "67" || newOrderModel.ObjType == '1250000001') {
                        title = this.renderTransfersFooter();
                    } else {
                        title = this.renderDocumentFooter();
                    }
                }
                break;
            case 'transfersEntry':
                title = this.renderDocumentFooterTransfer();
                break;
            case 'transfersOutput':
                title = this.renderDocumentFooterTransfer();
                break;
            case 'inventoryRevaluation':
                title = this.renderInventoryFooter();
                break;
            case 'SalesHelmets':
                title = this.renderSalesHelmetsFooter();
                break;
            case 'ExitHelmets':
                title = this.renderSalesHelmetsFooter();
                break;
            case 'purchaseInvoice':
                title = this.renderDocumentFooter();
                break;
            case 'purchaseCreditNotes':
                title = this.renderDocumentFooter();
                break;
            case 'outgoingPayment':
                title = this.renderDocumentsPagosFooter();
                break;
            case 'invoiceReserve':
                title = this.renderDocumentFooter();
                break;
            case 'middleware':
                title = this.renderDocumentFooter();
                break;
            case 'citibanamex':
                title = this.renderDocumentFooter();
                break;
            case 'landedCosts':
                title = this.renderContentLandedCosts('footer');
                break;
            case 'PurchaseQuotation':
                title = this.renderDocumentFooter();
                break;
            case 'draft':
                title = this.renderDraftFooter();
                break;
            default:
        }

        return title;
    };

    renderDraftFooter = () => {
        const { newOrderModel, DraftObjType = '' } = this.props;
        const ObjType = newOrderModel.ObjType || DraftObjType;
        switch (String(ObjType)) {
            case "540000006":
            case "22":
                return this.renderDocumentFooter();
            case "1250000001":
                return this.renderTransfersFooter();

            default:
                break;
        }
    }

    renderDocumentsPagosTipo = () => {
        const { view, action } = this.props;
        let title = '';

        let select1 = '';
        let select2 = '';
        let select3 = '';
        let select4 = '';

        select1 = 'active';
        select2 = '';
        select3 = '';
        select4 = '';

        const selectTransfers = () => {
            if (action == 2) {
                return;
            }

            select1 = 'active';
            select2 = '';
            select3 = '';
            select4 = '';
        };

        const selectCheque = () => {
            if (action == 2) {
                return;
            }

            select1 = '';
            select2 = 'active';
            select3 = '';
            select4 = '';
        };

        const selectCash = () => {
            if (action == 2) {
                return;
            }

            select1 = '';
            select2 = '';
            select3 = 'active';
            select4 = '';
        };

        const selectCard = () => {
            if (action == 2) {
                return;
            }

            select1 = '';
            select2 = '';
            select3 = '';
            select4 = 'active';
        };

        if (view == 'payment' || view == 'outgoingPayment') {
            return (
                <div>
                    <div>
                        <nav>
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className={'nav-item nav-link font-weight-bold text-secondary ' + select1}
                                    id="nav-home-tab-One"
                                    data-toggle="tab"
                                    href="#transfersControl"
                                    role="tab"
                                    aria-controls="transfersControl"
                                    aria-selected="false"
                                    onClick={selectTransfers}>
                                    Transferencia
                                </a>
                                <a
                                    className={'nav-item nav-link font-weight-bold text-secondary ' + select2}
                                    id="nav-profile-tab-C"
                                    data-toggle="tab"
                                    href="#chequeControl"
                                    role="tab"
                                    aria-controls="chequeControl"
                                    aria-selected="false"
                                    onClick={selectCheque}>
                                    Cheque
                                </a>
                                <a
                                    className={'nav-item nav-link font-weight-bold text-secondary ' + select3}
                                    id="nav-contact-tab-E"
                                    data-toggle="tab"
                                    href="#cashControl"
                                    role="tab"
                                    aria-controls="cashControl"
                                    aria-selected="false"
                                    onClick={selectCash}>
                                    Efectivo
                                </a>
                                <a
                                    className={'nav-item nav-link font-weight-bold text-secondary ' + select4}
                                    id="nav-contac-tab-T"
                                    data-toggle="tab"
                                    href="#cardControl"
                                    role="tab"
                                    aria-controls="cardControl"
                                    aria-selected="false"
                                    onClick={selectCard}>
                                    Tarjeta
                                </a>
                            </div>
                        </nav>
                    </div>
                    <br />
                </div>
            );
        }
    };

    billingInfo = action => {
        const { billing, newOrderModel } = this.props;

        billing(newOrderModel.indexRowDetails, action);
        this.setState({
            isCancelCFDI: false,
        });
    };

    acceptEditMode = async (option = null) => {
        const { acceptEditMode, newOrderModel, showAlert } = this.props;
        const { flagUploadAttachments, hasUploadedAttachment } = this.state;

        if (option === 1) {
            newOrderModel.DocStatus = 'C';
            newOrderModel.DocType = 'I';
            newOrderModel.DocStatusCasco = 'C';
        } else {
            if (newOrderModel.OriginDocumentCreate === 'invoice') {
                // COMERCIO EXTERIOR
                if (newOrderModel.isComercioExterior === "Y") {
                    if (!newOrderModel.ComercioExterior.CertificadoOrigen) {
                        showAlert({ type: "warning", message: `El campo Certificado Origen no puede ir vacío.` });
                        return;
                    }

                    if (newOrderModel.ComercioExterior.CertificadoOrigen === '1') {
                        if (!newOrderModel.ComercioExterior.NumCertificadoOrigen) {
                            showAlert({ type: "warning", message: `El campo N° de Certificado Origen no puede ir vacío.` });
                            return;
                        }
                    }
                    // EMISOR
                    if (!newOrderModel.ComercioExterior.Emisor_Pais) {
                        showAlert({ type: "warning", message: `El campo País del Emisor no puede ir vacío.` });
                        return;
                    }

                    if (!newOrderModel.ComercioExterior.Emisor_Estado) {
                        showAlert({ type: "warning", message: `El campo Estado del Emisor no puede ir vacío.` });
                        return;
                    }

                    if (!newOrderModel.ComercioExterior.Emisor_CodigoPostal) {
                        showAlert({ type: "warning", message: `El campo Código Postal del Emisor no puede ir vacío.` });
                        return;
                    }

                    if (!newOrderModel.ComercioExterior.Emisor_Calle) {
                        showAlert({ type: "warning", message: `El campo Calle del Emisor no puede ir vacío.` });
                        return;
                    }

                    // RECEPTOR
                    if (!newOrderModel.ComercioExterior.Receptor_Pais) {
                        showAlert({ type: "warning", message: `El campo País del Receptor no puede ir vacío.` });
                        return;
                    }

                    if (!newOrderModel.ComercioExterior.Receptor_Estado) {
                        showAlert({ type: "warning", message: `El campo Estado del Receptor no puede ir vacío.` });
                        return;
                    }

                    if (!newOrderModel.ComercioExterior.Receptor_CodigoPostal) {
                        showAlert({ type: "warning", message: `El campo Código Postal del Receptor no puede ir vacío.` });
                        return;
                    }

                    if (!newOrderModel.ComercioExterior.Receptor_Calle) {
                        showAlert({ type: "warning", message: `El campo Calle del Receptor no puede ir vacío.` });
                        return;
                    }

                    let sendContinue = false;

                    if (!newOrderModel.ComercioExterior.Mercancias) {
                        showAlert({ type: "warning", message: `No se agregaron mercancias.` });
                        return;
                    }
                    for (let index = 0; index < newOrderModel.ComercioExterior.Mercancias.length; index++) {
                        const mercancia = newOrderModel.ComercioExterior.Mercancias[index];
                        if (!mercancia.UnidadAduana) {
                            sendContinue = true;
                        }
                    }

                    if (sendContinue) {
                        showAlert({ type: "warning", message: `Es necesario llenar la unidad de aduana en las mercancias.` });
                        return;
                    }
                    await this.Add_ComercioExterior();
                }
                // LEYENDAS FISCALES
                if (newOrderModel.isLeyendaFiscal && newOrderModel.SelectLeyendas) {
                    let sendContinue = false;

                    for (let index = 0; index < newOrderModel.LeyendasFiscales.length; index++) {
                        const element = newOrderModel.LeyendasFiscales[index];

                        if (!element.textoLeyenda) {
                            sendContinue = true;
                        }
                    }

                    if (sendContinue) {
                        showAlert({ type: "warning", message: `Es necesario llenar el texto de la leyenda para poder agregar una nueva Leyenda Fiscal.` });
                        return;
                    }
                }
                // MANDAR LEYENDAS FISCALES
                if (newOrderModel.SelectLeyendas) {
                    await this.Add_LeyendasFiscales();
                }
            }
        }
        this.refreshModel(newOrderModel);
        //#region ATTACHMENT
        if (hasUploadedAttachment && !flagUploadAttachments) {
            showAlert({ type: 'info', message: `Por favor, haz clic en 'Subir archivo' para adjuntar los anexos correctamente.`, timeOut: 8000 });
            return;
        }
        //#endregion ATTACHMENT
        acceptEditMode(newOrderModel);
    };

    cancelEditMode = () => {
        const { newOrderModel, cancelEditMode } = this.props;
        cancelEditMode();
        this.setState({
            editMode: false,
        });
    };

    editMode = () => {
        const { newOrderModel, view, processUserFields, isDraftOWTQ = false } = this.props;
        this.setState({
            editMode: !this.state.editMode,
        }, async () => {
            //#region CAMPOS EMPRESA
            const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput' || Number(newOrderModel?.ObjType) === 59 || Number(newOrderModel?.ObjType) === 60;
            const isOWTR = view === 'transfers' || Number(newOrderModel?.ObjType) === 67;
            const isOWTRoOWTQ = isOWTR || view === 'transfersRequest' || Number(newOrderModel?.ObjType) === 1250000001 || isDraftOWTQ;

            if (isOIGNoOIGE || isOWTRoOWTQ) {
                await processUserFields({
                    fields: invFields,
                    model: newOrderModel,
                    targetProperty: "invFields",
                    headerFields: isOWTRoOWTQ ? [] : [
                        'U_BPP_MDTS',
                        'U_RS_MOTIVOIS',
                        'U_RS_TIPOOPER',
                        'U_BPP_MDTD',
                        'U_BPP_MDSD',
                        'U_BPP_MDCD'
                    ],
                    dateFields: ["U_STR_FE_GRE_FechaTransporte"],
                    isOWTRoOWTQ,
                    isCopy: true,
                    header: newOrderModel
                });
            }

            if (isOWTRoOWTQ) {
                await processUserFields({
                    fields: transferFields,
                    model: newOrderModel,
                    targetProperty: "transferFields",
                    headerFields: [],
                    dateFields: [],
                    isOWTRoOWTQ,
                    isCopy: true,
                    header: newOrderModel
                });
            }

            //#region U_RML_TIPOS13
            const isType13 = Number(newOrderModel?.U_STR_FE_GRE_CodigoMotivoTraslado) === 13;

            const tipos13Field = newOrderModel?.invFields?.find(field => field?.Field === 'U_RML_TIPOS13');
            if (tipos13Field && Object.prototype.hasOwnProperty.call(tipos13Field, 'Static')) {
                tipos13Field.Static = !isType13;
            }
            if (!isType13) {
                newOrderModel.U_RML_TIPOS13 = '';
            }
            //#endregion U_RML_TIPOS13

            if (isOIGNoOIGE || isOWTRoOWTQ || isOWTR) {
                await this.refreshModel(newOrderModel);
            }
            //#endregion

            //#region DETRACCIONES | RETENCIONES
            if ((newOrderModel?.DetraccionVista || newOrderModel?.RetencionVista) && (newOrderModel?.newView === 'PurchaseOrder' || view === 'PurchaseOrder')) {
                await this.refreshTotal(newOrderModel);
            }
            //#endregion DETRACCIONES | RETENCIONES
        });
    };

    renderEditButton = () => {
        const { newOrderModel, action, view, writeAccess } = this.props;
        const { editMode, _user } = this.state;

        const isOPRQ = view === 'PurchaseRequest' && !newOrderModel?.newView;
        const isOPOR = view === 'PurchaseOrder' && !newOrderModel?.newView;
        const isOPRQAuth = isOPRQ && newOrderModel?.isOPRQAuth === 'Y';
        let status = isOPRQAuth || newOrderModel.StatusDocument === 'Cerrado' ? 0 : 1;
        status = !isOPOR ? status // No es OPOR: mantiene la lógica normal
            : status && _user?.BranchPermission?.EditPurchaseOrder ? 1 : 0; // OPOR: requiere cumplir la lógica normal de edición y tener el permiso

        if (action === 2 && !editMode && writeAccess) {
            if (status === 1 && view !== 'middleware' && view !== 'invoiceBorrador' && view !== 'invoiceAuthorization' && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'transfers' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'citibanamex' && view !== 'landedCosts') {
                return (
                    <button
                        type="button"
                        style={{ backgroundColor: 'transparent', color: '#000' }}
                        className="btn btn-editar"
                        onClick={this.editMode}>
                        <i className="fas fa-edit  fa-lg" />
                        Editar
                    </button>
                );
            }
        }
    };

    renderEditButton2 = () => {
        return (
            <div>
                <button style={{ backgroundColor: 'transparent', color: '#fff' }} className="btn btn-editar" disabled="true">
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            </div>
        );
    };

    addNewItemCheck = () => {
        const { newOrderModel } = this.props;

        let newItem = new NewItemCheck();

        newOrderModel.CheckList.push(newItem);
        this.refreshModel(newOrderModel);

    };

    deleteItemCheck = indexToDelete => {
        const { newOrderModel } = this.props;
        let newItems = [];

        newOrderModel.CheckList.map((item, index) => {
            if (indexToDelete != index) {
                newItems.push(item);
            }
        });

        newOrderModel.CheckList = newItems;
        this.refreshTotal(newOrderModel);
    };

    printElement = (elem) => {

        var domClone = elem.cloneNode(true);

        var $printSection = document.getElementById("printSection");

        if (!$printSection) {
            var $printSection = document.createElement("div");
            $printSection.id = "printSection";
            document.body.appendChild($printSection);
        }

        $printSection.innerHTML = "";
        $printSection.appendChild(domClone);
        window.print();
    }

    hanldeUserFields = async (index, event) => {
        const { showAlert, enableSpinner, newOrderModel, view } = this.props;
        let newView = newOrderModel.newView || view;


        this.setState({
            newOrderModel,
        });
    }

    addCreditCard = () => {
        const { newOrderModel } = this.props;
        let newCreditCard = new CreditCards();
        newCreditCard.isSelected = false;
        newOrderModel.PaymentsCreditCards.push(newCreditCard);
        this.refreshModel(newOrderModel);
    }

    deleteCard = (cardID) => {
        const { newOrderModel } = this.props;
        newOrderModel.PaymentsCreditCards.splice(cardID, 1);
        this.refreshModel(newOrderModel);
    }

    selectTabCard = (cardId) => {
        const { newOrderModel } = this.props;

        for (let index = 0; index < newOrderModel.PaymentsCreditCards.length; index++) {
            const tabCard = newOrderModel.PaymentsCreditCards[index];
            if (cardId === index) {
                tabCard.isSelected = true;
            } else {
                tabCard.isSelected = false;
            }
        }
        this.setState({
            cardId
        });
        this.refreshModel(newOrderModel);
    }

    changeCardNum = (value, cardId) => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;

        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        newOrderModel.PaymentsCreditCards[cardId].CrCardNum = value;
        this.refreshModel(newOrderModel);
    }

    validateCardNum = (value, cardId) => {
        const { showAlert, newOrderModel } = this.props;
        //  let regex = /^(?:4\d([\- ])?\d{6}\1\d{5}|(?:4\d{3}|5[1-5]\d{2}|6011)([\- ])?\d{4}\2\d{4}\2\d{4})$/;
        let regex = /^\d{4}$/;
        if (regex.test(value)) {
            return;
        }
        showAlert({ type: 'info', message: 'Formato de tarjeta no valido' });
    }

    changeCardValid = (value, cardId) => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;
        value = value.replace('/', '');
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        if (value.length > 2) {
            if (value.slice(0, 2) > 12) {
                showAlert({ type: 'info', message: 'Fecha incorrecta' });
                return;
            }
            value = value.slice(0, 2) + '/' + value.slice(2);
        }
        newOrderModel.PaymentsCreditCards[cardId].CardValid = value;
        this.refreshModel(newOrderModel);
    }

    ChangeValidateValidCard = (value, cardId) => {
        const { showAlert, newOrderModel } = this.props;

        if (newOrderModel.PaymentsCreditCards[cardId].CardValid.length < 5) {
            showAlert({ type: "warning", message: `La fecha de vencimiento de la tarjeta esta incompleta` });
            return
        }
    }

    changeOwnerIdNum = (value, cardId) => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        newOrderModel.PaymentsCreditCards[cardId].OwnerIdNum = value;
        this.refreshModel(newOrderModel);
    }

    changeOwnerPhone = (value, cardId) => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        newOrderModel.PaymentsCreditCards[cardId].OwnerPhone = value;
        this.refreshModel(newOrderModel);
    }

    keydownHandler = (event, cardId) => {
        const { newOrderModel } = this.props;

        if (event.key.toLowerCase() === 'b' && event.shiftKey) {
            newOrderModel.CreditSum = newOrderModel.totalPago;
            newOrderModel.PaymentsCreditCards[cardId].CreditSum = newOrderModel.totalPago;
            this.refreshTotal(newOrderModel);
        }
    }

    changeCreditSum = (value, cardId) => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;

        if (isNaN(value)) {
            return;
        }
        newOrderModel.PaymentsCreditCards[cardId].CreditSum = value;

        let newModel = this.sumCheck(newOrderModel);
        this.refreshTotal(newModel);
    }

    sumCheck = model => {
        let suma = 0;
        let credits = model.PaymentsCreditCards || [];
        credits.map(credit => {
            suma += parseFloat(credit.CreditSum || 0);
        })

        model.CreditSum = suma;
        return model;
    }

    changeCreditSumOne = event => {
        const { newOrderModel } = this.props;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data !== ' ') {
                newOrderModel.CreditSum = event.nativeEvent.target.value;
            }
        }
        this.refreshTotal(newOrderModel);
    };

    changeVoucherNum = (value, cardId) => {
        const { showAlert, newOrderModel } = this.props;
        if (isNaN(value)) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        newOrderModel.PaymentsCreditCards[cardId].VoucherNum = value;
        this.refreshModel(newOrderModel);
    }

    changeCreditType = async (value, cardId) => {
        const { newOrderModel } = this.props;
        newOrderModel.PaymentsCreditCards[cardId].CreditType = value;
        this.refreshModel(newOrderModel);
    }

    ChangeConfirmed = () => {
        const { newOrderModel } = this.props;
        newOrderModel.Confirmed = !newOrderModel.Confirmed;
        this.setState({
            newOrderModel,
        });

    }

    ChangePartSupply = () => {
        const { newOrderModel } = this.props;
        newOrderModel.PartSupply = !newOrderModel.PartSupply;
        this.setState({
            newOrderModel,
        });

    }

    //#region ######### TIMBRA ###########################################
    AddUuid = async () => {
        const { newOrderModel } = this.props;
        newOrderModel.U_FMB_UUID_RELACIONADO = [...newOrderModel.U_FMB_UUID_RELACIONADO, ""]
        await this.refreshModel(newOrderModel);
    }

    RemoveUuid = async (index) => {
        const { newOrderModel } = this.props;
        let UUID = newOrderModel.U_FMB_UUID_RELACIONADO || [];

        if (UUID.length >= index) {
            UUID.splice(index, 1);
            newOrderModel.U_FMB_UUID_RELACIONADO = UUID;
        }
        if (index === 0) {
            newOrderModel.U_FMB_UUID_RELACIONADO = [];
        }
        await this.refreshModel(newOrderModel);
    }

    HandleChange = async (e, index) => {
        const { newOrderModel } = this.props;

        let UUID = newOrderModel.U_FMB_UUID_RELACIONADO || [];
        let uuidText = e.target.value;
        let exist = false;

        for (var i = 0; i < UUID.length; i++) {
            if (i === index) {
                UUID[i] = uuidText;
                exist = true;
                break;
            }
        }

        if (!exist) {
            UUID.push(uuidText);
        }

        newOrderModel.U_FMB_UUID_RELACIONADO = UUID;


        await this.refreshModel(newOrderModel);


    }
    ChangeU_FMB_TIPO_REL = async (value) => {
        const { newOrderModel } = this.props;
        newOrderModel.U_FMB_TIPO_REL = value;
        await this.refreshModel(newOrderModel);
    }
    //#endregion

    RequestPriceListByItems = async () => {
        const { enableSpinner } = this.props;
        let responseApi = null;

        enableSpinner(true);
        responseApi = await apiClient.getPriceList();
        enableSpinner(false);

        return responseApi;
    }

    ShowGrossProfitModal = async (action) => {
        const { newOrderModel, showAlert, enableSpinner } = this.props
        if (Array.isArray(newOrderModel.Items) && newOrderModel.Items.length === 0) {
            showAlert({ type: 'warning', message: 'AGREGA ARTÍCULOS PARA CONTINUAR' });
            return;
        }
        if (action === 1) {
            await this.FillPricesList(newOrderModel.Items[0].PricesList)
            this.CalculateGrossProfit();
        } else {
            const WhsCodeInLines = newOrderModel?.Items[0]?.WhsCode ?? '';
            const data = {
                ItemsCodes: newOrderModel.Items.map(item => item.ItemCode),
                WhsCode: WhsCodeInLines,
            }
            enableSpinner(true);
            const responseApi = await apiClient.getPriceListByItems(data);
            enableSpinner(false);

            let flag = false;
            if (responseApi.data?.precioItems && responseApi.data?.precioItems.length > 0) {
                for (let x = 0; x < newOrderModel.Items.length; x++) {
                    let ItemInDoc = newOrderModel.Items[x];
                    ItemInDoc.PricesList = responseApi.data?.precioItems.filter(element => element.ItemCode === ItemInDoc.ItemCode) ?? [];
                    flag = true;
                }
            }
            if (flag) {
                this.refreshModel(newOrderModel)
                await this.FillPricesList(newOrderModel.Items[0].PricesList)
                this.CalculateGrossProfit();
            } else {
                await this.GetGrossProfit();
            }
        }
        $('#grossProfitModal').modal('show');
    }

    HideGrossProfitModal = async () => {
        $('#grossProfitModal').modal('hide');
    }

    FillPricesList = async (priceList) => {
        if (Array.isArray(priceList)) {
            // priceList.splice(0, 1); // 1 es la cantidad de elemento a eliminar
            await this.setState({ PricesList: priceList })
        }
    }

    OnchangePriceList = async (value) => {
        await this.setState({ ChoosePriceList: Number(value) });
        this.CalculateGrossProfit();
    }

    CalculateGrossProfit = () => {
        const { newOrderModel } = this.props
        const { ChoosePriceList } = this.state
        let auxArray = [], auxTotProfit = 0, auxTotPrctProfit = 0, salesTotal = 0;
        for (let i = 0; i < newOrderModel.Items.length; i++) {
            const Item = newOrderModel.Items[i];

            let auxSalePrice = Item?.PricesList?.find(({ PriceList }) => Number(PriceList) === Number(ChoosePriceList))?.Price || 0;
            auxSalePrice = Number(auxSalePrice) || 0;
            const price = Number(Item.PriceBefDi || Item.Price);
            const priceTaken = (price - (price * (Number(Item.DiscountPercent) / 100)));

            const GRPF = GROSSPROFIT.new(priceTaken, auxSalePrice);
            auxArray.push({
                ItemCode: Item.ItemCode,
                Description: Item.ItemName,
                BasePrice: auxSalePrice || 0, //lista de precios
                SalePrice: priceTaken, // it was before 
                Quantity: Item.Quantity,
                Profit: GRPF.GrossProfit * Number(Item.Quantity),
                PrctProfit: GRPF.PrcntProfit || '',
            });

            auxTotProfit += Number(GRPF.GrossProfit * Number(Item.Quantity));
            salesTotal += Number((Number(priceTaken) * Number(Item.Quantity)).toFixed(2));
        }
        auxTotPrctProfit = (auxTotProfit / salesTotal * 100).toFixed(2);

        this.setState({
            LinesGrossProfit: auxArray || [],
            TotPrctGrossProfit: auxTotPrctProfit || 0,
            TotalGrossProfit: auxTotProfit || 0,
        })
    }

    GetGrossProfit = async () => {
        const { newOrderModel } = this.props
        let auxArray = [], auxTotProfit = 0, auxTotPrctProfit = 0, salesTotal = 0;
        for (let i = 0; i < newOrderModel.Items.length; i++) {
            const Item = newOrderModel.Items[i];
            const prctGrossProfit = ((Item.Price - Item.GrossBuyPr) / Item.Price) * 100;
            auxArray.push({
                ItemCode: Item.ItemCode,
                Description: Item.ItemName,
                BasePrice: Item.GrossBuyPr,
                SalePrice: Item.Price,
                Quantity: Item.Quantity,
                Profit: Item.GrssProfit,
                PrctProfit: prctGrossProfit,
            });
            auxTotProfit = Number(auxTotProfit) + Number(Item.GrssProfit);
            salesTotal += Number((Number(Item.Price) * Number(Item.Quantity)).toFixed(2));
        }
        auxTotPrctProfit = salesTotal / auxTotProfit;
        this.setState({
            LinesGrossProfit: auxArray || [],
            TotPrctGrossProfit: auxTotPrctProfit,
            TotalGrossProfit: auxTotProfit
        })
    };

    //#region ########## ENVIAR POR CORREO #####################################

    OpenPdfSendMailModal = (docEntry) => {
        const { sendMailModel } = this.state;
        sendMailModel.docEntry = docEntry
        $('#pdfSendMailModal').modal('show');
        this.setState({ sendMailModel });
    }

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async () => {
        const { enableSpinner, showAlert, newOrderModel, selectTable, view, DraftObjType = '', selectDraftTable } = this.props;
        const { sendMailModel } = this.state;
        let table = selectTable(newOrderModel.OriginDocumentCreate);
        let draftTable = view === 'draft' && Number(DraftObjType) > 0 ? selectDraftTable(DraftObjType) : {};
        let isDraftDoc = view === 'draft' && draftTable?.name && draftTable?.name !== 'ODRF';

        let infoDoc = [];
        let newInfoDoc = {
            cardCode: newOrderModel.CardCode ?? '',
            folio: newOrderModel.folio ?? '',
            docEntry: newOrderModel.DocEntry || '',
            slpInfo: {
                slpCode: !!newOrderModel && !!newOrderModel.SlpCode && newOrderModel.SlpCode !== undefined ? newOrderModel.SlpCode : '',
                slpName: !!newOrderModel && !!newOrderModel.SlpName && newOrderModel.SlpName !== undefined ? newOrderModel.SlpName : '',
            }
        }
        infoDoc.push(newInfoDoc);
        let data = {
            sendMailModel,
            typeDoc: isDraftDoc ? draftTable.name : table.name,
            infoDoc,
            isDraftDoc,
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }


        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
        await this.setState({
            sendMailModel: {
                to: '',
                cc: '',
                subject: '',
                message: '',
                docEntry: null,
            }
        })
        $('#pdfSendMailModal').modal('hide');
    }

    RenderMailModal = () => {
        const { view, newOrderModel, isDraftOWTQ = false } = this.props;
        const { sendMailModel } = this.state;
        const ShowExtraActions = ((view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'invoiceReserve' || view === 'payment') && newOrderModel.U_UDF_UUID) ? true : false;
        let mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendEmail: this.SendDocsByEmail
        }
        return (
            <SendMailModal
                MailTools={mailTools}
                SendEmail={this.SendDocsByEmail}
                ShowExtraActions={ShowExtraActions}
                suggestedEmail={!!newOrderModel && view !== 'transfers' && view !== 'transfersRequest' && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'deliveries' && view !== 'return' && view !== 'PurchaseRequest' && !isDraftOWTQ ? (newOrderModel.Email || newOrderModel.E_Mail || "") : ""}
            />
        )
    }

    //#endregion

    //#region ########## BATCH ####################################

    OpenBatchReportModal = async () => {
        const { enableSpinner, showAlert, newOrderModel, selectTable } = this.props;
        let data = {
            docEntry: newOrderModel.DocEntry,
            objType: newOrderModel.ObjType,
        }
        enableSpinner(true);
        let batchsResponse = await apiClient.getBatchReport(data);
        enableSpinner(false);

        if (batchsResponse.status === 0) {
            showAlert({ type: "error", message: `${batchsResponse.message ?? ''}` });
            return;
        }

        if (batchsResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        await this.setState({
            BatchReports: batchsResponse.data
        });

        $('#batchReportModal').modal('show');
    }

    RefreshBatchs = async (BatchReports) => {
        await this.setState({
            BatchReports
        });
    }

    //#endregion

    //#region MRP
    changeDpstType = event => {
        const { newOrderModel } = this.props;
        newOrderModel.DpstType = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeObjAbs = event => {
        const { newOrderModel } = this.props;
        newOrderModel.ObjAbs = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeFromDate = event => {
        const { newOrderModel } = this.props;
        newOrderModel.FromDate = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeToDate = event => {
        const { newOrderModel } = this.props;
        newOrderModel.ToDate = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeFromDate3 = event => {
        const { newOrderModel } = this.props;
        newOrderModel.FromDate3 = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeToDate3 = event => {
        const { newOrderModel } = this.props;
        newOrderModel.ToDate3 = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeItmFrom1 = event => {
        const { newOrderModel } = this.props;
        newOrderModel.ItmFrom1 = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeItmTo1 = event => {
        const { newOrderModel } = this.props;
        newOrderModel.ItmTo1 = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeItmGroup = event => {
        const { newOrderModel } = this.props;
        newOrderModel.ItmGroup = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeCardFrom1 = event => {
        const { newOrderModel } = this.props;
        newOrderModel.CardFrom1 = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    changeCardTo1 = event => {
        const { newOrderModel } = this.props;
        newOrderModel.CardTo1 = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    // sendModel = () => {
    searchRecommendation = async event => {
        const { showAlert, newOrderModel, view, enableSpinner } = this.props;

        if (newOrderModel.ObjAbs === -1 || newOrderModel.ObjAbs === '-1') {
            showAlert({ type: 'info', message: 'Selecciona un escenario' });
            return;
        }

        this.refreshModel(newOrderModel);
        // this.tableOrderRecommendation.enableDataTable();

        let model = {
            DpstType: newOrderModel.DpstType,
            ObjAbs: newOrderModel.ObjAbs,
            FromDate: newOrderModel.FromDate,
            ToDate: newOrderModel.ToDate,
            FromDate3: newOrderModel.FromDate3,
            ToDate3: newOrderModel.ToDate3,
            ItmFrom1: newOrderModel.ItmFrom1,
            ItmTo1: newOrderModel.ItmTo1,
            ItmGroup: newOrderModel.ItmGroup,
            CardFrom1: newOrderModel.CardFrom1,
            CardTo1: newOrderModel.CardTo1,
        }
        enableSpinner(true)
        let response = await apiClient.getOrderRecommendation(model);
        enableSpinner(false)
        if (response.data.length === 0) {

            if (!Array.isArray(response.data)) {
                showAlert({ type: 'info', message: response.message });
                return;
            }

            if (response.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        await this.setState({
            showOrderRecommendation: true,
            listOrderRecommendation: response.data,
        });
        $('#orderRecommendation').modal('show');
    };

    refreshDataRecommendation = (index, field, value) => {
        const { listOrderRecommendation } = this.state
        const newOrdersList = listOrderRecommendation.slice()

        if (field === "OrderType") {
            const orderTypeOptions = [{ key: 'P', value: "Pedido" }, { key: 'Q', value: "Oferta de compra" }, { key: 'R', value: "Solicitud de compra" }, { key: 'T', value: "Solicitud de traslado" }, { key: 'W', value: "Orden de fabricación" }]
            const find = orderTypeOptions.find(orderType => orderType.key === value)
            newOrdersList[index].OrderType = value
            newOrdersList[index].OrderTypeDesc = find.value
            newOrdersList[index].FromWhse = '';
            this.setState({
                valueSelected: value,
                indexSelected: index,
                listOrderRecommendation: newOrdersList,
                recommendationOrderType: newOrdersList[index].OrderTypeDesc,
                recommendationOrderWhs: newOrdersList[index].Warehouse,
                recommendationOrderItem: newOrdersList[index].ItemCode,
            })
            $('#ConfirmCancelModal').modal('show');
        } else {
            newOrdersList[index][field] = value;
            this.setState({ listOrderRecommendation: newOrdersList })
        }
    }

    clearRecommendationSelect = () => {
        this.setState({
            valueSelected: '',
            indexSelected: null,
        })
    }

    changeAllRecommendation = () => {
        const { indexSelected, valueSelected, listOrderRecommendation } = this.state
        if (indexSelected) {
            const orderTypeOptions = [{ key: 'P', value: "Pedido" }, { key: 'Q', value: "Oferta de compra" }, { key: 'R', value: "Solicitud de compra" }, { key: 'T', value: "Solicitud de traslado" }, { key: 'W', value: "Orden de fabricación" }]
            const find = orderTypeOptions.find(orderType => orderType.key === valueSelected)
            const newOrdersList = listOrderRecommendation.slice()
            const orderSelected = newOrdersList[indexSelected]
            for (let index = 0; index < newOrdersList.length; index++) {
                const order = newOrdersList[index];
                if (order.ItemCode === orderSelected.ItemCode && order.Warehouse === orderSelected.Warehouse) {
                    order.OrderType = valueSelected
                    order.OrderTypeDesc = find.value
                }
            }
            this.setState({
                listOrderRecommendation: newOrdersList
            })
            this.clearRecommendationSelect()
        }
    }
    //#endregion



    //#region LEYENDAS FISCALES
    Add_LeyendasFiscales = async () => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;

        const data = {
            DocEntry: newOrderModel.DocEntry || '',
            ObjType: newOrderModel.ObjType || '',
            LeyendasFiscales: newOrderModel.LeyendasFiscales,
            isLeyendasFiscales: newOrderModel.isLeyendaFiscal ? 'Y' : 'N',
        };

        enableSpinner(true);
        let createDefinition = await apiClient.createNewLeyendaFiscal(data);
        enableSpinner(false);

        if (!createDefinition.status || createDefinition.status !== 1) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + createDefinition.message, timeOut: 5000 });
            await this.setState({
                showAreYouAgreeModal: false,
            });
            return;
        }
        showAlert({ type: "success", message: createDefinition.message, timeOut: 5000 });
    }
    //#endregion

    //#region COMERCIO EXTERIOR
    Add_ComercioExterior = async () => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;

        const data = {
            DocEntry: newOrderModel.DocEntry || '',
            ObjType: newOrderModel.ObjType || '',
            ComercioExterior: newOrderModel.ComercioExterior,
            isComercioExterior: newOrderModel.isComercioExterior || 'N',
        };

        enableSpinner(true);
        let createComercio = await apiClient.createNewComercioExterior(data);
        enableSpinner(false);

        if (!createComercio.status || createComercio.status !== 1) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + createComercio.message, timeOut: 5000 });
            await this.setState({
                showAreYouAgreeModal_Comercio: false,
            });
            return;
        }
        await this.setState({
            showAreYouAgreeModal_Comercio: false,
        });
        showAlert({ type: "success", message: createComercio.message, timeOut: 5000 });
    }
    //#endregion

    //#region ############### OXXO SERVICES ########
    UpdateStateField = async (key, value) => {
        await this.setState({
            [key]: value
        })
    }

    PrepareOxxoComp = async () => {
        const { newOrderModel } = this.props
        const infoOxxo = {
            DocEntry: newOrderModel?.DocEntry,
            ObjType: newOrderModel?.ObjType,
            SubType: '--',
            Param: newOrderModel?.ReserveInvoice === 'tYES' ? 'Y' : 'N' ?? 'N',
            IdOxxoRef: newOrderModel?.IdOxxoRef ?? -1,
        }
        await this.UpdateStateField('infoOxxo', infoOxxo)
        await this.UpdateStateField('enableOxxoInfo', true)

        // await this.setState({
        //     enableOxxoInfo: true
        // })



    }


    //#endregion

    getInvType = (item = {}) => {
        const { docType = '', DocSubType = '--', Memo = '' } = item;

        const docTypes = {
            '13': DocSubType === '--' ? 'Factura de cliente' : 'Nota de débito cliente',
            '14': 'Nota de crédito cliente',
            '18': DocSubType === '--' ? 'Factura de proveedores' : 'Nota de débito proveedor',
            '19': 'Nota de crédito proveedor',
            '203': 'Anticipo de cliente',
            '204': 'Anticipo de proveedor',
            '24': 'Pago recibido',
            '25': 'Depósito',
            '46': 'Aviso de pago',
            '57': 'Cheque para pago',
            '76': 'Depósito posfechado',
            '-2': 'Saldo de apertura',
            '-3': 'Saldo de cierre',
            '163': 'Factura de corrección proveedor',
            '165': 'Factura de corrección cliente'
        };

        //#region Asientos contables
        if (String(docType) === '30') {
            let journalTitle = 'Registro en el diario';

            if (Memo) {
                const memoLower = Memo?.toLowerCase()
                    ?.normalize("NFD")
                    ?.replace(/[\u0300-\u036f]/g, "");

                if (memoLower?.includes('percepcion'))
                    journalTitle = 'Asiento de percepción';
                else if (memoLower?.includes('letra'))
                    journalTitle = 'Asiento de letras';
                else if (memoLower?.includes('retencion'))
                    journalTitle = 'Asiento de retención';
                else
                    journalTitle = `Registro en el diario - ${Memo}`;
            }

            return journalTitle;
        }
        //#endregion Asientos contables

        return docTypes[docType] || 'Documento no identificado';
    };

    //#region Cancel IncomingPayment
    cancelPayment = async () => {
        const { newOrderModel = {}, enableSpinner, showAlert, CloseDocumentModal, searchDocuments } = this.props;
        const { cancelCurrentDate } = this.state;
        const { DocEntry } = newOrderModel ?? {};
        if (!DocEntry || !newOrderModel.canCancelIncomingPayment) {
            $('#areYouAgreeModal').modal('hide');
            setTimeout(async () => {
                await this.setState({
                    showAreYouAgreeModal: false,
                });
            }, 500);
            return
        };

        let datos = {
            currentDate: cancelCurrentDate,
            DocEntry,
            isPaymentView: true,
        }
        enableSpinner(true);
        let CancelIncomingPayments = await apiClient.CancelIncomingPayments(datos);
        enableSpinner(false);

        if (CancelIncomingPayments?.status === 1) {
            showAlert({ type: "success", message: CancelIncomingPayments?.message, timeOut: 8000, });
        } else {
            showAlert({ type: "error", message: CancelIncomingPayments?.message || 'Ocurrió un error al cancelar el pago', timeOut: 8000, });
        }

        $('#areYouAgreeModal').modal('hide');
        setTimeout(async () => {
            await this.setState({
                showAreYouAgreeModal: false,
            }, async () => {
                if (CancelIncomingPayments?.status === 1) {
                    $('#DocumentCreateModal').modal('hide');
                    await CloseDocumentModal();
                    await searchDocuments();
                }
            });
        }, 500);
    }

    ValidateCancelDate = async () => {
        const { newOrderModel } = this.props;
        const documentDate = moment(newOrderModel.TaxDate).utc().format("DD-MM-YYYY");
        const todayDate = moment(new Date()).format("DD-MM-YYYY");
        if (documentDate !== todayDate) {
            $('#cancelDateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        } else {
            this.OpenShowAreYouAgreeModal();
        }
    }

    OpenShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
        });
        $('#areYouAgreeModal').modal('show');
    }

    changeCancelDate = async (value) => {
        await this.setState({ cancelCurrentDate: value });
    }

    CloseShowAreYouAgreeModal = async () => {
        $('#areYouAgreeModal').modal('hide');
        setTimeout(async () => {
            await this.setState({
                showAreYouAgreeModal: false,
            });
        }, 500);
    }

    //#endregion Cancel IncomingPayment

    clickPriceCalculate = (index = null) => {
        if (Number(index) >= 0) {
            this.setState({
                showPriceModal: true,
                itemIndex: index,
                totalPriceInput: ''
            });
        }
    }

    closeCalculatorModal() {
        this.setState({
            showPriceModal: false,
            itemIndex: null,
            totalPriceInput: null
        })
    }

    changeVatPrice = async (index, value) => {
        const { newOrderModel } = this.props;
        newOrderModel.Items[index].PriceAfterVAT = value;
        await this.refreshModel(newOrderModel)
    }

    changeCFW = async (event = null, type = 1) => {
        const { newOrderModel } = this.props;
        const value = event?.value ?? event?.nativeEvent?.target?.value ?? null;
        const cfwFields = {
            1: 'transferCFWId',
            2: 'cashCFWId',
            3: 'checkCFWId'
        };
        newOrderModel[cfwFields[type]] = value;
        await this.refreshModel(newOrderModel);
    };

    getORDRTransports = async () => {
        const { showAlert, newOrderModel, enableSpinner, getUserFieldHeaderValue } = this.props;
        const U_FMB_AttentionType = await getUserFieldHeaderValue('U_FMB_AttentionType', newOrderModel); // Tipo de atención

        if (U_FMB_AttentionType !== 'RCF') {
            showAlert({ type: 'info', message: 'Esta opción se encuentra disponible únicamente para el Tipo de Atención Ruta CF' });
            return;
        }

        if (!newOrderModel?.Items?.length) {
            showAlert({ type: 'info', message: 'Debe de agregar al menos un artículo' });
            return;
        }

        let DocumentLines = [];

        for (const item of newOrderModel?.Items) {
            const { ItemCode = '', Quantity = 0 } = item ?? {};
            DocumentLines.push({
                ItemCode,
                Quantity,
                qtyGLNToKGM: Quantity,
            })
        }

        let data = {
            sapDocument: {
                CardCode: newOrderModel?.CardCode || '',
                ShipToCode: newOrderModel?.ShipToCode || '',
                DocumentLines
            }
        }

        enableSpinner(true);
        let responseApi = await apiClient.getORDRTransports(data);
        enableSpinner(false);
        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            if (!responseApi?.data?.length) {
                showAlert({ type: 'info', message: 'No se encontró ningún transporte disponible' });
                return;
            }
            this.setState({
                ORDRTransports: responseApi?.data ?? [],
                showORDRTransportsModal: true,
            }, () => {
                $("#ordrTransportsModal").modal("show");
            })
        } else {
            showAlert({ type: 'warning', message: responseApi?.message ?? 'No se encontraron resultados' });
        }
    }

    selectORDRTransport = async (action) => {
        const { ORDRTransports = [] } = this.state;
        const { newOrderModel } = this.props;
        const { CodigoAutotransporte = '', CodigoUnidad = '', PlacaVM = '', WhsCode = '', WhsName = '', AcctCode = '', AcctCode2 = '', AcctName = '', FormatCode = '', FormatCode2 = '' } = ORDRTransports?.[action?.index] ?? {};
        newOrderModel.CodigoAutotransporte = CodigoAutotransporte;
        newOrderModel.CodigoUnidad = CodigoUnidad;
        newOrderModel.PlacaVM = PlacaVM;
        const whsInfo = {
            WhsCode,
            WhsName,
            AcctCode,
            AcctCode2,
            AcctName,
            FormatCode,
            FormatCode2,
        }
        newOrderModel.TransportWhs = whsInfo;

        let newPrice = false;
        if (!WhsCode) {
            for (let index = 0; index < newOrderModel?.Items?.length; index++) {
                let item = newOrderModel?.Items?.[index];
                item.whsSelected = false;
                item.WhsCode = '';
                item.WhsName = '';
                //#region Precio Llamagas
                const envasado = Envasados?.includes(Number(item?.ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(item?.ItmsGrpCod));
                if (!item?.isTemporary && (envasado || glpGranel)) { // Si el articulo es GLP Granel o Envasado mandar precio a 0 ya que el precio depende del almacén
                    newPrice = true;
                    item.HomePrice = 0;
                    item.Price = 0;
                }
                //#endregion Precio Llamagas
                //#region DIMENSIONS
                item.OcrCode2 = '';
                item.OcrCode3 = '';
                item.Dimension2 = false;
                item.Dimension3 = false;
                //#endregion DIMENSIONS
            }
        }

        $('#ordrTransportsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                ORDRTransports: [],
                showORDRTransportsModal: false
            });
        }, 100);
        if (!newPrice) {
            await this.refreshModel(newOrderModel);
        } else {
            await this.refreshTotal(newOrderModel);
        }

        setTimeout(async () => {
            if (WhsCode && newOrderModel?.Items?.length) {
                for (let index = 0; index < newOrderModel?.Items?.length; index++) {
                    let item = newOrderModel?.Items?.[index];
                    if (WhsCode) {
                        await this.SearchAlmacen(index, WhsCode, item?.ItemCode, true)
                    }
                }
            }
        }, 100);
    }

    removeORDRTranport = async () => {
        const { newOrderModel } = this.props;
        //#region Transportes de ORDR
        newOrderModel.CodigoAutotransporte = '';
        newOrderModel.CodigoUnidad = '';
        newOrderModel.PlacaVM = '';
        newOrderModel.TransportWhs = {};
        //#endregion Transportes de ORDR
        await this.refreshModel(newOrderModel);
    }

    render() {
        const { action, view, newOrderModel, showAlert, enableSpinner, openConfigUserFieldsHeaders, configHeaderUserFields, CloseDocumentModal, writeAccess, docFilter, generateTXT, downloadTXT, createDocRecommend, showDocs, SendAprovedPartial, setWhsByRouteDocs, getDimension1ByUserField, isDraftOWTQ = false } = this.props;
        const { isSelectTo, isSelectOf } = newOrderModel;

        let status = newOrderModel.StatusDocument === 'Cerrado' ? 0 : 1;
        let docStatusCasco = newOrderModel.DocStatusCasco || '';
        let statusAuthorized = newOrderModel.Status === 'W' || newOrderModel.Status === 'WN' ? 'Pendiente' : newOrderModel.Status === 'Y' ? 'Autorizado' : newOrderModel.Status === 'N' ? 'Rechazado' : newOrderModel.Status;
        let itemBaseType = action === 2 ? newOrderModel.Items.filter((item) => item.BaseType == '13') : [];
        const {
            partners,
            series,
            series2,
            series3,
            contacts,
            warehouses,
            items,
            taxes,
            centroCostes,
            employees,
            owners,
            prices,
            accounts,
            currencies,
            invoicesPayments,
            editMode,
            checkItemCreateInfo,
            users,
            departments,
            branches,
            partnerType,
            pageTotal,
            Codigo,
            CardName,
            Balance,
            Asiento,
            AsientoContable,
            CardCodeBalance,
            AccountBalan,
            AccountBalanceData,
            projects,
            transactions,
            paymentList,
            indexPurchaseRequest,
            editAddress,
            cardList,
            itemSelected,
            SearchWhs,
            BatchReports,
            isCancelCFDI,
            enableTransfersList,
            showOrderRecommendation,
            listOrderRecommendation,
            _user,
            showLocationAssignment,
            optionLocation,
            lineNumLocation,
            locations,
            showListLocationsModal,
            positionLine,
            showDocumentStock,
            documentStock,
            locationModel,
            showLocationModal,
            uomCodes,
            showAreUAgree,
            CancelAction,
            AcceptAction,
            showFormattedQueriesModal,
            formattedInfo = {},
            cancelCurrentDate,
            showAreYouAgreeModal,
            showBinLocationsModal,
            listBinLocations,
            showPropietarioCreateModal,
            showPriceModal,
            itemIndex,
            ORDRTransports = [],
            showORDRTransportsModal,
        } = this.state;
        let auxiModel = {
            CardCode: ''
        }
        const isAccountPayment = newOrderModel?.isAccountPayment;
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="DocumentCreateModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ zIndex: 90 }}>

                {enableTransfersList &&
                    <ListPartnerModal
                        data={this.state.transfersListCEDIS}
                        modalView={"T"}
                        totalPage={pageTotal}
                        model={auxiModel}
                        cleanData={() => this.setState({
                            transfersListCEDIS: [],
                            partners: [],
                            invoices: [],
                            checkboxArray: (new Map())
                        })}
                        selectPartner={this.selectPartner}
                        type={partnerType}
                        selectItems={this.SaveCheckBoxTransfers}
                        selectItemsToArray={this.selectItemsToArray}
                        checkboxArray={this.state.checkboxArray}
                        refreshPartner={this.refreshPartner}
                        showAlert={showAlert}
                        search={this.searchDocuments}
                        newOrderModel={newOrderModel}
                        view={view}
                    />
                }

                {showAreUAgree &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro de que quieres agregar los archivos seleccionados? No podrás modificarlos después.'}
                        cancel={CancelAction}
                        accept={AcceptAction}
                        cleanData={() => this.setState({ showAreUAgree: false })}
                    />
                }

                <TransactionsModal
                    data={transactions}
                    selectAccount={this.selectAccountList}
                    cleanData={() => this.setState({ transactions: [] })}
                />
                <PaymentListModaL
                    data={paymentList}
                    selectAccount={this.selectAccountList}
                    cleanData={() => this.setState({ transactions: [] })}
                />
                <ProjectsModal
                    data={projects}
                    selectTaxe={this.selectProjects}
                    cleanData={() => this.setState({ projects: [] })}
                />
                <AccountBalance
                    CardCodeBalance={CardCodeBalance}
                    AccountBalan={AccountBalan}
                    newOrderModel={newOrderModel}
                    AccountBalanceData={AccountBalanceData}
                    openAccountBalance={this.openAccountBalance}
                />
                <ConfirmModal
                    CloseDocumentModal={CloseDocumentModal} />

                <ConfirmCurrencyModal
                    confirmCurrency={this.confirmCurrency}
                />

                <CancelDocuments
                    CancelDocuments={this.CancelDocuments} />


                <CancelCFDI
                    CancelDocuments={this.CancelCFDI} />

                <CancelPaymentModal
                    cancelCurrentDate={cancelCurrentDate}
                    changeCancelDate={this.changeCancelDate}
                    continueAction={this.OpenShowAreYouAgreeModal}
                />

                {showAreYouAgreeModal &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro que deseas cancelar el pago?'}
                        accept={this.cancelPayment}
                        cancel={this.CloseShowAreYouAgreeModal}
                    />
                }

                <AsientoContableModal
                    Asiento={Asiento}
                    AsientoContable={AsientoContable}


                />
                <CreditLimitModal
                    Balance={Balance}
                    Codigo={Codigo}
                    CardName={CardName}
                    clearSocio={this.clearSocio}
                    view={view}
                />
                <SelectOfModal
                    showAlert={showAlert}
                    enableSpinner={enableSpinner}
                    newOrderModel={newOrderModel}
                    addItem={this.selectOfDocuments}
                    view={view}
                    ref={(ref) => this.selectOfReference = ref
                    }
                />
                <PartnerCreateModal
                    data={partners}
                    type={partnerType}
                    totalPage={pageTotal}
                    newOrderModel={newOrderModel}
                    selectPartner={this.selectPartner}
                    cleanData={() => this.setState({ partners: [] })}
                    refreshPartner={this.refreshPartner}
                    indexPurchaseRequest={indexPurchaseRequest}
                    view={view}
                />
                <ItemsCreateModal
                    data={items}
                    totalPage={pageTotal}
                    newOrderModel={newOrderModel}
                    mainView={view}
                    selectItems={this.selectItems}
                    cleanData={() => this.setState({ items: [] })}
                    refreshItems={this.refreshItems}
                />
                <BranchesModal
                    data={branches}
                    selectBranches={this.selectBranches}
                    cleanData={() => this.setState({ branches: [] })}
                />
                <DepartmentsModal
                    data={departments}
                    selectDepartments={this.selectDepartments}
                    cleanData={() => this.setState({ departments: [] })}
                />
                <SeriesCreateModal
                    data={series}
                    selectSerie={this.selectSeries}
                    cleanData={() => this.setState({ series: [] })}
                />
                <SeriesCreateModale
                    data={series2}
                    selectSerie={this.selectSeries2}
                    cleanData={() => this.setState({ series2: [] })}
                />
                <SeriesPagoModal
                    data={series3}
                    selectSerie={this.selectSeries3}
                    cleanData={() => this.setState({ series3: [] })}
                />
                <PersonContactModal
                    data={contacts}
                    selectContact={this.selectContact}
                    cleanData={() => this.setState({ contacts: [] })}
                />
                <AlmacenModal
                    data={warehouses}
                    view={view}
                    itemSelected={itemSelected}
                    selectAlmacen={this.selectAlmacen}
                    cleanData={() => this.setState({ warehouses: [], itemSelected: '' })}
                />

                <ImpuestoCreateModal
                    data={taxes}
                    selectTaxe={this.selectTaxes}
                    cleanData={() => this.setState({ taxes: [] })}
                />
                <CentroCosteModal
                    data={centroCostes}
                    selectCentroCoste={this.selectCentroCoste}
                    cleanData={() => this.setState({ centroCostes: [] })}
                />
                <UomCodeModal
                    data={uomCodes}
                    selectUomCode={this.selectUomCode}
                    cleanData={() => this.setState({ uomCodes: [] })}
                />
                <EmployeeSalesModal
                    data={employees}
                    selectEmployee={this.selectEmployee}
                    cleanData={() => this.setState({ employees: [] })}
                />
                {users.length > 0 &&
                    <UsersModal
                        data={users}
                        selectUser={this.selectUser}
                        cleanData={() => this.setState({ users: [], openPersonRequest: false })}
                    />
                }
                {showPropietarioCreateModal &&
                    <PropietarioCreateModal
                        data={owners}
                        selectPropietario={this.selectPropietario}
                        cleanData={() => this.setState({ owners: [], openPersonRequest: false, showPropietarioCreateModal: false })}
                    />
                }
                <PriceListModal
                    data={prices}
                    selectPriceList={this.selectPriceList}
                    cleanData={() => this.setState({ prices: [] })}
                />

                <CardsListModal
                    data={cardList}
                    selectAccount={this.selectCardList}
                    cleanData={() => this.setState({ cardList: [] })}
                />

                <AccountListModal
                    data={accounts}
                    selectAccount={this.selectAccountList}
                    cleanData={() => this.setState({ accounts: [] })}
                />

                <InvoicesPaymentModal
                    data={invoicesPayments}
                    selectItems={this.selectInvoicePayment}
                    cleanData={() => this.setState({ invoicesPayments: [] })}
                />

                <CheckListModal
                    action={action}
                    model={newOrderModel}
                    dataInfo={checkItemCreateInfo}
                    refreshTotal={this.refreshTotal}
                    addNewItem={this.addNewItemCheck}
                    deleteItem={this.deleteItemCheck}
                    isAccountPayment={isAccountPayment}
                />

                {showBinLocationsModal && <StandardSelectModal
                    id="sucursalLocationsModal"
                    title={"TRANSPORTES"}
                    headers={[
                        { title: "Ubicación", value: true, filter: true, field: "BinCode" },
                    ]}
                    data={listBinLocations ?? []}
                    selectAction={this.selectBinLocation}
                    selectedItems={[]}
                    disabled={false}
                    idSelection="BinCode"
                    validNoSelection={true} />}

                <UserFieldsModal
                    newOrderModel={newOrderModel}
                    action={action}
                    refreshModel={this.refreshModel}
                    view={view}
                    hanldeUserFields={this.hanldeUserFields}
                    newView={newOrderModel.newView}
                    editMode={editMode}
                    openConfigUserFieldsHeaders={openConfigUserFieldsHeaders}
                    configHeaderUserFields={configHeaderUserFields}
                    setWhsByRouteDocs={setWhsByRouteDocs}
                    getDimension1ByUserField={getDimension1ByUserField}
                    checkWithHolding={this.checkWithHolding}
                    checkItemPrices={this.checkItemPrices}
                    isDraftOWTQ={isDraftOWTQ}
                />

                <MonedaModal
                    data={currencies}
                    selectCurrency={this.selectCurrency}
                    cleanData={() => this.setState({ currencies: [] })}
                />

                <AddressesModal
                    data={newOrderModel.Addresses}
                    selectAddresses={this.selectAddresses}
                    edditAddres={this.edditAddres}
                    cleanData={() => { }}
                />

                <CfdiCreateModal />

                {editAddress &&
                    <AddressModal
                        address={editAddress}
                        refreshAddress={this.refreshAddress}
                        aceptEditAddress={this.aceptEditAddress}
                        cleanData={() => this.setState({ editAddress: null })} />
                }

                <ValidationBatchsModal
                    SearchWhs={SearchWhs}
                    newOrderModel={newOrderModel}
                    refreshModel={this.refreshModel}
                    SearchAlmacen={this.SearchAlmacen} />

                {BatchReports.length > 0 &&
                    <BatchReportModal
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        RefreshBatchs={this.RefreshBatchs}
                        BatchReports={BatchReports}
                        CleanData={() => this.setState({ BatchReports: [] })} />}
                {showOrderRecommendation &&
                    <OrderRecommendation
                        data={listOrderRecommendation}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        newOrderModel={newOrderModel}
                        addItem={this.selectOfDocuments}
                        view={view}
                        ref={(ref) => this.tableOrderRecommendation = ref}
                        cleanData={() => this.setState({ showOrderRecommendation: false })}
                        createDocRecommend={createDocRecommend}
                        showDocs={this.showDocs}
                        refreshData={this.refreshDataRecommendation}
                        searchAlmacen={this.SearchAlmacen} />
                }
                {showLocationAssignment &&
                    <LocationAssignment
                        newOrderModel={newOrderModel}
                        option={optionLocation}
                        lineNumLocation={lineNumLocation}
                        changeBatFromWarehouse={this.changeBatFromWarehouse}
                        CleanData={() => this.setState({ showLocationAssignment: false, showListLocationsModal: false })}
                        openLocations={this.openLocations}
                        changeSearchLocations={this.changeSearchLocations}
                        locations={locations}
                        pageTotal={pageTotal}
                        cleanData={() => this.setState({ locations: [] })}
                        showListLocationsModal={showListLocationsModal}
                        refreshLocations={this.refreshLocations}
                        changeBatToWarehouse={this.changeBatToWarehouse}
                        selectLocation={this.selectLocationsEnter}
                        updateModel={this.refreshModel}
                        showAlert={showAlert}
                        action={action}
                        editMode={editMode}
                        view={view}
                    />
                }

                {/* {showListLocationsModal &&
                    <ListLocationsModal
                        data={locations}
                        totalPage={pageTotal}
                        newOrderModel={newOrderModel}
                        mainView={'transfers'}
                        selectLocation={this.selectLocationsEnter}
                        cleanData={() => this.setState({ locations: [], showListLocationsModal: false })}
                        refreshLocations={this.refreshLocations}
                        LineNum={positionLine}
                    />
                } */}

                {showDocumentStock &&
                    <DocumentStockModal
                        data={documentStock}
                        enableSpinner={enableSpinner}
                        openLocation={this.openLocationDetails}
                        formatNumber={formatNumber}
                        isMarketingDoc={(newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument) || false}
                    />
                }

                {showLocationModal &&
                    <LocationModal
                        model={locationModel}
                        enableSpinner={enableSpinner} />
                }

                {showFormattedQueriesModal &&
                    <FormattedQueriesModal
                        formattedInfo={formattedInfo}
                        formattedMap={newOrderModel?.formattedMap}
                        view={view}
                        selectFormattedQueries={this.selectFormattedQueries}
                        cleanData={() => this.setState({ formattedInfo: {}, showFormattedQueriesModal: false })}
                    />
                }

                {showPriceModal &&
                    <CalculatorModal
                        title="Precio total"
                        placeholder="Ingrese el precio"
                        btnAccept="Guardar"
                        btnCancel="Cancelar"
                        accept={(value) => { this.validatePriceNull(itemIndex, value); this.closeCalculatorModal(); }}
                        acceptAmount={(value) => { this.changeVatPrice(itemIndex, value) }}
                        cancel={() => { this.closeCalculatorModal() }}
                        newOrderModel={newOrderModel}
                        itemIndex={itemIndex}
                    />
                }
                {showORDRTransportsModal &&
                    <ORDRTransportsModal
                        data={ORDRTransports}
                        selectORDRTransport={this.selectORDRTransport}
                        cleanData={() => this.setState({ ORDRTransports: {}, showORDRTransportsModal: false })}
                    />
                }

                <ConfirmCancelModal
                    title={`¿Desea modificar el tipo de pedido a ${this.state.recommendationOrderType} para todas las líneas con el artículo ${this.state.recommendationOrderItem} y el almacén ${this.state.recommendationOrderWhs}?`}
                    firstBtnTitle={"SI"}
                    secndBtnTitle={"NO"}
                    firstBtnAction={() => this.changeAllRecommendation()}
                    secndBtnAction={() => { }}
                />
                {this.RenderMailModal()}

                <div className="modal-dialog modal-xl modal-open modalOrder" role="document">
                    <div className="modal-content" id="printThis">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                {this.renderTitleModal()}
                            </h4>
                            <button type="button" className="close" onClick={this.closeModalCreate} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="container">
                                {this.RenderToolBar()}
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table style={{ marginBottom: 0, tableLayout: 'fixed' }}>
                                                {this.renderSelector()}
                                                {this.renderDocumentsPagosTipo()}
                                                {this.renderContentColumnCreate()}
                                                <tr className="row">
                                                    {this.renderEditButton()}
                                                    {this.renderEditButton2()}
                                                </tr>
                                                {this.renderPartidasColumnCreate()}
                                                {this.renderContentColumnTwoCreate()}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            {newOrderModel.U_UDF_UUID && action === 2 &&
                                <>
                                    {!isCancelCFDI ?
                                        <button
                                            type="button"
                                            className="btn btn-info text-white "
                                            style={{ position: "absolute", left: "1rem" }}
                                            onClick={this.ConsultarEstatusCFDI}
                                        >
                                            Consultar estatus
                                        </button>
                                        :
                                        <button
                                            type="button"
                                            className="btn btn-danger text-white "
                                            style={{ position: "absolute", left: "1rem" }}
                                            onClick={this.OpenModalCancelCFDI}
                                        >
                                            Solicitar cancelacion
                                        </button>
                                    }
                                </>
                            }
                            {(action === 2 && view === 'citibanamex') &&
                                (newOrderModel.U_FMB_Bank_Status !== 'N' ?
                                    <button
                                        type="button"
                                        className="btn btn-info text-white "
                                        style={{ position: "absolute", left: "1rem" }}
                                        onClick={() => downloadTXT(newOrderModel, docFilter)}>
                                        Descargar TXT
                                    </button>
                                    :
                                    <button
                                        type="button"
                                        className="btn btn-success text-white "
                                        style={{ position: "absolute", left: "1rem" }}
                                        onClick={() => generateTXT([], docFilter, newOrderModel)}>
                                        Generar TXT
                                    </button>
                                )
                            }

                            {(action === 2 && view === 'deliveries' && itemBaseType.length > 0) &&
                                <button
                                    type="button"
                                    className="btn btn-danger text-white "
                                    style={{ left: "1rem" }}
                                    onClick={this.OpenModalCloseDocuments}>
                                    Cancelar
                                </button>
                            }

                            {status === 1 && Number(action) === 2 && !editMode && writeAccess && (view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'invoice' || view === 'debitNote' || view === 'invoiceReserve' || view === 'GoodsReceipt' || view === 'SalesHelmets' || view === 'purchaseInvoice' || view === 'PurchaseRequest' || (view === 'transfersRequest' && _user?.Branch?.U_FMB_WHS_TYPE !== '7')) && (
                                <label className="btn text-white copiarA">
                                    <select name="select" className="btn botonCorrect text-white copiarAA"
                                        value={'--'}
                                        onChange={this.selectTo}>
                                        <option value="--">Copiar a ...</option>
                                        {(view === 'quotations') && <option value="orderSales">Orden de Venta</option>}
                                        {(view === 'orderSales' || view === 'quotations' || (view === 'invoiceReserve' && (newOrderModel.StatusDocument === 'Abierto' || newOrderModel.StatusDocument === 'Pagado'))) &&
                                            <option value="deliveries">Entrega</option>}
                                        {(view === 'deliveries') && <option value="return">Devolución</option>}
                                        {(view === 'orderSales' || view === 'deliveries' || view === 'quotations') &&
                                            <option value="invoice">Factura</option>}
                                        {(view === 'orderSales' || view === 'quotations') &&
                                            <option value="invoiceReserve">Factura res.</option>}
                                        {(view === 'invoice' || view === 'debitNote' || (view === 'invoiceReserve' && newOrderModel.StatusDocument !== 'Pagado')) &&
                                            <option value="creditNote">Nota de Crédito</option>}
                                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation') &&
                                            <option value="GoodsReceipt">Entrada de Mercancía</option>}
                                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation') &&
                                            <option value="purchaseInvoice">Factura de proveedores</option>}
                                        {(view === 'GoodsReceipt') &&
                                            <option value="purchaseReturn">Devolución de Mercancía</option>}
                                        {(view === 'GoodsReceipt') &&
                                            <option value="purchaseInvoice">Factura de proveedores</option>}
                                        {(view === 'purchaseInvoice') &&
                                            <option value="purchaseCreditNotes">Nota de crédito proveedores</option>}
                                        {(view === 'SalesHelmets') &&
                                            <option value="ExitHelmets">Salida de Mercancía Cascos</option>}
                                        {(view === 'transfersRequest') &&
                                            <option value="transfers">Traslado de Mercancía</option>}
                                        {(view === 'PurchaseRequest') &&
                                            <option value="PurchaseQuotationDraft">{`Oferta de compra (Borrador ${Number(newOrderModel?.OPQTDraft || 0) + 1})`}</option>}
                                        {(view === 'PurchaseRequest') &&
                                            <option value="PurchaseOrder"> Orden de Compra </option>}
                                    </select>
                                </label>
                            )}

                            {Number(action) === 1 && writeAccess && (!isSelectTo || !isSelectOf) &&
                                (view === 'invoice' || view === 'deliveries' || view === 'debitNote' || view === 'creditNote' || view === 'return' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'ExitHelmets' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'transfers' || view === 'landedCosts') &&
                                (newOrderModel.Items.length === 0) &&
                                (
                                    <label className="btn text-white copiarde">
                                        <select name="select" className="btn botonCorrect text-white" value={'--'}
                                            onChange={this.selectOf}>
                                            <option value="--">Copiar de ...</option>
                                            {(view === 'invoice' || view === 'deliveries' || view === 'debitNote') &&
                                                <option value="orderSales">Orden de Venta</option>}
                                            {(view === 'deliveries' || view === 'creditNote') &&
                                                <option value="invoice">Factura</option>}
                                            {(view === 'invoice' || view === 'debitNote' || view === 'return') &&
                                                <option value="deliveries">Entrega</option>}
                                            {(view === 'deliveries' || view === 'creditNote') &&
                                                <option value="return">Devolución</option>}
                                            {(view === 'GoodsReceipt') &&
                                                <option value="PurchaseOrder">Orden de Compra</option>}
                                            {(view === 'purchaseReturn' || view === 'landedCosts') &&
                                                <option value="GoodsReceipt">Entrada de Mercancía</option>}
                                            {(view === 'ExitHelmets') &&
                                                <option value="SalesHelmets">Entrada de Mercancía Cascos</option>}
                                            {(view === 'purchaseInvoice') &&
                                                <option value="GoodsReceipt">Entrada de Mercancía</option>}
                                            {(view === 'purchaseCreditNotes' || view === 'landedCosts') &&
                                                <option value="purchaseInvoice">Factura de Proveedores</option>}
                                            {(view === 'transfers') &&
                                                <option value="transfersRequest">Solicitud de Traslado</option>}
                                            {(view === 'landedCosts') &&
                                                <option value="landedCosts">Precio de Entrega</option>}
                                        </select>

                                    </label>
                                )}

                            {Number(action) === 2 && view === 'SalesHelmets' && writeAccess && docStatusCasco === 'O' && !editMode &&
                                <button type="button" className="btn botonCorrect" onClick={() => this.acceptEditMode(1)}>
                                    Autorizar
                                </button>
                            }

                            {/* {Number(action) === 2 && writeAccess && view === 'invoiceAuthorization' && !editMode && (statusAuthorized === 'Pendiente' || statusAuthorized === 'Rechazado') && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.billingInfo(4)}>
                                    Autorizar
                                </button>
                            )}

                            {Number(action) === 2 && writeAccess && view === 'invoiceAuthorization' && statusAuthorized === 'Pendiente' && !editMode && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.billingInfo(5)}>
                                    Rechazar
                                </button>
                            )} */}

                            {view === 'payment' && Modules['Cancel_' + view] && Number(action) === 2 && writeAccess && !editMode && newOrderModel?.canCancelIncomingPayment && (
                                <button type="button" className="btn btn-outline-danger" onClick={this.ValidateCancelDate}>
                                    Cancelar Pago
                                </button>
                            )}

                            {Number(action) === 2 && view !== 'landedCosts' && !isAccountPayment && <button
                                type="button"
                                className="btn btn-outline-info"
                                onClick={() => this.OpenPdfSendMailModal(newOrderModel.DocEntry)}
                            >
                                Enviar por Correo
                            </button>}

                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModalCreate}>
                                Cerrar
                            </button>

                            {Number(action) === 1 && writeAccess && (view === 'PurchaseQuotation' || isDraftOWTQ) && (
                                <button type="button" className="btn botonCorrect text-black" onClick={() => this.sendModel(true)}>
                                    Crear Preliminar
                                </button>
                            )}
                            {Number(action) === 2 && !editMode && writeAccess && view === 'draft' && newOrderModel?.DocStatus === 'O' && Number(newOrderModel?.ObjType || this.props.DraftObjType) !== 22 && (
                                <button type="button" className="btn botonCorrect text-black" onClick={() => this.sendModel('draft')}>
                                    Crear Firme
                                </button>
                            )}
                            {Number(action) === 1 && writeAccess && (view !== 'reportSelectionCriteria' && !isDraftOWTQ) && (
                                <button type="button" className="btn botonCorrect text-black" onClick={this.sendModel}>
                                    Crear
                                </button>
                            )}
                            {view === 'reportSelectionCriteria' && (
                                <button type="button" className="btn botonCorrect text-black" onClick={this.searchRecommendation}>
                                    OK
                                </button>
                            )}

                            {writeAccess && (
                                view === "quotations" ||
                                view === "orderSales" ||
                                view === "deliveries" ||
                                view === "invoice" ||
                                view === "return" ||
                                view === "debitNote" ||
                                view === "creditNote") && action === 2 && (
                                    <button type="button" className="btn btn-secondary text-black" onClick={this.duplicate}>
                                        Duplicar
                                    </button>
                                )}

                            {/* {action == 2 &&
                            view !== 'return' &&
                            view !== 'purchaseReturn' &&
                            view !== 'PurchaseOrder' &&
                            view !== 'GoodsReceipt' &&                            
                            view !== 'PurchaseRequest' &&
                            view !== 'invoiceBorrador' &&
                            view !== 'orderSales' &&
                            view !== 'deliveries' &&
                            view !== 'invoiceAuthorization' &&
                            !editMode && timbra && (
                             <button
                                    type="button"
                                    className="btn botonCorrect"
                                    onClick={() => this.billingInfo(1)}>
                                    Timbrar
                                </button>
                            )}*/}
                            {/*  onClick ={ ()=> this.printElement(document.getElementById("printThis"))}  */}

                            {status === 1 && Number(action) === 2 && writeAccess && (view === 'orderSales' || view === 'deliveries') && !editMode && false && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.billingInfo(2)} >
                                    Facturar
                                </button>
                            )}

                            {Number(action) === 2 && writeAccess && view === 'invoiceBorrador' && !editMode && newOrderModel.isCreator !== 'Y' && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.billingInfo(3)}>
                                    Crear
                                </button>
                            )}

                            {/* EMPRESA SOLICITO QUE SE QUITARA ESTE BOTON PORQUE LOS USUARIOS LA CAGAN */}
                            {/* {Number(action) === 2 && writeAccess && view === 'invoiceBorrador' && !editMode && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.billingInfo(6)}>
                                    Cancelar
                                </button>
                            )} */}

                            {(view === 'invoiceBorrador' && newOrderModel.ObjType === "67" && newOrderModel.U_FMB_EditTraslado === 'Y') &&
                                < button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            }
                            {(view === 'invoiceBorrador' && newOrderModel.ObjType === "67" && newOrderModel.U_FMB_EditTraslado === 'N' && newOrderModel.SendRequestEdition === 'Y' && newOrderModel.isCreator === 'Y') &&
                                <button type="button" className="btn botonCorrect" onClick={() => SendAprovedPartial()}>
                                    Aprobar Edición Parcial
                                </button>
                            }
                            {Number(action) === 2 && writeAccess && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}

                            {Number(action) === 2 && writeAccess && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}

                        </div>
                    </div>
                </div>
                {this.openAction()}
            </div>
        );
    }
    renderReportSelectionCriteria = () => {
        const { newOrderModel, action, scenarios, prices } = this.props;
        // const { editMode } = this.state;
        return (
            <div className="row">
                <div className="col-12">
                    {/* TIPO PEDIDO */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo pedido</span>
                        </div>
                        <select
                            className="form-control"
                            // disabled={action === 2 && !editMode}
                            disabled={action === 2 ? true : false}
                            onChange={action === 1 ? (event) => this.changeDpstType(event) : ''}
                            value={newOrderModel.DpstType}>
                            <option value={''}>Todos</option>
                            <option value={'W'}>Órdenes fabricación</option>
                            <option value={'P'}>Pedidos</option>
                            <option value={'T'}>Solicitudes de traslado</option>
                            {/* <option value={'Q'}>Ofertas de compra</option> */}
                            <option value={'R'}>Solicitudes de compra</option>
                        </select>
                    </div>

                    {/* ESCENARIO */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Escenario</span>
                        </div>
                        <select
                            className="form-control"
                            // disabled={action === 2 && !editMode}
                            disabled={action == 2 ? true : false}
                            onChange={action === 1 ? (event) => this.changeObjAbs(event) : ''}
                            value={newOrderModel.ObjAbs}>
                            <option value={-1}>Selecciona un escenario</option>
                            {!!scenarios && scenarios.map(scens => {
                                return (
                                    <option value={scens.AbsEntry}>{scens.MsnCode}</option>
                                )
                            })}
                        </select>
                    </div>

                    {/* FECHA DE VENCIMIENTO */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha vencimiento</span>
                        </div>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                        </div>
                        <input
                            type="date"
                            className="form-control input-sm"
                            id="txtStatus"
                            autoComplete="off"
                            disabled={action == 2 ? true : false}
                            onChange={this.changeFromDate}
                            value={newOrderModel.FromDate ? newOrderModel.FromDate : ''} />
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <input
                            type="date"
                            className="form-control input-sm"
                            id="txtStatus"
                            autoComplete="off"
                            disabled={action == 2 ? true : false}
                            onChange={this.changeToDate}
                            value={newOrderModel.ToDate ? newOrderModel.ToDate : ''} />
                    </div>

                    {/* FECHA DE LIBERACIÓN */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha de liberación</span>
                        </div>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                        </div>
                        <input
                            type="date"
                            className="form-control input-sm"
                            id="txtStatus"
                            autoComplete="off"
                            disabled={action == 2 ? true : false}
                            onChange={this.changeFromDate3}
                            value={newOrderModel.FromDate3 ? newOrderModel.FromDate3 : ''} />
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <input
                            type="date"
                            className="form-control input-sm"
                            id="txtStatus"
                            autoComplete="off"
                            disabled={action == 2 ? true : false}
                            onChange={this.changeToDate3}
                            value={newOrderModel.ToDate3 ? newOrderModel.ToDate3 : ''} />
                    </div>

                    {/* ARTICULOS */}
                    <div className="input-group mb-3">
                        <strong><u>Artículos</u></strong>
                    </div>

                    {/* CODIGO ARTICULOS DESDE - HASTA */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtStatus"
                            autoComplete="off"
                            disabled={action == 2 ? true : false}
                            onChange={this.changeItmFrom1}
                            value={newOrderModel.ItmFrom1 ? newOrderModel.ItmFrom1 : ''} />
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtStatus"
                            autoComplete="off"
                            disabled={action == 2 ? true : false}
                            onChange={this.changeItmTo1}
                            value={newOrderModel.ItmTo1 ? newOrderModel.ItmTo1 : ''} />
                    </div>

                    {/* GRUPO ARTICULOS */}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Grupo</span>
                        </div>
                        <select
                            className="form-control"
                            // disabled={action === 2 && !editMode}
                            disabled={action == 2 ? true : false}
                            onChange={action === 1 ? (event) => this.changeItmGroup(event) : ''}
                            value={newOrderModel.ItmGroup || -1}>
                            {!!prices && prices.map(price => {
                                return (
                                    <option value={price.ListNum}>{price.ListName}</option>
                                )
                            })}
                            <option value={-1}>Todos</option>
                        </select>
                    </div> */}

                    {/* PROPIEDADES ARTICULOS */}
                    {/* <div className="input-group mb-3">
                        {action == 1 && (
                            <button
                                type="button"
                                // style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text btn botonCerrar text-white"
                                onClick={this.openSeries}>
                                Propiedades
                            </button>
                        )}
                        <input
                            type="text"
                            className=" form-control"
                            id="idSerie"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : 'Ignorar'} />
                    </div> */}

                    {/* PROVEEDORES */}
                    <div className="input-group mb-3" style={{ visibility: (Number(newOrderModel.DpstType) === 1 || Number(newOrderModel.DpstType) === 3) ? "hidden" : "visible" }}>
                        <strong><u>Proveedores</u></strong>
                    </div>

                    {/* CODIGO PROVEEDORES DESDE - HASTA */}
                    <div className="input-group mb-3" style={{ visibility: (Number(newOrderModel.DpstType) === 1 || Number(newOrderModel.DpstType) === 3) ? "hidden" : "visible" }}>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtStatus"
                            autoComplete="off"
                            disabled={action == 2 ? true : false}
                            onChange={this.changeCardFrom1}
                            value={newOrderModel.CardFrom1 ? newOrderModel.CardFrom1 : ''} />
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtStatus"
                            autoComplete="off"
                            disabled={action == 2 ? true : false}
                            onChange={this.changeCardTo1}
                            value={newOrderModel.CardTo1 ? newOrderModel.CardTo1 : ''} />
                    </div>

                    {/* GRUPO PROVEEDORES */}
                    {/* <div className="input-group mb-3" style={{ visibility: (Number(newOrderModel.DpstType) === 1 || Number(newOrderModel.DpstType) === 3) ? "hidden" : "visible" }}>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Grupo</span>
                        </div>
                        <select
                            className="form-control"
                            // disabled={action === 2 && !editMode}
                            disabled={action == 2 ? true : false}
                            onChange={action === 1 ? (event) => this.changePriceList(event) : ''}
                            value={newOrderModel.PriceList || -1}>
                            {!!prices && prices.map(price => {
                                return (
                                    <option value={price.ListNum}>{price.ListName}</option>
                                )
                            })}
                            <option value={-1}>Todos</option>
                        </select>
                    </div> */}

                    {/* PROPIEDADES PROVEEDORES */}
                    {/* <div className="input-group mb-3" style={{ visibility: (Number(newOrderModel.DpstType) === 1 || Number(newOrderModel.DpstType) === 3) ? "hidden" : "visible" }}>
                        {action == 1 && (
                            <button
                                type="button"
                                // style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text btn botonCerrar text-white"
                                onClick={this.openSeries}>
                                Propiedades
                            </button>
                        )}
                        <input
                            type="text"
                            className=" form-control"
                            id="idSerie"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : 'Ignorar'} />
                    </div> */}
                </div>
            </div>
        );
    };

    renderGrossProfitModal = () => {
        const { action } = this.props;
        const { LinesGrossProfit, TotalGrossProfit, TotPrctGrossProfit, PricesList, ChoosePriceList } = this.state;

        let grossProfitTools = {
            Action: action,
            LinesGrossProfit: LinesGrossProfit,
            PricesList: PricesList,
            TotalGrossProfit: TotalGrossProfit,
            TotPrctGrossProfit: TotPrctGrossProfit,
            HideGrossProfitModal: this.HideGrossProfitModal,
            OnchangePriceList: this.OnchangePriceList,
            ChoosePriceList: ChoosePriceList,
        }

        return (
            <>
                <GrossProfitModal
                    GrossProfitTools={grossProfitTools} />
            </>
        )
    }

    renderContentLandedCosts = (render) => {
        const { newOrderModel, action, enableSpinner } = this.props;
        const { editMode, documentsSelected } = this.state;
        return (
            <>
                <ContentLandedCosts
                    render={render}
                    ref={(ref) => this.landedCostsRef = ref}
                    newOrderModel={newOrderModel}
                    action={action}
                    openPartner={this.openPartner}
                    changeCardCode={this.changeCardCode}
                    openCurrency={this.openCurrency}
                    selectDocDate={this.selectDocDate}
                    selectDocDueDate={this.selectDocDueDate}
                    validatePartner={this.validatePartner}
                    enableSpinner={enableSpinner}
                    refreshModel={this.refreshModel}
                    changeComments={this.changeComments}
                    selectOfReference={this.selectOfReference}
                    openSeries={this.openSeries}
                />
            </>
        );
    }

    emptyField = () => {
        return (
            <td style={{ textAlign: 'center' }}>
                <input
                    type="text"
                    className="form-control btn-outline-secondary"
                    disabled={true}
                    readOnly={true}
                    style={{
                        backgroundColor: 'transparent',
                        borderColor: '#ced4da',
                        color: '#000',
                        paddingTop: 1,
                        paddingBottom: 2,
                        minWidth: 80,
                        textAlign: "center",
                    }}
                    value={''}
                />
            </td>
        )
    }
}

export default DocumentCreateModal;